import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  date: any;
  float8: any;
  json: any;
  jsonb: any;
  numeric: any;
  timestamp: any;
  timestamptz: any;
  uuid: any;
};

/** expression to compare columns of type Boolean. All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
};

/** expression to compare columns of type Int. All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
};

export type QueueActionOutput = {
  __typename?: 'QueueActionOutput';
  error?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['jsonb']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** expression to compare columns of type String. All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  _nlike?: Maybe<Scalars['String']>;
  _nsimilar?: Maybe<Scalars['String']>;
  _similar?: Maybe<Scalars['String']>;
};

/** columns and relationships of "admin.adminuser" */
export type AdminAdminuser = {
  __typename?: 'admin_adminuser';
  email?: Maybe<Scalars['String']>;
  fullname: Scalars['String'];
  /** An array relationship */
  sms_messages: Array<RecruitSmsMessage>;
  /** An aggregated array relationship */
  sms_messages_aggregate: RecruitSmsMessageAggregate;
  twilio_phone?: Maybe<Scalars['String']>;
  user_id: Scalars['String'];
};


/** columns and relationships of "admin.adminuser" */
export type AdminAdminuserSmsMessagesArgs = {
  distinct_on?: Maybe<Array<RecruitSmsMessageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsMessageOrderBy>>;
  where?: Maybe<RecruitSmsMessageBoolExp>;
};


/** columns and relationships of "admin.adminuser" */
export type AdminAdminuserSmsMessagesAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitSmsMessageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsMessageOrderBy>>;
  where?: Maybe<RecruitSmsMessageBoolExp>;
};

/** aggregated selection of "admin.adminuser" */
export type AdminAdminuserAggregate = {
  __typename?: 'admin_adminuser_aggregate';
  aggregate?: Maybe<AdminAdminuserAggregateFields>;
  nodes: Array<AdminAdminuser>;
};

/** aggregate fields of "admin.adminuser" */
export type AdminAdminuserAggregateFields = {
  __typename?: 'admin_adminuser_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<AdminAdminuserMaxFields>;
  min?: Maybe<AdminAdminuserMinFields>;
};


/** aggregate fields of "admin.adminuser" */
export type AdminAdminuserAggregateFieldsCountArgs = {
  columns?: Maybe<Array<AdminAdminuserSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "admin.adminuser" */
export type AdminAdminuserAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<AdminAdminuserMaxOrderBy>;
  min?: Maybe<AdminAdminuserMinOrderBy>;
};

/** input type for inserting array relation for remote table "admin.adminuser" */
export type AdminAdminuserArrRelInsertInput = {
  data: Array<AdminAdminuserInsertInput>;
  on_conflict?: Maybe<AdminAdminuserOnConflict>;
};

/** Boolean expression to filter rows from the table "admin.adminuser". All fields are combined with a logical 'AND'. */
export type AdminAdminuserBoolExp = {
  _and?: Maybe<Array<Maybe<AdminAdminuserBoolExp>>>;
  _not?: Maybe<AdminAdminuserBoolExp>;
  _or?: Maybe<Array<Maybe<AdminAdminuserBoolExp>>>;
  email?: Maybe<StringComparisonExp>;
  fullname?: Maybe<StringComparisonExp>;
  sms_messages?: Maybe<RecruitSmsMessageBoolExp>;
  twilio_phone?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "admin.adminuser" */
export enum AdminAdminuserConstraint {
  /** unique or primary key constraint */
  AdminuserPkey = 'adminuser_pkey'
}

/** input type for inserting data into table "admin.adminuser" */
export type AdminAdminuserInsertInput = {
  email?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  sms_messages?: Maybe<RecruitSmsMessageArrRelInsertInput>;
  twilio_phone?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AdminAdminuserMaxFields = {
  __typename?: 'admin_adminuser_max_fields';
  email?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  twilio_phone?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "admin.adminuser" */
export type AdminAdminuserMaxOrderBy = {
  email?: Maybe<OrderBy>;
  fullname?: Maybe<OrderBy>;
  twilio_phone?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type AdminAdminuserMinFields = {
  __typename?: 'admin_adminuser_min_fields';
  email?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  twilio_phone?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "admin.adminuser" */
export type AdminAdminuserMinOrderBy = {
  email?: Maybe<OrderBy>;
  fullname?: Maybe<OrderBy>;
  twilio_phone?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "admin.adminuser" */
export type AdminAdminuserMutationResponse = {
  __typename?: 'admin_adminuser_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<AdminAdminuser>;
};

/** input type for inserting object relation for remote table "admin.adminuser" */
export type AdminAdminuserObjRelInsertInput = {
  data: AdminAdminuserInsertInput;
  on_conflict?: Maybe<AdminAdminuserOnConflict>;
};

/** on conflict condition type for table "admin.adminuser" */
export type AdminAdminuserOnConflict = {
  constraint: AdminAdminuserConstraint;
  update_columns: Array<AdminAdminuserUpdateColumn>;
  where?: Maybe<AdminAdminuserBoolExp>;
};

/** ordering options when selecting data from "admin.adminuser" */
export type AdminAdminuserOrderBy = {
  email?: Maybe<OrderBy>;
  fullname?: Maybe<OrderBy>;
  sms_messages_aggregate?: Maybe<RecruitSmsMessageAggregateOrderBy>;
  twilio_phone?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "admin.adminuser" */
export type AdminAdminuserPkColumnsInput = {
  user_id: Scalars['String'];
};

/** select columns of table "admin.adminuser" */
export enum AdminAdminuserSelectColumn {
  /** column name */
  Email = 'email',
  /** column name */
  Fullname = 'fullname',
  /** column name */
  TwilioPhone = 'twilio_phone',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "admin.adminuser" */
export type AdminAdminuserSetInput = {
  email?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  twilio_phone?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "admin.adminuser" */
export enum AdminAdminuserUpdateColumn {
  /** column name */
  Email = 'email',
  /** column name */
  Fullname = 'fullname',
  /** column name */
  TwilioPhone = 'twilio_phone',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "admin.auth0mgmt" */
export type AdminAuth0mgmt = {
  __typename?: 'admin_auth0mgmt';
  auth0mgmt_id: Scalars['Int'];
  body?: Maybe<Scalars['String']>;
  endpoint: Scalars['String'];
  method: Scalars['String'];
  time: Scalars['timestamptz'];
  user_id: Scalars['String'];
};

/** aggregated selection of "admin.auth0mgmt" */
export type AdminAuth0mgmtAggregate = {
  __typename?: 'admin_auth0mgmt_aggregate';
  aggregate?: Maybe<AdminAuth0mgmtAggregateFields>;
  nodes: Array<AdminAuth0mgmt>;
};

/** aggregate fields of "admin.auth0mgmt" */
export type AdminAuth0mgmtAggregateFields = {
  __typename?: 'admin_auth0mgmt_aggregate_fields';
  avg?: Maybe<AdminAuth0mgmtAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<AdminAuth0mgmtMaxFields>;
  min?: Maybe<AdminAuth0mgmtMinFields>;
  stddev?: Maybe<AdminAuth0mgmtStddevFields>;
  stddev_pop?: Maybe<AdminAuth0mgmtStddevPopFields>;
  stddev_samp?: Maybe<AdminAuth0mgmtStddevSampFields>;
  sum?: Maybe<AdminAuth0mgmtSumFields>;
  var_pop?: Maybe<AdminAuth0mgmtVarPopFields>;
  var_samp?: Maybe<AdminAuth0mgmtVarSampFields>;
  variance?: Maybe<AdminAuth0mgmtVarianceFields>;
};


/** aggregate fields of "admin.auth0mgmt" */
export type AdminAuth0mgmtAggregateFieldsCountArgs = {
  columns?: Maybe<Array<AdminAuth0mgmtSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "admin.auth0mgmt" */
export type AdminAuth0mgmtAggregateOrderBy = {
  avg?: Maybe<AdminAuth0mgmtAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<AdminAuth0mgmtMaxOrderBy>;
  min?: Maybe<AdminAuth0mgmtMinOrderBy>;
  stddev?: Maybe<AdminAuth0mgmtStddevOrderBy>;
  stddev_pop?: Maybe<AdminAuth0mgmtStddevPopOrderBy>;
  stddev_samp?: Maybe<AdminAuth0mgmtStddevSampOrderBy>;
  sum?: Maybe<AdminAuth0mgmtSumOrderBy>;
  var_pop?: Maybe<AdminAuth0mgmtVarPopOrderBy>;
  var_samp?: Maybe<AdminAuth0mgmtVarSampOrderBy>;
  variance?: Maybe<AdminAuth0mgmtVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "admin.auth0mgmt" */
export type AdminAuth0mgmtArrRelInsertInput = {
  data: Array<AdminAuth0mgmtInsertInput>;
  on_conflict?: Maybe<AdminAuth0mgmtOnConflict>;
};

/** aggregate avg on columns */
export type AdminAuth0mgmtAvgFields = {
  __typename?: 'admin_auth0mgmt_avg_fields';
  auth0mgmt_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "admin.auth0mgmt" */
export type AdminAuth0mgmtAvgOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "admin.auth0mgmt". All fields are combined with a logical 'AND'. */
export type AdminAuth0mgmtBoolExp = {
  _and?: Maybe<Array<Maybe<AdminAuth0mgmtBoolExp>>>;
  _not?: Maybe<AdminAuth0mgmtBoolExp>;
  _or?: Maybe<Array<Maybe<AdminAuth0mgmtBoolExp>>>;
  auth0mgmt_id?: Maybe<IntComparisonExp>;
  body?: Maybe<StringComparisonExp>;
  endpoint?: Maybe<StringComparisonExp>;
  method?: Maybe<StringComparisonExp>;
  time?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "admin.auth0mgmt" */
export enum AdminAuth0mgmtConstraint {
  /** unique or primary key constraint */
  Auth0mgmtPkey = 'auth0mgmt_pkey'
}

/** input type for incrementing integer column in table "admin.auth0mgmt" */
export type AdminAuth0mgmtIncInput = {
  auth0mgmt_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "admin.auth0mgmt" */
export type AdminAuth0mgmtInsertInput = {
  auth0mgmt_id?: Maybe<Scalars['Int']>;
  body?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AdminAuth0mgmtMaxFields = {
  __typename?: 'admin_auth0mgmt_max_fields';
  auth0mgmt_id?: Maybe<Scalars['Int']>;
  body?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "admin.auth0mgmt" */
export type AdminAuth0mgmtMaxOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
  body?: Maybe<OrderBy>;
  endpoint?: Maybe<OrderBy>;
  method?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type AdminAuth0mgmtMinFields = {
  __typename?: 'admin_auth0mgmt_min_fields';
  auth0mgmt_id?: Maybe<Scalars['Int']>;
  body?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "admin.auth0mgmt" */
export type AdminAuth0mgmtMinOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
  body?: Maybe<OrderBy>;
  endpoint?: Maybe<OrderBy>;
  method?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "admin.auth0mgmt" */
export type AdminAuth0mgmtMutationResponse = {
  __typename?: 'admin_auth0mgmt_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<AdminAuth0mgmt>;
};

/** input type for inserting object relation for remote table "admin.auth0mgmt" */
export type AdminAuth0mgmtObjRelInsertInput = {
  data: AdminAuth0mgmtInsertInput;
  on_conflict?: Maybe<AdminAuth0mgmtOnConflict>;
};

/** on conflict condition type for table "admin.auth0mgmt" */
export type AdminAuth0mgmtOnConflict = {
  constraint: AdminAuth0mgmtConstraint;
  update_columns: Array<AdminAuth0mgmtUpdateColumn>;
  where?: Maybe<AdminAuth0mgmtBoolExp>;
};

/** ordering options when selecting data from "admin.auth0mgmt" */
export type AdminAuth0mgmtOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
  body?: Maybe<OrderBy>;
  endpoint?: Maybe<OrderBy>;
  method?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "admin.auth0mgmt" */
export type AdminAuth0mgmtPkColumnsInput = {
  auth0mgmt_id: Scalars['Int'];
};

/** columns and relationships of "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResult = {
  __typename?: 'admin_auth0mgmt_result';
  auth0mgmt_id: Scalars['Int'];
  other_errors?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultAggregate = {
  __typename?: 'admin_auth0mgmt_result_aggregate';
  aggregate?: Maybe<AdminAuth0mgmtResultAggregateFields>;
  nodes: Array<AdminAuth0mgmtResult>;
};

/** aggregate fields of "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultAggregateFields = {
  __typename?: 'admin_auth0mgmt_result_aggregate_fields';
  avg?: Maybe<AdminAuth0mgmtResultAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<AdminAuth0mgmtResultMaxFields>;
  min?: Maybe<AdminAuth0mgmtResultMinFields>;
  stddev?: Maybe<AdminAuth0mgmtResultStddevFields>;
  stddev_pop?: Maybe<AdminAuth0mgmtResultStddevPopFields>;
  stddev_samp?: Maybe<AdminAuth0mgmtResultStddevSampFields>;
  sum?: Maybe<AdminAuth0mgmtResultSumFields>;
  var_pop?: Maybe<AdminAuth0mgmtResultVarPopFields>;
  var_samp?: Maybe<AdminAuth0mgmtResultVarSampFields>;
  variance?: Maybe<AdminAuth0mgmtResultVarianceFields>;
};


/** aggregate fields of "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultAggregateFieldsCountArgs = {
  columns?: Maybe<Array<AdminAuth0mgmtResultSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultAggregateOrderBy = {
  avg?: Maybe<AdminAuth0mgmtResultAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<AdminAuth0mgmtResultMaxOrderBy>;
  min?: Maybe<AdminAuth0mgmtResultMinOrderBy>;
  stddev?: Maybe<AdminAuth0mgmtResultStddevOrderBy>;
  stddev_pop?: Maybe<AdminAuth0mgmtResultStddevPopOrderBy>;
  stddev_samp?: Maybe<AdminAuth0mgmtResultStddevSampOrderBy>;
  sum?: Maybe<AdminAuth0mgmtResultSumOrderBy>;
  var_pop?: Maybe<AdminAuth0mgmtResultVarPopOrderBy>;
  var_samp?: Maybe<AdminAuth0mgmtResultVarSampOrderBy>;
  variance?: Maybe<AdminAuth0mgmtResultVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultArrRelInsertInput = {
  data: Array<AdminAuth0mgmtResultInsertInput>;
  on_conflict?: Maybe<AdminAuth0mgmtResultOnConflict>;
};

/** aggregate avg on columns */
export type AdminAuth0mgmtResultAvgFields = {
  __typename?: 'admin_auth0mgmt_result_avg_fields';
  auth0mgmt_id?: Maybe<Scalars['Float']>;
  status_code?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultAvgOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
  status_code?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "admin.auth0mgmt_result". All fields are combined with a logical 'AND'. */
export type AdminAuth0mgmtResultBoolExp = {
  _and?: Maybe<Array<Maybe<AdminAuth0mgmtResultBoolExp>>>;
  _not?: Maybe<AdminAuth0mgmtResultBoolExp>;
  _or?: Maybe<Array<Maybe<AdminAuth0mgmtResultBoolExp>>>;
  auth0mgmt_id?: Maybe<IntComparisonExp>;
  other_errors?: Maybe<StringComparisonExp>;
  response?: Maybe<StringComparisonExp>;
  status_code?: Maybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "admin.auth0mgmt_result" */
export enum AdminAuth0mgmtResultConstraint {
  /** unique or primary key constraint */
  Auth0mgmtResultPkey = 'auth0mgmt_result_pkey'
}

/** input type for incrementing integer column in table "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultIncInput = {
  auth0mgmt_id?: Maybe<Scalars['Int']>;
  status_code?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultInsertInput = {
  auth0mgmt_id?: Maybe<Scalars['Int']>;
  other_errors?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type AdminAuth0mgmtResultMaxFields = {
  __typename?: 'admin_auth0mgmt_result_max_fields';
  auth0mgmt_id?: Maybe<Scalars['Int']>;
  other_errors?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultMaxOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
  other_errors?: Maybe<OrderBy>;
  response?: Maybe<OrderBy>;
  status_code?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type AdminAuth0mgmtResultMinFields = {
  __typename?: 'admin_auth0mgmt_result_min_fields';
  auth0mgmt_id?: Maybe<Scalars['Int']>;
  other_errors?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultMinOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
  other_errors?: Maybe<OrderBy>;
  response?: Maybe<OrderBy>;
  status_code?: Maybe<OrderBy>;
};

/** response of any mutation on the table "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultMutationResponse = {
  __typename?: 'admin_auth0mgmt_result_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<AdminAuth0mgmtResult>;
};

/** input type for inserting object relation for remote table "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultObjRelInsertInput = {
  data: AdminAuth0mgmtResultInsertInput;
  on_conflict?: Maybe<AdminAuth0mgmtResultOnConflict>;
};

/** on conflict condition type for table "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultOnConflict = {
  constraint: AdminAuth0mgmtResultConstraint;
  update_columns: Array<AdminAuth0mgmtResultUpdateColumn>;
  where?: Maybe<AdminAuth0mgmtResultBoolExp>;
};

/** ordering options when selecting data from "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
  other_errors?: Maybe<OrderBy>;
  response?: Maybe<OrderBy>;
  status_code?: Maybe<OrderBy>;
};

/** primary key columns input for table: "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultPkColumnsInput = {
  auth0mgmt_id: Scalars['Int'];
};

/** select columns of table "admin.auth0mgmt_result" */
export enum AdminAuth0mgmtResultSelectColumn {
  /** column name */
  Auth0mgmtId = 'auth0mgmt_id',
  /** column name */
  OtherErrors = 'other_errors',
  /** column name */
  Response = 'response',
  /** column name */
  StatusCode = 'status_code'
}

/** input type for updating data in table "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultSetInput = {
  auth0mgmt_id?: Maybe<Scalars['Int']>;
  other_errors?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type AdminAuth0mgmtResultStddevFields = {
  __typename?: 'admin_auth0mgmt_result_stddev_fields';
  auth0mgmt_id?: Maybe<Scalars['Float']>;
  status_code?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultStddevOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
  status_code?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AdminAuth0mgmtResultStddevPopFields = {
  __typename?: 'admin_auth0mgmt_result_stddev_pop_fields';
  auth0mgmt_id?: Maybe<Scalars['Float']>;
  status_code?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultStddevPopOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
  status_code?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AdminAuth0mgmtResultStddevSampFields = {
  __typename?: 'admin_auth0mgmt_result_stddev_samp_fields';
  auth0mgmt_id?: Maybe<Scalars['Float']>;
  status_code?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultStddevSampOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
  status_code?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type AdminAuth0mgmtResultSumFields = {
  __typename?: 'admin_auth0mgmt_result_sum_fields';
  auth0mgmt_id?: Maybe<Scalars['Int']>;
  status_code?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultSumOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
  status_code?: Maybe<OrderBy>;
};

/** update columns of table "admin.auth0mgmt_result" */
export enum AdminAuth0mgmtResultUpdateColumn {
  /** column name */
  Auth0mgmtId = 'auth0mgmt_id',
  /** column name */
  OtherErrors = 'other_errors',
  /** column name */
  Response = 'response',
  /** column name */
  StatusCode = 'status_code'
}

/** aggregate var_pop on columns */
export type AdminAuth0mgmtResultVarPopFields = {
  __typename?: 'admin_auth0mgmt_result_var_pop_fields';
  auth0mgmt_id?: Maybe<Scalars['Float']>;
  status_code?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultVarPopOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
  status_code?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AdminAuth0mgmtResultVarSampFields = {
  __typename?: 'admin_auth0mgmt_result_var_samp_fields';
  auth0mgmt_id?: Maybe<Scalars['Float']>;
  status_code?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultVarSampOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
  status_code?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type AdminAuth0mgmtResultVarianceFields = {
  __typename?: 'admin_auth0mgmt_result_variance_fields';
  auth0mgmt_id?: Maybe<Scalars['Float']>;
  status_code?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "admin.auth0mgmt_result" */
export type AdminAuth0mgmtResultVarianceOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
  status_code?: Maybe<OrderBy>;
};

/** select columns of table "admin.auth0mgmt" */
export enum AdminAuth0mgmtSelectColumn {
  /** column name */
  Auth0mgmtId = 'auth0mgmt_id',
  /** column name */
  Body = 'body',
  /** column name */
  Endpoint = 'endpoint',
  /** column name */
  Method = 'method',
  /** column name */
  Time = 'time',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "admin.auth0mgmt" */
export type AdminAuth0mgmtSetInput = {
  auth0mgmt_id?: Maybe<Scalars['Int']>;
  body?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AdminAuth0mgmtStddevFields = {
  __typename?: 'admin_auth0mgmt_stddev_fields';
  auth0mgmt_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "admin.auth0mgmt" */
export type AdminAuth0mgmtStddevOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AdminAuth0mgmtStddevPopFields = {
  __typename?: 'admin_auth0mgmt_stddev_pop_fields';
  auth0mgmt_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "admin.auth0mgmt" */
export type AdminAuth0mgmtStddevPopOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AdminAuth0mgmtStddevSampFields = {
  __typename?: 'admin_auth0mgmt_stddev_samp_fields';
  auth0mgmt_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "admin.auth0mgmt" */
export type AdminAuth0mgmtStddevSampOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type AdminAuth0mgmtSumFields = {
  __typename?: 'admin_auth0mgmt_sum_fields';
  auth0mgmt_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "admin.auth0mgmt" */
export type AdminAuth0mgmtSumOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
};

/** update columns of table "admin.auth0mgmt" */
export enum AdminAuth0mgmtUpdateColumn {
  /** column name */
  Auth0mgmtId = 'auth0mgmt_id',
  /** column name */
  Body = 'body',
  /** column name */
  Endpoint = 'endpoint',
  /** column name */
  Method = 'method',
  /** column name */
  Time = 'time',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type AdminAuth0mgmtVarPopFields = {
  __typename?: 'admin_auth0mgmt_var_pop_fields';
  auth0mgmt_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "admin.auth0mgmt" */
export type AdminAuth0mgmtVarPopOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AdminAuth0mgmtVarSampFields = {
  __typename?: 'admin_auth0mgmt_var_samp_fields';
  auth0mgmt_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "admin.auth0mgmt" */
export type AdminAuth0mgmtVarSampOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type AdminAuth0mgmtVarianceFields = {
  __typename?: 'admin_auth0mgmt_variance_fields';
  auth0mgmt_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "admin.auth0mgmt" */
export type AdminAuth0mgmtVarianceOrderBy = {
  auth0mgmt_id?: Maybe<OrderBy>;
};

/** columns and relationships of "admin.email" */
export type AdminEmail = {
  __typename?: 'admin_email';
  email_id: Scalars['Int'];
  email_template_id: Scalars['String'];
  inputs: Scalars['jsonb'];
};


/** columns and relationships of "admin.email" */
export type AdminEmailInputsArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "admin.email" */
export type AdminEmailAggregate = {
  __typename?: 'admin_email_aggregate';
  aggregate?: Maybe<AdminEmailAggregateFields>;
  nodes: Array<AdminEmail>;
};

/** aggregate fields of "admin.email" */
export type AdminEmailAggregateFields = {
  __typename?: 'admin_email_aggregate_fields';
  avg?: Maybe<AdminEmailAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<AdminEmailMaxFields>;
  min?: Maybe<AdminEmailMinFields>;
  stddev?: Maybe<AdminEmailStddevFields>;
  stddev_pop?: Maybe<AdminEmailStddevPopFields>;
  stddev_samp?: Maybe<AdminEmailStddevSampFields>;
  sum?: Maybe<AdminEmailSumFields>;
  var_pop?: Maybe<AdminEmailVarPopFields>;
  var_samp?: Maybe<AdminEmailVarSampFields>;
  variance?: Maybe<AdminEmailVarianceFields>;
};


/** aggregate fields of "admin.email" */
export type AdminEmailAggregateFieldsCountArgs = {
  columns?: Maybe<Array<AdminEmailSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "admin.email" */
export type AdminEmailAggregateOrderBy = {
  avg?: Maybe<AdminEmailAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<AdminEmailMaxOrderBy>;
  min?: Maybe<AdminEmailMinOrderBy>;
  stddev?: Maybe<AdminEmailStddevOrderBy>;
  stddev_pop?: Maybe<AdminEmailStddevPopOrderBy>;
  stddev_samp?: Maybe<AdminEmailStddevSampOrderBy>;
  sum?: Maybe<AdminEmailSumOrderBy>;
  var_pop?: Maybe<AdminEmailVarPopOrderBy>;
  var_samp?: Maybe<AdminEmailVarSampOrderBy>;
  variance?: Maybe<AdminEmailVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AdminEmailAppendInput = {
  inputs?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "admin.email" */
export type AdminEmailArrRelInsertInput = {
  data: Array<AdminEmailInsertInput>;
  on_conflict?: Maybe<AdminEmailOnConflict>;
};

/** aggregate avg on columns */
export type AdminEmailAvgFields = {
  __typename?: 'admin_email_avg_fields';
  email_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "admin.email" */
export type AdminEmailAvgOrderBy = {
  email_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "admin.email". All fields are combined with a logical 'AND'. */
export type AdminEmailBoolExp = {
  _and?: Maybe<Array<Maybe<AdminEmailBoolExp>>>;
  _not?: Maybe<AdminEmailBoolExp>;
  _or?: Maybe<Array<Maybe<AdminEmailBoolExp>>>;
  email_id?: Maybe<IntComparisonExp>;
  email_template_id?: Maybe<StringComparisonExp>;
  inputs?: Maybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "admin.email" */
export enum AdminEmailConstraint {
  /** unique or primary key constraint */
  EmailPkey = 'email_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AdminEmailDeleteAtPathInput = {
  inputs?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AdminEmailDeleteElemInput = {
  inputs?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AdminEmailDeleteKeyInput = {
  inputs?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "admin.email" */
export type AdminEmailIncInput = {
  email_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "admin.email" */
export type AdminEmailInsertInput = {
  email_id?: Maybe<Scalars['Int']>;
  email_template_id?: Maybe<Scalars['String']>;
  inputs?: Maybe<Scalars['jsonb']>;
};

/** columns and relationships of "admin.email_layout" */
export type AdminEmailLayout = {
  __typename?: 'admin_email_layout';
  description?: Maybe<Scalars['String']>;
  email_layout_id: Scalars['String'];
  html: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "admin.email_layout" */
export type AdminEmailLayoutAggregate = {
  __typename?: 'admin_email_layout_aggregate';
  aggregate?: Maybe<AdminEmailLayoutAggregateFields>;
  nodes: Array<AdminEmailLayout>;
};

/** aggregate fields of "admin.email_layout" */
export type AdminEmailLayoutAggregateFields = {
  __typename?: 'admin_email_layout_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<AdminEmailLayoutMaxFields>;
  min?: Maybe<AdminEmailLayoutMinFields>;
};


/** aggregate fields of "admin.email_layout" */
export type AdminEmailLayoutAggregateFieldsCountArgs = {
  columns?: Maybe<Array<AdminEmailLayoutSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "admin.email_layout" */
export type AdminEmailLayoutAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<AdminEmailLayoutMaxOrderBy>;
  min?: Maybe<AdminEmailLayoutMinOrderBy>;
};

/** input type for inserting array relation for remote table "admin.email_layout" */
export type AdminEmailLayoutArrRelInsertInput = {
  data: Array<AdminEmailLayoutInsertInput>;
  on_conflict?: Maybe<AdminEmailLayoutOnConflict>;
};

/** Boolean expression to filter rows from the table "admin.email_layout". All fields are combined with a logical 'AND'. */
export type AdminEmailLayoutBoolExp = {
  _and?: Maybe<Array<Maybe<AdminEmailLayoutBoolExp>>>;
  _not?: Maybe<AdminEmailLayoutBoolExp>;
  _or?: Maybe<Array<Maybe<AdminEmailLayoutBoolExp>>>;
  description?: Maybe<StringComparisonExp>;
  email_layout_id?: Maybe<StringComparisonExp>;
  html?: Maybe<StringComparisonExp>;
  name?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "admin.email_layout" */
export enum AdminEmailLayoutConstraint {
  /** unique or primary key constraint */
  EmailLayoutPkey = 'email_layout_pkey'
}

/** input type for inserting data into table "admin.email_layout" */
export type AdminEmailLayoutInsertInput = {
  description?: Maybe<Scalars['String']>;
  email_layout_id?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AdminEmailLayoutMaxFields = {
  __typename?: 'admin_email_layout_max_fields';
  description?: Maybe<Scalars['String']>;
  email_layout_id?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "admin.email_layout" */
export type AdminEmailLayoutMaxOrderBy = {
  description?: Maybe<OrderBy>;
  email_layout_id?: Maybe<OrderBy>;
  html?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type AdminEmailLayoutMinFields = {
  __typename?: 'admin_email_layout_min_fields';
  description?: Maybe<Scalars['String']>;
  email_layout_id?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "admin.email_layout" */
export type AdminEmailLayoutMinOrderBy = {
  description?: Maybe<OrderBy>;
  email_layout_id?: Maybe<OrderBy>;
  html?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
};

/** response of any mutation on the table "admin.email_layout" */
export type AdminEmailLayoutMutationResponse = {
  __typename?: 'admin_email_layout_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<AdminEmailLayout>;
};

/** input type for inserting object relation for remote table "admin.email_layout" */
export type AdminEmailLayoutObjRelInsertInput = {
  data: AdminEmailLayoutInsertInput;
  on_conflict?: Maybe<AdminEmailLayoutOnConflict>;
};

/** on conflict condition type for table "admin.email_layout" */
export type AdminEmailLayoutOnConflict = {
  constraint: AdminEmailLayoutConstraint;
  update_columns: Array<AdminEmailLayoutUpdateColumn>;
  where?: Maybe<AdminEmailLayoutBoolExp>;
};

/** ordering options when selecting data from "admin.email_layout" */
export type AdminEmailLayoutOrderBy = {
  description?: Maybe<OrderBy>;
  email_layout_id?: Maybe<OrderBy>;
  html?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
};

/** primary key columns input for table: "admin.email_layout" */
export type AdminEmailLayoutPkColumnsInput = {
  email_layout_id: Scalars['String'];
};

/** select columns of table "admin.email_layout" */
export enum AdminEmailLayoutSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  EmailLayoutId = 'email_layout_id',
  /** column name */
  Html = 'html',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "admin.email_layout" */
export type AdminEmailLayoutSetInput = {
  description?: Maybe<Scalars['String']>;
  email_layout_id?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "admin.email_layout" */
export enum AdminEmailLayoutUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  EmailLayoutId = 'email_layout_id',
  /** column name */
  Html = 'html',
  /** column name */
  Name = 'name'
}

/** aggregate max on columns */
export type AdminEmailMaxFields = {
  __typename?: 'admin_email_max_fields';
  email_id?: Maybe<Scalars['Int']>;
  email_template_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "admin.email" */
export type AdminEmailMaxOrderBy = {
  email_id?: Maybe<OrderBy>;
  email_template_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type AdminEmailMinFields = {
  __typename?: 'admin_email_min_fields';
  email_id?: Maybe<Scalars['Int']>;
  email_template_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "admin.email" */
export type AdminEmailMinOrderBy = {
  email_id?: Maybe<OrderBy>;
  email_template_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "admin.email" */
export type AdminEmailMutationResponse = {
  __typename?: 'admin_email_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<AdminEmail>;
};

/** input type for inserting object relation for remote table "admin.email" */
export type AdminEmailObjRelInsertInput = {
  data: AdminEmailInsertInput;
  on_conflict?: Maybe<AdminEmailOnConflict>;
};

/** on conflict condition type for table "admin.email" */
export type AdminEmailOnConflict = {
  constraint: AdminEmailConstraint;
  update_columns: Array<AdminEmailUpdateColumn>;
  where?: Maybe<AdminEmailBoolExp>;
};

/** ordering options when selecting data from "admin.email" */
export type AdminEmailOrderBy = {
  email_id?: Maybe<OrderBy>;
  email_template_id?: Maybe<OrderBy>;
  inputs?: Maybe<OrderBy>;
};

/** primary key columns input for table: "admin.email" */
export type AdminEmailPkColumnsInput = {
  email_id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AdminEmailPrependInput = {
  inputs?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "admin.email" */
export enum AdminEmailSelectColumn {
  /** column name */
  EmailId = 'email_id',
  /** column name */
  EmailTemplateId = 'email_template_id',
  /** column name */
  Inputs = 'inputs'
}

/** input type for updating data in table "admin.email" */
export type AdminEmailSetInput = {
  email_id?: Maybe<Scalars['Int']>;
  email_template_id?: Maybe<Scalars['String']>;
  inputs?: Maybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type AdminEmailStddevFields = {
  __typename?: 'admin_email_stddev_fields';
  email_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "admin.email" */
export type AdminEmailStddevOrderBy = {
  email_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AdminEmailStddevPopFields = {
  __typename?: 'admin_email_stddev_pop_fields';
  email_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "admin.email" */
export type AdminEmailStddevPopOrderBy = {
  email_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AdminEmailStddevSampFields = {
  __typename?: 'admin_email_stddev_samp_fields';
  email_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "admin.email" */
export type AdminEmailStddevSampOrderBy = {
  email_id?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type AdminEmailSumFields = {
  __typename?: 'admin_email_sum_fields';
  email_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "admin.email" */
export type AdminEmailSumOrderBy = {
  email_id?: Maybe<OrderBy>;
};

/** columns and relationships of "admin.email_template" */
export type AdminEmailTemplate = {
  __typename?: 'admin_email_template';
  content: Scalars['jsonb'];
  description?: Maybe<Scalars['String']>;
  /** An object relationship */
  email_layout: AdminEmailLayout;
  email_layout_id: Scalars['String'];
  email_template_id: Scalars['String'];
  from: Scalars['String'];
  name: Scalars['String'];
};


/** columns and relationships of "admin.email_template" */
export type AdminEmailTemplateContentArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "admin.email_template" */
export type AdminEmailTemplateAggregate = {
  __typename?: 'admin_email_template_aggregate';
  aggregate?: Maybe<AdminEmailTemplateAggregateFields>;
  nodes: Array<AdminEmailTemplate>;
};

/** aggregate fields of "admin.email_template" */
export type AdminEmailTemplateAggregateFields = {
  __typename?: 'admin_email_template_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<AdminEmailTemplateMaxFields>;
  min?: Maybe<AdminEmailTemplateMinFields>;
};


/** aggregate fields of "admin.email_template" */
export type AdminEmailTemplateAggregateFieldsCountArgs = {
  columns?: Maybe<Array<AdminEmailTemplateSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "admin.email_template" */
export type AdminEmailTemplateAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<AdminEmailTemplateMaxOrderBy>;
  min?: Maybe<AdminEmailTemplateMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AdminEmailTemplateAppendInput = {
  content?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "admin.email_template" */
export type AdminEmailTemplateArrRelInsertInput = {
  data: Array<AdminEmailTemplateInsertInput>;
  on_conflict?: Maybe<AdminEmailTemplateOnConflict>;
};

/** Boolean expression to filter rows from the table "admin.email_template". All fields are combined with a logical 'AND'. */
export type AdminEmailTemplateBoolExp = {
  _and?: Maybe<Array<Maybe<AdminEmailTemplateBoolExp>>>;
  _not?: Maybe<AdminEmailTemplateBoolExp>;
  _or?: Maybe<Array<Maybe<AdminEmailTemplateBoolExp>>>;
  content?: Maybe<JsonbComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  email_layout?: Maybe<AdminEmailLayoutBoolExp>;
  email_layout_id?: Maybe<StringComparisonExp>;
  email_template_id?: Maybe<StringComparisonExp>;
  from?: Maybe<StringComparisonExp>;
  name?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "admin.email_template" */
export enum AdminEmailTemplateConstraint {
  /** unique or primary key constraint */
  EmailTemplatePkey = 'email_template_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AdminEmailTemplateDeleteAtPathInput = {
  content?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AdminEmailTemplateDeleteElemInput = {
  content?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AdminEmailTemplateDeleteKeyInput = {
  content?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "admin.email_template" */
export type AdminEmailTemplateInsertInput = {
  content?: Maybe<Scalars['jsonb']>;
  description?: Maybe<Scalars['String']>;
  email_layout?: Maybe<AdminEmailLayoutObjRelInsertInput>;
  email_layout_id?: Maybe<Scalars['String']>;
  email_template_id?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AdminEmailTemplateMaxFields = {
  __typename?: 'admin_email_template_max_fields';
  description?: Maybe<Scalars['String']>;
  email_layout_id?: Maybe<Scalars['String']>;
  email_template_id?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "admin.email_template" */
export type AdminEmailTemplateMaxOrderBy = {
  description?: Maybe<OrderBy>;
  email_layout_id?: Maybe<OrderBy>;
  email_template_id?: Maybe<OrderBy>;
  from?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type AdminEmailTemplateMinFields = {
  __typename?: 'admin_email_template_min_fields';
  description?: Maybe<Scalars['String']>;
  email_layout_id?: Maybe<Scalars['String']>;
  email_template_id?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "admin.email_template" */
export type AdminEmailTemplateMinOrderBy = {
  description?: Maybe<OrderBy>;
  email_layout_id?: Maybe<OrderBy>;
  email_template_id?: Maybe<OrderBy>;
  from?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
};

/** response of any mutation on the table "admin.email_template" */
export type AdminEmailTemplateMutationResponse = {
  __typename?: 'admin_email_template_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<AdminEmailTemplate>;
};

/** input type for inserting object relation for remote table "admin.email_template" */
export type AdminEmailTemplateObjRelInsertInput = {
  data: AdminEmailTemplateInsertInput;
  on_conflict?: Maybe<AdminEmailTemplateOnConflict>;
};

/** on conflict condition type for table "admin.email_template" */
export type AdminEmailTemplateOnConflict = {
  constraint: AdminEmailTemplateConstraint;
  update_columns: Array<AdminEmailTemplateUpdateColumn>;
  where?: Maybe<AdminEmailTemplateBoolExp>;
};

/** ordering options when selecting data from "admin.email_template" */
export type AdminEmailTemplateOrderBy = {
  content?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  email_layout?: Maybe<AdminEmailLayoutOrderBy>;
  email_layout_id?: Maybe<OrderBy>;
  email_template_id?: Maybe<OrderBy>;
  from?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
};

/** primary key columns input for table: "admin.email_template" */
export type AdminEmailTemplatePkColumnsInput = {
  email_template_id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AdminEmailTemplatePrependInput = {
  content?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "admin.email_template" */
export enum AdminEmailTemplateSelectColumn {
  /** column name */
  Content = 'content',
  /** column name */
  Description = 'description',
  /** column name */
  EmailLayoutId = 'email_layout_id',
  /** column name */
  EmailTemplateId = 'email_template_id',
  /** column name */
  From = 'from',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "admin.email_template" */
export type AdminEmailTemplateSetInput = {
  content?: Maybe<Scalars['jsonb']>;
  description?: Maybe<Scalars['String']>;
  email_layout_id?: Maybe<Scalars['String']>;
  email_template_id?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "admin.email_template" */
export enum AdminEmailTemplateUpdateColumn {
  /** column name */
  Content = 'content',
  /** column name */
  Description = 'description',
  /** column name */
  EmailLayoutId = 'email_layout_id',
  /** column name */
  EmailTemplateId = 'email_template_id',
  /** column name */
  From = 'from',
  /** column name */
  Name = 'name'
}

/** update columns of table "admin.email" */
export enum AdminEmailUpdateColumn {
  /** column name */
  EmailId = 'email_id',
  /** column name */
  EmailTemplateId = 'email_template_id',
  /** column name */
  Inputs = 'inputs'
}

/** aggregate var_pop on columns */
export type AdminEmailVarPopFields = {
  __typename?: 'admin_email_var_pop_fields';
  email_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "admin.email" */
export type AdminEmailVarPopOrderBy = {
  email_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AdminEmailVarSampFields = {
  __typename?: 'admin_email_var_samp_fields';
  email_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "admin.email" */
export type AdminEmailVarSampOrderBy = {
  email_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type AdminEmailVarianceFields = {
  __typename?: 'admin_email_variance_fields';
  email_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "admin.email" */
export type AdminEmailVarianceOrderBy = {
  email_id?: Maybe<OrderBy>;
};

/** columns and relationships of "admin.twiliomgmt" */
export type AdminTwiliomgmt = {
  __typename?: 'admin_twiliomgmt';
  body?: Maybe<Scalars['String']>;
  endpoint: Scalars['String'];
  method: Scalars['String'];
  time: Scalars['timestamptz'];
  twiliomgmt_id: Scalars['Int'];
  user_id: Scalars['String'];
};

/** aggregated selection of "admin.twiliomgmt" */
export type AdminTwiliomgmtAggregate = {
  __typename?: 'admin_twiliomgmt_aggregate';
  aggregate?: Maybe<AdminTwiliomgmtAggregateFields>;
  nodes: Array<AdminTwiliomgmt>;
};

/** aggregate fields of "admin.twiliomgmt" */
export type AdminTwiliomgmtAggregateFields = {
  __typename?: 'admin_twiliomgmt_aggregate_fields';
  avg?: Maybe<AdminTwiliomgmtAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<AdminTwiliomgmtMaxFields>;
  min?: Maybe<AdminTwiliomgmtMinFields>;
  stddev?: Maybe<AdminTwiliomgmtStddevFields>;
  stddev_pop?: Maybe<AdminTwiliomgmtStddevPopFields>;
  stddev_samp?: Maybe<AdminTwiliomgmtStddevSampFields>;
  sum?: Maybe<AdminTwiliomgmtSumFields>;
  var_pop?: Maybe<AdminTwiliomgmtVarPopFields>;
  var_samp?: Maybe<AdminTwiliomgmtVarSampFields>;
  variance?: Maybe<AdminTwiliomgmtVarianceFields>;
};


/** aggregate fields of "admin.twiliomgmt" */
export type AdminTwiliomgmtAggregateFieldsCountArgs = {
  columns?: Maybe<Array<AdminTwiliomgmtSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "admin.twiliomgmt" */
export type AdminTwiliomgmtAggregateOrderBy = {
  avg?: Maybe<AdminTwiliomgmtAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<AdminTwiliomgmtMaxOrderBy>;
  min?: Maybe<AdminTwiliomgmtMinOrderBy>;
  stddev?: Maybe<AdminTwiliomgmtStddevOrderBy>;
  stddev_pop?: Maybe<AdminTwiliomgmtStddevPopOrderBy>;
  stddev_samp?: Maybe<AdminTwiliomgmtStddevSampOrderBy>;
  sum?: Maybe<AdminTwiliomgmtSumOrderBy>;
  var_pop?: Maybe<AdminTwiliomgmtVarPopOrderBy>;
  var_samp?: Maybe<AdminTwiliomgmtVarSampOrderBy>;
  variance?: Maybe<AdminTwiliomgmtVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "admin.twiliomgmt" */
export type AdminTwiliomgmtArrRelInsertInput = {
  data: Array<AdminTwiliomgmtInsertInput>;
  on_conflict?: Maybe<AdminTwiliomgmtOnConflict>;
};

/** aggregate avg on columns */
export type AdminTwiliomgmtAvgFields = {
  __typename?: 'admin_twiliomgmt_avg_fields';
  twiliomgmt_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "admin.twiliomgmt" */
export type AdminTwiliomgmtAvgOrderBy = {
  twiliomgmt_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "admin.twiliomgmt". All fields are combined with a logical 'AND'. */
export type AdminTwiliomgmtBoolExp = {
  _and?: Maybe<Array<Maybe<AdminTwiliomgmtBoolExp>>>;
  _not?: Maybe<AdminTwiliomgmtBoolExp>;
  _or?: Maybe<Array<Maybe<AdminTwiliomgmtBoolExp>>>;
  body?: Maybe<StringComparisonExp>;
  endpoint?: Maybe<StringComparisonExp>;
  method?: Maybe<StringComparisonExp>;
  time?: Maybe<TimestamptzComparisonExp>;
  twiliomgmt_id?: Maybe<IntComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "admin.twiliomgmt" */
export enum AdminTwiliomgmtConstraint {
  /** unique or primary key constraint */
  TwiliomgmtPkey = 'twiliomgmt_pkey'
}

/** input type for incrementing integer column in table "admin.twiliomgmt" */
export type AdminTwiliomgmtIncInput = {
  twiliomgmt_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "admin.twiliomgmt" */
export type AdminTwiliomgmtInsertInput = {
  body?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['timestamptz']>;
  twiliomgmt_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AdminTwiliomgmtMaxFields = {
  __typename?: 'admin_twiliomgmt_max_fields';
  body?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['timestamptz']>;
  twiliomgmt_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "admin.twiliomgmt" */
export type AdminTwiliomgmtMaxOrderBy = {
  body?: Maybe<OrderBy>;
  endpoint?: Maybe<OrderBy>;
  method?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
  twiliomgmt_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type AdminTwiliomgmtMinFields = {
  __typename?: 'admin_twiliomgmt_min_fields';
  body?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['timestamptz']>;
  twiliomgmt_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "admin.twiliomgmt" */
export type AdminTwiliomgmtMinOrderBy = {
  body?: Maybe<OrderBy>;
  endpoint?: Maybe<OrderBy>;
  method?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
  twiliomgmt_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "admin.twiliomgmt" */
export type AdminTwiliomgmtMutationResponse = {
  __typename?: 'admin_twiliomgmt_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<AdminTwiliomgmt>;
};

/** input type for inserting object relation for remote table "admin.twiliomgmt" */
export type AdminTwiliomgmtObjRelInsertInput = {
  data: AdminTwiliomgmtInsertInput;
  on_conflict?: Maybe<AdminTwiliomgmtOnConflict>;
};

/** on conflict condition type for table "admin.twiliomgmt" */
export type AdminTwiliomgmtOnConflict = {
  constraint: AdminTwiliomgmtConstraint;
  update_columns: Array<AdminTwiliomgmtUpdateColumn>;
  where?: Maybe<AdminTwiliomgmtBoolExp>;
};

/** ordering options when selecting data from "admin.twiliomgmt" */
export type AdminTwiliomgmtOrderBy = {
  body?: Maybe<OrderBy>;
  endpoint?: Maybe<OrderBy>;
  method?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
  twiliomgmt_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "admin.twiliomgmt" */
export type AdminTwiliomgmtPkColumnsInput = {
  twiliomgmt_id: Scalars['Int'];
};

/** columns and relationships of "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResult = {
  __typename?: 'admin_twiliomgmt_result';
  other_errors?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  twiliomgmt_id: Scalars['Int'];
};

/** aggregated selection of "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultAggregate = {
  __typename?: 'admin_twiliomgmt_result_aggregate';
  aggregate?: Maybe<AdminTwiliomgmtResultAggregateFields>;
  nodes: Array<AdminTwiliomgmtResult>;
};

/** aggregate fields of "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultAggregateFields = {
  __typename?: 'admin_twiliomgmt_result_aggregate_fields';
  avg?: Maybe<AdminTwiliomgmtResultAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<AdminTwiliomgmtResultMaxFields>;
  min?: Maybe<AdminTwiliomgmtResultMinFields>;
  stddev?: Maybe<AdminTwiliomgmtResultStddevFields>;
  stddev_pop?: Maybe<AdminTwiliomgmtResultStddevPopFields>;
  stddev_samp?: Maybe<AdminTwiliomgmtResultStddevSampFields>;
  sum?: Maybe<AdminTwiliomgmtResultSumFields>;
  var_pop?: Maybe<AdminTwiliomgmtResultVarPopFields>;
  var_samp?: Maybe<AdminTwiliomgmtResultVarSampFields>;
  variance?: Maybe<AdminTwiliomgmtResultVarianceFields>;
};


/** aggregate fields of "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultAggregateFieldsCountArgs = {
  columns?: Maybe<Array<AdminTwiliomgmtResultSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultAggregateOrderBy = {
  avg?: Maybe<AdminTwiliomgmtResultAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<AdminTwiliomgmtResultMaxOrderBy>;
  min?: Maybe<AdminTwiliomgmtResultMinOrderBy>;
  stddev?: Maybe<AdminTwiliomgmtResultStddevOrderBy>;
  stddev_pop?: Maybe<AdminTwiliomgmtResultStddevPopOrderBy>;
  stddev_samp?: Maybe<AdminTwiliomgmtResultStddevSampOrderBy>;
  sum?: Maybe<AdminTwiliomgmtResultSumOrderBy>;
  var_pop?: Maybe<AdminTwiliomgmtResultVarPopOrderBy>;
  var_samp?: Maybe<AdminTwiliomgmtResultVarSampOrderBy>;
  variance?: Maybe<AdminTwiliomgmtResultVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultArrRelInsertInput = {
  data: Array<AdminTwiliomgmtResultInsertInput>;
  on_conflict?: Maybe<AdminTwiliomgmtResultOnConflict>;
};

/** aggregate avg on columns */
export type AdminTwiliomgmtResultAvgFields = {
  __typename?: 'admin_twiliomgmt_result_avg_fields';
  status_code?: Maybe<Scalars['Float']>;
  twiliomgmt_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultAvgOrderBy = {
  status_code?: Maybe<OrderBy>;
  twiliomgmt_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "admin.twiliomgmt_result". All fields are combined with a logical 'AND'. */
export type AdminTwiliomgmtResultBoolExp = {
  _and?: Maybe<Array<Maybe<AdminTwiliomgmtResultBoolExp>>>;
  _not?: Maybe<AdminTwiliomgmtResultBoolExp>;
  _or?: Maybe<Array<Maybe<AdminTwiliomgmtResultBoolExp>>>;
  other_errors?: Maybe<StringComparisonExp>;
  response?: Maybe<StringComparisonExp>;
  status_code?: Maybe<IntComparisonExp>;
  twiliomgmt_id?: Maybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "admin.twiliomgmt_result" */
export enum AdminTwiliomgmtResultConstraint {
  /** unique or primary key constraint */
  TwiliomgmtResultPkey = 'twiliomgmt_result_pkey'
}

/** input type for incrementing integer column in table "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultIncInput = {
  status_code?: Maybe<Scalars['Int']>;
  twiliomgmt_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultInsertInput = {
  other_errors?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  twiliomgmt_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type AdminTwiliomgmtResultMaxFields = {
  __typename?: 'admin_twiliomgmt_result_max_fields';
  other_errors?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  twiliomgmt_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultMaxOrderBy = {
  other_errors?: Maybe<OrderBy>;
  response?: Maybe<OrderBy>;
  status_code?: Maybe<OrderBy>;
  twiliomgmt_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type AdminTwiliomgmtResultMinFields = {
  __typename?: 'admin_twiliomgmt_result_min_fields';
  other_errors?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  twiliomgmt_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultMinOrderBy = {
  other_errors?: Maybe<OrderBy>;
  response?: Maybe<OrderBy>;
  status_code?: Maybe<OrderBy>;
  twiliomgmt_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultMutationResponse = {
  __typename?: 'admin_twiliomgmt_result_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<AdminTwiliomgmtResult>;
};

/** input type for inserting object relation for remote table "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultObjRelInsertInput = {
  data: AdminTwiliomgmtResultInsertInput;
  on_conflict?: Maybe<AdminTwiliomgmtResultOnConflict>;
};

/** on conflict condition type for table "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultOnConflict = {
  constraint: AdminTwiliomgmtResultConstraint;
  update_columns: Array<AdminTwiliomgmtResultUpdateColumn>;
  where?: Maybe<AdminTwiliomgmtResultBoolExp>;
};

/** ordering options when selecting data from "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultOrderBy = {
  other_errors?: Maybe<OrderBy>;
  response?: Maybe<OrderBy>;
  status_code?: Maybe<OrderBy>;
  twiliomgmt_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultPkColumnsInput = {
  twiliomgmt_id: Scalars['Int'];
};

/** select columns of table "admin.twiliomgmt_result" */
export enum AdminTwiliomgmtResultSelectColumn {
  /** column name */
  OtherErrors = 'other_errors',
  /** column name */
  Response = 'response',
  /** column name */
  StatusCode = 'status_code',
  /** column name */
  TwiliomgmtId = 'twiliomgmt_id'
}

/** input type for updating data in table "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultSetInput = {
  other_errors?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  twiliomgmt_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type AdminTwiliomgmtResultStddevFields = {
  __typename?: 'admin_twiliomgmt_result_stddev_fields';
  status_code?: Maybe<Scalars['Float']>;
  twiliomgmt_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultStddevOrderBy = {
  status_code?: Maybe<OrderBy>;
  twiliomgmt_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AdminTwiliomgmtResultStddevPopFields = {
  __typename?: 'admin_twiliomgmt_result_stddev_pop_fields';
  status_code?: Maybe<Scalars['Float']>;
  twiliomgmt_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultStddevPopOrderBy = {
  status_code?: Maybe<OrderBy>;
  twiliomgmt_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AdminTwiliomgmtResultStddevSampFields = {
  __typename?: 'admin_twiliomgmt_result_stddev_samp_fields';
  status_code?: Maybe<Scalars['Float']>;
  twiliomgmt_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultStddevSampOrderBy = {
  status_code?: Maybe<OrderBy>;
  twiliomgmt_id?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type AdminTwiliomgmtResultSumFields = {
  __typename?: 'admin_twiliomgmt_result_sum_fields';
  status_code?: Maybe<Scalars['Int']>;
  twiliomgmt_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultSumOrderBy = {
  status_code?: Maybe<OrderBy>;
  twiliomgmt_id?: Maybe<OrderBy>;
};

/** update columns of table "admin.twiliomgmt_result" */
export enum AdminTwiliomgmtResultUpdateColumn {
  /** column name */
  OtherErrors = 'other_errors',
  /** column name */
  Response = 'response',
  /** column name */
  StatusCode = 'status_code',
  /** column name */
  TwiliomgmtId = 'twiliomgmt_id'
}

/** aggregate var_pop on columns */
export type AdminTwiliomgmtResultVarPopFields = {
  __typename?: 'admin_twiliomgmt_result_var_pop_fields';
  status_code?: Maybe<Scalars['Float']>;
  twiliomgmt_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultVarPopOrderBy = {
  status_code?: Maybe<OrderBy>;
  twiliomgmt_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AdminTwiliomgmtResultVarSampFields = {
  __typename?: 'admin_twiliomgmt_result_var_samp_fields';
  status_code?: Maybe<Scalars['Float']>;
  twiliomgmt_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultVarSampOrderBy = {
  status_code?: Maybe<OrderBy>;
  twiliomgmt_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type AdminTwiliomgmtResultVarianceFields = {
  __typename?: 'admin_twiliomgmt_result_variance_fields';
  status_code?: Maybe<Scalars['Float']>;
  twiliomgmt_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "admin.twiliomgmt_result" */
export type AdminTwiliomgmtResultVarianceOrderBy = {
  status_code?: Maybe<OrderBy>;
  twiliomgmt_id?: Maybe<OrderBy>;
};

/** select columns of table "admin.twiliomgmt" */
export enum AdminTwiliomgmtSelectColumn {
  /** column name */
  Body = 'body',
  /** column name */
  Endpoint = 'endpoint',
  /** column name */
  Method = 'method',
  /** column name */
  Time = 'time',
  /** column name */
  TwiliomgmtId = 'twiliomgmt_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "admin.twiliomgmt" */
export type AdminTwiliomgmtSetInput = {
  body?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['timestamptz']>;
  twiliomgmt_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AdminTwiliomgmtStddevFields = {
  __typename?: 'admin_twiliomgmt_stddev_fields';
  twiliomgmt_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "admin.twiliomgmt" */
export type AdminTwiliomgmtStddevOrderBy = {
  twiliomgmt_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type AdminTwiliomgmtStddevPopFields = {
  __typename?: 'admin_twiliomgmt_stddev_pop_fields';
  twiliomgmt_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "admin.twiliomgmt" */
export type AdminTwiliomgmtStddevPopOrderBy = {
  twiliomgmt_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type AdminTwiliomgmtStddevSampFields = {
  __typename?: 'admin_twiliomgmt_stddev_samp_fields';
  twiliomgmt_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "admin.twiliomgmt" */
export type AdminTwiliomgmtStddevSampOrderBy = {
  twiliomgmt_id?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type AdminTwiliomgmtSumFields = {
  __typename?: 'admin_twiliomgmt_sum_fields';
  twiliomgmt_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "admin.twiliomgmt" */
export type AdminTwiliomgmtSumOrderBy = {
  twiliomgmt_id?: Maybe<OrderBy>;
};

/** update columns of table "admin.twiliomgmt" */
export enum AdminTwiliomgmtUpdateColumn {
  /** column name */
  Body = 'body',
  /** column name */
  Endpoint = 'endpoint',
  /** column name */
  Method = 'method',
  /** column name */
  Time = 'time',
  /** column name */
  TwiliomgmtId = 'twiliomgmt_id',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type AdminTwiliomgmtVarPopFields = {
  __typename?: 'admin_twiliomgmt_var_pop_fields';
  twiliomgmt_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "admin.twiliomgmt" */
export type AdminTwiliomgmtVarPopOrderBy = {
  twiliomgmt_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type AdminTwiliomgmtVarSampFields = {
  __typename?: 'admin_twiliomgmt_var_samp_fields';
  twiliomgmt_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "admin.twiliomgmt" */
export type AdminTwiliomgmtVarSampOrderBy = {
  twiliomgmt_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type AdminTwiliomgmtVarianceFields = {
  __typename?: 'admin_twiliomgmt_variance_fields';
  twiliomgmt_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "admin.twiliomgmt" */
export type AdminTwiliomgmtVarianceOrderBy = {
  twiliomgmt_id?: Maybe<OrderBy>;
};


/** expression to compare columns of type bigint. All fields are combined with logical 'AND'. */
export type BigintComparisonExp = {
  _eq?: Maybe<Scalars['bigint']>;
  _gt?: Maybe<Scalars['bigint']>;
  _gte?: Maybe<Scalars['bigint']>;
  _in?: Maybe<Array<Scalars['bigint']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['bigint']>;
  _lte?: Maybe<Scalars['bigint']>;
  _neq?: Maybe<Scalars['bigint']>;
  _nin?: Maybe<Array<Scalars['bigint']>>;
};


/** expression to compare columns of type date. All fields are combined with logical 'AND'. */
export type DateComparisonExp = {
  _eq?: Maybe<Scalars['date']>;
  _gt?: Maybe<Scalars['date']>;
  _gte?: Maybe<Scalars['date']>;
  _in?: Maybe<Array<Scalars['date']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['date']>;
  _lte?: Maybe<Scalars['date']>;
  _neq?: Maybe<Scalars['date']>;
  _nin?: Maybe<Array<Scalars['date']>>;
};

/** columns and relationships of "db_ping" */
export type DbPing = {
  __typename?: 'db_ping';
  date: Scalars['String'];
  id: Scalars['Int'];
  time: Scalars['String'];
  timestamp: Scalars['timestamptz'];
};

/** aggregated selection of "db_ping" */
export type DbPingAggregate = {
  __typename?: 'db_ping_aggregate';
  aggregate?: Maybe<DbPingAggregateFields>;
  nodes: Array<DbPing>;
};

/** aggregate fields of "db_ping" */
export type DbPingAggregateFields = {
  __typename?: 'db_ping_aggregate_fields';
  avg?: Maybe<DbPingAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<DbPingMaxFields>;
  min?: Maybe<DbPingMinFields>;
  stddev?: Maybe<DbPingStddevFields>;
  stddev_pop?: Maybe<DbPingStddevPopFields>;
  stddev_samp?: Maybe<DbPingStddevSampFields>;
  sum?: Maybe<DbPingSumFields>;
  var_pop?: Maybe<DbPingVarPopFields>;
  var_samp?: Maybe<DbPingVarSampFields>;
  variance?: Maybe<DbPingVarianceFields>;
};


/** aggregate fields of "db_ping" */
export type DbPingAggregateFieldsCountArgs = {
  columns?: Maybe<Array<DbPingSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "db_ping" */
export type DbPingAggregateOrderBy = {
  avg?: Maybe<DbPingAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<DbPingMaxOrderBy>;
  min?: Maybe<DbPingMinOrderBy>;
  stddev?: Maybe<DbPingStddevOrderBy>;
  stddev_pop?: Maybe<DbPingStddevPopOrderBy>;
  stddev_samp?: Maybe<DbPingStddevSampOrderBy>;
  sum?: Maybe<DbPingSumOrderBy>;
  var_pop?: Maybe<DbPingVarPopOrderBy>;
  var_samp?: Maybe<DbPingVarSampOrderBy>;
  variance?: Maybe<DbPingVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "db_ping" */
export type DbPingArrRelInsertInput = {
  data: Array<DbPingInsertInput>;
  on_conflict?: Maybe<DbPingOnConflict>;
};

/** aggregate avg on columns */
export type DbPingAvgFields = {
  __typename?: 'db_ping_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "db_ping" */
export type DbPingAvgOrderBy = {
  id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "db_ping". All fields are combined with a logical 'AND'. */
export type DbPingBoolExp = {
  _and?: Maybe<Array<Maybe<DbPingBoolExp>>>;
  _not?: Maybe<DbPingBoolExp>;
  _or?: Maybe<Array<Maybe<DbPingBoolExp>>>;
  date?: Maybe<StringComparisonExp>;
  id?: Maybe<IntComparisonExp>;
  time?: Maybe<StringComparisonExp>;
  timestamp?: Maybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "db_ping" */
export enum DbPingConstraint {
  /** unique or primary key constraint */
  DbPingPkey = 'db_ping_pkey'
}

/** input type for incrementing integer column in table "db_ping" */
export type DbPingIncInput = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "db_ping" */
export type DbPingInsertInput = {
  date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  time?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type DbPingMaxFields = {
  __typename?: 'db_ping_max_fields';
  date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  time?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "db_ping" */
export type DbPingMaxOrderBy = {
  date?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type DbPingMinFields = {
  __typename?: 'db_ping_min_fields';
  date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  time?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "db_ping" */
export type DbPingMinOrderBy = {
  date?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
};

/** response of any mutation on the table "db_ping" */
export type DbPingMutationResponse = {
  __typename?: 'db_ping_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<DbPing>;
};

/** input type for inserting object relation for remote table "db_ping" */
export type DbPingObjRelInsertInput = {
  data: DbPingInsertInput;
  on_conflict?: Maybe<DbPingOnConflict>;
};

/** on conflict condition type for table "db_ping" */
export type DbPingOnConflict = {
  constraint: DbPingConstraint;
  update_columns: Array<DbPingUpdateColumn>;
  where?: Maybe<DbPingBoolExp>;
};

/** ordering options when selecting data from "db_ping" */
export type DbPingOrderBy = {
  date?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
};

/** primary key columns input for table: "db_ping" */
export type DbPingPkColumnsInput = {
  id: Scalars['Int'];
};

/** select columns of table "db_ping" */
export enum DbPingSelectColumn {
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  Time = 'time',
  /** column name */
  Timestamp = 'timestamp'
}

/** input type for updating data in table "db_ping" */
export type DbPingSetInput = {
  date?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  time?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type DbPingStddevFields = {
  __typename?: 'db_ping_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "db_ping" */
export type DbPingStddevOrderBy = {
  id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type DbPingStddevPopFields = {
  __typename?: 'db_ping_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "db_ping" */
export type DbPingStddevPopOrderBy = {
  id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type DbPingStddevSampFields = {
  __typename?: 'db_ping_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "db_ping" */
export type DbPingStddevSampOrderBy = {
  id?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type DbPingSumFields = {
  __typename?: 'db_ping_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "db_ping" */
export type DbPingSumOrderBy = {
  id?: Maybe<OrderBy>;
};

/** update columns of table "db_ping" */
export enum DbPingUpdateColumn {
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  Time = 'time',
  /** column name */
  Timestamp = 'timestamp'
}

/** aggregate var_pop on columns */
export type DbPingVarPopFields = {
  __typename?: 'db_ping_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "db_ping" */
export type DbPingVarPopOrderBy = {
  id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type DbPingVarSampFields = {
  __typename?: 'db_ping_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "db_ping" */
export type DbPingVarSampOrderBy = {
  id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type DbPingVarianceFields = {
  __typename?: 'db_ping_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "db_ping" */
export type DbPingVarianceOrderBy = {
  id?: Maybe<OrderBy>;
};

/** columns and relationships of "db_state" */
export type DbState = {
  __typename?: 'db_state';
  key: Scalars['String'];
  val: Scalars['jsonb'];
};


/** columns and relationships of "db_state" */
export type DbStateValArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "db_state" */
export type DbStateAggregate = {
  __typename?: 'db_state_aggregate';
  aggregate?: Maybe<DbStateAggregateFields>;
  nodes: Array<DbState>;
};

/** aggregate fields of "db_state" */
export type DbStateAggregateFields = {
  __typename?: 'db_state_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<DbStateMaxFields>;
  min?: Maybe<DbStateMinFields>;
};


/** aggregate fields of "db_state" */
export type DbStateAggregateFieldsCountArgs = {
  columns?: Maybe<Array<DbStateSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "db_state" */
export type DbStateAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<DbStateMaxOrderBy>;
  min?: Maybe<DbStateMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DbStateAppendInput = {
  val?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "db_state" */
export type DbStateArrRelInsertInput = {
  data: Array<DbStateInsertInput>;
  on_conflict?: Maybe<DbStateOnConflict>;
};

/** Boolean expression to filter rows from the table "db_state". All fields are combined with a logical 'AND'. */
export type DbStateBoolExp = {
  _and?: Maybe<Array<Maybe<DbStateBoolExp>>>;
  _not?: Maybe<DbStateBoolExp>;
  _or?: Maybe<Array<Maybe<DbStateBoolExp>>>;
  key?: Maybe<StringComparisonExp>;
  val?: Maybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "db_state" */
export enum DbStateConstraint {
  /** unique or primary key constraint */
  DbStatePkey = 'db_state_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DbStateDeleteAtPathInput = {
  val?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DbStateDeleteElemInput = {
  val?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DbStateDeleteKeyInput = {
  val?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "db_state" */
export type DbStateInsertInput = {
  key?: Maybe<Scalars['String']>;
  val?: Maybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type DbStateMaxFields = {
  __typename?: 'db_state_max_fields';
  key?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "db_state" */
export type DbStateMaxOrderBy = {
  key?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type DbStateMinFields = {
  __typename?: 'db_state_min_fields';
  key?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "db_state" */
export type DbStateMinOrderBy = {
  key?: Maybe<OrderBy>;
};

/** response of any mutation on the table "db_state" */
export type DbStateMutationResponse = {
  __typename?: 'db_state_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<DbState>;
};

/** input type for inserting object relation for remote table "db_state" */
export type DbStateObjRelInsertInput = {
  data: DbStateInsertInput;
  on_conflict?: Maybe<DbStateOnConflict>;
};

/** on conflict condition type for table "db_state" */
export type DbStateOnConflict = {
  constraint: DbStateConstraint;
  update_columns: Array<DbStateUpdateColumn>;
  where?: Maybe<DbStateBoolExp>;
};

/** ordering options when selecting data from "db_state" */
export type DbStateOrderBy = {
  key?: Maybe<OrderBy>;
  val?: Maybe<OrderBy>;
};

/** primary key columns input for table: "db_state" */
export type DbStatePkColumnsInput = {
  key: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DbStatePrependInput = {
  val?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "db_state" */
export enum DbStateSelectColumn {
  /** column name */
  Key = 'key',
  /** column name */
  Val = 'val'
}

/** input type for updating data in table "db_state" */
export type DbStateSetInput = {
  key?: Maybe<Scalars['String']>;
  val?: Maybe<Scalars['jsonb']>;
};

/** update columns of table "db_state" */
export enum DbStateUpdateColumn {
  /** column name */
  Key = 'key',
  /** column name */
  Val = 'val'
}


/** expression to compare columns of type float8. All fields are combined with logical 'AND'. */
export type Float8ComparisonExp = {
  _eq?: Maybe<Scalars['float8']>;
  _gt?: Maybe<Scalars['float8']>;
  _gte?: Maybe<Scalars['float8']>;
  _in?: Maybe<Array<Scalars['float8']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['float8']>;
  _lte?: Maybe<Scalars['float8']>;
  _neq?: Maybe<Scalars['float8']>;
  _nin?: Maybe<Array<Scalars['float8']>>;
};

/**
 * stores student achievements
 *
 *
 * columns and relationships of "grad.achievement"
 */
export type GradAchievement = {
  __typename?: 'grad_achievement';
  /** auto-generated uuid */
  achievement_id: Scalars['String'];
  /** free form text describing achievement */
  description: Scalars['String'];
  /** maps to profile.user_id */
  user_id: Scalars['String'];
};

/** aggregated selection of "grad.achievement" */
export type GradAchievementAggregate = {
  __typename?: 'grad_achievement_aggregate';
  aggregate?: Maybe<GradAchievementAggregateFields>;
  nodes: Array<GradAchievement>;
};

/** aggregate fields of "grad.achievement" */
export type GradAchievementAggregateFields = {
  __typename?: 'grad_achievement_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradAchievementMaxFields>;
  min?: Maybe<GradAchievementMinFields>;
};


/** aggregate fields of "grad.achievement" */
export type GradAchievementAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradAchievementSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.achievement" */
export type GradAchievementAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradAchievementMaxOrderBy>;
  min?: Maybe<GradAchievementMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.achievement" */
export type GradAchievementArrRelInsertInput = {
  data: Array<GradAchievementInsertInput>;
  on_conflict?: Maybe<GradAchievementOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.achievement". All fields are combined with a logical 'AND'. */
export type GradAchievementBoolExp = {
  _and?: Maybe<Array<Maybe<GradAchievementBoolExp>>>;
  _not?: Maybe<GradAchievementBoolExp>;
  _or?: Maybe<Array<Maybe<GradAchievementBoolExp>>>;
  achievement_id?: Maybe<StringComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.achievement" */
export enum GradAchievementConstraint {
  /** unique or primary key constraint */
  AchievementAchievementIdKey = 'achievement_achievement_id_key',
  /** unique or primary key constraint */
  AchievementPkey = 'achievement_pkey'
}

/** input type for inserting data into table "grad.achievement" */
export type GradAchievementInsertInput = {
  achievement_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradAchievementMaxFields = {
  __typename?: 'grad_achievement_max_fields';
  achievement_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.achievement" */
export type GradAchievementMaxOrderBy = {
  achievement_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradAchievementMinFields = {
  __typename?: 'grad_achievement_min_fields';
  achievement_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.achievement" */
export type GradAchievementMinOrderBy = {
  achievement_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.achievement" */
export type GradAchievementMutationResponse = {
  __typename?: 'grad_achievement_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradAchievement>;
};

/** input type for inserting object relation for remote table "grad.achievement" */
export type GradAchievementObjRelInsertInput = {
  data: GradAchievementInsertInput;
  on_conflict?: Maybe<GradAchievementOnConflict>;
};

/** on conflict condition type for table "grad.achievement" */
export type GradAchievementOnConflict = {
  constraint: GradAchievementConstraint;
  update_columns: Array<GradAchievementUpdateColumn>;
  where?: Maybe<GradAchievementBoolExp>;
};

/** ordering options when selecting data from "grad.achievement" */
export type GradAchievementOrderBy = {
  achievement_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.achievement" */
export type GradAchievementPkColumnsInput = {
  /** auto-generated uuid */
  achievement_id: Scalars['String'];
};

/** select columns of table "grad.achievement" */
export enum GradAchievementSelectColumn {
  /** column name */
  AchievementId = 'achievement_id',
  /** column name */
  Description = 'description',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "grad.achievement" */
export type GradAchievementSetInput = {
  achievement_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.achievement" */
export enum GradAchievementUpdateColumn {
  /** column name */
  AchievementId = 'achievement_id',
  /** column name */
  Description = 'description',
  /** column name */
  UserId = 'user_id'
}

/**
 * stores academic awards, professional awards and designations
 *
 *
 * columns and relationships of "grad.award"
 */
export type GradAward = {
  __typename?: 'grad_award';
  /** possible values: Professional designation | Academic honor */
  award_category?: Maybe<Scalars['String']>;
  /** auto-generated uuid */
  award_id: Scalars['String'];
  /** text: either from autocomplete or fill in */
  award_name: Scalars['String'];
  /** link this award to a degree, optional */
  degree_id?: Maybe<Scalars['String']>;
  /** maps to profile.user_id */
  user_id: Scalars['String'];
  /** link this award to a work experience, optional */
  work_experience_id?: Maybe<Scalars['String']>;
  /** year award is received, optional */
  year_received?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "grad.award" */
export type GradAwardAggregate = {
  __typename?: 'grad_award_aggregate';
  aggregate?: Maybe<GradAwardAggregateFields>;
  nodes: Array<GradAward>;
};

/** aggregate fields of "grad.award" */
export type GradAwardAggregateFields = {
  __typename?: 'grad_award_aggregate_fields';
  avg?: Maybe<GradAwardAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradAwardMaxFields>;
  min?: Maybe<GradAwardMinFields>;
  stddev?: Maybe<GradAwardStddevFields>;
  stddev_pop?: Maybe<GradAwardStddevPopFields>;
  stddev_samp?: Maybe<GradAwardStddevSampFields>;
  sum?: Maybe<GradAwardSumFields>;
  var_pop?: Maybe<GradAwardVarPopFields>;
  var_samp?: Maybe<GradAwardVarSampFields>;
  variance?: Maybe<GradAwardVarianceFields>;
};


/** aggregate fields of "grad.award" */
export type GradAwardAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradAwardSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.award" */
export type GradAwardAggregateOrderBy = {
  avg?: Maybe<GradAwardAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<GradAwardMaxOrderBy>;
  min?: Maybe<GradAwardMinOrderBy>;
  stddev?: Maybe<GradAwardStddevOrderBy>;
  stddev_pop?: Maybe<GradAwardStddevPopOrderBy>;
  stddev_samp?: Maybe<GradAwardStddevSampOrderBy>;
  sum?: Maybe<GradAwardSumOrderBy>;
  var_pop?: Maybe<GradAwardVarPopOrderBy>;
  var_samp?: Maybe<GradAwardVarSampOrderBy>;
  variance?: Maybe<GradAwardVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "grad.award" */
export type GradAwardArrRelInsertInput = {
  data: Array<GradAwardInsertInput>;
  on_conflict?: Maybe<GradAwardOnConflict>;
};

/** aggregate avg on columns */
export type GradAwardAvgFields = {
  __typename?: 'grad_award_avg_fields';
  year_received?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "grad.award" */
export type GradAwardAvgOrderBy = {
  year_received?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "grad.award". All fields are combined with a logical 'AND'. */
export type GradAwardBoolExp = {
  _and?: Maybe<Array<Maybe<GradAwardBoolExp>>>;
  _not?: Maybe<GradAwardBoolExp>;
  _or?: Maybe<Array<Maybe<GradAwardBoolExp>>>;
  award_category?: Maybe<StringComparisonExp>;
  award_id?: Maybe<StringComparisonExp>;
  award_name?: Maybe<StringComparisonExp>;
  degree_id?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
  work_experience_id?: Maybe<StringComparisonExp>;
  year_received?: Maybe<NumericComparisonExp>;
};

/** unique or primary key constraints on table "grad.award" */
export enum GradAwardConstraint {
  /** unique or primary key constraint */
  AwardAwardIdKey = 'award_award_id_key',
  /** unique or primary key constraint */
  AwardPkey = 'award_pkey'
}

/** input type for incrementing integer column in table "grad.award" */
export type GradAwardIncInput = {
  year_received?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "grad.award" */
export type GradAwardInsertInput = {
  award_category?: Maybe<Scalars['String']>;
  award_id?: Maybe<Scalars['String']>;
  award_name?: Maybe<Scalars['String']>;
  degree_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  work_experience_id?: Maybe<Scalars['String']>;
  year_received?: Maybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type GradAwardMaxFields = {
  __typename?: 'grad_award_max_fields';
  award_category?: Maybe<Scalars['String']>;
  award_id?: Maybe<Scalars['String']>;
  award_name?: Maybe<Scalars['String']>;
  degree_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  work_experience_id?: Maybe<Scalars['String']>;
  year_received?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "grad.award" */
export type GradAwardMaxOrderBy = {
  award_category?: Maybe<OrderBy>;
  award_id?: Maybe<OrderBy>;
  award_name?: Maybe<OrderBy>;
  degree_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  work_experience_id?: Maybe<OrderBy>;
  year_received?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradAwardMinFields = {
  __typename?: 'grad_award_min_fields';
  award_category?: Maybe<Scalars['String']>;
  award_id?: Maybe<Scalars['String']>;
  award_name?: Maybe<Scalars['String']>;
  degree_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  work_experience_id?: Maybe<Scalars['String']>;
  year_received?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "grad.award" */
export type GradAwardMinOrderBy = {
  award_category?: Maybe<OrderBy>;
  award_id?: Maybe<OrderBy>;
  award_name?: Maybe<OrderBy>;
  degree_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  work_experience_id?: Maybe<OrderBy>;
  year_received?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.award" */
export type GradAwardMutationResponse = {
  __typename?: 'grad_award_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradAward>;
};

/** input type for inserting object relation for remote table "grad.award" */
export type GradAwardObjRelInsertInput = {
  data: GradAwardInsertInput;
  on_conflict?: Maybe<GradAwardOnConflict>;
};

/** on conflict condition type for table "grad.award" */
export type GradAwardOnConflict = {
  constraint: GradAwardConstraint;
  update_columns: Array<GradAwardUpdateColumn>;
  where?: Maybe<GradAwardBoolExp>;
};

/** ordering options when selecting data from "grad.award" */
export type GradAwardOrderBy = {
  award_category?: Maybe<OrderBy>;
  award_id?: Maybe<OrderBy>;
  award_name?: Maybe<OrderBy>;
  degree_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  work_experience_id?: Maybe<OrderBy>;
  year_received?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.award" */
export type GradAwardPkColumnsInput = {
  /** auto-generated uuid */
  award_id: Scalars['String'];
};

/** select columns of table "grad.award" */
export enum GradAwardSelectColumn {
  /** column name */
  AwardCategory = 'award_category',
  /** column name */
  AwardId = 'award_id',
  /** column name */
  AwardName = 'award_name',
  /** column name */
  DegreeId = 'degree_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WorkExperienceId = 'work_experience_id',
  /** column name */
  YearReceived = 'year_received'
}

/** input type for updating data in table "grad.award" */
export type GradAwardSetInput = {
  award_category?: Maybe<Scalars['String']>;
  award_id?: Maybe<Scalars['String']>;
  award_name?: Maybe<Scalars['String']>;
  degree_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  work_experience_id?: Maybe<Scalars['String']>;
  year_received?: Maybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type GradAwardStddevFields = {
  __typename?: 'grad_award_stddev_fields';
  year_received?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "grad.award" */
export type GradAwardStddevOrderBy = {
  year_received?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type GradAwardStddevPopFields = {
  __typename?: 'grad_award_stddev_pop_fields';
  year_received?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "grad.award" */
export type GradAwardStddevPopOrderBy = {
  year_received?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type GradAwardStddevSampFields = {
  __typename?: 'grad_award_stddev_samp_fields';
  year_received?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "grad.award" */
export type GradAwardStddevSampOrderBy = {
  year_received?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type GradAwardSumFields = {
  __typename?: 'grad_award_sum_fields';
  year_received?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "grad.award" */
export type GradAwardSumOrderBy = {
  year_received?: Maybe<OrderBy>;
};

/** update columns of table "grad.award" */
export enum GradAwardUpdateColumn {
  /** column name */
  AwardCategory = 'award_category',
  /** column name */
  AwardId = 'award_id',
  /** column name */
  AwardName = 'award_name',
  /** column name */
  DegreeId = 'degree_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WorkExperienceId = 'work_experience_id',
  /** column name */
  YearReceived = 'year_received'
}

/** aggregate var_pop on columns */
export type GradAwardVarPopFields = {
  __typename?: 'grad_award_var_pop_fields';
  year_received?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "grad.award" */
export type GradAwardVarPopOrderBy = {
  year_received?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type GradAwardVarSampFields = {
  __typename?: 'grad_award_var_samp_fields';
  year_received?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "grad.award" */
export type GradAwardVarSampOrderBy = {
  year_received?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type GradAwardVarianceFields = {
  __typename?: 'grad_award_variance_fields';
  year_received?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "grad.award" */
export type GradAwardVarianceOrderBy = {
  year_received?: Maybe<OrderBy>;
};

/**
 * stores student bookmarking jobs
 *
 *
 * columns and relationships of "grad.bookmark_job"
 */
export type GradBookmarkJob = {
  __typename?: 'grad_bookmark_job';
  /** auto-generated uuid */
  bookmark_job_id: Scalars['String'];
  /** maps to job_posting.job_posting_id */
  job_posting_id: Scalars['String'];
  /** timestamp when bookmarked */
  timestamp: Scalars['timestamptz'];
  /** maps to profile.user_id */
  user_id: Scalars['String'];
};

/** aggregated selection of "grad.bookmark_job" */
export type GradBookmarkJobAggregate = {
  __typename?: 'grad_bookmark_job_aggregate';
  aggregate?: Maybe<GradBookmarkJobAggregateFields>;
  nodes: Array<GradBookmarkJob>;
};

/** aggregate fields of "grad.bookmark_job" */
export type GradBookmarkJobAggregateFields = {
  __typename?: 'grad_bookmark_job_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradBookmarkJobMaxFields>;
  min?: Maybe<GradBookmarkJobMinFields>;
};


/** aggregate fields of "grad.bookmark_job" */
export type GradBookmarkJobAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradBookmarkJobSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.bookmark_job" */
export type GradBookmarkJobAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradBookmarkJobMaxOrderBy>;
  min?: Maybe<GradBookmarkJobMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.bookmark_job" */
export type GradBookmarkJobArrRelInsertInput = {
  data: Array<GradBookmarkJobInsertInput>;
  on_conflict?: Maybe<GradBookmarkJobOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.bookmark_job". All fields are combined with a logical 'AND'. */
export type GradBookmarkJobBoolExp = {
  _and?: Maybe<Array<Maybe<GradBookmarkJobBoolExp>>>;
  _not?: Maybe<GradBookmarkJobBoolExp>;
  _or?: Maybe<Array<Maybe<GradBookmarkJobBoolExp>>>;
  bookmark_job_id?: Maybe<StringComparisonExp>;
  job_posting_id?: Maybe<StringComparisonExp>;
  timestamp?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.bookmark_job" */
export enum GradBookmarkJobConstraint {
  /** unique or primary key constraint */
  BookmarkJobBookmarkJobIdKey = 'bookmark_job_bookmark_job_id_key',
  /** unique or primary key constraint */
  BookmarkJobPkey = 'bookmark_job_pkey'
}

/** input type for inserting data into table "grad.bookmark_job" */
export type GradBookmarkJobInsertInput = {
  bookmark_job_id?: Maybe<Scalars['String']>;
  job_posting_id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradBookmarkJobMaxFields = {
  __typename?: 'grad_bookmark_job_max_fields';
  bookmark_job_id?: Maybe<Scalars['String']>;
  job_posting_id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.bookmark_job" */
export type GradBookmarkJobMaxOrderBy = {
  bookmark_job_id?: Maybe<OrderBy>;
  job_posting_id?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradBookmarkJobMinFields = {
  __typename?: 'grad_bookmark_job_min_fields';
  bookmark_job_id?: Maybe<Scalars['String']>;
  job_posting_id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.bookmark_job" */
export type GradBookmarkJobMinOrderBy = {
  bookmark_job_id?: Maybe<OrderBy>;
  job_posting_id?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.bookmark_job" */
export type GradBookmarkJobMutationResponse = {
  __typename?: 'grad_bookmark_job_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradBookmarkJob>;
};

/** input type for inserting object relation for remote table "grad.bookmark_job" */
export type GradBookmarkJobObjRelInsertInput = {
  data: GradBookmarkJobInsertInput;
  on_conflict?: Maybe<GradBookmarkJobOnConflict>;
};

/** on conflict condition type for table "grad.bookmark_job" */
export type GradBookmarkJobOnConflict = {
  constraint: GradBookmarkJobConstraint;
  update_columns: Array<GradBookmarkJobUpdateColumn>;
  where?: Maybe<GradBookmarkJobBoolExp>;
};

/** ordering options when selecting data from "grad.bookmark_job" */
export type GradBookmarkJobOrderBy = {
  bookmark_job_id?: Maybe<OrderBy>;
  job_posting_id?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.bookmark_job" */
export type GradBookmarkJobPkColumnsInput = {
  /** auto-generated uuid */
  bookmark_job_id: Scalars['String'];
};

/** select columns of table "grad.bookmark_job" */
export enum GradBookmarkJobSelectColumn {
  /** column name */
  BookmarkJobId = 'bookmark_job_id',
  /** column name */
  JobPostingId = 'job_posting_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "grad.bookmark_job" */
export type GradBookmarkJobSetInput = {
  bookmark_job_id?: Maybe<Scalars['String']>;
  job_posting_id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.bookmark_job" */
export enum GradBookmarkJobUpdateColumn {
  /** column name */
  BookmarkJobId = 'bookmark_job_id',
  /** column name */
  JobPostingId = 'job_posting_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "grad.city_state_selection" */
export type GradCityStateSelection = {
  __typename?: 'grad_city_state_selection';
  city: Scalars['String'];
  city_state_selection_id: Scalars['String'];
  state: Scalars['String'];
};

/** aggregated selection of "grad.city_state_selection" */
export type GradCityStateSelectionAggregate = {
  __typename?: 'grad_city_state_selection_aggregate';
  aggregate?: Maybe<GradCityStateSelectionAggregateFields>;
  nodes: Array<GradCityStateSelection>;
};

/** aggregate fields of "grad.city_state_selection" */
export type GradCityStateSelectionAggregateFields = {
  __typename?: 'grad_city_state_selection_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradCityStateSelectionMaxFields>;
  min?: Maybe<GradCityStateSelectionMinFields>;
};


/** aggregate fields of "grad.city_state_selection" */
export type GradCityStateSelectionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradCityStateSelectionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.city_state_selection" */
export type GradCityStateSelectionAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradCityStateSelectionMaxOrderBy>;
  min?: Maybe<GradCityStateSelectionMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.city_state_selection" */
export type GradCityStateSelectionArrRelInsertInput = {
  data: Array<GradCityStateSelectionInsertInput>;
  on_conflict?: Maybe<GradCityStateSelectionOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.city_state_selection". All fields are combined with a logical 'AND'. */
export type GradCityStateSelectionBoolExp = {
  _and?: Maybe<Array<Maybe<GradCityStateSelectionBoolExp>>>;
  _not?: Maybe<GradCityStateSelectionBoolExp>;
  _or?: Maybe<Array<Maybe<GradCityStateSelectionBoolExp>>>;
  city?: Maybe<StringComparisonExp>;
  city_state_selection_id?: Maybe<StringComparisonExp>;
  state?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.city_state_selection" */
export enum GradCityStateSelectionConstraint {
  /** unique or primary key constraint */
  CityStateSelectionPkey = 'city_state_selection_pkey'
}

/** input type for inserting data into table "grad.city_state_selection" */
export type GradCityStateSelectionInsertInput = {
  city?: Maybe<Scalars['String']>;
  city_state_selection_id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradCityStateSelectionMaxFields = {
  __typename?: 'grad_city_state_selection_max_fields';
  city?: Maybe<Scalars['String']>;
  city_state_selection_id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.city_state_selection" */
export type GradCityStateSelectionMaxOrderBy = {
  city?: Maybe<OrderBy>;
  city_state_selection_id?: Maybe<OrderBy>;
  state?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradCityStateSelectionMinFields = {
  __typename?: 'grad_city_state_selection_min_fields';
  city?: Maybe<Scalars['String']>;
  city_state_selection_id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.city_state_selection" */
export type GradCityStateSelectionMinOrderBy = {
  city?: Maybe<OrderBy>;
  city_state_selection_id?: Maybe<OrderBy>;
  state?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.city_state_selection" */
export type GradCityStateSelectionMutationResponse = {
  __typename?: 'grad_city_state_selection_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradCityStateSelection>;
};

/** input type for inserting object relation for remote table "grad.city_state_selection" */
export type GradCityStateSelectionObjRelInsertInput = {
  data: GradCityStateSelectionInsertInput;
  on_conflict?: Maybe<GradCityStateSelectionOnConflict>;
};

/** on conflict condition type for table "grad.city_state_selection" */
export type GradCityStateSelectionOnConflict = {
  constraint: GradCityStateSelectionConstraint;
  update_columns: Array<GradCityStateSelectionUpdateColumn>;
  where?: Maybe<GradCityStateSelectionBoolExp>;
};

/** ordering options when selecting data from "grad.city_state_selection" */
export type GradCityStateSelectionOrderBy = {
  city?: Maybe<OrderBy>;
  city_state_selection_id?: Maybe<OrderBy>;
  state?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.city_state_selection" */
export type GradCityStateSelectionPkColumnsInput = {
  city_state_selection_id: Scalars['String'];
};

/** select columns of table "grad.city_state_selection" */
export enum GradCityStateSelectionSelectColumn {
  /** column name */
  City = 'city',
  /** column name */
  CityStateSelectionId = 'city_state_selection_id',
  /** column name */
  State = 'state'
}

/** input type for updating data in table "grad.city_state_selection" */
export type GradCityStateSelectionSetInput = {
  city?: Maybe<Scalars['String']>;
  city_state_selection_id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.city_state_selection" */
export enum GradCityStateSelectionUpdateColumn {
  /** column name */
  City = 'city',
  /** column name */
  CityStateSelectionId = 'city_state_selection_id',
  /** column name */
  State = 'state'
}

/** columns and relationships of "grad.comm_preference_selection" */
export type GradCommPreferenceSelection = {
  __typename?: 'grad_comm_preference_selection';
  comm_preference_selection_id: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "grad.comm_preference_selection" */
export type GradCommPreferenceSelectionAggregate = {
  __typename?: 'grad_comm_preference_selection_aggregate';
  aggregate?: Maybe<GradCommPreferenceSelectionAggregateFields>;
  nodes: Array<GradCommPreferenceSelection>;
};

/** aggregate fields of "grad.comm_preference_selection" */
export type GradCommPreferenceSelectionAggregateFields = {
  __typename?: 'grad_comm_preference_selection_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradCommPreferenceSelectionMaxFields>;
  min?: Maybe<GradCommPreferenceSelectionMinFields>;
};


/** aggregate fields of "grad.comm_preference_selection" */
export type GradCommPreferenceSelectionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradCommPreferenceSelectionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.comm_preference_selection" */
export type GradCommPreferenceSelectionAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradCommPreferenceSelectionMaxOrderBy>;
  min?: Maybe<GradCommPreferenceSelectionMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.comm_preference_selection" */
export type GradCommPreferenceSelectionArrRelInsertInput = {
  data: Array<GradCommPreferenceSelectionInsertInput>;
  on_conflict?: Maybe<GradCommPreferenceSelectionOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.comm_preference_selection". All fields are combined with a logical 'AND'. */
export type GradCommPreferenceSelectionBoolExp = {
  _and?: Maybe<Array<Maybe<GradCommPreferenceSelectionBoolExp>>>;
  _not?: Maybe<GradCommPreferenceSelectionBoolExp>;
  _or?: Maybe<Array<Maybe<GradCommPreferenceSelectionBoolExp>>>;
  comm_preference_selection_id?: Maybe<StringComparisonExp>;
  value?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.comm_preference_selection" */
export enum GradCommPreferenceSelectionConstraint {
  /** unique or primary key constraint */
  CommPreferenceSelectionPkey = 'comm_preference_selection_pkey'
}

/** input type for inserting data into table "grad.comm_preference_selection" */
export type GradCommPreferenceSelectionInsertInput = {
  comm_preference_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradCommPreferenceSelectionMaxFields = {
  __typename?: 'grad_comm_preference_selection_max_fields';
  comm_preference_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.comm_preference_selection" */
export type GradCommPreferenceSelectionMaxOrderBy = {
  comm_preference_selection_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradCommPreferenceSelectionMinFields = {
  __typename?: 'grad_comm_preference_selection_min_fields';
  comm_preference_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.comm_preference_selection" */
export type GradCommPreferenceSelectionMinOrderBy = {
  comm_preference_selection_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.comm_preference_selection" */
export type GradCommPreferenceSelectionMutationResponse = {
  __typename?: 'grad_comm_preference_selection_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradCommPreferenceSelection>;
};

/** input type for inserting object relation for remote table "grad.comm_preference_selection" */
export type GradCommPreferenceSelectionObjRelInsertInput = {
  data: GradCommPreferenceSelectionInsertInput;
  on_conflict?: Maybe<GradCommPreferenceSelectionOnConflict>;
};

/** on conflict condition type for table "grad.comm_preference_selection" */
export type GradCommPreferenceSelectionOnConflict = {
  constraint: GradCommPreferenceSelectionConstraint;
  update_columns: Array<GradCommPreferenceSelectionUpdateColumn>;
  where?: Maybe<GradCommPreferenceSelectionBoolExp>;
};

/** ordering options when selecting data from "grad.comm_preference_selection" */
export type GradCommPreferenceSelectionOrderBy = {
  comm_preference_selection_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.comm_preference_selection" */
export type GradCommPreferenceSelectionPkColumnsInput = {
  comm_preference_selection_id: Scalars['String'];
};

/** select columns of table "grad.comm_preference_selection" */
export enum GradCommPreferenceSelectionSelectColumn {
  /** column name */
  CommPreferenceSelectionId = 'comm_preference_selection_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "grad.comm_preference_selection" */
export type GradCommPreferenceSelectionSetInput = {
  comm_preference_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.comm_preference_selection" */
export enum GradCommPreferenceSelectionUpdateColumn {
  /** column name */
  CommPreferenceSelectionId = 'comm_preference_selection_id',
  /** column name */
  Value = 'value'
}

/**
 * used for autocomplete to pick a company, read only
 *
 *
 * columns and relationships of "grad.company_selection"
 */
export type GradCompanySelection = {
  __typename?: 'grad_company_selection';
  /** company name */
  company: Scalars['String'];
  /** auto-generated uuid */
  company_selection_id: Scalars['String'];
};

/** aggregated selection of "grad.company_selection" */
export type GradCompanySelectionAggregate = {
  __typename?: 'grad_company_selection_aggregate';
  aggregate?: Maybe<GradCompanySelectionAggregateFields>;
  nodes: Array<GradCompanySelection>;
};

/** aggregate fields of "grad.company_selection" */
export type GradCompanySelectionAggregateFields = {
  __typename?: 'grad_company_selection_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradCompanySelectionMaxFields>;
  min?: Maybe<GradCompanySelectionMinFields>;
};


/** aggregate fields of "grad.company_selection" */
export type GradCompanySelectionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradCompanySelectionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.company_selection" */
export type GradCompanySelectionAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradCompanySelectionMaxOrderBy>;
  min?: Maybe<GradCompanySelectionMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.company_selection" */
export type GradCompanySelectionArrRelInsertInput = {
  data: Array<GradCompanySelectionInsertInput>;
  on_conflict?: Maybe<GradCompanySelectionOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.company_selection". All fields are combined with a logical 'AND'. */
export type GradCompanySelectionBoolExp = {
  _and?: Maybe<Array<Maybe<GradCompanySelectionBoolExp>>>;
  _not?: Maybe<GradCompanySelectionBoolExp>;
  _or?: Maybe<Array<Maybe<GradCompanySelectionBoolExp>>>;
  company?: Maybe<StringComparisonExp>;
  company_selection_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.company_selection" */
export enum GradCompanySelectionConstraint {
  /** unique or primary key constraint */
  CompanySelectionCompanySelectionIdKey = 'company_selection_company_selection_id_key',
  /** unique or primary key constraint */
  CompanySelectionPkey = 'company_selection_pkey'
}

/** input type for inserting data into table "grad.company_selection" */
export type GradCompanySelectionInsertInput = {
  company?: Maybe<Scalars['String']>;
  company_selection_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradCompanySelectionMaxFields = {
  __typename?: 'grad_company_selection_max_fields';
  company?: Maybe<Scalars['String']>;
  company_selection_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.company_selection" */
export type GradCompanySelectionMaxOrderBy = {
  company?: Maybe<OrderBy>;
  company_selection_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradCompanySelectionMinFields = {
  __typename?: 'grad_company_selection_min_fields';
  company?: Maybe<Scalars['String']>;
  company_selection_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.company_selection" */
export type GradCompanySelectionMinOrderBy = {
  company?: Maybe<OrderBy>;
  company_selection_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.company_selection" */
export type GradCompanySelectionMutationResponse = {
  __typename?: 'grad_company_selection_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradCompanySelection>;
};

/** input type for inserting object relation for remote table "grad.company_selection" */
export type GradCompanySelectionObjRelInsertInput = {
  data: GradCompanySelectionInsertInput;
  on_conflict?: Maybe<GradCompanySelectionOnConflict>;
};

/** on conflict condition type for table "grad.company_selection" */
export type GradCompanySelectionOnConflict = {
  constraint: GradCompanySelectionConstraint;
  update_columns: Array<GradCompanySelectionUpdateColumn>;
  where?: Maybe<GradCompanySelectionBoolExp>;
};

/** ordering options when selecting data from "grad.company_selection" */
export type GradCompanySelectionOrderBy = {
  company?: Maybe<OrderBy>;
  company_selection_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.company_selection" */
export type GradCompanySelectionPkColumnsInput = {
  /** auto-generated uuid */
  company_selection_id: Scalars['String'];
};

/** select columns of table "grad.company_selection" */
export enum GradCompanySelectionSelectColumn {
  /** column name */
  Company = 'company',
  /** column name */
  CompanySelectionId = 'company_selection_id'
}

/** input type for updating data in table "grad.company_selection" */
export type GradCompanySelectionSetInput = {
  company?: Maybe<Scalars['String']>;
  company_selection_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.company_selection" */
export enum GradCompanySelectionUpdateColumn {
  /** column name */
  Company = 'company',
  /** column name */
  CompanySelectionId = 'company_selection_id'
}

/** columns and relationships of "grad.computer_language" */
export type GradComputerLanguage = {
  __typename?: 'grad_computer_language';
  computer_language_id: Scalars['String'];
  language: Scalars['String'];
  user_id: Scalars['String'];
};

/** aggregated selection of "grad.computer_language" */
export type GradComputerLanguageAggregate = {
  __typename?: 'grad_computer_language_aggregate';
  aggregate?: Maybe<GradComputerLanguageAggregateFields>;
  nodes: Array<GradComputerLanguage>;
};

/** aggregate fields of "grad.computer_language" */
export type GradComputerLanguageAggregateFields = {
  __typename?: 'grad_computer_language_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradComputerLanguageMaxFields>;
  min?: Maybe<GradComputerLanguageMinFields>;
};


/** aggregate fields of "grad.computer_language" */
export type GradComputerLanguageAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradComputerLanguageSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.computer_language" */
export type GradComputerLanguageAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradComputerLanguageMaxOrderBy>;
  min?: Maybe<GradComputerLanguageMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.computer_language" */
export type GradComputerLanguageArrRelInsertInput = {
  data: Array<GradComputerLanguageInsertInput>;
  on_conflict?: Maybe<GradComputerLanguageOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.computer_language". All fields are combined with a logical 'AND'. */
export type GradComputerLanguageBoolExp = {
  _and?: Maybe<Array<Maybe<GradComputerLanguageBoolExp>>>;
  _not?: Maybe<GradComputerLanguageBoolExp>;
  _or?: Maybe<Array<Maybe<GradComputerLanguageBoolExp>>>;
  computer_language_id?: Maybe<StringComparisonExp>;
  language?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.computer_language" */
export enum GradComputerLanguageConstraint {
  /** unique or primary key constraint */
  ComputerLanguagePkey = 'computer_language_pkey',
  /** unique or primary key constraint */
  ComputerLanguageUserIdLanguageKey = 'computer_language_user_id_language_key'
}

/** input type for inserting data into table "grad.computer_language" */
export type GradComputerLanguageInsertInput = {
  computer_language_id?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradComputerLanguageMaxFields = {
  __typename?: 'grad_computer_language_max_fields';
  computer_language_id?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.computer_language" */
export type GradComputerLanguageMaxOrderBy = {
  computer_language_id?: Maybe<OrderBy>;
  language?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradComputerLanguageMinFields = {
  __typename?: 'grad_computer_language_min_fields';
  computer_language_id?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.computer_language" */
export type GradComputerLanguageMinOrderBy = {
  computer_language_id?: Maybe<OrderBy>;
  language?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.computer_language" */
export type GradComputerLanguageMutationResponse = {
  __typename?: 'grad_computer_language_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradComputerLanguage>;
};

/** input type for inserting object relation for remote table "grad.computer_language" */
export type GradComputerLanguageObjRelInsertInput = {
  data: GradComputerLanguageInsertInput;
  on_conflict?: Maybe<GradComputerLanguageOnConflict>;
};

/** on conflict condition type for table "grad.computer_language" */
export type GradComputerLanguageOnConflict = {
  constraint: GradComputerLanguageConstraint;
  update_columns: Array<GradComputerLanguageUpdateColumn>;
  where?: Maybe<GradComputerLanguageBoolExp>;
};

/** ordering options when selecting data from "grad.computer_language" */
export type GradComputerLanguageOrderBy = {
  computer_language_id?: Maybe<OrderBy>;
  language?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.computer_language" */
export type GradComputerLanguagePkColumnsInput = {
  computer_language_id: Scalars['String'];
};

/** select columns of table "grad.computer_language" */
export enum GradComputerLanguageSelectColumn {
  /** column name */
  ComputerLanguageId = 'computer_language_id',
  /** column name */
  Language = 'language',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "grad.computer_language_selection" */
export type GradComputerLanguageSelection = {
  __typename?: 'grad_computer_language_selection';
  computer_language: Scalars['String'];
};

/** aggregated selection of "grad.computer_language_selection" */
export type GradComputerLanguageSelectionAggregate = {
  __typename?: 'grad_computer_language_selection_aggregate';
  aggregate?: Maybe<GradComputerLanguageSelectionAggregateFields>;
  nodes: Array<GradComputerLanguageSelection>;
};

/** aggregate fields of "grad.computer_language_selection" */
export type GradComputerLanguageSelectionAggregateFields = {
  __typename?: 'grad_computer_language_selection_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradComputerLanguageSelectionMaxFields>;
  min?: Maybe<GradComputerLanguageSelectionMinFields>;
};


/** aggregate fields of "grad.computer_language_selection" */
export type GradComputerLanguageSelectionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradComputerLanguageSelectionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.computer_language_selection" */
export type GradComputerLanguageSelectionAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradComputerLanguageSelectionMaxOrderBy>;
  min?: Maybe<GradComputerLanguageSelectionMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.computer_language_selection" */
export type GradComputerLanguageSelectionArrRelInsertInput = {
  data: Array<GradComputerLanguageSelectionInsertInput>;
  on_conflict?: Maybe<GradComputerLanguageSelectionOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.computer_language_selection". All fields are combined with a logical 'AND'. */
export type GradComputerLanguageSelectionBoolExp = {
  _and?: Maybe<Array<Maybe<GradComputerLanguageSelectionBoolExp>>>;
  _not?: Maybe<GradComputerLanguageSelectionBoolExp>;
  _or?: Maybe<Array<Maybe<GradComputerLanguageSelectionBoolExp>>>;
  computer_language?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.computer_language_selection" */
export enum GradComputerLanguageSelectionConstraint {
  /** unique or primary key constraint */
  ComputerLanguageSelectionPkey = 'computer_language_selection_pkey'
}

/** input type for inserting data into table "grad.computer_language_selection" */
export type GradComputerLanguageSelectionInsertInput = {
  computer_language?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradComputerLanguageSelectionMaxFields = {
  __typename?: 'grad_computer_language_selection_max_fields';
  computer_language?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.computer_language_selection" */
export type GradComputerLanguageSelectionMaxOrderBy = {
  computer_language?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradComputerLanguageSelectionMinFields = {
  __typename?: 'grad_computer_language_selection_min_fields';
  computer_language?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.computer_language_selection" */
export type GradComputerLanguageSelectionMinOrderBy = {
  computer_language?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.computer_language_selection" */
export type GradComputerLanguageSelectionMutationResponse = {
  __typename?: 'grad_computer_language_selection_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradComputerLanguageSelection>;
};

/** input type for inserting object relation for remote table "grad.computer_language_selection" */
export type GradComputerLanguageSelectionObjRelInsertInput = {
  data: GradComputerLanguageSelectionInsertInput;
  on_conflict?: Maybe<GradComputerLanguageSelectionOnConflict>;
};

/** on conflict condition type for table "grad.computer_language_selection" */
export type GradComputerLanguageSelectionOnConflict = {
  constraint: GradComputerLanguageSelectionConstraint;
  update_columns: Array<GradComputerLanguageSelectionUpdateColumn>;
  where?: Maybe<GradComputerLanguageSelectionBoolExp>;
};

/** ordering options when selecting data from "grad.computer_language_selection" */
export type GradComputerLanguageSelectionOrderBy = {
  computer_language?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.computer_language_selection" */
export type GradComputerLanguageSelectionPkColumnsInput = {
  computer_language: Scalars['String'];
};

/** select columns of table "grad.computer_language_selection" */
export enum GradComputerLanguageSelectionSelectColumn {
  /** column name */
  ComputerLanguage = 'computer_language'
}

/** input type for updating data in table "grad.computer_language_selection" */
export type GradComputerLanguageSelectionSetInput = {
  computer_language?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.computer_language_selection" */
export enum GradComputerLanguageSelectionUpdateColumn {
  /** column name */
  ComputerLanguage = 'computer_language'
}

/** input type for updating data in table "grad.computer_language" */
export type GradComputerLanguageSetInput = {
  computer_language_id?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.computer_language" */
export enum GradComputerLanguageUpdateColumn {
  /** column name */
  ComputerLanguageId = 'computer_language_id',
  /** column name */
  Language = 'language',
  /** column name */
  UserId = 'user_id'
}

/**
 * stores student majors, minors and concentrations
 *
 *
 * columns and relationships of "grad.concentration"
 */
export type GradConcentration = {
  __typename?: 'grad_concentration';
  /** auto-generated uuid */
  concentration_id: Scalars['String'];
  /** links to degree.degree_id */
  degree_id?: Maybe<Scalars['String']>;
  /** possible values: major | minor | concentration */
  type: Scalars['String'];
  /** links to profile.user_id */
  user_id: Scalars['String'];
  /** text, either from major_selection autocomplete or fill in */
  val: Scalars['String'];
};

/** aggregated selection of "grad.concentration" */
export type GradConcentrationAggregate = {
  __typename?: 'grad_concentration_aggregate';
  aggregate?: Maybe<GradConcentrationAggregateFields>;
  nodes: Array<GradConcentration>;
};

/** aggregate fields of "grad.concentration" */
export type GradConcentrationAggregateFields = {
  __typename?: 'grad_concentration_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradConcentrationMaxFields>;
  min?: Maybe<GradConcentrationMinFields>;
};


/** aggregate fields of "grad.concentration" */
export type GradConcentrationAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradConcentrationSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.concentration" */
export type GradConcentrationAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradConcentrationMaxOrderBy>;
  min?: Maybe<GradConcentrationMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.concentration" */
export type GradConcentrationArrRelInsertInput = {
  data: Array<GradConcentrationInsertInput>;
  on_conflict?: Maybe<GradConcentrationOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.concentration". All fields are combined with a logical 'AND'. */
export type GradConcentrationBoolExp = {
  _and?: Maybe<Array<Maybe<GradConcentrationBoolExp>>>;
  _not?: Maybe<GradConcentrationBoolExp>;
  _or?: Maybe<Array<Maybe<GradConcentrationBoolExp>>>;
  concentration_id?: Maybe<StringComparisonExp>;
  degree_id?: Maybe<StringComparisonExp>;
  type?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
  val?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.concentration" */
export enum GradConcentrationConstraint {
  /** unique or primary key constraint */
  ConcentrationConcentrationIdKey = 'concentration_concentration_id_key',
  /** unique or primary key constraint */
  ConcentrationPkey = 'concentration_pkey',
  /** unique or primary key constraint */
  ConcentrationUserIdDegreeIdTypeValKey = 'concentration_user_id_degree_id_type_val_key'
}

/** input type for inserting data into table "grad.concentration" */
export type GradConcentrationInsertInput = {
  concentration_id?: Maybe<Scalars['String']>;
  degree_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  val?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradConcentrationMaxFields = {
  __typename?: 'grad_concentration_max_fields';
  concentration_id?: Maybe<Scalars['String']>;
  degree_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  val?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.concentration" */
export type GradConcentrationMaxOrderBy = {
  concentration_id?: Maybe<OrderBy>;
  degree_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  val?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradConcentrationMinFields = {
  __typename?: 'grad_concentration_min_fields';
  concentration_id?: Maybe<Scalars['String']>;
  degree_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  val?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.concentration" */
export type GradConcentrationMinOrderBy = {
  concentration_id?: Maybe<OrderBy>;
  degree_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  val?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.concentration" */
export type GradConcentrationMutationResponse = {
  __typename?: 'grad_concentration_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradConcentration>;
};

/** input type for inserting object relation for remote table "grad.concentration" */
export type GradConcentrationObjRelInsertInput = {
  data: GradConcentrationInsertInput;
  on_conflict?: Maybe<GradConcentrationOnConflict>;
};

/** on conflict condition type for table "grad.concentration" */
export type GradConcentrationOnConflict = {
  constraint: GradConcentrationConstraint;
  update_columns: Array<GradConcentrationUpdateColumn>;
  where?: Maybe<GradConcentrationBoolExp>;
};

/** ordering options when selecting data from "grad.concentration" */
export type GradConcentrationOrderBy = {
  concentration_id?: Maybe<OrderBy>;
  degree_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  val?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.concentration" */
export type GradConcentrationPkColumnsInput = {
  /** auto-generated uuid */
  concentration_id: Scalars['String'];
};

/** select columns of table "grad.concentration" */
export enum GradConcentrationSelectColumn {
  /** column name */
  ConcentrationId = 'concentration_id',
  /** column name */
  DegreeId = 'degree_id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Val = 'val'
}

/** input type for updating data in table "grad.concentration" */
export type GradConcentrationSetInput = {
  concentration_id?: Maybe<Scalars['String']>;
  degree_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  val?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.concentration" */
export enum GradConcentrationUpdateColumn {
  /** column name */
  ConcentrationId = 'concentration_id',
  /** column name */
  DegreeId = 'degree_id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Val = 'val'
}

/** columns and relationships of "grad.country_selection" */
export type GradCountrySelection = {
  __typename?: 'grad_country_selection';
  country: Scalars['String'];
  country_selection_id: Scalars['String'];
};

/** aggregated selection of "grad.country_selection" */
export type GradCountrySelectionAggregate = {
  __typename?: 'grad_country_selection_aggregate';
  aggregate?: Maybe<GradCountrySelectionAggregateFields>;
  nodes: Array<GradCountrySelection>;
};

/** aggregate fields of "grad.country_selection" */
export type GradCountrySelectionAggregateFields = {
  __typename?: 'grad_country_selection_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradCountrySelectionMaxFields>;
  min?: Maybe<GradCountrySelectionMinFields>;
};


/** aggregate fields of "grad.country_selection" */
export type GradCountrySelectionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradCountrySelectionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.country_selection" */
export type GradCountrySelectionAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradCountrySelectionMaxOrderBy>;
  min?: Maybe<GradCountrySelectionMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.country_selection" */
export type GradCountrySelectionArrRelInsertInput = {
  data: Array<GradCountrySelectionInsertInput>;
  on_conflict?: Maybe<GradCountrySelectionOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.country_selection". All fields are combined with a logical 'AND'. */
export type GradCountrySelectionBoolExp = {
  _and?: Maybe<Array<Maybe<GradCountrySelectionBoolExp>>>;
  _not?: Maybe<GradCountrySelectionBoolExp>;
  _or?: Maybe<Array<Maybe<GradCountrySelectionBoolExp>>>;
  country?: Maybe<StringComparisonExp>;
  country_selection_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.country_selection" */
export enum GradCountrySelectionConstraint {
  /** unique or primary key constraint */
  CountrySelectionPkey = 'country_selection_pkey'
}

/** input type for inserting data into table "grad.country_selection" */
export type GradCountrySelectionInsertInput = {
  country?: Maybe<Scalars['String']>;
  country_selection_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradCountrySelectionMaxFields = {
  __typename?: 'grad_country_selection_max_fields';
  country?: Maybe<Scalars['String']>;
  country_selection_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.country_selection" */
export type GradCountrySelectionMaxOrderBy = {
  country?: Maybe<OrderBy>;
  country_selection_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradCountrySelectionMinFields = {
  __typename?: 'grad_country_selection_min_fields';
  country?: Maybe<Scalars['String']>;
  country_selection_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.country_selection" */
export type GradCountrySelectionMinOrderBy = {
  country?: Maybe<OrderBy>;
  country_selection_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.country_selection" */
export type GradCountrySelectionMutationResponse = {
  __typename?: 'grad_country_selection_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradCountrySelection>;
};

/** input type for inserting object relation for remote table "grad.country_selection" */
export type GradCountrySelectionObjRelInsertInput = {
  data: GradCountrySelectionInsertInput;
  on_conflict?: Maybe<GradCountrySelectionOnConflict>;
};

/** on conflict condition type for table "grad.country_selection" */
export type GradCountrySelectionOnConflict = {
  constraint: GradCountrySelectionConstraint;
  update_columns: Array<GradCountrySelectionUpdateColumn>;
  where?: Maybe<GradCountrySelectionBoolExp>;
};

/** ordering options when selecting data from "grad.country_selection" */
export type GradCountrySelectionOrderBy = {
  country?: Maybe<OrderBy>;
  country_selection_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.country_selection" */
export type GradCountrySelectionPkColumnsInput = {
  country_selection_id: Scalars['String'];
};

/** select columns of table "grad.country_selection" */
export enum GradCountrySelectionSelectColumn {
  /** column name */
  Country = 'country',
  /** column name */
  CountrySelectionId = 'country_selection_id'
}

/** input type for updating data in table "grad.country_selection" */
export type GradCountrySelectionSetInput = {
  country?: Maybe<Scalars['String']>;
  country_selection_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.country_selection" */
export enum GradCountrySelectionUpdateColumn {
  /** column name */
  Country = 'country',
  /** column name */
  CountrySelectionId = 'country_selection_id'
}

/**
 * each row represents a degree, such as BS, BA
 *
 *
 * columns and relationships of "grad.degree"
 */
export type GradDegree = {
  __typename?: 'grad_degree';
  /** An array relationship */
  awards: Array<GradAward>;
  /** An aggregated array relationship */
  awards_aggregate: GradAwardAggregate;
  /** deprecated */
  complete_month?: Maybe<Scalars['String']>;
  /** numeric complete month: range 1-12 */
  complete_month_numeric?: Maybe<Scalars['Int']>;
  /** complete year, e.g. 2015 */
  complete_year?: Maybe<Scalars['numeric']>;
  /** deprecated */
  completed?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  concentrations: Array<GradConcentration>;
  /** An aggregated array relationship */
  concentrations_aggregate: GradConcentrationAggregate;
  /** deprecated */
  current?: Maybe<Scalars['Boolean']>;
  /** sample values: BS | BA, pick from degree_selection.degree */
  degree: Scalars['String'];
  /** auto-generated uuid */
  degree_id: Scalars['String'];
  /** possible values: undergrad | masters | doctoral */
  degree_level: Scalars['String'];
  /** An object relationship */
  fill_in_university?: Maybe<GradDegreeFillInUniversity>;
  /** gpa, e.g. 3.5 */
  gpa?: Maybe<Scalars['numeric']>;
  gpa_not_applicable: Scalars['Boolean'];
  /** what is gpa out of, e.g. 4.0 */
  gpa_outof?: Maybe<Scalars['numeric']>;
  /** deprecated */
  start_month?: Maybe<Scalars['String']>;
  /** numeric start month: range 1-12 */
  start_month_numeric?: Maybe<Scalars['Int']>;
  /** start year. e.g. 2010 */
  start_year?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  university?: Maybe<GradUniversitySelection>;
  /** maps to university_selection.university_selection_id */
  university_selection_id?: Maybe<Scalars['String']>;
  /** maps to profile.user_id */
  user_id: Scalars['String'];
};


/**
 * each row represents a degree, such as BS, BA
 *
 *
 * columns and relationships of "grad.degree"
 */
export type GradDegreeAwardsArgs = {
  distinct_on?: Maybe<Array<GradAwardSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradAwardOrderBy>>;
  where?: Maybe<GradAwardBoolExp>;
};


/**
 * each row represents a degree, such as BS, BA
 *
 *
 * columns and relationships of "grad.degree"
 */
export type GradDegreeAwardsAggregateArgs = {
  distinct_on?: Maybe<Array<GradAwardSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradAwardOrderBy>>;
  where?: Maybe<GradAwardBoolExp>;
};


/**
 * each row represents a degree, such as BS, BA
 *
 *
 * columns and relationships of "grad.degree"
 */
export type GradDegreeConcentrationsArgs = {
  distinct_on?: Maybe<Array<GradConcentrationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradConcentrationOrderBy>>;
  where?: Maybe<GradConcentrationBoolExp>;
};


/**
 * each row represents a degree, such as BS, BA
 *
 *
 * columns and relationships of "grad.degree"
 */
export type GradDegreeConcentrationsAggregateArgs = {
  distinct_on?: Maybe<Array<GradConcentrationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradConcentrationOrderBy>>;
  where?: Maybe<GradConcentrationBoolExp>;
};

/** aggregated selection of "grad.degree" */
export type GradDegreeAggregate = {
  __typename?: 'grad_degree_aggregate';
  aggregate?: Maybe<GradDegreeAggregateFields>;
  nodes: Array<GradDegree>;
};

/** aggregate fields of "grad.degree" */
export type GradDegreeAggregateFields = {
  __typename?: 'grad_degree_aggregate_fields';
  avg?: Maybe<GradDegreeAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradDegreeMaxFields>;
  min?: Maybe<GradDegreeMinFields>;
  stddev?: Maybe<GradDegreeStddevFields>;
  stddev_pop?: Maybe<GradDegreeStddevPopFields>;
  stddev_samp?: Maybe<GradDegreeStddevSampFields>;
  sum?: Maybe<GradDegreeSumFields>;
  var_pop?: Maybe<GradDegreeVarPopFields>;
  var_samp?: Maybe<GradDegreeVarSampFields>;
  variance?: Maybe<GradDegreeVarianceFields>;
};


/** aggregate fields of "grad.degree" */
export type GradDegreeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradDegreeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.degree" */
export type GradDegreeAggregateOrderBy = {
  avg?: Maybe<GradDegreeAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<GradDegreeMaxOrderBy>;
  min?: Maybe<GradDegreeMinOrderBy>;
  stddev?: Maybe<GradDegreeStddevOrderBy>;
  stddev_pop?: Maybe<GradDegreeStddevPopOrderBy>;
  stddev_samp?: Maybe<GradDegreeStddevSampOrderBy>;
  sum?: Maybe<GradDegreeSumOrderBy>;
  var_pop?: Maybe<GradDegreeVarPopOrderBy>;
  var_samp?: Maybe<GradDegreeVarSampOrderBy>;
  variance?: Maybe<GradDegreeVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "grad.degree" */
export type GradDegreeArrRelInsertInput = {
  data: Array<GradDegreeInsertInput>;
  on_conflict?: Maybe<GradDegreeOnConflict>;
};

/** aggregate avg on columns */
export type GradDegreeAvgFields = {
  __typename?: 'grad_degree_avg_fields';
  complete_month_numeric?: Maybe<Scalars['Float']>;
  complete_year?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  gpa_outof?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "grad.degree" */
export type GradDegreeAvgOrderBy = {
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "grad.degree". All fields are combined with a logical 'AND'. */
export type GradDegreeBoolExp = {
  _and?: Maybe<Array<Maybe<GradDegreeBoolExp>>>;
  _not?: Maybe<GradDegreeBoolExp>;
  _or?: Maybe<Array<Maybe<GradDegreeBoolExp>>>;
  awards?: Maybe<GradAwardBoolExp>;
  complete_month?: Maybe<StringComparisonExp>;
  complete_month_numeric?: Maybe<IntComparisonExp>;
  complete_year?: Maybe<NumericComparisonExp>;
  completed?: Maybe<BooleanComparisonExp>;
  concentrations?: Maybe<GradConcentrationBoolExp>;
  current?: Maybe<BooleanComparisonExp>;
  degree?: Maybe<StringComparisonExp>;
  degree_id?: Maybe<StringComparisonExp>;
  degree_level?: Maybe<StringComparisonExp>;
  fill_in_university?: Maybe<GradDegreeFillInUniversityBoolExp>;
  gpa?: Maybe<NumericComparisonExp>;
  gpa_not_applicable?: Maybe<BooleanComparisonExp>;
  gpa_outof?: Maybe<NumericComparisonExp>;
  start_month?: Maybe<StringComparisonExp>;
  start_month_numeric?: Maybe<IntComparisonExp>;
  start_year?: Maybe<NumericComparisonExp>;
  university?: Maybe<GradUniversitySelectionBoolExp>;
  university_selection_id?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.degree" */
export enum GradDegreeConstraint {
  /** unique or primary key constraint */
  DegreeDegreeidKey = 'degree_degreeid_key',
  /** unique or primary key constraint */
  DegreePkey = 'degree_pkey'
}

/**
 * stores the university information if it's a filled in university
 *
 *
 * columns and relationships of "grad.degree_fill_in_university"
 */
export type GradDegreeFillInUniversity = {
  __typename?: 'grad_degree_fill_in_university';
  /** the address of the filled in university */
  address?: Maybe<Scalars['String']>;
  /** maps to degree.degree_id */
  degree_id: Scalars['String'];
  /** the general phone of the filled in university */
  general_phone?: Maybe<Scalars['String']>;
  /** the name of the filled in university */
  institution_name: Scalars['String'];
  /** maps to profile.user_id */
  user_id: Scalars['String'];
};

/** aggregated selection of "grad.degree_fill_in_university" */
export type GradDegreeFillInUniversityAggregate = {
  __typename?: 'grad_degree_fill_in_university_aggregate';
  aggregate?: Maybe<GradDegreeFillInUniversityAggregateFields>;
  nodes: Array<GradDegreeFillInUniversity>;
};

/** aggregate fields of "grad.degree_fill_in_university" */
export type GradDegreeFillInUniversityAggregateFields = {
  __typename?: 'grad_degree_fill_in_university_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradDegreeFillInUniversityMaxFields>;
  min?: Maybe<GradDegreeFillInUniversityMinFields>;
};


/** aggregate fields of "grad.degree_fill_in_university" */
export type GradDegreeFillInUniversityAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradDegreeFillInUniversitySelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.degree_fill_in_university" */
export type GradDegreeFillInUniversityAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradDegreeFillInUniversityMaxOrderBy>;
  min?: Maybe<GradDegreeFillInUniversityMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.degree_fill_in_university" */
export type GradDegreeFillInUniversityArrRelInsertInput = {
  data: Array<GradDegreeFillInUniversityInsertInput>;
  on_conflict?: Maybe<GradDegreeFillInUniversityOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.degree_fill_in_university". All fields are combined with a logical 'AND'. */
export type GradDegreeFillInUniversityBoolExp = {
  _and?: Maybe<Array<Maybe<GradDegreeFillInUniversityBoolExp>>>;
  _not?: Maybe<GradDegreeFillInUniversityBoolExp>;
  _or?: Maybe<Array<Maybe<GradDegreeFillInUniversityBoolExp>>>;
  address?: Maybe<StringComparisonExp>;
  degree_id?: Maybe<StringComparisonExp>;
  general_phone?: Maybe<StringComparisonExp>;
  institution_name?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.degree_fill_in_university" */
export enum GradDegreeFillInUniversityConstraint {
  /** unique or primary key constraint */
  DegreeFillInUniversityDegreeIdKey = 'degree_fill_in_university_degree_id_key',
  /** unique or primary key constraint */
  DegreeFillInUniversityPkey = 'degree_fill_in_university_pkey'
}

/** input type for inserting data into table "grad.degree_fill_in_university" */
export type GradDegreeFillInUniversityInsertInput = {
  address?: Maybe<Scalars['String']>;
  degree_id?: Maybe<Scalars['String']>;
  general_phone?: Maybe<Scalars['String']>;
  institution_name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradDegreeFillInUniversityMaxFields = {
  __typename?: 'grad_degree_fill_in_university_max_fields';
  address?: Maybe<Scalars['String']>;
  degree_id?: Maybe<Scalars['String']>;
  general_phone?: Maybe<Scalars['String']>;
  institution_name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.degree_fill_in_university" */
export type GradDegreeFillInUniversityMaxOrderBy = {
  address?: Maybe<OrderBy>;
  degree_id?: Maybe<OrderBy>;
  general_phone?: Maybe<OrderBy>;
  institution_name?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradDegreeFillInUniversityMinFields = {
  __typename?: 'grad_degree_fill_in_university_min_fields';
  address?: Maybe<Scalars['String']>;
  degree_id?: Maybe<Scalars['String']>;
  general_phone?: Maybe<Scalars['String']>;
  institution_name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.degree_fill_in_university" */
export type GradDegreeFillInUniversityMinOrderBy = {
  address?: Maybe<OrderBy>;
  degree_id?: Maybe<OrderBy>;
  general_phone?: Maybe<OrderBy>;
  institution_name?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.degree_fill_in_university" */
export type GradDegreeFillInUniversityMutationResponse = {
  __typename?: 'grad_degree_fill_in_university_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradDegreeFillInUniversity>;
};

/** input type for inserting object relation for remote table "grad.degree_fill_in_university" */
export type GradDegreeFillInUniversityObjRelInsertInput = {
  data: GradDegreeFillInUniversityInsertInput;
  on_conflict?: Maybe<GradDegreeFillInUniversityOnConflict>;
};

/** on conflict condition type for table "grad.degree_fill_in_university" */
export type GradDegreeFillInUniversityOnConflict = {
  constraint: GradDegreeFillInUniversityConstraint;
  update_columns: Array<GradDegreeFillInUniversityUpdateColumn>;
  where?: Maybe<GradDegreeFillInUniversityBoolExp>;
};

/** ordering options when selecting data from "grad.degree_fill_in_university" */
export type GradDegreeFillInUniversityOrderBy = {
  address?: Maybe<OrderBy>;
  degree_id?: Maybe<OrderBy>;
  general_phone?: Maybe<OrderBy>;
  institution_name?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.degree_fill_in_university" */
export type GradDegreeFillInUniversityPkColumnsInput = {
  /** maps to degree.degree_id */
  degree_id: Scalars['String'];
};

/** select columns of table "grad.degree_fill_in_university" */
export enum GradDegreeFillInUniversitySelectColumn {
  /** column name */
  Address = 'address',
  /** column name */
  DegreeId = 'degree_id',
  /** column name */
  GeneralPhone = 'general_phone',
  /** column name */
  InstitutionName = 'institution_name',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "grad.degree_fill_in_university" */
export type GradDegreeFillInUniversitySetInput = {
  address?: Maybe<Scalars['String']>;
  degree_id?: Maybe<Scalars['String']>;
  general_phone?: Maybe<Scalars['String']>;
  institution_name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.degree_fill_in_university" */
export enum GradDegreeFillInUniversityUpdateColumn {
  /** column name */
  Address = 'address',
  /** column name */
  DegreeId = 'degree_id',
  /** column name */
  GeneralPhone = 'general_phone',
  /** column name */
  InstitutionName = 'institution_name',
  /** column name */
  UserId = 'user_id'
}

/** input type for incrementing integer column in table "grad.degree" */
export type GradDegreeIncInput = {
  complete_month_numeric?: Maybe<Scalars['Int']>;
  complete_year?: Maybe<Scalars['numeric']>;
  gpa?: Maybe<Scalars['numeric']>;
  gpa_outof?: Maybe<Scalars['numeric']>;
  start_month_numeric?: Maybe<Scalars['Int']>;
  start_year?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "grad.degree" */
export type GradDegreeInsertInput = {
  awards?: Maybe<GradAwardArrRelInsertInput>;
  complete_month?: Maybe<Scalars['String']>;
  complete_month_numeric?: Maybe<Scalars['Int']>;
  complete_year?: Maybe<Scalars['numeric']>;
  completed?: Maybe<Scalars['Boolean']>;
  concentrations?: Maybe<GradConcentrationArrRelInsertInput>;
  current?: Maybe<Scalars['Boolean']>;
  degree?: Maybe<Scalars['String']>;
  degree_id?: Maybe<Scalars['String']>;
  degree_level?: Maybe<Scalars['String']>;
  fill_in_university?: Maybe<GradDegreeFillInUniversityObjRelInsertInput>;
  gpa?: Maybe<Scalars['numeric']>;
  gpa_not_applicable?: Maybe<Scalars['Boolean']>;
  gpa_outof?: Maybe<Scalars['numeric']>;
  start_month?: Maybe<Scalars['String']>;
  start_month_numeric?: Maybe<Scalars['Int']>;
  start_year?: Maybe<Scalars['numeric']>;
  university?: Maybe<GradUniversitySelectionObjRelInsertInput>;
  university_selection_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** columns and relationships of "grad.degree_latest" */
export type GradDegreeLatest = {
  __typename?: 'grad_degree_latest';
  complete_month?: Maybe<Scalars['String']>;
  complete_month_numeric?: Maybe<Scalars['Int']>;
  complete_year?: Maybe<Scalars['numeric']>;
  completed?: Maybe<Scalars['Boolean']>;
  current?: Maybe<Scalars['Boolean']>;
  degree?: Maybe<Scalars['String']>;
  degree_id?: Maybe<Scalars['String']>;
  degree_level?: Maybe<Scalars['String']>;
  gpa?: Maybe<Scalars['numeric']>;
  gpa_not_applicable?: Maybe<Scalars['Boolean']>;
  gpa_outof?: Maybe<Scalars['numeric']>;
  start_month?: Maybe<Scalars['String']>;
  start_month_numeric?: Maybe<Scalars['Int']>;
  start_year?: Maybe<Scalars['numeric']>;
  university_selection_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "grad.degree_latest" */
export type GradDegreeLatestAggregate = {
  __typename?: 'grad_degree_latest_aggregate';
  aggregate?: Maybe<GradDegreeLatestAggregateFields>;
  nodes: Array<GradDegreeLatest>;
};

/** aggregate fields of "grad.degree_latest" */
export type GradDegreeLatestAggregateFields = {
  __typename?: 'grad_degree_latest_aggregate_fields';
  avg?: Maybe<GradDegreeLatestAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradDegreeLatestMaxFields>;
  min?: Maybe<GradDegreeLatestMinFields>;
  stddev?: Maybe<GradDegreeLatestStddevFields>;
  stddev_pop?: Maybe<GradDegreeLatestStddevPopFields>;
  stddev_samp?: Maybe<GradDegreeLatestStddevSampFields>;
  sum?: Maybe<GradDegreeLatestSumFields>;
  var_pop?: Maybe<GradDegreeLatestVarPopFields>;
  var_samp?: Maybe<GradDegreeLatestVarSampFields>;
  variance?: Maybe<GradDegreeLatestVarianceFields>;
};


/** aggregate fields of "grad.degree_latest" */
export type GradDegreeLatestAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradDegreeLatestSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.degree_latest" */
export type GradDegreeLatestAggregateOrderBy = {
  avg?: Maybe<GradDegreeLatestAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<GradDegreeLatestMaxOrderBy>;
  min?: Maybe<GradDegreeLatestMinOrderBy>;
  stddev?: Maybe<GradDegreeLatestStddevOrderBy>;
  stddev_pop?: Maybe<GradDegreeLatestStddevPopOrderBy>;
  stddev_samp?: Maybe<GradDegreeLatestStddevSampOrderBy>;
  sum?: Maybe<GradDegreeLatestSumOrderBy>;
  var_pop?: Maybe<GradDegreeLatestVarPopOrderBy>;
  var_samp?: Maybe<GradDegreeLatestVarSampOrderBy>;
  variance?: Maybe<GradDegreeLatestVarianceOrderBy>;
};

/** aggregate avg on columns */
export type GradDegreeLatestAvgFields = {
  __typename?: 'grad_degree_latest_avg_fields';
  complete_month_numeric?: Maybe<Scalars['Float']>;
  complete_year?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  gpa_outof?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "grad.degree_latest" */
export type GradDegreeLatestAvgOrderBy = {
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "grad.degree_latest". All fields are combined with a logical 'AND'. */
export type GradDegreeLatestBoolExp = {
  _and?: Maybe<Array<Maybe<GradDegreeLatestBoolExp>>>;
  _not?: Maybe<GradDegreeLatestBoolExp>;
  _or?: Maybe<Array<Maybe<GradDegreeLatestBoolExp>>>;
  complete_month?: Maybe<StringComparisonExp>;
  complete_month_numeric?: Maybe<IntComparisonExp>;
  complete_year?: Maybe<NumericComparisonExp>;
  completed?: Maybe<BooleanComparisonExp>;
  current?: Maybe<BooleanComparisonExp>;
  degree?: Maybe<StringComparisonExp>;
  degree_id?: Maybe<StringComparisonExp>;
  degree_level?: Maybe<StringComparisonExp>;
  gpa?: Maybe<NumericComparisonExp>;
  gpa_not_applicable?: Maybe<BooleanComparisonExp>;
  gpa_outof?: Maybe<NumericComparisonExp>;
  start_month?: Maybe<StringComparisonExp>;
  start_month_numeric?: Maybe<IntComparisonExp>;
  start_year?: Maybe<NumericComparisonExp>;
  university_selection_id?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type GradDegreeLatestMaxFields = {
  __typename?: 'grad_degree_latest_max_fields';
  complete_month?: Maybe<Scalars['String']>;
  complete_month_numeric?: Maybe<Scalars['Int']>;
  complete_year?: Maybe<Scalars['numeric']>;
  degree?: Maybe<Scalars['String']>;
  degree_id?: Maybe<Scalars['String']>;
  degree_level?: Maybe<Scalars['String']>;
  gpa?: Maybe<Scalars['numeric']>;
  gpa_outof?: Maybe<Scalars['numeric']>;
  start_month?: Maybe<Scalars['String']>;
  start_month_numeric?: Maybe<Scalars['Int']>;
  start_year?: Maybe<Scalars['numeric']>;
  university_selection_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.degree_latest" */
export type GradDegreeLatestMaxOrderBy = {
  complete_month?: Maybe<OrderBy>;
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  degree?: Maybe<OrderBy>;
  degree_id?: Maybe<OrderBy>;
  degree_level?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
  university_selection_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradDegreeLatestMinFields = {
  __typename?: 'grad_degree_latest_min_fields';
  complete_month?: Maybe<Scalars['String']>;
  complete_month_numeric?: Maybe<Scalars['Int']>;
  complete_year?: Maybe<Scalars['numeric']>;
  degree?: Maybe<Scalars['String']>;
  degree_id?: Maybe<Scalars['String']>;
  degree_level?: Maybe<Scalars['String']>;
  gpa?: Maybe<Scalars['numeric']>;
  gpa_outof?: Maybe<Scalars['numeric']>;
  start_month?: Maybe<Scalars['String']>;
  start_month_numeric?: Maybe<Scalars['Int']>;
  start_year?: Maybe<Scalars['numeric']>;
  university_selection_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.degree_latest" */
export type GradDegreeLatestMinOrderBy = {
  complete_month?: Maybe<OrderBy>;
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  degree?: Maybe<OrderBy>;
  degree_id?: Maybe<OrderBy>;
  degree_level?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
  university_selection_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** ordering options when selecting data from "grad.degree_latest" */
export type GradDegreeLatestOrderBy = {
  complete_month?: Maybe<OrderBy>;
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  completed?: Maybe<OrderBy>;
  current?: Maybe<OrderBy>;
  degree?: Maybe<OrderBy>;
  degree_id?: Maybe<OrderBy>;
  degree_level?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_not_applicable?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
  university_selection_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** select columns of table "grad.degree_latest" */
export enum GradDegreeLatestSelectColumn {
  /** column name */
  CompleteMonth = 'complete_month',
  /** column name */
  CompleteMonthNumeric = 'complete_month_numeric',
  /** column name */
  CompleteYear = 'complete_year',
  /** column name */
  Completed = 'completed',
  /** column name */
  Current = 'current',
  /** column name */
  Degree = 'degree',
  /** column name */
  DegreeId = 'degree_id',
  /** column name */
  DegreeLevel = 'degree_level',
  /** column name */
  Gpa = 'gpa',
  /** column name */
  GpaNotApplicable = 'gpa_not_applicable',
  /** column name */
  GpaOutof = 'gpa_outof',
  /** column name */
  StartMonth = 'start_month',
  /** column name */
  StartMonthNumeric = 'start_month_numeric',
  /** column name */
  StartYear = 'start_year',
  /** column name */
  UniversitySelectionId = 'university_selection_id',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type GradDegreeLatestStddevFields = {
  __typename?: 'grad_degree_latest_stddev_fields';
  complete_month_numeric?: Maybe<Scalars['Float']>;
  complete_year?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  gpa_outof?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "grad.degree_latest" */
export type GradDegreeLatestStddevOrderBy = {
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type GradDegreeLatestStddevPopFields = {
  __typename?: 'grad_degree_latest_stddev_pop_fields';
  complete_month_numeric?: Maybe<Scalars['Float']>;
  complete_year?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  gpa_outof?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "grad.degree_latest" */
export type GradDegreeLatestStddevPopOrderBy = {
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type GradDegreeLatestStddevSampFields = {
  __typename?: 'grad_degree_latest_stddev_samp_fields';
  complete_month_numeric?: Maybe<Scalars['Float']>;
  complete_year?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  gpa_outof?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "grad.degree_latest" */
export type GradDegreeLatestStddevSampOrderBy = {
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type GradDegreeLatestSumFields = {
  __typename?: 'grad_degree_latest_sum_fields';
  complete_month_numeric?: Maybe<Scalars['Int']>;
  complete_year?: Maybe<Scalars['numeric']>;
  gpa?: Maybe<Scalars['numeric']>;
  gpa_outof?: Maybe<Scalars['numeric']>;
  start_month_numeric?: Maybe<Scalars['Int']>;
  start_year?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "grad.degree_latest" */
export type GradDegreeLatestSumOrderBy = {
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** aggregate var_pop on columns */
export type GradDegreeLatestVarPopFields = {
  __typename?: 'grad_degree_latest_var_pop_fields';
  complete_month_numeric?: Maybe<Scalars['Float']>;
  complete_year?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  gpa_outof?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "grad.degree_latest" */
export type GradDegreeLatestVarPopOrderBy = {
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type GradDegreeLatestVarSampFields = {
  __typename?: 'grad_degree_latest_var_samp_fields';
  complete_month_numeric?: Maybe<Scalars['Float']>;
  complete_year?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  gpa_outof?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "grad.degree_latest" */
export type GradDegreeLatestVarSampOrderBy = {
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type GradDegreeLatestVarianceFields = {
  __typename?: 'grad_degree_latest_variance_fields';
  complete_month_numeric?: Maybe<Scalars['Float']>;
  complete_year?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  gpa_outof?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "grad.degree_latest" */
export type GradDegreeLatestVarianceOrderBy = {
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** aggregate max on columns */
export type GradDegreeMaxFields = {
  __typename?: 'grad_degree_max_fields';
  complete_month?: Maybe<Scalars['String']>;
  complete_month_numeric?: Maybe<Scalars['Int']>;
  complete_year?: Maybe<Scalars['numeric']>;
  degree?: Maybe<Scalars['String']>;
  degree_id?: Maybe<Scalars['String']>;
  degree_level?: Maybe<Scalars['String']>;
  gpa?: Maybe<Scalars['numeric']>;
  gpa_outof?: Maybe<Scalars['numeric']>;
  start_month?: Maybe<Scalars['String']>;
  start_month_numeric?: Maybe<Scalars['Int']>;
  start_year?: Maybe<Scalars['numeric']>;
  university_selection_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.degree" */
export type GradDegreeMaxOrderBy = {
  complete_month?: Maybe<OrderBy>;
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  degree?: Maybe<OrderBy>;
  degree_id?: Maybe<OrderBy>;
  degree_level?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
  university_selection_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradDegreeMinFields = {
  __typename?: 'grad_degree_min_fields';
  complete_month?: Maybe<Scalars['String']>;
  complete_month_numeric?: Maybe<Scalars['Int']>;
  complete_year?: Maybe<Scalars['numeric']>;
  degree?: Maybe<Scalars['String']>;
  degree_id?: Maybe<Scalars['String']>;
  degree_level?: Maybe<Scalars['String']>;
  gpa?: Maybe<Scalars['numeric']>;
  gpa_outof?: Maybe<Scalars['numeric']>;
  start_month?: Maybe<Scalars['String']>;
  start_month_numeric?: Maybe<Scalars['Int']>;
  start_year?: Maybe<Scalars['numeric']>;
  university_selection_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.degree" */
export type GradDegreeMinOrderBy = {
  complete_month?: Maybe<OrderBy>;
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  degree?: Maybe<OrderBy>;
  degree_id?: Maybe<OrderBy>;
  degree_level?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
  university_selection_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.degree" */
export type GradDegreeMutationResponse = {
  __typename?: 'grad_degree_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradDegree>;
};

/** input type for inserting object relation for remote table "grad.degree" */
export type GradDegreeObjRelInsertInput = {
  data: GradDegreeInsertInput;
  on_conflict?: Maybe<GradDegreeOnConflict>;
};

/** on conflict condition type for table "grad.degree" */
export type GradDegreeOnConflict = {
  constraint: GradDegreeConstraint;
  update_columns: Array<GradDegreeUpdateColumn>;
  where?: Maybe<GradDegreeBoolExp>;
};

/** ordering options when selecting data from "grad.degree" */
export type GradDegreeOrderBy = {
  awards_aggregate?: Maybe<GradAwardAggregateOrderBy>;
  complete_month?: Maybe<OrderBy>;
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  completed?: Maybe<OrderBy>;
  concentrations_aggregate?: Maybe<GradConcentrationAggregateOrderBy>;
  current?: Maybe<OrderBy>;
  degree?: Maybe<OrderBy>;
  degree_id?: Maybe<OrderBy>;
  degree_level?: Maybe<OrderBy>;
  fill_in_university?: Maybe<GradDegreeFillInUniversityOrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_not_applicable?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
  university?: Maybe<GradUniversitySelectionOrderBy>;
  university_selection_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.degree" */
export type GradDegreePkColumnsInput = {
  /** auto-generated uuid */
  degree_id: Scalars['String'];
};

/** select columns of table "grad.degree" */
export enum GradDegreeSelectColumn {
  /** column name */
  CompleteMonth = 'complete_month',
  /** column name */
  CompleteMonthNumeric = 'complete_month_numeric',
  /** column name */
  CompleteYear = 'complete_year',
  /** column name */
  Completed = 'completed',
  /** column name */
  Current = 'current',
  /** column name */
  Degree = 'degree',
  /** column name */
  DegreeId = 'degree_id',
  /** column name */
  DegreeLevel = 'degree_level',
  /** column name */
  Gpa = 'gpa',
  /** column name */
  GpaNotApplicable = 'gpa_not_applicable',
  /** column name */
  GpaOutof = 'gpa_outof',
  /** column name */
  StartMonth = 'start_month',
  /** column name */
  StartMonthNumeric = 'start_month_numeric',
  /** column name */
  StartYear = 'start_year',
  /** column name */
  UniversitySelectionId = 'university_selection_id',
  /** column name */
  UserId = 'user_id'
}

/**
 * used for autocomplete of degree name, read only
 *
 *
 * columns and relationships of "grad.degree_selection"
 */
export type GradDegreeSelection = {
  __typename?: 'grad_degree_selection';
  /** degree name, e.g. BS BA etc. */
  degree: Scalars['String'];
  /** level, e.g. undergrad | masters | doctoral */
  degree_level: Scalars['String'];
  /** auto-generated uuid */
  degree_selection_id: Scalars['String'];
  /** description of degree, e.g. Bachelor of Science */
  description: Scalars['String'];
};

/** aggregated selection of "grad.degree_selection" */
export type GradDegreeSelectionAggregate = {
  __typename?: 'grad_degree_selection_aggregate';
  aggregate?: Maybe<GradDegreeSelectionAggregateFields>;
  nodes: Array<GradDegreeSelection>;
};

/** aggregate fields of "grad.degree_selection" */
export type GradDegreeSelectionAggregateFields = {
  __typename?: 'grad_degree_selection_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradDegreeSelectionMaxFields>;
  min?: Maybe<GradDegreeSelectionMinFields>;
};


/** aggregate fields of "grad.degree_selection" */
export type GradDegreeSelectionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradDegreeSelectionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.degree_selection" */
export type GradDegreeSelectionAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradDegreeSelectionMaxOrderBy>;
  min?: Maybe<GradDegreeSelectionMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.degree_selection" */
export type GradDegreeSelectionArrRelInsertInput = {
  data: Array<GradDegreeSelectionInsertInput>;
  on_conflict?: Maybe<GradDegreeSelectionOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.degree_selection". All fields are combined with a logical 'AND'. */
export type GradDegreeSelectionBoolExp = {
  _and?: Maybe<Array<Maybe<GradDegreeSelectionBoolExp>>>;
  _not?: Maybe<GradDegreeSelectionBoolExp>;
  _or?: Maybe<Array<Maybe<GradDegreeSelectionBoolExp>>>;
  degree?: Maybe<StringComparisonExp>;
  degree_level?: Maybe<StringComparisonExp>;
  degree_selection_id?: Maybe<StringComparisonExp>;
  description?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.degree_selection" */
export enum GradDegreeSelectionConstraint {
  /** unique or primary key constraint */
  DegreeSelectionDegreeSelectionIdKey = 'degree_selection_degree_selection_id_key',
  /** unique or primary key constraint */
  DegreeSelectionPkey = 'degree_selection_pkey'
}

/** input type for inserting data into table "grad.degree_selection" */
export type GradDegreeSelectionInsertInput = {
  degree?: Maybe<Scalars['String']>;
  degree_level?: Maybe<Scalars['String']>;
  degree_selection_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradDegreeSelectionMaxFields = {
  __typename?: 'grad_degree_selection_max_fields';
  degree?: Maybe<Scalars['String']>;
  degree_level?: Maybe<Scalars['String']>;
  degree_selection_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.degree_selection" */
export type GradDegreeSelectionMaxOrderBy = {
  degree?: Maybe<OrderBy>;
  degree_level?: Maybe<OrderBy>;
  degree_selection_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradDegreeSelectionMinFields = {
  __typename?: 'grad_degree_selection_min_fields';
  degree?: Maybe<Scalars['String']>;
  degree_level?: Maybe<Scalars['String']>;
  degree_selection_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.degree_selection" */
export type GradDegreeSelectionMinOrderBy = {
  degree?: Maybe<OrderBy>;
  degree_level?: Maybe<OrderBy>;
  degree_selection_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.degree_selection" */
export type GradDegreeSelectionMutationResponse = {
  __typename?: 'grad_degree_selection_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradDegreeSelection>;
};

/** input type for inserting object relation for remote table "grad.degree_selection" */
export type GradDegreeSelectionObjRelInsertInput = {
  data: GradDegreeSelectionInsertInput;
  on_conflict?: Maybe<GradDegreeSelectionOnConflict>;
};

/** on conflict condition type for table "grad.degree_selection" */
export type GradDegreeSelectionOnConflict = {
  constraint: GradDegreeSelectionConstraint;
  update_columns: Array<GradDegreeSelectionUpdateColumn>;
  where?: Maybe<GradDegreeSelectionBoolExp>;
};

/** ordering options when selecting data from "grad.degree_selection" */
export type GradDegreeSelectionOrderBy = {
  degree?: Maybe<OrderBy>;
  degree_level?: Maybe<OrderBy>;
  degree_selection_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.degree_selection" */
export type GradDegreeSelectionPkColumnsInput = {
  /** auto-generated uuid */
  degree_selection_id: Scalars['String'];
};

/** select columns of table "grad.degree_selection" */
export enum GradDegreeSelectionSelectColumn {
  /** column name */
  Degree = 'degree',
  /** column name */
  DegreeLevel = 'degree_level',
  /** column name */
  DegreeSelectionId = 'degree_selection_id',
  /** column name */
  Description = 'description'
}

/** input type for updating data in table "grad.degree_selection" */
export type GradDegreeSelectionSetInput = {
  degree?: Maybe<Scalars['String']>;
  degree_level?: Maybe<Scalars['String']>;
  degree_selection_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.degree_selection" */
export enum GradDegreeSelectionUpdateColumn {
  /** column name */
  Degree = 'degree',
  /** column name */
  DegreeLevel = 'degree_level',
  /** column name */
  DegreeSelectionId = 'degree_selection_id',
  /** column name */
  Description = 'description'
}

/** input type for updating data in table "grad.degree" */
export type GradDegreeSetInput = {
  complete_month?: Maybe<Scalars['String']>;
  complete_month_numeric?: Maybe<Scalars['Int']>;
  complete_year?: Maybe<Scalars['numeric']>;
  completed?: Maybe<Scalars['Boolean']>;
  current?: Maybe<Scalars['Boolean']>;
  degree?: Maybe<Scalars['String']>;
  degree_id?: Maybe<Scalars['String']>;
  degree_level?: Maybe<Scalars['String']>;
  gpa?: Maybe<Scalars['numeric']>;
  gpa_not_applicable?: Maybe<Scalars['Boolean']>;
  gpa_outof?: Maybe<Scalars['numeric']>;
  start_month?: Maybe<Scalars['String']>;
  start_month_numeric?: Maybe<Scalars['Int']>;
  start_year?: Maybe<Scalars['numeric']>;
  university_selection_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type GradDegreeStddevFields = {
  __typename?: 'grad_degree_stddev_fields';
  complete_month_numeric?: Maybe<Scalars['Float']>;
  complete_year?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  gpa_outof?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "grad.degree" */
export type GradDegreeStddevOrderBy = {
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type GradDegreeStddevPopFields = {
  __typename?: 'grad_degree_stddev_pop_fields';
  complete_month_numeric?: Maybe<Scalars['Float']>;
  complete_year?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  gpa_outof?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "grad.degree" */
export type GradDegreeStddevPopOrderBy = {
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type GradDegreeStddevSampFields = {
  __typename?: 'grad_degree_stddev_samp_fields';
  complete_month_numeric?: Maybe<Scalars['Float']>;
  complete_year?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  gpa_outof?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "grad.degree" */
export type GradDegreeStddevSampOrderBy = {
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type GradDegreeSumFields = {
  __typename?: 'grad_degree_sum_fields';
  complete_month_numeric?: Maybe<Scalars['Int']>;
  complete_year?: Maybe<Scalars['numeric']>;
  gpa?: Maybe<Scalars['numeric']>;
  gpa_outof?: Maybe<Scalars['numeric']>;
  start_month_numeric?: Maybe<Scalars['Int']>;
  start_year?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "grad.degree" */
export type GradDegreeSumOrderBy = {
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** update columns of table "grad.degree" */
export enum GradDegreeUpdateColumn {
  /** column name */
  CompleteMonth = 'complete_month',
  /** column name */
  CompleteMonthNumeric = 'complete_month_numeric',
  /** column name */
  CompleteYear = 'complete_year',
  /** column name */
  Completed = 'completed',
  /** column name */
  Current = 'current',
  /** column name */
  Degree = 'degree',
  /** column name */
  DegreeId = 'degree_id',
  /** column name */
  DegreeLevel = 'degree_level',
  /** column name */
  Gpa = 'gpa',
  /** column name */
  GpaNotApplicable = 'gpa_not_applicable',
  /** column name */
  GpaOutof = 'gpa_outof',
  /** column name */
  StartMonth = 'start_month',
  /** column name */
  StartMonthNumeric = 'start_month_numeric',
  /** column name */
  StartYear = 'start_year',
  /** column name */
  UniversitySelectionId = 'university_selection_id',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type GradDegreeVarPopFields = {
  __typename?: 'grad_degree_var_pop_fields';
  complete_month_numeric?: Maybe<Scalars['Float']>;
  complete_year?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  gpa_outof?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "grad.degree" */
export type GradDegreeVarPopOrderBy = {
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type GradDegreeVarSampFields = {
  __typename?: 'grad_degree_var_samp_fields';
  complete_month_numeric?: Maybe<Scalars['Float']>;
  complete_year?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  gpa_outof?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "grad.degree" */
export type GradDegreeVarSampOrderBy = {
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type GradDegreeVarianceFields = {
  __typename?: 'grad_degree_variance_fields';
  complete_month_numeric?: Maybe<Scalars['Float']>;
  complete_year?: Maybe<Scalars['Float']>;
  gpa?: Maybe<Scalars['Float']>;
  gpa_outof?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "grad.degree" */
export type GradDegreeVarianceOrderBy = {
  complete_month_numeric?: Maybe<OrderBy>;
  complete_year?: Maybe<OrderBy>;
  gpa?: Maybe<OrderBy>;
  gpa_outof?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** columns and relationships of "grad.employer_preference" */
export type GradEmployerPreference = {
  __typename?: 'grad_employer_preference';
  employer_preference_id: Scalars['String'];
  preference: Scalars['String'];
  user_id: Scalars['String'];
};

/** aggregated selection of "grad.employer_preference" */
export type GradEmployerPreferenceAggregate = {
  __typename?: 'grad_employer_preference_aggregate';
  aggregate?: Maybe<GradEmployerPreferenceAggregateFields>;
  nodes: Array<GradEmployerPreference>;
};

/** aggregate fields of "grad.employer_preference" */
export type GradEmployerPreferenceAggregateFields = {
  __typename?: 'grad_employer_preference_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradEmployerPreferenceMaxFields>;
  min?: Maybe<GradEmployerPreferenceMinFields>;
};


/** aggregate fields of "grad.employer_preference" */
export type GradEmployerPreferenceAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradEmployerPreferenceSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.employer_preference" */
export type GradEmployerPreferenceAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradEmployerPreferenceMaxOrderBy>;
  min?: Maybe<GradEmployerPreferenceMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.employer_preference" */
export type GradEmployerPreferenceArrRelInsertInput = {
  data: Array<GradEmployerPreferenceInsertInput>;
  on_conflict?: Maybe<GradEmployerPreferenceOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.employer_preference". All fields are combined with a logical 'AND'. */
export type GradEmployerPreferenceBoolExp = {
  _and?: Maybe<Array<Maybe<GradEmployerPreferenceBoolExp>>>;
  _not?: Maybe<GradEmployerPreferenceBoolExp>;
  _or?: Maybe<Array<Maybe<GradEmployerPreferenceBoolExp>>>;
  employer_preference_id?: Maybe<StringComparisonExp>;
  preference?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.employer_preference" */
export enum GradEmployerPreferenceConstraint {
  /** unique or primary key constraint */
  EmployerPreferencePkey = 'employer_preference_pkey',
  /** unique or primary key constraint */
  EmployerPreferenceUserIdPreferenceKey = 'employer_preference_user_id_preference_key'
}

/** input type for inserting data into table "grad.employer_preference" */
export type GradEmployerPreferenceInsertInput = {
  employer_preference_id?: Maybe<Scalars['String']>;
  preference?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradEmployerPreferenceMaxFields = {
  __typename?: 'grad_employer_preference_max_fields';
  employer_preference_id?: Maybe<Scalars['String']>;
  preference?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.employer_preference" */
export type GradEmployerPreferenceMaxOrderBy = {
  employer_preference_id?: Maybe<OrderBy>;
  preference?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradEmployerPreferenceMinFields = {
  __typename?: 'grad_employer_preference_min_fields';
  employer_preference_id?: Maybe<Scalars['String']>;
  preference?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.employer_preference" */
export type GradEmployerPreferenceMinOrderBy = {
  employer_preference_id?: Maybe<OrderBy>;
  preference?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.employer_preference" */
export type GradEmployerPreferenceMutationResponse = {
  __typename?: 'grad_employer_preference_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradEmployerPreference>;
};

/** input type for inserting object relation for remote table "grad.employer_preference" */
export type GradEmployerPreferenceObjRelInsertInput = {
  data: GradEmployerPreferenceInsertInput;
  on_conflict?: Maybe<GradEmployerPreferenceOnConflict>;
};

/** on conflict condition type for table "grad.employer_preference" */
export type GradEmployerPreferenceOnConflict = {
  constraint: GradEmployerPreferenceConstraint;
  update_columns: Array<GradEmployerPreferenceUpdateColumn>;
  where?: Maybe<GradEmployerPreferenceBoolExp>;
};

/** ordering options when selecting data from "grad.employer_preference" */
export type GradEmployerPreferenceOrderBy = {
  employer_preference_id?: Maybe<OrderBy>;
  preference?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.employer_preference" */
export type GradEmployerPreferencePkColumnsInput = {
  employer_preference_id: Scalars['String'];
};

/** select columns of table "grad.employer_preference" */
export enum GradEmployerPreferenceSelectColumn {
  /** column name */
  EmployerPreferenceId = 'employer_preference_id',
  /** column name */
  Preference = 'preference',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "grad.employer_preference_selection" */
export type GradEmployerPreferenceSelection = {
  __typename?: 'grad_employer_preference_selection';
  employer_preference_selection_id: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "grad.employer_preference_selection" */
export type GradEmployerPreferenceSelectionAggregate = {
  __typename?: 'grad_employer_preference_selection_aggregate';
  aggregate?: Maybe<GradEmployerPreferenceSelectionAggregateFields>;
  nodes: Array<GradEmployerPreferenceSelection>;
};

/** aggregate fields of "grad.employer_preference_selection" */
export type GradEmployerPreferenceSelectionAggregateFields = {
  __typename?: 'grad_employer_preference_selection_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradEmployerPreferenceSelectionMaxFields>;
  min?: Maybe<GradEmployerPreferenceSelectionMinFields>;
};


/** aggregate fields of "grad.employer_preference_selection" */
export type GradEmployerPreferenceSelectionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradEmployerPreferenceSelectionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.employer_preference_selection" */
export type GradEmployerPreferenceSelectionAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradEmployerPreferenceSelectionMaxOrderBy>;
  min?: Maybe<GradEmployerPreferenceSelectionMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.employer_preference_selection" */
export type GradEmployerPreferenceSelectionArrRelInsertInput = {
  data: Array<GradEmployerPreferenceSelectionInsertInput>;
  on_conflict?: Maybe<GradEmployerPreferenceSelectionOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.employer_preference_selection". All fields are combined with a logical 'AND'. */
export type GradEmployerPreferenceSelectionBoolExp = {
  _and?: Maybe<Array<Maybe<GradEmployerPreferenceSelectionBoolExp>>>;
  _not?: Maybe<GradEmployerPreferenceSelectionBoolExp>;
  _or?: Maybe<Array<Maybe<GradEmployerPreferenceSelectionBoolExp>>>;
  employer_preference_selection_id?: Maybe<StringComparisonExp>;
  value?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.employer_preference_selection" */
export enum GradEmployerPreferenceSelectionConstraint {
  /** unique or primary key constraint */
  EmployerPreferenceSelectionPkey = 'employer_preference_selection_pkey'
}

/** input type for inserting data into table "grad.employer_preference_selection" */
export type GradEmployerPreferenceSelectionInsertInput = {
  employer_preference_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradEmployerPreferenceSelectionMaxFields = {
  __typename?: 'grad_employer_preference_selection_max_fields';
  employer_preference_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.employer_preference_selection" */
export type GradEmployerPreferenceSelectionMaxOrderBy = {
  employer_preference_selection_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradEmployerPreferenceSelectionMinFields = {
  __typename?: 'grad_employer_preference_selection_min_fields';
  employer_preference_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.employer_preference_selection" */
export type GradEmployerPreferenceSelectionMinOrderBy = {
  employer_preference_selection_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.employer_preference_selection" */
export type GradEmployerPreferenceSelectionMutationResponse = {
  __typename?: 'grad_employer_preference_selection_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradEmployerPreferenceSelection>;
};

/** input type for inserting object relation for remote table "grad.employer_preference_selection" */
export type GradEmployerPreferenceSelectionObjRelInsertInput = {
  data: GradEmployerPreferenceSelectionInsertInput;
  on_conflict?: Maybe<GradEmployerPreferenceSelectionOnConflict>;
};

/** on conflict condition type for table "grad.employer_preference_selection" */
export type GradEmployerPreferenceSelectionOnConflict = {
  constraint: GradEmployerPreferenceSelectionConstraint;
  update_columns: Array<GradEmployerPreferenceSelectionUpdateColumn>;
  where?: Maybe<GradEmployerPreferenceSelectionBoolExp>;
};

/** ordering options when selecting data from "grad.employer_preference_selection" */
export type GradEmployerPreferenceSelectionOrderBy = {
  employer_preference_selection_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.employer_preference_selection" */
export type GradEmployerPreferenceSelectionPkColumnsInput = {
  employer_preference_selection_id: Scalars['String'];
};

/** select columns of table "grad.employer_preference_selection" */
export enum GradEmployerPreferenceSelectionSelectColumn {
  /** column name */
  EmployerPreferenceSelectionId = 'employer_preference_selection_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "grad.employer_preference_selection" */
export type GradEmployerPreferenceSelectionSetInput = {
  employer_preference_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.employer_preference_selection" */
export enum GradEmployerPreferenceSelectionUpdateColumn {
  /** column name */
  EmployerPreferenceSelectionId = 'employer_preference_selection_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "grad.employer_preference" */
export type GradEmployerPreferenceSetInput = {
  employer_preference_id?: Maybe<Scalars['String']>;
  preference?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.employer_preference" */
export enum GradEmployerPreferenceUpdateColumn {
  /** column name */
  EmployerPreferenceId = 'employer_preference_id',
  /** column name */
  Preference = 'preference',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "grad.event_registration" */
export type GradEventRegistration = {
  __typename?: 'grad_event_registration';
  /** An object relationship */
  event: RecruitEvent;
  event_id: Scalars['String'];
  event_registration_id: Scalars['String'];
  /** An object relationship */
  profile: GradProfile;
  timestamp: Scalars['timestamptz'];
  user_id: Scalars['String'];
};

/** aggregated selection of "grad.event_registration" */
export type GradEventRegistrationAggregate = {
  __typename?: 'grad_event_registration_aggregate';
  aggregate?: Maybe<GradEventRegistrationAggregateFields>;
  nodes: Array<GradEventRegistration>;
};

/** aggregate fields of "grad.event_registration" */
export type GradEventRegistrationAggregateFields = {
  __typename?: 'grad_event_registration_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradEventRegistrationMaxFields>;
  min?: Maybe<GradEventRegistrationMinFields>;
};


/** aggregate fields of "grad.event_registration" */
export type GradEventRegistrationAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradEventRegistrationSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.event_registration" */
export type GradEventRegistrationAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradEventRegistrationMaxOrderBy>;
  min?: Maybe<GradEventRegistrationMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.event_registration" */
export type GradEventRegistrationArrRelInsertInput = {
  data: Array<GradEventRegistrationInsertInput>;
  on_conflict?: Maybe<GradEventRegistrationOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.event_registration". All fields are combined with a logical 'AND'. */
export type GradEventRegistrationBoolExp = {
  _and?: Maybe<Array<Maybe<GradEventRegistrationBoolExp>>>;
  _not?: Maybe<GradEventRegistrationBoolExp>;
  _or?: Maybe<Array<Maybe<GradEventRegistrationBoolExp>>>;
  event?: Maybe<RecruitEventBoolExp>;
  event_id?: Maybe<StringComparisonExp>;
  event_registration_id?: Maybe<StringComparisonExp>;
  profile?: Maybe<GradProfileBoolExp>;
  timestamp?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.event_registration" */
export enum GradEventRegistrationConstraint {
  /** unique or primary key constraint */
  EventRegistrationEventIdUserIdKey = 'event_registration_event_id_user_id_key',
  /** unique or primary key constraint */
  EventRegistrationPkey = 'event_registration_pkey'
}

/** input type for inserting data into table "grad.event_registration" */
export type GradEventRegistrationInsertInput = {
  event?: Maybe<RecruitEventObjRelInsertInput>;
  event_id?: Maybe<Scalars['String']>;
  event_registration_id?: Maybe<Scalars['String']>;
  profile?: Maybe<GradProfileObjRelInsertInput>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradEventRegistrationMaxFields = {
  __typename?: 'grad_event_registration_max_fields';
  event_id?: Maybe<Scalars['String']>;
  event_registration_id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.event_registration" */
export type GradEventRegistrationMaxOrderBy = {
  event_id?: Maybe<OrderBy>;
  event_registration_id?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradEventRegistrationMinFields = {
  __typename?: 'grad_event_registration_min_fields';
  event_id?: Maybe<Scalars['String']>;
  event_registration_id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.event_registration" */
export type GradEventRegistrationMinOrderBy = {
  event_id?: Maybe<OrderBy>;
  event_registration_id?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.event_registration" */
export type GradEventRegistrationMutationResponse = {
  __typename?: 'grad_event_registration_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradEventRegistration>;
};

/** input type for inserting object relation for remote table "grad.event_registration" */
export type GradEventRegistrationObjRelInsertInput = {
  data: GradEventRegistrationInsertInput;
  on_conflict?: Maybe<GradEventRegistrationOnConflict>;
};

/** on conflict condition type for table "grad.event_registration" */
export type GradEventRegistrationOnConflict = {
  constraint: GradEventRegistrationConstraint;
  update_columns: Array<GradEventRegistrationUpdateColumn>;
  where?: Maybe<GradEventRegistrationBoolExp>;
};

/** ordering options when selecting data from "grad.event_registration" */
export type GradEventRegistrationOrderBy = {
  event?: Maybe<RecruitEventOrderBy>;
  event_id?: Maybe<OrderBy>;
  event_registration_id?: Maybe<OrderBy>;
  profile?: Maybe<GradProfileOrderBy>;
  timestamp?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.event_registration" */
export type GradEventRegistrationPkColumnsInput = {
  event_registration_id: Scalars['String'];
};

/** select columns of table "grad.event_registration" */
export enum GradEventRegistrationSelectColumn {
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventRegistrationId = 'event_registration_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "grad.event_registration" */
export type GradEventRegistrationSetInput = {
  event_id?: Maybe<Scalars['String']>;
  event_registration_id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.event_registration" */
export enum GradEventRegistrationUpdateColumn {
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventRegistrationId = 'event_registration_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id'
}

/**
 * stores student fun facts
 *
 *
 * columns and relationships of "grad.fun_fact"
 */
export type GradFunFact = {
  __typename?: 'grad_fun_fact';
  /** text, describing the fun fact */
  description: Scalars['String'];
  /** auto-generated uuid */
  fun_fact_id: Scalars['String'];
  /** maps to profile.user_id */
  user_id: Scalars['String'];
};

/** aggregated selection of "grad.fun_fact" */
export type GradFunFactAggregate = {
  __typename?: 'grad_fun_fact_aggregate';
  aggregate?: Maybe<GradFunFactAggregateFields>;
  nodes: Array<GradFunFact>;
};

/** aggregate fields of "grad.fun_fact" */
export type GradFunFactAggregateFields = {
  __typename?: 'grad_fun_fact_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradFunFactMaxFields>;
  min?: Maybe<GradFunFactMinFields>;
};


/** aggregate fields of "grad.fun_fact" */
export type GradFunFactAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradFunFactSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.fun_fact" */
export type GradFunFactAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradFunFactMaxOrderBy>;
  min?: Maybe<GradFunFactMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.fun_fact" */
export type GradFunFactArrRelInsertInput = {
  data: Array<GradFunFactInsertInput>;
  on_conflict?: Maybe<GradFunFactOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.fun_fact". All fields are combined with a logical 'AND'. */
export type GradFunFactBoolExp = {
  _and?: Maybe<Array<Maybe<GradFunFactBoolExp>>>;
  _not?: Maybe<GradFunFactBoolExp>;
  _or?: Maybe<Array<Maybe<GradFunFactBoolExp>>>;
  description?: Maybe<StringComparisonExp>;
  fun_fact_id?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.fun_fact" */
export enum GradFunFactConstraint {
  /** unique or primary key constraint */
  FunFactFunFactIdKey = 'fun_fact_fun_fact_id_key',
  /** unique or primary key constraint */
  FunFactPkey = 'fun_fact_pkey'
}

/** input type for inserting data into table "grad.fun_fact" */
export type GradFunFactInsertInput = {
  description?: Maybe<Scalars['String']>;
  fun_fact_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradFunFactMaxFields = {
  __typename?: 'grad_fun_fact_max_fields';
  description?: Maybe<Scalars['String']>;
  fun_fact_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.fun_fact" */
export type GradFunFactMaxOrderBy = {
  description?: Maybe<OrderBy>;
  fun_fact_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradFunFactMinFields = {
  __typename?: 'grad_fun_fact_min_fields';
  description?: Maybe<Scalars['String']>;
  fun_fact_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.fun_fact" */
export type GradFunFactMinOrderBy = {
  description?: Maybe<OrderBy>;
  fun_fact_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.fun_fact" */
export type GradFunFactMutationResponse = {
  __typename?: 'grad_fun_fact_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradFunFact>;
};

/** input type for inserting object relation for remote table "grad.fun_fact" */
export type GradFunFactObjRelInsertInput = {
  data: GradFunFactInsertInput;
  on_conflict?: Maybe<GradFunFactOnConflict>;
};

/** on conflict condition type for table "grad.fun_fact" */
export type GradFunFactOnConflict = {
  constraint: GradFunFactConstraint;
  update_columns: Array<GradFunFactUpdateColumn>;
  where?: Maybe<GradFunFactBoolExp>;
};

/** ordering options when selecting data from "grad.fun_fact" */
export type GradFunFactOrderBy = {
  description?: Maybe<OrderBy>;
  fun_fact_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.fun_fact" */
export type GradFunFactPkColumnsInput = {
  /** auto-generated uuid */
  fun_fact_id: Scalars['String'];
};

/** select columns of table "grad.fun_fact" */
export enum GradFunFactSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  FunFactId = 'fun_fact_id',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "grad.fun_fact_selection" */
export type GradFunFactSelection = {
  __typename?: 'grad_fun_fact_selection';
  description: Scalars['String'];
  fun_fact_selection_id: Scalars['String'];
};

/** aggregated selection of "grad.fun_fact_selection" */
export type GradFunFactSelectionAggregate = {
  __typename?: 'grad_fun_fact_selection_aggregate';
  aggregate?: Maybe<GradFunFactSelectionAggregateFields>;
  nodes: Array<GradFunFactSelection>;
};

/** aggregate fields of "grad.fun_fact_selection" */
export type GradFunFactSelectionAggregateFields = {
  __typename?: 'grad_fun_fact_selection_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradFunFactSelectionMaxFields>;
  min?: Maybe<GradFunFactSelectionMinFields>;
};


/** aggregate fields of "grad.fun_fact_selection" */
export type GradFunFactSelectionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradFunFactSelectionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.fun_fact_selection" */
export type GradFunFactSelectionAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradFunFactSelectionMaxOrderBy>;
  min?: Maybe<GradFunFactSelectionMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.fun_fact_selection" */
export type GradFunFactSelectionArrRelInsertInput = {
  data: Array<GradFunFactSelectionInsertInput>;
  on_conflict?: Maybe<GradFunFactSelectionOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.fun_fact_selection". All fields are combined with a logical 'AND'. */
export type GradFunFactSelectionBoolExp = {
  _and?: Maybe<Array<Maybe<GradFunFactSelectionBoolExp>>>;
  _not?: Maybe<GradFunFactSelectionBoolExp>;
  _or?: Maybe<Array<Maybe<GradFunFactSelectionBoolExp>>>;
  description?: Maybe<StringComparisonExp>;
  fun_fact_selection_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.fun_fact_selection" */
export enum GradFunFactSelectionConstraint {
  /** unique or primary key constraint */
  FunFactSelectionPkey = 'fun_fact_selection_pkey'
}

/** input type for inserting data into table "grad.fun_fact_selection" */
export type GradFunFactSelectionInsertInput = {
  description?: Maybe<Scalars['String']>;
  fun_fact_selection_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradFunFactSelectionMaxFields = {
  __typename?: 'grad_fun_fact_selection_max_fields';
  description?: Maybe<Scalars['String']>;
  fun_fact_selection_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.fun_fact_selection" */
export type GradFunFactSelectionMaxOrderBy = {
  description?: Maybe<OrderBy>;
  fun_fact_selection_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradFunFactSelectionMinFields = {
  __typename?: 'grad_fun_fact_selection_min_fields';
  description?: Maybe<Scalars['String']>;
  fun_fact_selection_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.fun_fact_selection" */
export type GradFunFactSelectionMinOrderBy = {
  description?: Maybe<OrderBy>;
  fun_fact_selection_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.fun_fact_selection" */
export type GradFunFactSelectionMutationResponse = {
  __typename?: 'grad_fun_fact_selection_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradFunFactSelection>;
};

/** input type for inserting object relation for remote table "grad.fun_fact_selection" */
export type GradFunFactSelectionObjRelInsertInput = {
  data: GradFunFactSelectionInsertInput;
  on_conflict?: Maybe<GradFunFactSelectionOnConflict>;
};

/** on conflict condition type for table "grad.fun_fact_selection" */
export type GradFunFactSelectionOnConflict = {
  constraint: GradFunFactSelectionConstraint;
  update_columns: Array<GradFunFactSelectionUpdateColumn>;
  where?: Maybe<GradFunFactSelectionBoolExp>;
};

/** ordering options when selecting data from "grad.fun_fact_selection" */
export type GradFunFactSelectionOrderBy = {
  description?: Maybe<OrderBy>;
  fun_fact_selection_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.fun_fact_selection" */
export type GradFunFactSelectionPkColumnsInput = {
  fun_fact_selection_id: Scalars['String'];
};

/** select columns of table "grad.fun_fact_selection" */
export enum GradFunFactSelectionSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  FunFactSelectionId = 'fun_fact_selection_id'
}

/** input type for updating data in table "grad.fun_fact_selection" */
export type GradFunFactSelectionSetInput = {
  description?: Maybe<Scalars['String']>;
  fun_fact_selection_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.fun_fact_selection" */
export enum GradFunFactSelectionUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  FunFactSelectionId = 'fun_fact_selection_id'
}

/** input type for updating data in table "grad.fun_fact" */
export type GradFunFactSetInput = {
  description?: Maybe<Scalars['String']>;
  fun_fact_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.fun_fact" */
export enum GradFunFactUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  FunFactId = 'fun_fact_id',
  /** column name */
  UserId = 'user_id'
}

/**
 * stores student interest in firm types
 *
 *
 * columns and relationships of "grad.interest_firm"
 */
export type GradInterestFirm = {
  __typename?: 'grad_interest_firm';
  /** e.g. Hedge Funds | Investment Banks, refer to spreadsheet for full list */
  firm_type: Scalars['String'];
  /** auto-generated uuid */
  interest_firm_id: Scalars['String'];
  /** maps to profile.user_id */
  user_id: Scalars['String'];
};

/** aggregated selection of "grad.interest_firm" */
export type GradInterestFirmAggregate = {
  __typename?: 'grad_interest_firm_aggregate';
  aggregate?: Maybe<GradInterestFirmAggregateFields>;
  nodes: Array<GradInterestFirm>;
};

/** aggregate fields of "grad.interest_firm" */
export type GradInterestFirmAggregateFields = {
  __typename?: 'grad_interest_firm_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradInterestFirmMaxFields>;
  min?: Maybe<GradInterestFirmMinFields>;
};


/** aggregate fields of "grad.interest_firm" */
export type GradInterestFirmAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradInterestFirmSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.interest_firm" */
export type GradInterestFirmAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradInterestFirmMaxOrderBy>;
  min?: Maybe<GradInterestFirmMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.interest_firm" */
export type GradInterestFirmArrRelInsertInput = {
  data: Array<GradInterestFirmInsertInput>;
  on_conflict?: Maybe<GradInterestFirmOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.interest_firm". All fields are combined with a logical 'AND'. */
export type GradInterestFirmBoolExp = {
  _and?: Maybe<Array<Maybe<GradInterestFirmBoolExp>>>;
  _not?: Maybe<GradInterestFirmBoolExp>;
  _or?: Maybe<Array<Maybe<GradInterestFirmBoolExp>>>;
  firm_type?: Maybe<StringComparisonExp>;
  interest_firm_id?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.interest_firm" */
export enum GradInterestFirmConstraint {
  /** unique or primary key constraint */
  InterestFirmInterestFirmIdKey = 'interest_firm_interest_firm_id_key',
  /** unique or primary key constraint */
  InterestFirmPkey = 'interest_firm_pkey',
  /** unique or primary key constraint */
  InterestFirmUserIdFirmTypeKey = 'interest_firm_user_id_firm_type_key'
}

/** input type for inserting data into table "grad.interest_firm" */
export type GradInterestFirmInsertInput = {
  firm_type?: Maybe<Scalars['String']>;
  interest_firm_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradInterestFirmMaxFields = {
  __typename?: 'grad_interest_firm_max_fields';
  firm_type?: Maybe<Scalars['String']>;
  interest_firm_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.interest_firm" */
export type GradInterestFirmMaxOrderBy = {
  firm_type?: Maybe<OrderBy>;
  interest_firm_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradInterestFirmMinFields = {
  __typename?: 'grad_interest_firm_min_fields';
  firm_type?: Maybe<Scalars['String']>;
  interest_firm_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.interest_firm" */
export type GradInterestFirmMinOrderBy = {
  firm_type?: Maybe<OrderBy>;
  interest_firm_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.interest_firm" */
export type GradInterestFirmMutationResponse = {
  __typename?: 'grad_interest_firm_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradInterestFirm>;
};

/** input type for inserting object relation for remote table "grad.interest_firm" */
export type GradInterestFirmObjRelInsertInput = {
  data: GradInterestFirmInsertInput;
  on_conflict?: Maybe<GradInterestFirmOnConflict>;
};

/** on conflict condition type for table "grad.interest_firm" */
export type GradInterestFirmOnConflict = {
  constraint: GradInterestFirmConstraint;
  update_columns: Array<GradInterestFirmUpdateColumn>;
  where?: Maybe<GradInterestFirmBoolExp>;
};

/** ordering options when selecting data from "grad.interest_firm" */
export type GradInterestFirmOrderBy = {
  firm_type?: Maybe<OrderBy>;
  interest_firm_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.interest_firm" */
export type GradInterestFirmPkColumnsInput = {
  /** auto-generated uuid */
  interest_firm_id: Scalars['String'];
};

/** select columns of table "grad.interest_firm" */
export enum GradInterestFirmSelectColumn {
  /** column name */
  FirmType = 'firm_type',
  /** column name */
  InterestFirmId = 'interest_firm_id',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "grad.interest_firm_selection" */
export type GradInterestFirmSelection = {
  __typename?: 'grad_interest_firm_selection';
  interest_firm_selection_id: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "grad.interest_firm_selection" */
export type GradInterestFirmSelectionAggregate = {
  __typename?: 'grad_interest_firm_selection_aggregate';
  aggregate?: Maybe<GradInterestFirmSelectionAggregateFields>;
  nodes: Array<GradInterestFirmSelection>;
};

/** aggregate fields of "grad.interest_firm_selection" */
export type GradInterestFirmSelectionAggregateFields = {
  __typename?: 'grad_interest_firm_selection_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradInterestFirmSelectionMaxFields>;
  min?: Maybe<GradInterestFirmSelectionMinFields>;
};


/** aggregate fields of "grad.interest_firm_selection" */
export type GradInterestFirmSelectionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradInterestFirmSelectionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.interest_firm_selection" */
export type GradInterestFirmSelectionAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradInterestFirmSelectionMaxOrderBy>;
  min?: Maybe<GradInterestFirmSelectionMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.interest_firm_selection" */
export type GradInterestFirmSelectionArrRelInsertInput = {
  data: Array<GradInterestFirmSelectionInsertInput>;
  on_conflict?: Maybe<GradInterestFirmSelectionOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.interest_firm_selection". All fields are combined with a logical 'AND'. */
export type GradInterestFirmSelectionBoolExp = {
  _and?: Maybe<Array<Maybe<GradInterestFirmSelectionBoolExp>>>;
  _not?: Maybe<GradInterestFirmSelectionBoolExp>;
  _or?: Maybe<Array<Maybe<GradInterestFirmSelectionBoolExp>>>;
  interest_firm_selection_id?: Maybe<StringComparisonExp>;
  value?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.interest_firm_selection" */
export enum GradInterestFirmSelectionConstraint {
  /** unique or primary key constraint */
  InterestFirmSelectionPkey = 'interest_firm_selection_pkey'
}

/** input type for inserting data into table "grad.interest_firm_selection" */
export type GradInterestFirmSelectionInsertInput = {
  interest_firm_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradInterestFirmSelectionMaxFields = {
  __typename?: 'grad_interest_firm_selection_max_fields';
  interest_firm_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.interest_firm_selection" */
export type GradInterestFirmSelectionMaxOrderBy = {
  interest_firm_selection_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradInterestFirmSelectionMinFields = {
  __typename?: 'grad_interest_firm_selection_min_fields';
  interest_firm_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.interest_firm_selection" */
export type GradInterestFirmSelectionMinOrderBy = {
  interest_firm_selection_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.interest_firm_selection" */
export type GradInterestFirmSelectionMutationResponse = {
  __typename?: 'grad_interest_firm_selection_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradInterestFirmSelection>;
};

/** input type for inserting object relation for remote table "grad.interest_firm_selection" */
export type GradInterestFirmSelectionObjRelInsertInput = {
  data: GradInterestFirmSelectionInsertInput;
  on_conflict?: Maybe<GradInterestFirmSelectionOnConflict>;
};

/** on conflict condition type for table "grad.interest_firm_selection" */
export type GradInterestFirmSelectionOnConflict = {
  constraint: GradInterestFirmSelectionConstraint;
  update_columns: Array<GradInterestFirmSelectionUpdateColumn>;
  where?: Maybe<GradInterestFirmSelectionBoolExp>;
};

/** ordering options when selecting data from "grad.interest_firm_selection" */
export type GradInterestFirmSelectionOrderBy = {
  interest_firm_selection_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.interest_firm_selection" */
export type GradInterestFirmSelectionPkColumnsInput = {
  interest_firm_selection_id: Scalars['String'];
};

/** select columns of table "grad.interest_firm_selection" */
export enum GradInterestFirmSelectionSelectColumn {
  /** column name */
  InterestFirmSelectionId = 'interest_firm_selection_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "grad.interest_firm_selection" */
export type GradInterestFirmSelectionSetInput = {
  interest_firm_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.interest_firm_selection" */
export enum GradInterestFirmSelectionUpdateColumn {
  /** column name */
  InterestFirmSelectionId = 'interest_firm_selection_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "grad.interest_firm" */
export type GradInterestFirmSetInput = {
  firm_type?: Maybe<Scalars['String']>;
  interest_firm_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.interest_firm" */
export enum GradInterestFirmUpdateColumn {
  /** column name */
  FirmType = 'firm_type',
  /** column name */
  InterestFirmId = 'interest_firm_id',
  /** column name */
  UserId = 'user_id'
}

/**
 * stores student interest in job types
 *
 *
 * columns and relationships of "grad.interest_job_type"
 */
export type GradInterestJobType = {
  __typename?: 'grad_interest_job_type';
  /** auto-generated uuid */
  interest_job_type_id: Scalars['String'];
  /** possible values: internship | full time */
  job_type: Scalars['String'];
  /** maps to profile.user_id */
  user_id: Scalars['String'];
};

/** aggregated selection of "grad.interest_job_type" */
export type GradInterestJobTypeAggregate = {
  __typename?: 'grad_interest_job_type_aggregate';
  aggregate?: Maybe<GradInterestJobTypeAggregateFields>;
  nodes: Array<GradInterestJobType>;
};

/** aggregate fields of "grad.interest_job_type" */
export type GradInterestJobTypeAggregateFields = {
  __typename?: 'grad_interest_job_type_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradInterestJobTypeMaxFields>;
  min?: Maybe<GradInterestJobTypeMinFields>;
};


/** aggregate fields of "grad.interest_job_type" */
export type GradInterestJobTypeAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradInterestJobTypeSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.interest_job_type" */
export type GradInterestJobTypeAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradInterestJobTypeMaxOrderBy>;
  min?: Maybe<GradInterestJobTypeMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.interest_job_type" */
export type GradInterestJobTypeArrRelInsertInput = {
  data: Array<GradInterestJobTypeInsertInput>;
  on_conflict?: Maybe<GradInterestJobTypeOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.interest_job_type". All fields are combined with a logical 'AND'. */
export type GradInterestJobTypeBoolExp = {
  _and?: Maybe<Array<Maybe<GradInterestJobTypeBoolExp>>>;
  _not?: Maybe<GradInterestJobTypeBoolExp>;
  _or?: Maybe<Array<Maybe<GradInterestJobTypeBoolExp>>>;
  interest_job_type_id?: Maybe<StringComparisonExp>;
  job_type?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.interest_job_type" */
export enum GradInterestJobTypeConstraint {
  /** unique or primary key constraint */
  InterestJobTypeInterestJobTypeIdKey = 'interest_job_type_interest_job_type_id_key',
  /** unique or primary key constraint */
  InterestJobTypePkey = 'interest_job_type_pkey',
  /** unique or primary key constraint */
  InterestJobTypeUserIdJobTypeKey = 'interest_job_type_user_id_job_type_key'
}

/** input type for inserting data into table "grad.interest_job_type" */
export type GradInterestJobTypeInsertInput = {
  interest_job_type_id?: Maybe<Scalars['String']>;
  job_type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradInterestJobTypeMaxFields = {
  __typename?: 'grad_interest_job_type_max_fields';
  interest_job_type_id?: Maybe<Scalars['String']>;
  job_type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.interest_job_type" */
export type GradInterestJobTypeMaxOrderBy = {
  interest_job_type_id?: Maybe<OrderBy>;
  job_type?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradInterestJobTypeMinFields = {
  __typename?: 'grad_interest_job_type_min_fields';
  interest_job_type_id?: Maybe<Scalars['String']>;
  job_type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.interest_job_type" */
export type GradInterestJobTypeMinOrderBy = {
  interest_job_type_id?: Maybe<OrderBy>;
  job_type?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.interest_job_type" */
export type GradInterestJobTypeMutationResponse = {
  __typename?: 'grad_interest_job_type_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradInterestJobType>;
};

/** input type for inserting object relation for remote table "grad.interest_job_type" */
export type GradInterestJobTypeObjRelInsertInput = {
  data: GradInterestJobTypeInsertInput;
  on_conflict?: Maybe<GradInterestJobTypeOnConflict>;
};

/** on conflict condition type for table "grad.interest_job_type" */
export type GradInterestJobTypeOnConflict = {
  constraint: GradInterestJobTypeConstraint;
  update_columns: Array<GradInterestJobTypeUpdateColumn>;
  where?: Maybe<GradInterestJobTypeBoolExp>;
};

/** ordering options when selecting data from "grad.interest_job_type" */
export type GradInterestJobTypeOrderBy = {
  interest_job_type_id?: Maybe<OrderBy>;
  job_type?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.interest_job_type" */
export type GradInterestJobTypePkColumnsInput = {
  /** auto-generated uuid */
  interest_job_type_id: Scalars['String'];
};

/** select columns of table "grad.interest_job_type" */
export enum GradInterestJobTypeSelectColumn {
  /** column name */
  InterestJobTypeId = 'interest_job_type_id',
  /** column name */
  JobType = 'job_type',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "grad.interest_job_type_selection" */
export type GradInterestJobTypeSelection = {
  __typename?: 'grad_interest_job_type_selection';
  interest_job_type_selection_id: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "grad.interest_job_type_selection" */
export type GradInterestJobTypeSelectionAggregate = {
  __typename?: 'grad_interest_job_type_selection_aggregate';
  aggregate?: Maybe<GradInterestJobTypeSelectionAggregateFields>;
  nodes: Array<GradInterestJobTypeSelection>;
};

/** aggregate fields of "grad.interest_job_type_selection" */
export type GradInterestJobTypeSelectionAggregateFields = {
  __typename?: 'grad_interest_job_type_selection_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradInterestJobTypeSelectionMaxFields>;
  min?: Maybe<GradInterestJobTypeSelectionMinFields>;
};


/** aggregate fields of "grad.interest_job_type_selection" */
export type GradInterestJobTypeSelectionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradInterestJobTypeSelectionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.interest_job_type_selection" */
export type GradInterestJobTypeSelectionAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradInterestJobTypeSelectionMaxOrderBy>;
  min?: Maybe<GradInterestJobTypeSelectionMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.interest_job_type_selection" */
export type GradInterestJobTypeSelectionArrRelInsertInput = {
  data: Array<GradInterestJobTypeSelectionInsertInput>;
  on_conflict?: Maybe<GradInterestJobTypeSelectionOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.interest_job_type_selection". All fields are combined with a logical 'AND'. */
export type GradInterestJobTypeSelectionBoolExp = {
  _and?: Maybe<Array<Maybe<GradInterestJobTypeSelectionBoolExp>>>;
  _not?: Maybe<GradInterestJobTypeSelectionBoolExp>;
  _or?: Maybe<Array<Maybe<GradInterestJobTypeSelectionBoolExp>>>;
  interest_job_type_selection_id?: Maybe<StringComparisonExp>;
  value?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.interest_job_type_selection" */
export enum GradInterestJobTypeSelectionConstraint {
  /** unique or primary key constraint */
  InterestJobTypeSelectionPkey = 'interest_job_type_selection_pkey'
}

/** input type for inserting data into table "grad.interest_job_type_selection" */
export type GradInterestJobTypeSelectionInsertInput = {
  interest_job_type_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradInterestJobTypeSelectionMaxFields = {
  __typename?: 'grad_interest_job_type_selection_max_fields';
  interest_job_type_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.interest_job_type_selection" */
export type GradInterestJobTypeSelectionMaxOrderBy = {
  interest_job_type_selection_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradInterestJobTypeSelectionMinFields = {
  __typename?: 'grad_interest_job_type_selection_min_fields';
  interest_job_type_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.interest_job_type_selection" */
export type GradInterestJobTypeSelectionMinOrderBy = {
  interest_job_type_selection_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.interest_job_type_selection" */
export type GradInterestJobTypeSelectionMutationResponse = {
  __typename?: 'grad_interest_job_type_selection_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradInterestJobTypeSelection>;
};

/** input type for inserting object relation for remote table "grad.interest_job_type_selection" */
export type GradInterestJobTypeSelectionObjRelInsertInput = {
  data: GradInterestJobTypeSelectionInsertInput;
  on_conflict?: Maybe<GradInterestJobTypeSelectionOnConflict>;
};

/** on conflict condition type for table "grad.interest_job_type_selection" */
export type GradInterestJobTypeSelectionOnConflict = {
  constraint: GradInterestJobTypeSelectionConstraint;
  update_columns: Array<GradInterestJobTypeSelectionUpdateColumn>;
  where?: Maybe<GradInterestJobTypeSelectionBoolExp>;
};

/** ordering options when selecting data from "grad.interest_job_type_selection" */
export type GradInterestJobTypeSelectionOrderBy = {
  interest_job_type_selection_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.interest_job_type_selection" */
export type GradInterestJobTypeSelectionPkColumnsInput = {
  interest_job_type_selection_id: Scalars['String'];
};

/** select columns of table "grad.interest_job_type_selection" */
export enum GradInterestJobTypeSelectionSelectColumn {
  /** column name */
  InterestJobTypeSelectionId = 'interest_job_type_selection_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "grad.interest_job_type_selection" */
export type GradInterestJobTypeSelectionSetInput = {
  interest_job_type_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.interest_job_type_selection" */
export enum GradInterestJobTypeSelectionUpdateColumn {
  /** column name */
  InterestJobTypeSelectionId = 'interest_job_type_selection_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "grad.interest_job_type" */
export type GradInterestJobTypeSetInput = {
  interest_job_type_id?: Maybe<Scalars['String']>;
  job_type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.interest_job_type" */
export enum GradInterestJobTypeUpdateColumn {
  /** column name */
  InterestJobTypeId = 'interest_job_type_id',
  /** column name */
  JobType = 'job_type',
  /** column name */
  UserId = 'user_id'
}

/**
 * stores student interest in geographic regions
 *
 *
 * columns and relationships of "grad.interest_region"
 */
export type GradInterestRegion = {
  __typename?: 'grad_interest_region';
  /** auto-generated uuid */
  interest_region_id: Scalars['String'];
  /** e.g. US - South | US - Northeast, refer to spreadsheet for full list */
  region: Scalars['String'];
  /** maps to profile.user_id */
  user_id: Scalars['String'];
};

/** aggregated selection of "grad.interest_region" */
export type GradInterestRegionAggregate = {
  __typename?: 'grad_interest_region_aggregate';
  aggregate?: Maybe<GradInterestRegionAggregateFields>;
  nodes: Array<GradInterestRegion>;
};

/** aggregate fields of "grad.interest_region" */
export type GradInterestRegionAggregateFields = {
  __typename?: 'grad_interest_region_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradInterestRegionMaxFields>;
  min?: Maybe<GradInterestRegionMinFields>;
};


/** aggregate fields of "grad.interest_region" */
export type GradInterestRegionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradInterestRegionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.interest_region" */
export type GradInterestRegionAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradInterestRegionMaxOrderBy>;
  min?: Maybe<GradInterestRegionMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.interest_region" */
export type GradInterestRegionArrRelInsertInput = {
  data: Array<GradInterestRegionInsertInput>;
  on_conflict?: Maybe<GradInterestRegionOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.interest_region". All fields are combined with a logical 'AND'. */
export type GradInterestRegionBoolExp = {
  _and?: Maybe<Array<Maybe<GradInterestRegionBoolExp>>>;
  _not?: Maybe<GradInterestRegionBoolExp>;
  _or?: Maybe<Array<Maybe<GradInterestRegionBoolExp>>>;
  interest_region_id?: Maybe<StringComparisonExp>;
  region?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.interest_region" */
export enum GradInterestRegionConstraint {
  /** unique or primary key constraint */
  InterestRegionInterestRegionIdKey = 'interest_region_interest_region_id_key',
  /** unique or primary key constraint */
  InterestRegionPkey = 'interest_region_pkey',
  /** unique or primary key constraint */
  InterestRegionUserIdRegionKey = 'interest_region_user_id_region_key'
}

/** input type for inserting data into table "grad.interest_region" */
export type GradInterestRegionInsertInput = {
  interest_region_id?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradInterestRegionMaxFields = {
  __typename?: 'grad_interest_region_max_fields';
  interest_region_id?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.interest_region" */
export type GradInterestRegionMaxOrderBy = {
  interest_region_id?: Maybe<OrderBy>;
  region?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradInterestRegionMinFields = {
  __typename?: 'grad_interest_region_min_fields';
  interest_region_id?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.interest_region" */
export type GradInterestRegionMinOrderBy = {
  interest_region_id?: Maybe<OrderBy>;
  region?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.interest_region" */
export type GradInterestRegionMutationResponse = {
  __typename?: 'grad_interest_region_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradInterestRegion>;
};

/** input type for inserting object relation for remote table "grad.interest_region" */
export type GradInterestRegionObjRelInsertInput = {
  data: GradInterestRegionInsertInput;
  on_conflict?: Maybe<GradInterestRegionOnConflict>;
};

/** on conflict condition type for table "grad.interest_region" */
export type GradInterestRegionOnConflict = {
  constraint: GradInterestRegionConstraint;
  update_columns: Array<GradInterestRegionUpdateColumn>;
  where?: Maybe<GradInterestRegionBoolExp>;
};

/** ordering options when selecting data from "grad.interest_region" */
export type GradInterestRegionOrderBy = {
  interest_region_id?: Maybe<OrderBy>;
  region?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.interest_region" */
export type GradInterestRegionPkColumnsInput = {
  /** auto-generated uuid */
  interest_region_id: Scalars['String'];
};

/** select columns of table "grad.interest_region" */
export enum GradInterestRegionSelectColumn {
  /** column name */
  InterestRegionId = 'interest_region_id',
  /** column name */
  Region = 'region',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "grad.interest_region_selection" */
export type GradInterestRegionSelection = {
  __typename?: 'grad_interest_region_selection';
  interest_region_selection_id: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "grad.interest_region_selection" */
export type GradInterestRegionSelectionAggregate = {
  __typename?: 'grad_interest_region_selection_aggregate';
  aggregate?: Maybe<GradInterestRegionSelectionAggregateFields>;
  nodes: Array<GradInterestRegionSelection>;
};

/** aggregate fields of "grad.interest_region_selection" */
export type GradInterestRegionSelectionAggregateFields = {
  __typename?: 'grad_interest_region_selection_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradInterestRegionSelectionMaxFields>;
  min?: Maybe<GradInterestRegionSelectionMinFields>;
};


/** aggregate fields of "grad.interest_region_selection" */
export type GradInterestRegionSelectionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradInterestRegionSelectionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.interest_region_selection" */
export type GradInterestRegionSelectionAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradInterestRegionSelectionMaxOrderBy>;
  min?: Maybe<GradInterestRegionSelectionMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.interest_region_selection" */
export type GradInterestRegionSelectionArrRelInsertInput = {
  data: Array<GradInterestRegionSelectionInsertInput>;
  on_conflict?: Maybe<GradInterestRegionSelectionOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.interest_region_selection". All fields are combined with a logical 'AND'. */
export type GradInterestRegionSelectionBoolExp = {
  _and?: Maybe<Array<Maybe<GradInterestRegionSelectionBoolExp>>>;
  _not?: Maybe<GradInterestRegionSelectionBoolExp>;
  _or?: Maybe<Array<Maybe<GradInterestRegionSelectionBoolExp>>>;
  interest_region_selection_id?: Maybe<StringComparisonExp>;
  value?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.interest_region_selection" */
export enum GradInterestRegionSelectionConstraint {
  /** unique or primary key constraint */
  InterestRegionSelectionPkey = 'interest_region_selection_pkey'
}

/** input type for inserting data into table "grad.interest_region_selection" */
export type GradInterestRegionSelectionInsertInput = {
  interest_region_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradInterestRegionSelectionMaxFields = {
  __typename?: 'grad_interest_region_selection_max_fields';
  interest_region_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.interest_region_selection" */
export type GradInterestRegionSelectionMaxOrderBy = {
  interest_region_selection_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradInterestRegionSelectionMinFields = {
  __typename?: 'grad_interest_region_selection_min_fields';
  interest_region_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.interest_region_selection" */
export type GradInterestRegionSelectionMinOrderBy = {
  interest_region_selection_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.interest_region_selection" */
export type GradInterestRegionSelectionMutationResponse = {
  __typename?: 'grad_interest_region_selection_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradInterestRegionSelection>;
};

/** input type for inserting object relation for remote table "grad.interest_region_selection" */
export type GradInterestRegionSelectionObjRelInsertInput = {
  data: GradInterestRegionSelectionInsertInput;
  on_conflict?: Maybe<GradInterestRegionSelectionOnConflict>;
};

/** on conflict condition type for table "grad.interest_region_selection" */
export type GradInterestRegionSelectionOnConflict = {
  constraint: GradInterestRegionSelectionConstraint;
  update_columns: Array<GradInterestRegionSelectionUpdateColumn>;
  where?: Maybe<GradInterestRegionSelectionBoolExp>;
};

/** ordering options when selecting data from "grad.interest_region_selection" */
export type GradInterestRegionSelectionOrderBy = {
  interest_region_selection_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.interest_region_selection" */
export type GradInterestRegionSelectionPkColumnsInput = {
  interest_region_selection_id: Scalars['String'];
};

/** select columns of table "grad.interest_region_selection" */
export enum GradInterestRegionSelectionSelectColumn {
  /** column name */
  InterestRegionSelectionId = 'interest_region_selection_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "grad.interest_region_selection" */
export type GradInterestRegionSelectionSetInput = {
  interest_region_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.interest_region_selection" */
export enum GradInterestRegionSelectionUpdateColumn {
  /** column name */
  InterestRegionSelectionId = 'interest_region_selection_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "grad.interest_region" */
export type GradInterestRegionSetInput = {
  interest_region_id?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.interest_region" */
export enum GradInterestRegionUpdateColumn {
  /** column name */
  InterestRegionId = 'interest_region_id',
  /** column name */
  Region = 'region',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "grad.interest_role" */
export type GradInterestRole = {
  __typename?: 'grad_interest_role';
  interest_role_id: Scalars['String'];
  role: Scalars['String'];
  user_id: Scalars['String'];
};

/** aggregated selection of "grad.interest_role" */
export type GradInterestRoleAggregate = {
  __typename?: 'grad_interest_role_aggregate';
  aggregate?: Maybe<GradInterestRoleAggregateFields>;
  nodes: Array<GradInterestRole>;
};

/** aggregate fields of "grad.interest_role" */
export type GradInterestRoleAggregateFields = {
  __typename?: 'grad_interest_role_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradInterestRoleMaxFields>;
  min?: Maybe<GradInterestRoleMinFields>;
};


/** aggregate fields of "grad.interest_role" */
export type GradInterestRoleAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradInterestRoleSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.interest_role" */
export type GradInterestRoleAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradInterestRoleMaxOrderBy>;
  min?: Maybe<GradInterestRoleMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.interest_role" */
export type GradInterestRoleArrRelInsertInput = {
  data: Array<GradInterestRoleInsertInput>;
  on_conflict?: Maybe<GradInterestRoleOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.interest_role". All fields are combined with a logical 'AND'. */
export type GradInterestRoleBoolExp = {
  _and?: Maybe<Array<Maybe<GradInterestRoleBoolExp>>>;
  _not?: Maybe<GradInterestRoleBoolExp>;
  _or?: Maybe<Array<Maybe<GradInterestRoleBoolExp>>>;
  interest_role_id?: Maybe<StringComparisonExp>;
  role?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.interest_role" */
export enum GradInterestRoleConstraint {
  /** unique or primary key constraint */
  InterestRolePkey = 'interest_role_pkey'
}

/** input type for inserting data into table "grad.interest_role" */
export type GradInterestRoleInsertInput = {
  interest_role_id?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradInterestRoleMaxFields = {
  __typename?: 'grad_interest_role_max_fields';
  interest_role_id?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.interest_role" */
export type GradInterestRoleMaxOrderBy = {
  interest_role_id?: Maybe<OrderBy>;
  role?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradInterestRoleMinFields = {
  __typename?: 'grad_interest_role_min_fields';
  interest_role_id?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.interest_role" */
export type GradInterestRoleMinOrderBy = {
  interest_role_id?: Maybe<OrderBy>;
  role?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.interest_role" */
export type GradInterestRoleMutationResponse = {
  __typename?: 'grad_interest_role_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradInterestRole>;
};

/** input type for inserting object relation for remote table "grad.interest_role" */
export type GradInterestRoleObjRelInsertInput = {
  data: GradInterestRoleInsertInput;
  on_conflict?: Maybe<GradInterestRoleOnConflict>;
};

/** on conflict condition type for table "grad.interest_role" */
export type GradInterestRoleOnConflict = {
  constraint: GradInterestRoleConstraint;
  update_columns: Array<GradInterestRoleUpdateColumn>;
  where?: Maybe<GradInterestRoleBoolExp>;
};

/** ordering options when selecting data from "grad.interest_role" */
export type GradInterestRoleOrderBy = {
  interest_role_id?: Maybe<OrderBy>;
  role?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.interest_role" */
export type GradInterestRolePkColumnsInput = {
  interest_role_id: Scalars['String'];
};

/** select columns of table "grad.interest_role" */
export enum GradInterestRoleSelectColumn {
  /** column name */
  InterestRoleId = 'interest_role_id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "grad.interest_role_selection" */
export type GradInterestRoleSelection = {
  __typename?: 'grad_interest_role_selection';
  interest_role_selection_id: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "grad.interest_role_selection" */
export type GradInterestRoleSelectionAggregate = {
  __typename?: 'grad_interest_role_selection_aggregate';
  aggregate?: Maybe<GradInterestRoleSelectionAggregateFields>;
  nodes: Array<GradInterestRoleSelection>;
};

/** aggregate fields of "grad.interest_role_selection" */
export type GradInterestRoleSelectionAggregateFields = {
  __typename?: 'grad_interest_role_selection_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradInterestRoleSelectionMaxFields>;
  min?: Maybe<GradInterestRoleSelectionMinFields>;
};


/** aggregate fields of "grad.interest_role_selection" */
export type GradInterestRoleSelectionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradInterestRoleSelectionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.interest_role_selection" */
export type GradInterestRoleSelectionAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradInterestRoleSelectionMaxOrderBy>;
  min?: Maybe<GradInterestRoleSelectionMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.interest_role_selection" */
export type GradInterestRoleSelectionArrRelInsertInput = {
  data: Array<GradInterestRoleSelectionInsertInput>;
  on_conflict?: Maybe<GradInterestRoleSelectionOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.interest_role_selection". All fields are combined with a logical 'AND'. */
export type GradInterestRoleSelectionBoolExp = {
  _and?: Maybe<Array<Maybe<GradInterestRoleSelectionBoolExp>>>;
  _not?: Maybe<GradInterestRoleSelectionBoolExp>;
  _or?: Maybe<Array<Maybe<GradInterestRoleSelectionBoolExp>>>;
  interest_role_selection_id?: Maybe<StringComparisonExp>;
  value?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.interest_role_selection" */
export enum GradInterestRoleSelectionConstraint {
  /** unique or primary key constraint */
  InterestRoleSelectionPkey = 'interest_role_selection_pkey'
}

/** input type for inserting data into table "grad.interest_role_selection" */
export type GradInterestRoleSelectionInsertInput = {
  interest_role_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradInterestRoleSelectionMaxFields = {
  __typename?: 'grad_interest_role_selection_max_fields';
  interest_role_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.interest_role_selection" */
export type GradInterestRoleSelectionMaxOrderBy = {
  interest_role_selection_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradInterestRoleSelectionMinFields = {
  __typename?: 'grad_interest_role_selection_min_fields';
  interest_role_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.interest_role_selection" */
export type GradInterestRoleSelectionMinOrderBy = {
  interest_role_selection_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.interest_role_selection" */
export type GradInterestRoleSelectionMutationResponse = {
  __typename?: 'grad_interest_role_selection_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradInterestRoleSelection>;
};

/** input type for inserting object relation for remote table "grad.interest_role_selection" */
export type GradInterestRoleSelectionObjRelInsertInput = {
  data: GradInterestRoleSelectionInsertInput;
  on_conflict?: Maybe<GradInterestRoleSelectionOnConflict>;
};

/** on conflict condition type for table "grad.interest_role_selection" */
export type GradInterestRoleSelectionOnConflict = {
  constraint: GradInterestRoleSelectionConstraint;
  update_columns: Array<GradInterestRoleSelectionUpdateColumn>;
  where?: Maybe<GradInterestRoleSelectionBoolExp>;
};

/** ordering options when selecting data from "grad.interest_role_selection" */
export type GradInterestRoleSelectionOrderBy = {
  interest_role_selection_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.interest_role_selection" */
export type GradInterestRoleSelectionPkColumnsInput = {
  interest_role_selection_id: Scalars['String'];
};

/** select columns of table "grad.interest_role_selection" */
export enum GradInterestRoleSelectionSelectColumn {
  /** column name */
  InterestRoleSelectionId = 'interest_role_selection_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "grad.interest_role_selection" */
export type GradInterestRoleSelectionSetInput = {
  interest_role_selection_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.interest_role_selection" */
export enum GradInterestRoleSelectionUpdateColumn {
  /** column name */
  InterestRoleSelectionId = 'interest_role_selection_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "grad.interest_role" */
export type GradInterestRoleSetInput = {
  interest_role_id?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.interest_role" */
export enum GradInterestRoleUpdateColumn {
  /** column name */
  InterestRoleId = 'interest_role_id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'user_id'
}

/**
 * used for autocomplete to pick a major, minor or concentration, read only
 *
 *
 * columns and relationships of "grad.major_selection"
 */
export type GradMajorSelection = {
  __typename?: 'grad_major_selection';
  /** major name */
  major: Scalars['String'];
  /** auto-generated uuid */
  major_selection_id: Scalars['String'];
};

/** aggregated selection of "grad.major_selection" */
export type GradMajorSelectionAggregate = {
  __typename?: 'grad_major_selection_aggregate';
  aggregate?: Maybe<GradMajorSelectionAggregateFields>;
  nodes: Array<GradMajorSelection>;
};

/** aggregate fields of "grad.major_selection" */
export type GradMajorSelectionAggregateFields = {
  __typename?: 'grad_major_selection_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradMajorSelectionMaxFields>;
  min?: Maybe<GradMajorSelectionMinFields>;
};


/** aggregate fields of "grad.major_selection" */
export type GradMajorSelectionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradMajorSelectionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.major_selection" */
export type GradMajorSelectionAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradMajorSelectionMaxOrderBy>;
  min?: Maybe<GradMajorSelectionMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.major_selection" */
export type GradMajorSelectionArrRelInsertInput = {
  data: Array<GradMajorSelectionInsertInput>;
  on_conflict?: Maybe<GradMajorSelectionOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.major_selection". All fields are combined with a logical 'AND'. */
export type GradMajorSelectionBoolExp = {
  _and?: Maybe<Array<Maybe<GradMajorSelectionBoolExp>>>;
  _not?: Maybe<GradMajorSelectionBoolExp>;
  _or?: Maybe<Array<Maybe<GradMajorSelectionBoolExp>>>;
  major?: Maybe<StringComparisonExp>;
  major_selection_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.major_selection" */
export enum GradMajorSelectionConstraint {
  /** unique or primary key constraint */
  MajorSelectionMajorKey = 'major_selection_major_key',
  /** unique or primary key constraint */
  MajorSelectionMajorSelectionIdKey = 'major_selection_major_selection_id_key',
  /** unique or primary key constraint */
  MajorSelectionPkey = 'major_selection_pkey'
}

/** input type for inserting data into table "grad.major_selection" */
export type GradMajorSelectionInsertInput = {
  major?: Maybe<Scalars['String']>;
  major_selection_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradMajorSelectionMaxFields = {
  __typename?: 'grad_major_selection_max_fields';
  major?: Maybe<Scalars['String']>;
  major_selection_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.major_selection" */
export type GradMajorSelectionMaxOrderBy = {
  major?: Maybe<OrderBy>;
  major_selection_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradMajorSelectionMinFields = {
  __typename?: 'grad_major_selection_min_fields';
  major?: Maybe<Scalars['String']>;
  major_selection_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.major_selection" */
export type GradMajorSelectionMinOrderBy = {
  major?: Maybe<OrderBy>;
  major_selection_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.major_selection" */
export type GradMajorSelectionMutationResponse = {
  __typename?: 'grad_major_selection_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradMajorSelection>;
};

/** input type for inserting object relation for remote table "grad.major_selection" */
export type GradMajorSelectionObjRelInsertInput = {
  data: GradMajorSelectionInsertInput;
  on_conflict?: Maybe<GradMajorSelectionOnConflict>;
};

/** on conflict condition type for table "grad.major_selection" */
export type GradMajorSelectionOnConflict = {
  constraint: GradMajorSelectionConstraint;
  update_columns: Array<GradMajorSelectionUpdateColumn>;
  where?: Maybe<GradMajorSelectionBoolExp>;
};

/** ordering options when selecting data from "grad.major_selection" */
export type GradMajorSelectionOrderBy = {
  major?: Maybe<OrderBy>;
  major_selection_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.major_selection" */
export type GradMajorSelectionPkColumnsInput = {
  /** auto-generated uuid */
  major_selection_id: Scalars['String'];
};

/** select columns of table "grad.major_selection" */
export enum GradMajorSelectionSelectColumn {
  /** column name */
  Major = 'major',
  /** column name */
  MajorSelectionId = 'major_selection_id'
}

/** input type for updating data in table "grad.major_selection" */
export type GradMajorSelectionSetInput = {
  major?: Maybe<Scalars['String']>;
  major_selection_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.major_selection" */
export enum GradMajorSelectionUpdateColumn {
  /** column name */
  Major = 'major',
  /** column name */
  MajorSelectionId = 'major_selection_id'
}

/**
 * stores tracking of user page views
 *
 *
 * columns and relationships of "grad.page_view"
 */
export type GradPageView = {
  __typename?: 'grad_page_view';
  /** other data of interest, optional */
  json?: Maybe<Scalars['jsonb']>;
  /** auto-generated uuid */
  page_view_id: Scalars['bigint'];
  /** the url path user is on */
  pathname: Scalars['String'];
  /** record timestamp */
  timestamp: Scalars['timestamptz'];
  /** maps to profile.user_id */
  user_id: Scalars['String'];
};


/**
 * stores tracking of user page views
 *
 *
 * columns and relationships of "grad.page_view"
 */
export type GradPageViewJsonArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "grad.page_view" */
export type GradPageViewAggregate = {
  __typename?: 'grad_page_view_aggregate';
  aggregate?: Maybe<GradPageViewAggregateFields>;
  nodes: Array<GradPageView>;
};

/** aggregate fields of "grad.page_view" */
export type GradPageViewAggregateFields = {
  __typename?: 'grad_page_view_aggregate_fields';
  avg?: Maybe<GradPageViewAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradPageViewMaxFields>;
  min?: Maybe<GradPageViewMinFields>;
  stddev?: Maybe<GradPageViewStddevFields>;
  stddev_pop?: Maybe<GradPageViewStddevPopFields>;
  stddev_samp?: Maybe<GradPageViewStddevSampFields>;
  sum?: Maybe<GradPageViewSumFields>;
  var_pop?: Maybe<GradPageViewVarPopFields>;
  var_samp?: Maybe<GradPageViewVarSampFields>;
  variance?: Maybe<GradPageViewVarianceFields>;
};


/** aggregate fields of "grad.page_view" */
export type GradPageViewAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradPageViewSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.page_view" */
export type GradPageViewAggregateOrderBy = {
  avg?: Maybe<GradPageViewAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<GradPageViewMaxOrderBy>;
  min?: Maybe<GradPageViewMinOrderBy>;
  stddev?: Maybe<GradPageViewStddevOrderBy>;
  stddev_pop?: Maybe<GradPageViewStddevPopOrderBy>;
  stddev_samp?: Maybe<GradPageViewStddevSampOrderBy>;
  sum?: Maybe<GradPageViewSumOrderBy>;
  var_pop?: Maybe<GradPageViewVarPopOrderBy>;
  var_samp?: Maybe<GradPageViewVarSampOrderBy>;
  variance?: Maybe<GradPageViewVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type GradPageViewAppendInput = {
  json?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "grad.page_view" */
export type GradPageViewArrRelInsertInput = {
  data: Array<GradPageViewInsertInput>;
  on_conflict?: Maybe<GradPageViewOnConflict>;
};

/** aggregate avg on columns */
export type GradPageViewAvgFields = {
  __typename?: 'grad_page_view_avg_fields';
  page_view_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "grad.page_view" */
export type GradPageViewAvgOrderBy = {
  page_view_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "grad.page_view". All fields are combined with a logical 'AND'. */
export type GradPageViewBoolExp = {
  _and?: Maybe<Array<Maybe<GradPageViewBoolExp>>>;
  _not?: Maybe<GradPageViewBoolExp>;
  _or?: Maybe<Array<Maybe<GradPageViewBoolExp>>>;
  json?: Maybe<JsonbComparisonExp>;
  page_view_id?: Maybe<BigintComparisonExp>;
  pathname?: Maybe<StringComparisonExp>;
  timestamp?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.page_view" */
export enum GradPageViewConstraint {
  /** unique or primary key constraint */
  PageViewPageViewIdKey = 'page_view_page_view_id_key',
  /** unique or primary key constraint */
  PageViewPkey = 'page_view_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type GradPageViewDeleteAtPathInput = {
  json?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type GradPageViewDeleteElemInput = {
  json?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type GradPageViewDeleteKeyInput = {
  json?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "grad.page_view" */
export type GradPageViewIncInput = {
  page_view_id?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "grad.page_view" */
export type GradPageViewInsertInput = {
  json?: Maybe<Scalars['jsonb']>;
  page_view_id?: Maybe<Scalars['bigint']>;
  pathname?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradPageViewMaxFields = {
  __typename?: 'grad_page_view_max_fields';
  page_view_id?: Maybe<Scalars['bigint']>;
  pathname?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.page_view" */
export type GradPageViewMaxOrderBy = {
  page_view_id?: Maybe<OrderBy>;
  pathname?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradPageViewMinFields = {
  __typename?: 'grad_page_view_min_fields';
  page_view_id?: Maybe<Scalars['bigint']>;
  pathname?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.page_view" */
export type GradPageViewMinOrderBy = {
  page_view_id?: Maybe<OrderBy>;
  pathname?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.page_view" */
export type GradPageViewMutationResponse = {
  __typename?: 'grad_page_view_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradPageView>;
};

/** input type for inserting object relation for remote table "grad.page_view" */
export type GradPageViewObjRelInsertInput = {
  data: GradPageViewInsertInput;
  on_conflict?: Maybe<GradPageViewOnConflict>;
};

/** on conflict condition type for table "grad.page_view" */
export type GradPageViewOnConflict = {
  constraint: GradPageViewConstraint;
  update_columns: Array<GradPageViewUpdateColumn>;
  where?: Maybe<GradPageViewBoolExp>;
};

/** ordering options when selecting data from "grad.page_view" */
export type GradPageViewOrderBy = {
  json?: Maybe<OrderBy>;
  page_view_id?: Maybe<OrderBy>;
  pathname?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.page_view" */
export type GradPageViewPkColumnsInput = {
  /** auto-generated uuid */
  page_view_id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type GradPageViewPrependInput = {
  json?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "grad.page_view" */
export enum GradPageViewSelectColumn {
  /** column name */
  Json = 'json',
  /** column name */
  PageViewId = 'page_view_id',
  /** column name */
  Pathname = 'pathname',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "grad.page_view" */
export type GradPageViewSetInput = {
  json?: Maybe<Scalars['jsonb']>;
  page_view_id?: Maybe<Scalars['bigint']>;
  pathname?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type GradPageViewStddevFields = {
  __typename?: 'grad_page_view_stddev_fields';
  page_view_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "grad.page_view" */
export type GradPageViewStddevOrderBy = {
  page_view_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type GradPageViewStddevPopFields = {
  __typename?: 'grad_page_view_stddev_pop_fields';
  page_view_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "grad.page_view" */
export type GradPageViewStddevPopOrderBy = {
  page_view_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type GradPageViewStddevSampFields = {
  __typename?: 'grad_page_view_stddev_samp_fields';
  page_view_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "grad.page_view" */
export type GradPageViewStddevSampOrderBy = {
  page_view_id?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type GradPageViewSumFields = {
  __typename?: 'grad_page_view_sum_fields';
  page_view_id?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "grad.page_view" */
export type GradPageViewSumOrderBy = {
  page_view_id?: Maybe<OrderBy>;
};

/** update columns of table "grad.page_view" */
export enum GradPageViewUpdateColumn {
  /** column name */
  Json = 'json',
  /** column name */
  PageViewId = 'page_view_id',
  /** column name */
  Pathname = 'pathname',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type GradPageViewVarPopFields = {
  __typename?: 'grad_page_view_var_pop_fields';
  page_view_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "grad.page_view" */
export type GradPageViewVarPopOrderBy = {
  page_view_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type GradPageViewVarSampFields = {
  __typename?: 'grad_page_view_var_samp_fields';
  page_view_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "grad.page_view" */
export type GradPageViewVarSampOrderBy = {
  page_view_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type GradPageViewVarianceFields = {
  __typename?: 'grad_page_view_variance_fields';
  page_view_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "grad.page_view" */
export type GradPageViewVarianceOrderBy = {
  page_view_id?: Maybe<OrderBy>;
};

/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfile = {
  __typename?: 'grad_profile';
  /** An array relationship */
  achievements: Array<GradAchievement>;
  /** An aggregated array relationship */
  achievements_aggregate: GradAchievementAggregate;
  /** An object relationship */
  activity_summary?: Maybe<GradUserActivitySummary>;
  /** is the student authorized to work in the US */
  authorized_to_work?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  awards: Array<GradAward>;
  /** An aggregated array relationship */
  awards_aggregate: GradAwardAggregate;
  /** birth date, including year */
  birth_date?: Maybe<Scalars['date']>;
  blocked: Scalars['Boolean'];
  blocked_reason?: Maybe<Scalars['String']>;
  /** An object relationship */
  combine?: Maybe<GradProfileCombine>;
  comm_preference?: Maybe<Scalars['String']>;
  /** An array relationship */
  computer_languages: Array<GradComputerLanguage>;
  /** An aggregated array relationship */
  computer_languages_aggregate: GradComputerLanguageAggregate;
  /** profile creation timestamp */
  creation_timestamp: Scalars['timestamptz'];
  /** An object relationship */
  degree_latest?: Maybe<GradDegreeLatest>;
  /** An array relationship */
  degrees: Array<GradDegree>;
  /** An aggregated array relationship */
  degrees_aggregate: GradDegreeAggregate;
  /** email */
  email?: Maybe<Scalars['String']>;
  email_verified?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  employer_preferences: Array<GradEmployerPreference>;
  /** An aggregated array relationship */
  employer_preferences_aggregate: GradEmployerPreferenceAggregate;
  /** An array relationship */
  event_registrations: Array<GradEventRegistration>;
  /** An aggregated array relationship */
  event_registrations_aggregate: GradEventRegistrationAggregate;
  /** first name */
  firstname: Scalars['String'];
  /** full name */
  fullname: Scalars['String'];
  /** An array relationship */
  fun_facts: Array<GradFunFact>;
  /** An aggregated array relationship */
  fun_facts_aggregate: GradFunFactAggregate;
  /** An array relationship */
  grad_group_members: Array<RecruitGradGroupMember>;
  /** An aggregated array relationship */
  grad_group_members_aggregate: RecruitGradGroupMemberAggregate;
  /** home town */
  hometown?: Maybe<Scalars['String']>;
  /** An array relationship */
  interest_firms: Array<GradInterestFirm>;
  /** An aggregated array relationship */
  interest_firms_aggregate: GradInterestFirmAggregate;
  /** An array relationship */
  interest_job_types: Array<GradInterestJobType>;
  /** An aggregated array relationship */
  interest_job_types_aggregate: GradInterestJobTypeAggregate;
  /** An array relationship */
  interest_regions: Array<GradInterestRegion>;
  /** An aggregated array relationship */
  interest_regions_aggregate: GradInterestRegionAggregate;
  /** An array relationship */
  interest_roles: Array<GradInterestRole>;
  /** An aggregated array relationship */
  interest_roles_aggregate: GradInterestRoleAggregate;
  /** last name */
  lastname: Scalars['String'];
  /** An object relationship */
  legal_residence_country?: Maybe<GradCountrySelection>;
  legal_residence_country_id?: Maybe<Scalars['String']>;
  /** middle name */
  middlename?: Maybe<Scalars['String']>;
  minority_search?: Maybe<Scalars['Boolean']>;
  /** mobile number */
  mobile?: Maybe<Scalars['String']>;
  mobile_valid: Scalars['Boolean'];
  /** does the student need sponsor to work in the future */
  need_sponsor?: Maybe<Scalars['Boolean']>;
  /** deprecated */
  prior_internship?: Maybe<Scalars['Boolean']>;
  /** profile image stored as encoded string */
  profile_image?: Maybe<Scalars['String']>;
  profile_verified?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  raise_hands: Array<GradRaiseHand>;
  /** An aggregated array relationship */
  raise_hands_aggregate: GradRaiseHandAggregate;
  /** An array relationship */
  spoken_languages: Array<GradSpokenLanguage>;
  /** An aggregated array relationship */
  spoken_languages_aggregate: GradSpokenLanguageAggregate;
  /** social security number */
  ssn?: Maybe<Scalars['String']>;
  student_athlete: Scalars['Boolean'];
  /** An array relationship */
  test_scores: Array<GradTestScore>;
  /** An aggregated array relationship */
  test_scores_aggregate: GradTestScoreAggregate;
  /** suffix, probably deprecated */
  title?: Maybe<Scalars['String']>;
  /** An array relationship */
  upload_docs: Array<GradUploadDoc>;
  /** An aggregated array relationship */
  upload_docs_aggregate: GradUploadDocAggregate;
  /** primary key of profile, same as auth0 sub */
  user_id: Scalars['String'];
  /** deprecated */
  visa_expiration?: Maybe<Scalars['date']>;
  /** deprecated */
  visa_status?: Maybe<Scalars['String']>;
  /** deprecated */
  visa_type?: Maybe<Scalars['String']>;
  /** An array relationship */
  volunteers: Array<GradVolunteer>;
  /** An aggregated array relationship */
  volunteers_aggregate: GradVolunteerAggregate;
  will_relocate?: Maybe<Scalars['Boolean']>;
  /** whether the profile wizard is completed */
  wizard_completed?: Maybe<Scalars['Boolean']>;
  wizard_completion_timestamp?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  work_experiences: Array<GradWorkExperience>;
  /** An aggregated array relationship */
  work_experiences_aggregate: GradWorkExperienceAggregate;
  /** how many years of relevant work, it's a range from dropdown */
  years_of_relevant_work?: Maybe<Scalars['String']>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileAchievementsArgs = {
  distinct_on?: Maybe<Array<GradAchievementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradAchievementOrderBy>>;
  where?: Maybe<GradAchievementBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileAchievementsAggregateArgs = {
  distinct_on?: Maybe<Array<GradAchievementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradAchievementOrderBy>>;
  where?: Maybe<GradAchievementBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileAwardsArgs = {
  distinct_on?: Maybe<Array<GradAwardSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradAwardOrderBy>>;
  where?: Maybe<GradAwardBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileAwardsAggregateArgs = {
  distinct_on?: Maybe<Array<GradAwardSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradAwardOrderBy>>;
  where?: Maybe<GradAwardBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileComputerLanguagesArgs = {
  distinct_on?: Maybe<Array<GradComputerLanguageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradComputerLanguageOrderBy>>;
  where?: Maybe<GradComputerLanguageBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileComputerLanguagesAggregateArgs = {
  distinct_on?: Maybe<Array<GradComputerLanguageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradComputerLanguageOrderBy>>;
  where?: Maybe<GradComputerLanguageBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileDegreesArgs = {
  distinct_on?: Maybe<Array<GradDegreeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradDegreeOrderBy>>;
  where?: Maybe<GradDegreeBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileDegreesAggregateArgs = {
  distinct_on?: Maybe<Array<GradDegreeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradDegreeOrderBy>>;
  where?: Maybe<GradDegreeBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileEmployerPreferencesArgs = {
  distinct_on?: Maybe<Array<GradEmployerPreferenceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradEmployerPreferenceOrderBy>>;
  where?: Maybe<GradEmployerPreferenceBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileEmployerPreferencesAggregateArgs = {
  distinct_on?: Maybe<Array<GradEmployerPreferenceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradEmployerPreferenceOrderBy>>;
  where?: Maybe<GradEmployerPreferenceBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileEventRegistrationsArgs = {
  distinct_on?: Maybe<Array<GradEventRegistrationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradEventRegistrationOrderBy>>;
  where?: Maybe<GradEventRegistrationBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileEventRegistrationsAggregateArgs = {
  distinct_on?: Maybe<Array<GradEventRegistrationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradEventRegistrationOrderBy>>;
  where?: Maybe<GradEventRegistrationBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileFunFactsArgs = {
  distinct_on?: Maybe<Array<GradFunFactSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradFunFactOrderBy>>;
  where?: Maybe<GradFunFactBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileFunFactsAggregateArgs = {
  distinct_on?: Maybe<Array<GradFunFactSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradFunFactOrderBy>>;
  where?: Maybe<GradFunFactBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileGradGroupMembersArgs = {
  distinct_on?: Maybe<Array<RecruitGradGroupMemberSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitGradGroupMemberOrderBy>>;
  where?: Maybe<RecruitGradGroupMemberBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileGradGroupMembersAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitGradGroupMemberSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitGradGroupMemberOrderBy>>;
  where?: Maybe<RecruitGradGroupMemberBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileInterestFirmsArgs = {
  distinct_on?: Maybe<Array<GradInterestFirmSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestFirmOrderBy>>;
  where?: Maybe<GradInterestFirmBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileInterestFirmsAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestFirmSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestFirmOrderBy>>;
  where?: Maybe<GradInterestFirmBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileInterestJobTypesArgs = {
  distinct_on?: Maybe<Array<GradInterestJobTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestJobTypeOrderBy>>;
  where?: Maybe<GradInterestJobTypeBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileInterestJobTypesAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestJobTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestJobTypeOrderBy>>;
  where?: Maybe<GradInterestJobTypeBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileInterestRegionsArgs = {
  distinct_on?: Maybe<Array<GradInterestRegionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRegionOrderBy>>;
  where?: Maybe<GradInterestRegionBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileInterestRegionsAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestRegionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRegionOrderBy>>;
  where?: Maybe<GradInterestRegionBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileInterestRolesArgs = {
  distinct_on?: Maybe<Array<GradInterestRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRoleOrderBy>>;
  where?: Maybe<GradInterestRoleBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileInterestRolesAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRoleOrderBy>>;
  where?: Maybe<GradInterestRoleBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileRaiseHandsArgs = {
  distinct_on?: Maybe<Array<GradRaiseHandSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradRaiseHandOrderBy>>;
  where?: Maybe<GradRaiseHandBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileRaiseHandsAggregateArgs = {
  distinct_on?: Maybe<Array<GradRaiseHandSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradRaiseHandOrderBy>>;
  where?: Maybe<GradRaiseHandBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileSpokenLanguagesArgs = {
  distinct_on?: Maybe<Array<GradSpokenLanguageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradSpokenLanguageOrderBy>>;
  where?: Maybe<GradSpokenLanguageBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileSpokenLanguagesAggregateArgs = {
  distinct_on?: Maybe<Array<GradSpokenLanguageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradSpokenLanguageOrderBy>>;
  where?: Maybe<GradSpokenLanguageBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileTestScoresArgs = {
  distinct_on?: Maybe<Array<GradTestScoreSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradTestScoreOrderBy>>;
  where?: Maybe<GradTestScoreBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileTestScoresAggregateArgs = {
  distinct_on?: Maybe<Array<GradTestScoreSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradTestScoreOrderBy>>;
  where?: Maybe<GradTestScoreBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileUploadDocsArgs = {
  distinct_on?: Maybe<Array<GradUploadDocSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradUploadDocOrderBy>>;
  where?: Maybe<GradUploadDocBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileUploadDocsAggregateArgs = {
  distinct_on?: Maybe<Array<GradUploadDocSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradUploadDocOrderBy>>;
  where?: Maybe<GradUploadDocBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileVolunteersArgs = {
  distinct_on?: Maybe<Array<GradVolunteerSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradVolunteerOrderBy>>;
  where?: Maybe<GradVolunteerBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileVolunteersAggregateArgs = {
  distinct_on?: Maybe<Array<GradVolunteerSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradVolunteerOrderBy>>;
  where?: Maybe<GradVolunteerBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileWorkExperiencesArgs = {
  distinct_on?: Maybe<Array<GradWorkExperienceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradWorkExperienceOrderBy>>;
  where?: Maybe<GradWorkExperienceBoolExp>;
};


/**
 * main student table, each row represents a student profile
 *
 *
 * columns and relationships of "grad.profile"
 */
export type GradProfileWorkExperiencesAggregateArgs = {
  distinct_on?: Maybe<Array<GradWorkExperienceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradWorkExperienceOrderBy>>;
  where?: Maybe<GradWorkExperienceBoolExp>;
};

/** aggregated selection of "grad.profile" */
export type GradProfileAggregate = {
  __typename?: 'grad_profile_aggregate';
  aggregate?: Maybe<GradProfileAggregateFields>;
  nodes: Array<GradProfile>;
};

/** aggregate fields of "grad.profile" */
export type GradProfileAggregateFields = {
  __typename?: 'grad_profile_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradProfileMaxFields>;
  min?: Maybe<GradProfileMinFields>;
};


/** aggregate fields of "grad.profile" */
export type GradProfileAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradProfileSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.profile" */
export type GradProfileAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradProfileMaxOrderBy>;
  min?: Maybe<GradProfileMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.profile" */
export type GradProfileArrRelInsertInput = {
  data: Array<GradProfileInsertInput>;
  on_conflict?: Maybe<GradProfileOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.profile". All fields are combined with a logical 'AND'. */
export type GradProfileBoolExp = {
  _and?: Maybe<Array<Maybe<GradProfileBoolExp>>>;
  _not?: Maybe<GradProfileBoolExp>;
  _or?: Maybe<Array<Maybe<GradProfileBoolExp>>>;
  achievements?: Maybe<GradAchievementBoolExp>;
  activity_summary?: Maybe<GradUserActivitySummaryBoolExp>;
  authorized_to_work?: Maybe<BooleanComparisonExp>;
  awards?: Maybe<GradAwardBoolExp>;
  birth_date?: Maybe<DateComparisonExp>;
  blocked?: Maybe<BooleanComparisonExp>;
  blocked_reason?: Maybe<StringComparisonExp>;
  combine?: Maybe<GradProfileCombineBoolExp>;
  comm_preference?: Maybe<StringComparisonExp>;
  computer_languages?: Maybe<GradComputerLanguageBoolExp>;
  creation_timestamp?: Maybe<TimestamptzComparisonExp>;
  degree_latest?: Maybe<GradDegreeLatestBoolExp>;
  degrees?: Maybe<GradDegreeBoolExp>;
  email?: Maybe<StringComparisonExp>;
  email_verified?: Maybe<BooleanComparisonExp>;
  employer_preferences?: Maybe<GradEmployerPreferenceBoolExp>;
  event_registrations?: Maybe<GradEventRegistrationBoolExp>;
  firstname?: Maybe<StringComparisonExp>;
  fullname?: Maybe<StringComparisonExp>;
  fun_facts?: Maybe<GradFunFactBoolExp>;
  grad_group_members?: Maybe<RecruitGradGroupMemberBoolExp>;
  hometown?: Maybe<StringComparisonExp>;
  interest_firms?: Maybe<GradInterestFirmBoolExp>;
  interest_job_types?: Maybe<GradInterestJobTypeBoolExp>;
  interest_regions?: Maybe<GradInterestRegionBoolExp>;
  interest_roles?: Maybe<GradInterestRoleBoolExp>;
  lastname?: Maybe<StringComparisonExp>;
  legal_residence_country?: Maybe<GradCountrySelectionBoolExp>;
  legal_residence_country_id?: Maybe<StringComparisonExp>;
  middlename?: Maybe<StringComparisonExp>;
  minority_search?: Maybe<BooleanComparisonExp>;
  mobile?: Maybe<StringComparisonExp>;
  mobile_valid?: Maybe<BooleanComparisonExp>;
  need_sponsor?: Maybe<BooleanComparisonExp>;
  prior_internship?: Maybe<BooleanComparisonExp>;
  profile_image?: Maybe<StringComparisonExp>;
  profile_verified?: Maybe<BooleanComparisonExp>;
  raise_hands?: Maybe<GradRaiseHandBoolExp>;
  spoken_languages?: Maybe<GradSpokenLanguageBoolExp>;
  ssn?: Maybe<StringComparisonExp>;
  student_athlete?: Maybe<BooleanComparisonExp>;
  test_scores?: Maybe<GradTestScoreBoolExp>;
  title?: Maybe<StringComparisonExp>;
  upload_docs?: Maybe<GradUploadDocBoolExp>;
  user_id?: Maybe<StringComparisonExp>;
  visa_expiration?: Maybe<DateComparisonExp>;
  visa_status?: Maybe<StringComparisonExp>;
  visa_type?: Maybe<StringComparisonExp>;
  volunteers?: Maybe<GradVolunteerBoolExp>;
  will_relocate?: Maybe<BooleanComparisonExp>;
  wizard_completed?: Maybe<BooleanComparisonExp>;
  wizard_completion_timestamp?: Maybe<TimestamptzComparisonExp>;
  work_experiences?: Maybe<GradWorkExperienceBoolExp>;
  years_of_relevant_work?: Maybe<StringComparisonExp>;
};

/** columns and relationships of "grad.profile_combine" */
export type GradProfileCombine = {
  __typename?: 'grad_profile_combine';
  content?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "grad.profile_combine" */
export type GradProfileCombineAggregate = {
  __typename?: 'grad_profile_combine_aggregate';
  aggregate?: Maybe<GradProfileCombineAggregateFields>;
  nodes: Array<GradProfileCombine>;
};

/** aggregate fields of "grad.profile_combine" */
export type GradProfileCombineAggregateFields = {
  __typename?: 'grad_profile_combine_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradProfileCombineMaxFields>;
  min?: Maybe<GradProfileCombineMinFields>;
};


/** aggregate fields of "grad.profile_combine" */
export type GradProfileCombineAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradProfileCombineSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.profile_combine" */
export type GradProfileCombineAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradProfileCombineMaxOrderBy>;
  min?: Maybe<GradProfileCombineMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.profile_combine" */
export type GradProfileCombineArrRelInsertInput = {
  data: Array<GradProfileCombineInsertInput>;
  on_conflict?: Maybe<GradProfileCombineOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.profile_combine". All fields are combined with a logical 'AND'. */
export type GradProfileCombineBoolExp = {
  _and?: Maybe<Array<Maybe<GradProfileCombineBoolExp>>>;
  _not?: Maybe<GradProfileCombineBoolExp>;
  _or?: Maybe<Array<Maybe<GradProfileCombineBoolExp>>>;
  content?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.profile_combine" */
export enum GradProfileCombineConstraint {
  /** unique or primary key constraint */
  ProfileCombinePkey = 'profile_combine_pkey'
}

/** input type for inserting data into table "grad.profile_combine" */
export type GradProfileCombineInsertInput = {
  content?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradProfileCombineMaxFields = {
  __typename?: 'grad_profile_combine_max_fields';
  content?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.profile_combine" */
export type GradProfileCombineMaxOrderBy = {
  content?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradProfileCombineMinFields = {
  __typename?: 'grad_profile_combine_min_fields';
  content?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.profile_combine" */
export type GradProfileCombineMinOrderBy = {
  content?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.profile_combine" */
export type GradProfileCombineMutationResponse = {
  __typename?: 'grad_profile_combine_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradProfileCombine>;
};

/** input type for inserting object relation for remote table "grad.profile_combine" */
export type GradProfileCombineObjRelInsertInput = {
  data: GradProfileCombineInsertInput;
  on_conflict?: Maybe<GradProfileCombineOnConflict>;
};

/** on conflict condition type for table "grad.profile_combine" */
export type GradProfileCombineOnConflict = {
  constraint: GradProfileCombineConstraint;
  update_columns: Array<GradProfileCombineUpdateColumn>;
  where?: Maybe<GradProfileCombineBoolExp>;
};

/** ordering options when selecting data from "grad.profile_combine" */
export type GradProfileCombineOrderBy = {
  content?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** select columns of table "grad.profile_combine" */
export enum GradProfileCombineSelectColumn {
  /** column name */
  Content = 'content',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "grad.profile_combine" */
export type GradProfileCombineSetInput = {
  content?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.profile_combine" */
export enum GradProfileCombineUpdateColumn {
  /** column name */
  Content = 'content',
  /** column name */
  UserId = 'user_id'
}

/** unique or primary key constraints on table "grad.profile" */
export enum GradProfileConstraint {
  /** unique or primary key constraint */
  ProfilePkey = 'profile_pkey',
  /** unique or primary key constraint */
  ProfileUseridKey = 'profile_userid_key'
}

/** input type for inserting data into table "grad.profile" */
export type GradProfileInsertInput = {
  achievements?: Maybe<GradAchievementArrRelInsertInput>;
  activity_summary?: Maybe<GradUserActivitySummaryObjRelInsertInput>;
  authorized_to_work?: Maybe<Scalars['Boolean']>;
  awards?: Maybe<GradAwardArrRelInsertInput>;
  birth_date?: Maybe<Scalars['date']>;
  blocked?: Maybe<Scalars['Boolean']>;
  blocked_reason?: Maybe<Scalars['String']>;
  combine?: Maybe<GradProfileCombineObjRelInsertInput>;
  comm_preference?: Maybe<Scalars['String']>;
  computer_languages?: Maybe<GradComputerLanguageArrRelInsertInput>;
  creation_timestamp?: Maybe<Scalars['timestamptz']>;
  degrees?: Maybe<GradDegreeArrRelInsertInput>;
  email?: Maybe<Scalars['String']>;
  email_verified?: Maybe<Scalars['Boolean']>;
  employer_preferences?: Maybe<GradEmployerPreferenceArrRelInsertInput>;
  event_registrations?: Maybe<GradEventRegistrationArrRelInsertInput>;
  firstname?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  fun_facts?: Maybe<GradFunFactArrRelInsertInput>;
  grad_group_members?: Maybe<RecruitGradGroupMemberArrRelInsertInput>;
  hometown?: Maybe<Scalars['String']>;
  interest_firms?: Maybe<GradInterestFirmArrRelInsertInput>;
  interest_job_types?: Maybe<GradInterestJobTypeArrRelInsertInput>;
  interest_regions?: Maybe<GradInterestRegionArrRelInsertInput>;
  interest_roles?: Maybe<GradInterestRoleArrRelInsertInput>;
  lastname?: Maybe<Scalars['String']>;
  legal_residence_country?: Maybe<GradCountrySelectionObjRelInsertInput>;
  legal_residence_country_id?: Maybe<Scalars['String']>;
  middlename?: Maybe<Scalars['String']>;
  minority_search?: Maybe<Scalars['Boolean']>;
  mobile?: Maybe<Scalars['String']>;
  mobile_valid?: Maybe<Scalars['Boolean']>;
  need_sponsor?: Maybe<Scalars['Boolean']>;
  prior_internship?: Maybe<Scalars['Boolean']>;
  profile_image?: Maybe<Scalars['String']>;
  profile_verified?: Maybe<Scalars['Boolean']>;
  raise_hands?: Maybe<GradRaiseHandArrRelInsertInput>;
  spoken_languages?: Maybe<GradSpokenLanguageArrRelInsertInput>;
  ssn?: Maybe<Scalars['String']>;
  student_athlete?: Maybe<Scalars['Boolean']>;
  test_scores?: Maybe<GradTestScoreArrRelInsertInput>;
  title?: Maybe<Scalars['String']>;
  upload_docs?: Maybe<GradUploadDocArrRelInsertInput>;
  user_id?: Maybe<Scalars['String']>;
  visa_expiration?: Maybe<Scalars['date']>;
  visa_status?: Maybe<Scalars['String']>;
  visa_type?: Maybe<Scalars['String']>;
  volunteers?: Maybe<GradVolunteerArrRelInsertInput>;
  will_relocate?: Maybe<Scalars['Boolean']>;
  wizard_completed?: Maybe<Scalars['Boolean']>;
  wizard_completion_timestamp?: Maybe<Scalars['timestamptz']>;
  work_experiences?: Maybe<GradWorkExperienceArrRelInsertInput>;
  years_of_relevant_work?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradProfileMaxFields = {
  __typename?: 'grad_profile_max_fields';
  birth_date?: Maybe<Scalars['date']>;
  blocked_reason?: Maybe<Scalars['String']>;
  comm_preference?: Maybe<Scalars['String']>;
  creation_timestamp?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  hometown?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  legal_residence_country_id?: Maybe<Scalars['String']>;
  middlename?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  profile_image?: Maybe<Scalars['String']>;
  ssn?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  visa_expiration?: Maybe<Scalars['date']>;
  visa_status?: Maybe<Scalars['String']>;
  visa_type?: Maybe<Scalars['String']>;
  wizard_completion_timestamp?: Maybe<Scalars['timestamptz']>;
  years_of_relevant_work?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.profile" */
export type GradProfileMaxOrderBy = {
  birth_date?: Maybe<OrderBy>;
  blocked_reason?: Maybe<OrderBy>;
  comm_preference?: Maybe<OrderBy>;
  creation_timestamp?: Maybe<OrderBy>;
  email?: Maybe<OrderBy>;
  firstname?: Maybe<OrderBy>;
  fullname?: Maybe<OrderBy>;
  hometown?: Maybe<OrderBy>;
  lastname?: Maybe<OrderBy>;
  legal_residence_country_id?: Maybe<OrderBy>;
  middlename?: Maybe<OrderBy>;
  mobile?: Maybe<OrderBy>;
  profile_image?: Maybe<OrderBy>;
  ssn?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  visa_expiration?: Maybe<OrderBy>;
  visa_status?: Maybe<OrderBy>;
  visa_type?: Maybe<OrderBy>;
  wizard_completion_timestamp?: Maybe<OrderBy>;
  years_of_relevant_work?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradProfileMinFields = {
  __typename?: 'grad_profile_min_fields';
  birth_date?: Maybe<Scalars['date']>;
  blocked_reason?: Maybe<Scalars['String']>;
  comm_preference?: Maybe<Scalars['String']>;
  creation_timestamp?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  hometown?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  legal_residence_country_id?: Maybe<Scalars['String']>;
  middlename?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  profile_image?: Maybe<Scalars['String']>;
  ssn?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  visa_expiration?: Maybe<Scalars['date']>;
  visa_status?: Maybe<Scalars['String']>;
  visa_type?: Maybe<Scalars['String']>;
  wizard_completion_timestamp?: Maybe<Scalars['timestamptz']>;
  years_of_relevant_work?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.profile" */
export type GradProfileMinOrderBy = {
  birth_date?: Maybe<OrderBy>;
  blocked_reason?: Maybe<OrderBy>;
  comm_preference?: Maybe<OrderBy>;
  creation_timestamp?: Maybe<OrderBy>;
  email?: Maybe<OrderBy>;
  firstname?: Maybe<OrderBy>;
  fullname?: Maybe<OrderBy>;
  hometown?: Maybe<OrderBy>;
  lastname?: Maybe<OrderBy>;
  legal_residence_country_id?: Maybe<OrderBy>;
  middlename?: Maybe<OrderBy>;
  mobile?: Maybe<OrderBy>;
  profile_image?: Maybe<OrderBy>;
  ssn?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  visa_expiration?: Maybe<OrderBy>;
  visa_status?: Maybe<OrderBy>;
  visa_type?: Maybe<OrderBy>;
  wizard_completion_timestamp?: Maybe<OrderBy>;
  years_of_relevant_work?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.profile" */
export type GradProfileMutationResponse = {
  __typename?: 'grad_profile_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradProfile>;
};

/** input type for inserting object relation for remote table "grad.profile" */
export type GradProfileObjRelInsertInput = {
  data: GradProfileInsertInput;
  on_conflict?: Maybe<GradProfileOnConflict>;
};

/** on conflict condition type for table "grad.profile" */
export type GradProfileOnConflict = {
  constraint: GradProfileConstraint;
  update_columns: Array<GradProfileUpdateColumn>;
  where?: Maybe<GradProfileBoolExp>;
};

/** ordering options when selecting data from "grad.profile" */
export type GradProfileOrderBy = {
  achievements_aggregate?: Maybe<GradAchievementAggregateOrderBy>;
  activity_summary?: Maybe<GradUserActivitySummaryOrderBy>;
  authorized_to_work?: Maybe<OrderBy>;
  awards_aggregate?: Maybe<GradAwardAggregateOrderBy>;
  birth_date?: Maybe<OrderBy>;
  blocked?: Maybe<OrderBy>;
  blocked_reason?: Maybe<OrderBy>;
  combine?: Maybe<GradProfileCombineOrderBy>;
  comm_preference?: Maybe<OrderBy>;
  computer_languages_aggregate?: Maybe<GradComputerLanguageAggregateOrderBy>;
  creation_timestamp?: Maybe<OrderBy>;
  degree_latest?: Maybe<GradDegreeLatestOrderBy>;
  degrees_aggregate?: Maybe<GradDegreeAggregateOrderBy>;
  email?: Maybe<OrderBy>;
  email_verified?: Maybe<OrderBy>;
  employer_preferences_aggregate?: Maybe<GradEmployerPreferenceAggregateOrderBy>;
  event_registrations_aggregate?: Maybe<GradEventRegistrationAggregateOrderBy>;
  firstname?: Maybe<OrderBy>;
  fullname?: Maybe<OrderBy>;
  fun_facts_aggregate?: Maybe<GradFunFactAggregateOrderBy>;
  grad_group_members_aggregate?: Maybe<RecruitGradGroupMemberAggregateOrderBy>;
  hometown?: Maybe<OrderBy>;
  interest_firms_aggregate?: Maybe<GradInterestFirmAggregateOrderBy>;
  interest_job_types_aggregate?: Maybe<GradInterestJobTypeAggregateOrderBy>;
  interest_regions_aggregate?: Maybe<GradInterestRegionAggregateOrderBy>;
  interest_roles_aggregate?: Maybe<GradInterestRoleAggregateOrderBy>;
  lastname?: Maybe<OrderBy>;
  legal_residence_country?: Maybe<GradCountrySelectionOrderBy>;
  legal_residence_country_id?: Maybe<OrderBy>;
  middlename?: Maybe<OrderBy>;
  minority_search?: Maybe<OrderBy>;
  mobile?: Maybe<OrderBy>;
  mobile_valid?: Maybe<OrderBy>;
  need_sponsor?: Maybe<OrderBy>;
  prior_internship?: Maybe<OrderBy>;
  profile_image?: Maybe<OrderBy>;
  profile_verified?: Maybe<OrderBy>;
  raise_hands_aggregate?: Maybe<GradRaiseHandAggregateOrderBy>;
  spoken_languages_aggregate?: Maybe<GradSpokenLanguageAggregateOrderBy>;
  ssn?: Maybe<OrderBy>;
  student_athlete?: Maybe<OrderBy>;
  test_scores_aggregate?: Maybe<GradTestScoreAggregateOrderBy>;
  title?: Maybe<OrderBy>;
  upload_docs_aggregate?: Maybe<GradUploadDocAggregateOrderBy>;
  user_id?: Maybe<OrderBy>;
  visa_expiration?: Maybe<OrderBy>;
  visa_status?: Maybe<OrderBy>;
  visa_type?: Maybe<OrderBy>;
  volunteers_aggregate?: Maybe<GradVolunteerAggregateOrderBy>;
  will_relocate?: Maybe<OrderBy>;
  wizard_completed?: Maybe<OrderBy>;
  wizard_completion_timestamp?: Maybe<OrderBy>;
  work_experiences_aggregate?: Maybe<GradWorkExperienceAggregateOrderBy>;
  years_of_relevant_work?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.profile" */
export type GradProfilePkColumnsInput = {
  /** primary key of profile, same as auth0 sub */
  user_id: Scalars['String'];
};

/** select columns of table "grad.profile" */
export enum GradProfileSelectColumn {
  /** column name */
  AuthorizedToWork = 'authorized_to_work',
  /** column name */
  BirthDate = 'birth_date',
  /** column name */
  Blocked = 'blocked',
  /** column name */
  BlockedReason = 'blocked_reason',
  /** column name */
  CommPreference = 'comm_preference',
  /** column name */
  CreationTimestamp = 'creation_timestamp',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  Firstname = 'firstname',
  /** column name */
  Fullname = 'fullname',
  /** column name */
  Hometown = 'hometown',
  /** column name */
  Lastname = 'lastname',
  /** column name */
  LegalResidenceCountryId = 'legal_residence_country_id',
  /** column name */
  Middlename = 'middlename',
  /** column name */
  MinoritySearch = 'minority_search',
  /** column name */
  Mobile = 'mobile',
  /** column name */
  MobileValid = 'mobile_valid',
  /** column name */
  NeedSponsor = 'need_sponsor',
  /** column name */
  PriorInternship = 'prior_internship',
  /** column name */
  ProfileImage = 'profile_image',
  /** column name */
  ProfileVerified = 'profile_verified',
  /** column name */
  Ssn = 'ssn',
  /** column name */
  StudentAthlete = 'student_athlete',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VisaExpiration = 'visa_expiration',
  /** column name */
  VisaStatus = 'visa_status',
  /** column name */
  VisaType = 'visa_type',
  /** column name */
  WillRelocate = 'will_relocate',
  /** column name */
  WizardCompleted = 'wizard_completed',
  /** column name */
  WizardCompletionTimestamp = 'wizard_completion_timestamp',
  /** column name */
  YearsOfRelevantWork = 'years_of_relevant_work'
}

/** input type for updating data in table "grad.profile" */
export type GradProfileSetInput = {
  authorized_to_work?: Maybe<Scalars['Boolean']>;
  birth_date?: Maybe<Scalars['date']>;
  blocked?: Maybe<Scalars['Boolean']>;
  blocked_reason?: Maybe<Scalars['String']>;
  comm_preference?: Maybe<Scalars['String']>;
  creation_timestamp?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  email_verified?: Maybe<Scalars['Boolean']>;
  firstname?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  hometown?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  legal_residence_country_id?: Maybe<Scalars['String']>;
  middlename?: Maybe<Scalars['String']>;
  minority_search?: Maybe<Scalars['Boolean']>;
  mobile?: Maybe<Scalars['String']>;
  mobile_valid?: Maybe<Scalars['Boolean']>;
  need_sponsor?: Maybe<Scalars['Boolean']>;
  prior_internship?: Maybe<Scalars['Boolean']>;
  profile_image?: Maybe<Scalars['String']>;
  profile_verified?: Maybe<Scalars['Boolean']>;
  ssn?: Maybe<Scalars['String']>;
  student_athlete?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  visa_expiration?: Maybe<Scalars['date']>;
  visa_status?: Maybe<Scalars['String']>;
  visa_type?: Maybe<Scalars['String']>;
  will_relocate?: Maybe<Scalars['Boolean']>;
  wizard_completed?: Maybe<Scalars['Boolean']>;
  wizard_completion_timestamp?: Maybe<Scalars['timestamptz']>;
  years_of_relevant_work?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.profile" */
export enum GradProfileUpdateColumn {
  /** column name */
  AuthorizedToWork = 'authorized_to_work',
  /** column name */
  BirthDate = 'birth_date',
  /** column name */
  Blocked = 'blocked',
  /** column name */
  BlockedReason = 'blocked_reason',
  /** column name */
  CommPreference = 'comm_preference',
  /** column name */
  CreationTimestamp = 'creation_timestamp',
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  Firstname = 'firstname',
  /** column name */
  Fullname = 'fullname',
  /** column name */
  Hometown = 'hometown',
  /** column name */
  Lastname = 'lastname',
  /** column name */
  LegalResidenceCountryId = 'legal_residence_country_id',
  /** column name */
  Middlename = 'middlename',
  /** column name */
  MinoritySearch = 'minority_search',
  /** column name */
  Mobile = 'mobile',
  /** column name */
  MobileValid = 'mobile_valid',
  /** column name */
  NeedSponsor = 'need_sponsor',
  /** column name */
  PriorInternship = 'prior_internship',
  /** column name */
  ProfileImage = 'profile_image',
  /** column name */
  ProfileVerified = 'profile_verified',
  /** column name */
  Ssn = 'ssn',
  /** column name */
  StudentAthlete = 'student_athlete',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VisaExpiration = 'visa_expiration',
  /** column name */
  VisaStatus = 'visa_status',
  /** column name */
  VisaType = 'visa_type',
  /** column name */
  WillRelocate = 'will_relocate',
  /** column name */
  WizardCompleted = 'wizard_completed',
  /** column name */
  WizardCompletionTimestamp = 'wizard_completion_timestamp',
  /** column name */
  YearsOfRelevantWork = 'years_of_relevant_work'
}

/**
 * stores student raised hands to jobs
 *
 *
 * columns and relationships of "grad.raise_hand"
 */
export type GradRaiseHand = {
  __typename?: 'grad_raise_hand';
  /** An object relationship */
  job_posting: RecruitJobPosting;
  /** maps to job_posting.job_posting_id */
  job_posting_id: Scalars['String'];
  /** An object relationship */
  profile: GradProfile;
  /** auto-generated uuid */
  raise__hand_id: Scalars['String'];
  /** timestamp when hand is raised */
  timestamp: Scalars['timestamptz'];
  /** maps to profile.user_id */
  user_id: Scalars['String'];
};

/** aggregated selection of "grad.raise_hand" */
export type GradRaiseHandAggregate = {
  __typename?: 'grad_raise_hand_aggregate';
  aggregate?: Maybe<GradRaiseHandAggregateFields>;
  nodes: Array<GradRaiseHand>;
};

/** aggregate fields of "grad.raise_hand" */
export type GradRaiseHandAggregateFields = {
  __typename?: 'grad_raise_hand_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradRaiseHandMaxFields>;
  min?: Maybe<GradRaiseHandMinFields>;
};


/** aggregate fields of "grad.raise_hand" */
export type GradRaiseHandAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradRaiseHandSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.raise_hand" */
export type GradRaiseHandAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradRaiseHandMaxOrderBy>;
  min?: Maybe<GradRaiseHandMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.raise_hand" */
export type GradRaiseHandArrRelInsertInput = {
  data: Array<GradRaiseHandInsertInput>;
  on_conflict?: Maybe<GradRaiseHandOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.raise_hand". All fields are combined with a logical 'AND'. */
export type GradRaiseHandBoolExp = {
  _and?: Maybe<Array<Maybe<GradRaiseHandBoolExp>>>;
  _not?: Maybe<GradRaiseHandBoolExp>;
  _or?: Maybe<Array<Maybe<GradRaiseHandBoolExp>>>;
  job_posting?: Maybe<RecruitJobPostingBoolExp>;
  job_posting_id?: Maybe<StringComparisonExp>;
  profile?: Maybe<GradProfileBoolExp>;
  raise__hand_id?: Maybe<StringComparisonExp>;
  timestamp?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.raise_hand" */
export enum GradRaiseHandConstraint {
  /** unique or primary key constraint */
  RaiseHandJobPostingIdUserIdKey = 'raise_hand_job_posting_id_user_id_key',
  /** unique or primary key constraint */
  RaiseHandPkey = 'raise_hand_pkey',
  /** unique or primary key constraint */
  RaiseHandRaiseHandIdKey = 'raise_hand_raise__hand_id_key'
}

/** input type for inserting data into table "grad.raise_hand" */
export type GradRaiseHandInsertInput = {
  job_posting?: Maybe<RecruitJobPostingObjRelInsertInput>;
  job_posting_id?: Maybe<Scalars['String']>;
  profile?: Maybe<GradProfileObjRelInsertInput>;
  raise__hand_id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradRaiseHandMaxFields = {
  __typename?: 'grad_raise_hand_max_fields';
  job_posting_id?: Maybe<Scalars['String']>;
  raise__hand_id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.raise_hand" */
export type GradRaiseHandMaxOrderBy = {
  job_posting_id?: Maybe<OrderBy>;
  raise__hand_id?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradRaiseHandMinFields = {
  __typename?: 'grad_raise_hand_min_fields';
  job_posting_id?: Maybe<Scalars['String']>;
  raise__hand_id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.raise_hand" */
export type GradRaiseHandMinOrderBy = {
  job_posting_id?: Maybe<OrderBy>;
  raise__hand_id?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.raise_hand" */
export type GradRaiseHandMutationResponse = {
  __typename?: 'grad_raise_hand_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradRaiseHand>;
};

/** input type for inserting object relation for remote table "grad.raise_hand" */
export type GradRaiseHandObjRelInsertInput = {
  data: GradRaiseHandInsertInput;
  on_conflict?: Maybe<GradRaiseHandOnConflict>;
};

/** on conflict condition type for table "grad.raise_hand" */
export type GradRaiseHandOnConflict = {
  constraint: GradRaiseHandConstraint;
  update_columns: Array<GradRaiseHandUpdateColumn>;
  where?: Maybe<GradRaiseHandBoolExp>;
};

/** ordering options when selecting data from "grad.raise_hand" */
export type GradRaiseHandOrderBy = {
  job_posting?: Maybe<RecruitJobPostingOrderBy>;
  job_posting_id?: Maybe<OrderBy>;
  profile?: Maybe<GradProfileOrderBy>;
  raise__hand_id?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.raise_hand" */
export type GradRaiseHandPkColumnsInput = {
  /** auto-generated uuid */
  raise__hand_id: Scalars['String'];
};

/** select columns of table "grad.raise_hand" */
export enum GradRaiseHandSelectColumn {
  /** column name */
  JobPostingId = 'job_posting_id',
  /** column name */
  RaiseHandId = 'raise__hand_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "grad.raise_hand" */
export type GradRaiseHandSetInput = {
  job_posting_id?: Maybe<Scalars['String']>;
  raise__hand_id?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.raise_hand" */
export enum GradRaiseHandUpdateColumn {
  /** column name */
  JobPostingId = 'job_posting_id',
  /** column name */
  RaiseHandId = 'raise__hand_id',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  UserId = 'user_id'
}

/**
 * stores student spoken languages
 *
 *
 * columns and relationships of "grad.spoken_language"
 */
export type GradSpokenLanguage = {
  __typename?: 'grad_spoken_language';
  /** language */
  language: Scalars['String'];
  /** auto-generated uuid */
  spoken_language_id: Scalars['String'];
  /** maps to profile.user_id */
  user_id: Scalars['String'];
};

/** aggregated selection of "grad.spoken_language" */
export type GradSpokenLanguageAggregate = {
  __typename?: 'grad_spoken_language_aggregate';
  aggregate?: Maybe<GradSpokenLanguageAggregateFields>;
  nodes: Array<GradSpokenLanguage>;
};

/** aggregate fields of "grad.spoken_language" */
export type GradSpokenLanguageAggregateFields = {
  __typename?: 'grad_spoken_language_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradSpokenLanguageMaxFields>;
  min?: Maybe<GradSpokenLanguageMinFields>;
};


/** aggregate fields of "grad.spoken_language" */
export type GradSpokenLanguageAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradSpokenLanguageSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.spoken_language" */
export type GradSpokenLanguageAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradSpokenLanguageMaxOrderBy>;
  min?: Maybe<GradSpokenLanguageMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.spoken_language" */
export type GradSpokenLanguageArrRelInsertInput = {
  data: Array<GradSpokenLanguageInsertInput>;
  on_conflict?: Maybe<GradSpokenLanguageOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.spoken_language". All fields are combined with a logical 'AND'. */
export type GradSpokenLanguageBoolExp = {
  _and?: Maybe<Array<Maybe<GradSpokenLanguageBoolExp>>>;
  _not?: Maybe<GradSpokenLanguageBoolExp>;
  _or?: Maybe<Array<Maybe<GradSpokenLanguageBoolExp>>>;
  language?: Maybe<StringComparisonExp>;
  spoken_language_id?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.spoken_language" */
export enum GradSpokenLanguageConstraint {
  /** unique or primary key constraint */
  SpokenLanguagePkey = 'spoken_language_pkey',
  /** unique or primary key constraint */
  SpokenLanguageSpokenLanguageIdKey = 'spoken_language_spoken_language_id_key',
  /** unique or primary key constraint */
  SpokenLanguageUserIdLanguageKey = 'spoken_language_user_id_language_key'
}

/** input type for inserting data into table "grad.spoken_language" */
export type GradSpokenLanguageInsertInput = {
  language?: Maybe<Scalars['String']>;
  spoken_language_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradSpokenLanguageMaxFields = {
  __typename?: 'grad_spoken_language_max_fields';
  language?: Maybe<Scalars['String']>;
  spoken_language_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.spoken_language" */
export type GradSpokenLanguageMaxOrderBy = {
  language?: Maybe<OrderBy>;
  spoken_language_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradSpokenLanguageMinFields = {
  __typename?: 'grad_spoken_language_min_fields';
  language?: Maybe<Scalars['String']>;
  spoken_language_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.spoken_language" */
export type GradSpokenLanguageMinOrderBy = {
  language?: Maybe<OrderBy>;
  spoken_language_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.spoken_language" */
export type GradSpokenLanguageMutationResponse = {
  __typename?: 'grad_spoken_language_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradSpokenLanguage>;
};

/** input type for inserting object relation for remote table "grad.spoken_language" */
export type GradSpokenLanguageObjRelInsertInput = {
  data: GradSpokenLanguageInsertInput;
  on_conflict?: Maybe<GradSpokenLanguageOnConflict>;
};

/** on conflict condition type for table "grad.spoken_language" */
export type GradSpokenLanguageOnConflict = {
  constraint: GradSpokenLanguageConstraint;
  update_columns: Array<GradSpokenLanguageUpdateColumn>;
  where?: Maybe<GradSpokenLanguageBoolExp>;
};

/** ordering options when selecting data from "grad.spoken_language" */
export type GradSpokenLanguageOrderBy = {
  language?: Maybe<OrderBy>;
  spoken_language_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.spoken_language" */
export type GradSpokenLanguagePkColumnsInput = {
  /** auto-generated uuid */
  spoken_language_id: Scalars['String'];
};

/** select columns of table "grad.spoken_language" */
export enum GradSpokenLanguageSelectColumn {
  /** column name */
  Language = 'language',
  /** column name */
  SpokenLanguageId = 'spoken_language_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "grad.spoken_language" */
export type GradSpokenLanguageSetInput = {
  language?: Maybe<Scalars['String']>;
  spoken_language_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.spoken_language" */
export enum GradSpokenLanguageUpdateColumn {
  /** column name */
  Language = 'language',
  /** column name */
  SpokenLanguageId = 'spoken_language_id',
  /** column name */
  UserId = 'user_id'
}

/**
 * stores student test scores such as SAT GRE
 *
 *
 * columns and relationships of "grad.test_score"
 */
export type GradTestScore = {
  __typename?: 'grad_test_score';
  /** date the test is taking, likely not used */
  date?: Maybe<Scalars['date']>;
  /** what is the maximum score of this test */
  outof?: Maybe<Scalars['Int']>;
  /** what total score did the student get */
  score: Scalars['Int'];
  /** which test: SAT, GRE, GMAT etc. */
  test: Scalars['String'];
  /** An array relationship */
  test_score_details: Array<GradTestScoreDetail>;
  /** An aggregated array relationship */
  test_score_details_aggregate: GradTestScoreDetailAggregate;
  /** auto-generated uuid */
  test_score_id: Scalars['String'];
  /** maps to profile.user_id */
  user_id: Scalars['String'];
};


/**
 * stores student test scores such as SAT GRE
 *
 *
 * columns and relationships of "grad.test_score"
 */
export type GradTestScoreTestScoreDetailsArgs = {
  distinct_on?: Maybe<Array<GradTestScoreDetailSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradTestScoreDetailOrderBy>>;
  where?: Maybe<GradTestScoreDetailBoolExp>;
};


/**
 * stores student test scores such as SAT GRE
 *
 *
 * columns and relationships of "grad.test_score"
 */
export type GradTestScoreTestScoreDetailsAggregateArgs = {
  distinct_on?: Maybe<Array<GradTestScoreDetailSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradTestScoreDetailOrderBy>>;
  where?: Maybe<GradTestScoreDetailBoolExp>;
};

/** aggregated selection of "grad.test_score" */
export type GradTestScoreAggregate = {
  __typename?: 'grad_test_score_aggregate';
  aggregate?: Maybe<GradTestScoreAggregateFields>;
  nodes: Array<GradTestScore>;
};

/** aggregate fields of "grad.test_score" */
export type GradTestScoreAggregateFields = {
  __typename?: 'grad_test_score_aggregate_fields';
  avg?: Maybe<GradTestScoreAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradTestScoreMaxFields>;
  min?: Maybe<GradTestScoreMinFields>;
  stddev?: Maybe<GradTestScoreStddevFields>;
  stddev_pop?: Maybe<GradTestScoreStddevPopFields>;
  stddev_samp?: Maybe<GradTestScoreStddevSampFields>;
  sum?: Maybe<GradTestScoreSumFields>;
  var_pop?: Maybe<GradTestScoreVarPopFields>;
  var_samp?: Maybe<GradTestScoreVarSampFields>;
  variance?: Maybe<GradTestScoreVarianceFields>;
};


/** aggregate fields of "grad.test_score" */
export type GradTestScoreAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradTestScoreSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.test_score" */
export type GradTestScoreAggregateOrderBy = {
  avg?: Maybe<GradTestScoreAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<GradTestScoreMaxOrderBy>;
  min?: Maybe<GradTestScoreMinOrderBy>;
  stddev?: Maybe<GradTestScoreStddevOrderBy>;
  stddev_pop?: Maybe<GradTestScoreStddevPopOrderBy>;
  stddev_samp?: Maybe<GradTestScoreStddevSampOrderBy>;
  sum?: Maybe<GradTestScoreSumOrderBy>;
  var_pop?: Maybe<GradTestScoreVarPopOrderBy>;
  var_samp?: Maybe<GradTestScoreVarSampOrderBy>;
  variance?: Maybe<GradTestScoreVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "grad.test_score" */
export type GradTestScoreArrRelInsertInput = {
  data: Array<GradTestScoreInsertInput>;
  on_conflict?: Maybe<GradTestScoreOnConflict>;
};

/** aggregate avg on columns */
export type GradTestScoreAvgFields = {
  __typename?: 'grad_test_score_avg_fields';
  outof?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "grad.test_score" */
export type GradTestScoreAvgOrderBy = {
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "grad.test_score". All fields are combined with a logical 'AND'. */
export type GradTestScoreBoolExp = {
  _and?: Maybe<Array<Maybe<GradTestScoreBoolExp>>>;
  _not?: Maybe<GradTestScoreBoolExp>;
  _or?: Maybe<Array<Maybe<GradTestScoreBoolExp>>>;
  date?: Maybe<DateComparisonExp>;
  outof?: Maybe<IntComparisonExp>;
  score?: Maybe<IntComparisonExp>;
  test?: Maybe<StringComparisonExp>;
  test_score_details?: Maybe<GradTestScoreDetailBoolExp>;
  test_score_id?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.test_score" */
export enum GradTestScoreConstraint {
  /** unique or primary key constraint */
  TestScorePkey = 'test_score_pkey',
  /** unique or primary key constraint */
  TestScoreTestScoreIdKey = 'test_score_test_score_id_key',
  /** unique or primary key constraint */
  TestScoreUserIdTestKey = 'test_score_user_id_test_key',
  /** unique or primary key constraint */
  TestScoreUserIdTestScoreIdKey = 'test_score_user_id_test_score_id_key'
}

/**
 * stores student test score breakdowns
 *
 *
 * columns and relationships of "grad.test_score_detail"
 */
export type GradTestScoreDetail = {
  __typename?: 'grad_test_score_detail';
  /** which subject, e.g. Verbal, Math */
  detail: Scalars['String'];
  /** maximum possible score for this subject */
  outof: Scalars['Int'];
  /** what score did the student get for this subject */
  score: Scalars['Int'];
  /** deprecated. maps to test_score.test */
  test?: Maybe<Scalars['String']>;
  /** auto-generated uuid */
  test_score_detail_id: Scalars['String'];
  test_score_id: Scalars['String'];
  /** profile.user_id */
  user_id: Scalars['String'];
};

/** aggregated selection of "grad.test_score_detail" */
export type GradTestScoreDetailAggregate = {
  __typename?: 'grad_test_score_detail_aggregate';
  aggregate?: Maybe<GradTestScoreDetailAggregateFields>;
  nodes: Array<GradTestScoreDetail>;
};

/** aggregate fields of "grad.test_score_detail" */
export type GradTestScoreDetailAggregateFields = {
  __typename?: 'grad_test_score_detail_aggregate_fields';
  avg?: Maybe<GradTestScoreDetailAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradTestScoreDetailMaxFields>;
  min?: Maybe<GradTestScoreDetailMinFields>;
  stddev?: Maybe<GradTestScoreDetailStddevFields>;
  stddev_pop?: Maybe<GradTestScoreDetailStddevPopFields>;
  stddev_samp?: Maybe<GradTestScoreDetailStddevSampFields>;
  sum?: Maybe<GradTestScoreDetailSumFields>;
  var_pop?: Maybe<GradTestScoreDetailVarPopFields>;
  var_samp?: Maybe<GradTestScoreDetailVarSampFields>;
  variance?: Maybe<GradTestScoreDetailVarianceFields>;
};


/** aggregate fields of "grad.test_score_detail" */
export type GradTestScoreDetailAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradTestScoreDetailSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.test_score_detail" */
export type GradTestScoreDetailAggregateOrderBy = {
  avg?: Maybe<GradTestScoreDetailAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<GradTestScoreDetailMaxOrderBy>;
  min?: Maybe<GradTestScoreDetailMinOrderBy>;
  stddev?: Maybe<GradTestScoreDetailStddevOrderBy>;
  stddev_pop?: Maybe<GradTestScoreDetailStddevPopOrderBy>;
  stddev_samp?: Maybe<GradTestScoreDetailStddevSampOrderBy>;
  sum?: Maybe<GradTestScoreDetailSumOrderBy>;
  var_pop?: Maybe<GradTestScoreDetailVarPopOrderBy>;
  var_samp?: Maybe<GradTestScoreDetailVarSampOrderBy>;
  variance?: Maybe<GradTestScoreDetailVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "grad.test_score_detail" */
export type GradTestScoreDetailArrRelInsertInput = {
  data: Array<GradTestScoreDetailInsertInput>;
  on_conflict?: Maybe<GradTestScoreDetailOnConflict>;
};

/** aggregate avg on columns */
export type GradTestScoreDetailAvgFields = {
  __typename?: 'grad_test_score_detail_avg_fields';
  outof?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "grad.test_score_detail" */
export type GradTestScoreDetailAvgOrderBy = {
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "grad.test_score_detail". All fields are combined with a logical 'AND'. */
export type GradTestScoreDetailBoolExp = {
  _and?: Maybe<Array<Maybe<GradTestScoreDetailBoolExp>>>;
  _not?: Maybe<GradTestScoreDetailBoolExp>;
  _or?: Maybe<Array<Maybe<GradTestScoreDetailBoolExp>>>;
  detail?: Maybe<StringComparisonExp>;
  outof?: Maybe<IntComparisonExp>;
  score?: Maybe<IntComparisonExp>;
  test?: Maybe<StringComparisonExp>;
  test_score_detail_id?: Maybe<StringComparisonExp>;
  test_score_id?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.test_score_detail" */
export enum GradTestScoreDetailConstraint {
  /** unique or primary key constraint */
  TestScoreDetailPkey = 'test_score_detail_pkey',
  /** unique or primary key constraint */
  TestScoreDetailTestScoreDetailIdKey = 'test_score_detail_test_score_detail_id_key',
  /** unique or primary key constraint */
  TestScoreDetailUserIdTestScoreIdDetailKey = 'test_score_detail_user_id_test_score_id_detail_key'
}

/** input type for incrementing integer column in table "grad.test_score_detail" */
export type GradTestScoreDetailIncInput = {
  outof?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "grad.test_score_detail" */
export type GradTestScoreDetailInsertInput = {
  detail?: Maybe<Scalars['String']>;
  outof?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  test?: Maybe<Scalars['String']>;
  test_score_detail_id?: Maybe<Scalars['String']>;
  test_score_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradTestScoreDetailMaxFields = {
  __typename?: 'grad_test_score_detail_max_fields';
  detail?: Maybe<Scalars['String']>;
  outof?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  test?: Maybe<Scalars['String']>;
  test_score_detail_id?: Maybe<Scalars['String']>;
  test_score_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.test_score_detail" */
export type GradTestScoreDetailMaxOrderBy = {
  detail?: Maybe<OrderBy>;
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
  test?: Maybe<OrderBy>;
  test_score_detail_id?: Maybe<OrderBy>;
  test_score_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradTestScoreDetailMinFields = {
  __typename?: 'grad_test_score_detail_min_fields';
  detail?: Maybe<Scalars['String']>;
  outof?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  test?: Maybe<Scalars['String']>;
  test_score_detail_id?: Maybe<Scalars['String']>;
  test_score_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.test_score_detail" */
export type GradTestScoreDetailMinOrderBy = {
  detail?: Maybe<OrderBy>;
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
  test?: Maybe<OrderBy>;
  test_score_detail_id?: Maybe<OrderBy>;
  test_score_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.test_score_detail" */
export type GradTestScoreDetailMutationResponse = {
  __typename?: 'grad_test_score_detail_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradTestScoreDetail>;
};

/** input type for inserting object relation for remote table "grad.test_score_detail" */
export type GradTestScoreDetailObjRelInsertInput = {
  data: GradTestScoreDetailInsertInput;
  on_conflict?: Maybe<GradTestScoreDetailOnConflict>;
};

/** on conflict condition type for table "grad.test_score_detail" */
export type GradTestScoreDetailOnConflict = {
  constraint: GradTestScoreDetailConstraint;
  update_columns: Array<GradTestScoreDetailUpdateColumn>;
  where?: Maybe<GradTestScoreDetailBoolExp>;
};

/** ordering options when selecting data from "grad.test_score_detail" */
export type GradTestScoreDetailOrderBy = {
  detail?: Maybe<OrderBy>;
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
  test?: Maybe<OrderBy>;
  test_score_detail_id?: Maybe<OrderBy>;
  test_score_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.test_score_detail" */
export type GradTestScoreDetailPkColumnsInput = {
  /** auto-generated uuid */
  test_score_detail_id: Scalars['String'];
};

/** select columns of table "grad.test_score_detail" */
export enum GradTestScoreDetailSelectColumn {
  /** column name */
  Detail = 'detail',
  /** column name */
  Outof = 'outof',
  /** column name */
  Score = 'score',
  /** column name */
  Test = 'test',
  /** column name */
  TestScoreDetailId = 'test_score_detail_id',
  /** column name */
  TestScoreId = 'test_score_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "grad.test_score_detail" */
export type GradTestScoreDetailSetInput = {
  detail?: Maybe<Scalars['String']>;
  outof?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  test?: Maybe<Scalars['String']>;
  test_score_detail_id?: Maybe<Scalars['String']>;
  test_score_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type GradTestScoreDetailStddevFields = {
  __typename?: 'grad_test_score_detail_stddev_fields';
  outof?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "grad.test_score_detail" */
export type GradTestScoreDetailStddevOrderBy = {
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type GradTestScoreDetailStddevPopFields = {
  __typename?: 'grad_test_score_detail_stddev_pop_fields';
  outof?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "grad.test_score_detail" */
export type GradTestScoreDetailStddevPopOrderBy = {
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type GradTestScoreDetailStddevSampFields = {
  __typename?: 'grad_test_score_detail_stddev_samp_fields';
  outof?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "grad.test_score_detail" */
export type GradTestScoreDetailStddevSampOrderBy = {
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type GradTestScoreDetailSumFields = {
  __typename?: 'grad_test_score_detail_sum_fields';
  outof?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "grad.test_score_detail" */
export type GradTestScoreDetailSumOrderBy = {
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
};

/** update columns of table "grad.test_score_detail" */
export enum GradTestScoreDetailUpdateColumn {
  /** column name */
  Detail = 'detail',
  /** column name */
  Outof = 'outof',
  /** column name */
  Score = 'score',
  /** column name */
  Test = 'test',
  /** column name */
  TestScoreDetailId = 'test_score_detail_id',
  /** column name */
  TestScoreId = 'test_score_id',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type GradTestScoreDetailVarPopFields = {
  __typename?: 'grad_test_score_detail_var_pop_fields';
  outof?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "grad.test_score_detail" */
export type GradTestScoreDetailVarPopOrderBy = {
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type GradTestScoreDetailVarSampFields = {
  __typename?: 'grad_test_score_detail_var_samp_fields';
  outof?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "grad.test_score_detail" */
export type GradTestScoreDetailVarSampOrderBy = {
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type GradTestScoreDetailVarianceFields = {
  __typename?: 'grad_test_score_detail_variance_fields';
  outof?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "grad.test_score_detail" */
export type GradTestScoreDetailVarianceOrderBy = {
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
};

/** input type for incrementing integer column in table "grad.test_score" */
export type GradTestScoreIncInput = {
  outof?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "grad.test_score" */
export type GradTestScoreInsertInput = {
  date?: Maybe<Scalars['date']>;
  outof?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  test?: Maybe<Scalars['String']>;
  test_score_details?: Maybe<GradTestScoreDetailArrRelInsertInput>;
  test_score_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradTestScoreMaxFields = {
  __typename?: 'grad_test_score_max_fields';
  date?: Maybe<Scalars['date']>;
  outof?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  test?: Maybe<Scalars['String']>;
  test_score_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.test_score" */
export type GradTestScoreMaxOrderBy = {
  date?: Maybe<OrderBy>;
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
  test?: Maybe<OrderBy>;
  test_score_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradTestScoreMinFields = {
  __typename?: 'grad_test_score_min_fields';
  date?: Maybe<Scalars['date']>;
  outof?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  test?: Maybe<Scalars['String']>;
  test_score_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.test_score" */
export type GradTestScoreMinOrderBy = {
  date?: Maybe<OrderBy>;
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
  test?: Maybe<OrderBy>;
  test_score_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.test_score" */
export type GradTestScoreMutationResponse = {
  __typename?: 'grad_test_score_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradTestScore>;
};

/** input type for inserting object relation for remote table "grad.test_score" */
export type GradTestScoreObjRelInsertInput = {
  data: GradTestScoreInsertInput;
  on_conflict?: Maybe<GradTestScoreOnConflict>;
};

/** on conflict condition type for table "grad.test_score" */
export type GradTestScoreOnConflict = {
  constraint: GradTestScoreConstraint;
  update_columns: Array<GradTestScoreUpdateColumn>;
  where?: Maybe<GradTestScoreBoolExp>;
};

/** ordering options when selecting data from "grad.test_score" */
export type GradTestScoreOrderBy = {
  date?: Maybe<OrderBy>;
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
  test?: Maybe<OrderBy>;
  test_score_details_aggregate?: Maybe<GradTestScoreDetailAggregateOrderBy>;
  test_score_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.test_score" */
export type GradTestScorePkColumnsInput = {
  /** auto-generated uuid */
  test_score_id: Scalars['String'];
};

/** select columns of table "grad.test_score" */
export enum GradTestScoreSelectColumn {
  /** column name */
  Date = 'date',
  /** column name */
  Outof = 'outof',
  /** column name */
  Score = 'score',
  /** column name */
  Test = 'test',
  /** column name */
  TestScoreId = 'test_score_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "grad.test_score" */
export type GradTestScoreSetInput = {
  date?: Maybe<Scalars['date']>;
  outof?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  test?: Maybe<Scalars['String']>;
  test_score_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type GradTestScoreStddevFields = {
  __typename?: 'grad_test_score_stddev_fields';
  outof?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "grad.test_score" */
export type GradTestScoreStddevOrderBy = {
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type GradTestScoreStddevPopFields = {
  __typename?: 'grad_test_score_stddev_pop_fields';
  outof?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "grad.test_score" */
export type GradTestScoreStddevPopOrderBy = {
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type GradTestScoreStddevSampFields = {
  __typename?: 'grad_test_score_stddev_samp_fields';
  outof?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "grad.test_score" */
export type GradTestScoreStddevSampOrderBy = {
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type GradTestScoreSumFields = {
  __typename?: 'grad_test_score_sum_fields';
  outof?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "grad.test_score" */
export type GradTestScoreSumOrderBy = {
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
};

/** update columns of table "grad.test_score" */
export enum GradTestScoreUpdateColumn {
  /** column name */
  Date = 'date',
  /** column name */
  Outof = 'outof',
  /** column name */
  Score = 'score',
  /** column name */
  Test = 'test',
  /** column name */
  TestScoreId = 'test_score_id',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type GradTestScoreVarPopFields = {
  __typename?: 'grad_test_score_var_pop_fields';
  outof?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "grad.test_score" */
export type GradTestScoreVarPopOrderBy = {
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type GradTestScoreVarSampFields = {
  __typename?: 'grad_test_score_var_samp_fields';
  outof?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "grad.test_score" */
export type GradTestScoreVarSampOrderBy = {
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type GradTestScoreVarianceFields = {
  __typename?: 'grad_test_score_variance_fields';
  outof?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "grad.test_score" */
export type GradTestScoreVarianceOrderBy = {
  outof?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
};

/**
 * used for autocomplete to pick a university, read only
 *
 *
 * columns and relationships of "grad.university_selection"
 */
export type GradUniversitySelection = {
  __typename?: 'grad_university_selection';
  /** main address of the university */
  address?: Maybe<Scalars['String']>;
  /** dapip id, not used atm */
  dapip_id: Scalars['String'];
  /** primary phone number */
  general_phone?: Maybe<Scalars['String']>;
  hidden: Scalars['Boolean'];
  /** latitude of the address */
  lat?: Maybe<Scalars['numeric']>;
  /** longitude of the address */
  lng?: Maybe<Scalars['numeric']>;
  /** university name */
  location_name: Scalars['String'];
  /** not sure, not used */
  location_type: Scalars['String'];
  logo_url?: Maybe<Scalars['String']>;
  /** ignore */
  parent_dapip_id?: Maybe<Scalars['String']>;
  /** ignore */
  parent_name?: Maybe<Scalars['String']>;
  /** auto-generated uuid, read only */
  university_selection_id: Scalars['String'];
};

/** aggregated selection of "grad.university_selection" */
export type GradUniversitySelectionAggregate = {
  __typename?: 'grad_university_selection_aggregate';
  aggregate?: Maybe<GradUniversitySelectionAggregateFields>;
  nodes: Array<GradUniversitySelection>;
};

/** aggregate fields of "grad.university_selection" */
export type GradUniversitySelectionAggregateFields = {
  __typename?: 'grad_university_selection_aggregate_fields';
  avg?: Maybe<GradUniversitySelectionAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradUniversitySelectionMaxFields>;
  min?: Maybe<GradUniversitySelectionMinFields>;
  stddev?: Maybe<GradUniversitySelectionStddevFields>;
  stddev_pop?: Maybe<GradUniversitySelectionStddevPopFields>;
  stddev_samp?: Maybe<GradUniversitySelectionStddevSampFields>;
  sum?: Maybe<GradUniversitySelectionSumFields>;
  var_pop?: Maybe<GradUniversitySelectionVarPopFields>;
  var_samp?: Maybe<GradUniversitySelectionVarSampFields>;
  variance?: Maybe<GradUniversitySelectionVarianceFields>;
};


/** aggregate fields of "grad.university_selection" */
export type GradUniversitySelectionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradUniversitySelectionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.university_selection" */
export type GradUniversitySelectionAggregateOrderBy = {
  avg?: Maybe<GradUniversitySelectionAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<GradUniversitySelectionMaxOrderBy>;
  min?: Maybe<GradUniversitySelectionMinOrderBy>;
  stddev?: Maybe<GradUniversitySelectionStddevOrderBy>;
  stddev_pop?: Maybe<GradUniversitySelectionStddevPopOrderBy>;
  stddev_samp?: Maybe<GradUniversitySelectionStddevSampOrderBy>;
  sum?: Maybe<GradUniversitySelectionSumOrderBy>;
  var_pop?: Maybe<GradUniversitySelectionVarPopOrderBy>;
  var_samp?: Maybe<GradUniversitySelectionVarSampOrderBy>;
  variance?: Maybe<GradUniversitySelectionVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "grad.university_selection" */
export type GradUniversitySelectionArrRelInsertInput = {
  data: Array<GradUniversitySelectionInsertInput>;
  on_conflict?: Maybe<GradUniversitySelectionOnConflict>;
};

/** aggregate avg on columns */
export type GradUniversitySelectionAvgFields = {
  __typename?: 'grad_university_selection_avg_fields';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "grad.university_selection" */
export type GradUniversitySelectionAvgOrderBy = {
  lat?: Maybe<OrderBy>;
  lng?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "grad.university_selection". All fields are combined with a logical 'AND'. */
export type GradUniversitySelectionBoolExp = {
  _and?: Maybe<Array<Maybe<GradUniversitySelectionBoolExp>>>;
  _not?: Maybe<GradUniversitySelectionBoolExp>;
  _or?: Maybe<Array<Maybe<GradUniversitySelectionBoolExp>>>;
  address?: Maybe<StringComparisonExp>;
  dapip_id?: Maybe<StringComparisonExp>;
  general_phone?: Maybe<StringComparisonExp>;
  hidden?: Maybe<BooleanComparisonExp>;
  lat?: Maybe<NumericComparisonExp>;
  lng?: Maybe<NumericComparisonExp>;
  location_name?: Maybe<StringComparisonExp>;
  location_type?: Maybe<StringComparisonExp>;
  logo_url?: Maybe<StringComparisonExp>;
  parent_dapip_id?: Maybe<StringComparisonExp>;
  parent_name?: Maybe<StringComparisonExp>;
  university_selection_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.university_selection" */
export enum GradUniversitySelectionConstraint {
  /** unique or primary key constraint */
  UniversitySelectionDapipIdKey = 'university_selection_dapip_id_key',
  /** unique or primary key constraint */
  UniversitySelectionPkey = 'university_selection_pkey',
  /** unique or primary key constraint */
  UniversitySelectionUniversitySelectionIdKey = 'university_selection_university_selection_id_key'
}

/** input type for incrementing integer column in table "grad.university_selection" */
export type GradUniversitySelectionIncInput = {
  lat?: Maybe<Scalars['numeric']>;
  lng?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "grad.university_selection" */
export type GradUniversitySelectionInsertInput = {
  address?: Maybe<Scalars['String']>;
  dapip_id?: Maybe<Scalars['String']>;
  general_phone?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  lat?: Maybe<Scalars['numeric']>;
  lng?: Maybe<Scalars['numeric']>;
  location_name?: Maybe<Scalars['String']>;
  location_type?: Maybe<Scalars['String']>;
  logo_url?: Maybe<Scalars['String']>;
  parent_dapip_id?: Maybe<Scalars['String']>;
  parent_name?: Maybe<Scalars['String']>;
  university_selection_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradUniversitySelectionMaxFields = {
  __typename?: 'grad_university_selection_max_fields';
  address?: Maybe<Scalars['String']>;
  dapip_id?: Maybe<Scalars['String']>;
  general_phone?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['numeric']>;
  lng?: Maybe<Scalars['numeric']>;
  location_name?: Maybe<Scalars['String']>;
  location_type?: Maybe<Scalars['String']>;
  logo_url?: Maybe<Scalars['String']>;
  parent_dapip_id?: Maybe<Scalars['String']>;
  parent_name?: Maybe<Scalars['String']>;
  university_selection_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.university_selection" */
export type GradUniversitySelectionMaxOrderBy = {
  address?: Maybe<OrderBy>;
  dapip_id?: Maybe<OrderBy>;
  general_phone?: Maybe<OrderBy>;
  lat?: Maybe<OrderBy>;
  lng?: Maybe<OrderBy>;
  location_name?: Maybe<OrderBy>;
  location_type?: Maybe<OrderBy>;
  logo_url?: Maybe<OrderBy>;
  parent_dapip_id?: Maybe<OrderBy>;
  parent_name?: Maybe<OrderBy>;
  university_selection_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradUniversitySelectionMinFields = {
  __typename?: 'grad_university_selection_min_fields';
  address?: Maybe<Scalars['String']>;
  dapip_id?: Maybe<Scalars['String']>;
  general_phone?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['numeric']>;
  lng?: Maybe<Scalars['numeric']>;
  location_name?: Maybe<Scalars['String']>;
  location_type?: Maybe<Scalars['String']>;
  logo_url?: Maybe<Scalars['String']>;
  parent_dapip_id?: Maybe<Scalars['String']>;
  parent_name?: Maybe<Scalars['String']>;
  university_selection_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.university_selection" */
export type GradUniversitySelectionMinOrderBy = {
  address?: Maybe<OrderBy>;
  dapip_id?: Maybe<OrderBy>;
  general_phone?: Maybe<OrderBy>;
  lat?: Maybe<OrderBy>;
  lng?: Maybe<OrderBy>;
  location_name?: Maybe<OrderBy>;
  location_type?: Maybe<OrderBy>;
  logo_url?: Maybe<OrderBy>;
  parent_dapip_id?: Maybe<OrderBy>;
  parent_name?: Maybe<OrderBy>;
  university_selection_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.university_selection" */
export type GradUniversitySelectionMutationResponse = {
  __typename?: 'grad_university_selection_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradUniversitySelection>;
};

/** input type for inserting object relation for remote table "grad.university_selection" */
export type GradUniversitySelectionObjRelInsertInput = {
  data: GradUniversitySelectionInsertInput;
  on_conflict?: Maybe<GradUniversitySelectionOnConflict>;
};

/** on conflict condition type for table "grad.university_selection" */
export type GradUniversitySelectionOnConflict = {
  constraint: GradUniversitySelectionConstraint;
  update_columns: Array<GradUniversitySelectionUpdateColumn>;
  where?: Maybe<GradUniversitySelectionBoolExp>;
};

/** ordering options when selecting data from "grad.university_selection" */
export type GradUniversitySelectionOrderBy = {
  address?: Maybe<OrderBy>;
  dapip_id?: Maybe<OrderBy>;
  general_phone?: Maybe<OrderBy>;
  hidden?: Maybe<OrderBy>;
  lat?: Maybe<OrderBy>;
  lng?: Maybe<OrderBy>;
  location_name?: Maybe<OrderBy>;
  location_type?: Maybe<OrderBy>;
  logo_url?: Maybe<OrderBy>;
  parent_dapip_id?: Maybe<OrderBy>;
  parent_name?: Maybe<OrderBy>;
  university_selection_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.university_selection" */
export type GradUniversitySelectionPkColumnsInput = {
  /** auto-generated uuid, read only */
  university_selection_id: Scalars['String'];
};

/** select columns of table "grad.university_selection" */
export enum GradUniversitySelectionSelectColumn {
  /** column name */
  Address = 'address',
  /** column name */
  DapipId = 'dapip_id',
  /** column name */
  GeneralPhone = 'general_phone',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocationName = 'location_name',
  /** column name */
  LocationType = 'location_type',
  /** column name */
  LogoUrl = 'logo_url',
  /** column name */
  ParentDapipId = 'parent_dapip_id',
  /** column name */
  ParentName = 'parent_name',
  /** column name */
  UniversitySelectionId = 'university_selection_id'
}

/** input type for updating data in table "grad.university_selection" */
export type GradUniversitySelectionSetInput = {
  address?: Maybe<Scalars['String']>;
  dapip_id?: Maybe<Scalars['String']>;
  general_phone?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  lat?: Maybe<Scalars['numeric']>;
  lng?: Maybe<Scalars['numeric']>;
  location_name?: Maybe<Scalars['String']>;
  location_type?: Maybe<Scalars['String']>;
  logo_url?: Maybe<Scalars['String']>;
  parent_dapip_id?: Maybe<Scalars['String']>;
  parent_name?: Maybe<Scalars['String']>;
  university_selection_id?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type GradUniversitySelectionStddevFields = {
  __typename?: 'grad_university_selection_stddev_fields';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "grad.university_selection" */
export type GradUniversitySelectionStddevOrderBy = {
  lat?: Maybe<OrderBy>;
  lng?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type GradUniversitySelectionStddevPopFields = {
  __typename?: 'grad_university_selection_stddev_pop_fields';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "grad.university_selection" */
export type GradUniversitySelectionStddevPopOrderBy = {
  lat?: Maybe<OrderBy>;
  lng?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type GradUniversitySelectionStddevSampFields = {
  __typename?: 'grad_university_selection_stddev_samp_fields';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "grad.university_selection" */
export type GradUniversitySelectionStddevSampOrderBy = {
  lat?: Maybe<OrderBy>;
  lng?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type GradUniversitySelectionSumFields = {
  __typename?: 'grad_university_selection_sum_fields';
  lat?: Maybe<Scalars['numeric']>;
  lng?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "grad.university_selection" */
export type GradUniversitySelectionSumOrderBy = {
  lat?: Maybe<OrderBy>;
  lng?: Maybe<OrderBy>;
};

/** update columns of table "grad.university_selection" */
export enum GradUniversitySelectionUpdateColumn {
  /** column name */
  Address = 'address',
  /** column name */
  DapipId = 'dapip_id',
  /** column name */
  GeneralPhone = 'general_phone',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocationName = 'location_name',
  /** column name */
  LocationType = 'location_type',
  /** column name */
  LogoUrl = 'logo_url',
  /** column name */
  ParentDapipId = 'parent_dapip_id',
  /** column name */
  ParentName = 'parent_name',
  /** column name */
  UniversitySelectionId = 'university_selection_id'
}

/** aggregate var_pop on columns */
export type GradUniversitySelectionVarPopFields = {
  __typename?: 'grad_university_selection_var_pop_fields';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "grad.university_selection" */
export type GradUniversitySelectionVarPopOrderBy = {
  lat?: Maybe<OrderBy>;
  lng?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type GradUniversitySelectionVarSampFields = {
  __typename?: 'grad_university_selection_var_samp_fields';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "grad.university_selection" */
export type GradUniversitySelectionVarSampOrderBy = {
  lat?: Maybe<OrderBy>;
  lng?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type GradUniversitySelectionVarianceFields = {
  __typename?: 'grad_university_selection_variance_fields';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "grad.university_selection" */
export type GradUniversitySelectionVarianceOrderBy = {
  lat?: Maybe<OrderBy>;
  lng?: Maybe<OrderBy>;
};

/** columns and relationships of "grad.university_stat" */
export type GradUniversityStat = {
  __typename?: 'grad_university_stat';
  degree_count?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  university_selection?: Maybe<GradUniversitySelection>;
  university_selection_id?: Maybe<Scalars['String']>;
  used_in_degree?: Maybe<Scalars['Boolean']>;
};

/** aggregated selection of "grad.university_stat" */
export type GradUniversityStatAggregate = {
  __typename?: 'grad_university_stat_aggregate';
  aggregate?: Maybe<GradUniversityStatAggregateFields>;
  nodes: Array<GradUniversityStat>;
};

/** aggregate fields of "grad.university_stat" */
export type GradUniversityStatAggregateFields = {
  __typename?: 'grad_university_stat_aggregate_fields';
  avg?: Maybe<GradUniversityStatAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradUniversityStatMaxFields>;
  min?: Maybe<GradUniversityStatMinFields>;
  stddev?: Maybe<GradUniversityStatStddevFields>;
  stddev_pop?: Maybe<GradUniversityStatStddevPopFields>;
  stddev_samp?: Maybe<GradUniversityStatStddevSampFields>;
  sum?: Maybe<GradUniversityStatSumFields>;
  var_pop?: Maybe<GradUniversityStatVarPopFields>;
  var_samp?: Maybe<GradUniversityStatVarSampFields>;
  variance?: Maybe<GradUniversityStatVarianceFields>;
};


/** aggregate fields of "grad.university_stat" */
export type GradUniversityStatAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradUniversityStatSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.university_stat" */
export type GradUniversityStatAggregateOrderBy = {
  avg?: Maybe<GradUniversityStatAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<GradUniversityStatMaxOrderBy>;
  min?: Maybe<GradUniversityStatMinOrderBy>;
  stddev?: Maybe<GradUniversityStatStddevOrderBy>;
  stddev_pop?: Maybe<GradUniversityStatStddevPopOrderBy>;
  stddev_samp?: Maybe<GradUniversityStatStddevSampOrderBy>;
  sum?: Maybe<GradUniversityStatSumOrderBy>;
  var_pop?: Maybe<GradUniversityStatVarPopOrderBy>;
  var_samp?: Maybe<GradUniversityStatVarSampOrderBy>;
  variance?: Maybe<GradUniversityStatVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "grad.university_stat" */
export type GradUniversityStatArrRelInsertInput = {
  data: Array<GradUniversityStatInsertInput>;
  on_conflict?: Maybe<GradUniversityStatOnConflict>;
};

/** aggregate avg on columns */
export type GradUniversityStatAvgFields = {
  __typename?: 'grad_university_stat_avg_fields';
  degree_count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "grad.university_stat" */
export type GradUniversityStatAvgOrderBy = {
  degree_count?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "grad.university_stat". All fields are combined with a logical 'AND'. */
export type GradUniversityStatBoolExp = {
  _and?: Maybe<Array<Maybe<GradUniversityStatBoolExp>>>;
  _not?: Maybe<GradUniversityStatBoolExp>;
  _or?: Maybe<Array<Maybe<GradUniversityStatBoolExp>>>;
  degree_count?: Maybe<BigintComparisonExp>;
  university_selection?: Maybe<GradUniversitySelectionBoolExp>;
  university_selection_id?: Maybe<StringComparisonExp>;
  used_in_degree?: Maybe<BooleanComparisonExp>;
};

/** unique or primary key constraints on table "grad.university_stat" */
export enum GradUniversityStatConstraint {
  /** unique or primary key constraint */
  UniversityStatPkey = 'university_stat_pkey'
}

/** input type for incrementing integer column in table "grad.university_stat" */
export type GradUniversityStatIncInput = {
  degree_count?: Maybe<Scalars['bigint']>;
};

/** input type for inserting data into table "grad.university_stat" */
export type GradUniversityStatInsertInput = {
  degree_count?: Maybe<Scalars['bigint']>;
  university_selection?: Maybe<GradUniversitySelectionObjRelInsertInput>;
  university_selection_id?: Maybe<Scalars['String']>;
  used_in_degree?: Maybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type GradUniversityStatMaxFields = {
  __typename?: 'grad_university_stat_max_fields';
  degree_count?: Maybe<Scalars['bigint']>;
  university_selection_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.university_stat" */
export type GradUniversityStatMaxOrderBy = {
  degree_count?: Maybe<OrderBy>;
  university_selection_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradUniversityStatMinFields = {
  __typename?: 'grad_university_stat_min_fields';
  degree_count?: Maybe<Scalars['bigint']>;
  university_selection_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.university_stat" */
export type GradUniversityStatMinOrderBy = {
  degree_count?: Maybe<OrderBy>;
  university_selection_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.university_stat" */
export type GradUniversityStatMutationResponse = {
  __typename?: 'grad_university_stat_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradUniversityStat>;
};

/** input type for inserting object relation for remote table "grad.university_stat" */
export type GradUniversityStatObjRelInsertInput = {
  data: GradUniversityStatInsertInput;
  on_conflict?: Maybe<GradUniversityStatOnConflict>;
};

/** on conflict condition type for table "grad.university_stat" */
export type GradUniversityStatOnConflict = {
  constraint: GradUniversityStatConstraint;
  update_columns: Array<GradUniversityStatUpdateColumn>;
  where?: Maybe<GradUniversityStatBoolExp>;
};

/** ordering options when selecting data from "grad.university_stat" */
export type GradUniversityStatOrderBy = {
  degree_count?: Maybe<OrderBy>;
  university_selection?: Maybe<GradUniversitySelectionOrderBy>;
  university_selection_id?: Maybe<OrderBy>;
  used_in_degree?: Maybe<OrderBy>;
};

/** select columns of table "grad.university_stat" */
export enum GradUniversityStatSelectColumn {
  /** column name */
  DegreeCount = 'degree_count',
  /** column name */
  UniversitySelectionId = 'university_selection_id',
  /** column name */
  UsedInDegree = 'used_in_degree'
}

/** input type for updating data in table "grad.university_stat" */
export type GradUniversityStatSetInput = {
  degree_count?: Maybe<Scalars['bigint']>;
  university_selection_id?: Maybe<Scalars['String']>;
  used_in_degree?: Maybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type GradUniversityStatStddevFields = {
  __typename?: 'grad_university_stat_stddev_fields';
  degree_count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "grad.university_stat" */
export type GradUniversityStatStddevOrderBy = {
  degree_count?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type GradUniversityStatStddevPopFields = {
  __typename?: 'grad_university_stat_stddev_pop_fields';
  degree_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "grad.university_stat" */
export type GradUniversityStatStddevPopOrderBy = {
  degree_count?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type GradUniversityStatStddevSampFields = {
  __typename?: 'grad_university_stat_stddev_samp_fields';
  degree_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "grad.university_stat" */
export type GradUniversityStatStddevSampOrderBy = {
  degree_count?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type GradUniversityStatSumFields = {
  __typename?: 'grad_university_stat_sum_fields';
  degree_count?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "grad.university_stat" */
export type GradUniversityStatSumOrderBy = {
  degree_count?: Maybe<OrderBy>;
};

/** update columns of table "grad.university_stat" */
export enum GradUniversityStatUpdateColumn {
  /** column name */
  DegreeCount = 'degree_count',
  /** column name */
  UniversitySelectionId = 'university_selection_id',
  /** column name */
  UsedInDegree = 'used_in_degree'
}

/** aggregate var_pop on columns */
export type GradUniversityStatVarPopFields = {
  __typename?: 'grad_university_stat_var_pop_fields';
  degree_count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "grad.university_stat" */
export type GradUniversityStatVarPopOrderBy = {
  degree_count?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type GradUniversityStatVarSampFields = {
  __typename?: 'grad_university_stat_var_samp_fields';
  degree_count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "grad.university_stat" */
export type GradUniversityStatVarSampOrderBy = {
  degree_count?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type GradUniversityStatVarianceFields = {
  __typename?: 'grad_university_stat_variance_fields';
  degree_count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "grad.university_stat" */
export type GradUniversityStatVarianceOrderBy = {
  degree_count?: Maybe<OrderBy>;
};

/**
 * stores student uploaded documents
 *
 *
 * columns and relationships of "grad.upload_doc"
 */
export type GradUploadDoc = {
  __typename?: 'grad_upload_doc';
  /** the filename */
  filename: Scalars['String'];
  /** file content hex encoded */
  hex_content: Scalars['String'];
  /** auto-generated uuid */
  upload_doc_id: Scalars['String'];
  /** maps to profile.user_id */
  user_id: Scalars['String'];
};

/** aggregated selection of "grad.upload_doc" */
export type GradUploadDocAggregate = {
  __typename?: 'grad_upload_doc_aggregate';
  aggregate?: Maybe<GradUploadDocAggregateFields>;
  nodes: Array<GradUploadDoc>;
};

/** aggregate fields of "grad.upload_doc" */
export type GradUploadDocAggregateFields = {
  __typename?: 'grad_upload_doc_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradUploadDocMaxFields>;
  min?: Maybe<GradUploadDocMinFields>;
};


/** aggregate fields of "grad.upload_doc" */
export type GradUploadDocAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradUploadDocSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.upload_doc" */
export type GradUploadDocAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradUploadDocMaxOrderBy>;
  min?: Maybe<GradUploadDocMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.upload_doc" */
export type GradUploadDocArrRelInsertInput = {
  data: Array<GradUploadDocInsertInput>;
  on_conflict?: Maybe<GradUploadDocOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.upload_doc". All fields are combined with a logical 'AND'. */
export type GradUploadDocBoolExp = {
  _and?: Maybe<Array<Maybe<GradUploadDocBoolExp>>>;
  _not?: Maybe<GradUploadDocBoolExp>;
  _or?: Maybe<Array<Maybe<GradUploadDocBoolExp>>>;
  filename?: Maybe<StringComparisonExp>;
  hex_content?: Maybe<StringComparisonExp>;
  upload_doc_id?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.upload_doc" */
export enum GradUploadDocConstraint {
  /** unique or primary key constraint */
  UploadDocPkey = 'upload_doc_pkey',
  /** unique or primary key constraint */
  UploadDocUploadDocIdKey = 'upload_doc_upload_doc_id_key'
}

/** input type for inserting data into table "grad.upload_doc" */
export type GradUploadDocInsertInput = {
  filename?: Maybe<Scalars['String']>;
  hex_content?: Maybe<Scalars['String']>;
  upload_doc_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradUploadDocMaxFields = {
  __typename?: 'grad_upload_doc_max_fields';
  filename?: Maybe<Scalars['String']>;
  hex_content?: Maybe<Scalars['String']>;
  upload_doc_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.upload_doc" */
export type GradUploadDocMaxOrderBy = {
  filename?: Maybe<OrderBy>;
  hex_content?: Maybe<OrderBy>;
  upload_doc_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradUploadDocMinFields = {
  __typename?: 'grad_upload_doc_min_fields';
  filename?: Maybe<Scalars['String']>;
  hex_content?: Maybe<Scalars['String']>;
  upload_doc_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.upload_doc" */
export type GradUploadDocMinOrderBy = {
  filename?: Maybe<OrderBy>;
  hex_content?: Maybe<OrderBy>;
  upload_doc_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.upload_doc" */
export type GradUploadDocMutationResponse = {
  __typename?: 'grad_upload_doc_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradUploadDoc>;
};

/** input type for inserting object relation for remote table "grad.upload_doc" */
export type GradUploadDocObjRelInsertInput = {
  data: GradUploadDocInsertInput;
  on_conflict?: Maybe<GradUploadDocOnConflict>;
};

/** on conflict condition type for table "grad.upload_doc" */
export type GradUploadDocOnConflict = {
  constraint: GradUploadDocConstraint;
  update_columns: Array<GradUploadDocUpdateColumn>;
  where?: Maybe<GradUploadDocBoolExp>;
};

/** ordering options when selecting data from "grad.upload_doc" */
export type GradUploadDocOrderBy = {
  filename?: Maybe<OrderBy>;
  hex_content?: Maybe<OrderBy>;
  upload_doc_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.upload_doc" */
export type GradUploadDocPkColumnsInput = {
  /** auto-generated uuid */
  upload_doc_id: Scalars['String'];
};

/** select columns of table "grad.upload_doc" */
export enum GradUploadDocSelectColumn {
  /** column name */
  Filename = 'filename',
  /** column name */
  HexContent = 'hex_content',
  /** column name */
  UploadDocId = 'upload_doc_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "grad.upload_doc" */
export type GradUploadDocSetInput = {
  filename?: Maybe<Scalars['String']>;
  hex_content?: Maybe<Scalars['String']>;
  upload_doc_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.upload_doc" */
export enum GradUploadDocUpdateColumn {
  /** column name */
  Filename = 'filename',
  /** column name */
  HexContent = 'hex_content',
  /** column name */
  UploadDocId = 'upload_doc_id',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "grad.user_activity_summary" */
export type GradUserActivitySummary = {
  __typename?: 'grad_user_activity_summary';
  last_edit?: Maybe<Scalars['timestamptz']>;
  last_page_view?: Maybe<Scalars['timestamptz']>;
  page_views_last_30d?: Maybe<Scalars['Int']>;
  page_views_last_7d?: Maybe<Scalars['Int']>;
  user_id: Scalars['String'];
};

/** aggregated selection of "grad.user_activity_summary" */
export type GradUserActivitySummaryAggregate = {
  __typename?: 'grad_user_activity_summary_aggregate';
  aggregate?: Maybe<GradUserActivitySummaryAggregateFields>;
  nodes: Array<GradUserActivitySummary>;
};

/** aggregate fields of "grad.user_activity_summary" */
export type GradUserActivitySummaryAggregateFields = {
  __typename?: 'grad_user_activity_summary_aggregate_fields';
  avg?: Maybe<GradUserActivitySummaryAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradUserActivitySummaryMaxFields>;
  min?: Maybe<GradUserActivitySummaryMinFields>;
  stddev?: Maybe<GradUserActivitySummaryStddevFields>;
  stddev_pop?: Maybe<GradUserActivitySummaryStddevPopFields>;
  stddev_samp?: Maybe<GradUserActivitySummaryStddevSampFields>;
  sum?: Maybe<GradUserActivitySummarySumFields>;
  var_pop?: Maybe<GradUserActivitySummaryVarPopFields>;
  var_samp?: Maybe<GradUserActivitySummaryVarSampFields>;
  variance?: Maybe<GradUserActivitySummaryVarianceFields>;
};


/** aggregate fields of "grad.user_activity_summary" */
export type GradUserActivitySummaryAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradUserActivitySummarySelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.user_activity_summary" */
export type GradUserActivitySummaryAggregateOrderBy = {
  avg?: Maybe<GradUserActivitySummaryAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<GradUserActivitySummaryMaxOrderBy>;
  min?: Maybe<GradUserActivitySummaryMinOrderBy>;
  stddev?: Maybe<GradUserActivitySummaryStddevOrderBy>;
  stddev_pop?: Maybe<GradUserActivitySummaryStddevPopOrderBy>;
  stddev_samp?: Maybe<GradUserActivitySummaryStddevSampOrderBy>;
  sum?: Maybe<GradUserActivitySummarySumOrderBy>;
  var_pop?: Maybe<GradUserActivitySummaryVarPopOrderBy>;
  var_samp?: Maybe<GradUserActivitySummaryVarSampOrderBy>;
  variance?: Maybe<GradUserActivitySummaryVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "grad.user_activity_summary" */
export type GradUserActivitySummaryArrRelInsertInput = {
  data: Array<GradUserActivitySummaryInsertInput>;
  on_conflict?: Maybe<GradUserActivitySummaryOnConflict>;
};

/** aggregate avg on columns */
export type GradUserActivitySummaryAvgFields = {
  __typename?: 'grad_user_activity_summary_avg_fields';
  page_views_last_30d?: Maybe<Scalars['Float']>;
  page_views_last_7d?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "grad.user_activity_summary" */
export type GradUserActivitySummaryAvgOrderBy = {
  page_views_last_30d?: Maybe<OrderBy>;
  page_views_last_7d?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "grad.user_activity_summary". All fields are combined with a logical 'AND'. */
export type GradUserActivitySummaryBoolExp = {
  _and?: Maybe<Array<Maybe<GradUserActivitySummaryBoolExp>>>;
  _not?: Maybe<GradUserActivitySummaryBoolExp>;
  _or?: Maybe<Array<Maybe<GradUserActivitySummaryBoolExp>>>;
  last_edit?: Maybe<TimestamptzComparisonExp>;
  last_page_view?: Maybe<TimestamptzComparisonExp>;
  page_views_last_30d?: Maybe<IntComparisonExp>;
  page_views_last_7d?: Maybe<IntComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.user_activity_summary" */
export enum GradUserActivitySummaryConstraint {
  /** unique or primary key constraint */
  UserActivitySummaryPkey = 'user_activity_summary_pkey'
}

/** input type for incrementing integer column in table "grad.user_activity_summary" */
export type GradUserActivitySummaryIncInput = {
  page_views_last_30d?: Maybe<Scalars['Int']>;
  page_views_last_7d?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "grad.user_activity_summary" */
export type GradUserActivitySummaryInsertInput = {
  last_edit?: Maybe<Scalars['timestamptz']>;
  last_page_view?: Maybe<Scalars['timestamptz']>;
  page_views_last_30d?: Maybe<Scalars['Int']>;
  page_views_last_7d?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradUserActivitySummaryMaxFields = {
  __typename?: 'grad_user_activity_summary_max_fields';
  last_edit?: Maybe<Scalars['timestamptz']>;
  last_page_view?: Maybe<Scalars['timestamptz']>;
  page_views_last_30d?: Maybe<Scalars['Int']>;
  page_views_last_7d?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.user_activity_summary" */
export type GradUserActivitySummaryMaxOrderBy = {
  last_edit?: Maybe<OrderBy>;
  last_page_view?: Maybe<OrderBy>;
  page_views_last_30d?: Maybe<OrderBy>;
  page_views_last_7d?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradUserActivitySummaryMinFields = {
  __typename?: 'grad_user_activity_summary_min_fields';
  last_edit?: Maybe<Scalars['timestamptz']>;
  last_page_view?: Maybe<Scalars['timestamptz']>;
  page_views_last_30d?: Maybe<Scalars['Int']>;
  page_views_last_7d?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.user_activity_summary" */
export type GradUserActivitySummaryMinOrderBy = {
  last_edit?: Maybe<OrderBy>;
  last_page_view?: Maybe<OrderBy>;
  page_views_last_30d?: Maybe<OrderBy>;
  page_views_last_7d?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.user_activity_summary" */
export type GradUserActivitySummaryMutationResponse = {
  __typename?: 'grad_user_activity_summary_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradUserActivitySummary>;
};

/** input type for inserting object relation for remote table "grad.user_activity_summary" */
export type GradUserActivitySummaryObjRelInsertInput = {
  data: GradUserActivitySummaryInsertInput;
  on_conflict?: Maybe<GradUserActivitySummaryOnConflict>;
};

/** on conflict condition type for table "grad.user_activity_summary" */
export type GradUserActivitySummaryOnConflict = {
  constraint: GradUserActivitySummaryConstraint;
  update_columns: Array<GradUserActivitySummaryUpdateColumn>;
  where?: Maybe<GradUserActivitySummaryBoolExp>;
};

/** ordering options when selecting data from "grad.user_activity_summary" */
export type GradUserActivitySummaryOrderBy = {
  last_edit?: Maybe<OrderBy>;
  last_page_view?: Maybe<OrderBy>;
  page_views_last_30d?: Maybe<OrderBy>;
  page_views_last_7d?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.user_activity_summary" */
export type GradUserActivitySummaryPkColumnsInput = {
  user_id: Scalars['String'];
};

/** select columns of table "grad.user_activity_summary" */
export enum GradUserActivitySummarySelectColumn {
  /** column name */
  LastEdit = 'last_edit',
  /** column name */
  LastPageView = 'last_page_view',
  /** column name */
  PageViewsLast30d = 'page_views_last_30d',
  /** column name */
  PageViewsLast7d = 'page_views_last_7d',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "grad.user_activity_summary" */
export type GradUserActivitySummarySetInput = {
  last_edit?: Maybe<Scalars['timestamptz']>;
  last_page_view?: Maybe<Scalars['timestamptz']>;
  page_views_last_30d?: Maybe<Scalars['Int']>;
  page_views_last_7d?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type GradUserActivitySummaryStddevFields = {
  __typename?: 'grad_user_activity_summary_stddev_fields';
  page_views_last_30d?: Maybe<Scalars['Float']>;
  page_views_last_7d?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "grad.user_activity_summary" */
export type GradUserActivitySummaryStddevOrderBy = {
  page_views_last_30d?: Maybe<OrderBy>;
  page_views_last_7d?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type GradUserActivitySummaryStddevPopFields = {
  __typename?: 'grad_user_activity_summary_stddev_pop_fields';
  page_views_last_30d?: Maybe<Scalars['Float']>;
  page_views_last_7d?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "grad.user_activity_summary" */
export type GradUserActivitySummaryStddevPopOrderBy = {
  page_views_last_30d?: Maybe<OrderBy>;
  page_views_last_7d?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type GradUserActivitySummaryStddevSampFields = {
  __typename?: 'grad_user_activity_summary_stddev_samp_fields';
  page_views_last_30d?: Maybe<Scalars['Float']>;
  page_views_last_7d?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "grad.user_activity_summary" */
export type GradUserActivitySummaryStddevSampOrderBy = {
  page_views_last_30d?: Maybe<OrderBy>;
  page_views_last_7d?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type GradUserActivitySummarySumFields = {
  __typename?: 'grad_user_activity_summary_sum_fields';
  page_views_last_30d?: Maybe<Scalars['Int']>;
  page_views_last_7d?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "grad.user_activity_summary" */
export type GradUserActivitySummarySumOrderBy = {
  page_views_last_30d?: Maybe<OrderBy>;
  page_views_last_7d?: Maybe<OrderBy>;
};

/** update columns of table "grad.user_activity_summary" */
export enum GradUserActivitySummaryUpdateColumn {
  /** column name */
  LastEdit = 'last_edit',
  /** column name */
  LastPageView = 'last_page_view',
  /** column name */
  PageViewsLast30d = 'page_views_last_30d',
  /** column name */
  PageViewsLast7d = 'page_views_last_7d',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type GradUserActivitySummaryVarPopFields = {
  __typename?: 'grad_user_activity_summary_var_pop_fields';
  page_views_last_30d?: Maybe<Scalars['Float']>;
  page_views_last_7d?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "grad.user_activity_summary" */
export type GradUserActivitySummaryVarPopOrderBy = {
  page_views_last_30d?: Maybe<OrderBy>;
  page_views_last_7d?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type GradUserActivitySummaryVarSampFields = {
  __typename?: 'grad_user_activity_summary_var_samp_fields';
  page_views_last_30d?: Maybe<Scalars['Float']>;
  page_views_last_7d?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "grad.user_activity_summary" */
export type GradUserActivitySummaryVarSampOrderBy = {
  page_views_last_30d?: Maybe<OrderBy>;
  page_views_last_7d?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type GradUserActivitySummaryVarianceFields = {
  __typename?: 'grad_user_activity_summary_variance_fields';
  page_views_last_30d?: Maybe<Scalars['Float']>;
  page_views_last_7d?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "grad.user_activity_summary" */
export type GradUserActivitySummaryVarianceOrderBy = {
  page_views_last_30d?: Maybe<OrderBy>;
  page_views_last_7d?: Maybe<OrderBy>;
};

/**
 * deprecated
 *
 *
 * columns and relationships of "grad.visa_selection"
 */
export type GradVisaSelection = {
  __typename?: 'grad_visa_selection';
  visa: Scalars['String'];
  visa_selection_id: Scalars['String'];
};

/** aggregated selection of "grad.visa_selection" */
export type GradVisaSelectionAggregate = {
  __typename?: 'grad_visa_selection_aggregate';
  aggregate?: Maybe<GradVisaSelectionAggregateFields>;
  nodes: Array<GradVisaSelection>;
};

/** aggregate fields of "grad.visa_selection" */
export type GradVisaSelectionAggregateFields = {
  __typename?: 'grad_visa_selection_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradVisaSelectionMaxFields>;
  min?: Maybe<GradVisaSelectionMinFields>;
};


/** aggregate fields of "grad.visa_selection" */
export type GradVisaSelectionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradVisaSelectionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.visa_selection" */
export type GradVisaSelectionAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradVisaSelectionMaxOrderBy>;
  min?: Maybe<GradVisaSelectionMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.visa_selection" */
export type GradVisaSelectionArrRelInsertInput = {
  data: Array<GradVisaSelectionInsertInput>;
  on_conflict?: Maybe<GradVisaSelectionOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.visa_selection". All fields are combined with a logical 'AND'. */
export type GradVisaSelectionBoolExp = {
  _and?: Maybe<Array<Maybe<GradVisaSelectionBoolExp>>>;
  _not?: Maybe<GradVisaSelectionBoolExp>;
  _or?: Maybe<Array<Maybe<GradVisaSelectionBoolExp>>>;
  visa?: Maybe<StringComparisonExp>;
  visa_selection_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.visa_selection" */
export enum GradVisaSelectionConstraint {
  /** unique or primary key constraint */
  VisaSelectionPkey = 'visa_selection_pkey',
  /** unique or primary key constraint */
  VisaSelectionVisaKey = 'visa_selection_visa_key'
}

/** input type for inserting data into table "grad.visa_selection" */
export type GradVisaSelectionInsertInput = {
  visa?: Maybe<Scalars['String']>;
  visa_selection_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradVisaSelectionMaxFields = {
  __typename?: 'grad_visa_selection_max_fields';
  visa?: Maybe<Scalars['String']>;
  visa_selection_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.visa_selection" */
export type GradVisaSelectionMaxOrderBy = {
  visa?: Maybe<OrderBy>;
  visa_selection_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradVisaSelectionMinFields = {
  __typename?: 'grad_visa_selection_min_fields';
  visa?: Maybe<Scalars['String']>;
  visa_selection_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.visa_selection" */
export type GradVisaSelectionMinOrderBy = {
  visa?: Maybe<OrderBy>;
  visa_selection_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.visa_selection" */
export type GradVisaSelectionMutationResponse = {
  __typename?: 'grad_visa_selection_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradVisaSelection>;
};

/** input type for inserting object relation for remote table "grad.visa_selection" */
export type GradVisaSelectionObjRelInsertInput = {
  data: GradVisaSelectionInsertInput;
  on_conflict?: Maybe<GradVisaSelectionOnConflict>;
};

/** on conflict condition type for table "grad.visa_selection" */
export type GradVisaSelectionOnConflict = {
  constraint: GradVisaSelectionConstraint;
  update_columns: Array<GradVisaSelectionUpdateColumn>;
  where?: Maybe<GradVisaSelectionBoolExp>;
};

/** ordering options when selecting data from "grad.visa_selection" */
export type GradVisaSelectionOrderBy = {
  visa?: Maybe<OrderBy>;
  visa_selection_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.visa_selection" */
export type GradVisaSelectionPkColumnsInput = {
  visa_selection_id: Scalars['String'];
};

/** select columns of table "grad.visa_selection" */
export enum GradVisaSelectionSelectColumn {
  /** column name */
  Visa = 'visa',
  /** column name */
  VisaSelectionId = 'visa_selection_id'
}

/** input type for updating data in table "grad.visa_selection" */
export type GradVisaSelectionSetInput = {
  visa?: Maybe<Scalars['String']>;
  visa_selection_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.visa_selection" */
export enum GradVisaSelectionUpdateColumn {
  /** column name */
  Visa = 'visa',
  /** column name */
  VisaSelectionId = 'visa_selection_id'
}

/**
 * stores student volunteer activities
 *
 *
 * columns and relationships of "grad.volunteer"
 */
export type GradVolunteer = {
  __typename?: 'grad_volunteer';
  /** description of the volunteer activity */
  description: Scalars['String'];
  /** maps to profile.user_id */
  user_id: Scalars['String'];
  /** auto-generated uuid */
  volunteer_id: Scalars['String'];
};

/** aggregated selection of "grad.volunteer" */
export type GradVolunteerAggregate = {
  __typename?: 'grad_volunteer_aggregate';
  aggregate?: Maybe<GradVolunteerAggregateFields>;
  nodes: Array<GradVolunteer>;
};

/** aggregate fields of "grad.volunteer" */
export type GradVolunteerAggregateFields = {
  __typename?: 'grad_volunteer_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradVolunteerMaxFields>;
  min?: Maybe<GradVolunteerMinFields>;
};


/** aggregate fields of "grad.volunteer" */
export type GradVolunteerAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradVolunteerSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.volunteer" */
export type GradVolunteerAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradVolunteerMaxOrderBy>;
  min?: Maybe<GradVolunteerMinOrderBy>;
};

/** input type for inserting array relation for remote table "grad.volunteer" */
export type GradVolunteerArrRelInsertInput = {
  data: Array<GradVolunteerInsertInput>;
  on_conflict?: Maybe<GradVolunteerOnConflict>;
};

/** Boolean expression to filter rows from the table "grad.volunteer". All fields are combined with a logical 'AND'. */
export type GradVolunteerBoolExp = {
  _and?: Maybe<Array<Maybe<GradVolunteerBoolExp>>>;
  _not?: Maybe<GradVolunteerBoolExp>;
  _or?: Maybe<Array<Maybe<GradVolunteerBoolExp>>>;
  description?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
  volunteer_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.volunteer" */
export enum GradVolunteerConstraint {
  /** unique or primary key constraint */
  VolunteerPkey = 'volunteer_pkey',
  /** unique or primary key constraint */
  VolunteerVolunteerIdKey = 'volunteer_volunteer_id_key'
}

/** input type for inserting data into table "grad.volunteer" */
export type GradVolunteerInsertInput = {
  description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  volunteer_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradVolunteerMaxFields = {
  __typename?: 'grad_volunteer_max_fields';
  description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  volunteer_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.volunteer" */
export type GradVolunteerMaxOrderBy = {
  description?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  volunteer_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradVolunteerMinFields = {
  __typename?: 'grad_volunteer_min_fields';
  description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  volunteer_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.volunteer" */
export type GradVolunteerMinOrderBy = {
  description?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  volunteer_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.volunteer" */
export type GradVolunteerMutationResponse = {
  __typename?: 'grad_volunteer_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradVolunteer>;
};

/** input type for inserting object relation for remote table "grad.volunteer" */
export type GradVolunteerObjRelInsertInput = {
  data: GradVolunteerInsertInput;
  on_conflict?: Maybe<GradVolunteerOnConflict>;
};

/** on conflict condition type for table "grad.volunteer" */
export type GradVolunteerOnConflict = {
  constraint: GradVolunteerConstraint;
  update_columns: Array<GradVolunteerUpdateColumn>;
  where?: Maybe<GradVolunteerBoolExp>;
};

/** ordering options when selecting data from "grad.volunteer" */
export type GradVolunteerOrderBy = {
  description?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  volunteer_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.volunteer" */
export type GradVolunteerPkColumnsInput = {
  /** auto-generated uuid */
  volunteer_id: Scalars['String'];
};

/** select columns of table "grad.volunteer" */
export enum GradVolunteerSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VolunteerId = 'volunteer_id'
}

/** input type for updating data in table "grad.volunteer" */
export type GradVolunteerSetInput = {
  description?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  volunteer_id?: Maybe<Scalars['String']>;
};

/** update columns of table "grad.volunteer" */
export enum GradVolunteerUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VolunteerId = 'volunteer_id'
}

/**
 * stores student work experience
 *
 *
 * columns and relationships of "grad.work_experience"
 */
export type GradWorkExperience = {
  __typename?: 'grad_work_experience';
  /** An array relationship */
  awards: Array<GradAward>;
  /** An aggregated array relationship */
  awards_aggregate: GradAwardAggregate;
  /** city the company or position is in */
  city?: Maybe<Scalars['String']>;
  /** company name, from comapny_selection.company */
  company: Scalars['String'];
  /** deprecated */
  current?: Maybe<Scalars['Boolean']>;
  /** description of this position */
  description?: Maybe<Scalars['String']>;
  /** which company division, if any */
  division?: Maybe<Scalars['String']>;
  /** deprecated */
  end_month?: Maybe<Scalars['String']>;
  /** the month the position ends 1 - 12 */
  end_month_numeric?: Maybe<Scalars['Int']>;
  /** the year the student ends this position */
  end_year?: Maybe<Scalars['numeric']>;
  /** fulltime, part time, internship */
  job_type?: Maybe<Scalars['String']>;
  /** position in the company */
  position: Scalars['String'];
  /** is the position relevant to the job applied */
  relevant?: Maybe<Scalars['Boolean']>;
  /** deprecated */
  start_month?: Maybe<Scalars['String']>;
  /** the month the position starts 1 - 12 */
  start_month_numeric?: Maybe<Scalars['Int']>;
  /** the year the student begins in this position */
  start_year?: Maybe<Scalars['numeric']>;
  /** state */
  state?: Maybe<Scalars['String']>;
  /** maps to profile.user_id */
  user_id: Scalars['String'];
  /** auto-generated uuid */
  work_experience_id: Scalars['String'];
};


/**
 * stores student work experience
 *
 *
 * columns and relationships of "grad.work_experience"
 */
export type GradWorkExperienceAwardsArgs = {
  distinct_on?: Maybe<Array<GradAwardSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradAwardOrderBy>>;
  where?: Maybe<GradAwardBoolExp>;
};


/**
 * stores student work experience
 *
 *
 * columns and relationships of "grad.work_experience"
 */
export type GradWorkExperienceAwardsAggregateArgs = {
  distinct_on?: Maybe<Array<GradAwardSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradAwardOrderBy>>;
  where?: Maybe<GradAwardBoolExp>;
};

/** aggregated selection of "grad.work_experience" */
export type GradWorkExperienceAggregate = {
  __typename?: 'grad_work_experience_aggregate';
  aggregate?: Maybe<GradWorkExperienceAggregateFields>;
  nodes: Array<GradWorkExperience>;
};

/** aggregate fields of "grad.work_experience" */
export type GradWorkExperienceAggregateFields = {
  __typename?: 'grad_work_experience_aggregate_fields';
  avg?: Maybe<GradWorkExperienceAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<GradWorkExperienceMaxFields>;
  min?: Maybe<GradWorkExperienceMinFields>;
  stddev?: Maybe<GradWorkExperienceStddevFields>;
  stddev_pop?: Maybe<GradWorkExperienceStddevPopFields>;
  stddev_samp?: Maybe<GradWorkExperienceStddevSampFields>;
  sum?: Maybe<GradWorkExperienceSumFields>;
  var_pop?: Maybe<GradWorkExperienceVarPopFields>;
  var_samp?: Maybe<GradWorkExperienceVarSampFields>;
  variance?: Maybe<GradWorkExperienceVarianceFields>;
};


/** aggregate fields of "grad.work_experience" */
export type GradWorkExperienceAggregateFieldsCountArgs = {
  columns?: Maybe<Array<GradWorkExperienceSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "grad.work_experience" */
export type GradWorkExperienceAggregateOrderBy = {
  avg?: Maybe<GradWorkExperienceAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<GradWorkExperienceMaxOrderBy>;
  min?: Maybe<GradWorkExperienceMinOrderBy>;
  stddev?: Maybe<GradWorkExperienceStddevOrderBy>;
  stddev_pop?: Maybe<GradWorkExperienceStddevPopOrderBy>;
  stddev_samp?: Maybe<GradWorkExperienceStddevSampOrderBy>;
  sum?: Maybe<GradWorkExperienceSumOrderBy>;
  var_pop?: Maybe<GradWorkExperienceVarPopOrderBy>;
  var_samp?: Maybe<GradWorkExperienceVarSampOrderBy>;
  variance?: Maybe<GradWorkExperienceVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "grad.work_experience" */
export type GradWorkExperienceArrRelInsertInput = {
  data: Array<GradWorkExperienceInsertInput>;
  on_conflict?: Maybe<GradWorkExperienceOnConflict>;
};

/** aggregate avg on columns */
export type GradWorkExperienceAvgFields = {
  __typename?: 'grad_work_experience_avg_fields';
  end_month_numeric?: Maybe<Scalars['Float']>;
  end_year?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "grad.work_experience" */
export type GradWorkExperienceAvgOrderBy = {
  end_month_numeric?: Maybe<OrderBy>;
  end_year?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "grad.work_experience". All fields are combined with a logical 'AND'. */
export type GradWorkExperienceBoolExp = {
  _and?: Maybe<Array<Maybe<GradWorkExperienceBoolExp>>>;
  _not?: Maybe<GradWorkExperienceBoolExp>;
  _or?: Maybe<Array<Maybe<GradWorkExperienceBoolExp>>>;
  awards?: Maybe<GradAwardBoolExp>;
  city?: Maybe<StringComparisonExp>;
  company?: Maybe<StringComparisonExp>;
  current?: Maybe<BooleanComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  division?: Maybe<StringComparisonExp>;
  end_month?: Maybe<StringComparisonExp>;
  end_month_numeric?: Maybe<IntComparisonExp>;
  end_year?: Maybe<NumericComparisonExp>;
  job_type?: Maybe<StringComparisonExp>;
  position?: Maybe<StringComparisonExp>;
  relevant?: Maybe<BooleanComparisonExp>;
  start_month?: Maybe<StringComparisonExp>;
  start_month_numeric?: Maybe<IntComparisonExp>;
  start_year?: Maybe<NumericComparisonExp>;
  state?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
  work_experience_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "grad.work_experience" */
export enum GradWorkExperienceConstraint {
  /** unique or primary key constraint */
  WorkExperiencePkey = 'work_experience_pkey',
  /** unique or primary key constraint */
  WorkExperienceWorkExperienceIdKey = 'work_experience_work_experience_id_key'
}

/** input type for incrementing integer column in table "grad.work_experience" */
export type GradWorkExperienceIncInput = {
  end_month_numeric?: Maybe<Scalars['Int']>;
  end_year?: Maybe<Scalars['numeric']>;
  start_month_numeric?: Maybe<Scalars['Int']>;
  start_year?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "grad.work_experience" */
export type GradWorkExperienceInsertInput = {
  awards?: Maybe<GradAwardArrRelInsertInput>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  current?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  division?: Maybe<Scalars['String']>;
  end_month?: Maybe<Scalars['String']>;
  end_month_numeric?: Maybe<Scalars['Int']>;
  end_year?: Maybe<Scalars['numeric']>;
  job_type?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  relevant?: Maybe<Scalars['Boolean']>;
  start_month?: Maybe<Scalars['String']>;
  start_month_numeric?: Maybe<Scalars['Int']>;
  start_year?: Maybe<Scalars['numeric']>;
  state?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  work_experience_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type GradWorkExperienceMaxFields = {
  __typename?: 'grad_work_experience_max_fields';
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  division?: Maybe<Scalars['String']>;
  end_month?: Maybe<Scalars['String']>;
  end_month_numeric?: Maybe<Scalars['Int']>;
  end_year?: Maybe<Scalars['numeric']>;
  job_type?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  start_month?: Maybe<Scalars['String']>;
  start_month_numeric?: Maybe<Scalars['Int']>;
  start_year?: Maybe<Scalars['numeric']>;
  state?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  work_experience_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "grad.work_experience" */
export type GradWorkExperienceMaxOrderBy = {
  city?: Maybe<OrderBy>;
  company?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  division?: Maybe<OrderBy>;
  end_month?: Maybe<OrderBy>;
  end_month_numeric?: Maybe<OrderBy>;
  end_year?: Maybe<OrderBy>;
  job_type?: Maybe<OrderBy>;
  position?: Maybe<OrderBy>;
  start_month?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
  state?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  work_experience_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type GradWorkExperienceMinFields = {
  __typename?: 'grad_work_experience_min_fields';
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  division?: Maybe<Scalars['String']>;
  end_month?: Maybe<Scalars['String']>;
  end_month_numeric?: Maybe<Scalars['Int']>;
  end_year?: Maybe<Scalars['numeric']>;
  job_type?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  start_month?: Maybe<Scalars['String']>;
  start_month_numeric?: Maybe<Scalars['Int']>;
  start_year?: Maybe<Scalars['numeric']>;
  state?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  work_experience_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "grad.work_experience" */
export type GradWorkExperienceMinOrderBy = {
  city?: Maybe<OrderBy>;
  company?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  division?: Maybe<OrderBy>;
  end_month?: Maybe<OrderBy>;
  end_month_numeric?: Maybe<OrderBy>;
  end_year?: Maybe<OrderBy>;
  job_type?: Maybe<OrderBy>;
  position?: Maybe<OrderBy>;
  start_month?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
  state?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  work_experience_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "grad.work_experience" */
export type GradWorkExperienceMutationResponse = {
  __typename?: 'grad_work_experience_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<GradWorkExperience>;
};

/** input type for inserting object relation for remote table "grad.work_experience" */
export type GradWorkExperienceObjRelInsertInput = {
  data: GradWorkExperienceInsertInput;
  on_conflict?: Maybe<GradWorkExperienceOnConflict>;
};

/** on conflict condition type for table "grad.work_experience" */
export type GradWorkExperienceOnConflict = {
  constraint: GradWorkExperienceConstraint;
  update_columns: Array<GradWorkExperienceUpdateColumn>;
  where?: Maybe<GradWorkExperienceBoolExp>;
};

/** ordering options when selecting data from "grad.work_experience" */
export type GradWorkExperienceOrderBy = {
  awards_aggregate?: Maybe<GradAwardAggregateOrderBy>;
  city?: Maybe<OrderBy>;
  company?: Maybe<OrderBy>;
  current?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  division?: Maybe<OrderBy>;
  end_month?: Maybe<OrderBy>;
  end_month_numeric?: Maybe<OrderBy>;
  end_year?: Maybe<OrderBy>;
  job_type?: Maybe<OrderBy>;
  position?: Maybe<OrderBy>;
  relevant?: Maybe<OrderBy>;
  start_month?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
  state?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
  work_experience_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "grad.work_experience" */
export type GradWorkExperiencePkColumnsInput = {
  /** auto-generated uuid */
  work_experience_id: Scalars['String'];
};

/** select columns of table "grad.work_experience" */
export enum GradWorkExperienceSelectColumn {
  /** column name */
  City = 'city',
  /** column name */
  Company = 'company',
  /** column name */
  Current = 'current',
  /** column name */
  Description = 'description',
  /** column name */
  Division = 'division',
  /** column name */
  EndMonth = 'end_month',
  /** column name */
  EndMonthNumeric = 'end_month_numeric',
  /** column name */
  EndYear = 'end_year',
  /** column name */
  JobType = 'job_type',
  /** column name */
  Position = 'position',
  /** column name */
  Relevant = 'relevant',
  /** column name */
  StartMonth = 'start_month',
  /** column name */
  StartMonthNumeric = 'start_month_numeric',
  /** column name */
  StartYear = 'start_year',
  /** column name */
  State = 'state',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WorkExperienceId = 'work_experience_id'
}

/** input type for updating data in table "grad.work_experience" */
export type GradWorkExperienceSetInput = {
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  current?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  division?: Maybe<Scalars['String']>;
  end_month?: Maybe<Scalars['String']>;
  end_month_numeric?: Maybe<Scalars['Int']>;
  end_year?: Maybe<Scalars['numeric']>;
  job_type?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  relevant?: Maybe<Scalars['Boolean']>;
  start_month?: Maybe<Scalars['String']>;
  start_month_numeric?: Maybe<Scalars['Int']>;
  start_year?: Maybe<Scalars['numeric']>;
  state?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  work_experience_id?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type GradWorkExperienceStddevFields = {
  __typename?: 'grad_work_experience_stddev_fields';
  end_month_numeric?: Maybe<Scalars['Float']>;
  end_year?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "grad.work_experience" */
export type GradWorkExperienceStddevOrderBy = {
  end_month_numeric?: Maybe<OrderBy>;
  end_year?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type GradWorkExperienceStddevPopFields = {
  __typename?: 'grad_work_experience_stddev_pop_fields';
  end_month_numeric?: Maybe<Scalars['Float']>;
  end_year?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "grad.work_experience" */
export type GradWorkExperienceStddevPopOrderBy = {
  end_month_numeric?: Maybe<OrderBy>;
  end_year?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type GradWorkExperienceStddevSampFields = {
  __typename?: 'grad_work_experience_stddev_samp_fields';
  end_month_numeric?: Maybe<Scalars['Float']>;
  end_year?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "grad.work_experience" */
export type GradWorkExperienceStddevSampOrderBy = {
  end_month_numeric?: Maybe<OrderBy>;
  end_year?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type GradWorkExperienceSumFields = {
  __typename?: 'grad_work_experience_sum_fields';
  end_month_numeric?: Maybe<Scalars['Int']>;
  end_year?: Maybe<Scalars['numeric']>;
  start_month_numeric?: Maybe<Scalars['Int']>;
  start_year?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "grad.work_experience" */
export type GradWorkExperienceSumOrderBy = {
  end_month_numeric?: Maybe<OrderBy>;
  end_year?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** update columns of table "grad.work_experience" */
export enum GradWorkExperienceUpdateColumn {
  /** column name */
  City = 'city',
  /** column name */
  Company = 'company',
  /** column name */
  Current = 'current',
  /** column name */
  Description = 'description',
  /** column name */
  Division = 'division',
  /** column name */
  EndMonth = 'end_month',
  /** column name */
  EndMonthNumeric = 'end_month_numeric',
  /** column name */
  EndYear = 'end_year',
  /** column name */
  JobType = 'job_type',
  /** column name */
  Position = 'position',
  /** column name */
  Relevant = 'relevant',
  /** column name */
  StartMonth = 'start_month',
  /** column name */
  StartMonthNumeric = 'start_month_numeric',
  /** column name */
  StartYear = 'start_year',
  /** column name */
  State = 'state',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WorkExperienceId = 'work_experience_id'
}

/** aggregate var_pop on columns */
export type GradWorkExperienceVarPopFields = {
  __typename?: 'grad_work_experience_var_pop_fields';
  end_month_numeric?: Maybe<Scalars['Float']>;
  end_year?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "grad.work_experience" */
export type GradWorkExperienceVarPopOrderBy = {
  end_month_numeric?: Maybe<OrderBy>;
  end_year?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type GradWorkExperienceVarSampFields = {
  __typename?: 'grad_work_experience_var_samp_fields';
  end_month_numeric?: Maybe<Scalars['Float']>;
  end_year?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "grad.work_experience" */
export type GradWorkExperienceVarSampOrderBy = {
  end_month_numeric?: Maybe<OrderBy>;
  end_year?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type GradWorkExperienceVarianceFields = {
  __typename?: 'grad_work_experience_variance_fields';
  end_month_numeric?: Maybe<Scalars['Float']>;
  end_year?: Maybe<Scalars['Float']>;
  start_month_numeric?: Maybe<Scalars['Float']>;
  start_year?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "grad.work_experience" */
export type GradWorkExperienceVarianceOrderBy = {
  end_month_numeric?: Maybe<OrderBy>;
  end_year?: Maybe<OrderBy>;
  start_month_numeric?: Maybe<OrderBy>;
  start_year?: Maybe<OrderBy>;
};


/** expression to compare columns of type json. All fields are combined with logical 'AND'. */
export type JsonComparisonExp = {
  _eq?: Maybe<Scalars['json']>;
  _gt?: Maybe<Scalars['json']>;
  _gte?: Maybe<Scalars['json']>;
  _in?: Maybe<Array<Scalars['json']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['json']>;
  _lte?: Maybe<Scalars['json']>;
  _neq?: Maybe<Scalars['json']>;
  _nin?: Maybe<Array<Scalars['json']>>;
};


/** expression to compare columns of type jsonb. All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  /** is the column contained in the given json value */
  _contained_in?: Maybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: Maybe<Scalars['jsonb']>;
  _eq?: Maybe<Scalars['jsonb']>;
  _gt?: Maybe<Scalars['jsonb']>;
  _gte?: Maybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: Maybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: Maybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: Maybe<Array<Scalars['String']>>;
  _in?: Maybe<Array<Scalars['jsonb']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['jsonb']>;
  _lte?: Maybe<Scalars['jsonb']>;
  _neq?: Maybe<Scalars['jsonb']>;
  _nin?: Maybe<Array<Scalars['jsonb']>>;
};

/** mutation root */
export type MutationRoot = {
  __typename?: 'mutation_root';
  /** delete data from the table: "admin.adminuser" */
  delete_admin_adminuser?: Maybe<AdminAdminuserMutationResponse>;
  /** delete single row from the table: "admin.adminuser" */
  delete_admin_adminuser_by_pk?: Maybe<AdminAdminuser>;
  /** delete data from the table: "admin.auth0mgmt" */
  delete_admin_auth0mgmt?: Maybe<AdminAuth0mgmtMutationResponse>;
  /** delete single row from the table: "admin.auth0mgmt" */
  delete_admin_auth0mgmt_by_pk?: Maybe<AdminAuth0mgmt>;
  /** delete data from the table: "admin.auth0mgmt_result" */
  delete_admin_auth0mgmt_result?: Maybe<AdminAuth0mgmtResultMutationResponse>;
  /** delete single row from the table: "admin.auth0mgmt_result" */
  delete_admin_auth0mgmt_result_by_pk?: Maybe<AdminAuth0mgmtResult>;
  /** delete data from the table: "admin.email" */
  delete_admin_email?: Maybe<AdminEmailMutationResponse>;
  /** delete single row from the table: "admin.email" */
  delete_admin_email_by_pk?: Maybe<AdminEmail>;
  /** delete data from the table: "admin.email_layout" */
  delete_admin_email_layout?: Maybe<AdminEmailLayoutMutationResponse>;
  /** delete single row from the table: "admin.email_layout" */
  delete_admin_email_layout_by_pk?: Maybe<AdminEmailLayout>;
  /** delete data from the table: "admin.email_template" */
  delete_admin_email_template?: Maybe<AdminEmailTemplateMutationResponse>;
  /** delete single row from the table: "admin.email_template" */
  delete_admin_email_template_by_pk?: Maybe<AdminEmailTemplate>;
  /** delete data from the table: "admin.twiliomgmt" */
  delete_admin_twiliomgmt?: Maybe<AdminTwiliomgmtMutationResponse>;
  /** delete single row from the table: "admin.twiliomgmt" */
  delete_admin_twiliomgmt_by_pk?: Maybe<AdminTwiliomgmt>;
  /** delete data from the table: "admin.twiliomgmt_result" */
  delete_admin_twiliomgmt_result?: Maybe<AdminTwiliomgmtResultMutationResponse>;
  /** delete single row from the table: "admin.twiliomgmt_result" */
  delete_admin_twiliomgmt_result_by_pk?: Maybe<AdminTwiliomgmtResult>;
  /** delete data from the table: "db_ping" */
  delete_db_ping?: Maybe<DbPingMutationResponse>;
  /** delete single row from the table: "db_ping" */
  delete_db_ping_by_pk?: Maybe<DbPing>;
  /** delete data from the table: "db_state" */
  delete_db_state?: Maybe<DbStateMutationResponse>;
  /** delete single row from the table: "db_state" */
  delete_db_state_by_pk?: Maybe<DbState>;
  /** delete data from the table: "grad.achievement" */
  delete_grad_achievement?: Maybe<GradAchievementMutationResponse>;
  /** delete single row from the table: "grad.achievement" */
  delete_grad_achievement_by_pk?: Maybe<GradAchievement>;
  /** delete data from the table: "grad.award" */
  delete_grad_award?: Maybe<GradAwardMutationResponse>;
  /** delete single row from the table: "grad.award" */
  delete_grad_award_by_pk?: Maybe<GradAward>;
  /** delete data from the table: "grad.bookmark_job" */
  delete_grad_bookmark_job?: Maybe<GradBookmarkJobMutationResponse>;
  /** delete single row from the table: "grad.bookmark_job" */
  delete_grad_bookmark_job_by_pk?: Maybe<GradBookmarkJob>;
  /** delete data from the table: "grad.city_state_selection" */
  delete_grad_city_state_selection?: Maybe<GradCityStateSelectionMutationResponse>;
  /** delete single row from the table: "grad.city_state_selection" */
  delete_grad_city_state_selection_by_pk?: Maybe<GradCityStateSelection>;
  /** delete data from the table: "grad.comm_preference_selection" */
  delete_grad_comm_preference_selection?: Maybe<GradCommPreferenceSelectionMutationResponse>;
  /** delete single row from the table: "grad.comm_preference_selection" */
  delete_grad_comm_preference_selection_by_pk?: Maybe<GradCommPreferenceSelection>;
  /** delete data from the table: "grad.company_selection" */
  delete_grad_company_selection?: Maybe<GradCompanySelectionMutationResponse>;
  /** delete single row from the table: "grad.company_selection" */
  delete_grad_company_selection_by_pk?: Maybe<GradCompanySelection>;
  /** delete data from the table: "grad.computer_language" */
  delete_grad_computer_language?: Maybe<GradComputerLanguageMutationResponse>;
  /** delete single row from the table: "grad.computer_language" */
  delete_grad_computer_language_by_pk?: Maybe<GradComputerLanguage>;
  /** delete data from the table: "grad.computer_language_selection" */
  delete_grad_computer_language_selection?: Maybe<GradComputerLanguageSelectionMutationResponse>;
  /** delete single row from the table: "grad.computer_language_selection" */
  delete_grad_computer_language_selection_by_pk?: Maybe<GradComputerLanguageSelection>;
  /** delete data from the table: "grad.concentration" */
  delete_grad_concentration?: Maybe<GradConcentrationMutationResponse>;
  /** delete single row from the table: "grad.concentration" */
  delete_grad_concentration_by_pk?: Maybe<GradConcentration>;
  /** delete data from the table: "grad.country_selection" */
  delete_grad_country_selection?: Maybe<GradCountrySelectionMutationResponse>;
  /** delete single row from the table: "grad.country_selection" */
  delete_grad_country_selection_by_pk?: Maybe<GradCountrySelection>;
  /** delete data from the table: "grad.degree" */
  delete_grad_degree?: Maybe<GradDegreeMutationResponse>;
  /** delete single row from the table: "grad.degree" */
  delete_grad_degree_by_pk?: Maybe<GradDegree>;
  /** delete data from the table: "grad.degree_fill_in_university" */
  delete_grad_degree_fill_in_university?: Maybe<GradDegreeFillInUniversityMutationResponse>;
  /** delete single row from the table: "grad.degree_fill_in_university" */
  delete_grad_degree_fill_in_university_by_pk?: Maybe<GradDegreeFillInUniversity>;
  /** delete data from the table: "grad.degree_selection" */
  delete_grad_degree_selection?: Maybe<GradDegreeSelectionMutationResponse>;
  /** delete single row from the table: "grad.degree_selection" */
  delete_grad_degree_selection_by_pk?: Maybe<GradDegreeSelection>;
  /** delete data from the table: "grad.employer_preference" */
  delete_grad_employer_preference?: Maybe<GradEmployerPreferenceMutationResponse>;
  /** delete single row from the table: "grad.employer_preference" */
  delete_grad_employer_preference_by_pk?: Maybe<GradEmployerPreference>;
  /** delete data from the table: "grad.employer_preference_selection" */
  delete_grad_employer_preference_selection?: Maybe<GradEmployerPreferenceSelectionMutationResponse>;
  /** delete single row from the table: "grad.employer_preference_selection" */
  delete_grad_employer_preference_selection_by_pk?: Maybe<GradEmployerPreferenceSelection>;
  /** delete data from the table: "grad.event_registration" */
  delete_grad_event_registration?: Maybe<GradEventRegistrationMutationResponse>;
  /** delete single row from the table: "grad.event_registration" */
  delete_grad_event_registration_by_pk?: Maybe<GradEventRegistration>;
  /** delete data from the table: "grad.fun_fact" */
  delete_grad_fun_fact?: Maybe<GradFunFactMutationResponse>;
  /** delete single row from the table: "grad.fun_fact" */
  delete_grad_fun_fact_by_pk?: Maybe<GradFunFact>;
  /** delete data from the table: "grad.fun_fact_selection" */
  delete_grad_fun_fact_selection?: Maybe<GradFunFactSelectionMutationResponse>;
  /** delete single row from the table: "grad.fun_fact_selection" */
  delete_grad_fun_fact_selection_by_pk?: Maybe<GradFunFactSelection>;
  /** delete data from the table: "grad.interest_firm" */
  delete_grad_interest_firm?: Maybe<GradInterestFirmMutationResponse>;
  /** delete single row from the table: "grad.interest_firm" */
  delete_grad_interest_firm_by_pk?: Maybe<GradInterestFirm>;
  /** delete data from the table: "grad.interest_firm_selection" */
  delete_grad_interest_firm_selection?: Maybe<GradInterestFirmSelectionMutationResponse>;
  /** delete single row from the table: "grad.interest_firm_selection" */
  delete_grad_interest_firm_selection_by_pk?: Maybe<GradInterestFirmSelection>;
  /** delete data from the table: "grad.interest_job_type" */
  delete_grad_interest_job_type?: Maybe<GradInterestJobTypeMutationResponse>;
  /** delete single row from the table: "grad.interest_job_type" */
  delete_grad_interest_job_type_by_pk?: Maybe<GradInterestJobType>;
  /** delete data from the table: "grad.interest_job_type_selection" */
  delete_grad_interest_job_type_selection?: Maybe<GradInterestJobTypeSelectionMutationResponse>;
  /** delete single row from the table: "grad.interest_job_type_selection" */
  delete_grad_interest_job_type_selection_by_pk?: Maybe<GradInterestJobTypeSelection>;
  /** delete data from the table: "grad.interest_region" */
  delete_grad_interest_region?: Maybe<GradInterestRegionMutationResponse>;
  /** delete single row from the table: "grad.interest_region" */
  delete_grad_interest_region_by_pk?: Maybe<GradInterestRegion>;
  /** delete data from the table: "grad.interest_region_selection" */
  delete_grad_interest_region_selection?: Maybe<GradInterestRegionSelectionMutationResponse>;
  /** delete single row from the table: "grad.interest_region_selection" */
  delete_grad_interest_region_selection_by_pk?: Maybe<GradInterestRegionSelection>;
  /** delete data from the table: "grad.interest_role" */
  delete_grad_interest_role?: Maybe<GradInterestRoleMutationResponse>;
  /** delete single row from the table: "grad.interest_role" */
  delete_grad_interest_role_by_pk?: Maybe<GradInterestRole>;
  /** delete data from the table: "grad.interest_role_selection" */
  delete_grad_interest_role_selection?: Maybe<GradInterestRoleSelectionMutationResponse>;
  /** delete single row from the table: "grad.interest_role_selection" */
  delete_grad_interest_role_selection_by_pk?: Maybe<GradInterestRoleSelection>;
  /** delete data from the table: "grad.major_selection" */
  delete_grad_major_selection?: Maybe<GradMajorSelectionMutationResponse>;
  /** delete single row from the table: "grad.major_selection" */
  delete_grad_major_selection_by_pk?: Maybe<GradMajorSelection>;
  /** delete data from the table: "grad.page_view" */
  delete_grad_page_view?: Maybe<GradPageViewMutationResponse>;
  /** delete single row from the table: "grad.page_view" */
  delete_grad_page_view_by_pk?: Maybe<GradPageView>;
  /** delete data from the table: "grad.profile" */
  delete_grad_profile?: Maybe<GradProfileMutationResponse>;
  /** delete single row from the table: "grad.profile" */
  delete_grad_profile_by_pk?: Maybe<GradProfile>;
  /** delete data from the table: "grad.profile_combine" */
  delete_grad_profile_combine?: Maybe<GradProfileCombineMutationResponse>;
  /** delete data from the table: "grad.raise_hand" */
  delete_grad_raise_hand?: Maybe<GradRaiseHandMutationResponse>;
  /** delete single row from the table: "grad.raise_hand" */
  delete_grad_raise_hand_by_pk?: Maybe<GradRaiseHand>;
  /** delete data from the table: "grad.spoken_language" */
  delete_grad_spoken_language?: Maybe<GradSpokenLanguageMutationResponse>;
  /** delete single row from the table: "grad.spoken_language" */
  delete_grad_spoken_language_by_pk?: Maybe<GradSpokenLanguage>;
  /** delete data from the table: "grad.test_score" */
  delete_grad_test_score?: Maybe<GradTestScoreMutationResponse>;
  /** delete single row from the table: "grad.test_score" */
  delete_grad_test_score_by_pk?: Maybe<GradTestScore>;
  /** delete data from the table: "grad.test_score_detail" */
  delete_grad_test_score_detail?: Maybe<GradTestScoreDetailMutationResponse>;
  /** delete single row from the table: "grad.test_score_detail" */
  delete_grad_test_score_detail_by_pk?: Maybe<GradTestScoreDetail>;
  /** delete data from the table: "grad.university_selection" */
  delete_grad_university_selection?: Maybe<GradUniversitySelectionMutationResponse>;
  /** delete single row from the table: "grad.university_selection" */
  delete_grad_university_selection_by_pk?: Maybe<GradUniversitySelection>;
  /** delete data from the table: "grad.university_stat" */
  delete_grad_university_stat?: Maybe<GradUniversityStatMutationResponse>;
  /** delete data from the table: "grad.upload_doc" */
  delete_grad_upload_doc?: Maybe<GradUploadDocMutationResponse>;
  /** delete single row from the table: "grad.upload_doc" */
  delete_grad_upload_doc_by_pk?: Maybe<GradUploadDoc>;
  /** delete data from the table: "grad.user_activity_summary" */
  delete_grad_user_activity_summary?: Maybe<GradUserActivitySummaryMutationResponse>;
  /** delete single row from the table: "grad.user_activity_summary" */
  delete_grad_user_activity_summary_by_pk?: Maybe<GradUserActivitySummary>;
  /** delete data from the table: "grad.visa_selection" */
  delete_grad_visa_selection?: Maybe<GradVisaSelectionMutationResponse>;
  /** delete single row from the table: "grad.visa_selection" */
  delete_grad_visa_selection_by_pk?: Maybe<GradVisaSelection>;
  /** delete data from the table: "grad.volunteer" */
  delete_grad_volunteer?: Maybe<GradVolunteerMutationResponse>;
  /** delete single row from the table: "grad.volunteer" */
  delete_grad_volunteer_by_pk?: Maybe<GradVolunteer>;
  /** delete data from the table: "grad.work_experience" */
  delete_grad_work_experience?: Maybe<GradWorkExperienceMutationResponse>;
  /** delete single row from the table: "grad.work_experience" */
  delete_grad_work_experience_by_pk?: Maybe<GradWorkExperience>;
  /** delete data from the table: "queue_handler_permission" */
  delete_queue_handler_permission?: Maybe<QueueHandlerPermissionMutationResponse>;
  /** delete single row from the table: "queue_handler_permission" */
  delete_queue_handler_permission_by_pk?: Maybe<QueueHandlerPermission>;
  /** delete data from the table: "recruit.account" */
  delete_recruit_account?: Maybe<RecruitAccountMutationResponse>;
  /** delete single row from the table: "recruit.account" */
  delete_recruit_account_by_pk?: Maybe<RecruitAccount>;
  /** delete data from the table: "recruit.company" */
  delete_recruit_company?: Maybe<RecruitCompanyMutationResponse>;
  /** delete single row from the table: "recruit.company" */
  delete_recruit_company_by_pk?: Maybe<RecruitCompany>;
  /** delete data from the table: "recruit.company_subindustry" */
  delete_recruit_company_subindustry?: Maybe<RecruitCompanySubindustryMutationResponse>;
  /** delete single row from the table: "recruit.company_subindustry" */
  delete_recruit_company_subindustry_by_pk?: Maybe<RecruitCompanySubindustry>;
  /** delete data from the table: "recruit.event" */
  delete_recruit_event?: Maybe<RecruitEventMutationResponse>;
  /** delete single row from the table: "recruit.event" */
  delete_recruit_event_by_pk?: Maybe<RecruitEvent>;
  /** delete data from the table: "recruit.grad_group" */
  delete_recruit_grad_group?: Maybe<RecruitGradGroupMutationResponse>;
  /** delete single row from the table: "recruit.grad_group" */
  delete_recruit_grad_group_by_pk?: Maybe<RecruitGradGroup>;
  /** delete data from the table: "recruit.grad_group_member" */
  delete_recruit_grad_group_member?: Maybe<RecruitGradGroupMemberMutationResponse>;
  /** delete single row from the table: "recruit.grad_group_member" */
  delete_recruit_grad_group_member_by_pk?: Maybe<RecruitGradGroupMember>;
  /** delete data from the table: "recruit.job_posting" */
  delete_recruit_job_posting?: Maybe<RecruitJobPostingMutationResponse>;
  /** delete single row from the table: "recruit.job_posting" */
  delete_recruit_job_posting_by_pk?: Maybe<RecruitJobPosting>;
  /** delete data from the table: "recruit.job_requirement" */
  delete_recruit_job_requirement?: Maybe<RecruitJobRequirementMutationResponse>;
  /** delete single row from the table: "recruit.job_requirement" */
  delete_recruit_job_requirement_by_pk?: Maybe<RecruitJobRequirement>;
  /** delete data from the table: "recruit.job_requirement_value" */
  delete_recruit_job_requirement_value?: Maybe<RecruitJobRequirementValueMutationResponse>;
  /** delete single row from the table: "recruit.job_requirement_value" */
  delete_recruit_job_requirement_value_by_pk?: Maybe<RecruitJobRequirementValue>;
  /** delete data from the table: "recruit.recruiter" */
  delete_recruit_recruiter?: Maybe<RecruitRecruiterMutationResponse>;
  /** delete single row from the table: "recruit.recruiter" */
  delete_recruit_recruiter_by_pk?: Maybe<RecruitRecruiter>;
  /** delete data from the table: "recruit.saved_search" */
  delete_recruit_saved_search?: Maybe<RecruitSavedSearchMutationResponse>;
  /** delete single row from the table: "recruit.saved_search" */
  delete_recruit_saved_search_by_pk?: Maybe<RecruitSavedSearch>;
  /** delete data from the table: "recruit.sms_correspondent" */
  delete_recruit_sms_correspondent?: Maybe<RecruitSmsCorrespondentMutationResponse>;
  /** delete single row from the table: "recruit.sms_correspondent" */
  delete_recruit_sms_correspondent_by_pk?: Maybe<RecruitSmsCorrespondent>;
  /** delete data from the table: "recruit.sms_message" */
  delete_recruit_sms_message?: Maybe<RecruitSmsMessageMutationResponse>;
  /** delete single row from the table: "recruit.sms_message" */
  delete_recruit_sms_message_by_pk?: Maybe<RecruitSmsMessage>;
  /** delete data from the table: "recruit.sms_message_correspondent" */
  delete_recruit_sms_message_correspondent?: Maybe<RecruitSmsMessageCorrespondentMutationResponse>;
  /** delete single row from the table: "recruit.sms_message_correspondent" */
  delete_recruit_sms_message_correspondent_by_pk?: Maybe<RecruitSmsMessageCorrespondent>;
  /** delete data from the table: "recruit.sms_template" */
  delete_recruit_sms_template?: Maybe<RecruitSmsTemplateMutationResponse>;
  /** delete single row from the table: "recruit.sms_template" */
  delete_recruit_sms_template_by_pk?: Maybe<RecruitSmsTemplate>;
  /** delete data from the table: "test_auto3" */
  delete_test_auto3?: Maybe<TestAuto3MutationResponse>;
  /** delete single row from the table: "test_auto3" */
  delete_test_auto3_by_pk?: Maybe<TestAuto3>;
  /** delete data from the table: "to_queue" */
  delete_to_queue?: Maybe<ToQueueMutationResponse>;
  /** delete single row from the table: "to_queue" */
  delete_to_queue_by_pk?: Maybe<ToQueue>;
  /** delete data from the table: "to_queue_response" */
  delete_to_queue_response?: Maybe<ToQueueResponseMutationResponse>;
  /** delete single row from the table: "to_queue_response" */
  delete_to_queue_response_by_pk?: Maybe<ToQueueResponse>;
  /** delete data from the table: "user_auth" */
  delete_user_auth?: Maybe<UserAuthMutationResponse>;
  /** delete single row from the table: "user_auth" */
  delete_user_auth_by_pk?: Maybe<UserAuth>;
  /** delete data from the table: "useraccount" */
  delete_useraccount?: Maybe<UseraccountMutationResponse>;
  /** delete single row from the table: "useraccount" */
  delete_useraccount_by_pk?: Maybe<Useraccount>;
  /** delete data from the table: "web_api_permission" */
  delete_web_api_permission?: Maybe<WebApiPermissionMutationResponse>;
  /** delete single row from the table: "web_api_permission" */
  delete_web_api_permission_by_pk?: Maybe<WebApiPermission>;
  /** insert data into the table: "admin.adminuser" */
  insert_admin_adminuser?: Maybe<AdminAdminuserMutationResponse>;
  /** insert a single row into the table: "admin.adminuser" */
  insert_admin_adminuser_one?: Maybe<AdminAdminuser>;
  /** insert data into the table: "admin.auth0mgmt" */
  insert_admin_auth0mgmt?: Maybe<AdminAuth0mgmtMutationResponse>;
  /** insert a single row into the table: "admin.auth0mgmt" */
  insert_admin_auth0mgmt_one?: Maybe<AdminAuth0mgmt>;
  /** insert data into the table: "admin.auth0mgmt_result" */
  insert_admin_auth0mgmt_result?: Maybe<AdminAuth0mgmtResultMutationResponse>;
  /** insert a single row into the table: "admin.auth0mgmt_result" */
  insert_admin_auth0mgmt_result_one?: Maybe<AdminAuth0mgmtResult>;
  /** insert data into the table: "admin.email" */
  insert_admin_email?: Maybe<AdminEmailMutationResponse>;
  /** insert data into the table: "admin.email_layout" */
  insert_admin_email_layout?: Maybe<AdminEmailLayoutMutationResponse>;
  /** insert a single row into the table: "admin.email_layout" */
  insert_admin_email_layout_one?: Maybe<AdminEmailLayout>;
  /** insert a single row into the table: "admin.email" */
  insert_admin_email_one?: Maybe<AdminEmail>;
  /** insert data into the table: "admin.email_template" */
  insert_admin_email_template?: Maybe<AdminEmailTemplateMutationResponse>;
  /** insert a single row into the table: "admin.email_template" */
  insert_admin_email_template_one?: Maybe<AdminEmailTemplate>;
  /** insert data into the table: "admin.twiliomgmt" */
  insert_admin_twiliomgmt?: Maybe<AdminTwiliomgmtMutationResponse>;
  /** insert a single row into the table: "admin.twiliomgmt" */
  insert_admin_twiliomgmt_one?: Maybe<AdminTwiliomgmt>;
  /** insert data into the table: "admin.twiliomgmt_result" */
  insert_admin_twiliomgmt_result?: Maybe<AdminTwiliomgmtResultMutationResponse>;
  /** insert a single row into the table: "admin.twiliomgmt_result" */
  insert_admin_twiliomgmt_result_one?: Maybe<AdminTwiliomgmtResult>;
  /** insert data into the table: "db_ping" */
  insert_db_ping?: Maybe<DbPingMutationResponse>;
  /** insert a single row into the table: "db_ping" */
  insert_db_ping_one?: Maybe<DbPing>;
  /** insert data into the table: "db_state" */
  insert_db_state?: Maybe<DbStateMutationResponse>;
  /** insert a single row into the table: "db_state" */
  insert_db_state_one?: Maybe<DbState>;
  /** insert data into the table: "grad.achievement" */
  insert_grad_achievement?: Maybe<GradAchievementMutationResponse>;
  /** insert a single row into the table: "grad.achievement" */
  insert_grad_achievement_one?: Maybe<GradAchievement>;
  /** insert data into the table: "grad.award" */
  insert_grad_award?: Maybe<GradAwardMutationResponse>;
  /** insert a single row into the table: "grad.award" */
  insert_grad_award_one?: Maybe<GradAward>;
  /** insert data into the table: "grad.bookmark_job" */
  insert_grad_bookmark_job?: Maybe<GradBookmarkJobMutationResponse>;
  /** insert a single row into the table: "grad.bookmark_job" */
  insert_grad_bookmark_job_one?: Maybe<GradBookmarkJob>;
  /** insert data into the table: "grad.city_state_selection" */
  insert_grad_city_state_selection?: Maybe<GradCityStateSelectionMutationResponse>;
  /** insert a single row into the table: "grad.city_state_selection" */
  insert_grad_city_state_selection_one?: Maybe<GradCityStateSelection>;
  /** insert data into the table: "grad.comm_preference_selection" */
  insert_grad_comm_preference_selection?: Maybe<GradCommPreferenceSelectionMutationResponse>;
  /** insert a single row into the table: "grad.comm_preference_selection" */
  insert_grad_comm_preference_selection_one?: Maybe<GradCommPreferenceSelection>;
  /** insert data into the table: "grad.company_selection" */
  insert_grad_company_selection?: Maybe<GradCompanySelectionMutationResponse>;
  /** insert a single row into the table: "grad.company_selection" */
  insert_grad_company_selection_one?: Maybe<GradCompanySelection>;
  /** insert data into the table: "grad.computer_language" */
  insert_grad_computer_language?: Maybe<GradComputerLanguageMutationResponse>;
  /** insert a single row into the table: "grad.computer_language" */
  insert_grad_computer_language_one?: Maybe<GradComputerLanguage>;
  /** insert data into the table: "grad.computer_language_selection" */
  insert_grad_computer_language_selection?: Maybe<GradComputerLanguageSelectionMutationResponse>;
  /** insert a single row into the table: "grad.computer_language_selection" */
  insert_grad_computer_language_selection_one?: Maybe<GradComputerLanguageSelection>;
  /** insert data into the table: "grad.concentration" */
  insert_grad_concentration?: Maybe<GradConcentrationMutationResponse>;
  /** insert a single row into the table: "grad.concentration" */
  insert_grad_concentration_one?: Maybe<GradConcentration>;
  /** insert data into the table: "grad.country_selection" */
  insert_grad_country_selection?: Maybe<GradCountrySelectionMutationResponse>;
  /** insert a single row into the table: "grad.country_selection" */
  insert_grad_country_selection_one?: Maybe<GradCountrySelection>;
  /** insert data into the table: "grad.degree" */
  insert_grad_degree?: Maybe<GradDegreeMutationResponse>;
  /** insert data into the table: "grad.degree_fill_in_university" */
  insert_grad_degree_fill_in_university?: Maybe<GradDegreeFillInUniversityMutationResponse>;
  /** insert a single row into the table: "grad.degree_fill_in_university" */
  insert_grad_degree_fill_in_university_one?: Maybe<GradDegreeFillInUniversity>;
  /** insert a single row into the table: "grad.degree" */
  insert_grad_degree_one?: Maybe<GradDegree>;
  /** insert data into the table: "grad.degree_selection" */
  insert_grad_degree_selection?: Maybe<GradDegreeSelectionMutationResponse>;
  /** insert a single row into the table: "grad.degree_selection" */
  insert_grad_degree_selection_one?: Maybe<GradDegreeSelection>;
  /** insert data into the table: "grad.employer_preference" */
  insert_grad_employer_preference?: Maybe<GradEmployerPreferenceMutationResponse>;
  /** insert a single row into the table: "grad.employer_preference" */
  insert_grad_employer_preference_one?: Maybe<GradEmployerPreference>;
  /** insert data into the table: "grad.employer_preference_selection" */
  insert_grad_employer_preference_selection?: Maybe<GradEmployerPreferenceSelectionMutationResponse>;
  /** insert a single row into the table: "grad.employer_preference_selection" */
  insert_grad_employer_preference_selection_one?: Maybe<GradEmployerPreferenceSelection>;
  /** insert data into the table: "grad.event_registration" */
  insert_grad_event_registration?: Maybe<GradEventRegistrationMutationResponse>;
  /** insert a single row into the table: "grad.event_registration" */
  insert_grad_event_registration_one?: Maybe<GradEventRegistration>;
  /** insert data into the table: "grad.fun_fact" */
  insert_grad_fun_fact?: Maybe<GradFunFactMutationResponse>;
  /** insert a single row into the table: "grad.fun_fact" */
  insert_grad_fun_fact_one?: Maybe<GradFunFact>;
  /** insert data into the table: "grad.fun_fact_selection" */
  insert_grad_fun_fact_selection?: Maybe<GradFunFactSelectionMutationResponse>;
  /** insert a single row into the table: "grad.fun_fact_selection" */
  insert_grad_fun_fact_selection_one?: Maybe<GradFunFactSelection>;
  /** insert data into the table: "grad.interest_firm" */
  insert_grad_interest_firm?: Maybe<GradInterestFirmMutationResponse>;
  /** insert a single row into the table: "grad.interest_firm" */
  insert_grad_interest_firm_one?: Maybe<GradInterestFirm>;
  /** insert data into the table: "grad.interest_firm_selection" */
  insert_grad_interest_firm_selection?: Maybe<GradInterestFirmSelectionMutationResponse>;
  /** insert a single row into the table: "grad.interest_firm_selection" */
  insert_grad_interest_firm_selection_one?: Maybe<GradInterestFirmSelection>;
  /** insert data into the table: "grad.interest_job_type" */
  insert_grad_interest_job_type?: Maybe<GradInterestJobTypeMutationResponse>;
  /** insert a single row into the table: "grad.interest_job_type" */
  insert_grad_interest_job_type_one?: Maybe<GradInterestJobType>;
  /** insert data into the table: "grad.interest_job_type_selection" */
  insert_grad_interest_job_type_selection?: Maybe<GradInterestJobTypeSelectionMutationResponse>;
  /** insert a single row into the table: "grad.interest_job_type_selection" */
  insert_grad_interest_job_type_selection_one?: Maybe<GradInterestJobTypeSelection>;
  /** insert data into the table: "grad.interest_region" */
  insert_grad_interest_region?: Maybe<GradInterestRegionMutationResponse>;
  /** insert a single row into the table: "grad.interest_region" */
  insert_grad_interest_region_one?: Maybe<GradInterestRegion>;
  /** insert data into the table: "grad.interest_region_selection" */
  insert_grad_interest_region_selection?: Maybe<GradInterestRegionSelectionMutationResponse>;
  /** insert a single row into the table: "grad.interest_region_selection" */
  insert_grad_interest_region_selection_one?: Maybe<GradInterestRegionSelection>;
  /** insert data into the table: "grad.interest_role" */
  insert_grad_interest_role?: Maybe<GradInterestRoleMutationResponse>;
  /** insert a single row into the table: "grad.interest_role" */
  insert_grad_interest_role_one?: Maybe<GradInterestRole>;
  /** insert data into the table: "grad.interest_role_selection" */
  insert_grad_interest_role_selection?: Maybe<GradInterestRoleSelectionMutationResponse>;
  /** insert a single row into the table: "grad.interest_role_selection" */
  insert_grad_interest_role_selection_one?: Maybe<GradInterestRoleSelection>;
  /** insert data into the table: "grad.major_selection" */
  insert_grad_major_selection?: Maybe<GradMajorSelectionMutationResponse>;
  /** insert a single row into the table: "grad.major_selection" */
  insert_grad_major_selection_one?: Maybe<GradMajorSelection>;
  /** insert data into the table: "grad.page_view" */
  insert_grad_page_view?: Maybe<GradPageViewMutationResponse>;
  /** insert a single row into the table: "grad.page_view" */
  insert_grad_page_view_one?: Maybe<GradPageView>;
  /** insert data into the table: "grad.profile" */
  insert_grad_profile?: Maybe<GradProfileMutationResponse>;
  /** insert data into the table: "grad.profile_combine" */
  insert_grad_profile_combine?: Maybe<GradProfileCombineMutationResponse>;
  /** insert a single row into the table: "grad.profile_combine" */
  insert_grad_profile_combine_one?: Maybe<GradProfileCombine>;
  /** insert a single row into the table: "grad.profile" */
  insert_grad_profile_one?: Maybe<GradProfile>;
  /** insert data into the table: "grad.raise_hand" */
  insert_grad_raise_hand?: Maybe<GradRaiseHandMutationResponse>;
  /** insert a single row into the table: "grad.raise_hand" */
  insert_grad_raise_hand_one?: Maybe<GradRaiseHand>;
  /** insert data into the table: "grad.spoken_language" */
  insert_grad_spoken_language?: Maybe<GradSpokenLanguageMutationResponse>;
  /** insert a single row into the table: "grad.spoken_language" */
  insert_grad_spoken_language_one?: Maybe<GradSpokenLanguage>;
  /** insert data into the table: "grad.test_score" */
  insert_grad_test_score?: Maybe<GradTestScoreMutationResponse>;
  /** insert data into the table: "grad.test_score_detail" */
  insert_grad_test_score_detail?: Maybe<GradTestScoreDetailMutationResponse>;
  /** insert a single row into the table: "grad.test_score_detail" */
  insert_grad_test_score_detail_one?: Maybe<GradTestScoreDetail>;
  /** insert a single row into the table: "grad.test_score" */
  insert_grad_test_score_one?: Maybe<GradTestScore>;
  /** insert data into the table: "grad.university_selection" */
  insert_grad_university_selection?: Maybe<GradUniversitySelectionMutationResponse>;
  /** insert a single row into the table: "grad.university_selection" */
  insert_grad_university_selection_one?: Maybe<GradUniversitySelection>;
  /** insert data into the table: "grad.university_stat" */
  insert_grad_university_stat?: Maybe<GradUniversityStatMutationResponse>;
  /** insert a single row into the table: "grad.university_stat" */
  insert_grad_university_stat_one?: Maybe<GradUniversityStat>;
  /** insert data into the table: "grad.upload_doc" */
  insert_grad_upload_doc?: Maybe<GradUploadDocMutationResponse>;
  /** insert a single row into the table: "grad.upload_doc" */
  insert_grad_upload_doc_one?: Maybe<GradUploadDoc>;
  /** insert data into the table: "grad.user_activity_summary" */
  insert_grad_user_activity_summary?: Maybe<GradUserActivitySummaryMutationResponse>;
  /** insert a single row into the table: "grad.user_activity_summary" */
  insert_grad_user_activity_summary_one?: Maybe<GradUserActivitySummary>;
  /** insert data into the table: "grad.visa_selection" */
  insert_grad_visa_selection?: Maybe<GradVisaSelectionMutationResponse>;
  /** insert a single row into the table: "grad.visa_selection" */
  insert_grad_visa_selection_one?: Maybe<GradVisaSelection>;
  /** insert data into the table: "grad.volunteer" */
  insert_grad_volunteer?: Maybe<GradVolunteerMutationResponse>;
  /** insert a single row into the table: "grad.volunteer" */
  insert_grad_volunteer_one?: Maybe<GradVolunteer>;
  /** insert data into the table: "grad.work_experience" */
  insert_grad_work_experience?: Maybe<GradWorkExperienceMutationResponse>;
  /** insert a single row into the table: "grad.work_experience" */
  insert_grad_work_experience_one?: Maybe<GradWorkExperience>;
  /** insert data into the table: "queue_handler_permission" */
  insert_queue_handler_permission?: Maybe<QueueHandlerPermissionMutationResponse>;
  /** insert a single row into the table: "queue_handler_permission" */
  insert_queue_handler_permission_one?: Maybe<QueueHandlerPermission>;
  /** insert data into the table: "recruit.account" */
  insert_recruit_account?: Maybe<RecruitAccountMutationResponse>;
  /** insert a single row into the table: "recruit.account" */
  insert_recruit_account_one?: Maybe<RecruitAccount>;
  /** insert data into the table: "recruit.company" */
  insert_recruit_company?: Maybe<RecruitCompanyMutationResponse>;
  /** insert a single row into the table: "recruit.company" */
  insert_recruit_company_one?: Maybe<RecruitCompany>;
  /** insert data into the table: "recruit.company_subindustry" */
  insert_recruit_company_subindustry?: Maybe<RecruitCompanySubindustryMutationResponse>;
  /** insert a single row into the table: "recruit.company_subindustry" */
  insert_recruit_company_subindustry_one?: Maybe<RecruitCompanySubindustry>;
  /** insert data into the table: "recruit.event" */
  insert_recruit_event?: Maybe<RecruitEventMutationResponse>;
  /** insert a single row into the table: "recruit.event" */
  insert_recruit_event_one?: Maybe<RecruitEvent>;
  /** insert data into the table: "recruit.grad_group" */
  insert_recruit_grad_group?: Maybe<RecruitGradGroupMutationResponse>;
  /** insert data into the table: "recruit.grad_group_member" */
  insert_recruit_grad_group_member?: Maybe<RecruitGradGroupMemberMutationResponse>;
  /** insert a single row into the table: "recruit.grad_group_member" */
  insert_recruit_grad_group_member_one?: Maybe<RecruitGradGroupMember>;
  /** insert a single row into the table: "recruit.grad_group" */
  insert_recruit_grad_group_one?: Maybe<RecruitGradGroup>;
  /** insert data into the table: "recruit.job_posting" */
  insert_recruit_job_posting?: Maybe<RecruitJobPostingMutationResponse>;
  /** insert a single row into the table: "recruit.job_posting" */
  insert_recruit_job_posting_one?: Maybe<RecruitJobPosting>;
  /** insert data into the table: "recruit.job_requirement" */
  insert_recruit_job_requirement?: Maybe<RecruitJobRequirementMutationResponse>;
  /** insert a single row into the table: "recruit.job_requirement" */
  insert_recruit_job_requirement_one?: Maybe<RecruitJobRequirement>;
  /** insert data into the table: "recruit.job_requirement_value" */
  insert_recruit_job_requirement_value?: Maybe<RecruitJobRequirementValueMutationResponse>;
  /** insert a single row into the table: "recruit.job_requirement_value" */
  insert_recruit_job_requirement_value_one?: Maybe<RecruitJobRequirementValue>;
  /** insert data into the table: "recruit.recruiter" */
  insert_recruit_recruiter?: Maybe<RecruitRecruiterMutationResponse>;
  /** insert a single row into the table: "recruit.recruiter" */
  insert_recruit_recruiter_one?: Maybe<RecruitRecruiter>;
  /** insert data into the table: "recruit.saved_search" */
  insert_recruit_saved_search?: Maybe<RecruitSavedSearchMutationResponse>;
  /** insert a single row into the table: "recruit.saved_search" */
  insert_recruit_saved_search_one?: Maybe<RecruitSavedSearch>;
  /** insert data into the table: "recruit.sms_correspondent" */
  insert_recruit_sms_correspondent?: Maybe<RecruitSmsCorrespondentMutationResponse>;
  /** insert a single row into the table: "recruit.sms_correspondent" */
  insert_recruit_sms_correspondent_one?: Maybe<RecruitSmsCorrespondent>;
  /** insert data into the table: "recruit.sms_message" */
  insert_recruit_sms_message?: Maybe<RecruitSmsMessageMutationResponse>;
  /** insert data into the table: "recruit.sms_message_correspondent" */
  insert_recruit_sms_message_correspondent?: Maybe<RecruitSmsMessageCorrespondentMutationResponse>;
  /** insert a single row into the table: "recruit.sms_message_correspondent" */
  insert_recruit_sms_message_correspondent_one?: Maybe<RecruitSmsMessageCorrespondent>;
  /** insert a single row into the table: "recruit.sms_message" */
  insert_recruit_sms_message_one?: Maybe<RecruitSmsMessage>;
  /** insert data into the table: "recruit.sms_template" */
  insert_recruit_sms_template?: Maybe<RecruitSmsTemplateMutationResponse>;
  /** insert a single row into the table: "recruit.sms_template" */
  insert_recruit_sms_template_one?: Maybe<RecruitSmsTemplate>;
  /** insert data into the table: "test_auto3" */
  insert_test_auto3?: Maybe<TestAuto3MutationResponse>;
  /** insert a single row into the table: "test_auto3" */
  insert_test_auto3_one?: Maybe<TestAuto3>;
  /** insert data into the table: "to_queue" */
  insert_to_queue?: Maybe<ToQueueMutationResponse>;
  /** insert a single row into the table: "to_queue" */
  insert_to_queue_one?: Maybe<ToQueue>;
  /** insert data into the table: "to_queue_response" */
  insert_to_queue_response?: Maybe<ToQueueResponseMutationResponse>;
  /** insert a single row into the table: "to_queue_response" */
  insert_to_queue_response_one?: Maybe<ToQueueResponse>;
  /** insert data into the table: "user_auth" */
  insert_user_auth?: Maybe<UserAuthMutationResponse>;
  /** insert a single row into the table: "user_auth" */
  insert_user_auth_one?: Maybe<UserAuth>;
  /** insert data into the table: "useraccount" */
  insert_useraccount?: Maybe<UseraccountMutationResponse>;
  /** insert a single row into the table: "useraccount" */
  insert_useraccount_one?: Maybe<Useraccount>;
  /** insert data into the table: "web_api_permission" */
  insert_web_api_permission?: Maybe<WebApiPermissionMutationResponse>;
  /** insert a single row into the table: "web_api_permission" */
  insert_web_api_permission_one?: Maybe<WebApiPermission>;
  /** perform the action: "queueAction" */
  queueAction?: Maybe<QueueActionOutput>;
  /** update data of the table: "admin.adminuser" */
  update_admin_adminuser?: Maybe<AdminAdminuserMutationResponse>;
  /** update single row of the table: "admin.adminuser" */
  update_admin_adminuser_by_pk?: Maybe<AdminAdminuser>;
  /** update data of the table: "admin.auth0mgmt" */
  update_admin_auth0mgmt?: Maybe<AdminAuth0mgmtMutationResponse>;
  /** update single row of the table: "admin.auth0mgmt" */
  update_admin_auth0mgmt_by_pk?: Maybe<AdminAuth0mgmt>;
  /** update data of the table: "admin.auth0mgmt_result" */
  update_admin_auth0mgmt_result?: Maybe<AdminAuth0mgmtResultMutationResponse>;
  /** update single row of the table: "admin.auth0mgmt_result" */
  update_admin_auth0mgmt_result_by_pk?: Maybe<AdminAuth0mgmtResult>;
  /** update data of the table: "admin.email" */
  update_admin_email?: Maybe<AdminEmailMutationResponse>;
  /** update single row of the table: "admin.email" */
  update_admin_email_by_pk?: Maybe<AdminEmail>;
  /** update data of the table: "admin.email_layout" */
  update_admin_email_layout?: Maybe<AdminEmailLayoutMutationResponse>;
  /** update single row of the table: "admin.email_layout" */
  update_admin_email_layout_by_pk?: Maybe<AdminEmailLayout>;
  /** update data of the table: "admin.email_template" */
  update_admin_email_template?: Maybe<AdminEmailTemplateMutationResponse>;
  /** update single row of the table: "admin.email_template" */
  update_admin_email_template_by_pk?: Maybe<AdminEmailTemplate>;
  /** update data of the table: "admin.twiliomgmt" */
  update_admin_twiliomgmt?: Maybe<AdminTwiliomgmtMutationResponse>;
  /** update single row of the table: "admin.twiliomgmt" */
  update_admin_twiliomgmt_by_pk?: Maybe<AdminTwiliomgmt>;
  /** update data of the table: "admin.twiliomgmt_result" */
  update_admin_twiliomgmt_result?: Maybe<AdminTwiliomgmtResultMutationResponse>;
  /** update single row of the table: "admin.twiliomgmt_result" */
  update_admin_twiliomgmt_result_by_pk?: Maybe<AdminTwiliomgmtResult>;
  /** update data of the table: "db_ping" */
  update_db_ping?: Maybe<DbPingMutationResponse>;
  /** update single row of the table: "db_ping" */
  update_db_ping_by_pk?: Maybe<DbPing>;
  /** update data of the table: "db_state" */
  update_db_state?: Maybe<DbStateMutationResponse>;
  /** update single row of the table: "db_state" */
  update_db_state_by_pk?: Maybe<DbState>;
  /** update data of the table: "grad.achievement" */
  update_grad_achievement?: Maybe<GradAchievementMutationResponse>;
  /** update single row of the table: "grad.achievement" */
  update_grad_achievement_by_pk?: Maybe<GradAchievement>;
  /** update data of the table: "grad.award" */
  update_grad_award?: Maybe<GradAwardMutationResponse>;
  /** update single row of the table: "grad.award" */
  update_grad_award_by_pk?: Maybe<GradAward>;
  /** update data of the table: "grad.bookmark_job" */
  update_grad_bookmark_job?: Maybe<GradBookmarkJobMutationResponse>;
  /** update single row of the table: "grad.bookmark_job" */
  update_grad_bookmark_job_by_pk?: Maybe<GradBookmarkJob>;
  /** update data of the table: "grad.city_state_selection" */
  update_grad_city_state_selection?: Maybe<GradCityStateSelectionMutationResponse>;
  /** update single row of the table: "grad.city_state_selection" */
  update_grad_city_state_selection_by_pk?: Maybe<GradCityStateSelection>;
  /** update data of the table: "grad.comm_preference_selection" */
  update_grad_comm_preference_selection?: Maybe<GradCommPreferenceSelectionMutationResponse>;
  /** update single row of the table: "grad.comm_preference_selection" */
  update_grad_comm_preference_selection_by_pk?: Maybe<GradCommPreferenceSelection>;
  /** update data of the table: "grad.company_selection" */
  update_grad_company_selection?: Maybe<GradCompanySelectionMutationResponse>;
  /** update single row of the table: "grad.company_selection" */
  update_grad_company_selection_by_pk?: Maybe<GradCompanySelection>;
  /** update data of the table: "grad.computer_language" */
  update_grad_computer_language?: Maybe<GradComputerLanguageMutationResponse>;
  /** update single row of the table: "grad.computer_language" */
  update_grad_computer_language_by_pk?: Maybe<GradComputerLanguage>;
  /** update data of the table: "grad.computer_language_selection" */
  update_grad_computer_language_selection?: Maybe<GradComputerLanguageSelectionMutationResponse>;
  /** update single row of the table: "grad.computer_language_selection" */
  update_grad_computer_language_selection_by_pk?: Maybe<GradComputerLanguageSelection>;
  /** update data of the table: "grad.concentration" */
  update_grad_concentration?: Maybe<GradConcentrationMutationResponse>;
  /** update single row of the table: "grad.concentration" */
  update_grad_concentration_by_pk?: Maybe<GradConcentration>;
  /** update data of the table: "grad.country_selection" */
  update_grad_country_selection?: Maybe<GradCountrySelectionMutationResponse>;
  /** update single row of the table: "grad.country_selection" */
  update_grad_country_selection_by_pk?: Maybe<GradCountrySelection>;
  /** update data of the table: "grad.degree" */
  update_grad_degree?: Maybe<GradDegreeMutationResponse>;
  /** update single row of the table: "grad.degree" */
  update_grad_degree_by_pk?: Maybe<GradDegree>;
  /** update data of the table: "grad.degree_fill_in_university" */
  update_grad_degree_fill_in_university?: Maybe<GradDegreeFillInUniversityMutationResponse>;
  /** update single row of the table: "grad.degree_fill_in_university" */
  update_grad_degree_fill_in_university_by_pk?: Maybe<GradDegreeFillInUniversity>;
  /** update data of the table: "grad.degree_selection" */
  update_grad_degree_selection?: Maybe<GradDegreeSelectionMutationResponse>;
  /** update single row of the table: "grad.degree_selection" */
  update_grad_degree_selection_by_pk?: Maybe<GradDegreeSelection>;
  /** update data of the table: "grad.employer_preference" */
  update_grad_employer_preference?: Maybe<GradEmployerPreferenceMutationResponse>;
  /** update single row of the table: "grad.employer_preference" */
  update_grad_employer_preference_by_pk?: Maybe<GradEmployerPreference>;
  /** update data of the table: "grad.employer_preference_selection" */
  update_grad_employer_preference_selection?: Maybe<GradEmployerPreferenceSelectionMutationResponse>;
  /** update single row of the table: "grad.employer_preference_selection" */
  update_grad_employer_preference_selection_by_pk?: Maybe<GradEmployerPreferenceSelection>;
  /** update data of the table: "grad.event_registration" */
  update_grad_event_registration?: Maybe<GradEventRegistrationMutationResponse>;
  /** update single row of the table: "grad.event_registration" */
  update_grad_event_registration_by_pk?: Maybe<GradEventRegistration>;
  /** update data of the table: "grad.fun_fact" */
  update_grad_fun_fact?: Maybe<GradFunFactMutationResponse>;
  /** update single row of the table: "grad.fun_fact" */
  update_grad_fun_fact_by_pk?: Maybe<GradFunFact>;
  /** update data of the table: "grad.fun_fact_selection" */
  update_grad_fun_fact_selection?: Maybe<GradFunFactSelectionMutationResponse>;
  /** update single row of the table: "grad.fun_fact_selection" */
  update_grad_fun_fact_selection_by_pk?: Maybe<GradFunFactSelection>;
  /** update data of the table: "grad.interest_firm" */
  update_grad_interest_firm?: Maybe<GradInterestFirmMutationResponse>;
  /** update single row of the table: "grad.interest_firm" */
  update_grad_interest_firm_by_pk?: Maybe<GradInterestFirm>;
  /** update data of the table: "grad.interest_firm_selection" */
  update_grad_interest_firm_selection?: Maybe<GradInterestFirmSelectionMutationResponse>;
  /** update single row of the table: "grad.interest_firm_selection" */
  update_grad_interest_firm_selection_by_pk?: Maybe<GradInterestFirmSelection>;
  /** update data of the table: "grad.interest_job_type" */
  update_grad_interest_job_type?: Maybe<GradInterestJobTypeMutationResponse>;
  /** update single row of the table: "grad.interest_job_type" */
  update_grad_interest_job_type_by_pk?: Maybe<GradInterestJobType>;
  /** update data of the table: "grad.interest_job_type_selection" */
  update_grad_interest_job_type_selection?: Maybe<GradInterestJobTypeSelectionMutationResponse>;
  /** update single row of the table: "grad.interest_job_type_selection" */
  update_grad_interest_job_type_selection_by_pk?: Maybe<GradInterestJobTypeSelection>;
  /** update data of the table: "grad.interest_region" */
  update_grad_interest_region?: Maybe<GradInterestRegionMutationResponse>;
  /** update single row of the table: "grad.interest_region" */
  update_grad_interest_region_by_pk?: Maybe<GradInterestRegion>;
  /** update data of the table: "grad.interest_region_selection" */
  update_grad_interest_region_selection?: Maybe<GradInterestRegionSelectionMutationResponse>;
  /** update single row of the table: "grad.interest_region_selection" */
  update_grad_interest_region_selection_by_pk?: Maybe<GradInterestRegionSelection>;
  /** update data of the table: "grad.interest_role" */
  update_grad_interest_role?: Maybe<GradInterestRoleMutationResponse>;
  /** update single row of the table: "grad.interest_role" */
  update_grad_interest_role_by_pk?: Maybe<GradInterestRole>;
  /** update data of the table: "grad.interest_role_selection" */
  update_grad_interest_role_selection?: Maybe<GradInterestRoleSelectionMutationResponse>;
  /** update single row of the table: "grad.interest_role_selection" */
  update_grad_interest_role_selection_by_pk?: Maybe<GradInterestRoleSelection>;
  /** update data of the table: "grad.major_selection" */
  update_grad_major_selection?: Maybe<GradMajorSelectionMutationResponse>;
  /** update single row of the table: "grad.major_selection" */
  update_grad_major_selection_by_pk?: Maybe<GradMajorSelection>;
  /** update data of the table: "grad.page_view" */
  update_grad_page_view?: Maybe<GradPageViewMutationResponse>;
  /** update single row of the table: "grad.page_view" */
  update_grad_page_view_by_pk?: Maybe<GradPageView>;
  /** update data of the table: "grad.profile" */
  update_grad_profile?: Maybe<GradProfileMutationResponse>;
  /** update single row of the table: "grad.profile" */
  update_grad_profile_by_pk?: Maybe<GradProfile>;
  /** update data of the table: "grad.profile_combine" */
  update_grad_profile_combine?: Maybe<GradProfileCombineMutationResponse>;
  /** update data of the table: "grad.raise_hand" */
  update_grad_raise_hand?: Maybe<GradRaiseHandMutationResponse>;
  /** update single row of the table: "grad.raise_hand" */
  update_grad_raise_hand_by_pk?: Maybe<GradRaiseHand>;
  /** update data of the table: "grad.spoken_language" */
  update_grad_spoken_language?: Maybe<GradSpokenLanguageMutationResponse>;
  /** update single row of the table: "grad.spoken_language" */
  update_grad_spoken_language_by_pk?: Maybe<GradSpokenLanguage>;
  /** update data of the table: "grad.test_score" */
  update_grad_test_score?: Maybe<GradTestScoreMutationResponse>;
  /** update single row of the table: "grad.test_score" */
  update_grad_test_score_by_pk?: Maybe<GradTestScore>;
  /** update data of the table: "grad.test_score_detail" */
  update_grad_test_score_detail?: Maybe<GradTestScoreDetailMutationResponse>;
  /** update single row of the table: "grad.test_score_detail" */
  update_grad_test_score_detail_by_pk?: Maybe<GradTestScoreDetail>;
  /** update data of the table: "grad.university_selection" */
  update_grad_university_selection?: Maybe<GradUniversitySelectionMutationResponse>;
  /** update single row of the table: "grad.university_selection" */
  update_grad_university_selection_by_pk?: Maybe<GradUniversitySelection>;
  /** update data of the table: "grad.university_stat" */
  update_grad_university_stat?: Maybe<GradUniversityStatMutationResponse>;
  /** update data of the table: "grad.upload_doc" */
  update_grad_upload_doc?: Maybe<GradUploadDocMutationResponse>;
  /** update single row of the table: "grad.upload_doc" */
  update_grad_upload_doc_by_pk?: Maybe<GradUploadDoc>;
  /** update data of the table: "grad.user_activity_summary" */
  update_grad_user_activity_summary?: Maybe<GradUserActivitySummaryMutationResponse>;
  /** update single row of the table: "grad.user_activity_summary" */
  update_grad_user_activity_summary_by_pk?: Maybe<GradUserActivitySummary>;
  /** update data of the table: "grad.visa_selection" */
  update_grad_visa_selection?: Maybe<GradVisaSelectionMutationResponse>;
  /** update single row of the table: "grad.visa_selection" */
  update_grad_visa_selection_by_pk?: Maybe<GradVisaSelection>;
  /** update data of the table: "grad.volunteer" */
  update_grad_volunteer?: Maybe<GradVolunteerMutationResponse>;
  /** update single row of the table: "grad.volunteer" */
  update_grad_volunteer_by_pk?: Maybe<GradVolunteer>;
  /** update data of the table: "grad.work_experience" */
  update_grad_work_experience?: Maybe<GradWorkExperienceMutationResponse>;
  /** update single row of the table: "grad.work_experience" */
  update_grad_work_experience_by_pk?: Maybe<GradWorkExperience>;
  /** update data of the table: "queue_handler_permission" */
  update_queue_handler_permission?: Maybe<QueueHandlerPermissionMutationResponse>;
  /** update single row of the table: "queue_handler_permission" */
  update_queue_handler_permission_by_pk?: Maybe<QueueHandlerPermission>;
  /** update data of the table: "recruit.account" */
  update_recruit_account?: Maybe<RecruitAccountMutationResponse>;
  /** update single row of the table: "recruit.account" */
  update_recruit_account_by_pk?: Maybe<RecruitAccount>;
  /** update data of the table: "recruit.company" */
  update_recruit_company?: Maybe<RecruitCompanyMutationResponse>;
  /** update single row of the table: "recruit.company" */
  update_recruit_company_by_pk?: Maybe<RecruitCompany>;
  /** update data of the table: "recruit.company_subindustry" */
  update_recruit_company_subindustry?: Maybe<RecruitCompanySubindustryMutationResponse>;
  /** update single row of the table: "recruit.company_subindustry" */
  update_recruit_company_subindustry_by_pk?: Maybe<RecruitCompanySubindustry>;
  /** update data of the table: "recruit.event" */
  update_recruit_event?: Maybe<RecruitEventMutationResponse>;
  /** update single row of the table: "recruit.event" */
  update_recruit_event_by_pk?: Maybe<RecruitEvent>;
  /** update data of the table: "recruit.grad_group" */
  update_recruit_grad_group?: Maybe<RecruitGradGroupMutationResponse>;
  /** update single row of the table: "recruit.grad_group" */
  update_recruit_grad_group_by_pk?: Maybe<RecruitGradGroup>;
  /** update data of the table: "recruit.grad_group_member" */
  update_recruit_grad_group_member?: Maybe<RecruitGradGroupMemberMutationResponse>;
  /** update single row of the table: "recruit.grad_group_member" */
  update_recruit_grad_group_member_by_pk?: Maybe<RecruitGradGroupMember>;
  /** update data of the table: "recruit.job_posting" */
  update_recruit_job_posting?: Maybe<RecruitJobPostingMutationResponse>;
  /** update single row of the table: "recruit.job_posting" */
  update_recruit_job_posting_by_pk?: Maybe<RecruitJobPosting>;
  /** update data of the table: "recruit.job_requirement" */
  update_recruit_job_requirement?: Maybe<RecruitJobRequirementMutationResponse>;
  /** update single row of the table: "recruit.job_requirement" */
  update_recruit_job_requirement_by_pk?: Maybe<RecruitJobRequirement>;
  /** update data of the table: "recruit.job_requirement_value" */
  update_recruit_job_requirement_value?: Maybe<RecruitJobRequirementValueMutationResponse>;
  /** update single row of the table: "recruit.job_requirement_value" */
  update_recruit_job_requirement_value_by_pk?: Maybe<RecruitJobRequirementValue>;
  /** update data of the table: "recruit.recruiter" */
  update_recruit_recruiter?: Maybe<RecruitRecruiterMutationResponse>;
  /** update single row of the table: "recruit.recruiter" */
  update_recruit_recruiter_by_pk?: Maybe<RecruitRecruiter>;
  /** update data of the table: "recruit.saved_search" */
  update_recruit_saved_search?: Maybe<RecruitSavedSearchMutationResponse>;
  /** update single row of the table: "recruit.saved_search" */
  update_recruit_saved_search_by_pk?: Maybe<RecruitSavedSearch>;
  /** update data of the table: "recruit.sms_correspondent" */
  update_recruit_sms_correspondent?: Maybe<RecruitSmsCorrespondentMutationResponse>;
  /** update single row of the table: "recruit.sms_correspondent" */
  update_recruit_sms_correspondent_by_pk?: Maybe<RecruitSmsCorrespondent>;
  /** update data of the table: "recruit.sms_message" */
  update_recruit_sms_message?: Maybe<RecruitSmsMessageMutationResponse>;
  /** update single row of the table: "recruit.sms_message" */
  update_recruit_sms_message_by_pk?: Maybe<RecruitSmsMessage>;
  /** update data of the table: "recruit.sms_message_correspondent" */
  update_recruit_sms_message_correspondent?: Maybe<RecruitSmsMessageCorrespondentMutationResponse>;
  /** update single row of the table: "recruit.sms_message_correspondent" */
  update_recruit_sms_message_correspondent_by_pk?: Maybe<RecruitSmsMessageCorrespondent>;
  /** update data of the table: "recruit.sms_template" */
  update_recruit_sms_template?: Maybe<RecruitSmsTemplateMutationResponse>;
  /** update single row of the table: "recruit.sms_template" */
  update_recruit_sms_template_by_pk?: Maybe<RecruitSmsTemplate>;
  /** update data of the table: "test_auto3" */
  update_test_auto3?: Maybe<TestAuto3MutationResponse>;
  /** update single row of the table: "test_auto3" */
  update_test_auto3_by_pk?: Maybe<TestAuto3>;
  /** update data of the table: "to_queue" */
  update_to_queue?: Maybe<ToQueueMutationResponse>;
  /** update single row of the table: "to_queue" */
  update_to_queue_by_pk?: Maybe<ToQueue>;
  /** update data of the table: "to_queue_response" */
  update_to_queue_response?: Maybe<ToQueueResponseMutationResponse>;
  /** update single row of the table: "to_queue_response" */
  update_to_queue_response_by_pk?: Maybe<ToQueueResponse>;
  /** update data of the table: "user_auth" */
  update_user_auth?: Maybe<UserAuthMutationResponse>;
  /** update single row of the table: "user_auth" */
  update_user_auth_by_pk?: Maybe<UserAuth>;
  /** update data of the table: "useraccount" */
  update_useraccount?: Maybe<UseraccountMutationResponse>;
  /** update single row of the table: "useraccount" */
  update_useraccount_by_pk?: Maybe<Useraccount>;
  /** update data of the table: "web_api_permission" */
  update_web_api_permission?: Maybe<WebApiPermissionMutationResponse>;
  /** update single row of the table: "web_api_permission" */
  update_web_api_permission_by_pk?: Maybe<WebApiPermission>;
};


/** mutation root */
export type MutationRootDeleteAdminAdminuserArgs = {
  where: AdminAdminuserBoolExp;
};


/** mutation root */
export type MutationRootDeleteAdminAdminuserByPkArgs = {
  user_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteAdminAuth0mgmtArgs = {
  where: AdminAuth0mgmtBoolExp;
};


/** mutation root */
export type MutationRootDeleteAdminAuth0mgmtByPkArgs = {
  auth0mgmt_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteAdminAuth0mgmtResultArgs = {
  where: AdminAuth0mgmtResultBoolExp;
};


/** mutation root */
export type MutationRootDeleteAdminAuth0mgmtResultByPkArgs = {
  auth0mgmt_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteAdminEmailArgs = {
  where: AdminEmailBoolExp;
};


/** mutation root */
export type MutationRootDeleteAdminEmailByPkArgs = {
  email_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteAdminEmailLayoutArgs = {
  where: AdminEmailLayoutBoolExp;
};


/** mutation root */
export type MutationRootDeleteAdminEmailLayoutByPkArgs = {
  email_layout_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteAdminEmailTemplateArgs = {
  where: AdminEmailTemplateBoolExp;
};


/** mutation root */
export type MutationRootDeleteAdminEmailTemplateByPkArgs = {
  email_template_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteAdminTwiliomgmtArgs = {
  where: AdminTwiliomgmtBoolExp;
};


/** mutation root */
export type MutationRootDeleteAdminTwiliomgmtByPkArgs = {
  twiliomgmt_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteAdminTwiliomgmtResultArgs = {
  where: AdminTwiliomgmtResultBoolExp;
};


/** mutation root */
export type MutationRootDeleteAdminTwiliomgmtResultByPkArgs = {
  twiliomgmt_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteDbPingArgs = {
  where: DbPingBoolExp;
};


/** mutation root */
export type MutationRootDeleteDbPingByPkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteDbStateArgs = {
  where: DbStateBoolExp;
};


/** mutation root */
export type MutationRootDeleteDbStateByPkArgs = {
  key: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradAchievementArgs = {
  where: GradAchievementBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradAchievementByPkArgs = {
  achievement_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradAwardArgs = {
  where: GradAwardBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradAwardByPkArgs = {
  award_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradBookmarkJobArgs = {
  where: GradBookmarkJobBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradBookmarkJobByPkArgs = {
  bookmark_job_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradCityStateSelectionArgs = {
  where: GradCityStateSelectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradCityStateSelectionByPkArgs = {
  city_state_selection_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradCommPreferenceSelectionArgs = {
  where: GradCommPreferenceSelectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradCommPreferenceSelectionByPkArgs = {
  comm_preference_selection_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradCompanySelectionArgs = {
  where: GradCompanySelectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradCompanySelectionByPkArgs = {
  company_selection_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradComputerLanguageArgs = {
  where: GradComputerLanguageBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradComputerLanguageByPkArgs = {
  computer_language_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradComputerLanguageSelectionArgs = {
  where: GradComputerLanguageSelectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradComputerLanguageSelectionByPkArgs = {
  computer_language: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradConcentrationArgs = {
  where: GradConcentrationBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradConcentrationByPkArgs = {
  concentration_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradCountrySelectionArgs = {
  where: GradCountrySelectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradCountrySelectionByPkArgs = {
  country_selection_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradDegreeArgs = {
  where: GradDegreeBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradDegreeByPkArgs = {
  degree_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradDegreeFillInUniversityArgs = {
  where: GradDegreeFillInUniversityBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradDegreeFillInUniversityByPkArgs = {
  degree_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradDegreeSelectionArgs = {
  where: GradDegreeSelectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradDegreeSelectionByPkArgs = {
  degree_selection_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradEmployerPreferenceArgs = {
  where: GradEmployerPreferenceBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradEmployerPreferenceByPkArgs = {
  employer_preference_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradEmployerPreferenceSelectionArgs = {
  where: GradEmployerPreferenceSelectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradEmployerPreferenceSelectionByPkArgs = {
  employer_preference_selection_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradEventRegistrationArgs = {
  where: GradEventRegistrationBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradEventRegistrationByPkArgs = {
  event_registration_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradFunFactArgs = {
  where: GradFunFactBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradFunFactByPkArgs = {
  fun_fact_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradFunFactSelectionArgs = {
  where: GradFunFactSelectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradFunFactSelectionByPkArgs = {
  fun_fact_selection_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradInterestFirmArgs = {
  where: GradInterestFirmBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradInterestFirmByPkArgs = {
  interest_firm_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradInterestFirmSelectionArgs = {
  where: GradInterestFirmSelectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradInterestFirmSelectionByPkArgs = {
  interest_firm_selection_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradInterestJobTypeArgs = {
  where: GradInterestJobTypeBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradInterestJobTypeByPkArgs = {
  interest_job_type_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradInterestJobTypeSelectionArgs = {
  where: GradInterestJobTypeSelectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradInterestJobTypeSelectionByPkArgs = {
  interest_job_type_selection_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradInterestRegionArgs = {
  where: GradInterestRegionBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradInterestRegionByPkArgs = {
  interest_region_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradInterestRegionSelectionArgs = {
  where: GradInterestRegionSelectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradInterestRegionSelectionByPkArgs = {
  interest_region_selection_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradInterestRoleArgs = {
  where: GradInterestRoleBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradInterestRoleByPkArgs = {
  interest_role_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradInterestRoleSelectionArgs = {
  where: GradInterestRoleSelectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradInterestRoleSelectionByPkArgs = {
  interest_role_selection_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradMajorSelectionArgs = {
  where: GradMajorSelectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradMajorSelectionByPkArgs = {
  major_selection_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradPageViewArgs = {
  where: GradPageViewBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradPageViewByPkArgs = {
  page_view_id: Scalars['bigint'];
};


/** mutation root */
export type MutationRootDeleteGradProfileArgs = {
  where: GradProfileBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradProfileByPkArgs = {
  user_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradProfileCombineArgs = {
  where: GradProfileCombineBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradRaiseHandArgs = {
  where: GradRaiseHandBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradRaiseHandByPkArgs = {
  raise__hand_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradSpokenLanguageArgs = {
  where: GradSpokenLanguageBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradSpokenLanguageByPkArgs = {
  spoken_language_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradTestScoreArgs = {
  where: GradTestScoreBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradTestScoreByPkArgs = {
  test_score_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradTestScoreDetailArgs = {
  where: GradTestScoreDetailBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradTestScoreDetailByPkArgs = {
  test_score_detail_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradUniversitySelectionArgs = {
  where: GradUniversitySelectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradUniversitySelectionByPkArgs = {
  university_selection_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradUniversityStatArgs = {
  where: GradUniversityStatBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradUploadDocArgs = {
  where: GradUploadDocBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradUploadDocByPkArgs = {
  upload_doc_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradUserActivitySummaryArgs = {
  where: GradUserActivitySummaryBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradUserActivitySummaryByPkArgs = {
  user_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradVisaSelectionArgs = {
  where: GradVisaSelectionBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradVisaSelectionByPkArgs = {
  visa_selection_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradVolunteerArgs = {
  where: GradVolunteerBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradVolunteerByPkArgs = {
  volunteer_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteGradWorkExperienceArgs = {
  where: GradWorkExperienceBoolExp;
};


/** mutation root */
export type MutationRootDeleteGradWorkExperienceByPkArgs = {
  work_experience_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteQueueHandlerPermissionArgs = {
  where: QueueHandlerPermissionBoolExp;
};


/** mutation root */
export type MutationRootDeleteQueueHandlerPermissionByPkArgs = {
  queue: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteRecruitAccountArgs = {
  where: RecruitAccountBoolExp;
};


/** mutation root */
export type MutationRootDeleteRecruitAccountByPkArgs = {
  account_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteRecruitCompanyArgs = {
  where: RecruitCompanyBoolExp;
};


/** mutation root */
export type MutationRootDeleteRecruitCompanyByPkArgs = {
  company_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteRecruitCompanySubindustryArgs = {
  where: RecruitCompanySubindustryBoolExp;
};


/** mutation root */
export type MutationRootDeleteRecruitCompanySubindustryByPkArgs = {
  company_subindustry_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteRecruitEventArgs = {
  where: RecruitEventBoolExp;
};


/** mutation root */
export type MutationRootDeleteRecruitEventByPkArgs = {
  event_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteRecruitGradGroupArgs = {
  where: RecruitGradGroupBoolExp;
};


/** mutation root */
export type MutationRootDeleteRecruitGradGroupByPkArgs = {
  grad_group_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteRecruitGradGroupMemberArgs = {
  where: RecruitGradGroupMemberBoolExp;
};


/** mutation root */
export type MutationRootDeleteRecruitGradGroupMemberByPkArgs = {
  grad_group_id: Scalars['String'];
  recruiter_user_id: Scalars['String'];
  student_user_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteRecruitJobPostingArgs = {
  where: RecruitJobPostingBoolExp;
};


/** mutation root */
export type MutationRootDeleteRecruitJobPostingByPkArgs = {
  job_posting_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteRecruitJobRequirementArgs = {
  where: RecruitJobRequirementBoolExp;
};


/** mutation root */
export type MutationRootDeleteRecruitJobRequirementByPkArgs = {
  job_requirement_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteRecruitJobRequirementValueArgs = {
  where: RecruitJobRequirementValueBoolExp;
};


/** mutation root */
export type MutationRootDeleteRecruitJobRequirementValueByPkArgs = {
  job_requirement_value_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteRecruitRecruiterArgs = {
  where: RecruitRecruiterBoolExp;
};


/** mutation root */
export type MutationRootDeleteRecruitRecruiterByPkArgs = {
  user_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteRecruitSavedSearchArgs = {
  where: RecruitSavedSearchBoolExp;
};


/** mutation root */
export type MutationRootDeleteRecruitSavedSearchByPkArgs = {
  saved_search_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteRecruitSmsCorrespondentArgs = {
  where: RecruitSmsCorrespondentBoolExp;
};


/** mutation root */
export type MutationRootDeleteRecruitSmsCorrespondentByPkArgs = {
  sms_correspondent_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteRecruitSmsMessageArgs = {
  where: RecruitSmsMessageBoolExp;
};


/** mutation root */
export type MutationRootDeleteRecruitSmsMessageByPkArgs = {
  sms_message_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteRecruitSmsMessageCorrespondentArgs = {
  where: RecruitSmsMessageCorrespondentBoolExp;
};


/** mutation root */
export type MutationRootDeleteRecruitSmsMessageCorrespondentByPkArgs = {
  sms_message_correspondent_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteRecruitSmsTemplateArgs = {
  where: RecruitSmsTemplateBoolExp;
};


/** mutation root */
export type MutationRootDeleteRecruitSmsTemplateByPkArgs = {
  sms_template_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteTestAuto3Args = {
  where: TestAuto3BoolExp;
};


/** mutation root */
export type MutationRootDeleteTestAuto3ByPkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteToQueueArgs = {
  where: ToQueueBoolExp;
};


/** mutation root */
export type MutationRootDeleteToQueueByPkArgs = {
  to_queue_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteToQueueResponseArgs = {
  where: ToQueueResponseBoolExp;
};


/** mutation root */
export type MutationRootDeleteToQueueResponseByPkArgs = {
  to_queue_id: Scalars['Int'];
};


/** mutation root */
export type MutationRootDeleteUserAuthArgs = {
  where: UserAuthBoolExp;
};


/** mutation root */
export type MutationRootDeleteUserAuthByPkArgs = {
  email: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteUseraccountArgs = {
  where: UseraccountBoolExp;
};


/** mutation root */
export type MutationRootDeleteUseraccountByPkArgs = {
  user_id: Scalars['String'];
};


/** mutation root */
export type MutationRootDeleteWebApiPermissionArgs = {
  where: WebApiPermissionBoolExp;
};


/** mutation root */
export type MutationRootDeleteWebApiPermissionByPkArgs = {
  fn: Scalars['String'];
};


/** mutation root */
export type MutationRootInsertAdminAdminuserArgs = {
  objects: Array<AdminAdminuserInsertInput>;
  on_conflict?: Maybe<AdminAdminuserOnConflict>;
};


/** mutation root */
export type MutationRootInsertAdminAdminuserOneArgs = {
  object: AdminAdminuserInsertInput;
  on_conflict?: Maybe<AdminAdminuserOnConflict>;
};


/** mutation root */
export type MutationRootInsertAdminAuth0mgmtArgs = {
  objects: Array<AdminAuth0mgmtInsertInput>;
  on_conflict?: Maybe<AdminAuth0mgmtOnConflict>;
};


/** mutation root */
export type MutationRootInsertAdminAuth0mgmtOneArgs = {
  object: AdminAuth0mgmtInsertInput;
  on_conflict?: Maybe<AdminAuth0mgmtOnConflict>;
};


/** mutation root */
export type MutationRootInsertAdminAuth0mgmtResultArgs = {
  objects: Array<AdminAuth0mgmtResultInsertInput>;
  on_conflict?: Maybe<AdminAuth0mgmtResultOnConflict>;
};


/** mutation root */
export type MutationRootInsertAdminAuth0mgmtResultOneArgs = {
  object: AdminAuth0mgmtResultInsertInput;
  on_conflict?: Maybe<AdminAuth0mgmtResultOnConflict>;
};


/** mutation root */
export type MutationRootInsertAdminEmailArgs = {
  objects: Array<AdminEmailInsertInput>;
  on_conflict?: Maybe<AdminEmailOnConflict>;
};


/** mutation root */
export type MutationRootInsertAdminEmailLayoutArgs = {
  objects: Array<AdminEmailLayoutInsertInput>;
  on_conflict?: Maybe<AdminEmailLayoutOnConflict>;
};


/** mutation root */
export type MutationRootInsertAdminEmailLayoutOneArgs = {
  object: AdminEmailLayoutInsertInput;
  on_conflict?: Maybe<AdminEmailLayoutOnConflict>;
};


/** mutation root */
export type MutationRootInsertAdminEmailOneArgs = {
  object: AdminEmailInsertInput;
  on_conflict?: Maybe<AdminEmailOnConflict>;
};


/** mutation root */
export type MutationRootInsertAdminEmailTemplateArgs = {
  objects: Array<AdminEmailTemplateInsertInput>;
  on_conflict?: Maybe<AdminEmailTemplateOnConflict>;
};


/** mutation root */
export type MutationRootInsertAdminEmailTemplateOneArgs = {
  object: AdminEmailTemplateInsertInput;
  on_conflict?: Maybe<AdminEmailTemplateOnConflict>;
};


/** mutation root */
export type MutationRootInsertAdminTwiliomgmtArgs = {
  objects: Array<AdminTwiliomgmtInsertInput>;
  on_conflict?: Maybe<AdminTwiliomgmtOnConflict>;
};


/** mutation root */
export type MutationRootInsertAdminTwiliomgmtOneArgs = {
  object: AdminTwiliomgmtInsertInput;
  on_conflict?: Maybe<AdminTwiliomgmtOnConflict>;
};


/** mutation root */
export type MutationRootInsertAdminTwiliomgmtResultArgs = {
  objects: Array<AdminTwiliomgmtResultInsertInput>;
  on_conflict?: Maybe<AdminTwiliomgmtResultOnConflict>;
};


/** mutation root */
export type MutationRootInsertAdminTwiliomgmtResultOneArgs = {
  object: AdminTwiliomgmtResultInsertInput;
  on_conflict?: Maybe<AdminTwiliomgmtResultOnConflict>;
};


/** mutation root */
export type MutationRootInsertDbPingArgs = {
  objects: Array<DbPingInsertInput>;
  on_conflict?: Maybe<DbPingOnConflict>;
};


/** mutation root */
export type MutationRootInsertDbPingOneArgs = {
  object: DbPingInsertInput;
  on_conflict?: Maybe<DbPingOnConflict>;
};


/** mutation root */
export type MutationRootInsertDbStateArgs = {
  objects: Array<DbStateInsertInput>;
  on_conflict?: Maybe<DbStateOnConflict>;
};


/** mutation root */
export type MutationRootInsertDbStateOneArgs = {
  object: DbStateInsertInput;
  on_conflict?: Maybe<DbStateOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradAchievementArgs = {
  objects: Array<GradAchievementInsertInput>;
  on_conflict?: Maybe<GradAchievementOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradAchievementOneArgs = {
  object: GradAchievementInsertInput;
  on_conflict?: Maybe<GradAchievementOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradAwardArgs = {
  objects: Array<GradAwardInsertInput>;
  on_conflict?: Maybe<GradAwardOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradAwardOneArgs = {
  object: GradAwardInsertInput;
  on_conflict?: Maybe<GradAwardOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradBookmarkJobArgs = {
  objects: Array<GradBookmarkJobInsertInput>;
  on_conflict?: Maybe<GradBookmarkJobOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradBookmarkJobOneArgs = {
  object: GradBookmarkJobInsertInput;
  on_conflict?: Maybe<GradBookmarkJobOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradCityStateSelectionArgs = {
  objects: Array<GradCityStateSelectionInsertInput>;
  on_conflict?: Maybe<GradCityStateSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradCityStateSelectionOneArgs = {
  object: GradCityStateSelectionInsertInput;
  on_conflict?: Maybe<GradCityStateSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradCommPreferenceSelectionArgs = {
  objects: Array<GradCommPreferenceSelectionInsertInput>;
  on_conflict?: Maybe<GradCommPreferenceSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradCommPreferenceSelectionOneArgs = {
  object: GradCommPreferenceSelectionInsertInput;
  on_conflict?: Maybe<GradCommPreferenceSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradCompanySelectionArgs = {
  objects: Array<GradCompanySelectionInsertInput>;
  on_conflict?: Maybe<GradCompanySelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradCompanySelectionOneArgs = {
  object: GradCompanySelectionInsertInput;
  on_conflict?: Maybe<GradCompanySelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradComputerLanguageArgs = {
  objects: Array<GradComputerLanguageInsertInput>;
  on_conflict?: Maybe<GradComputerLanguageOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradComputerLanguageOneArgs = {
  object: GradComputerLanguageInsertInput;
  on_conflict?: Maybe<GradComputerLanguageOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradComputerLanguageSelectionArgs = {
  objects: Array<GradComputerLanguageSelectionInsertInput>;
  on_conflict?: Maybe<GradComputerLanguageSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradComputerLanguageSelectionOneArgs = {
  object: GradComputerLanguageSelectionInsertInput;
  on_conflict?: Maybe<GradComputerLanguageSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradConcentrationArgs = {
  objects: Array<GradConcentrationInsertInput>;
  on_conflict?: Maybe<GradConcentrationOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradConcentrationOneArgs = {
  object: GradConcentrationInsertInput;
  on_conflict?: Maybe<GradConcentrationOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradCountrySelectionArgs = {
  objects: Array<GradCountrySelectionInsertInput>;
  on_conflict?: Maybe<GradCountrySelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradCountrySelectionOneArgs = {
  object: GradCountrySelectionInsertInput;
  on_conflict?: Maybe<GradCountrySelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradDegreeArgs = {
  objects: Array<GradDegreeInsertInput>;
  on_conflict?: Maybe<GradDegreeOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradDegreeFillInUniversityArgs = {
  objects: Array<GradDegreeFillInUniversityInsertInput>;
  on_conflict?: Maybe<GradDegreeFillInUniversityOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradDegreeFillInUniversityOneArgs = {
  object: GradDegreeFillInUniversityInsertInput;
  on_conflict?: Maybe<GradDegreeFillInUniversityOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradDegreeOneArgs = {
  object: GradDegreeInsertInput;
  on_conflict?: Maybe<GradDegreeOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradDegreeSelectionArgs = {
  objects: Array<GradDegreeSelectionInsertInput>;
  on_conflict?: Maybe<GradDegreeSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradDegreeSelectionOneArgs = {
  object: GradDegreeSelectionInsertInput;
  on_conflict?: Maybe<GradDegreeSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradEmployerPreferenceArgs = {
  objects: Array<GradEmployerPreferenceInsertInput>;
  on_conflict?: Maybe<GradEmployerPreferenceOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradEmployerPreferenceOneArgs = {
  object: GradEmployerPreferenceInsertInput;
  on_conflict?: Maybe<GradEmployerPreferenceOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradEmployerPreferenceSelectionArgs = {
  objects: Array<GradEmployerPreferenceSelectionInsertInput>;
  on_conflict?: Maybe<GradEmployerPreferenceSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradEmployerPreferenceSelectionOneArgs = {
  object: GradEmployerPreferenceSelectionInsertInput;
  on_conflict?: Maybe<GradEmployerPreferenceSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradEventRegistrationArgs = {
  objects: Array<GradEventRegistrationInsertInput>;
  on_conflict?: Maybe<GradEventRegistrationOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradEventRegistrationOneArgs = {
  object: GradEventRegistrationInsertInput;
  on_conflict?: Maybe<GradEventRegistrationOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradFunFactArgs = {
  objects: Array<GradFunFactInsertInput>;
  on_conflict?: Maybe<GradFunFactOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradFunFactOneArgs = {
  object: GradFunFactInsertInput;
  on_conflict?: Maybe<GradFunFactOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradFunFactSelectionArgs = {
  objects: Array<GradFunFactSelectionInsertInput>;
  on_conflict?: Maybe<GradFunFactSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradFunFactSelectionOneArgs = {
  object: GradFunFactSelectionInsertInput;
  on_conflict?: Maybe<GradFunFactSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradInterestFirmArgs = {
  objects: Array<GradInterestFirmInsertInput>;
  on_conflict?: Maybe<GradInterestFirmOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradInterestFirmOneArgs = {
  object: GradInterestFirmInsertInput;
  on_conflict?: Maybe<GradInterestFirmOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradInterestFirmSelectionArgs = {
  objects: Array<GradInterestFirmSelectionInsertInput>;
  on_conflict?: Maybe<GradInterestFirmSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradInterestFirmSelectionOneArgs = {
  object: GradInterestFirmSelectionInsertInput;
  on_conflict?: Maybe<GradInterestFirmSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradInterestJobTypeArgs = {
  objects: Array<GradInterestJobTypeInsertInput>;
  on_conflict?: Maybe<GradInterestJobTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradInterestJobTypeOneArgs = {
  object: GradInterestJobTypeInsertInput;
  on_conflict?: Maybe<GradInterestJobTypeOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradInterestJobTypeSelectionArgs = {
  objects: Array<GradInterestJobTypeSelectionInsertInput>;
  on_conflict?: Maybe<GradInterestJobTypeSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradInterestJobTypeSelectionOneArgs = {
  object: GradInterestJobTypeSelectionInsertInput;
  on_conflict?: Maybe<GradInterestJobTypeSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradInterestRegionArgs = {
  objects: Array<GradInterestRegionInsertInput>;
  on_conflict?: Maybe<GradInterestRegionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradInterestRegionOneArgs = {
  object: GradInterestRegionInsertInput;
  on_conflict?: Maybe<GradInterestRegionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradInterestRegionSelectionArgs = {
  objects: Array<GradInterestRegionSelectionInsertInput>;
  on_conflict?: Maybe<GradInterestRegionSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradInterestRegionSelectionOneArgs = {
  object: GradInterestRegionSelectionInsertInput;
  on_conflict?: Maybe<GradInterestRegionSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradInterestRoleArgs = {
  objects: Array<GradInterestRoleInsertInput>;
  on_conflict?: Maybe<GradInterestRoleOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradInterestRoleOneArgs = {
  object: GradInterestRoleInsertInput;
  on_conflict?: Maybe<GradInterestRoleOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradInterestRoleSelectionArgs = {
  objects: Array<GradInterestRoleSelectionInsertInput>;
  on_conflict?: Maybe<GradInterestRoleSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradInterestRoleSelectionOneArgs = {
  object: GradInterestRoleSelectionInsertInput;
  on_conflict?: Maybe<GradInterestRoleSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradMajorSelectionArgs = {
  objects: Array<GradMajorSelectionInsertInput>;
  on_conflict?: Maybe<GradMajorSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradMajorSelectionOneArgs = {
  object: GradMajorSelectionInsertInput;
  on_conflict?: Maybe<GradMajorSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradPageViewArgs = {
  objects: Array<GradPageViewInsertInput>;
  on_conflict?: Maybe<GradPageViewOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradPageViewOneArgs = {
  object: GradPageViewInsertInput;
  on_conflict?: Maybe<GradPageViewOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradProfileArgs = {
  objects: Array<GradProfileInsertInput>;
  on_conflict?: Maybe<GradProfileOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradProfileCombineArgs = {
  objects: Array<GradProfileCombineInsertInput>;
  on_conflict?: Maybe<GradProfileCombineOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradProfileCombineOneArgs = {
  object: GradProfileCombineInsertInput;
  on_conflict?: Maybe<GradProfileCombineOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradProfileOneArgs = {
  object: GradProfileInsertInput;
  on_conflict?: Maybe<GradProfileOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradRaiseHandArgs = {
  objects: Array<GradRaiseHandInsertInput>;
  on_conflict?: Maybe<GradRaiseHandOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradRaiseHandOneArgs = {
  object: GradRaiseHandInsertInput;
  on_conflict?: Maybe<GradRaiseHandOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradSpokenLanguageArgs = {
  objects: Array<GradSpokenLanguageInsertInput>;
  on_conflict?: Maybe<GradSpokenLanguageOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradSpokenLanguageOneArgs = {
  object: GradSpokenLanguageInsertInput;
  on_conflict?: Maybe<GradSpokenLanguageOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradTestScoreArgs = {
  objects: Array<GradTestScoreInsertInput>;
  on_conflict?: Maybe<GradTestScoreOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradTestScoreDetailArgs = {
  objects: Array<GradTestScoreDetailInsertInput>;
  on_conflict?: Maybe<GradTestScoreDetailOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradTestScoreDetailOneArgs = {
  object: GradTestScoreDetailInsertInput;
  on_conflict?: Maybe<GradTestScoreDetailOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradTestScoreOneArgs = {
  object: GradTestScoreInsertInput;
  on_conflict?: Maybe<GradTestScoreOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradUniversitySelectionArgs = {
  objects: Array<GradUniversitySelectionInsertInput>;
  on_conflict?: Maybe<GradUniversitySelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradUniversitySelectionOneArgs = {
  object: GradUniversitySelectionInsertInput;
  on_conflict?: Maybe<GradUniversitySelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradUniversityStatArgs = {
  objects: Array<GradUniversityStatInsertInput>;
  on_conflict?: Maybe<GradUniversityStatOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradUniversityStatOneArgs = {
  object: GradUniversityStatInsertInput;
  on_conflict?: Maybe<GradUniversityStatOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradUploadDocArgs = {
  objects: Array<GradUploadDocInsertInput>;
  on_conflict?: Maybe<GradUploadDocOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradUploadDocOneArgs = {
  object: GradUploadDocInsertInput;
  on_conflict?: Maybe<GradUploadDocOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradUserActivitySummaryArgs = {
  objects: Array<GradUserActivitySummaryInsertInput>;
  on_conflict?: Maybe<GradUserActivitySummaryOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradUserActivitySummaryOneArgs = {
  object: GradUserActivitySummaryInsertInput;
  on_conflict?: Maybe<GradUserActivitySummaryOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradVisaSelectionArgs = {
  objects: Array<GradVisaSelectionInsertInput>;
  on_conflict?: Maybe<GradVisaSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradVisaSelectionOneArgs = {
  object: GradVisaSelectionInsertInput;
  on_conflict?: Maybe<GradVisaSelectionOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradVolunteerArgs = {
  objects: Array<GradVolunteerInsertInput>;
  on_conflict?: Maybe<GradVolunteerOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradVolunteerOneArgs = {
  object: GradVolunteerInsertInput;
  on_conflict?: Maybe<GradVolunteerOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradWorkExperienceArgs = {
  objects: Array<GradWorkExperienceInsertInput>;
  on_conflict?: Maybe<GradWorkExperienceOnConflict>;
};


/** mutation root */
export type MutationRootInsertGradWorkExperienceOneArgs = {
  object: GradWorkExperienceInsertInput;
  on_conflict?: Maybe<GradWorkExperienceOnConflict>;
};


/** mutation root */
export type MutationRootInsertQueueHandlerPermissionArgs = {
  objects: Array<QueueHandlerPermissionInsertInput>;
  on_conflict?: Maybe<QueueHandlerPermissionOnConflict>;
};


/** mutation root */
export type MutationRootInsertQueueHandlerPermissionOneArgs = {
  object: QueueHandlerPermissionInsertInput;
  on_conflict?: Maybe<QueueHandlerPermissionOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitAccountArgs = {
  objects: Array<RecruitAccountInsertInput>;
  on_conflict?: Maybe<RecruitAccountOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitAccountOneArgs = {
  object: RecruitAccountInsertInput;
  on_conflict?: Maybe<RecruitAccountOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitCompanyArgs = {
  objects: Array<RecruitCompanyInsertInput>;
  on_conflict?: Maybe<RecruitCompanyOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitCompanyOneArgs = {
  object: RecruitCompanyInsertInput;
  on_conflict?: Maybe<RecruitCompanyOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitCompanySubindustryArgs = {
  objects: Array<RecruitCompanySubindustryInsertInput>;
  on_conflict?: Maybe<RecruitCompanySubindustryOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitCompanySubindustryOneArgs = {
  object: RecruitCompanySubindustryInsertInput;
  on_conflict?: Maybe<RecruitCompanySubindustryOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitEventArgs = {
  objects: Array<RecruitEventInsertInput>;
  on_conflict?: Maybe<RecruitEventOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitEventOneArgs = {
  object: RecruitEventInsertInput;
  on_conflict?: Maybe<RecruitEventOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitGradGroupArgs = {
  objects: Array<RecruitGradGroupInsertInput>;
  on_conflict?: Maybe<RecruitGradGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitGradGroupMemberArgs = {
  objects: Array<RecruitGradGroupMemberInsertInput>;
  on_conflict?: Maybe<RecruitGradGroupMemberOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitGradGroupMemberOneArgs = {
  object: RecruitGradGroupMemberInsertInput;
  on_conflict?: Maybe<RecruitGradGroupMemberOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitGradGroupOneArgs = {
  object: RecruitGradGroupInsertInput;
  on_conflict?: Maybe<RecruitGradGroupOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitJobPostingArgs = {
  objects: Array<RecruitJobPostingInsertInput>;
  on_conflict?: Maybe<RecruitJobPostingOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitJobPostingOneArgs = {
  object: RecruitJobPostingInsertInput;
  on_conflict?: Maybe<RecruitJobPostingOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitJobRequirementArgs = {
  objects: Array<RecruitJobRequirementInsertInput>;
  on_conflict?: Maybe<RecruitJobRequirementOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitJobRequirementOneArgs = {
  object: RecruitJobRequirementInsertInput;
  on_conflict?: Maybe<RecruitJobRequirementOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitJobRequirementValueArgs = {
  objects: Array<RecruitJobRequirementValueInsertInput>;
  on_conflict?: Maybe<RecruitJobRequirementValueOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitJobRequirementValueOneArgs = {
  object: RecruitJobRequirementValueInsertInput;
  on_conflict?: Maybe<RecruitJobRequirementValueOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitRecruiterArgs = {
  objects: Array<RecruitRecruiterInsertInput>;
  on_conflict?: Maybe<RecruitRecruiterOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitRecruiterOneArgs = {
  object: RecruitRecruiterInsertInput;
  on_conflict?: Maybe<RecruitRecruiterOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitSavedSearchArgs = {
  objects: Array<RecruitSavedSearchInsertInput>;
  on_conflict?: Maybe<RecruitSavedSearchOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitSavedSearchOneArgs = {
  object: RecruitSavedSearchInsertInput;
  on_conflict?: Maybe<RecruitSavedSearchOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitSmsCorrespondentArgs = {
  objects: Array<RecruitSmsCorrespondentInsertInput>;
  on_conflict?: Maybe<RecruitSmsCorrespondentOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitSmsCorrespondentOneArgs = {
  object: RecruitSmsCorrespondentInsertInput;
  on_conflict?: Maybe<RecruitSmsCorrespondentOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitSmsMessageArgs = {
  objects: Array<RecruitSmsMessageInsertInput>;
  on_conflict?: Maybe<RecruitSmsMessageOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitSmsMessageCorrespondentArgs = {
  objects: Array<RecruitSmsMessageCorrespondentInsertInput>;
  on_conflict?: Maybe<RecruitSmsMessageCorrespondentOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitSmsMessageCorrespondentOneArgs = {
  object: RecruitSmsMessageCorrespondentInsertInput;
  on_conflict?: Maybe<RecruitSmsMessageCorrespondentOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitSmsMessageOneArgs = {
  object: RecruitSmsMessageInsertInput;
  on_conflict?: Maybe<RecruitSmsMessageOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitSmsTemplateArgs = {
  objects: Array<RecruitSmsTemplateInsertInput>;
  on_conflict?: Maybe<RecruitSmsTemplateOnConflict>;
};


/** mutation root */
export type MutationRootInsertRecruitSmsTemplateOneArgs = {
  object: RecruitSmsTemplateInsertInput;
  on_conflict?: Maybe<RecruitSmsTemplateOnConflict>;
};


/** mutation root */
export type MutationRootInsertTestAuto3Args = {
  objects: Array<TestAuto3InsertInput>;
  on_conflict?: Maybe<TestAuto3OnConflict>;
};


/** mutation root */
export type MutationRootInsertTestAuto3OneArgs = {
  object: TestAuto3InsertInput;
  on_conflict?: Maybe<TestAuto3OnConflict>;
};


/** mutation root */
export type MutationRootInsertToQueueArgs = {
  objects: Array<ToQueueInsertInput>;
  on_conflict?: Maybe<ToQueueOnConflict>;
};


/** mutation root */
export type MutationRootInsertToQueueOneArgs = {
  object: ToQueueInsertInput;
  on_conflict?: Maybe<ToQueueOnConflict>;
};


/** mutation root */
export type MutationRootInsertToQueueResponseArgs = {
  objects: Array<ToQueueResponseInsertInput>;
  on_conflict?: Maybe<ToQueueResponseOnConflict>;
};


/** mutation root */
export type MutationRootInsertToQueueResponseOneArgs = {
  object: ToQueueResponseInsertInput;
  on_conflict?: Maybe<ToQueueResponseOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserAuthArgs = {
  objects: Array<UserAuthInsertInput>;
  on_conflict?: Maybe<UserAuthOnConflict>;
};


/** mutation root */
export type MutationRootInsertUserAuthOneArgs = {
  object: UserAuthInsertInput;
  on_conflict?: Maybe<UserAuthOnConflict>;
};


/** mutation root */
export type MutationRootInsertUseraccountArgs = {
  objects: Array<UseraccountInsertInput>;
  on_conflict?: Maybe<UseraccountOnConflict>;
};


/** mutation root */
export type MutationRootInsertUseraccountOneArgs = {
  object: UseraccountInsertInput;
  on_conflict?: Maybe<UseraccountOnConflict>;
};


/** mutation root */
export type MutationRootInsertWebApiPermissionArgs = {
  objects: Array<WebApiPermissionInsertInput>;
  on_conflict?: Maybe<WebApiPermissionOnConflict>;
};


/** mutation root */
export type MutationRootInsertWebApiPermissionOneArgs = {
  object: WebApiPermissionInsertInput;
  on_conflict?: Maybe<WebApiPermissionOnConflict>;
};


/** mutation root */
export type MutationRootQueueActionArgs = {
  content: Scalars['jsonb'];
  queue: Scalars['String'];
};


/** mutation root */
export type MutationRootUpdateAdminAdminuserArgs = {
  _set?: Maybe<AdminAdminuserSetInput>;
  where: AdminAdminuserBoolExp;
};


/** mutation root */
export type MutationRootUpdateAdminAdminuserByPkArgs = {
  _set?: Maybe<AdminAdminuserSetInput>;
  pk_columns: AdminAdminuserPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAdminAuth0mgmtArgs = {
  _inc?: Maybe<AdminAuth0mgmtIncInput>;
  _set?: Maybe<AdminAuth0mgmtSetInput>;
  where: AdminAuth0mgmtBoolExp;
};


/** mutation root */
export type MutationRootUpdateAdminAuth0mgmtByPkArgs = {
  _inc?: Maybe<AdminAuth0mgmtIncInput>;
  _set?: Maybe<AdminAuth0mgmtSetInput>;
  pk_columns: AdminAuth0mgmtPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAdminAuth0mgmtResultArgs = {
  _inc?: Maybe<AdminAuth0mgmtResultIncInput>;
  _set?: Maybe<AdminAuth0mgmtResultSetInput>;
  where: AdminAuth0mgmtResultBoolExp;
};


/** mutation root */
export type MutationRootUpdateAdminAuth0mgmtResultByPkArgs = {
  _inc?: Maybe<AdminAuth0mgmtResultIncInput>;
  _set?: Maybe<AdminAuth0mgmtResultSetInput>;
  pk_columns: AdminAuth0mgmtResultPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAdminEmailArgs = {
  _append?: Maybe<AdminEmailAppendInput>;
  _delete_at_path?: Maybe<AdminEmailDeleteAtPathInput>;
  _delete_elem?: Maybe<AdminEmailDeleteElemInput>;
  _delete_key?: Maybe<AdminEmailDeleteKeyInput>;
  _inc?: Maybe<AdminEmailIncInput>;
  _prepend?: Maybe<AdminEmailPrependInput>;
  _set?: Maybe<AdminEmailSetInput>;
  where: AdminEmailBoolExp;
};


/** mutation root */
export type MutationRootUpdateAdminEmailByPkArgs = {
  _append?: Maybe<AdminEmailAppendInput>;
  _delete_at_path?: Maybe<AdminEmailDeleteAtPathInput>;
  _delete_elem?: Maybe<AdminEmailDeleteElemInput>;
  _delete_key?: Maybe<AdminEmailDeleteKeyInput>;
  _inc?: Maybe<AdminEmailIncInput>;
  _prepend?: Maybe<AdminEmailPrependInput>;
  _set?: Maybe<AdminEmailSetInput>;
  pk_columns: AdminEmailPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAdminEmailLayoutArgs = {
  _set?: Maybe<AdminEmailLayoutSetInput>;
  where: AdminEmailLayoutBoolExp;
};


/** mutation root */
export type MutationRootUpdateAdminEmailLayoutByPkArgs = {
  _set?: Maybe<AdminEmailLayoutSetInput>;
  pk_columns: AdminEmailLayoutPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAdminEmailTemplateArgs = {
  _append?: Maybe<AdminEmailTemplateAppendInput>;
  _delete_at_path?: Maybe<AdminEmailTemplateDeleteAtPathInput>;
  _delete_elem?: Maybe<AdminEmailTemplateDeleteElemInput>;
  _delete_key?: Maybe<AdminEmailTemplateDeleteKeyInput>;
  _prepend?: Maybe<AdminEmailTemplatePrependInput>;
  _set?: Maybe<AdminEmailTemplateSetInput>;
  where: AdminEmailTemplateBoolExp;
};


/** mutation root */
export type MutationRootUpdateAdminEmailTemplateByPkArgs = {
  _append?: Maybe<AdminEmailTemplateAppendInput>;
  _delete_at_path?: Maybe<AdminEmailTemplateDeleteAtPathInput>;
  _delete_elem?: Maybe<AdminEmailTemplateDeleteElemInput>;
  _delete_key?: Maybe<AdminEmailTemplateDeleteKeyInput>;
  _prepend?: Maybe<AdminEmailTemplatePrependInput>;
  _set?: Maybe<AdminEmailTemplateSetInput>;
  pk_columns: AdminEmailTemplatePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAdminTwiliomgmtArgs = {
  _inc?: Maybe<AdminTwiliomgmtIncInput>;
  _set?: Maybe<AdminTwiliomgmtSetInput>;
  where: AdminTwiliomgmtBoolExp;
};


/** mutation root */
export type MutationRootUpdateAdminTwiliomgmtByPkArgs = {
  _inc?: Maybe<AdminTwiliomgmtIncInput>;
  _set?: Maybe<AdminTwiliomgmtSetInput>;
  pk_columns: AdminTwiliomgmtPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateAdminTwiliomgmtResultArgs = {
  _inc?: Maybe<AdminTwiliomgmtResultIncInput>;
  _set?: Maybe<AdminTwiliomgmtResultSetInput>;
  where: AdminTwiliomgmtResultBoolExp;
};


/** mutation root */
export type MutationRootUpdateAdminTwiliomgmtResultByPkArgs = {
  _inc?: Maybe<AdminTwiliomgmtResultIncInput>;
  _set?: Maybe<AdminTwiliomgmtResultSetInput>;
  pk_columns: AdminTwiliomgmtResultPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDbPingArgs = {
  _inc?: Maybe<DbPingIncInput>;
  _set?: Maybe<DbPingSetInput>;
  where: DbPingBoolExp;
};


/** mutation root */
export type MutationRootUpdateDbPingByPkArgs = {
  _inc?: Maybe<DbPingIncInput>;
  _set?: Maybe<DbPingSetInput>;
  pk_columns: DbPingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateDbStateArgs = {
  _append?: Maybe<DbStateAppendInput>;
  _delete_at_path?: Maybe<DbStateDeleteAtPathInput>;
  _delete_elem?: Maybe<DbStateDeleteElemInput>;
  _delete_key?: Maybe<DbStateDeleteKeyInput>;
  _prepend?: Maybe<DbStatePrependInput>;
  _set?: Maybe<DbStateSetInput>;
  where: DbStateBoolExp;
};


/** mutation root */
export type MutationRootUpdateDbStateByPkArgs = {
  _append?: Maybe<DbStateAppendInput>;
  _delete_at_path?: Maybe<DbStateDeleteAtPathInput>;
  _delete_elem?: Maybe<DbStateDeleteElemInput>;
  _delete_key?: Maybe<DbStateDeleteKeyInput>;
  _prepend?: Maybe<DbStatePrependInput>;
  _set?: Maybe<DbStateSetInput>;
  pk_columns: DbStatePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradAchievementArgs = {
  _set?: Maybe<GradAchievementSetInput>;
  where: GradAchievementBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradAchievementByPkArgs = {
  _set?: Maybe<GradAchievementSetInput>;
  pk_columns: GradAchievementPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradAwardArgs = {
  _inc?: Maybe<GradAwardIncInput>;
  _set?: Maybe<GradAwardSetInput>;
  where: GradAwardBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradAwardByPkArgs = {
  _inc?: Maybe<GradAwardIncInput>;
  _set?: Maybe<GradAwardSetInput>;
  pk_columns: GradAwardPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradBookmarkJobArgs = {
  _set?: Maybe<GradBookmarkJobSetInput>;
  where: GradBookmarkJobBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradBookmarkJobByPkArgs = {
  _set?: Maybe<GradBookmarkJobSetInput>;
  pk_columns: GradBookmarkJobPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradCityStateSelectionArgs = {
  _set?: Maybe<GradCityStateSelectionSetInput>;
  where: GradCityStateSelectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradCityStateSelectionByPkArgs = {
  _set?: Maybe<GradCityStateSelectionSetInput>;
  pk_columns: GradCityStateSelectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradCommPreferenceSelectionArgs = {
  _set?: Maybe<GradCommPreferenceSelectionSetInput>;
  where: GradCommPreferenceSelectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradCommPreferenceSelectionByPkArgs = {
  _set?: Maybe<GradCommPreferenceSelectionSetInput>;
  pk_columns: GradCommPreferenceSelectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradCompanySelectionArgs = {
  _set?: Maybe<GradCompanySelectionSetInput>;
  where: GradCompanySelectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradCompanySelectionByPkArgs = {
  _set?: Maybe<GradCompanySelectionSetInput>;
  pk_columns: GradCompanySelectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradComputerLanguageArgs = {
  _set?: Maybe<GradComputerLanguageSetInput>;
  where: GradComputerLanguageBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradComputerLanguageByPkArgs = {
  _set?: Maybe<GradComputerLanguageSetInput>;
  pk_columns: GradComputerLanguagePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradComputerLanguageSelectionArgs = {
  _set?: Maybe<GradComputerLanguageSelectionSetInput>;
  where: GradComputerLanguageSelectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradComputerLanguageSelectionByPkArgs = {
  _set?: Maybe<GradComputerLanguageSelectionSetInput>;
  pk_columns: GradComputerLanguageSelectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradConcentrationArgs = {
  _set?: Maybe<GradConcentrationSetInput>;
  where: GradConcentrationBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradConcentrationByPkArgs = {
  _set?: Maybe<GradConcentrationSetInput>;
  pk_columns: GradConcentrationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradCountrySelectionArgs = {
  _set?: Maybe<GradCountrySelectionSetInput>;
  where: GradCountrySelectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradCountrySelectionByPkArgs = {
  _set?: Maybe<GradCountrySelectionSetInput>;
  pk_columns: GradCountrySelectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradDegreeArgs = {
  _inc?: Maybe<GradDegreeIncInput>;
  _set?: Maybe<GradDegreeSetInput>;
  where: GradDegreeBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradDegreeByPkArgs = {
  _inc?: Maybe<GradDegreeIncInput>;
  _set?: Maybe<GradDegreeSetInput>;
  pk_columns: GradDegreePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradDegreeFillInUniversityArgs = {
  _set?: Maybe<GradDegreeFillInUniversitySetInput>;
  where: GradDegreeFillInUniversityBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradDegreeFillInUniversityByPkArgs = {
  _set?: Maybe<GradDegreeFillInUniversitySetInput>;
  pk_columns: GradDegreeFillInUniversityPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradDegreeSelectionArgs = {
  _set?: Maybe<GradDegreeSelectionSetInput>;
  where: GradDegreeSelectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradDegreeSelectionByPkArgs = {
  _set?: Maybe<GradDegreeSelectionSetInput>;
  pk_columns: GradDegreeSelectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradEmployerPreferenceArgs = {
  _set?: Maybe<GradEmployerPreferenceSetInput>;
  where: GradEmployerPreferenceBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradEmployerPreferenceByPkArgs = {
  _set?: Maybe<GradEmployerPreferenceSetInput>;
  pk_columns: GradEmployerPreferencePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradEmployerPreferenceSelectionArgs = {
  _set?: Maybe<GradEmployerPreferenceSelectionSetInput>;
  where: GradEmployerPreferenceSelectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradEmployerPreferenceSelectionByPkArgs = {
  _set?: Maybe<GradEmployerPreferenceSelectionSetInput>;
  pk_columns: GradEmployerPreferenceSelectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradEventRegistrationArgs = {
  _set?: Maybe<GradEventRegistrationSetInput>;
  where: GradEventRegistrationBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradEventRegistrationByPkArgs = {
  _set?: Maybe<GradEventRegistrationSetInput>;
  pk_columns: GradEventRegistrationPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradFunFactArgs = {
  _set?: Maybe<GradFunFactSetInput>;
  where: GradFunFactBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradFunFactByPkArgs = {
  _set?: Maybe<GradFunFactSetInput>;
  pk_columns: GradFunFactPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradFunFactSelectionArgs = {
  _set?: Maybe<GradFunFactSelectionSetInput>;
  where: GradFunFactSelectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradFunFactSelectionByPkArgs = {
  _set?: Maybe<GradFunFactSelectionSetInput>;
  pk_columns: GradFunFactSelectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradInterestFirmArgs = {
  _set?: Maybe<GradInterestFirmSetInput>;
  where: GradInterestFirmBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradInterestFirmByPkArgs = {
  _set?: Maybe<GradInterestFirmSetInput>;
  pk_columns: GradInterestFirmPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradInterestFirmSelectionArgs = {
  _set?: Maybe<GradInterestFirmSelectionSetInput>;
  where: GradInterestFirmSelectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradInterestFirmSelectionByPkArgs = {
  _set?: Maybe<GradInterestFirmSelectionSetInput>;
  pk_columns: GradInterestFirmSelectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradInterestJobTypeArgs = {
  _set?: Maybe<GradInterestJobTypeSetInput>;
  where: GradInterestJobTypeBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradInterestJobTypeByPkArgs = {
  _set?: Maybe<GradInterestJobTypeSetInput>;
  pk_columns: GradInterestJobTypePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradInterestJobTypeSelectionArgs = {
  _set?: Maybe<GradInterestJobTypeSelectionSetInput>;
  where: GradInterestJobTypeSelectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradInterestJobTypeSelectionByPkArgs = {
  _set?: Maybe<GradInterestJobTypeSelectionSetInput>;
  pk_columns: GradInterestJobTypeSelectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradInterestRegionArgs = {
  _set?: Maybe<GradInterestRegionSetInput>;
  where: GradInterestRegionBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradInterestRegionByPkArgs = {
  _set?: Maybe<GradInterestRegionSetInput>;
  pk_columns: GradInterestRegionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradInterestRegionSelectionArgs = {
  _set?: Maybe<GradInterestRegionSelectionSetInput>;
  where: GradInterestRegionSelectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradInterestRegionSelectionByPkArgs = {
  _set?: Maybe<GradInterestRegionSelectionSetInput>;
  pk_columns: GradInterestRegionSelectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradInterestRoleArgs = {
  _set?: Maybe<GradInterestRoleSetInput>;
  where: GradInterestRoleBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradInterestRoleByPkArgs = {
  _set?: Maybe<GradInterestRoleSetInput>;
  pk_columns: GradInterestRolePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradInterestRoleSelectionArgs = {
  _set?: Maybe<GradInterestRoleSelectionSetInput>;
  where: GradInterestRoleSelectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradInterestRoleSelectionByPkArgs = {
  _set?: Maybe<GradInterestRoleSelectionSetInput>;
  pk_columns: GradInterestRoleSelectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradMajorSelectionArgs = {
  _set?: Maybe<GradMajorSelectionSetInput>;
  where: GradMajorSelectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradMajorSelectionByPkArgs = {
  _set?: Maybe<GradMajorSelectionSetInput>;
  pk_columns: GradMajorSelectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradPageViewArgs = {
  _append?: Maybe<GradPageViewAppendInput>;
  _delete_at_path?: Maybe<GradPageViewDeleteAtPathInput>;
  _delete_elem?: Maybe<GradPageViewDeleteElemInput>;
  _delete_key?: Maybe<GradPageViewDeleteKeyInput>;
  _inc?: Maybe<GradPageViewIncInput>;
  _prepend?: Maybe<GradPageViewPrependInput>;
  _set?: Maybe<GradPageViewSetInput>;
  where: GradPageViewBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradPageViewByPkArgs = {
  _append?: Maybe<GradPageViewAppendInput>;
  _delete_at_path?: Maybe<GradPageViewDeleteAtPathInput>;
  _delete_elem?: Maybe<GradPageViewDeleteElemInput>;
  _delete_key?: Maybe<GradPageViewDeleteKeyInput>;
  _inc?: Maybe<GradPageViewIncInput>;
  _prepend?: Maybe<GradPageViewPrependInput>;
  _set?: Maybe<GradPageViewSetInput>;
  pk_columns: GradPageViewPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradProfileArgs = {
  _set?: Maybe<GradProfileSetInput>;
  where: GradProfileBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradProfileByPkArgs = {
  _set?: Maybe<GradProfileSetInput>;
  pk_columns: GradProfilePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradProfileCombineArgs = {
  _set?: Maybe<GradProfileCombineSetInput>;
  where: GradProfileCombineBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradRaiseHandArgs = {
  _set?: Maybe<GradRaiseHandSetInput>;
  where: GradRaiseHandBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradRaiseHandByPkArgs = {
  _set?: Maybe<GradRaiseHandSetInput>;
  pk_columns: GradRaiseHandPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradSpokenLanguageArgs = {
  _set?: Maybe<GradSpokenLanguageSetInput>;
  where: GradSpokenLanguageBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradSpokenLanguageByPkArgs = {
  _set?: Maybe<GradSpokenLanguageSetInput>;
  pk_columns: GradSpokenLanguagePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradTestScoreArgs = {
  _inc?: Maybe<GradTestScoreIncInput>;
  _set?: Maybe<GradTestScoreSetInput>;
  where: GradTestScoreBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradTestScoreByPkArgs = {
  _inc?: Maybe<GradTestScoreIncInput>;
  _set?: Maybe<GradTestScoreSetInput>;
  pk_columns: GradTestScorePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradTestScoreDetailArgs = {
  _inc?: Maybe<GradTestScoreDetailIncInput>;
  _set?: Maybe<GradTestScoreDetailSetInput>;
  where: GradTestScoreDetailBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradTestScoreDetailByPkArgs = {
  _inc?: Maybe<GradTestScoreDetailIncInput>;
  _set?: Maybe<GradTestScoreDetailSetInput>;
  pk_columns: GradTestScoreDetailPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradUniversitySelectionArgs = {
  _inc?: Maybe<GradUniversitySelectionIncInput>;
  _set?: Maybe<GradUniversitySelectionSetInput>;
  where: GradUniversitySelectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradUniversitySelectionByPkArgs = {
  _inc?: Maybe<GradUniversitySelectionIncInput>;
  _set?: Maybe<GradUniversitySelectionSetInput>;
  pk_columns: GradUniversitySelectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradUniversityStatArgs = {
  _inc?: Maybe<GradUniversityStatIncInput>;
  _set?: Maybe<GradUniversityStatSetInput>;
  where: GradUniversityStatBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradUploadDocArgs = {
  _set?: Maybe<GradUploadDocSetInput>;
  where: GradUploadDocBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradUploadDocByPkArgs = {
  _set?: Maybe<GradUploadDocSetInput>;
  pk_columns: GradUploadDocPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradUserActivitySummaryArgs = {
  _inc?: Maybe<GradUserActivitySummaryIncInput>;
  _set?: Maybe<GradUserActivitySummarySetInput>;
  where: GradUserActivitySummaryBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradUserActivitySummaryByPkArgs = {
  _inc?: Maybe<GradUserActivitySummaryIncInput>;
  _set?: Maybe<GradUserActivitySummarySetInput>;
  pk_columns: GradUserActivitySummaryPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradVisaSelectionArgs = {
  _set?: Maybe<GradVisaSelectionSetInput>;
  where: GradVisaSelectionBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradVisaSelectionByPkArgs = {
  _set?: Maybe<GradVisaSelectionSetInput>;
  pk_columns: GradVisaSelectionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradVolunteerArgs = {
  _set?: Maybe<GradVolunteerSetInput>;
  where: GradVolunteerBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradVolunteerByPkArgs = {
  _set?: Maybe<GradVolunteerSetInput>;
  pk_columns: GradVolunteerPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateGradWorkExperienceArgs = {
  _inc?: Maybe<GradWorkExperienceIncInput>;
  _set?: Maybe<GradWorkExperienceSetInput>;
  where: GradWorkExperienceBoolExp;
};


/** mutation root */
export type MutationRootUpdateGradWorkExperienceByPkArgs = {
  _inc?: Maybe<GradWorkExperienceIncInput>;
  _set?: Maybe<GradWorkExperienceSetInput>;
  pk_columns: GradWorkExperiencePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateQueueHandlerPermissionArgs = {
  _set?: Maybe<QueueHandlerPermissionSetInput>;
  where: QueueHandlerPermissionBoolExp;
};


/** mutation root */
export type MutationRootUpdateQueueHandlerPermissionByPkArgs = {
  _set?: Maybe<QueueHandlerPermissionSetInput>;
  pk_columns: QueueHandlerPermissionPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRecruitAccountArgs = {
  _set?: Maybe<RecruitAccountSetInput>;
  where: RecruitAccountBoolExp;
};


/** mutation root */
export type MutationRootUpdateRecruitAccountByPkArgs = {
  _set?: Maybe<RecruitAccountSetInput>;
  pk_columns: RecruitAccountPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRecruitCompanyArgs = {
  _inc?: Maybe<RecruitCompanyIncInput>;
  _set?: Maybe<RecruitCompanySetInput>;
  where: RecruitCompanyBoolExp;
};


/** mutation root */
export type MutationRootUpdateRecruitCompanyByPkArgs = {
  _inc?: Maybe<RecruitCompanyIncInput>;
  _set?: Maybe<RecruitCompanySetInput>;
  pk_columns: RecruitCompanyPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRecruitCompanySubindustryArgs = {
  _inc?: Maybe<RecruitCompanySubindustryIncInput>;
  _set?: Maybe<RecruitCompanySubindustrySetInput>;
  where: RecruitCompanySubindustryBoolExp;
};


/** mutation root */
export type MutationRootUpdateRecruitCompanySubindustryByPkArgs = {
  _inc?: Maybe<RecruitCompanySubindustryIncInput>;
  _set?: Maybe<RecruitCompanySubindustrySetInput>;
  pk_columns: RecruitCompanySubindustryPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRecruitEventArgs = {
  _inc?: Maybe<RecruitEventIncInput>;
  _set?: Maybe<RecruitEventSetInput>;
  where: RecruitEventBoolExp;
};


/** mutation root */
export type MutationRootUpdateRecruitEventByPkArgs = {
  _inc?: Maybe<RecruitEventIncInput>;
  _set?: Maybe<RecruitEventSetInput>;
  pk_columns: RecruitEventPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRecruitGradGroupArgs = {
  _set?: Maybe<RecruitGradGroupSetInput>;
  where: RecruitGradGroupBoolExp;
};


/** mutation root */
export type MutationRootUpdateRecruitGradGroupByPkArgs = {
  _set?: Maybe<RecruitGradGroupSetInput>;
  pk_columns: RecruitGradGroupPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRecruitGradGroupMemberArgs = {
  _set?: Maybe<RecruitGradGroupMemberSetInput>;
  where: RecruitGradGroupMemberBoolExp;
};


/** mutation root */
export type MutationRootUpdateRecruitGradGroupMemberByPkArgs = {
  _set?: Maybe<RecruitGradGroupMemberSetInput>;
  pk_columns: RecruitGradGroupMemberPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRecruitJobPostingArgs = {
  _set?: Maybe<RecruitJobPostingSetInput>;
  where: RecruitJobPostingBoolExp;
};


/** mutation root */
export type MutationRootUpdateRecruitJobPostingByPkArgs = {
  _set?: Maybe<RecruitJobPostingSetInput>;
  pk_columns: RecruitJobPostingPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRecruitJobRequirementArgs = {
  _inc?: Maybe<RecruitJobRequirementIncInput>;
  _set?: Maybe<RecruitJobRequirementSetInput>;
  where: RecruitJobRequirementBoolExp;
};


/** mutation root */
export type MutationRootUpdateRecruitJobRequirementByPkArgs = {
  _inc?: Maybe<RecruitJobRequirementIncInput>;
  _set?: Maybe<RecruitJobRequirementSetInput>;
  pk_columns: RecruitJobRequirementPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRecruitJobRequirementValueArgs = {
  _set?: Maybe<RecruitJobRequirementValueSetInput>;
  where: RecruitJobRequirementValueBoolExp;
};


/** mutation root */
export type MutationRootUpdateRecruitJobRequirementValueByPkArgs = {
  _set?: Maybe<RecruitJobRequirementValueSetInput>;
  pk_columns: RecruitJobRequirementValuePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRecruitRecruiterArgs = {
  _set?: Maybe<RecruitRecruiterSetInput>;
  where: RecruitRecruiterBoolExp;
};


/** mutation root */
export type MutationRootUpdateRecruitRecruiterByPkArgs = {
  _set?: Maybe<RecruitRecruiterSetInput>;
  pk_columns: RecruitRecruiterPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRecruitSavedSearchArgs = {
  _append?: Maybe<RecruitSavedSearchAppendInput>;
  _delete_at_path?: Maybe<RecruitSavedSearchDeleteAtPathInput>;
  _delete_elem?: Maybe<RecruitSavedSearchDeleteElemInput>;
  _delete_key?: Maybe<RecruitSavedSearchDeleteKeyInput>;
  _prepend?: Maybe<RecruitSavedSearchPrependInput>;
  _set?: Maybe<RecruitSavedSearchSetInput>;
  where: RecruitSavedSearchBoolExp;
};


/** mutation root */
export type MutationRootUpdateRecruitSavedSearchByPkArgs = {
  _append?: Maybe<RecruitSavedSearchAppendInput>;
  _delete_at_path?: Maybe<RecruitSavedSearchDeleteAtPathInput>;
  _delete_elem?: Maybe<RecruitSavedSearchDeleteElemInput>;
  _delete_key?: Maybe<RecruitSavedSearchDeleteKeyInput>;
  _prepend?: Maybe<RecruitSavedSearchPrependInput>;
  _set?: Maybe<RecruitSavedSearchSetInput>;
  pk_columns: RecruitSavedSearchPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRecruitSmsCorrespondentArgs = {
  _inc?: Maybe<RecruitSmsCorrespondentIncInput>;
  _set?: Maybe<RecruitSmsCorrespondentSetInput>;
  where: RecruitSmsCorrespondentBoolExp;
};


/** mutation root */
export type MutationRootUpdateRecruitSmsCorrespondentByPkArgs = {
  _inc?: Maybe<RecruitSmsCorrespondentIncInput>;
  _set?: Maybe<RecruitSmsCorrespondentSetInput>;
  pk_columns: RecruitSmsCorrespondentPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRecruitSmsMessageArgs = {
  _inc?: Maybe<RecruitSmsMessageIncInput>;
  _set?: Maybe<RecruitSmsMessageSetInput>;
  where: RecruitSmsMessageBoolExp;
};


/** mutation root */
export type MutationRootUpdateRecruitSmsMessageByPkArgs = {
  _inc?: Maybe<RecruitSmsMessageIncInput>;
  _set?: Maybe<RecruitSmsMessageSetInput>;
  pk_columns: RecruitSmsMessagePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRecruitSmsMessageCorrespondentArgs = {
  _inc?: Maybe<RecruitSmsMessageCorrespondentIncInput>;
  _set?: Maybe<RecruitSmsMessageCorrespondentSetInput>;
  where: RecruitSmsMessageCorrespondentBoolExp;
};


/** mutation root */
export type MutationRootUpdateRecruitSmsMessageCorrespondentByPkArgs = {
  _inc?: Maybe<RecruitSmsMessageCorrespondentIncInput>;
  _set?: Maybe<RecruitSmsMessageCorrespondentSetInput>;
  pk_columns: RecruitSmsMessageCorrespondentPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateRecruitSmsTemplateArgs = {
  _inc?: Maybe<RecruitSmsTemplateIncInput>;
  _set?: Maybe<RecruitSmsTemplateSetInput>;
  where: RecruitSmsTemplateBoolExp;
};


/** mutation root */
export type MutationRootUpdateRecruitSmsTemplateByPkArgs = {
  _inc?: Maybe<RecruitSmsTemplateIncInput>;
  _set?: Maybe<RecruitSmsTemplateSetInput>;
  pk_columns: RecruitSmsTemplatePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateTestAuto3Args = {
  _inc?: Maybe<TestAuto3IncInput>;
  _set?: Maybe<TestAuto3SetInput>;
  where: TestAuto3BoolExp;
};


/** mutation root */
export type MutationRootUpdateTestAuto3ByPkArgs = {
  _inc?: Maybe<TestAuto3IncInput>;
  _set?: Maybe<TestAuto3SetInput>;
  pk_columns: TestAuto3PkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateToQueueArgs = {
  _append?: Maybe<ToQueueAppendInput>;
  _delete_at_path?: Maybe<ToQueueDeleteAtPathInput>;
  _delete_elem?: Maybe<ToQueueDeleteElemInput>;
  _delete_key?: Maybe<ToQueueDeleteKeyInput>;
  _inc?: Maybe<ToQueueIncInput>;
  _prepend?: Maybe<ToQueuePrependInput>;
  _set?: Maybe<ToQueueSetInput>;
  where: ToQueueBoolExp;
};


/** mutation root */
export type MutationRootUpdateToQueueByPkArgs = {
  _append?: Maybe<ToQueueAppendInput>;
  _delete_at_path?: Maybe<ToQueueDeleteAtPathInput>;
  _delete_elem?: Maybe<ToQueueDeleteElemInput>;
  _delete_key?: Maybe<ToQueueDeleteKeyInput>;
  _inc?: Maybe<ToQueueIncInput>;
  _prepend?: Maybe<ToQueuePrependInput>;
  _set?: Maybe<ToQueueSetInput>;
  pk_columns: ToQueuePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateToQueueResponseArgs = {
  _append?: Maybe<ToQueueResponseAppendInput>;
  _delete_at_path?: Maybe<ToQueueResponseDeleteAtPathInput>;
  _delete_elem?: Maybe<ToQueueResponseDeleteElemInput>;
  _delete_key?: Maybe<ToQueueResponseDeleteKeyInput>;
  _inc?: Maybe<ToQueueResponseIncInput>;
  _prepend?: Maybe<ToQueueResponsePrependInput>;
  _set?: Maybe<ToQueueResponseSetInput>;
  where: ToQueueResponseBoolExp;
};


/** mutation root */
export type MutationRootUpdateToQueueResponseByPkArgs = {
  _append?: Maybe<ToQueueResponseAppendInput>;
  _delete_at_path?: Maybe<ToQueueResponseDeleteAtPathInput>;
  _delete_elem?: Maybe<ToQueueResponseDeleteElemInput>;
  _delete_key?: Maybe<ToQueueResponseDeleteKeyInput>;
  _inc?: Maybe<ToQueueResponseIncInput>;
  _prepend?: Maybe<ToQueueResponsePrependInput>;
  _set?: Maybe<ToQueueResponseSetInput>;
  pk_columns: ToQueueResponsePkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateUserAuthArgs = {
  _set?: Maybe<UserAuthSetInput>;
  where: UserAuthBoolExp;
};


/** mutation root */
export type MutationRootUpdateUserAuthByPkArgs = {
  _set?: Maybe<UserAuthSetInput>;
  pk_columns: UserAuthPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateUseraccountArgs = {
  _inc?: Maybe<UseraccountIncInput>;
  _set?: Maybe<UseraccountSetInput>;
  where: UseraccountBoolExp;
};


/** mutation root */
export type MutationRootUpdateUseraccountByPkArgs = {
  _inc?: Maybe<UseraccountIncInput>;
  _set?: Maybe<UseraccountSetInput>;
  pk_columns: UseraccountPkColumnsInput;
};


/** mutation root */
export type MutationRootUpdateWebApiPermissionArgs = {
  _set?: Maybe<WebApiPermissionSetInput>;
  where: WebApiPermissionBoolExp;
};


/** mutation root */
export type MutationRootUpdateWebApiPermissionByPkArgs = {
  _set?: Maybe<WebApiPermissionSetInput>;
  pk_columns: WebApiPermissionPkColumnsInput;
};


/** expression to compare columns of type numeric. All fields are combined with logical 'AND'. */
export type NumericComparisonExp = {
  _eq?: Maybe<Scalars['numeric']>;
  _gt?: Maybe<Scalars['numeric']>;
  _gte?: Maybe<Scalars['numeric']>;
  _in?: Maybe<Array<Scalars['numeric']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['numeric']>;
  _lte?: Maybe<Scalars['numeric']>;
  _neq?: Maybe<Scalars['numeric']>;
  _nin?: Maybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum OrderBy {
  /** in the ascending order, nulls last */
  Asc = 'asc',
  /** in the ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in the ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in the descending order, nulls first */
  Desc = 'desc',
  /** in the descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in the descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** query root */
export type QueryRoot = {
  __typename?: 'query_root';
  /** fetch data from the table: "admin.adminuser" */
  admin_adminuser: Array<AdminAdminuser>;
  /** fetch aggregated fields from the table: "admin.adminuser" */
  admin_adminuser_aggregate: AdminAdminuserAggregate;
  /** fetch data from the table: "admin.adminuser" using primary key columns */
  admin_adminuser_by_pk?: Maybe<AdminAdminuser>;
  /** fetch data from the table: "admin.auth0mgmt" */
  admin_auth0mgmt: Array<AdminAuth0mgmt>;
  /** fetch aggregated fields from the table: "admin.auth0mgmt" */
  admin_auth0mgmt_aggregate: AdminAuth0mgmtAggregate;
  /** fetch data from the table: "admin.auth0mgmt" using primary key columns */
  admin_auth0mgmt_by_pk?: Maybe<AdminAuth0mgmt>;
  /** fetch data from the table: "admin.auth0mgmt_result" */
  admin_auth0mgmt_result: Array<AdminAuth0mgmtResult>;
  /** fetch aggregated fields from the table: "admin.auth0mgmt_result" */
  admin_auth0mgmt_result_aggregate: AdminAuth0mgmtResultAggregate;
  /** fetch data from the table: "admin.auth0mgmt_result" using primary key columns */
  admin_auth0mgmt_result_by_pk?: Maybe<AdminAuth0mgmtResult>;
  /** fetch data from the table: "admin.email" */
  admin_email: Array<AdminEmail>;
  /** fetch aggregated fields from the table: "admin.email" */
  admin_email_aggregate: AdminEmailAggregate;
  /** fetch data from the table: "admin.email" using primary key columns */
  admin_email_by_pk?: Maybe<AdminEmail>;
  /** fetch data from the table: "admin.email_layout" */
  admin_email_layout: Array<AdminEmailLayout>;
  /** fetch aggregated fields from the table: "admin.email_layout" */
  admin_email_layout_aggregate: AdminEmailLayoutAggregate;
  /** fetch data from the table: "admin.email_layout" using primary key columns */
  admin_email_layout_by_pk?: Maybe<AdminEmailLayout>;
  /** fetch data from the table: "admin.email_template" */
  admin_email_template: Array<AdminEmailTemplate>;
  /** fetch aggregated fields from the table: "admin.email_template" */
  admin_email_template_aggregate: AdminEmailTemplateAggregate;
  /** fetch data from the table: "admin.email_template" using primary key columns */
  admin_email_template_by_pk?: Maybe<AdminEmailTemplate>;
  /** fetch data from the table: "admin.twiliomgmt" */
  admin_twiliomgmt: Array<AdminTwiliomgmt>;
  /** fetch aggregated fields from the table: "admin.twiliomgmt" */
  admin_twiliomgmt_aggregate: AdminTwiliomgmtAggregate;
  /** fetch data from the table: "admin.twiliomgmt" using primary key columns */
  admin_twiliomgmt_by_pk?: Maybe<AdminTwiliomgmt>;
  /** fetch data from the table: "admin.twiliomgmt_result" */
  admin_twiliomgmt_result: Array<AdminTwiliomgmtResult>;
  /** fetch aggregated fields from the table: "admin.twiliomgmt_result" */
  admin_twiliomgmt_result_aggregate: AdminTwiliomgmtResultAggregate;
  /** fetch data from the table: "admin.twiliomgmt_result" using primary key columns */
  admin_twiliomgmt_result_by_pk?: Maybe<AdminTwiliomgmtResult>;
  /** fetch data from the table: "db_ping" */
  db_ping: Array<DbPing>;
  /** fetch aggregated fields from the table: "db_ping" */
  db_ping_aggregate: DbPingAggregate;
  /** fetch data from the table: "db_ping" using primary key columns */
  db_ping_by_pk?: Maybe<DbPing>;
  /** fetch data from the table: "db_state" */
  db_state: Array<DbState>;
  /** fetch aggregated fields from the table: "db_state" */
  db_state_aggregate: DbStateAggregate;
  /** fetch data from the table: "db_state" using primary key columns */
  db_state_by_pk?: Maybe<DbState>;
  /** fetch data from the table: "grad.achievement" */
  grad_achievement: Array<GradAchievement>;
  /** fetch aggregated fields from the table: "grad.achievement" */
  grad_achievement_aggregate: GradAchievementAggregate;
  /** fetch data from the table: "grad.achievement" using primary key columns */
  grad_achievement_by_pk?: Maybe<GradAchievement>;
  /** fetch data from the table: "grad.award" */
  grad_award: Array<GradAward>;
  /** fetch aggregated fields from the table: "grad.award" */
  grad_award_aggregate: GradAwardAggregate;
  /** fetch data from the table: "grad.award" using primary key columns */
  grad_award_by_pk?: Maybe<GradAward>;
  /** fetch data from the table: "grad.bookmark_job" */
  grad_bookmark_job: Array<GradBookmarkJob>;
  /** fetch aggregated fields from the table: "grad.bookmark_job" */
  grad_bookmark_job_aggregate: GradBookmarkJobAggregate;
  /** fetch data from the table: "grad.bookmark_job" using primary key columns */
  grad_bookmark_job_by_pk?: Maybe<GradBookmarkJob>;
  /** fetch data from the table: "grad.city_state_selection" */
  grad_city_state_selection: Array<GradCityStateSelection>;
  /** fetch aggregated fields from the table: "grad.city_state_selection" */
  grad_city_state_selection_aggregate: GradCityStateSelectionAggregate;
  /** fetch data from the table: "grad.city_state_selection" using primary key columns */
  grad_city_state_selection_by_pk?: Maybe<GradCityStateSelection>;
  /** fetch data from the table: "grad.comm_preference_selection" */
  grad_comm_preference_selection: Array<GradCommPreferenceSelection>;
  /** fetch aggregated fields from the table: "grad.comm_preference_selection" */
  grad_comm_preference_selection_aggregate: GradCommPreferenceSelectionAggregate;
  /** fetch data from the table: "grad.comm_preference_selection" using primary key columns */
  grad_comm_preference_selection_by_pk?: Maybe<GradCommPreferenceSelection>;
  /** fetch data from the table: "grad.company_selection" */
  grad_company_selection: Array<GradCompanySelection>;
  /** fetch aggregated fields from the table: "grad.company_selection" */
  grad_company_selection_aggregate: GradCompanySelectionAggregate;
  /** fetch data from the table: "grad.company_selection" using primary key columns */
  grad_company_selection_by_pk?: Maybe<GradCompanySelection>;
  /** fetch data from the table: "grad.computer_language" */
  grad_computer_language: Array<GradComputerLanguage>;
  /** fetch aggregated fields from the table: "grad.computer_language" */
  grad_computer_language_aggregate: GradComputerLanguageAggregate;
  /** fetch data from the table: "grad.computer_language" using primary key columns */
  grad_computer_language_by_pk?: Maybe<GradComputerLanguage>;
  /** fetch data from the table: "grad.computer_language_selection" */
  grad_computer_language_selection: Array<GradComputerLanguageSelection>;
  /** fetch aggregated fields from the table: "grad.computer_language_selection" */
  grad_computer_language_selection_aggregate: GradComputerLanguageSelectionAggregate;
  /** fetch data from the table: "grad.computer_language_selection" using primary key columns */
  grad_computer_language_selection_by_pk?: Maybe<GradComputerLanguageSelection>;
  /** fetch data from the table: "grad.concentration" */
  grad_concentration: Array<GradConcentration>;
  /** fetch aggregated fields from the table: "grad.concentration" */
  grad_concentration_aggregate: GradConcentrationAggregate;
  /** fetch data from the table: "grad.concentration" using primary key columns */
  grad_concentration_by_pk?: Maybe<GradConcentration>;
  /** fetch data from the table: "grad.country_selection" */
  grad_country_selection: Array<GradCountrySelection>;
  /** fetch aggregated fields from the table: "grad.country_selection" */
  grad_country_selection_aggregate: GradCountrySelectionAggregate;
  /** fetch data from the table: "grad.country_selection" using primary key columns */
  grad_country_selection_by_pk?: Maybe<GradCountrySelection>;
  /** fetch data from the table: "grad.degree" */
  grad_degree: Array<GradDegree>;
  /** fetch aggregated fields from the table: "grad.degree" */
  grad_degree_aggregate: GradDegreeAggregate;
  /** fetch data from the table: "grad.degree" using primary key columns */
  grad_degree_by_pk?: Maybe<GradDegree>;
  /** fetch data from the table: "grad.degree_fill_in_university" */
  grad_degree_fill_in_university: Array<GradDegreeFillInUniversity>;
  /** fetch aggregated fields from the table: "grad.degree_fill_in_university" */
  grad_degree_fill_in_university_aggregate: GradDegreeFillInUniversityAggregate;
  /** fetch data from the table: "grad.degree_fill_in_university" using primary key columns */
  grad_degree_fill_in_university_by_pk?: Maybe<GradDegreeFillInUniversity>;
  /** fetch data from the table: "grad.degree_latest" */
  grad_degree_latest: Array<GradDegreeLatest>;
  /** fetch aggregated fields from the table: "grad.degree_latest" */
  grad_degree_latest_aggregate: GradDegreeLatestAggregate;
  /** fetch data from the table: "grad.degree_selection" */
  grad_degree_selection: Array<GradDegreeSelection>;
  /** fetch aggregated fields from the table: "grad.degree_selection" */
  grad_degree_selection_aggregate: GradDegreeSelectionAggregate;
  /** fetch data from the table: "grad.degree_selection" using primary key columns */
  grad_degree_selection_by_pk?: Maybe<GradDegreeSelection>;
  /** fetch data from the table: "grad.employer_preference" */
  grad_employer_preference: Array<GradEmployerPreference>;
  /** fetch aggregated fields from the table: "grad.employer_preference" */
  grad_employer_preference_aggregate: GradEmployerPreferenceAggregate;
  /** fetch data from the table: "grad.employer_preference" using primary key columns */
  grad_employer_preference_by_pk?: Maybe<GradEmployerPreference>;
  /** fetch data from the table: "grad.employer_preference_selection" */
  grad_employer_preference_selection: Array<GradEmployerPreferenceSelection>;
  /** fetch aggregated fields from the table: "grad.employer_preference_selection" */
  grad_employer_preference_selection_aggregate: GradEmployerPreferenceSelectionAggregate;
  /** fetch data from the table: "grad.employer_preference_selection" using primary key columns */
  grad_employer_preference_selection_by_pk?: Maybe<GradEmployerPreferenceSelection>;
  /** fetch data from the table: "grad.event_registration" */
  grad_event_registration: Array<GradEventRegistration>;
  /** fetch aggregated fields from the table: "grad.event_registration" */
  grad_event_registration_aggregate: GradEventRegistrationAggregate;
  /** fetch data from the table: "grad.event_registration" using primary key columns */
  grad_event_registration_by_pk?: Maybe<GradEventRegistration>;
  /** fetch data from the table: "grad.fun_fact" */
  grad_fun_fact: Array<GradFunFact>;
  /** fetch aggregated fields from the table: "grad.fun_fact" */
  grad_fun_fact_aggregate: GradFunFactAggregate;
  /** fetch data from the table: "grad.fun_fact" using primary key columns */
  grad_fun_fact_by_pk?: Maybe<GradFunFact>;
  /** fetch data from the table: "grad.fun_fact_selection" */
  grad_fun_fact_selection: Array<GradFunFactSelection>;
  /** fetch aggregated fields from the table: "grad.fun_fact_selection" */
  grad_fun_fact_selection_aggregate: GradFunFactSelectionAggregate;
  /** fetch data from the table: "grad.fun_fact_selection" using primary key columns */
  grad_fun_fact_selection_by_pk?: Maybe<GradFunFactSelection>;
  /** fetch data from the table: "grad.interest_firm" */
  grad_interest_firm: Array<GradInterestFirm>;
  /** fetch aggregated fields from the table: "grad.interest_firm" */
  grad_interest_firm_aggregate: GradInterestFirmAggregate;
  /** fetch data from the table: "grad.interest_firm" using primary key columns */
  grad_interest_firm_by_pk?: Maybe<GradInterestFirm>;
  /** fetch data from the table: "grad.interest_firm_selection" */
  grad_interest_firm_selection: Array<GradInterestFirmSelection>;
  /** fetch aggregated fields from the table: "grad.interest_firm_selection" */
  grad_interest_firm_selection_aggregate: GradInterestFirmSelectionAggregate;
  /** fetch data from the table: "grad.interest_firm_selection" using primary key columns */
  grad_interest_firm_selection_by_pk?: Maybe<GradInterestFirmSelection>;
  /** fetch data from the table: "grad.interest_job_type" */
  grad_interest_job_type: Array<GradInterestJobType>;
  /** fetch aggregated fields from the table: "grad.interest_job_type" */
  grad_interest_job_type_aggregate: GradInterestJobTypeAggregate;
  /** fetch data from the table: "grad.interest_job_type" using primary key columns */
  grad_interest_job_type_by_pk?: Maybe<GradInterestJobType>;
  /** fetch data from the table: "grad.interest_job_type_selection" */
  grad_interest_job_type_selection: Array<GradInterestJobTypeSelection>;
  /** fetch aggregated fields from the table: "grad.interest_job_type_selection" */
  grad_interest_job_type_selection_aggregate: GradInterestJobTypeSelectionAggregate;
  /** fetch data from the table: "grad.interest_job_type_selection" using primary key columns */
  grad_interest_job_type_selection_by_pk?: Maybe<GradInterestJobTypeSelection>;
  /** fetch data from the table: "grad.interest_region" */
  grad_interest_region: Array<GradInterestRegion>;
  /** fetch aggregated fields from the table: "grad.interest_region" */
  grad_interest_region_aggregate: GradInterestRegionAggregate;
  /** fetch data from the table: "grad.interest_region" using primary key columns */
  grad_interest_region_by_pk?: Maybe<GradInterestRegion>;
  /** fetch data from the table: "grad.interest_region_selection" */
  grad_interest_region_selection: Array<GradInterestRegionSelection>;
  /** fetch aggregated fields from the table: "grad.interest_region_selection" */
  grad_interest_region_selection_aggregate: GradInterestRegionSelectionAggregate;
  /** fetch data from the table: "grad.interest_region_selection" using primary key columns */
  grad_interest_region_selection_by_pk?: Maybe<GradInterestRegionSelection>;
  /** fetch data from the table: "grad.interest_role" */
  grad_interest_role: Array<GradInterestRole>;
  /** fetch aggregated fields from the table: "grad.interest_role" */
  grad_interest_role_aggregate: GradInterestRoleAggregate;
  /** fetch data from the table: "grad.interest_role" using primary key columns */
  grad_interest_role_by_pk?: Maybe<GradInterestRole>;
  /** fetch data from the table: "grad.interest_role_selection" */
  grad_interest_role_selection: Array<GradInterestRoleSelection>;
  /** fetch aggregated fields from the table: "grad.interest_role_selection" */
  grad_interest_role_selection_aggregate: GradInterestRoleSelectionAggregate;
  /** fetch data from the table: "grad.interest_role_selection" using primary key columns */
  grad_interest_role_selection_by_pk?: Maybe<GradInterestRoleSelection>;
  /** fetch data from the table: "grad.major_selection" */
  grad_major_selection: Array<GradMajorSelection>;
  /** fetch aggregated fields from the table: "grad.major_selection" */
  grad_major_selection_aggregate: GradMajorSelectionAggregate;
  /** fetch data from the table: "grad.major_selection" using primary key columns */
  grad_major_selection_by_pk?: Maybe<GradMajorSelection>;
  /** fetch data from the table: "grad.page_view" */
  grad_page_view: Array<GradPageView>;
  /** fetch aggregated fields from the table: "grad.page_view" */
  grad_page_view_aggregate: GradPageViewAggregate;
  /** fetch data from the table: "grad.page_view" using primary key columns */
  grad_page_view_by_pk?: Maybe<GradPageView>;
  /** fetch data from the table: "grad.profile" */
  grad_profile: Array<GradProfile>;
  /** fetch aggregated fields from the table: "grad.profile" */
  grad_profile_aggregate: GradProfileAggregate;
  /** fetch data from the table: "grad.profile" using primary key columns */
  grad_profile_by_pk?: Maybe<GradProfile>;
  /** fetch data from the table: "grad.profile_combine" */
  grad_profile_combine: Array<GradProfileCombine>;
  /** fetch aggregated fields from the table: "grad.profile_combine" */
  grad_profile_combine_aggregate: GradProfileCombineAggregate;
  /** fetch data from the table: "grad.raise_hand" */
  grad_raise_hand: Array<GradRaiseHand>;
  /** fetch aggregated fields from the table: "grad.raise_hand" */
  grad_raise_hand_aggregate: GradRaiseHandAggregate;
  /** fetch data from the table: "grad.raise_hand" using primary key columns */
  grad_raise_hand_by_pk?: Maybe<GradRaiseHand>;
  /** fetch data from the table: "grad.spoken_language" */
  grad_spoken_language: Array<GradSpokenLanguage>;
  /** fetch aggregated fields from the table: "grad.spoken_language" */
  grad_spoken_language_aggregate: GradSpokenLanguageAggregate;
  /** fetch data from the table: "grad.spoken_language" using primary key columns */
  grad_spoken_language_by_pk?: Maybe<GradSpokenLanguage>;
  /** fetch data from the table: "grad.test_score" */
  grad_test_score: Array<GradTestScore>;
  /** fetch aggregated fields from the table: "grad.test_score" */
  grad_test_score_aggregate: GradTestScoreAggregate;
  /** fetch data from the table: "grad.test_score" using primary key columns */
  grad_test_score_by_pk?: Maybe<GradTestScore>;
  /** fetch data from the table: "grad.test_score_detail" */
  grad_test_score_detail: Array<GradTestScoreDetail>;
  /** fetch aggregated fields from the table: "grad.test_score_detail" */
  grad_test_score_detail_aggregate: GradTestScoreDetailAggregate;
  /** fetch data from the table: "grad.test_score_detail" using primary key columns */
  grad_test_score_detail_by_pk?: Maybe<GradTestScoreDetail>;
  /** fetch data from the table: "grad.university_selection" */
  grad_university_selection: Array<GradUniversitySelection>;
  /** fetch aggregated fields from the table: "grad.university_selection" */
  grad_university_selection_aggregate: GradUniversitySelectionAggregate;
  /** fetch data from the table: "grad.university_selection" using primary key columns */
  grad_university_selection_by_pk?: Maybe<GradUniversitySelection>;
  /** fetch data from the table: "grad.university_stat" */
  grad_university_stat: Array<GradUniversityStat>;
  /** fetch aggregated fields from the table: "grad.university_stat" */
  grad_university_stat_aggregate: GradUniversityStatAggregate;
  /** fetch data from the table: "grad.upload_doc" */
  grad_upload_doc: Array<GradUploadDoc>;
  /** fetch aggregated fields from the table: "grad.upload_doc" */
  grad_upload_doc_aggregate: GradUploadDocAggregate;
  /** fetch data from the table: "grad.upload_doc" using primary key columns */
  grad_upload_doc_by_pk?: Maybe<GradUploadDoc>;
  /** fetch data from the table: "grad.user_activity_summary" */
  grad_user_activity_summary: Array<GradUserActivitySummary>;
  /** fetch aggregated fields from the table: "grad.user_activity_summary" */
  grad_user_activity_summary_aggregate: GradUserActivitySummaryAggregate;
  /** fetch data from the table: "grad.user_activity_summary" using primary key columns */
  grad_user_activity_summary_by_pk?: Maybe<GradUserActivitySummary>;
  /** fetch data from the table: "grad.visa_selection" */
  grad_visa_selection: Array<GradVisaSelection>;
  /** fetch aggregated fields from the table: "grad.visa_selection" */
  grad_visa_selection_aggregate: GradVisaSelectionAggregate;
  /** fetch data from the table: "grad.visa_selection" using primary key columns */
  grad_visa_selection_by_pk?: Maybe<GradVisaSelection>;
  /** fetch data from the table: "grad.volunteer" */
  grad_volunteer: Array<GradVolunteer>;
  /** fetch aggregated fields from the table: "grad.volunteer" */
  grad_volunteer_aggregate: GradVolunteerAggregate;
  /** fetch data from the table: "grad.volunteer" using primary key columns */
  grad_volunteer_by_pk?: Maybe<GradVolunteer>;
  /** fetch data from the table: "grad.work_experience" */
  grad_work_experience: Array<GradWorkExperience>;
  /** fetch aggregated fields from the table: "grad.work_experience" */
  grad_work_experience_aggregate: GradWorkExperienceAggregate;
  /** fetch data from the table: "grad.work_experience" using primary key columns */
  grad_work_experience_by_pk?: Maybe<GradWorkExperience>;
  /** fetch data from the table: "queue_handler_permission" */
  queue_handler_permission: Array<QueueHandlerPermission>;
  /** fetch aggregated fields from the table: "queue_handler_permission" */
  queue_handler_permission_aggregate: QueueHandlerPermissionAggregate;
  /** fetch data from the table: "queue_handler_permission" using primary key columns */
  queue_handler_permission_by_pk?: Maybe<QueueHandlerPermission>;
  /** fetch data from the table: "recruit.account" */
  recruit_account: Array<RecruitAccount>;
  /** fetch aggregated fields from the table: "recruit.account" */
  recruit_account_aggregate: RecruitAccountAggregate;
  /** fetch data from the table: "recruit.account" using primary key columns */
  recruit_account_by_pk?: Maybe<RecruitAccount>;
  /** fetch data from the table: "recruit.company" */
  recruit_company: Array<RecruitCompany>;
  /** fetch aggregated fields from the table: "recruit.company" */
  recruit_company_aggregate: RecruitCompanyAggregate;
  /** fetch data from the table: "recruit.company" using primary key columns */
  recruit_company_by_pk?: Maybe<RecruitCompany>;
  /** fetch data from the table: "recruit.company_subindustry" */
  recruit_company_subindustry: Array<RecruitCompanySubindustry>;
  /** fetch aggregated fields from the table: "recruit.company_subindustry" */
  recruit_company_subindustry_aggregate: RecruitCompanySubindustryAggregate;
  /** fetch data from the table: "recruit.company_subindustry" using primary key columns */
  recruit_company_subindustry_by_pk?: Maybe<RecruitCompanySubindustry>;
  /** fetch data from the table: "recruit.event" */
  recruit_event: Array<RecruitEvent>;
  /** fetch aggregated fields from the table: "recruit.event" */
  recruit_event_aggregate: RecruitEventAggregate;
  /** fetch data from the table: "recruit.event" using primary key columns */
  recruit_event_by_pk?: Maybe<RecruitEvent>;
  /** fetch data from the table: "recruit.grad_group" */
  recruit_grad_group: Array<RecruitGradGroup>;
  /** fetch aggregated fields from the table: "recruit.grad_group" */
  recruit_grad_group_aggregate: RecruitGradGroupAggregate;
  /** fetch data from the table: "recruit.grad_group" using primary key columns */
  recruit_grad_group_by_pk?: Maybe<RecruitGradGroup>;
  /** fetch data from the table: "recruit.grad_group_member" */
  recruit_grad_group_member: Array<RecruitGradGroupMember>;
  /** fetch aggregated fields from the table: "recruit.grad_group_member" */
  recruit_grad_group_member_aggregate: RecruitGradGroupMemberAggregate;
  /** fetch data from the table: "recruit.grad_group_member" using primary key columns */
  recruit_grad_group_member_by_pk?: Maybe<RecruitGradGroupMember>;
  /** fetch data from the table: "recruit.job_posting" */
  recruit_job_posting: Array<RecruitJobPosting>;
  /** fetch aggregated fields from the table: "recruit.job_posting" */
  recruit_job_posting_aggregate: RecruitJobPostingAggregate;
  /** fetch data from the table: "recruit.job_posting" using primary key columns */
  recruit_job_posting_by_pk?: Maybe<RecruitJobPosting>;
  /** fetch data from the table: "recruit.job_requirement" */
  recruit_job_requirement: Array<RecruitJobRequirement>;
  /** fetch aggregated fields from the table: "recruit.job_requirement" */
  recruit_job_requirement_aggregate: RecruitJobRequirementAggregate;
  /** fetch data from the table: "recruit.job_requirement" using primary key columns */
  recruit_job_requirement_by_pk?: Maybe<RecruitJobRequirement>;
  /** fetch data from the table: "recruit.job_requirement_value" */
  recruit_job_requirement_value: Array<RecruitJobRequirementValue>;
  /** fetch aggregated fields from the table: "recruit.job_requirement_value" */
  recruit_job_requirement_value_aggregate: RecruitJobRequirementValueAggregate;
  /** fetch data from the table: "recruit.job_requirement_value" using primary key columns */
  recruit_job_requirement_value_by_pk?: Maybe<RecruitJobRequirementValue>;
  /** fetch data from the table: "recruit.recruiter" */
  recruit_recruiter: Array<RecruitRecruiter>;
  /** fetch aggregated fields from the table: "recruit.recruiter" */
  recruit_recruiter_aggregate: RecruitRecruiterAggregate;
  /** fetch data from the table: "recruit.recruiter" using primary key columns */
  recruit_recruiter_by_pk?: Maybe<RecruitRecruiter>;
  /** fetch data from the table: "recruit.saved_search" */
  recruit_saved_search: Array<RecruitSavedSearch>;
  /** fetch aggregated fields from the table: "recruit.saved_search" */
  recruit_saved_search_aggregate: RecruitSavedSearchAggregate;
  /** fetch data from the table: "recruit.saved_search" using primary key columns */
  recruit_saved_search_by_pk?: Maybe<RecruitSavedSearch>;
  /** fetch data from the table: "recruit.sms_correspondent" */
  recruit_sms_correspondent: Array<RecruitSmsCorrespondent>;
  /** fetch aggregated fields from the table: "recruit.sms_correspondent" */
  recruit_sms_correspondent_aggregate: RecruitSmsCorrespondentAggregate;
  /** fetch data from the table: "recruit.sms_correspondent" using primary key columns */
  recruit_sms_correspondent_by_pk?: Maybe<RecruitSmsCorrespondent>;
  /** fetch data from the table: "recruit.sms_message" */
  recruit_sms_message: Array<RecruitSmsMessage>;
  /** fetch aggregated fields from the table: "recruit.sms_message" */
  recruit_sms_message_aggregate: RecruitSmsMessageAggregate;
  /** fetch data from the table: "recruit.sms_message" using primary key columns */
  recruit_sms_message_by_pk?: Maybe<RecruitSmsMessage>;
  /** fetch data from the table: "recruit.sms_message_correspondent" */
  recruit_sms_message_correspondent: Array<RecruitSmsMessageCorrespondent>;
  /** fetch aggregated fields from the table: "recruit.sms_message_correspondent" */
  recruit_sms_message_correspondent_aggregate: RecruitSmsMessageCorrespondentAggregate;
  /** fetch data from the table: "recruit.sms_message_correspondent" using primary key columns */
  recruit_sms_message_correspondent_by_pk?: Maybe<RecruitSmsMessageCorrespondent>;
  /** fetch data from the table: "recruit.sms_template" */
  recruit_sms_template: Array<RecruitSmsTemplate>;
  /** fetch aggregated fields from the table: "recruit.sms_template" */
  recruit_sms_template_aggregate: RecruitSmsTemplateAggregate;
  /** fetch data from the table: "recruit.sms_template" using primary key columns */
  recruit_sms_template_by_pk?: Maybe<RecruitSmsTemplate>;
  /** fetch data from the table: "test_auto3" */
  test_auto3: Array<TestAuto3>;
  /** fetch aggregated fields from the table: "test_auto3" */
  test_auto3_aggregate: TestAuto3Aggregate;
  /** fetch data from the table: "test_auto3" using primary key columns */
  test_auto3_by_pk?: Maybe<TestAuto3>;
  /** fetch data from the table: "to_queue" */
  to_queue: Array<ToQueue>;
  /** fetch aggregated fields from the table: "to_queue" */
  to_queue_aggregate: ToQueueAggregate;
  /** fetch data from the table: "to_queue" using primary key columns */
  to_queue_by_pk?: Maybe<ToQueue>;
  /** fetch data from the table: "to_queue_response" */
  to_queue_response: Array<ToQueueResponse>;
  /** fetch aggregated fields from the table: "to_queue_response" */
  to_queue_response_aggregate: ToQueueResponseAggregate;
  /** fetch data from the table: "to_queue_response" using primary key columns */
  to_queue_response_by_pk?: Maybe<ToQueueResponse>;
  /** fetch data from the table: "user_auth" */
  user_auth: Array<UserAuth>;
  /** fetch aggregated fields from the table: "user_auth" */
  user_auth_aggregate: UserAuthAggregate;
  /** fetch data from the table: "user_auth" using primary key columns */
  user_auth_by_pk?: Maybe<UserAuth>;
  /** fetch data from the table: "useraccount" */
  useraccount: Array<Useraccount>;
  /** fetch aggregated fields from the table: "useraccount" */
  useraccount_aggregate: UseraccountAggregate;
  /** fetch data from the table: "useraccount" using primary key columns */
  useraccount_by_pk?: Maybe<Useraccount>;
  /** fetch data from the table: "web_api_permission" */
  web_api_permission: Array<WebApiPermission>;
  /** fetch aggregated fields from the table: "web_api_permission" */
  web_api_permission_aggregate: WebApiPermissionAggregate;
  /** fetch data from the table: "web_api_permission" using primary key columns */
  web_api_permission_by_pk?: Maybe<WebApiPermission>;
};


/** query root */
export type QueryRootAdminAdminuserArgs = {
  distinct_on?: Maybe<Array<AdminAdminuserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminAdminuserOrderBy>>;
  where?: Maybe<AdminAdminuserBoolExp>;
};


/** query root */
export type QueryRootAdminAdminuserAggregateArgs = {
  distinct_on?: Maybe<Array<AdminAdminuserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminAdminuserOrderBy>>;
  where?: Maybe<AdminAdminuserBoolExp>;
};


/** query root */
export type QueryRootAdminAdminuserByPkArgs = {
  user_id: Scalars['String'];
};


/** query root */
export type QueryRootAdminAuth0mgmtArgs = {
  distinct_on?: Maybe<Array<AdminAuth0mgmtSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminAuth0mgmtOrderBy>>;
  where?: Maybe<AdminAuth0mgmtBoolExp>;
};


/** query root */
export type QueryRootAdminAuth0mgmtAggregateArgs = {
  distinct_on?: Maybe<Array<AdminAuth0mgmtSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminAuth0mgmtOrderBy>>;
  where?: Maybe<AdminAuth0mgmtBoolExp>;
};


/** query root */
export type QueryRootAdminAuth0mgmtByPkArgs = {
  auth0mgmt_id: Scalars['Int'];
};


/** query root */
export type QueryRootAdminAuth0mgmtResultArgs = {
  distinct_on?: Maybe<Array<AdminAuth0mgmtResultSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminAuth0mgmtResultOrderBy>>;
  where?: Maybe<AdminAuth0mgmtResultBoolExp>;
};


/** query root */
export type QueryRootAdminAuth0mgmtResultAggregateArgs = {
  distinct_on?: Maybe<Array<AdminAuth0mgmtResultSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminAuth0mgmtResultOrderBy>>;
  where?: Maybe<AdminAuth0mgmtResultBoolExp>;
};


/** query root */
export type QueryRootAdminAuth0mgmtResultByPkArgs = {
  auth0mgmt_id: Scalars['Int'];
};


/** query root */
export type QueryRootAdminEmailArgs = {
  distinct_on?: Maybe<Array<AdminEmailSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminEmailOrderBy>>;
  where?: Maybe<AdminEmailBoolExp>;
};


/** query root */
export type QueryRootAdminEmailAggregateArgs = {
  distinct_on?: Maybe<Array<AdminEmailSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminEmailOrderBy>>;
  where?: Maybe<AdminEmailBoolExp>;
};


/** query root */
export type QueryRootAdminEmailByPkArgs = {
  email_id: Scalars['Int'];
};


/** query root */
export type QueryRootAdminEmailLayoutArgs = {
  distinct_on?: Maybe<Array<AdminEmailLayoutSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminEmailLayoutOrderBy>>;
  where?: Maybe<AdminEmailLayoutBoolExp>;
};


/** query root */
export type QueryRootAdminEmailLayoutAggregateArgs = {
  distinct_on?: Maybe<Array<AdminEmailLayoutSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminEmailLayoutOrderBy>>;
  where?: Maybe<AdminEmailLayoutBoolExp>;
};


/** query root */
export type QueryRootAdminEmailLayoutByPkArgs = {
  email_layout_id: Scalars['String'];
};


/** query root */
export type QueryRootAdminEmailTemplateArgs = {
  distinct_on?: Maybe<Array<AdminEmailTemplateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminEmailTemplateOrderBy>>;
  where?: Maybe<AdminEmailTemplateBoolExp>;
};


/** query root */
export type QueryRootAdminEmailTemplateAggregateArgs = {
  distinct_on?: Maybe<Array<AdminEmailTemplateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminEmailTemplateOrderBy>>;
  where?: Maybe<AdminEmailTemplateBoolExp>;
};


/** query root */
export type QueryRootAdminEmailTemplateByPkArgs = {
  email_template_id: Scalars['String'];
};


/** query root */
export type QueryRootAdminTwiliomgmtArgs = {
  distinct_on?: Maybe<Array<AdminTwiliomgmtSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminTwiliomgmtOrderBy>>;
  where?: Maybe<AdminTwiliomgmtBoolExp>;
};


/** query root */
export type QueryRootAdminTwiliomgmtAggregateArgs = {
  distinct_on?: Maybe<Array<AdminTwiliomgmtSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminTwiliomgmtOrderBy>>;
  where?: Maybe<AdminTwiliomgmtBoolExp>;
};


/** query root */
export type QueryRootAdminTwiliomgmtByPkArgs = {
  twiliomgmt_id: Scalars['Int'];
};


/** query root */
export type QueryRootAdminTwiliomgmtResultArgs = {
  distinct_on?: Maybe<Array<AdminTwiliomgmtResultSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminTwiliomgmtResultOrderBy>>;
  where?: Maybe<AdminTwiliomgmtResultBoolExp>;
};


/** query root */
export type QueryRootAdminTwiliomgmtResultAggregateArgs = {
  distinct_on?: Maybe<Array<AdminTwiliomgmtResultSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminTwiliomgmtResultOrderBy>>;
  where?: Maybe<AdminTwiliomgmtResultBoolExp>;
};


/** query root */
export type QueryRootAdminTwiliomgmtResultByPkArgs = {
  twiliomgmt_id: Scalars['Int'];
};


/** query root */
export type QueryRootDbPingArgs = {
  distinct_on?: Maybe<Array<DbPingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DbPingOrderBy>>;
  where?: Maybe<DbPingBoolExp>;
};


/** query root */
export type QueryRootDbPingAggregateArgs = {
  distinct_on?: Maybe<Array<DbPingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DbPingOrderBy>>;
  where?: Maybe<DbPingBoolExp>;
};


/** query root */
export type QueryRootDbPingByPkArgs = {
  id: Scalars['Int'];
};


/** query root */
export type QueryRootDbStateArgs = {
  distinct_on?: Maybe<Array<DbStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DbStateOrderBy>>;
  where?: Maybe<DbStateBoolExp>;
};


/** query root */
export type QueryRootDbStateAggregateArgs = {
  distinct_on?: Maybe<Array<DbStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DbStateOrderBy>>;
  where?: Maybe<DbStateBoolExp>;
};


/** query root */
export type QueryRootDbStateByPkArgs = {
  key: Scalars['String'];
};


/** query root */
export type QueryRootGradAchievementArgs = {
  distinct_on?: Maybe<Array<GradAchievementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradAchievementOrderBy>>;
  where?: Maybe<GradAchievementBoolExp>;
};


/** query root */
export type QueryRootGradAchievementAggregateArgs = {
  distinct_on?: Maybe<Array<GradAchievementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradAchievementOrderBy>>;
  where?: Maybe<GradAchievementBoolExp>;
};


/** query root */
export type QueryRootGradAchievementByPkArgs = {
  achievement_id: Scalars['String'];
};


/** query root */
export type QueryRootGradAwardArgs = {
  distinct_on?: Maybe<Array<GradAwardSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradAwardOrderBy>>;
  where?: Maybe<GradAwardBoolExp>;
};


/** query root */
export type QueryRootGradAwardAggregateArgs = {
  distinct_on?: Maybe<Array<GradAwardSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradAwardOrderBy>>;
  where?: Maybe<GradAwardBoolExp>;
};


/** query root */
export type QueryRootGradAwardByPkArgs = {
  award_id: Scalars['String'];
};


/** query root */
export type QueryRootGradBookmarkJobArgs = {
  distinct_on?: Maybe<Array<GradBookmarkJobSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradBookmarkJobOrderBy>>;
  where?: Maybe<GradBookmarkJobBoolExp>;
};


/** query root */
export type QueryRootGradBookmarkJobAggregateArgs = {
  distinct_on?: Maybe<Array<GradBookmarkJobSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradBookmarkJobOrderBy>>;
  where?: Maybe<GradBookmarkJobBoolExp>;
};


/** query root */
export type QueryRootGradBookmarkJobByPkArgs = {
  bookmark_job_id: Scalars['String'];
};


/** query root */
export type QueryRootGradCityStateSelectionArgs = {
  distinct_on?: Maybe<Array<GradCityStateSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradCityStateSelectionOrderBy>>;
  where?: Maybe<GradCityStateSelectionBoolExp>;
};


/** query root */
export type QueryRootGradCityStateSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradCityStateSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradCityStateSelectionOrderBy>>;
  where?: Maybe<GradCityStateSelectionBoolExp>;
};


/** query root */
export type QueryRootGradCityStateSelectionByPkArgs = {
  city_state_selection_id: Scalars['String'];
};


/** query root */
export type QueryRootGradCommPreferenceSelectionArgs = {
  distinct_on?: Maybe<Array<GradCommPreferenceSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradCommPreferenceSelectionOrderBy>>;
  where?: Maybe<GradCommPreferenceSelectionBoolExp>;
};


/** query root */
export type QueryRootGradCommPreferenceSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradCommPreferenceSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradCommPreferenceSelectionOrderBy>>;
  where?: Maybe<GradCommPreferenceSelectionBoolExp>;
};


/** query root */
export type QueryRootGradCommPreferenceSelectionByPkArgs = {
  comm_preference_selection_id: Scalars['String'];
};


/** query root */
export type QueryRootGradCompanySelectionArgs = {
  distinct_on?: Maybe<Array<GradCompanySelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradCompanySelectionOrderBy>>;
  where?: Maybe<GradCompanySelectionBoolExp>;
};


/** query root */
export type QueryRootGradCompanySelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradCompanySelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradCompanySelectionOrderBy>>;
  where?: Maybe<GradCompanySelectionBoolExp>;
};


/** query root */
export type QueryRootGradCompanySelectionByPkArgs = {
  company_selection_id: Scalars['String'];
};


/** query root */
export type QueryRootGradComputerLanguageArgs = {
  distinct_on?: Maybe<Array<GradComputerLanguageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradComputerLanguageOrderBy>>;
  where?: Maybe<GradComputerLanguageBoolExp>;
};


/** query root */
export type QueryRootGradComputerLanguageAggregateArgs = {
  distinct_on?: Maybe<Array<GradComputerLanguageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradComputerLanguageOrderBy>>;
  where?: Maybe<GradComputerLanguageBoolExp>;
};


/** query root */
export type QueryRootGradComputerLanguageByPkArgs = {
  computer_language_id: Scalars['String'];
};


/** query root */
export type QueryRootGradComputerLanguageSelectionArgs = {
  distinct_on?: Maybe<Array<GradComputerLanguageSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradComputerLanguageSelectionOrderBy>>;
  where?: Maybe<GradComputerLanguageSelectionBoolExp>;
};


/** query root */
export type QueryRootGradComputerLanguageSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradComputerLanguageSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradComputerLanguageSelectionOrderBy>>;
  where?: Maybe<GradComputerLanguageSelectionBoolExp>;
};


/** query root */
export type QueryRootGradComputerLanguageSelectionByPkArgs = {
  computer_language: Scalars['String'];
};


/** query root */
export type QueryRootGradConcentrationArgs = {
  distinct_on?: Maybe<Array<GradConcentrationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradConcentrationOrderBy>>;
  where?: Maybe<GradConcentrationBoolExp>;
};


/** query root */
export type QueryRootGradConcentrationAggregateArgs = {
  distinct_on?: Maybe<Array<GradConcentrationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradConcentrationOrderBy>>;
  where?: Maybe<GradConcentrationBoolExp>;
};


/** query root */
export type QueryRootGradConcentrationByPkArgs = {
  concentration_id: Scalars['String'];
};


/** query root */
export type QueryRootGradCountrySelectionArgs = {
  distinct_on?: Maybe<Array<GradCountrySelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradCountrySelectionOrderBy>>;
  where?: Maybe<GradCountrySelectionBoolExp>;
};


/** query root */
export type QueryRootGradCountrySelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradCountrySelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradCountrySelectionOrderBy>>;
  where?: Maybe<GradCountrySelectionBoolExp>;
};


/** query root */
export type QueryRootGradCountrySelectionByPkArgs = {
  country_selection_id: Scalars['String'];
};


/** query root */
export type QueryRootGradDegreeArgs = {
  distinct_on?: Maybe<Array<GradDegreeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradDegreeOrderBy>>;
  where?: Maybe<GradDegreeBoolExp>;
};


/** query root */
export type QueryRootGradDegreeAggregateArgs = {
  distinct_on?: Maybe<Array<GradDegreeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradDegreeOrderBy>>;
  where?: Maybe<GradDegreeBoolExp>;
};


/** query root */
export type QueryRootGradDegreeByPkArgs = {
  degree_id: Scalars['String'];
};


/** query root */
export type QueryRootGradDegreeFillInUniversityArgs = {
  distinct_on?: Maybe<Array<GradDegreeFillInUniversitySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradDegreeFillInUniversityOrderBy>>;
  where?: Maybe<GradDegreeFillInUniversityBoolExp>;
};


/** query root */
export type QueryRootGradDegreeFillInUniversityAggregateArgs = {
  distinct_on?: Maybe<Array<GradDegreeFillInUniversitySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradDegreeFillInUniversityOrderBy>>;
  where?: Maybe<GradDegreeFillInUniversityBoolExp>;
};


/** query root */
export type QueryRootGradDegreeFillInUniversityByPkArgs = {
  degree_id: Scalars['String'];
};


/** query root */
export type QueryRootGradDegreeLatestArgs = {
  distinct_on?: Maybe<Array<GradDegreeLatestSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradDegreeLatestOrderBy>>;
  where?: Maybe<GradDegreeLatestBoolExp>;
};


/** query root */
export type QueryRootGradDegreeLatestAggregateArgs = {
  distinct_on?: Maybe<Array<GradDegreeLatestSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradDegreeLatestOrderBy>>;
  where?: Maybe<GradDegreeLatestBoolExp>;
};


/** query root */
export type QueryRootGradDegreeSelectionArgs = {
  distinct_on?: Maybe<Array<GradDegreeSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradDegreeSelectionOrderBy>>;
  where?: Maybe<GradDegreeSelectionBoolExp>;
};


/** query root */
export type QueryRootGradDegreeSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradDegreeSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradDegreeSelectionOrderBy>>;
  where?: Maybe<GradDegreeSelectionBoolExp>;
};


/** query root */
export type QueryRootGradDegreeSelectionByPkArgs = {
  degree_selection_id: Scalars['String'];
};


/** query root */
export type QueryRootGradEmployerPreferenceArgs = {
  distinct_on?: Maybe<Array<GradEmployerPreferenceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradEmployerPreferenceOrderBy>>;
  where?: Maybe<GradEmployerPreferenceBoolExp>;
};


/** query root */
export type QueryRootGradEmployerPreferenceAggregateArgs = {
  distinct_on?: Maybe<Array<GradEmployerPreferenceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradEmployerPreferenceOrderBy>>;
  where?: Maybe<GradEmployerPreferenceBoolExp>;
};


/** query root */
export type QueryRootGradEmployerPreferenceByPkArgs = {
  employer_preference_id: Scalars['String'];
};


/** query root */
export type QueryRootGradEmployerPreferenceSelectionArgs = {
  distinct_on?: Maybe<Array<GradEmployerPreferenceSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradEmployerPreferenceSelectionOrderBy>>;
  where?: Maybe<GradEmployerPreferenceSelectionBoolExp>;
};


/** query root */
export type QueryRootGradEmployerPreferenceSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradEmployerPreferenceSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradEmployerPreferenceSelectionOrderBy>>;
  where?: Maybe<GradEmployerPreferenceSelectionBoolExp>;
};


/** query root */
export type QueryRootGradEmployerPreferenceSelectionByPkArgs = {
  employer_preference_selection_id: Scalars['String'];
};


/** query root */
export type QueryRootGradEventRegistrationArgs = {
  distinct_on?: Maybe<Array<GradEventRegistrationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradEventRegistrationOrderBy>>;
  where?: Maybe<GradEventRegistrationBoolExp>;
};


/** query root */
export type QueryRootGradEventRegistrationAggregateArgs = {
  distinct_on?: Maybe<Array<GradEventRegistrationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradEventRegistrationOrderBy>>;
  where?: Maybe<GradEventRegistrationBoolExp>;
};


/** query root */
export type QueryRootGradEventRegistrationByPkArgs = {
  event_registration_id: Scalars['String'];
};


/** query root */
export type QueryRootGradFunFactArgs = {
  distinct_on?: Maybe<Array<GradFunFactSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradFunFactOrderBy>>;
  where?: Maybe<GradFunFactBoolExp>;
};


/** query root */
export type QueryRootGradFunFactAggregateArgs = {
  distinct_on?: Maybe<Array<GradFunFactSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradFunFactOrderBy>>;
  where?: Maybe<GradFunFactBoolExp>;
};


/** query root */
export type QueryRootGradFunFactByPkArgs = {
  fun_fact_id: Scalars['String'];
};


/** query root */
export type QueryRootGradFunFactSelectionArgs = {
  distinct_on?: Maybe<Array<GradFunFactSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradFunFactSelectionOrderBy>>;
  where?: Maybe<GradFunFactSelectionBoolExp>;
};


/** query root */
export type QueryRootGradFunFactSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradFunFactSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradFunFactSelectionOrderBy>>;
  where?: Maybe<GradFunFactSelectionBoolExp>;
};


/** query root */
export type QueryRootGradFunFactSelectionByPkArgs = {
  fun_fact_selection_id: Scalars['String'];
};


/** query root */
export type QueryRootGradInterestFirmArgs = {
  distinct_on?: Maybe<Array<GradInterestFirmSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestFirmOrderBy>>;
  where?: Maybe<GradInterestFirmBoolExp>;
};


/** query root */
export type QueryRootGradInterestFirmAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestFirmSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestFirmOrderBy>>;
  where?: Maybe<GradInterestFirmBoolExp>;
};


/** query root */
export type QueryRootGradInterestFirmByPkArgs = {
  interest_firm_id: Scalars['String'];
};


/** query root */
export type QueryRootGradInterestFirmSelectionArgs = {
  distinct_on?: Maybe<Array<GradInterestFirmSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestFirmSelectionOrderBy>>;
  where?: Maybe<GradInterestFirmSelectionBoolExp>;
};


/** query root */
export type QueryRootGradInterestFirmSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestFirmSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestFirmSelectionOrderBy>>;
  where?: Maybe<GradInterestFirmSelectionBoolExp>;
};


/** query root */
export type QueryRootGradInterestFirmSelectionByPkArgs = {
  interest_firm_selection_id: Scalars['String'];
};


/** query root */
export type QueryRootGradInterestJobTypeArgs = {
  distinct_on?: Maybe<Array<GradInterestJobTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestJobTypeOrderBy>>;
  where?: Maybe<GradInterestJobTypeBoolExp>;
};


/** query root */
export type QueryRootGradInterestJobTypeAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestJobTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestJobTypeOrderBy>>;
  where?: Maybe<GradInterestJobTypeBoolExp>;
};


/** query root */
export type QueryRootGradInterestJobTypeByPkArgs = {
  interest_job_type_id: Scalars['String'];
};


/** query root */
export type QueryRootGradInterestJobTypeSelectionArgs = {
  distinct_on?: Maybe<Array<GradInterestJobTypeSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestJobTypeSelectionOrderBy>>;
  where?: Maybe<GradInterestJobTypeSelectionBoolExp>;
};


/** query root */
export type QueryRootGradInterestJobTypeSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestJobTypeSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestJobTypeSelectionOrderBy>>;
  where?: Maybe<GradInterestJobTypeSelectionBoolExp>;
};


/** query root */
export type QueryRootGradInterestJobTypeSelectionByPkArgs = {
  interest_job_type_selection_id: Scalars['String'];
};


/** query root */
export type QueryRootGradInterestRegionArgs = {
  distinct_on?: Maybe<Array<GradInterestRegionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRegionOrderBy>>;
  where?: Maybe<GradInterestRegionBoolExp>;
};


/** query root */
export type QueryRootGradInterestRegionAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestRegionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRegionOrderBy>>;
  where?: Maybe<GradInterestRegionBoolExp>;
};


/** query root */
export type QueryRootGradInterestRegionByPkArgs = {
  interest_region_id: Scalars['String'];
};


/** query root */
export type QueryRootGradInterestRegionSelectionArgs = {
  distinct_on?: Maybe<Array<GradInterestRegionSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRegionSelectionOrderBy>>;
  where?: Maybe<GradInterestRegionSelectionBoolExp>;
};


/** query root */
export type QueryRootGradInterestRegionSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestRegionSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRegionSelectionOrderBy>>;
  where?: Maybe<GradInterestRegionSelectionBoolExp>;
};


/** query root */
export type QueryRootGradInterestRegionSelectionByPkArgs = {
  interest_region_selection_id: Scalars['String'];
};


/** query root */
export type QueryRootGradInterestRoleArgs = {
  distinct_on?: Maybe<Array<GradInterestRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRoleOrderBy>>;
  where?: Maybe<GradInterestRoleBoolExp>;
};


/** query root */
export type QueryRootGradInterestRoleAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRoleOrderBy>>;
  where?: Maybe<GradInterestRoleBoolExp>;
};


/** query root */
export type QueryRootGradInterestRoleByPkArgs = {
  interest_role_id: Scalars['String'];
};


/** query root */
export type QueryRootGradInterestRoleSelectionArgs = {
  distinct_on?: Maybe<Array<GradInterestRoleSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRoleSelectionOrderBy>>;
  where?: Maybe<GradInterestRoleSelectionBoolExp>;
};


/** query root */
export type QueryRootGradInterestRoleSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestRoleSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRoleSelectionOrderBy>>;
  where?: Maybe<GradInterestRoleSelectionBoolExp>;
};


/** query root */
export type QueryRootGradInterestRoleSelectionByPkArgs = {
  interest_role_selection_id: Scalars['String'];
};


/** query root */
export type QueryRootGradMajorSelectionArgs = {
  distinct_on?: Maybe<Array<GradMajorSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradMajorSelectionOrderBy>>;
  where?: Maybe<GradMajorSelectionBoolExp>;
};


/** query root */
export type QueryRootGradMajorSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradMajorSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradMajorSelectionOrderBy>>;
  where?: Maybe<GradMajorSelectionBoolExp>;
};


/** query root */
export type QueryRootGradMajorSelectionByPkArgs = {
  major_selection_id: Scalars['String'];
};


/** query root */
export type QueryRootGradPageViewArgs = {
  distinct_on?: Maybe<Array<GradPageViewSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradPageViewOrderBy>>;
  where?: Maybe<GradPageViewBoolExp>;
};


/** query root */
export type QueryRootGradPageViewAggregateArgs = {
  distinct_on?: Maybe<Array<GradPageViewSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradPageViewOrderBy>>;
  where?: Maybe<GradPageViewBoolExp>;
};


/** query root */
export type QueryRootGradPageViewByPkArgs = {
  page_view_id: Scalars['bigint'];
};


/** query root */
export type QueryRootGradProfileArgs = {
  distinct_on?: Maybe<Array<GradProfileSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradProfileOrderBy>>;
  where?: Maybe<GradProfileBoolExp>;
};


/** query root */
export type QueryRootGradProfileAggregateArgs = {
  distinct_on?: Maybe<Array<GradProfileSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradProfileOrderBy>>;
  where?: Maybe<GradProfileBoolExp>;
};


/** query root */
export type QueryRootGradProfileByPkArgs = {
  user_id: Scalars['String'];
};


/** query root */
export type QueryRootGradProfileCombineArgs = {
  distinct_on?: Maybe<Array<GradProfileCombineSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradProfileCombineOrderBy>>;
  where?: Maybe<GradProfileCombineBoolExp>;
};


/** query root */
export type QueryRootGradProfileCombineAggregateArgs = {
  distinct_on?: Maybe<Array<GradProfileCombineSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradProfileCombineOrderBy>>;
  where?: Maybe<GradProfileCombineBoolExp>;
};


/** query root */
export type QueryRootGradRaiseHandArgs = {
  distinct_on?: Maybe<Array<GradRaiseHandSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradRaiseHandOrderBy>>;
  where?: Maybe<GradRaiseHandBoolExp>;
};


/** query root */
export type QueryRootGradRaiseHandAggregateArgs = {
  distinct_on?: Maybe<Array<GradRaiseHandSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradRaiseHandOrderBy>>;
  where?: Maybe<GradRaiseHandBoolExp>;
};


/** query root */
export type QueryRootGradRaiseHandByPkArgs = {
  raise__hand_id: Scalars['String'];
};


/** query root */
export type QueryRootGradSpokenLanguageArgs = {
  distinct_on?: Maybe<Array<GradSpokenLanguageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradSpokenLanguageOrderBy>>;
  where?: Maybe<GradSpokenLanguageBoolExp>;
};


/** query root */
export type QueryRootGradSpokenLanguageAggregateArgs = {
  distinct_on?: Maybe<Array<GradSpokenLanguageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradSpokenLanguageOrderBy>>;
  where?: Maybe<GradSpokenLanguageBoolExp>;
};


/** query root */
export type QueryRootGradSpokenLanguageByPkArgs = {
  spoken_language_id: Scalars['String'];
};


/** query root */
export type QueryRootGradTestScoreArgs = {
  distinct_on?: Maybe<Array<GradTestScoreSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradTestScoreOrderBy>>;
  where?: Maybe<GradTestScoreBoolExp>;
};


/** query root */
export type QueryRootGradTestScoreAggregateArgs = {
  distinct_on?: Maybe<Array<GradTestScoreSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradTestScoreOrderBy>>;
  where?: Maybe<GradTestScoreBoolExp>;
};


/** query root */
export type QueryRootGradTestScoreByPkArgs = {
  test_score_id: Scalars['String'];
};


/** query root */
export type QueryRootGradTestScoreDetailArgs = {
  distinct_on?: Maybe<Array<GradTestScoreDetailSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradTestScoreDetailOrderBy>>;
  where?: Maybe<GradTestScoreDetailBoolExp>;
};


/** query root */
export type QueryRootGradTestScoreDetailAggregateArgs = {
  distinct_on?: Maybe<Array<GradTestScoreDetailSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradTestScoreDetailOrderBy>>;
  where?: Maybe<GradTestScoreDetailBoolExp>;
};


/** query root */
export type QueryRootGradTestScoreDetailByPkArgs = {
  test_score_detail_id: Scalars['String'];
};


/** query root */
export type QueryRootGradUniversitySelectionArgs = {
  distinct_on?: Maybe<Array<GradUniversitySelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradUniversitySelectionOrderBy>>;
  where?: Maybe<GradUniversitySelectionBoolExp>;
};


/** query root */
export type QueryRootGradUniversitySelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradUniversitySelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradUniversitySelectionOrderBy>>;
  where?: Maybe<GradUniversitySelectionBoolExp>;
};


/** query root */
export type QueryRootGradUniversitySelectionByPkArgs = {
  university_selection_id: Scalars['String'];
};


/** query root */
export type QueryRootGradUniversityStatArgs = {
  distinct_on?: Maybe<Array<GradUniversityStatSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradUniversityStatOrderBy>>;
  where?: Maybe<GradUniversityStatBoolExp>;
};


/** query root */
export type QueryRootGradUniversityStatAggregateArgs = {
  distinct_on?: Maybe<Array<GradUniversityStatSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradUniversityStatOrderBy>>;
  where?: Maybe<GradUniversityStatBoolExp>;
};


/** query root */
export type QueryRootGradUploadDocArgs = {
  distinct_on?: Maybe<Array<GradUploadDocSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradUploadDocOrderBy>>;
  where?: Maybe<GradUploadDocBoolExp>;
};


/** query root */
export type QueryRootGradUploadDocAggregateArgs = {
  distinct_on?: Maybe<Array<GradUploadDocSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradUploadDocOrderBy>>;
  where?: Maybe<GradUploadDocBoolExp>;
};


/** query root */
export type QueryRootGradUploadDocByPkArgs = {
  upload_doc_id: Scalars['String'];
};


/** query root */
export type QueryRootGradUserActivitySummaryArgs = {
  distinct_on?: Maybe<Array<GradUserActivitySummarySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradUserActivitySummaryOrderBy>>;
  where?: Maybe<GradUserActivitySummaryBoolExp>;
};


/** query root */
export type QueryRootGradUserActivitySummaryAggregateArgs = {
  distinct_on?: Maybe<Array<GradUserActivitySummarySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradUserActivitySummaryOrderBy>>;
  where?: Maybe<GradUserActivitySummaryBoolExp>;
};


/** query root */
export type QueryRootGradUserActivitySummaryByPkArgs = {
  user_id: Scalars['String'];
};


/** query root */
export type QueryRootGradVisaSelectionArgs = {
  distinct_on?: Maybe<Array<GradVisaSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradVisaSelectionOrderBy>>;
  where?: Maybe<GradVisaSelectionBoolExp>;
};


/** query root */
export type QueryRootGradVisaSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradVisaSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradVisaSelectionOrderBy>>;
  where?: Maybe<GradVisaSelectionBoolExp>;
};


/** query root */
export type QueryRootGradVisaSelectionByPkArgs = {
  visa_selection_id: Scalars['String'];
};


/** query root */
export type QueryRootGradVolunteerArgs = {
  distinct_on?: Maybe<Array<GradVolunteerSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradVolunteerOrderBy>>;
  where?: Maybe<GradVolunteerBoolExp>;
};


/** query root */
export type QueryRootGradVolunteerAggregateArgs = {
  distinct_on?: Maybe<Array<GradVolunteerSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradVolunteerOrderBy>>;
  where?: Maybe<GradVolunteerBoolExp>;
};


/** query root */
export type QueryRootGradVolunteerByPkArgs = {
  volunteer_id: Scalars['String'];
};


/** query root */
export type QueryRootGradWorkExperienceArgs = {
  distinct_on?: Maybe<Array<GradWorkExperienceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradWorkExperienceOrderBy>>;
  where?: Maybe<GradWorkExperienceBoolExp>;
};


/** query root */
export type QueryRootGradWorkExperienceAggregateArgs = {
  distinct_on?: Maybe<Array<GradWorkExperienceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradWorkExperienceOrderBy>>;
  where?: Maybe<GradWorkExperienceBoolExp>;
};


/** query root */
export type QueryRootGradWorkExperienceByPkArgs = {
  work_experience_id: Scalars['String'];
};


/** query root */
export type QueryRootQueueHandlerPermissionArgs = {
  distinct_on?: Maybe<Array<QueueHandlerPermissionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<QueueHandlerPermissionOrderBy>>;
  where?: Maybe<QueueHandlerPermissionBoolExp>;
};


/** query root */
export type QueryRootQueueHandlerPermissionAggregateArgs = {
  distinct_on?: Maybe<Array<QueueHandlerPermissionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<QueueHandlerPermissionOrderBy>>;
  where?: Maybe<QueueHandlerPermissionBoolExp>;
};


/** query root */
export type QueryRootQueueHandlerPermissionByPkArgs = {
  queue: Scalars['String'];
};


/** query root */
export type QueryRootRecruitAccountArgs = {
  distinct_on?: Maybe<Array<RecruitAccountSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitAccountOrderBy>>;
  where?: Maybe<RecruitAccountBoolExp>;
};


/** query root */
export type QueryRootRecruitAccountAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitAccountSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitAccountOrderBy>>;
  where?: Maybe<RecruitAccountBoolExp>;
};


/** query root */
export type QueryRootRecruitAccountByPkArgs = {
  account_id: Scalars['String'];
};


/** query root */
export type QueryRootRecruitCompanyArgs = {
  distinct_on?: Maybe<Array<RecruitCompanySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitCompanyOrderBy>>;
  where?: Maybe<RecruitCompanyBoolExp>;
};


/** query root */
export type QueryRootRecruitCompanyAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitCompanySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitCompanyOrderBy>>;
  where?: Maybe<RecruitCompanyBoolExp>;
};


/** query root */
export type QueryRootRecruitCompanyByPkArgs = {
  company_id: Scalars['Int'];
};


/** query root */
export type QueryRootRecruitCompanySubindustryArgs = {
  distinct_on?: Maybe<Array<RecruitCompanySubindustrySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitCompanySubindustryOrderBy>>;
  where?: Maybe<RecruitCompanySubindustryBoolExp>;
};


/** query root */
export type QueryRootRecruitCompanySubindustryAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitCompanySubindustrySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitCompanySubindustryOrderBy>>;
  where?: Maybe<RecruitCompanySubindustryBoolExp>;
};


/** query root */
export type QueryRootRecruitCompanySubindustryByPkArgs = {
  company_subindustry_id: Scalars['Int'];
};


/** query root */
export type QueryRootRecruitEventArgs = {
  distinct_on?: Maybe<Array<RecruitEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitEventOrderBy>>;
  where?: Maybe<RecruitEventBoolExp>;
};


/** query root */
export type QueryRootRecruitEventAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitEventOrderBy>>;
  where?: Maybe<RecruitEventBoolExp>;
};


/** query root */
export type QueryRootRecruitEventByPkArgs = {
  event_id: Scalars['String'];
};


/** query root */
export type QueryRootRecruitGradGroupArgs = {
  distinct_on?: Maybe<Array<RecruitGradGroupSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitGradGroupOrderBy>>;
  where?: Maybe<RecruitGradGroupBoolExp>;
};


/** query root */
export type QueryRootRecruitGradGroupAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitGradGroupSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitGradGroupOrderBy>>;
  where?: Maybe<RecruitGradGroupBoolExp>;
};


/** query root */
export type QueryRootRecruitGradGroupByPkArgs = {
  grad_group_id: Scalars['String'];
};


/** query root */
export type QueryRootRecruitGradGroupMemberArgs = {
  distinct_on?: Maybe<Array<RecruitGradGroupMemberSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitGradGroupMemberOrderBy>>;
  where?: Maybe<RecruitGradGroupMemberBoolExp>;
};


/** query root */
export type QueryRootRecruitGradGroupMemberAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitGradGroupMemberSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitGradGroupMemberOrderBy>>;
  where?: Maybe<RecruitGradGroupMemberBoolExp>;
};


/** query root */
export type QueryRootRecruitGradGroupMemberByPkArgs = {
  grad_group_id: Scalars['String'];
  recruiter_user_id: Scalars['String'];
  student_user_id: Scalars['String'];
};


/** query root */
export type QueryRootRecruitJobPostingArgs = {
  distinct_on?: Maybe<Array<RecruitJobPostingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitJobPostingOrderBy>>;
  where?: Maybe<RecruitJobPostingBoolExp>;
};


/** query root */
export type QueryRootRecruitJobPostingAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitJobPostingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitJobPostingOrderBy>>;
  where?: Maybe<RecruitJobPostingBoolExp>;
};


/** query root */
export type QueryRootRecruitJobPostingByPkArgs = {
  job_posting_id: Scalars['String'];
};


/** query root */
export type QueryRootRecruitJobRequirementArgs = {
  distinct_on?: Maybe<Array<RecruitJobRequirementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitJobRequirementOrderBy>>;
  where?: Maybe<RecruitJobRequirementBoolExp>;
};


/** query root */
export type QueryRootRecruitJobRequirementAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitJobRequirementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitJobRequirementOrderBy>>;
  where?: Maybe<RecruitJobRequirementBoolExp>;
};


/** query root */
export type QueryRootRecruitJobRequirementByPkArgs = {
  job_requirement_id: Scalars['String'];
};


/** query root */
export type QueryRootRecruitJobRequirementValueArgs = {
  distinct_on?: Maybe<Array<RecruitJobRequirementValueSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitJobRequirementValueOrderBy>>;
  where?: Maybe<RecruitJobRequirementValueBoolExp>;
};


/** query root */
export type QueryRootRecruitJobRequirementValueAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitJobRequirementValueSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitJobRequirementValueOrderBy>>;
  where?: Maybe<RecruitJobRequirementValueBoolExp>;
};


/** query root */
export type QueryRootRecruitJobRequirementValueByPkArgs = {
  job_requirement_value_id: Scalars['String'];
};


/** query root */
export type QueryRootRecruitRecruiterArgs = {
  distinct_on?: Maybe<Array<RecruitRecruiterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitRecruiterOrderBy>>;
  where?: Maybe<RecruitRecruiterBoolExp>;
};


/** query root */
export type QueryRootRecruitRecruiterAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitRecruiterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitRecruiterOrderBy>>;
  where?: Maybe<RecruitRecruiterBoolExp>;
};


/** query root */
export type QueryRootRecruitRecruiterByPkArgs = {
  user_id: Scalars['String'];
};


/** query root */
export type QueryRootRecruitSavedSearchArgs = {
  distinct_on?: Maybe<Array<RecruitSavedSearchSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSavedSearchOrderBy>>;
  where?: Maybe<RecruitSavedSearchBoolExp>;
};


/** query root */
export type QueryRootRecruitSavedSearchAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitSavedSearchSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSavedSearchOrderBy>>;
  where?: Maybe<RecruitSavedSearchBoolExp>;
};


/** query root */
export type QueryRootRecruitSavedSearchByPkArgs = {
  saved_search_id: Scalars['String'];
};


/** query root */
export type QueryRootRecruitSmsCorrespondentArgs = {
  distinct_on?: Maybe<Array<RecruitSmsCorrespondentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsCorrespondentOrderBy>>;
  where?: Maybe<RecruitSmsCorrespondentBoolExp>;
};


/** query root */
export type QueryRootRecruitSmsCorrespondentAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitSmsCorrespondentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsCorrespondentOrderBy>>;
  where?: Maybe<RecruitSmsCorrespondentBoolExp>;
};


/** query root */
export type QueryRootRecruitSmsCorrespondentByPkArgs = {
  sms_correspondent_id: Scalars['Int'];
};


/** query root */
export type QueryRootRecruitSmsMessageArgs = {
  distinct_on?: Maybe<Array<RecruitSmsMessageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsMessageOrderBy>>;
  where?: Maybe<RecruitSmsMessageBoolExp>;
};


/** query root */
export type QueryRootRecruitSmsMessageAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitSmsMessageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsMessageOrderBy>>;
  where?: Maybe<RecruitSmsMessageBoolExp>;
};


/** query root */
export type QueryRootRecruitSmsMessageByPkArgs = {
  sms_message_id: Scalars['Int'];
};


/** query root */
export type QueryRootRecruitSmsMessageCorrespondentArgs = {
  distinct_on?: Maybe<Array<RecruitSmsMessageCorrespondentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsMessageCorrespondentOrderBy>>;
  where?: Maybe<RecruitSmsMessageCorrespondentBoolExp>;
};


/** query root */
export type QueryRootRecruitSmsMessageCorrespondentAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitSmsMessageCorrespondentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsMessageCorrespondentOrderBy>>;
  where?: Maybe<RecruitSmsMessageCorrespondentBoolExp>;
};


/** query root */
export type QueryRootRecruitSmsMessageCorrespondentByPkArgs = {
  sms_message_correspondent_id: Scalars['Int'];
};


/** query root */
export type QueryRootRecruitSmsTemplateArgs = {
  distinct_on?: Maybe<Array<RecruitSmsTemplateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsTemplateOrderBy>>;
  where?: Maybe<RecruitSmsTemplateBoolExp>;
};


/** query root */
export type QueryRootRecruitSmsTemplateAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitSmsTemplateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsTemplateOrderBy>>;
  where?: Maybe<RecruitSmsTemplateBoolExp>;
};


/** query root */
export type QueryRootRecruitSmsTemplateByPkArgs = {
  sms_template_id: Scalars['Int'];
};


/** query root */
export type QueryRootTestAuto3Args = {
  distinct_on?: Maybe<Array<TestAuto3SelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TestAuto3OrderBy>>;
  where?: Maybe<TestAuto3BoolExp>;
};


/** query root */
export type QueryRootTestAuto3AggregateArgs = {
  distinct_on?: Maybe<Array<TestAuto3SelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TestAuto3OrderBy>>;
  where?: Maybe<TestAuto3BoolExp>;
};


/** query root */
export type QueryRootTestAuto3ByPkArgs = {
  id: Scalars['String'];
};


/** query root */
export type QueryRootToQueueArgs = {
  distinct_on?: Maybe<Array<ToQueueSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ToQueueOrderBy>>;
  where?: Maybe<ToQueueBoolExp>;
};


/** query root */
export type QueryRootToQueueAggregateArgs = {
  distinct_on?: Maybe<Array<ToQueueSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ToQueueOrderBy>>;
  where?: Maybe<ToQueueBoolExp>;
};


/** query root */
export type QueryRootToQueueByPkArgs = {
  to_queue_id: Scalars['Int'];
};


/** query root */
export type QueryRootToQueueResponseArgs = {
  distinct_on?: Maybe<Array<ToQueueResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ToQueueResponseOrderBy>>;
  where?: Maybe<ToQueueResponseBoolExp>;
};


/** query root */
export type QueryRootToQueueResponseAggregateArgs = {
  distinct_on?: Maybe<Array<ToQueueResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ToQueueResponseOrderBy>>;
  where?: Maybe<ToQueueResponseBoolExp>;
};


/** query root */
export type QueryRootToQueueResponseByPkArgs = {
  to_queue_id: Scalars['Int'];
};


/** query root */
export type QueryRootUserAuthArgs = {
  distinct_on?: Maybe<Array<UserAuthSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<UserAuthOrderBy>>;
  where?: Maybe<UserAuthBoolExp>;
};


/** query root */
export type QueryRootUserAuthAggregateArgs = {
  distinct_on?: Maybe<Array<UserAuthSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<UserAuthOrderBy>>;
  where?: Maybe<UserAuthBoolExp>;
};


/** query root */
export type QueryRootUserAuthByPkArgs = {
  email: Scalars['String'];
};


/** query root */
export type QueryRootUseraccountArgs = {
  distinct_on?: Maybe<Array<UseraccountSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<UseraccountOrderBy>>;
  where?: Maybe<UseraccountBoolExp>;
};


/** query root */
export type QueryRootUseraccountAggregateArgs = {
  distinct_on?: Maybe<Array<UseraccountSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<UseraccountOrderBy>>;
  where?: Maybe<UseraccountBoolExp>;
};


/** query root */
export type QueryRootUseraccountByPkArgs = {
  user_id: Scalars['String'];
};


/** query root */
export type QueryRootWebApiPermissionArgs = {
  distinct_on?: Maybe<Array<WebApiPermissionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<WebApiPermissionOrderBy>>;
  where?: Maybe<WebApiPermissionBoolExp>;
};


/** query root */
export type QueryRootWebApiPermissionAggregateArgs = {
  distinct_on?: Maybe<Array<WebApiPermissionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<WebApiPermissionOrderBy>>;
  where?: Maybe<WebApiPermissionBoolExp>;
};


/** query root */
export type QueryRootWebApiPermissionByPkArgs = {
  fn: Scalars['String'];
};

/** columns and relationships of "queue_handler_permission" */
export type QueueHandlerPermission = {
  __typename?: 'queue_handler_permission';
  queue: Scalars['String'];
};

/** aggregated selection of "queue_handler_permission" */
export type QueueHandlerPermissionAggregate = {
  __typename?: 'queue_handler_permission_aggregate';
  aggregate?: Maybe<QueueHandlerPermissionAggregateFields>;
  nodes: Array<QueueHandlerPermission>;
};

/** aggregate fields of "queue_handler_permission" */
export type QueueHandlerPermissionAggregateFields = {
  __typename?: 'queue_handler_permission_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<QueueHandlerPermissionMaxFields>;
  min?: Maybe<QueueHandlerPermissionMinFields>;
};


/** aggregate fields of "queue_handler_permission" */
export type QueueHandlerPermissionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<QueueHandlerPermissionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "queue_handler_permission" */
export type QueueHandlerPermissionAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<QueueHandlerPermissionMaxOrderBy>;
  min?: Maybe<QueueHandlerPermissionMinOrderBy>;
};

/** input type for inserting array relation for remote table "queue_handler_permission" */
export type QueueHandlerPermissionArrRelInsertInput = {
  data: Array<QueueHandlerPermissionInsertInput>;
  on_conflict?: Maybe<QueueHandlerPermissionOnConflict>;
};

/** Boolean expression to filter rows from the table "queue_handler_permission". All fields are combined with a logical 'AND'. */
export type QueueHandlerPermissionBoolExp = {
  _and?: Maybe<Array<Maybe<QueueHandlerPermissionBoolExp>>>;
  _not?: Maybe<QueueHandlerPermissionBoolExp>;
  _or?: Maybe<Array<Maybe<QueueHandlerPermissionBoolExp>>>;
  queue?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "queue_handler_permission" */
export enum QueueHandlerPermissionConstraint {
  /** unique or primary key constraint */
  QueueHandlerPermissionPkey = 'queue_handler_permission_pkey'
}

/** input type for inserting data into table "queue_handler_permission" */
export type QueueHandlerPermissionInsertInput = {
  queue?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type QueueHandlerPermissionMaxFields = {
  __typename?: 'queue_handler_permission_max_fields';
  queue?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "queue_handler_permission" */
export type QueueHandlerPermissionMaxOrderBy = {
  queue?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type QueueHandlerPermissionMinFields = {
  __typename?: 'queue_handler_permission_min_fields';
  queue?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "queue_handler_permission" */
export type QueueHandlerPermissionMinOrderBy = {
  queue?: Maybe<OrderBy>;
};

/** response of any mutation on the table "queue_handler_permission" */
export type QueueHandlerPermissionMutationResponse = {
  __typename?: 'queue_handler_permission_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<QueueHandlerPermission>;
};

/** input type for inserting object relation for remote table "queue_handler_permission" */
export type QueueHandlerPermissionObjRelInsertInput = {
  data: QueueHandlerPermissionInsertInput;
  on_conflict?: Maybe<QueueHandlerPermissionOnConflict>;
};

/** on conflict condition type for table "queue_handler_permission" */
export type QueueHandlerPermissionOnConflict = {
  constraint: QueueHandlerPermissionConstraint;
  update_columns: Array<QueueHandlerPermissionUpdateColumn>;
  where?: Maybe<QueueHandlerPermissionBoolExp>;
};

/** ordering options when selecting data from "queue_handler_permission" */
export type QueueHandlerPermissionOrderBy = {
  queue?: Maybe<OrderBy>;
};

/** primary key columns input for table: "queue_handler_permission" */
export type QueueHandlerPermissionPkColumnsInput = {
  queue: Scalars['String'];
};

/** select columns of table "queue_handler_permission" */
export enum QueueHandlerPermissionSelectColumn {
  /** column name */
  Queue = 'queue'
}

/** input type for updating data in table "queue_handler_permission" */
export type QueueHandlerPermissionSetInput = {
  queue?: Maybe<Scalars['String']>;
};

/** update columns of table "queue_handler_permission" */
export enum QueueHandlerPermissionUpdateColumn {
  /** column name */
  Queue = 'queue'
}

/**
 * each row represents an account, which can have multiple recruiters
 *
 *
 * columns and relationships of "recruit.account"
 */
export type RecruitAccount = {
  __typename?: 'recruit_account';
  /** auto-generated uuid */
  account_id: Scalars['String'];
  /** company name */
  account_name: Scalars['String'];
  /** An object relationship */
  company?: Maybe<RecruitCompany>;
  /** An array relationship */
  insert_company: Array<RecruitCompany>;
  /** An aggregated array relationship */
  insert_company_aggregate: RecruitCompanyAggregate;
  /** An array relationship */
  recruiters: Array<RecruitRecruiter>;
  /** An aggregated array relationship */
  recruiters_aggregate: RecruitRecruiterAggregate;
};


/**
 * each row represents an account, which can have multiple recruiters
 *
 *
 * columns and relationships of "recruit.account"
 */
export type RecruitAccountInsertCompanyArgs = {
  distinct_on?: Maybe<Array<RecruitCompanySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitCompanyOrderBy>>;
  where?: Maybe<RecruitCompanyBoolExp>;
};


/**
 * each row represents an account, which can have multiple recruiters
 *
 *
 * columns and relationships of "recruit.account"
 */
export type RecruitAccountInsertCompanyAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitCompanySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitCompanyOrderBy>>;
  where?: Maybe<RecruitCompanyBoolExp>;
};


/**
 * each row represents an account, which can have multiple recruiters
 *
 *
 * columns and relationships of "recruit.account"
 */
export type RecruitAccountRecruitersArgs = {
  distinct_on?: Maybe<Array<RecruitRecruiterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitRecruiterOrderBy>>;
  where?: Maybe<RecruitRecruiterBoolExp>;
};


/**
 * each row represents an account, which can have multiple recruiters
 *
 *
 * columns and relationships of "recruit.account"
 */
export type RecruitAccountRecruitersAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitRecruiterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitRecruiterOrderBy>>;
  where?: Maybe<RecruitRecruiterBoolExp>;
};

/** aggregated selection of "recruit.account" */
export type RecruitAccountAggregate = {
  __typename?: 'recruit_account_aggregate';
  aggregate?: Maybe<RecruitAccountAggregateFields>;
  nodes: Array<RecruitAccount>;
};

/** aggregate fields of "recruit.account" */
export type RecruitAccountAggregateFields = {
  __typename?: 'recruit_account_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<RecruitAccountMaxFields>;
  min?: Maybe<RecruitAccountMinFields>;
};


/** aggregate fields of "recruit.account" */
export type RecruitAccountAggregateFieldsCountArgs = {
  columns?: Maybe<Array<RecruitAccountSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recruit.account" */
export type RecruitAccountAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<RecruitAccountMaxOrderBy>;
  min?: Maybe<RecruitAccountMinOrderBy>;
};

/** input type for inserting array relation for remote table "recruit.account" */
export type RecruitAccountArrRelInsertInput = {
  data: Array<RecruitAccountInsertInput>;
  on_conflict?: Maybe<RecruitAccountOnConflict>;
};

/** Boolean expression to filter rows from the table "recruit.account". All fields are combined with a logical 'AND'. */
export type RecruitAccountBoolExp = {
  _and?: Maybe<Array<Maybe<RecruitAccountBoolExp>>>;
  _not?: Maybe<RecruitAccountBoolExp>;
  _or?: Maybe<Array<Maybe<RecruitAccountBoolExp>>>;
  account_id?: Maybe<StringComparisonExp>;
  account_name?: Maybe<StringComparisonExp>;
  company?: Maybe<RecruitCompanyBoolExp>;
  insert_company?: Maybe<RecruitCompanyBoolExp>;
  recruiters?: Maybe<RecruitRecruiterBoolExp>;
};

/** unique or primary key constraints on table "recruit.account" */
export enum RecruitAccountConstraint {
  /** unique or primary key constraint */
  AccountAccountIdKey = 'account_account_id_key',
  /** unique or primary key constraint */
  AccountPkey = 'account_pkey'
}

/** input type for inserting data into table "recruit.account" */
export type RecruitAccountInsertInput = {
  account_id?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  company?: Maybe<RecruitCompanyObjRelInsertInput>;
  insert_company?: Maybe<RecruitCompanyArrRelInsertInput>;
  recruiters?: Maybe<RecruitRecruiterArrRelInsertInput>;
};

/** aggregate max on columns */
export type RecruitAccountMaxFields = {
  __typename?: 'recruit_account_max_fields';
  account_id?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "recruit.account" */
export type RecruitAccountMaxOrderBy = {
  account_id?: Maybe<OrderBy>;
  account_name?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type RecruitAccountMinFields = {
  __typename?: 'recruit_account_min_fields';
  account_id?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "recruit.account" */
export type RecruitAccountMinOrderBy = {
  account_id?: Maybe<OrderBy>;
  account_name?: Maybe<OrderBy>;
};

/** response of any mutation on the table "recruit.account" */
export type RecruitAccountMutationResponse = {
  __typename?: 'recruit_account_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<RecruitAccount>;
};

/** input type for inserting object relation for remote table "recruit.account" */
export type RecruitAccountObjRelInsertInput = {
  data: RecruitAccountInsertInput;
  on_conflict?: Maybe<RecruitAccountOnConflict>;
};

/** on conflict condition type for table "recruit.account" */
export type RecruitAccountOnConflict = {
  constraint: RecruitAccountConstraint;
  update_columns: Array<RecruitAccountUpdateColumn>;
  where?: Maybe<RecruitAccountBoolExp>;
};

/** ordering options when selecting data from "recruit.account" */
export type RecruitAccountOrderBy = {
  account_id?: Maybe<OrderBy>;
  account_name?: Maybe<OrderBy>;
  company?: Maybe<RecruitCompanyOrderBy>;
  insert_company_aggregate?: Maybe<RecruitCompanyAggregateOrderBy>;
  recruiters_aggregate?: Maybe<RecruitRecruiterAggregateOrderBy>;
};

/** primary key columns input for table: "recruit.account" */
export type RecruitAccountPkColumnsInput = {
  /** auto-generated uuid */
  account_id: Scalars['String'];
};

/** select columns of table "recruit.account" */
export enum RecruitAccountSelectColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AccountName = 'account_name'
}

/** input type for updating data in table "recruit.account" */
export type RecruitAccountSetInput = {
  account_id?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
};

/** update columns of table "recruit.account" */
export enum RecruitAccountUpdateColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  AccountName = 'account_name'
}

/** columns and relationships of "recruit.company" */
export type RecruitCompany = {
  __typename?: 'recruit_company';
  /** An object relationship */
  account: RecruitAccount;
  account_id: Scalars['String'];
  address?: Maybe<Scalars['String']>;
  company_id: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** possible values: 0-25, 26-50, 51-100, 101-250, 251+ */
  num_employees?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  /** An array relationship */
  subindustries: Array<RecruitCompanySubindustry>;
  /** An aggregated array relationship */
  subindustries_aggregate: RecruitCompanySubindustryAggregate;
  website?: Maybe<Scalars['String']>;
};


/** columns and relationships of "recruit.company" */
export type RecruitCompanySubindustriesArgs = {
  distinct_on?: Maybe<Array<RecruitCompanySubindustrySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitCompanySubindustryOrderBy>>;
  where?: Maybe<RecruitCompanySubindustryBoolExp>;
};


/** columns and relationships of "recruit.company" */
export type RecruitCompanySubindustriesAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitCompanySubindustrySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitCompanySubindustryOrderBy>>;
  where?: Maybe<RecruitCompanySubindustryBoolExp>;
};

/** aggregated selection of "recruit.company" */
export type RecruitCompanyAggregate = {
  __typename?: 'recruit_company_aggregate';
  aggregate?: Maybe<RecruitCompanyAggregateFields>;
  nodes: Array<RecruitCompany>;
};

/** aggregate fields of "recruit.company" */
export type RecruitCompanyAggregateFields = {
  __typename?: 'recruit_company_aggregate_fields';
  avg?: Maybe<RecruitCompanyAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<RecruitCompanyMaxFields>;
  min?: Maybe<RecruitCompanyMinFields>;
  stddev?: Maybe<RecruitCompanyStddevFields>;
  stddev_pop?: Maybe<RecruitCompanyStddevPopFields>;
  stddev_samp?: Maybe<RecruitCompanyStddevSampFields>;
  sum?: Maybe<RecruitCompanySumFields>;
  var_pop?: Maybe<RecruitCompanyVarPopFields>;
  var_samp?: Maybe<RecruitCompanyVarSampFields>;
  variance?: Maybe<RecruitCompanyVarianceFields>;
};


/** aggregate fields of "recruit.company" */
export type RecruitCompanyAggregateFieldsCountArgs = {
  columns?: Maybe<Array<RecruitCompanySelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recruit.company" */
export type RecruitCompanyAggregateOrderBy = {
  avg?: Maybe<RecruitCompanyAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<RecruitCompanyMaxOrderBy>;
  min?: Maybe<RecruitCompanyMinOrderBy>;
  stddev?: Maybe<RecruitCompanyStddevOrderBy>;
  stddev_pop?: Maybe<RecruitCompanyStddevPopOrderBy>;
  stddev_samp?: Maybe<RecruitCompanyStddevSampOrderBy>;
  sum?: Maybe<RecruitCompanySumOrderBy>;
  var_pop?: Maybe<RecruitCompanyVarPopOrderBy>;
  var_samp?: Maybe<RecruitCompanyVarSampOrderBy>;
  variance?: Maybe<RecruitCompanyVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "recruit.company" */
export type RecruitCompanyArrRelInsertInput = {
  data: Array<RecruitCompanyInsertInput>;
  on_conflict?: Maybe<RecruitCompanyOnConflict>;
};

/** aggregate avg on columns */
export type RecruitCompanyAvgFields = {
  __typename?: 'recruit_company_avg_fields';
  company_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "recruit.company" */
export type RecruitCompanyAvgOrderBy = {
  company_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "recruit.company". All fields are combined with a logical 'AND'. */
export type RecruitCompanyBoolExp = {
  _and?: Maybe<Array<Maybe<RecruitCompanyBoolExp>>>;
  _not?: Maybe<RecruitCompanyBoolExp>;
  _or?: Maybe<Array<Maybe<RecruitCompanyBoolExp>>>;
  account?: Maybe<RecruitAccountBoolExp>;
  account_id?: Maybe<StringComparisonExp>;
  address?: Maybe<StringComparisonExp>;
  company_id?: Maybe<IntComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  industry?: Maybe<StringComparisonExp>;
  logo?: Maybe<StringComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  num_employees?: Maybe<StringComparisonExp>;
  phone?: Maybe<StringComparisonExp>;
  photo?: Maybe<StringComparisonExp>;
  subindustries?: Maybe<RecruitCompanySubindustryBoolExp>;
  website?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "recruit.company" */
export enum RecruitCompanyConstraint {
  /** unique or primary key constraint */
  CompanyAccountIdKey = 'company_account_id_key',
  /** unique or primary key constraint */
  CompanyPkey = 'company_pkey'
}

/** input type for incrementing integer column in table "recruit.company" */
export type RecruitCompanyIncInput = {
  company_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "recruit.company" */
export type RecruitCompanyInsertInput = {
  account?: Maybe<RecruitAccountObjRelInsertInput>;
  account_id?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  num_employees?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  subindustries?: Maybe<RecruitCompanySubindustryArrRelInsertInput>;
  website?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RecruitCompanyMaxFields = {
  __typename?: 'recruit_company_max_fields';
  account_id?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  num_employees?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "recruit.company" */
export type RecruitCompanyMaxOrderBy = {
  account_id?: Maybe<OrderBy>;
  address?: Maybe<OrderBy>;
  company_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  industry?: Maybe<OrderBy>;
  logo?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  num_employees?: Maybe<OrderBy>;
  phone?: Maybe<OrderBy>;
  photo?: Maybe<OrderBy>;
  website?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type RecruitCompanyMinFields = {
  __typename?: 'recruit_company_min_fields';
  account_id?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  num_employees?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "recruit.company" */
export type RecruitCompanyMinOrderBy = {
  account_id?: Maybe<OrderBy>;
  address?: Maybe<OrderBy>;
  company_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  industry?: Maybe<OrderBy>;
  logo?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  num_employees?: Maybe<OrderBy>;
  phone?: Maybe<OrderBy>;
  photo?: Maybe<OrderBy>;
  website?: Maybe<OrderBy>;
};

/** response of any mutation on the table "recruit.company" */
export type RecruitCompanyMutationResponse = {
  __typename?: 'recruit_company_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<RecruitCompany>;
};

/** input type for inserting object relation for remote table "recruit.company" */
export type RecruitCompanyObjRelInsertInput = {
  data: RecruitCompanyInsertInput;
  on_conflict?: Maybe<RecruitCompanyOnConflict>;
};

/** on conflict condition type for table "recruit.company" */
export type RecruitCompanyOnConflict = {
  constraint: RecruitCompanyConstraint;
  update_columns: Array<RecruitCompanyUpdateColumn>;
  where?: Maybe<RecruitCompanyBoolExp>;
};

/** ordering options when selecting data from "recruit.company" */
export type RecruitCompanyOrderBy = {
  account?: Maybe<RecruitAccountOrderBy>;
  account_id?: Maybe<OrderBy>;
  address?: Maybe<OrderBy>;
  company_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  industry?: Maybe<OrderBy>;
  logo?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  num_employees?: Maybe<OrderBy>;
  phone?: Maybe<OrderBy>;
  photo?: Maybe<OrderBy>;
  subindustries_aggregate?: Maybe<RecruitCompanySubindustryAggregateOrderBy>;
  website?: Maybe<OrderBy>;
};

/** primary key columns input for table: "recruit.company" */
export type RecruitCompanyPkColumnsInput = {
  company_id: Scalars['Int'];
};

/** select columns of table "recruit.company" */
export enum RecruitCompanySelectColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Address = 'address',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Description = 'description',
  /** column name */
  Industry = 'industry',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  NumEmployees = 'num_employees',
  /** column name */
  Phone = 'phone',
  /** column name */
  Photo = 'photo',
  /** column name */
  Website = 'website'
}

/** input type for updating data in table "recruit.company" */
export type RecruitCompanySetInput = {
  account_id?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  company_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  num_employees?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type RecruitCompanyStddevFields = {
  __typename?: 'recruit_company_stddev_fields';
  company_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "recruit.company" */
export type RecruitCompanyStddevOrderBy = {
  company_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type RecruitCompanyStddevPopFields = {
  __typename?: 'recruit_company_stddev_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "recruit.company" */
export type RecruitCompanyStddevPopOrderBy = {
  company_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type RecruitCompanyStddevSampFields = {
  __typename?: 'recruit_company_stddev_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "recruit.company" */
export type RecruitCompanyStddevSampOrderBy = {
  company_id?: Maybe<OrderBy>;
};

/** columns and relationships of "recruit.company_subindustry" */
export type RecruitCompanySubindustry = {
  __typename?: 'recruit_company_subindustry';
  /** An object relationship */
  company: RecruitCompany;
  company_id: Scalars['Int'];
  company_subindustry_id: Scalars['Int'];
  value: Scalars['String'];
};

/** aggregated selection of "recruit.company_subindustry" */
export type RecruitCompanySubindustryAggregate = {
  __typename?: 'recruit_company_subindustry_aggregate';
  aggregate?: Maybe<RecruitCompanySubindustryAggregateFields>;
  nodes: Array<RecruitCompanySubindustry>;
};

/** aggregate fields of "recruit.company_subindustry" */
export type RecruitCompanySubindustryAggregateFields = {
  __typename?: 'recruit_company_subindustry_aggregate_fields';
  avg?: Maybe<RecruitCompanySubindustryAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<RecruitCompanySubindustryMaxFields>;
  min?: Maybe<RecruitCompanySubindustryMinFields>;
  stddev?: Maybe<RecruitCompanySubindustryStddevFields>;
  stddev_pop?: Maybe<RecruitCompanySubindustryStddevPopFields>;
  stddev_samp?: Maybe<RecruitCompanySubindustryStddevSampFields>;
  sum?: Maybe<RecruitCompanySubindustrySumFields>;
  var_pop?: Maybe<RecruitCompanySubindustryVarPopFields>;
  var_samp?: Maybe<RecruitCompanySubindustryVarSampFields>;
  variance?: Maybe<RecruitCompanySubindustryVarianceFields>;
};


/** aggregate fields of "recruit.company_subindustry" */
export type RecruitCompanySubindustryAggregateFieldsCountArgs = {
  columns?: Maybe<Array<RecruitCompanySubindustrySelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recruit.company_subindustry" */
export type RecruitCompanySubindustryAggregateOrderBy = {
  avg?: Maybe<RecruitCompanySubindustryAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<RecruitCompanySubindustryMaxOrderBy>;
  min?: Maybe<RecruitCompanySubindustryMinOrderBy>;
  stddev?: Maybe<RecruitCompanySubindustryStddevOrderBy>;
  stddev_pop?: Maybe<RecruitCompanySubindustryStddevPopOrderBy>;
  stddev_samp?: Maybe<RecruitCompanySubindustryStddevSampOrderBy>;
  sum?: Maybe<RecruitCompanySubindustrySumOrderBy>;
  var_pop?: Maybe<RecruitCompanySubindustryVarPopOrderBy>;
  var_samp?: Maybe<RecruitCompanySubindustryVarSampOrderBy>;
  variance?: Maybe<RecruitCompanySubindustryVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "recruit.company_subindustry" */
export type RecruitCompanySubindustryArrRelInsertInput = {
  data: Array<RecruitCompanySubindustryInsertInput>;
  on_conflict?: Maybe<RecruitCompanySubindustryOnConflict>;
};

/** aggregate avg on columns */
export type RecruitCompanySubindustryAvgFields = {
  __typename?: 'recruit_company_subindustry_avg_fields';
  company_id?: Maybe<Scalars['Float']>;
  company_subindustry_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "recruit.company_subindustry" */
export type RecruitCompanySubindustryAvgOrderBy = {
  company_id?: Maybe<OrderBy>;
  company_subindustry_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "recruit.company_subindustry". All fields are combined with a logical 'AND'. */
export type RecruitCompanySubindustryBoolExp = {
  _and?: Maybe<Array<Maybe<RecruitCompanySubindustryBoolExp>>>;
  _not?: Maybe<RecruitCompanySubindustryBoolExp>;
  _or?: Maybe<Array<Maybe<RecruitCompanySubindustryBoolExp>>>;
  company?: Maybe<RecruitCompanyBoolExp>;
  company_id?: Maybe<IntComparisonExp>;
  company_subindustry_id?: Maybe<IntComparisonExp>;
  value?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "recruit.company_subindustry" */
export enum RecruitCompanySubindustryConstraint {
  /** unique or primary key constraint */
  CompanySubindustryPkey = 'company_subindustry_pkey'
}

/** input type for incrementing integer column in table "recruit.company_subindustry" */
export type RecruitCompanySubindustryIncInput = {
  company_id?: Maybe<Scalars['Int']>;
  company_subindustry_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "recruit.company_subindustry" */
export type RecruitCompanySubindustryInsertInput = {
  company?: Maybe<RecruitCompanyObjRelInsertInput>;
  company_id?: Maybe<Scalars['Int']>;
  company_subindustry_id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RecruitCompanySubindustryMaxFields = {
  __typename?: 'recruit_company_subindustry_max_fields';
  company_id?: Maybe<Scalars['Int']>;
  company_subindustry_id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "recruit.company_subindustry" */
export type RecruitCompanySubindustryMaxOrderBy = {
  company_id?: Maybe<OrderBy>;
  company_subindustry_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type RecruitCompanySubindustryMinFields = {
  __typename?: 'recruit_company_subindustry_min_fields';
  company_id?: Maybe<Scalars['Int']>;
  company_subindustry_id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "recruit.company_subindustry" */
export type RecruitCompanySubindustryMinOrderBy = {
  company_id?: Maybe<OrderBy>;
  company_subindustry_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** response of any mutation on the table "recruit.company_subindustry" */
export type RecruitCompanySubindustryMutationResponse = {
  __typename?: 'recruit_company_subindustry_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<RecruitCompanySubindustry>;
};

/** input type for inserting object relation for remote table "recruit.company_subindustry" */
export type RecruitCompanySubindustryObjRelInsertInput = {
  data: RecruitCompanySubindustryInsertInput;
  on_conflict?: Maybe<RecruitCompanySubindustryOnConflict>;
};

/** on conflict condition type for table "recruit.company_subindustry" */
export type RecruitCompanySubindustryOnConflict = {
  constraint: RecruitCompanySubindustryConstraint;
  update_columns: Array<RecruitCompanySubindustryUpdateColumn>;
  where?: Maybe<RecruitCompanySubindustryBoolExp>;
};

/** ordering options when selecting data from "recruit.company_subindustry" */
export type RecruitCompanySubindustryOrderBy = {
  company?: Maybe<RecruitCompanyOrderBy>;
  company_id?: Maybe<OrderBy>;
  company_subindustry_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
};

/** primary key columns input for table: "recruit.company_subindustry" */
export type RecruitCompanySubindustryPkColumnsInput = {
  company_subindustry_id: Scalars['Int'];
};

/** select columns of table "recruit.company_subindustry" */
export enum RecruitCompanySubindustrySelectColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CompanySubindustryId = 'company_subindustry_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "recruit.company_subindustry" */
export type RecruitCompanySubindustrySetInput = {
  company_id?: Maybe<Scalars['Int']>;
  company_subindustry_id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type RecruitCompanySubindustryStddevFields = {
  __typename?: 'recruit_company_subindustry_stddev_fields';
  company_id?: Maybe<Scalars['Float']>;
  company_subindustry_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "recruit.company_subindustry" */
export type RecruitCompanySubindustryStddevOrderBy = {
  company_id?: Maybe<OrderBy>;
  company_subindustry_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type RecruitCompanySubindustryStddevPopFields = {
  __typename?: 'recruit_company_subindustry_stddev_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  company_subindustry_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "recruit.company_subindustry" */
export type RecruitCompanySubindustryStddevPopOrderBy = {
  company_id?: Maybe<OrderBy>;
  company_subindustry_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type RecruitCompanySubindustryStddevSampFields = {
  __typename?: 'recruit_company_subindustry_stddev_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  company_subindustry_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "recruit.company_subindustry" */
export type RecruitCompanySubindustryStddevSampOrderBy = {
  company_id?: Maybe<OrderBy>;
  company_subindustry_id?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type RecruitCompanySubindustrySumFields = {
  __typename?: 'recruit_company_subindustry_sum_fields';
  company_id?: Maybe<Scalars['Int']>;
  company_subindustry_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "recruit.company_subindustry" */
export type RecruitCompanySubindustrySumOrderBy = {
  company_id?: Maybe<OrderBy>;
  company_subindustry_id?: Maybe<OrderBy>;
};

/** update columns of table "recruit.company_subindustry" */
export enum RecruitCompanySubindustryUpdateColumn {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CompanySubindustryId = 'company_subindustry_id',
  /** column name */
  Value = 'value'
}

/** aggregate var_pop on columns */
export type RecruitCompanySubindustryVarPopFields = {
  __typename?: 'recruit_company_subindustry_var_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  company_subindustry_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "recruit.company_subindustry" */
export type RecruitCompanySubindustryVarPopOrderBy = {
  company_id?: Maybe<OrderBy>;
  company_subindustry_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type RecruitCompanySubindustryVarSampFields = {
  __typename?: 'recruit_company_subindustry_var_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  company_subindustry_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "recruit.company_subindustry" */
export type RecruitCompanySubindustryVarSampOrderBy = {
  company_id?: Maybe<OrderBy>;
  company_subindustry_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type RecruitCompanySubindustryVarianceFields = {
  __typename?: 'recruit_company_subindustry_variance_fields';
  company_id?: Maybe<Scalars['Float']>;
  company_subindustry_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "recruit.company_subindustry" */
export type RecruitCompanySubindustryVarianceOrderBy = {
  company_id?: Maybe<OrderBy>;
  company_subindustry_id?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type RecruitCompanySumFields = {
  __typename?: 'recruit_company_sum_fields';
  company_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "recruit.company" */
export type RecruitCompanySumOrderBy = {
  company_id?: Maybe<OrderBy>;
};

/** update columns of table "recruit.company" */
export enum RecruitCompanyUpdateColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Address = 'address',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Description = 'description',
  /** column name */
  Industry = 'industry',
  /** column name */
  Logo = 'logo',
  /** column name */
  Name = 'name',
  /** column name */
  NumEmployees = 'num_employees',
  /** column name */
  Phone = 'phone',
  /** column name */
  Photo = 'photo',
  /** column name */
  Website = 'website'
}

/** aggregate var_pop on columns */
export type RecruitCompanyVarPopFields = {
  __typename?: 'recruit_company_var_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "recruit.company" */
export type RecruitCompanyVarPopOrderBy = {
  company_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type RecruitCompanyVarSampFields = {
  __typename?: 'recruit_company_var_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "recruit.company" */
export type RecruitCompanyVarSampOrderBy = {
  company_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type RecruitCompanyVarianceFields = {
  __typename?: 'recruit_company_variance_fields';
  company_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "recruit.company" */
export type RecruitCompanyVarianceOrderBy = {
  company_id?: Maybe<OrderBy>;
};

/** columns and relationships of "recruit.event" */
export type RecruitEvent = {
  __typename?: 'recruit_event';
  /** An object relationship */
  account: RecruitAccount;
  account_id: Scalars['String'];
  address?: Maybe<Scalars['String']>;
  capacity: Scalars['Int'];
  creation_timestamp: Scalars['timestamptz'];
  creator_id: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  end_datetime: Scalars['timestamp'];
  end_timestamp: Scalars['timestamptz'];
  event_id: Scalars['String'];
  /** An array relationship */
  event_registrations: Array<GradEventRegistration>;
  /** An aggregated array relationship */
  event_registrations_aggregate: GradEventRegistrationAggregate;
  event_type: Scalars['String'];
  event_url?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  /** An object relationship */
  recruiter?: Maybe<RecruitRecruiter>;
  registration_count: Scalars['Int'];
  show_event: Scalars['Boolean'];
  start_datetime: Scalars['timestamp'];
  start_timestamp: Scalars['timestamptz'];
  timezone: Scalars['String'];
  title: Scalars['String'];
};


/** columns and relationships of "recruit.event" */
export type RecruitEventEventRegistrationsArgs = {
  distinct_on?: Maybe<Array<GradEventRegistrationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradEventRegistrationOrderBy>>;
  where?: Maybe<GradEventRegistrationBoolExp>;
};


/** columns and relationships of "recruit.event" */
export type RecruitEventEventRegistrationsAggregateArgs = {
  distinct_on?: Maybe<Array<GradEventRegistrationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradEventRegistrationOrderBy>>;
  where?: Maybe<GradEventRegistrationBoolExp>;
};

/** aggregated selection of "recruit.event" */
export type RecruitEventAggregate = {
  __typename?: 'recruit_event_aggregate';
  aggregate?: Maybe<RecruitEventAggregateFields>;
  nodes: Array<RecruitEvent>;
};

/** aggregate fields of "recruit.event" */
export type RecruitEventAggregateFields = {
  __typename?: 'recruit_event_aggregate_fields';
  avg?: Maybe<RecruitEventAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<RecruitEventMaxFields>;
  min?: Maybe<RecruitEventMinFields>;
  stddev?: Maybe<RecruitEventStddevFields>;
  stddev_pop?: Maybe<RecruitEventStddevPopFields>;
  stddev_samp?: Maybe<RecruitEventStddevSampFields>;
  sum?: Maybe<RecruitEventSumFields>;
  var_pop?: Maybe<RecruitEventVarPopFields>;
  var_samp?: Maybe<RecruitEventVarSampFields>;
  variance?: Maybe<RecruitEventVarianceFields>;
};


/** aggregate fields of "recruit.event" */
export type RecruitEventAggregateFieldsCountArgs = {
  columns?: Maybe<Array<RecruitEventSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recruit.event" */
export type RecruitEventAggregateOrderBy = {
  avg?: Maybe<RecruitEventAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<RecruitEventMaxOrderBy>;
  min?: Maybe<RecruitEventMinOrderBy>;
  stddev?: Maybe<RecruitEventStddevOrderBy>;
  stddev_pop?: Maybe<RecruitEventStddevPopOrderBy>;
  stddev_samp?: Maybe<RecruitEventStddevSampOrderBy>;
  sum?: Maybe<RecruitEventSumOrderBy>;
  var_pop?: Maybe<RecruitEventVarPopOrderBy>;
  var_samp?: Maybe<RecruitEventVarSampOrderBy>;
  variance?: Maybe<RecruitEventVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "recruit.event" */
export type RecruitEventArrRelInsertInput = {
  data: Array<RecruitEventInsertInput>;
  on_conflict?: Maybe<RecruitEventOnConflict>;
};

/** aggregate avg on columns */
export type RecruitEventAvgFields = {
  __typename?: 'recruit_event_avg_fields';
  capacity?: Maybe<Scalars['Float']>;
  registration_count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "recruit.event" */
export type RecruitEventAvgOrderBy = {
  capacity?: Maybe<OrderBy>;
  registration_count?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "recruit.event". All fields are combined with a logical 'AND'. */
export type RecruitEventBoolExp = {
  _and?: Maybe<Array<Maybe<RecruitEventBoolExp>>>;
  _not?: Maybe<RecruitEventBoolExp>;
  _or?: Maybe<Array<Maybe<RecruitEventBoolExp>>>;
  account?: Maybe<RecruitAccountBoolExp>;
  account_id?: Maybe<StringComparisonExp>;
  address?: Maybe<StringComparisonExp>;
  capacity?: Maybe<IntComparisonExp>;
  creation_timestamp?: Maybe<TimestamptzComparisonExp>;
  creator_id?: Maybe<StringComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  end_datetime?: Maybe<TimestampComparisonExp>;
  end_timestamp?: Maybe<TimestamptzComparisonExp>;
  event_id?: Maybe<StringComparisonExp>;
  event_registrations?: Maybe<GradEventRegistrationBoolExp>;
  event_type?: Maybe<StringComparisonExp>;
  event_url?: Maybe<StringComparisonExp>;
  image?: Maybe<StringComparisonExp>;
  recruiter?: Maybe<RecruitRecruiterBoolExp>;
  registration_count?: Maybe<IntComparisonExp>;
  show_event?: Maybe<BooleanComparisonExp>;
  start_datetime?: Maybe<TimestampComparisonExp>;
  start_timestamp?: Maybe<TimestamptzComparisonExp>;
  timezone?: Maybe<StringComparisonExp>;
  title?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "recruit.event" */
export enum RecruitEventConstraint {
  /** unique or primary key constraint */
  EventPkey = 'event_pkey'
}

/** input type for incrementing integer column in table "recruit.event" */
export type RecruitEventIncInput = {
  capacity?: Maybe<Scalars['Int']>;
  registration_count?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "recruit.event" */
export type RecruitEventInsertInput = {
  account?: Maybe<RecruitAccountObjRelInsertInput>;
  account_id?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  capacity?: Maybe<Scalars['Int']>;
  creation_timestamp?: Maybe<Scalars['timestamptz']>;
  creator_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  end_datetime?: Maybe<Scalars['timestamp']>;
  end_timestamp?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['String']>;
  event_registrations?: Maybe<GradEventRegistrationArrRelInsertInput>;
  event_type?: Maybe<Scalars['String']>;
  event_url?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  recruiter?: Maybe<RecruitRecruiterObjRelInsertInput>;
  registration_count?: Maybe<Scalars['Int']>;
  show_event?: Maybe<Scalars['Boolean']>;
  start_datetime?: Maybe<Scalars['timestamp']>;
  start_timestamp?: Maybe<Scalars['timestamptz']>;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RecruitEventMaxFields = {
  __typename?: 'recruit_event_max_fields';
  account_id?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  capacity?: Maybe<Scalars['Int']>;
  creation_timestamp?: Maybe<Scalars['timestamptz']>;
  creator_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  end_datetime?: Maybe<Scalars['timestamp']>;
  end_timestamp?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['String']>;
  event_type?: Maybe<Scalars['String']>;
  event_url?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  registration_count?: Maybe<Scalars['Int']>;
  start_datetime?: Maybe<Scalars['timestamp']>;
  start_timestamp?: Maybe<Scalars['timestamptz']>;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "recruit.event" */
export type RecruitEventMaxOrderBy = {
  account_id?: Maybe<OrderBy>;
  address?: Maybe<OrderBy>;
  capacity?: Maybe<OrderBy>;
  creation_timestamp?: Maybe<OrderBy>;
  creator_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  end_datetime?: Maybe<OrderBy>;
  end_timestamp?: Maybe<OrderBy>;
  event_id?: Maybe<OrderBy>;
  event_type?: Maybe<OrderBy>;
  event_url?: Maybe<OrderBy>;
  image?: Maybe<OrderBy>;
  registration_count?: Maybe<OrderBy>;
  start_datetime?: Maybe<OrderBy>;
  start_timestamp?: Maybe<OrderBy>;
  timezone?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type RecruitEventMinFields = {
  __typename?: 'recruit_event_min_fields';
  account_id?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  capacity?: Maybe<Scalars['Int']>;
  creation_timestamp?: Maybe<Scalars['timestamptz']>;
  creator_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  end_datetime?: Maybe<Scalars['timestamp']>;
  end_timestamp?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['String']>;
  event_type?: Maybe<Scalars['String']>;
  event_url?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  registration_count?: Maybe<Scalars['Int']>;
  start_datetime?: Maybe<Scalars['timestamp']>;
  start_timestamp?: Maybe<Scalars['timestamptz']>;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "recruit.event" */
export type RecruitEventMinOrderBy = {
  account_id?: Maybe<OrderBy>;
  address?: Maybe<OrderBy>;
  capacity?: Maybe<OrderBy>;
  creation_timestamp?: Maybe<OrderBy>;
  creator_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  end_datetime?: Maybe<OrderBy>;
  end_timestamp?: Maybe<OrderBy>;
  event_id?: Maybe<OrderBy>;
  event_type?: Maybe<OrderBy>;
  event_url?: Maybe<OrderBy>;
  image?: Maybe<OrderBy>;
  registration_count?: Maybe<OrderBy>;
  start_datetime?: Maybe<OrderBy>;
  start_timestamp?: Maybe<OrderBy>;
  timezone?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
};

/** response of any mutation on the table "recruit.event" */
export type RecruitEventMutationResponse = {
  __typename?: 'recruit_event_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<RecruitEvent>;
};

/** input type for inserting object relation for remote table "recruit.event" */
export type RecruitEventObjRelInsertInput = {
  data: RecruitEventInsertInput;
  on_conflict?: Maybe<RecruitEventOnConflict>;
};

/** on conflict condition type for table "recruit.event" */
export type RecruitEventOnConflict = {
  constraint: RecruitEventConstraint;
  update_columns: Array<RecruitEventUpdateColumn>;
  where?: Maybe<RecruitEventBoolExp>;
};

/** ordering options when selecting data from "recruit.event" */
export type RecruitEventOrderBy = {
  account?: Maybe<RecruitAccountOrderBy>;
  account_id?: Maybe<OrderBy>;
  address?: Maybe<OrderBy>;
  capacity?: Maybe<OrderBy>;
  creation_timestamp?: Maybe<OrderBy>;
  creator_id?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  end_datetime?: Maybe<OrderBy>;
  end_timestamp?: Maybe<OrderBy>;
  event_id?: Maybe<OrderBy>;
  event_registrations_aggregate?: Maybe<GradEventRegistrationAggregateOrderBy>;
  event_type?: Maybe<OrderBy>;
  event_url?: Maybe<OrderBy>;
  image?: Maybe<OrderBy>;
  recruiter?: Maybe<RecruitRecruiterOrderBy>;
  registration_count?: Maybe<OrderBy>;
  show_event?: Maybe<OrderBy>;
  start_datetime?: Maybe<OrderBy>;
  start_timestamp?: Maybe<OrderBy>;
  timezone?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
};

/** primary key columns input for table: "recruit.event" */
export type RecruitEventPkColumnsInput = {
  event_id: Scalars['String'];
};

/** select columns of table "recruit.event" */
export enum RecruitEventSelectColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Address = 'address',
  /** column name */
  Capacity = 'capacity',
  /** column name */
  CreationTimestamp = 'creation_timestamp',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Description = 'description',
  /** column name */
  EndDatetime = 'end_datetime',
  /** column name */
  EndTimestamp = 'end_timestamp',
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventType = 'event_type',
  /** column name */
  EventUrl = 'event_url',
  /** column name */
  Image = 'image',
  /** column name */
  RegistrationCount = 'registration_count',
  /** column name */
  ShowEvent = 'show_event',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  StartTimestamp = 'start_timestamp',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "recruit.event" */
export type RecruitEventSetInput = {
  account_id?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  capacity?: Maybe<Scalars['Int']>;
  creation_timestamp?: Maybe<Scalars['timestamptz']>;
  creator_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  end_datetime?: Maybe<Scalars['timestamp']>;
  end_timestamp?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['String']>;
  event_type?: Maybe<Scalars['String']>;
  event_url?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  registration_count?: Maybe<Scalars['Int']>;
  show_event?: Maybe<Scalars['Boolean']>;
  start_datetime?: Maybe<Scalars['timestamp']>;
  start_timestamp?: Maybe<Scalars['timestamptz']>;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type RecruitEventStddevFields = {
  __typename?: 'recruit_event_stddev_fields';
  capacity?: Maybe<Scalars['Float']>;
  registration_count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "recruit.event" */
export type RecruitEventStddevOrderBy = {
  capacity?: Maybe<OrderBy>;
  registration_count?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type RecruitEventStddevPopFields = {
  __typename?: 'recruit_event_stddev_pop_fields';
  capacity?: Maybe<Scalars['Float']>;
  registration_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "recruit.event" */
export type RecruitEventStddevPopOrderBy = {
  capacity?: Maybe<OrderBy>;
  registration_count?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type RecruitEventStddevSampFields = {
  __typename?: 'recruit_event_stddev_samp_fields';
  capacity?: Maybe<Scalars['Float']>;
  registration_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "recruit.event" */
export type RecruitEventStddevSampOrderBy = {
  capacity?: Maybe<OrderBy>;
  registration_count?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type RecruitEventSumFields = {
  __typename?: 'recruit_event_sum_fields';
  capacity?: Maybe<Scalars['Int']>;
  registration_count?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "recruit.event" */
export type RecruitEventSumOrderBy = {
  capacity?: Maybe<OrderBy>;
  registration_count?: Maybe<OrderBy>;
};

/** update columns of table "recruit.event" */
export enum RecruitEventUpdateColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Address = 'address',
  /** column name */
  Capacity = 'capacity',
  /** column name */
  CreationTimestamp = 'creation_timestamp',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Description = 'description',
  /** column name */
  EndDatetime = 'end_datetime',
  /** column name */
  EndTimestamp = 'end_timestamp',
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventType = 'event_type',
  /** column name */
  EventUrl = 'event_url',
  /** column name */
  Image = 'image',
  /** column name */
  RegistrationCount = 'registration_count',
  /** column name */
  ShowEvent = 'show_event',
  /** column name */
  StartDatetime = 'start_datetime',
  /** column name */
  StartTimestamp = 'start_timestamp',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  Title = 'title'
}

/** aggregate var_pop on columns */
export type RecruitEventVarPopFields = {
  __typename?: 'recruit_event_var_pop_fields';
  capacity?: Maybe<Scalars['Float']>;
  registration_count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "recruit.event" */
export type RecruitEventVarPopOrderBy = {
  capacity?: Maybe<OrderBy>;
  registration_count?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type RecruitEventVarSampFields = {
  __typename?: 'recruit_event_var_samp_fields';
  capacity?: Maybe<Scalars['Float']>;
  registration_count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "recruit.event" */
export type RecruitEventVarSampOrderBy = {
  capacity?: Maybe<OrderBy>;
  registration_count?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type RecruitEventVarianceFields = {
  __typename?: 'recruit_event_variance_fields';
  capacity?: Maybe<Scalars['Float']>;
  registration_count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "recruit.event" */
export type RecruitEventVarianceOrderBy = {
  capacity?: Maybe<OrderBy>;
  registration_count?: Maybe<OrderBy>;
};

/**
 * probably by recruiters to organize prospects into groups
 *
 *
 * columns and relationships of "recruit.grad_group"
 */
export type RecruitGradGroup = {
  __typename?: 'recruit_grad_group';
  grad_group_id: Scalars['String'];
  /** An array relationship */
  grad_group_members: Array<RecruitGradGroupMember>;
  /** An aggregated array relationship */
  grad_group_members_aggregate: RecruitGradGroupMemberAggregate;
  group_name: Scalars['String'];
  recruiter_user_id: Scalars['String'];
};


/**
 * probably by recruiters to organize prospects into groups
 *
 *
 * columns and relationships of "recruit.grad_group"
 */
export type RecruitGradGroupGradGroupMembersArgs = {
  distinct_on?: Maybe<Array<RecruitGradGroupMemberSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitGradGroupMemberOrderBy>>;
  where?: Maybe<RecruitGradGroupMemberBoolExp>;
};


/**
 * probably by recruiters to organize prospects into groups
 *
 *
 * columns and relationships of "recruit.grad_group"
 */
export type RecruitGradGroupGradGroupMembersAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitGradGroupMemberSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitGradGroupMemberOrderBy>>;
  where?: Maybe<RecruitGradGroupMemberBoolExp>;
};

/** aggregated selection of "recruit.grad_group" */
export type RecruitGradGroupAggregate = {
  __typename?: 'recruit_grad_group_aggregate';
  aggregate?: Maybe<RecruitGradGroupAggregateFields>;
  nodes: Array<RecruitGradGroup>;
};

/** aggregate fields of "recruit.grad_group" */
export type RecruitGradGroupAggregateFields = {
  __typename?: 'recruit_grad_group_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<RecruitGradGroupMaxFields>;
  min?: Maybe<RecruitGradGroupMinFields>;
};


/** aggregate fields of "recruit.grad_group" */
export type RecruitGradGroupAggregateFieldsCountArgs = {
  columns?: Maybe<Array<RecruitGradGroupSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recruit.grad_group" */
export type RecruitGradGroupAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<RecruitGradGroupMaxOrderBy>;
  min?: Maybe<RecruitGradGroupMinOrderBy>;
};

/** input type for inserting array relation for remote table "recruit.grad_group" */
export type RecruitGradGroupArrRelInsertInput = {
  data: Array<RecruitGradGroupInsertInput>;
  on_conflict?: Maybe<RecruitGradGroupOnConflict>;
};

/** Boolean expression to filter rows from the table "recruit.grad_group". All fields are combined with a logical 'AND'. */
export type RecruitGradGroupBoolExp = {
  _and?: Maybe<Array<Maybe<RecruitGradGroupBoolExp>>>;
  _not?: Maybe<RecruitGradGroupBoolExp>;
  _or?: Maybe<Array<Maybe<RecruitGradGroupBoolExp>>>;
  grad_group_id?: Maybe<StringComparisonExp>;
  grad_group_members?: Maybe<RecruitGradGroupMemberBoolExp>;
  group_name?: Maybe<StringComparisonExp>;
  recruiter_user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "recruit.grad_group" */
export enum RecruitGradGroupConstraint {
  /** unique or primary key constraint */
  GradGroupPkey = 'grad_group_pkey',
  /** unique or primary key constraint */
  GradGroupRecruiterUseridGradGroupIdKey = 'grad_group_recruiter_userid_grad_group_id_key'
}

/** input type for inserting data into table "recruit.grad_group" */
export type RecruitGradGroupInsertInput = {
  grad_group_id?: Maybe<Scalars['String']>;
  grad_group_members?: Maybe<RecruitGradGroupMemberArrRelInsertInput>;
  group_name?: Maybe<Scalars['String']>;
  recruiter_user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RecruitGradGroupMaxFields = {
  __typename?: 'recruit_grad_group_max_fields';
  grad_group_id?: Maybe<Scalars['String']>;
  group_name?: Maybe<Scalars['String']>;
  recruiter_user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "recruit.grad_group" */
export type RecruitGradGroupMaxOrderBy = {
  grad_group_id?: Maybe<OrderBy>;
  group_name?: Maybe<OrderBy>;
  recruiter_user_id?: Maybe<OrderBy>;
};

/** columns and relationships of "recruit.grad_group_member" */
export type RecruitGradGroupMember = {
  __typename?: 'recruit_grad_group_member';
  /** An object relationship */
  grad_group?: Maybe<RecruitGradGroup>;
  grad_group_id: Scalars['String'];
  /** An object relationship */
  profile: GradProfile;
  recruiter_user_id: Scalars['String'];
  student_user_id: Scalars['String'];
};

/** aggregated selection of "recruit.grad_group_member" */
export type RecruitGradGroupMemberAggregate = {
  __typename?: 'recruit_grad_group_member_aggregate';
  aggregate?: Maybe<RecruitGradGroupMemberAggregateFields>;
  nodes: Array<RecruitGradGroupMember>;
};

/** aggregate fields of "recruit.grad_group_member" */
export type RecruitGradGroupMemberAggregateFields = {
  __typename?: 'recruit_grad_group_member_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<RecruitGradGroupMemberMaxFields>;
  min?: Maybe<RecruitGradGroupMemberMinFields>;
};


/** aggregate fields of "recruit.grad_group_member" */
export type RecruitGradGroupMemberAggregateFieldsCountArgs = {
  columns?: Maybe<Array<RecruitGradGroupMemberSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recruit.grad_group_member" */
export type RecruitGradGroupMemberAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<RecruitGradGroupMemberMaxOrderBy>;
  min?: Maybe<RecruitGradGroupMemberMinOrderBy>;
};

/** input type for inserting array relation for remote table "recruit.grad_group_member" */
export type RecruitGradGroupMemberArrRelInsertInput = {
  data: Array<RecruitGradGroupMemberInsertInput>;
  on_conflict?: Maybe<RecruitGradGroupMemberOnConflict>;
};

/** Boolean expression to filter rows from the table "recruit.grad_group_member". All fields are combined with a logical 'AND'. */
export type RecruitGradGroupMemberBoolExp = {
  _and?: Maybe<Array<Maybe<RecruitGradGroupMemberBoolExp>>>;
  _not?: Maybe<RecruitGradGroupMemberBoolExp>;
  _or?: Maybe<Array<Maybe<RecruitGradGroupMemberBoolExp>>>;
  grad_group?: Maybe<RecruitGradGroupBoolExp>;
  grad_group_id?: Maybe<StringComparisonExp>;
  profile?: Maybe<GradProfileBoolExp>;
  recruiter_user_id?: Maybe<StringComparisonExp>;
  student_user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "recruit.grad_group_member" */
export enum RecruitGradGroupMemberConstraint {
  /** unique or primary key constraint */
  GradGroupMemberPkey = 'grad_group_member_pkey'
}

/** input type for inserting data into table "recruit.grad_group_member" */
export type RecruitGradGroupMemberInsertInput = {
  grad_group?: Maybe<RecruitGradGroupObjRelInsertInput>;
  grad_group_id?: Maybe<Scalars['String']>;
  profile?: Maybe<GradProfileObjRelInsertInput>;
  recruiter_user_id?: Maybe<Scalars['String']>;
  student_user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RecruitGradGroupMemberMaxFields = {
  __typename?: 'recruit_grad_group_member_max_fields';
  grad_group_id?: Maybe<Scalars['String']>;
  recruiter_user_id?: Maybe<Scalars['String']>;
  student_user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "recruit.grad_group_member" */
export type RecruitGradGroupMemberMaxOrderBy = {
  grad_group_id?: Maybe<OrderBy>;
  recruiter_user_id?: Maybe<OrderBy>;
  student_user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type RecruitGradGroupMemberMinFields = {
  __typename?: 'recruit_grad_group_member_min_fields';
  grad_group_id?: Maybe<Scalars['String']>;
  recruiter_user_id?: Maybe<Scalars['String']>;
  student_user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "recruit.grad_group_member" */
export type RecruitGradGroupMemberMinOrderBy = {
  grad_group_id?: Maybe<OrderBy>;
  recruiter_user_id?: Maybe<OrderBy>;
  student_user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "recruit.grad_group_member" */
export type RecruitGradGroupMemberMutationResponse = {
  __typename?: 'recruit_grad_group_member_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<RecruitGradGroupMember>;
};

/** input type for inserting object relation for remote table "recruit.grad_group_member" */
export type RecruitGradGroupMemberObjRelInsertInput = {
  data: RecruitGradGroupMemberInsertInput;
  on_conflict?: Maybe<RecruitGradGroupMemberOnConflict>;
};

/** on conflict condition type for table "recruit.grad_group_member" */
export type RecruitGradGroupMemberOnConflict = {
  constraint: RecruitGradGroupMemberConstraint;
  update_columns: Array<RecruitGradGroupMemberUpdateColumn>;
  where?: Maybe<RecruitGradGroupMemberBoolExp>;
};

/** ordering options when selecting data from "recruit.grad_group_member" */
export type RecruitGradGroupMemberOrderBy = {
  grad_group?: Maybe<RecruitGradGroupOrderBy>;
  grad_group_id?: Maybe<OrderBy>;
  profile?: Maybe<GradProfileOrderBy>;
  recruiter_user_id?: Maybe<OrderBy>;
  student_user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "recruit.grad_group_member" */
export type RecruitGradGroupMemberPkColumnsInput = {
  grad_group_id: Scalars['String'];
  recruiter_user_id: Scalars['String'];
  student_user_id: Scalars['String'];
};

/** select columns of table "recruit.grad_group_member" */
export enum RecruitGradGroupMemberSelectColumn {
  /** column name */
  GradGroupId = 'grad_group_id',
  /** column name */
  RecruiterUserId = 'recruiter_user_id',
  /** column name */
  StudentUserId = 'student_user_id'
}

/** input type for updating data in table "recruit.grad_group_member" */
export type RecruitGradGroupMemberSetInput = {
  grad_group_id?: Maybe<Scalars['String']>;
  recruiter_user_id?: Maybe<Scalars['String']>;
  student_user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "recruit.grad_group_member" */
export enum RecruitGradGroupMemberUpdateColumn {
  /** column name */
  GradGroupId = 'grad_group_id',
  /** column name */
  RecruiterUserId = 'recruiter_user_id',
  /** column name */
  StudentUserId = 'student_user_id'
}

/** aggregate min on columns */
export type RecruitGradGroupMinFields = {
  __typename?: 'recruit_grad_group_min_fields';
  grad_group_id?: Maybe<Scalars['String']>;
  group_name?: Maybe<Scalars['String']>;
  recruiter_user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "recruit.grad_group" */
export type RecruitGradGroupMinOrderBy = {
  grad_group_id?: Maybe<OrderBy>;
  group_name?: Maybe<OrderBy>;
  recruiter_user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "recruit.grad_group" */
export type RecruitGradGroupMutationResponse = {
  __typename?: 'recruit_grad_group_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<RecruitGradGroup>;
};

/** input type for inserting object relation for remote table "recruit.grad_group" */
export type RecruitGradGroupObjRelInsertInput = {
  data: RecruitGradGroupInsertInput;
  on_conflict?: Maybe<RecruitGradGroupOnConflict>;
};

/** on conflict condition type for table "recruit.grad_group" */
export type RecruitGradGroupOnConflict = {
  constraint: RecruitGradGroupConstraint;
  update_columns: Array<RecruitGradGroupUpdateColumn>;
  where?: Maybe<RecruitGradGroupBoolExp>;
};

/** ordering options when selecting data from "recruit.grad_group" */
export type RecruitGradGroupOrderBy = {
  grad_group_id?: Maybe<OrderBy>;
  grad_group_members_aggregate?: Maybe<RecruitGradGroupMemberAggregateOrderBy>;
  group_name?: Maybe<OrderBy>;
  recruiter_user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "recruit.grad_group" */
export type RecruitGradGroupPkColumnsInput = {
  grad_group_id: Scalars['String'];
};

/** select columns of table "recruit.grad_group" */
export enum RecruitGradGroupSelectColumn {
  /** column name */
  GradGroupId = 'grad_group_id',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  RecruiterUserId = 'recruiter_user_id'
}

/** input type for updating data in table "recruit.grad_group" */
export type RecruitGradGroupSetInput = {
  grad_group_id?: Maybe<Scalars['String']>;
  group_name?: Maybe<Scalars['String']>;
  recruiter_user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "recruit.grad_group" */
export enum RecruitGradGroupUpdateColumn {
  /** column name */
  GradGroupId = 'grad_group_id',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  RecruiterUserId = 'recruiter_user_id'
}

/**
 * job posting
 *
 *
 * columns and relationships of "recruit.job_posting"
 */
export type RecruitJobPosting = {
  __typename?: 'recruit_job_posting';
  /** maps to account.account_id */
  account_id: Scalars['String'];
  /** is this job posting active */
  active: Scalars['Boolean'];
  /** An array relationship */
  bookmark_jobs: Array<GradBookmarkJob>;
  /** An aggregated array relationship */
  bookmark_jobs_aggregate: GradBookmarkJobAggregate;
  /** the date the job posting is created */
  creation_date?: Maybe<Scalars['date']>;
  /** maps to recruiter.user_id */
  creator_id: Scalars['String'];
  /** deadline of the application */
  deadline?: Maybe<Scalars['date']>;
  /** description of this job */
  description: Scalars['String'];
  /** which company is this job */
  firm: Scalars['String'];
  /** auto-generated uuid */
  job_posting_id: Scalars['String'];
  /** An array relationship */
  job_requirements: Array<RecruitJobRequirement>;
  /** An aggregated array relationship */
  job_requirements_aggregate: RecruitJobRequirementAggregate;
  /** full time, part time, internship */
  job_type: Scalars['String'];
  /** the date the posting is last modified */
  modified_date?: Maybe<Scalars['date']>;
  /** title of the position */
  position_title: Scalars['String'];
  /** whether the posting is publicly visible or only to students that raised hands */
  public: Scalars['Boolean'];
  /** the date the posting is published */
  publishing_date?: Maybe<Scalars['date']>;
  /** An array relationship */
  raise_hands: Array<GradRaiseHand>;
  /** An aggregated array relationship */
  raise_hands_aggregate: GradRaiseHandAggregate;
  /** which region is the job */
  region: Scalars['String'];
};


/**
 * job posting
 *
 *
 * columns and relationships of "recruit.job_posting"
 */
export type RecruitJobPostingBookmarkJobsArgs = {
  distinct_on?: Maybe<Array<GradBookmarkJobSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradBookmarkJobOrderBy>>;
  where?: Maybe<GradBookmarkJobBoolExp>;
};


/**
 * job posting
 *
 *
 * columns and relationships of "recruit.job_posting"
 */
export type RecruitJobPostingBookmarkJobsAggregateArgs = {
  distinct_on?: Maybe<Array<GradBookmarkJobSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradBookmarkJobOrderBy>>;
  where?: Maybe<GradBookmarkJobBoolExp>;
};


/**
 * job posting
 *
 *
 * columns and relationships of "recruit.job_posting"
 */
export type RecruitJobPostingJobRequirementsArgs = {
  distinct_on?: Maybe<Array<RecruitJobRequirementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitJobRequirementOrderBy>>;
  where?: Maybe<RecruitJobRequirementBoolExp>;
};


/**
 * job posting
 *
 *
 * columns and relationships of "recruit.job_posting"
 */
export type RecruitJobPostingJobRequirementsAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitJobRequirementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitJobRequirementOrderBy>>;
  where?: Maybe<RecruitJobRequirementBoolExp>;
};


/**
 * job posting
 *
 *
 * columns and relationships of "recruit.job_posting"
 */
export type RecruitJobPostingRaiseHandsArgs = {
  distinct_on?: Maybe<Array<GradRaiseHandSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradRaiseHandOrderBy>>;
  where?: Maybe<GradRaiseHandBoolExp>;
};


/**
 * job posting
 *
 *
 * columns and relationships of "recruit.job_posting"
 */
export type RecruitJobPostingRaiseHandsAggregateArgs = {
  distinct_on?: Maybe<Array<GradRaiseHandSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradRaiseHandOrderBy>>;
  where?: Maybe<GradRaiseHandBoolExp>;
};

/** aggregated selection of "recruit.job_posting" */
export type RecruitJobPostingAggregate = {
  __typename?: 'recruit_job_posting_aggregate';
  aggregate?: Maybe<RecruitJobPostingAggregateFields>;
  nodes: Array<RecruitJobPosting>;
};

/** aggregate fields of "recruit.job_posting" */
export type RecruitJobPostingAggregateFields = {
  __typename?: 'recruit_job_posting_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<RecruitJobPostingMaxFields>;
  min?: Maybe<RecruitJobPostingMinFields>;
};


/** aggregate fields of "recruit.job_posting" */
export type RecruitJobPostingAggregateFieldsCountArgs = {
  columns?: Maybe<Array<RecruitJobPostingSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recruit.job_posting" */
export type RecruitJobPostingAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<RecruitJobPostingMaxOrderBy>;
  min?: Maybe<RecruitJobPostingMinOrderBy>;
};

/** input type for inserting array relation for remote table "recruit.job_posting" */
export type RecruitJobPostingArrRelInsertInput = {
  data: Array<RecruitJobPostingInsertInput>;
  on_conflict?: Maybe<RecruitJobPostingOnConflict>;
};

/** Boolean expression to filter rows from the table "recruit.job_posting". All fields are combined with a logical 'AND'. */
export type RecruitJobPostingBoolExp = {
  _and?: Maybe<Array<Maybe<RecruitJobPostingBoolExp>>>;
  _not?: Maybe<RecruitJobPostingBoolExp>;
  _or?: Maybe<Array<Maybe<RecruitJobPostingBoolExp>>>;
  account_id?: Maybe<StringComparisonExp>;
  active?: Maybe<BooleanComparisonExp>;
  bookmark_jobs?: Maybe<GradBookmarkJobBoolExp>;
  creation_date?: Maybe<DateComparisonExp>;
  creator_id?: Maybe<StringComparisonExp>;
  deadline?: Maybe<DateComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  firm?: Maybe<StringComparisonExp>;
  job_posting_id?: Maybe<StringComparisonExp>;
  job_requirements?: Maybe<RecruitJobRequirementBoolExp>;
  job_type?: Maybe<StringComparisonExp>;
  modified_date?: Maybe<DateComparisonExp>;
  position_title?: Maybe<StringComparisonExp>;
  public?: Maybe<BooleanComparisonExp>;
  publishing_date?: Maybe<DateComparisonExp>;
  raise_hands?: Maybe<GradRaiseHandBoolExp>;
  region?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "recruit.job_posting" */
export enum RecruitJobPostingConstraint {
  /** unique or primary key constraint */
  JobPostingJobPostingIdKey = 'job_posting_job_posting_id_key',
  /** unique or primary key constraint */
  JobPostingPkey = 'job_posting_pkey'
}

/** input type for inserting data into table "recruit.job_posting" */
export type RecruitJobPostingInsertInput = {
  account_id?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  bookmark_jobs?: Maybe<GradBookmarkJobArrRelInsertInput>;
  creation_date?: Maybe<Scalars['date']>;
  creator_id?: Maybe<Scalars['String']>;
  deadline?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  firm?: Maybe<Scalars['String']>;
  job_posting_id?: Maybe<Scalars['String']>;
  job_requirements?: Maybe<RecruitJobRequirementArrRelInsertInput>;
  job_type?: Maybe<Scalars['String']>;
  modified_date?: Maybe<Scalars['date']>;
  position_title?: Maybe<Scalars['String']>;
  public?: Maybe<Scalars['Boolean']>;
  publishing_date?: Maybe<Scalars['date']>;
  raise_hands?: Maybe<GradRaiseHandArrRelInsertInput>;
  region?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RecruitJobPostingMaxFields = {
  __typename?: 'recruit_job_posting_max_fields';
  account_id?: Maybe<Scalars['String']>;
  creation_date?: Maybe<Scalars['date']>;
  creator_id?: Maybe<Scalars['String']>;
  deadline?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  firm?: Maybe<Scalars['String']>;
  job_posting_id?: Maybe<Scalars['String']>;
  job_type?: Maybe<Scalars['String']>;
  modified_date?: Maybe<Scalars['date']>;
  position_title?: Maybe<Scalars['String']>;
  publishing_date?: Maybe<Scalars['date']>;
  region?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "recruit.job_posting" */
export type RecruitJobPostingMaxOrderBy = {
  account_id?: Maybe<OrderBy>;
  creation_date?: Maybe<OrderBy>;
  creator_id?: Maybe<OrderBy>;
  deadline?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  firm?: Maybe<OrderBy>;
  job_posting_id?: Maybe<OrderBy>;
  job_type?: Maybe<OrderBy>;
  modified_date?: Maybe<OrderBy>;
  position_title?: Maybe<OrderBy>;
  publishing_date?: Maybe<OrderBy>;
  region?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type RecruitJobPostingMinFields = {
  __typename?: 'recruit_job_posting_min_fields';
  account_id?: Maybe<Scalars['String']>;
  creation_date?: Maybe<Scalars['date']>;
  creator_id?: Maybe<Scalars['String']>;
  deadline?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  firm?: Maybe<Scalars['String']>;
  job_posting_id?: Maybe<Scalars['String']>;
  job_type?: Maybe<Scalars['String']>;
  modified_date?: Maybe<Scalars['date']>;
  position_title?: Maybe<Scalars['String']>;
  publishing_date?: Maybe<Scalars['date']>;
  region?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "recruit.job_posting" */
export type RecruitJobPostingMinOrderBy = {
  account_id?: Maybe<OrderBy>;
  creation_date?: Maybe<OrderBy>;
  creator_id?: Maybe<OrderBy>;
  deadline?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  firm?: Maybe<OrderBy>;
  job_posting_id?: Maybe<OrderBy>;
  job_type?: Maybe<OrderBy>;
  modified_date?: Maybe<OrderBy>;
  position_title?: Maybe<OrderBy>;
  publishing_date?: Maybe<OrderBy>;
  region?: Maybe<OrderBy>;
};

/** response of any mutation on the table "recruit.job_posting" */
export type RecruitJobPostingMutationResponse = {
  __typename?: 'recruit_job_posting_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<RecruitJobPosting>;
};

/** input type for inserting object relation for remote table "recruit.job_posting" */
export type RecruitJobPostingObjRelInsertInput = {
  data: RecruitJobPostingInsertInput;
  on_conflict?: Maybe<RecruitJobPostingOnConflict>;
};

/** on conflict condition type for table "recruit.job_posting" */
export type RecruitJobPostingOnConflict = {
  constraint: RecruitJobPostingConstraint;
  update_columns: Array<RecruitJobPostingUpdateColumn>;
  where?: Maybe<RecruitJobPostingBoolExp>;
};

/** ordering options when selecting data from "recruit.job_posting" */
export type RecruitJobPostingOrderBy = {
  account_id?: Maybe<OrderBy>;
  active?: Maybe<OrderBy>;
  bookmark_jobs_aggregate?: Maybe<GradBookmarkJobAggregateOrderBy>;
  creation_date?: Maybe<OrderBy>;
  creator_id?: Maybe<OrderBy>;
  deadline?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  firm?: Maybe<OrderBy>;
  job_posting_id?: Maybe<OrderBy>;
  job_requirements_aggregate?: Maybe<RecruitJobRequirementAggregateOrderBy>;
  job_type?: Maybe<OrderBy>;
  modified_date?: Maybe<OrderBy>;
  position_title?: Maybe<OrderBy>;
  public?: Maybe<OrderBy>;
  publishing_date?: Maybe<OrderBy>;
  raise_hands_aggregate?: Maybe<GradRaiseHandAggregateOrderBy>;
  region?: Maybe<OrderBy>;
};

/** primary key columns input for table: "recruit.job_posting" */
export type RecruitJobPostingPkColumnsInput = {
  /** auto-generated uuid */
  job_posting_id: Scalars['String'];
};

/** select columns of table "recruit.job_posting" */
export enum RecruitJobPostingSelectColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Active = 'active',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Deadline = 'deadline',
  /** column name */
  Description = 'description',
  /** column name */
  Firm = 'firm',
  /** column name */
  JobPostingId = 'job_posting_id',
  /** column name */
  JobType = 'job_type',
  /** column name */
  ModifiedDate = 'modified_date',
  /** column name */
  PositionTitle = 'position_title',
  /** column name */
  Public = 'public',
  /** column name */
  PublishingDate = 'publishing_date',
  /** column name */
  Region = 'region'
}

/** input type for updating data in table "recruit.job_posting" */
export type RecruitJobPostingSetInput = {
  account_id?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  creation_date?: Maybe<Scalars['date']>;
  creator_id?: Maybe<Scalars['String']>;
  deadline?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  firm?: Maybe<Scalars['String']>;
  job_posting_id?: Maybe<Scalars['String']>;
  job_type?: Maybe<Scalars['String']>;
  modified_date?: Maybe<Scalars['date']>;
  position_title?: Maybe<Scalars['String']>;
  public?: Maybe<Scalars['Boolean']>;
  publishing_date?: Maybe<Scalars['date']>;
  region?: Maybe<Scalars['String']>;
};

/** update columns of table "recruit.job_posting" */
export enum RecruitJobPostingUpdateColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Active = 'active',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Deadline = 'deadline',
  /** column name */
  Description = 'description',
  /** column name */
  Firm = 'firm',
  /** column name */
  JobPostingId = 'job_posting_id',
  /** column name */
  JobType = 'job_type',
  /** column name */
  ModifiedDate = 'modified_date',
  /** column name */
  PositionTitle = 'position_title',
  /** column name */
  Public = 'public',
  /** column name */
  PublishingDate = 'publishing_date',
  /** column name */
  Region = 'region'
}

/** columns and relationships of "recruit.job_requirement" */
export type RecruitJobRequirement = {
  __typename?: 'recruit_job_requirement';
  boolean_value?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  job_posting: RecruitJobPosting;
  job_posting_id: Scalars['String'];
  job_requirement_id: Scalars['String'];
  max_range_value?: Maybe<Scalars['numeric']>;
  min_range_value?: Maybe<Scalars['numeric']>;
  number_value?: Maybe<Scalars['numeric']>;
  requirement_name: Scalars['String'];
  requirement_type: Scalars['String'];
  /** An array relationship */
  values: Array<RecruitJobRequirementValue>;
  /** An aggregated array relationship */
  values_aggregate: RecruitJobRequirementValueAggregate;
};


/** columns and relationships of "recruit.job_requirement" */
export type RecruitJobRequirementValuesArgs = {
  distinct_on?: Maybe<Array<RecruitJobRequirementValueSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitJobRequirementValueOrderBy>>;
  where?: Maybe<RecruitJobRequirementValueBoolExp>;
};


/** columns and relationships of "recruit.job_requirement" */
export type RecruitJobRequirementValuesAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitJobRequirementValueSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitJobRequirementValueOrderBy>>;
  where?: Maybe<RecruitJobRequirementValueBoolExp>;
};

/** aggregated selection of "recruit.job_requirement" */
export type RecruitJobRequirementAggregate = {
  __typename?: 'recruit_job_requirement_aggregate';
  aggregate?: Maybe<RecruitJobRequirementAggregateFields>;
  nodes: Array<RecruitJobRequirement>;
};

/** aggregate fields of "recruit.job_requirement" */
export type RecruitJobRequirementAggregateFields = {
  __typename?: 'recruit_job_requirement_aggregate_fields';
  avg?: Maybe<RecruitJobRequirementAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<RecruitJobRequirementMaxFields>;
  min?: Maybe<RecruitJobRequirementMinFields>;
  stddev?: Maybe<RecruitJobRequirementStddevFields>;
  stddev_pop?: Maybe<RecruitJobRequirementStddevPopFields>;
  stddev_samp?: Maybe<RecruitJobRequirementStddevSampFields>;
  sum?: Maybe<RecruitJobRequirementSumFields>;
  var_pop?: Maybe<RecruitJobRequirementVarPopFields>;
  var_samp?: Maybe<RecruitJobRequirementVarSampFields>;
  variance?: Maybe<RecruitJobRequirementVarianceFields>;
};


/** aggregate fields of "recruit.job_requirement" */
export type RecruitJobRequirementAggregateFieldsCountArgs = {
  columns?: Maybe<Array<RecruitJobRequirementSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recruit.job_requirement" */
export type RecruitJobRequirementAggregateOrderBy = {
  avg?: Maybe<RecruitJobRequirementAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<RecruitJobRequirementMaxOrderBy>;
  min?: Maybe<RecruitJobRequirementMinOrderBy>;
  stddev?: Maybe<RecruitJobRequirementStddevOrderBy>;
  stddev_pop?: Maybe<RecruitJobRequirementStddevPopOrderBy>;
  stddev_samp?: Maybe<RecruitJobRequirementStddevSampOrderBy>;
  sum?: Maybe<RecruitJobRequirementSumOrderBy>;
  var_pop?: Maybe<RecruitJobRequirementVarPopOrderBy>;
  var_samp?: Maybe<RecruitJobRequirementVarSampOrderBy>;
  variance?: Maybe<RecruitJobRequirementVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "recruit.job_requirement" */
export type RecruitJobRequirementArrRelInsertInput = {
  data: Array<RecruitJobRequirementInsertInput>;
  on_conflict?: Maybe<RecruitJobRequirementOnConflict>;
};

/** aggregate avg on columns */
export type RecruitJobRequirementAvgFields = {
  __typename?: 'recruit_job_requirement_avg_fields';
  max_range_value?: Maybe<Scalars['Float']>;
  min_range_value?: Maybe<Scalars['Float']>;
  number_value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "recruit.job_requirement" */
export type RecruitJobRequirementAvgOrderBy = {
  max_range_value?: Maybe<OrderBy>;
  min_range_value?: Maybe<OrderBy>;
  number_value?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "recruit.job_requirement". All fields are combined with a logical 'AND'. */
export type RecruitJobRequirementBoolExp = {
  _and?: Maybe<Array<Maybe<RecruitJobRequirementBoolExp>>>;
  _not?: Maybe<RecruitJobRequirementBoolExp>;
  _or?: Maybe<Array<Maybe<RecruitJobRequirementBoolExp>>>;
  boolean_value?: Maybe<BooleanComparisonExp>;
  job_posting?: Maybe<RecruitJobPostingBoolExp>;
  job_posting_id?: Maybe<StringComparisonExp>;
  job_requirement_id?: Maybe<StringComparisonExp>;
  max_range_value?: Maybe<NumericComparisonExp>;
  min_range_value?: Maybe<NumericComparisonExp>;
  number_value?: Maybe<NumericComparisonExp>;
  requirement_name?: Maybe<StringComparisonExp>;
  requirement_type?: Maybe<StringComparisonExp>;
  values?: Maybe<RecruitJobRequirementValueBoolExp>;
};

/** unique or primary key constraints on table "recruit.job_requirement" */
export enum RecruitJobRequirementConstraint {
  /** unique or primary key constraint */
  JobRequirementPkey = 'job_requirement_pkey'
}

/** input type for incrementing integer column in table "recruit.job_requirement" */
export type RecruitJobRequirementIncInput = {
  max_range_value?: Maybe<Scalars['numeric']>;
  min_range_value?: Maybe<Scalars['numeric']>;
  number_value?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "recruit.job_requirement" */
export type RecruitJobRequirementInsertInput = {
  boolean_value?: Maybe<Scalars['Boolean']>;
  job_posting?: Maybe<RecruitJobPostingObjRelInsertInput>;
  job_posting_id?: Maybe<Scalars['String']>;
  job_requirement_id?: Maybe<Scalars['String']>;
  max_range_value?: Maybe<Scalars['numeric']>;
  min_range_value?: Maybe<Scalars['numeric']>;
  number_value?: Maybe<Scalars['numeric']>;
  requirement_name?: Maybe<Scalars['String']>;
  requirement_type?: Maybe<Scalars['String']>;
  values?: Maybe<RecruitJobRequirementValueArrRelInsertInput>;
};

/** aggregate max on columns */
export type RecruitJobRequirementMaxFields = {
  __typename?: 'recruit_job_requirement_max_fields';
  job_posting_id?: Maybe<Scalars['String']>;
  job_requirement_id?: Maybe<Scalars['String']>;
  max_range_value?: Maybe<Scalars['numeric']>;
  min_range_value?: Maybe<Scalars['numeric']>;
  number_value?: Maybe<Scalars['numeric']>;
  requirement_name?: Maybe<Scalars['String']>;
  requirement_type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "recruit.job_requirement" */
export type RecruitJobRequirementMaxOrderBy = {
  job_posting_id?: Maybe<OrderBy>;
  job_requirement_id?: Maybe<OrderBy>;
  max_range_value?: Maybe<OrderBy>;
  min_range_value?: Maybe<OrderBy>;
  number_value?: Maybe<OrderBy>;
  requirement_name?: Maybe<OrderBy>;
  requirement_type?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type RecruitJobRequirementMinFields = {
  __typename?: 'recruit_job_requirement_min_fields';
  job_posting_id?: Maybe<Scalars['String']>;
  job_requirement_id?: Maybe<Scalars['String']>;
  max_range_value?: Maybe<Scalars['numeric']>;
  min_range_value?: Maybe<Scalars['numeric']>;
  number_value?: Maybe<Scalars['numeric']>;
  requirement_name?: Maybe<Scalars['String']>;
  requirement_type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "recruit.job_requirement" */
export type RecruitJobRequirementMinOrderBy = {
  job_posting_id?: Maybe<OrderBy>;
  job_requirement_id?: Maybe<OrderBy>;
  max_range_value?: Maybe<OrderBy>;
  min_range_value?: Maybe<OrderBy>;
  number_value?: Maybe<OrderBy>;
  requirement_name?: Maybe<OrderBy>;
  requirement_type?: Maybe<OrderBy>;
};

/** response of any mutation on the table "recruit.job_requirement" */
export type RecruitJobRequirementMutationResponse = {
  __typename?: 'recruit_job_requirement_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<RecruitJobRequirement>;
};

/** input type for inserting object relation for remote table "recruit.job_requirement" */
export type RecruitJobRequirementObjRelInsertInput = {
  data: RecruitJobRequirementInsertInput;
  on_conflict?: Maybe<RecruitJobRequirementOnConflict>;
};

/** on conflict condition type for table "recruit.job_requirement" */
export type RecruitJobRequirementOnConflict = {
  constraint: RecruitJobRequirementConstraint;
  update_columns: Array<RecruitJobRequirementUpdateColumn>;
  where?: Maybe<RecruitJobRequirementBoolExp>;
};

/** ordering options when selecting data from "recruit.job_requirement" */
export type RecruitJobRequirementOrderBy = {
  boolean_value?: Maybe<OrderBy>;
  job_posting?: Maybe<RecruitJobPostingOrderBy>;
  job_posting_id?: Maybe<OrderBy>;
  job_requirement_id?: Maybe<OrderBy>;
  max_range_value?: Maybe<OrderBy>;
  min_range_value?: Maybe<OrderBy>;
  number_value?: Maybe<OrderBy>;
  requirement_name?: Maybe<OrderBy>;
  requirement_type?: Maybe<OrderBy>;
  values_aggregate?: Maybe<RecruitJobRequirementValueAggregateOrderBy>;
};

/** primary key columns input for table: "recruit.job_requirement" */
export type RecruitJobRequirementPkColumnsInput = {
  job_requirement_id: Scalars['String'];
};

/** select columns of table "recruit.job_requirement" */
export enum RecruitJobRequirementSelectColumn {
  /** column name */
  BooleanValue = 'boolean_value',
  /** column name */
  JobPostingId = 'job_posting_id',
  /** column name */
  JobRequirementId = 'job_requirement_id',
  /** column name */
  MaxRangeValue = 'max_range_value',
  /** column name */
  MinRangeValue = 'min_range_value',
  /** column name */
  NumberValue = 'number_value',
  /** column name */
  RequirementName = 'requirement_name',
  /** column name */
  RequirementType = 'requirement_type'
}

/** input type for updating data in table "recruit.job_requirement" */
export type RecruitJobRequirementSetInput = {
  boolean_value?: Maybe<Scalars['Boolean']>;
  job_posting_id?: Maybe<Scalars['String']>;
  job_requirement_id?: Maybe<Scalars['String']>;
  max_range_value?: Maybe<Scalars['numeric']>;
  min_range_value?: Maybe<Scalars['numeric']>;
  number_value?: Maybe<Scalars['numeric']>;
  requirement_name?: Maybe<Scalars['String']>;
  requirement_type?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type RecruitJobRequirementStddevFields = {
  __typename?: 'recruit_job_requirement_stddev_fields';
  max_range_value?: Maybe<Scalars['Float']>;
  min_range_value?: Maybe<Scalars['Float']>;
  number_value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "recruit.job_requirement" */
export type RecruitJobRequirementStddevOrderBy = {
  max_range_value?: Maybe<OrderBy>;
  min_range_value?: Maybe<OrderBy>;
  number_value?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type RecruitJobRequirementStddevPopFields = {
  __typename?: 'recruit_job_requirement_stddev_pop_fields';
  max_range_value?: Maybe<Scalars['Float']>;
  min_range_value?: Maybe<Scalars['Float']>;
  number_value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "recruit.job_requirement" */
export type RecruitJobRequirementStddevPopOrderBy = {
  max_range_value?: Maybe<OrderBy>;
  min_range_value?: Maybe<OrderBy>;
  number_value?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type RecruitJobRequirementStddevSampFields = {
  __typename?: 'recruit_job_requirement_stddev_samp_fields';
  max_range_value?: Maybe<Scalars['Float']>;
  min_range_value?: Maybe<Scalars['Float']>;
  number_value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "recruit.job_requirement" */
export type RecruitJobRequirementStddevSampOrderBy = {
  max_range_value?: Maybe<OrderBy>;
  min_range_value?: Maybe<OrderBy>;
  number_value?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type RecruitJobRequirementSumFields = {
  __typename?: 'recruit_job_requirement_sum_fields';
  max_range_value?: Maybe<Scalars['numeric']>;
  min_range_value?: Maybe<Scalars['numeric']>;
  number_value?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "recruit.job_requirement" */
export type RecruitJobRequirementSumOrderBy = {
  max_range_value?: Maybe<OrderBy>;
  min_range_value?: Maybe<OrderBy>;
  number_value?: Maybe<OrderBy>;
};

/** update columns of table "recruit.job_requirement" */
export enum RecruitJobRequirementUpdateColumn {
  /** column name */
  BooleanValue = 'boolean_value',
  /** column name */
  JobPostingId = 'job_posting_id',
  /** column name */
  JobRequirementId = 'job_requirement_id',
  /** column name */
  MaxRangeValue = 'max_range_value',
  /** column name */
  MinRangeValue = 'min_range_value',
  /** column name */
  NumberValue = 'number_value',
  /** column name */
  RequirementName = 'requirement_name',
  /** column name */
  RequirementType = 'requirement_type'
}

/** columns and relationships of "recruit.job_requirement_value" */
export type RecruitJobRequirementValue = {
  __typename?: 'recruit_job_requirement_value';
  /** An object relationship */
  job_requirement: RecruitJobRequirement;
  job_requirement_id: Scalars['String'];
  job_requirement_value_id: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  value_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "recruit.job_requirement_value" */
export type RecruitJobRequirementValueAggregate = {
  __typename?: 'recruit_job_requirement_value_aggregate';
  aggregate?: Maybe<RecruitJobRequirementValueAggregateFields>;
  nodes: Array<RecruitJobRequirementValue>;
};

/** aggregate fields of "recruit.job_requirement_value" */
export type RecruitJobRequirementValueAggregateFields = {
  __typename?: 'recruit_job_requirement_value_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<RecruitJobRequirementValueMaxFields>;
  min?: Maybe<RecruitJobRequirementValueMinFields>;
};


/** aggregate fields of "recruit.job_requirement_value" */
export type RecruitJobRequirementValueAggregateFieldsCountArgs = {
  columns?: Maybe<Array<RecruitJobRequirementValueSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recruit.job_requirement_value" */
export type RecruitJobRequirementValueAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<RecruitJobRequirementValueMaxOrderBy>;
  min?: Maybe<RecruitJobRequirementValueMinOrderBy>;
};

/** input type for inserting array relation for remote table "recruit.job_requirement_value" */
export type RecruitJobRequirementValueArrRelInsertInput = {
  data: Array<RecruitJobRequirementValueInsertInput>;
  on_conflict?: Maybe<RecruitJobRequirementValueOnConflict>;
};

/** Boolean expression to filter rows from the table "recruit.job_requirement_value". All fields are combined with a logical 'AND'. */
export type RecruitJobRequirementValueBoolExp = {
  _and?: Maybe<Array<Maybe<RecruitJobRequirementValueBoolExp>>>;
  _not?: Maybe<RecruitJobRequirementValueBoolExp>;
  _or?: Maybe<Array<Maybe<RecruitJobRequirementValueBoolExp>>>;
  job_requirement?: Maybe<RecruitJobRequirementBoolExp>;
  job_requirement_id?: Maybe<StringComparisonExp>;
  job_requirement_value_id?: Maybe<StringComparisonExp>;
  label?: Maybe<StringComparisonExp>;
  value?: Maybe<StringComparisonExp>;
  value_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "recruit.job_requirement_value" */
export enum RecruitJobRequirementValueConstraint {
  /** unique or primary key constraint */
  JobRequirementValuePkey = 'job_requirement_value_pkey'
}

/** input type for inserting data into table "recruit.job_requirement_value" */
export type RecruitJobRequirementValueInsertInput = {
  job_requirement?: Maybe<RecruitJobRequirementObjRelInsertInput>;
  job_requirement_id?: Maybe<Scalars['String']>;
  job_requirement_value_id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  value_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RecruitJobRequirementValueMaxFields = {
  __typename?: 'recruit_job_requirement_value_max_fields';
  job_requirement_id?: Maybe<Scalars['String']>;
  job_requirement_value_id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  value_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "recruit.job_requirement_value" */
export type RecruitJobRequirementValueMaxOrderBy = {
  job_requirement_id?: Maybe<OrderBy>;
  job_requirement_value_id?: Maybe<OrderBy>;
  label?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
  value_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type RecruitJobRequirementValueMinFields = {
  __typename?: 'recruit_job_requirement_value_min_fields';
  job_requirement_id?: Maybe<Scalars['String']>;
  job_requirement_value_id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  value_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "recruit.job_requirement_value" */
export type RecruitJobRequirementValueMinOrderBy = {
  job_requirement_id?: Maybe<OrderBy>;
  job_requirement_value_id?: Maybe<OrderBy>;
  label?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
  value_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "recruit.job_requirement_value" */
export type RecruitJobRequirementValueMutationResponse = {
  __typename?: 'recruit_job_requirement_value_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<RecruitJobRequirementValue>;
};

/** input type for inserting object relation for remote table "recruit.job_requirement_value" */
export type RecruitJobRequirementValueObjRelInsertInput = {
  data: RecruitJobRequirementValueInsertInput;
  on_conflict?: Maybe<RecruitJobRequirementValueOnConflict>;
};

/** on conflict condition type for table "recruit.job_requirement_value" */
export type RecruitJobRequirementValueOnConflict = {
  constraint: RecruitJobRequirementValueConstraint;
  update_columns: Array<RecruitJobRequirementValueUpdateColumn>;
  where?: Maybe<RecruitJobRequirementValueBoolExp>;
};

/** ordering options when selecting data from "recruit.job_requirement_value" */
export type RecruitJobRequirementValueOrderBy = {
  job_requirement?: Maybe<RecruitJobRequirementOrderBy>;
  job_requirement_id?: Maybe<OrderBy>;
  job_requirement_value_id?: Maybe<OrderBy>;
  label?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
  value_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "recruit.job_requirement_value" */
export type RecruitJobRequirementValuePkColumnsInput = {
  job_requirement_value_id: Scalars['String'];
};

/** select columns of table "recruit.job_requirement_value" */
export enum RecruitJobRequirementValueSelectColumn {
  /** column name */
  JobRequirementId = 'job_requirement_id',
  /** column name */
  JobRequirementValueId = 'job_requirement_value_id',
  /** column name */
  Label = 'label',
  /** column name */
  Value = 'value',
  /** column name */
  ValueId = 'value_id'
}

/** input type for updating data in table "recruit.job_requirement_value" */
export type RecruitJobRequirementValueSetInput = {
  job_requirement_id?: Maybe<Scalars['String']>;
  job_requirement_value_id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  value_id?: Maybe<Scalars['String']>;
};

/** update columns of table "recruit.job_requirement_value" */
export enum RecruitJobRequirementValueUpdateColumn {
  /** column name */
  JobRequirementId = 'job_requirement_id',
  /** column name */
  JobRequirementValueId = 'job_requirement_value_id',
  /** column name */
  Label = 'label',
  /** column name */
  Value = 'value',
  /** column name */
  ValueId = 'value_id'
}

/** aggregate var_pop on columns */
export type RecruitJobRequirementVarPopFields = {
  __typename?: 'recruit_job_requirement_var_pop_fields';
  max_range_value?: Maybe<Scalars['Float']>;
  min_range_value?: Maybe<Scalars['Float']>;
  number_value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "recruit.job_requirement" */
export type RecruitJobRequirementVarPopOrderBy = {
  max_range_value?: Maybe<OrderBy>;
  min_range_value?: Maybe<OrderBy>;
  number_value?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type RecruitJobRequirementVarSampFields = {
  __typename?: 'recruit_job_requirement_var_samp_fields';
  max_range_value?: Maybe<Scalars['Float']>;
  min_range_value?: Maybe<Scalars['Float']>;
  number_value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "recruit.job_requirement" */
export type RecruitJobRequirementVarSampOrderBy = {
  max_range_value?: Maybe<OrderBy>;
  min_range_value?: Maybe<OrderBy>;
  number_value?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type RecruitJobRequirementVarianceFields = {
  __typename?: 'recruit_job_requirement_variance_fields';
  max_range_value?: Maybe<Scalars['Float']>;
  min_range_value?: Maybe<Scalars['Float']>;
  number_value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "recruit.job_requirement" */
export type RecruitJobRequirementVarianceOrderBy = {
  max_range_value?: Maybe<OrderBy>;
  min_range_value?: Maybe<OrderBy>;
  number_value?: Maybe<OrderBy>;
};

/**
 * each row represents a recruiter
 *
 *
 * columns and relationships of "recruit.recruiter"
 */
export type RecruitRecruiter = {
  __typename?: 'recruit_recruiter';
  /** An object relationship */
  account: RecruitAccount;
  /** maps to account.account_id */
  account_id: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  /** full name of the recruiter */
  fullname: Scalars['String'];
  /** An array relationship */
  grad_groups: Array<RecruitGradGroup>;
  /** An aggregated array relationship */
  grad_groups_aggregate: RecruitGradGroupAggregate;
  /** An array relationship */
  sms_messages: Array<RecruitSmsMessage>;
  /** An aggregated array relationship */
  sms_messages_aggregate: RecruitSmsMessageAggregate;
  twilio_phone?: Maybe<Scalars['String']>;
  /** primary key, maps to auth0 sub */
  user_id: Scalars['String'];
};


/**
 * each row represents a recruiter
 *
 *
 * columns and relationships of "recruit.recruiter"
 */
export type RecruitRecruiterGradGroupsArgs = {
  distinct_on?: Maybe<Array<RecruitGradGroupSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitGradGroupOrderBy>>;
  where?: Maybe<RecruitGradGroupBoolExp>;
};


/**
 * each row represents a recruiter
 *
 *
 * columns and relationships of "recruit.recruiter"
 */
export type RecruitRecruiterGradGroupsAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitGradGroupSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitGradGroupOrderBy>>;
  where?: Maybe<RecruitGradGroupBoolExp>;
};


/**
 * each row represents a recruiter
 *
 *
 * columns and relationships of "recruit.recruiter"
 */
export type RecruitRecruiterSmsMessagesArgs = {
  distinct_on?: Maybe<Array<RecruitSmsMessageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsMessageOrderBy>>;
  where?: Maybe<RecruitSmsMessageBoolExp>;
};


/**
 * each row represents a recruiter
 *
 *
 * columns and relationships of "recruit.recruiter"
 */
export type RecruitRecruiterSmsMessagesAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitSmsMessageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsMessageOrderBy>>;
  where?: Maybe<RecruitSmsMessageBoolExp>;
};

/** aggregated selection of "recruit.recruiter" */
export type RecruitRecruiterAggregate = {
  __typename?: 'recruit_recruiter_aggregate';
  aggregate?: Maybe<RecruitRecruiterAggregateFields>;
  nodes: Array<RecruitRecruiter>;
};

/** aggregate fields of "recruit.recruiter" */
export type RecruitRecruiterAggregateFields = {
  __typename?: 'recruit_recruiter_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<RecruitRecruiterMaxFields>;
  min?: Maybe<RecruitRecruiterMinFields>;
};


/** aggregate fields of "recruit.recruiter" */
export type RecruitRecruiterAggregateFieldsCountArgs = {
  columns?: Maybe<Array<RecruitRecruiterSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recruit.recruiter" */
export type RecruitRecruiterAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<RecruitRecruiterMaxOrderBy>;
  min?: Maybe<RecruitRecruiterMinOrderBy>;
};

/** input type for inserting array relation for remote table "recruit.recruiter" */
export type RecruitRecruiterArrRelInsertInput = {
  data: Array<RecruitRecruiterInsertInput>;
  on_conflict?: Maybe<RecruitRecruiterOnConflict>;
};

/** Boolean expression to filter rows from the table "recruit.recruiter". All fields are combined with a logical 'AND'. */
export type RecruitRecruiterBoolExp = {
  _and?: Maybe<Array<Maybe<RecruitRecruiterBoolExp>>>;
  _not?: Maybe<RecruitRecruiterBoolExp>;
  _or?: Maybe<Array<Maybe<RecruitRecruiterBoolExp>>>;
  account?: Maybe<RecruitAccountBoolExp>;
  account_id?: Maybe<StringComparisonExp>;
  email?: Maybe<StringComparisonExp>;
  fullname?: Maybe<StringComparisonExp>;
  grad_groups?: Maybe<RecruitGradGroupBoolExp>;
  sms_messages?: Maybe<RecruitSmsMessageBoolExp>;
  twilio_phone?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "recruit.recruiter" */
export enum RecruitRecruiterConstraint {
  /** unique or primary key constraint */
  RecruiterAccountIdUserIdKey = 'recruiter_account_id_user_id_key',
  /** unique or primary key constraint */
  RecruiterPkey = 'recruiter_pkey',
  /** unique or primary key constraint */
  RecruiterUseridKey = 'recruiter_userid_key'
}

/** input type for inserting data into table "recruit.recruiter" */
export type RecruitRecruiterInsertInput = {
  account?: Maybe<RecruitAccountObjRelInsertInput>;
  account_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  grad_groups?: Maybe<RecruitGradGroupArrRelInsertInput>;
  sms_messages?: Maybe<RecruitSmsMessageArrRelInsertInput>;
  twilio_phone?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RecruitRecruiterMaxFields = {
  __typename?: 'recruit_recruiter_max_fields';
  account_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  twilio_phone?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "recruit.recruiter" */
export type RecruitRecruiterMaxOrderBy = {
  account_id?: Maybe<OrderBy>;
  email?: Maybe<OrderBy>;
  fullname?: Maybe<OrderBy>;
  twilio_phone?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type RecruitRecruiterMinFields = {
  __typename?: 'recruit_recruiter_min_fields';
  account_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  twilio_phone?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "recruit.recruiter" */
export type RecruitRecruiterMinOrderBy = {
  account_id?: Maybe<OrderBy>;
  email?: Maybe<OrderBy>;
  fullname?: Maybe<OrderBy>;
  twilio_phone?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "recruit.recruiter" */
export type RecruitRecruiterMutationResponse = {
  __typename?: 'recruit_recruiter_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<RecruitRecruiter>;
};

/** input type for inserting object relation for remote table "recruit.recruiter" */
export type RecruitRecruiterObjRelInsertInput = {
  data: RecruitRecruiterInsertInput;
  on_conflict?: Maybe<RecruitRecruiterOnConflict>;
};

/** on conflict condition type for table "recruit.recruiter" */
export type RecruitRecruiterOnConflict = {
  constraint: RecruitRecruiterConstraint;
  update_columns: Array<RecruitRecruiterUpdateColumn>;
  where?: Maybe<RecruitRecruiterBoolExp>;
};

/** ordering options when selecting data from "recruit.recruiter" */
export type RecruitRecruiterOrderBy = {
  account?: Maybe<RecruitAccountOrderBy>;
  account_id?: Maybe<OrderBy>;
  email?: Maybe<OrderBy>;
  fullname?: Maybe<OrderBy>;
  grad_groups_aggregate?: Maybe<RecruitGradGroupAggregateOrderBy>;
  sms_messages_aggregate?: Maybe<RecruitSmsMessageAggregateOrderBy>;
  twilio_phone?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "recruit.recruiter" */
export type RecruitRecruiterPkColumnsInput = {
  /** primary key, maps to auth0 sub */
  user_id: Scalars['String'];
};

/** select columns of table "recruit.recruiter" */
export enum RecruitRecruiterSelectColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Email = 'email',
  /** column name */
  Fullname = 'fullname',
  /** column name */
  TwilioPhone = 'twilio_phone',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "recruit.recruiter" */
export type RecruitRecruiterSetInput = {
  account_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  twilio_phone?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "recruit.recruiter" */
export enum RecruitRecruiterUpdateColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Email = 'email',
  /** column name */
  Fullname = 'fullname',
  /** column name */
  TwilioPhone = 'twilio_phone',
  /** column name */
  UserId = 'user_id'
}

/**
 * stores saved searches
 *
 *
 * columns and relationships of "recruit.saved_search"
 */
export type RecruitSavedSearch = {
  __typename?: 'recruit_saved_search';
  /** name of the saved search */
  name: Scalars['String'];
  /** free form json to store saved search parameters */
  parameters_json: Scalars['jsonb'];
  /** auto-generated uuid */
  saved_search_id: Scalars['String'];
  /** maps to recruiter.user_id */
  user_id: Scalars['String'];
};


/**
 * stores saved searches
 *
 *
 * columns and relationships of "recruit.saved_search"
 */
export type RecruitSavedSearchParametersJsonArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "recruit.saved_search" */
export type RecruitSavedSearchAggregate = {
  __typename?: 'recruit_saved_search_aggregate';
  aggregate?: Maybe<RecruitSavedSearchAggregateFields>;
  nodes: Array<RecruitSavedSearch>;
};

/** aggregate fields of "recruit.saved_search" */
export type RecruitSavedSearchAggregateFields = {
  __typename?: 'recruit_saved_search_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<RecruitSavedSearchMaxFields>;
  min?: Maybe<RecruitSavedSearchMinFields>;
};


/** aggregate fields of "recruit.saved_search" */
export type RecruitSavedSearchAggregateFieldsCountArgs = {
  columns?: Maybe<Array<RecruitSavedSearchSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recruit.saved_search" */
export type RecruitSavedSearchAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<RecruitSavedSearchMaxOrderBy>;
  min?: Maybe<RecruitSavedSearchMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RecruitSavedSearchAppendInput = {
  parameters_json?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "recruit.saved_search" */
export type RecruitSavedSearchArrRelInsertInput = {
  data: Array<RecruitSavedSearchInsertInput>;
  on_conflict?: Maybe<RecruitSavedSearchOnConflict>;
};

/** Boolean expression to filter rows from the table "recruit.saved_search". All fields are combined with a logical 'AND'. */
export type RecruitSavedSearchBoolExp = {
  _and?: Maybe<Array<Maybe<RecruitSavedSearchBoolExp>>>;
  _not?: Maybe<RecruitSavedSearchBoolExp>;
  _or?: Maybe<Array<Maybe<RecruitSavedSearchBoolExp>>>;
  name?: Maybe<StringComparisonExp>;
  parameters_json?: Maybe<JsonbComparisonExp>;
  saved_search_id?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "recruit.saved_search" */
export enum RecruitSavedSearchConstraint {
  /** unique or primary key constraint */
  SavedSearchPkey = 'saved_search_pkey',
  /** unique or primary key constraint */
  SavedSearchSavedSearchIdKey = 'saved_search_saved_search_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RecruitSavedSearchDeleteAtPathInput = {
  parameters_json?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RecruitSavedSearchDeleteElemInput = {
  parameters_json?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RecruitSavedSearchDeleteKeyInput = {
  parameters_json?: Maybe<Scalars['String']>;
};

/** input type for inserting data into table "recruit.saved_search" */
export type RecruitSavedSearchInsertInput = {
  name?: Maybe<Scalars['String']>;
  parameters_json?: Maybe<Scalars['jsonb']>;
  saved_search_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RecruitSavedSearchMaxFields = {
  __typename?: 'recruit_saved_search_max_fields';
  name?: Maybe<Scalars['String']>;
  saved_search_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "recruit.saved_search" */
export type RecruitSavedSearchMaxOrderBy = {
  name?: Maybe<OrderBy>;
  saved_search_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type RecruitSavedSearchMinFields = {
  __typename?: 'recruit_saved_search_min_fields';
  name?: Maybe<Scalars['String']>;
  saved_search_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "recruit.saved_search" */
export type RecruitSavedSearchMinOrderBy = {
  name?: Maybe<OrderBy>;
  saved_search_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "recruit.saved_search" */
export type RecruitSavedSearchMutationResponse = {
  __typename?: 'recruit_saved_search_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<RecruitSavedSearch>;
};

/** input type for inserting object relation for remote table "recruit.saved_search" */
export type RecruitSavedSearchObjRelInsertInput = {
  data: RecruitSavedSearchInsertInput;
  on_conflict?: Maybe<RecruitSavedSearchOnConflict>;
};

/** on conflict condition type for table "recruit.saved_search" */
export type RecruitSavedSearchOnConflict = {
  constraint: RecruitSavedSearchConstraint;
  update_columns: Array<RecruitSavedSearchUpdateColumn>;
  where?: Maybe<RecruitSavedSearchBoolExp>;
};

/** ordering options when selecting data from "recruit.saved_search" */
export type RecruitSavedSearchOrderBy = {
  name?: Maybe<OrderBy>;
  parameters_json?: Maybe<OrderBy>;
  saved_search_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "recruit.saved_search" */
export type RecruitSavedSearchPkColumnsInput = {
  /** auto-generated uuid */
  saved_search_id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RecruitSavedSearchPrependInput = {
  parameters_json?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "recruit.saved_search" */
export enum RecruitSavedSearchSelectColumn {
  /** column name */
  Name = 'name',
  /** column name */
  ParametersJson = 'parameters_json',
  /** column name */
  SavedSearchId = 'saved_search_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "recruit.saved_search" */
export type RecruitSavedSearchSetInput = {
  name?: Maybe<Scalars['String']>;
  parameters_json?: Maybe<Scalars['jsonb']>;
  saved_search_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** update columns of table "recruit.saved_search" */
export enum RecruitSavedSearchUpdateColumn {
  /** column name */
  Name = 'name',
  /** column name */
  ParametersJson = 'parameters_json',
  /** column name */
  SavedSearchId = 'saved_search_id',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "recruit.sms_correspondent" */
export type RecruitSmsCorrespondent = {
  __typename?: 'recruit_sms_correspondent';
  archived: Scalars['Boolean'];
  blocked: Scalars['Boolean'];
  blocked_reason?: Maybe<Scalars['String']>;
  conversation_ended: Scalars['Boolean'];
  correspondent_user_id: Scalars['String'];
  /** An object relationship */
  grad_profile: GradProfile;
  has_unread_message: Scalars['Boolean'];
  last_incoming_timestamp?: Maybe<Scalars['timestamptz']>;
  last_message_timestamp?: Maybe<Scalars['timestamptz']>;
  last_outgoing_timestamp?: Maybe<Scalars['timestamptz']>;
  last_read_timestamp?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  message_correspondents: Array<RecruitSmsMessageCorrespondent>;
  /** An aggregated array relationship */
  message_correspondents_aggregate: RecruitSmsMessageCorrespondentAggregate;
  recruiter_user_id: Scalars['String'];
  sms_correspondent_id: Scalars['Int'];
};


/** columns and relationships of "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentMessageCorrespondentsArgs = {
  distinct_on?: Maybe<Array<RecruitSmsMessageCorrespondentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsMessageCorrespondentOrderBy>>;
  where?: Maybe<RecruitSmsMessageCorrespondentBoolExp>;
};


/** columns and relationships of "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentMessageCorrespondentsAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitSmsMessageCorrespondentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsMessageCorrespondentOrderBy>>;
  where?: Maybe<RecruitSmsMessageCorrespondentBoolExp>;
};

/** aggregated selection of "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentAggregate = {
  __typename?: 'recruit_sms_correspondent_aggregate';
  aggregate?: Maybe<RecruitSmsCorrespondentAggregateFields>;
  nodes: Array<RecruitSmsCorrespondent>;
};

/** aggregate fields of "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentAggregateFields = {
  __typename?: 'recruit_sms_correspondent_aggregate_fields';
  avg?: Maybe<RecruitSmsCorrespondentAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<RecruitSmsCorrespondentMaxFields>;
  min?: Maybe<RecruitSmsCorrespondentMinFields>;
  stddev?: Maybe<RecruitSmsCorrespondentStddevFields>;
  stddev_pop?: Maybe<RecruitSmsCorrespondentStddevPopFields>;
  stddev_samp?: Maybe<RecruitSmsCorrespondentStddevSampFields>;
  sum?: Maybe<RecruitSmsCorrespondentSumFields>;
  var_pop?: Maybe<RecruitSmsCorrespondentVarPopFields>;
  var_samp?: Maybe<RecruitSmsCorrespondentVarSampFields>;
  variance?: Maybe<RecruitSmsCorrespondentVarianceFields>;
};


/** aggregate fields of "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentAggregateFieldsCountArgs = {
  columns?: Maybe<Array<RecruitSmsCorrespondentSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentAggregateOrderBy = {
  avg?: Maybe<RecruitSmsCorrespondentAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<RecruitSmsCorrespondentMaxOrderBy>;
  min?: Maybe<RecruitSmsCorrespondentMinOrderBy>;
  stddev?: Maybe<RecruitSmsCorrespondentStddevOrderBy>;
  stddev_pop?: Maybe<RecruitSmsCorrespondentStddevPopOrderBy>;
  stddev_samp?: Maybe<RecruitSmsCorrespondentStddevSampOrderBy>;
  sum?: Maybe<RecruitSmsCorrespondentSumOrderBy>;
  var_pop?: Maybe<RecruitSmsCorrespondentVarPopOrderBy>;
  var_samp?: Maybe<RecruitSmsCorrespondentVarSampOrderBy>;
  variance?: Maybe<RecruitSmsCorrespondentVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentArrRelInsertInput = {
  data: Array<RecruitSmsCorrespondentInsertInput>;
  on_conflict?: Maybe<RecruitSmsCorrespondentOnConflict>;
};

/** aggregate avg on columns */
export type RecruitSmsCorrespondentAvgFields = {
  __typename?: 'recruit_sms_correspondent_avg_fields';
  sms_correspondent_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentAvgOrderBy = {
  sms_correspondent_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "recruit.sms_correspondent". All fields are combined with a logical 'AND'. */
export type RecruitSmsCorrespondentBoolExp = {
  _and?: Maybe<Array<Maybe<RecruitSmsCorrespondentBoolExp>>>;
  _not?: Maybe<RecruitSmsCorrespondentBoolExp>;
  _or?: Maybe<Array<Maybe<RecruitSmsCorrespondentBoolExp>>>;
  archived?: Maybe<BooleanComparisonExp>;
  blocked?: Maybe<BooleanComparisonExp>;
  blocked_reason?: Maybe<StringComparisonExp>;
  conversation_ended?: Maybe<BooleanComparisonExp>;
  correspondent_user_id?: Maybe<StringComparisonExp>;
  grad_profile?: Maybe<GradProfileBoolExp>;
  has_unread_message?: Maybe<BooleanComparisonExp>;
  last_incoming_timestamp?: Maybe<TimestamptzComparisonExp>;
  last_message_timestamp?: Maybe<TimestamptzComparisonExp>;
  last_outgoing_timestamp?: Maybe<TimestamptzComparisonExp>;
  last_read_timestamp?: Maybe<TimestamptzComparisonExp>;
  message_correspondents?: Maybe<RecruitSmsMessageCorrespondentBoolExp>;
  recruiter_user_id?: Maybe<StringComparisonExp>;
  sms_correspondent_id?: Maybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "recruit.sms_correspondent" */
export enum RecruitSmsCorrespondentConstraint {
  /** unique or primary key constraint */
  SmsCorrespondentPkey = 'sms_correspondent_pkey',
  /** unique or primary key constraint */
  SmsCorrespondentRecruiterUserIdCorrespondentUserIdKey = 'sms_correspondent_recruiter_user_id_correspondent_user_id_key'
}

/** input type for incrementing integer column in table "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentIncInput = {
  sms_correspondent_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentInsertInput = {
  archived?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  blocked_reason?: Maybe<Scalars['String']>;
  conversation_ended?: Maybe<Scalars['Boolean']>;
  correspondent_user_id?: Maybe<Scalars['String']>;
  grad_profile?: Maybe<GradProfileObjRelInsertInput>;
  has_unread_message?: Maybe<Scalars['Boolean']>;
  last_incoming_timestamp?: Maybe<Scalars['timestamptz']>;
  last_message_timestamp?: Maybe<Scalars['timestamptz']>;
  last_outgoing_timestamp?: Maybe<Scalars['timestamptz']>;
  last_read_timestamp?: Maybe<Scalars['timestamptz']>;
  message_correspondents?: Maybe<RecruitSmsMessageCorrespondentArrRelInsertInput>;
  recruiter_user_id?: Maybe<Scalars['String']>;
  sms_correspondent_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type RecruitSmsCorrespondentMaxFields = {
  __typename?: 'recruit_sms_correspondent_max_fields';
  blocked_reason?: Maybe<Scalars['String']>;
  correspondent_user_id?: Maybe<Scalars['String']>;
  last_incoming_timestamp?: Maybe<Scalars['timestamptz']>;
  last_message_timestamp?: Maybe<Scalars['timestamptz']>;
  last_outgoing_timestamp?: Maybe<Scalars['timestamptz']>;
  last_read_timestamp?: Maybe<Scalars['timestamptz']>;
  recruiter_user_id?: Maybe<Scalars['String']>;
  sms_correspondent_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentMaxOrderBy = {
  blocked_reason?: Maybe<OrderBy>;
  correspondent_user_id?: Maybe<OrderBy>;
  last_incoming_timestamp?: Maybe<OrderBy>;
  last_message_timestamp?: Maybe<OrderBy>;
  last_outgoing_timestamp?: Maybe<OrderBy>;
  last_read_timestamp?: Maybe<OrderBy>;
  recruiter_user_id?: Maybe<OrderBy>;
  sms_correspondent_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type RecruitSmsCorrespondentMinFields = {
  __typename?: 'recruit_sms_correspondent_min_fields';
  blocked_reason?: Maybe<Scalars['String']>;
  correspondent_user_id?: Maybe<Scalars['String']>;
  last_incoming_timestamp?: Maybe<Scalars['timestamptz']>;
  last_message_timestamp?: Maybe<Scalars['timestamptz']>;
  last_outgoing_timestamp?: Maybe<Scalars['timestamptz']>;
  last_read_timestamp?: Maybe<Scalars['timestamptz']>;
  recruiter_user_id?: Maybe<Scalars['String']>;
  sms_correspondent_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentMinOrderBy = {
  blocked_reason?: Maybe<OrderBy>;
  correspondent_user_id?: Maybe<OrderBy>;
  last_incoming_timestamp?: Maybe<OrderBy>;
  last_message_timestamp?: Maybe<OrderBy>;
  last_outgoing_timestamp?: Maybe<OrderBy>;
  last_read_timestamp?: Maybe<OrderBy>;
  recruiter_user_id?: Maybe<OrderBy>;
  sms_correspondent_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentMutationResponse = {
  __typename?: 'recruit_sms_correspondent_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<RecruitSmsCorrespondent>;
};

/** input type for inserting object relation for remote table "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentObjRelInsertInput = {
  data: RecruitSmsCorrespondentInsertInput;
  on_conflict?: Maybe<RecruitSmsCorrespondentOnConflict>;
};

/** on conflict condition type for table "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentOnConflict = {
  constraint: RecruitSmsCorrespondentConstraint;
  update_columns: Array<RecruitSmsCorrespondentUpdateColumn>;
  where?: Maybe<RecruitSmsCorrespondentBoolExp>;
};

/** ordering options when selecting data from "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentOrderBy = {
  archived?: Maybe<OrderBy>;
  blocked?: Maybe<OrderBy>;
  blocked_reason?: Maybe<OrderBy>;
  conversation_ended?: Maybe<OrderBy>;
  correspondent_user_id?: Maybe<OrderBy>;
  grad_profile?: Maybe<GradProfileOrderBy>;
  has_unread_message?: Maybe<OrderBy>;
  last_incoming_timestamp?: Maybe<OrderBy>;
  last_message_timestamp?: Maybe<OrderBy>;
  last_outgoing_timestamp?: Maybe<OrderBy>;
  last_read_timestamp?: Maybe<OrderBy>;
  message_correspondents_aggregate?: Maybe<RecruitSmsMessageCorrespondentAggregateOrderBy>;
  recruiter_user_id?: Maybe<OrderBy>;
  sms_correspondent_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentPkColumnsInput = {
  sms_correspondent_id: Scalars['Int'];
};

/** select columns of table "recruit.sms_correspondent" */
export enum RecruitSmsCorrespondentSelectColumn {
  /** column name */
  Archived = 'archived',
  /** column name */
  Blocked = 'blocked',
  /** column name */
  BlockedReason = 'blocked_reason',
  /** column name */
  ConversationEnded = 'conversation_ended',
  /** column name */
  CorrespondentUserId = 'correspondent_user_id',
  /** column name */
  HasUnreadMessage = 'has_unread_message',
  /** column name */
  LastIncomingTimestamp = 'last_incoming_timestamp',
  /** column name */
  LastMessageTimestamp = 'last_message_timestamp',
  /** column name */
  LastOutgoingTimestamp = 'last_outgoing_timestamp',
  /** column name */
  LastReadTimestamp = 'last_read_timestamp',
  /** column name */
  RecruiterUserId = 'recruiter_user_id',
  /** column name */
  SmsCorrespondentId = 'sms_correspondent_id'
}

/** input type for updating data in table "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentSetInput = {
  archived?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  blocked_reason?: Maybe<Scalars['String']>;
  conversation_ended?: Maybe<Scalars['Boolean']>;
  correspondent_user_id?: Maybe<Scalars['String']>;
  has_unread_message?: Maybe<Scalars['Boolean']>;
  last_incoming_timestamp?: Maybe<Scalars['timestamptz']>;
  last_message_timestamp?: Maybe<Scalars['timestamptz']>;
  last_outgoing_timestamp?: Maybe<Scalars['timestamptz']>;
  last_read_timestamp?: Maybe<Scalars['timestamptz']>;
  recruiter_user_id?: Maybe<Scalars['String']>;
  sms_correspondent_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type RecruitSmsCorrespondentStddevFields = {
  __typename?: 'recruit_sms_correspondent_stddev_fields';
  sms_correspondent_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentStddevOrderBy = {
  sms_correspondent_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type RecruitSmsCorrespondentStddevPopFields = {
  __typename?: 'recruit_sms_correspondent_stddev_pop_fields';
  sms_correspondent_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentStddevPopOrderBy = {
  sms_correspondent_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type RecruitSmsCorrespondentStddevSampFields = {
  __typename?: 'recruit_sms_correspondent_stddev_samp_fields';
  sms_correspondent_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentStddevSampOrderBy = {
  sms_correspondent_id?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type RecruitSmsCorrespondentSumFields = {
  __typename?: 'recruit_sms_correspondent_sum_fields';
  sms_correspondent_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentSumOrderBy = {
  sms_correspondent_id?: Maybe<OrderBy>;
};

/** update columns of table "recruit.sms_correspondent" */
export enum RecruitSmsCorrespondentUpdateColumn {
  /** column name */
  Archived = 'archived',
  /** column name */
  Blocked = 'blocked',
  /** column name */
  BlockedReason = 'blocked_reason',
  /** column name */
  ConversationEnded = 'conversation_ended',
  /** column name */
  CorrespondentUserId = 'correspondent_user_id',
  /** column name */
  HasUnreadMessage = 'has_unread_message',
  /** column name */
  LastIncomingTimestamp = 'last_incoming_timestamp',
  /** column name */
  LastMessageTimestamp = 'last_message_timestamp',
  /** column name */
  LastOutgoingTimestamp = 'last_outgoing_timestamp',
  /** column name */
  LastReadTimestamp = 'last_read_timestamp',
  /** column name */
  RecruiterUserId = 'recruiter_user_id',
  /** column name */
  SmsCorrespondentId = 'sms_correspondent_id'
}

/** aggregate var_pop on columns */
export type RecruitSmsCorrespondentVarPopFields = {
  __typename?: 'recruit_sms_correspondent_var_pop_fields';
  sms_correspondent_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentVarPopOrderBy = {
  sms_correspondent_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type RecruitSmsCorrespondentVarSampFields = {
  __typename?: 'recruit_sms_correspondent_var_samp_fields';
  sms_correspondent_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentVarSampOrderBy = {
  sms_correspondent_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type RecruitSmsCorrespondentVarianceFields = {
  __typename?: 'recruit_sms_correspondent_variance_fields';
  sms_correspondent_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "recruit.sms_correspondent" */
export type RecruitSmsCorrespondentVarianceOrderBy = {
  sms_correspondent_id?: Maybe<OrderBy>;
};

/** columns and relationships of "recruit.sms_message" */
export type RecruitSmsMessage = {
  __typename?: 'recruit_sms_message';
  /** An object relationship */
  adminuser?: Maybe<AdminAdminuser>;
  content: Scalars['String'];
  /** An array relationship */
  correspondents: Array<RecruitSmsMessageCorrespondent>;
  /** An aggregated array relationship */
  correspondents_aggregate: RecruitSmsMessageCorrespondentAggregate;
  incoming: Scalars['Boolean'];
  /** An object relationship */
  recruiter?: Maybe<RecruitRecruiter>;
  recruiter_user_id: Scalars['String'];
  sms_message_id: Scalars['Int'];
  timestamp: Scalars['timestamptz'];
};


/** columns and relationships of "recruit.sms_message" */
export type RecruitSmsMessageCorrespondentsArgs = {
  distinct_on?: Maybe<Array<RecruitSmsMessageCorrespondentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsMessageCorrespondentOrderBy>>;
  where?: Maybe<RecruitSmsMessageCorrespondentBoolExp>;
};


/** columns and relationships of "recruit.sms_message" */
export type RecruitSmsMessageCorrespondentsAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitSmsMessageCorrespondentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsMessageCorrespondentOrderBy>>;
  where?: Maybe<RecruitSmsMessageCorrespondentBoolExp>;
};

/** aggregated selection of "recruit.sms_message" */
export type RecruitSmsMessageAggregate = {
  __typename?: 'recruit_sms_message_aggregate';
  aggregate?: Maybe<RecruitSmsMessageAggregateFields>;
  nodes: Array<RecruitSmsMessage>;
};

/** aggregate fields of "recruit.sms_message" */
export type RecruitSmsMessageAggregateFields = {
  __typename?: 'recruit_sms_message_aggregate_fields';
  avg?: Maybe<RecruitSmsMessageAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<RecruitSmsMessageMaxFields>;
  min?: Maybe<RecruitSmsMessageMinFields>;
  stddev?: Maybe<RecruitSmsMessageStddevFields>;
  stddev_pop?: Maybe<RecruitSmsMessageStddevPopFields>;
  stddev_samp?: Maybe<RecruitSmsMessageStddevSampFields>;
  sum?: Maybe<RecruitSmsMessageSumFields>;
  var_pop?: Maybe<RecruitSmsMessageVarPopFields>;
  var_samp?: Maybe<RecruitSmsMessageVarSampFields>;
  variance?: Maybe<RecruitSmsMessageVarianceFields>;
};


/** aggregate fields of "recruit.sms_message" */
export type RecruitSmsMessageAggregateFieldsCountArgs = {
  columns?: Maybe<Array<RecruitSmsMessageSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recruit.sms_message" */
export type RecruitSmsMessageAggregateOrderBy = {
  avg?: Maybe<RecruitSmsMessageAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<RecruitSmsMessageMaxOrderBy>;
  min?: Maybe<RecruitSmsMessageMinOrderBy>;
  stddev?: Maybe<RecruitSmsMessageStddevOrderBy>;
  stddev_pop?: Maybe<RecruitSmsMessageStddevPopOrderBy>;
  stddev_samp?: Maybe<RecruitSmsMessageStddevSampOrderBy>;
  sum?: Maybe<RecruitSmsMessageSumOrderBy>;
  var_pop?: Maybe<RecruitSmsMessageVarPopOrderBy>;
  var_samp?: Maybe<RecruitSmsMessageVarSampOrderBy>;
  variance?: Maybe<RecruitSmsMessageVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "recruit.sms_message" */
export type RecruitSmsMessageArrRelInsertInput = {
  data: Array<RecruitSmsMessageInsertInput>;
  on_conflict?: Maybe<RecruitSmsMessageOnConflict>;
};

/** aggregate avg on columns */
export type RecruitSmsMessageAvgFields = {
  __typename?: 'recruit_sms_message_avg_fields';
  sms_message_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "recruit.sms_message" */
export type RecruitSmsMessageAvgOrderBy = {
  sms_message_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "recruit.sms_message". All fields are combined with a logical 'AND'. */
export type RecruitSmsMessageBoolExp = {
  _and?: Maybe<Array<Maybe<RecruitSmsMessageBoolExp>>>;
  _not?: Maybe<RecruitSmsMessageBoolExp>;
  _or?: Maybe<Array<Maybe<RecruitSmsMessageBoolExp>>>;
  adminuser?: Maybe<AdminAdminuserBoolExp>;
  content?: Maybe<StringComparisonExp>;
  correspondents?: Maybe<RecruitSmsMessageCorrespondentBoolExp>;
  incoming?: Maybe<BooleanComparisonExp>;
  recruiter?: Maybe<RecruitRecruiterBoolExp>;
  recruiter_user_id?: Maybe<StringComparisonExp>;
  sms_message_id?: Maybe<IntComparisonExp>;
  timestamp?: Maybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "recruit.sms_message" */
export enum RecruitSmsMessageConstraint {
  /** unique or primary key constraint */
  SmsMessagePkey = 'sms_message_pkey'
}

/** columns and relationships of "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondent = {
  __typename?: 'recruit_sms_message_correspondent';
  correspondent_user_id: Scalars['String'];
  error_message?: Maybe<Scalars['String']>;
  /** An object relationship */
  grad: GradProfile;
  /** An object relationship */
  message: RecruitSmsMessage;
  sms_message_correspondent_id: Scalars['Int'];
  sms_message_id: Scalars['Int'];
};

/** aggregated selection of "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentAggregate = {
  __typename?: 'recruit_sms_message_correspondent_aggregate';
  aggregate?: Maybe<RecruitSmsMessageCorrespondentAggregateFields>;
  nodes: Array<RecruitSmsMessageCorrespondent>;
};

/** aggregate fields of "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentAggregateFields = {
  __typename?: 'recruit_sms_message_correspondent_aggregate_fields';
  avg?: Maybe<RecruitSmsMessageCorrespondentAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<RecruitSmsMessageCorrespondentMaxFields>;
  min?: Maybe<RecruitSmsMessageCorrespondentMinFields>;
  stddev?: Maybe<RecruitSmsMessageCorrespondentStddevFields>;
  stddev_pop?: Maybe<RecruitSmsMessageCorrespondentStddevPopFields>;
  stddev_samp?: Maybe<RecruitSmsMessageCorrespondentStddevSampFields>;
  sum?: Maybe<RecruitSmsMessageCorrespondentSumFields>;
  var_pop?: Maybe<RecruitSmsMessageCorrespondentVarPopFields>;
  var_samp?: Maybe<RecruitSmsMessageCorrespondentVarSampFields>;
  variance?: Maybe<RecruitSmsMessageCorrespondentVarianceFields>;
};


/** aggregate fields of "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentAggregateFieldsCountArgs = {
  columns?: Maybe<Array<RecruitSmsMessageCorrespondentSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentAggregateOrderBy = {
  avg?: Maybe<RecruitSmsMessageCorrespondentAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<RecruitSmsMessageCorrespondentMaxOrderBy>;
  min?: Maybe<RecruitSmsMessageCorrespondentMinOrderBy>;
  stddev?: Maybe<RecruitSmsMessageCorrespondentStddevOrderBy>;
  stddev_pop?: Maybe<RecruitSmsMessageCorrespondentStddevPopOrderBy>;
  stddev_samp?: Maybe<RecruitSmsMessageCorrespondentStddevSampOrderBy>;
  sum?: Maybe<RecruitSmsMessageCorrespondentSumOrderBy>;
  var_pop?: Maybe<RecruitSmsMessageCorrespondentVarPopOrderBy>;
  var_samp?: Maybe<RecruitSmsMessageCorrespondentVarSampOrderBy>;
  variance?: Maybe<RecruitSmsMessageCorrespondentVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentArrRelInsertInput = {
  data: Array<RecruitSmsMessageCorrespondentInsertInput>;
  on_conflict?: Maybe<RecruitSmsMessageCorrespondentOnConflict>;
};

/** aggregate avg on columns */
export type RecruitSmsMessageCorrespondentAvgFields = {
  __typename?: 'recruit_sms_message_correspondent_avg_fields';
  sms_message_correspondent_id?: Maybe<Scalars['Float']>;
  sms_message_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentAvgOrderBy = {
  sms_message_correspondent_id?: Maybe<OrderBy>;
  sms_message_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "recruit.sms_message_correspondent". All fields are combined with a logical 'AND'. */
export type RecruitSmsMessageCorrespondentBoolExp = {
  _and?: Maybe<Array<Maybe<RecruitSmsMessageCorrespondentBoolExp>>>;
  _not?: Maybe<RecruitSmsMessageCorrespondentBoolExp>;
  _or?: Maybe<Array<Maybe<RecruitSmsMessageCorrespondentBoolExp>>>;
  correspondent_user_id?: Maybe<StringComparisonExp>;
  error_message?: Maybe<StringComparisonExp>;
  grad?: Maybe<GradProfileBoolExp>;
  message?: Maybe<RecruitSmsMessageBoolExp>;
  sms_message_correspondent_id?: Maybe<IntComparisonExp>;
  sms_message_id?: Maybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "recruit.sms_message_correspondent" */
export enum RecruitSmsMessageCorrespondentConstraint {
  /** unique or primary key constraint */
  SmsMessageCorrespondentPkey = 'sms_message_correspondent_pkey'
}

/** input type for incrementing integer column in table "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentIncInput = {
  sms_message_correspondent_id?: Maybe<Scalars['Int']>;
  sms_message_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentInsertInput = {
  correspondent_user_id?: Maybe<Scalars['String']>;
  error_message?: Maybe<Scalars['String']>;
  grad?: Maybe<GradProfileObjRelInsertInput>;
  message?: Maybe<RecruitSmsMessageObjRelInsertInput>;
  sms_message_correspondent_id?: Maybe<Scalars['Int']>;
  sms_message_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type RecruitSmsMessageCorrespondentMaxFields = {
  __typename?: 'recruit_sms_message_correspondent_max_fields';
  correspondent_user_id?: Maybe<Scalars['String']>;
  error_message?: Maybe<Scalars['String']>;
  sms_message_correspondent_id?: Maybe<Scalars['Int']>;
  sms_message_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentMaxOrderBy = {
  correspondent_user_id?: Maybe<OrderBy>;
  error_message?: Maybe<OrderBy>;
  sms_message_correspondent_id?: Maybe<OrderBy>;
  sms_message_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type RecruitSmsMessageCorrespondentMinFields = {
  __typename?: 'recruit_sms_message_correspondent_min_fields';
  correspondent_user_id?: Maybe<Scalars['String']>;
  error_message?: Maybe<Scalars['String']>;
  sms_message_correspondent_id?: Maybe<Scalars['Int']>;
  sms_message_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentMinOrderBy = {
  correspondent_user_id?: Maybe<OrderBy>;
  error_message?: Maybe<OrderBy>;
  sms_message_correspondent_id?: Maybe<OrderBy>;
  sms_message_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentMutationResponse = {
  __typename?: 'recruit_sms_message_correspondent_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<RecruitSmsMessageCorrespondent>;
};

/** input type for inserting object relation for remote table "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentObjRelInsertInput = {
  data: RecruitSmsMessageCorrespondentInsertInput;
  on_conflict?: Maybe<RecruitSmsMessageCorrespondentOnConflict>;
};

/** on conflict condition type for table "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentOnConflict = {
  constraint: RecruitSmsMessageCorrespondentConstraint;
  update_columns: Array<RecruitSmsMessageCorrespondentUpdateColumn>;
  where?: Maybe<RecruitSmsMessageCorrespondentBoolExp>;
};

/** ordering options when selecting data from "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentOrderBy = {
  correspondent_user_id?: Maybe<OrderBy>;
  error_message?: Maybe<OrderBy>;
  grad?: Maybe<GradProfileOrderBy>;
  message?: Maybe<RecruitSmsMessageOrderBy>;
  sms_message_correspondent_id?: Maybe<OrderBy>;
  sms_message_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentPkColumnsInput = {
  sms_message_correspondent_id: Scalars['Int'];
};

/** select columns of table "recruit.sms_message_correspondent" */
export enum RecruitSmsMessageCorrespondentSelectColumn {
  /** column name */
  CorrespondentUserId = 'correspondent_user_id',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  SmsMessageCorrespondentId = 'sms_message_correspondent_id',
  /** column name */
  SmsMessageId = 'sms_message_id'
}

/** input type for updating data in table "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentSetInput = {
  correspondent_user_id?: Maybe<Scalars['String']>;
  error_message?: Maybe<Scalars['String']>;
  sms_message_correspondent_id?: Maybe<Scalars['Int']>;
  sms_message_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type RecruitSmsMessageCorrespondentStddevFields = {
  __typename?: 'recruit_sms_message_correspondent_stddev_fields';
  sms_message_correspondent_id?: Maybe<Scalars['Float']>;
  sms_message_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentStddevOrderBy = {
  sms_message_correspondent_id?: Maybe<OrderBy>;
  sms_message_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type RecruitSmsMessageCorrespondentStddevPopFields = {
  __typename?: 'recruit_sms_message_correspondent_stddev_pop_fields';
  sms_message_correspondent_id?: Maybe<Scalars['Float']>;
  sms_message_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentStddevPopOrderBy = {
  sms_message_correspondent_id?: Maybe<OrderBy>;
  sms_message_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type RecruitSmsMessageCorrespondentStddevSampFields = {
  __typename?: 'recruit_sms_message_correspondent_stddev_samp_fields';
  sms_message_correspondent_id?: Maybe<Scalars['Float']>;
  sms_message_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentStddevSampOrderBy = {
  sms_message_correspondent_id?: Maybe<OrderBy>;
  sms_message_id?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type RecruitSmsMessageCorrespondentSumFields = {
  __typename?: 'recruit_sms_message_correspondent_sum_fields';
  sms_message_correspondent_id?: Maybe<Scalars['Int']>;
  sms_message_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentSumOrderBy = {
  sms_message_correspondent_id?: Maybe<OrderBy>;
  sms_message_id?: Maybe<OrderBy>;
};

/** update columns of table "recruit.sms_message_correspondent" */
export enum RecruitSmsMessageCorrespondentUpdateColumn {
  /** column name */
  CorrespondentUserId = 'correspondent_user_id',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  SmsMessageCorrespondentId = 'sms_message_correspondent_id',
  /** column name */
  SmsMessageId = 'sms_message_id'
}

/** aggregate var_pop on columns */
export type RecruitSmsMessageCorrespondentVarPopFields = {
  __typename?: 'recruit_sms_message_correspondent_var_pop_fields';
  sms_message_correspondent_id?: Maybe<Scalars['Float']>;
  sms_message_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentVarPopOrderBy = {
  sms_message_correspondent_id?: Maybe<OrderBy>;
  sms_message_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type RecruitSmsMessageCorrespondentVarSampFields = {
  __typename?: 'recruit_sms_message_correspondent_var_samp_fields';
  sms_message_correspondent_id?: Maybe<Scalars['Float']>;
  sms_message_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentVarSampOrderBy = {
  sms_message_correspondent_id?: Maybe<OrderBy>;
  sms_message_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type RecruitSmsMessageCorrespondentVarianceFields = {
  __typename?: 'recruit_sms_message_correspondent_variance_fields';
  sms_message_correspondent_id?: Maybe<Scalars['Float']>;
  sms_message_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "recruit.sms_message_correspondent" */
export type RecruitSmsMessageCorrespondentVarianceOrderBy = {
  sms_message_correspondent_id?: Maybe<OrderBy>;
  sms_message_id?: Maybe<OrderBy>;
};

/** input type for incrementing integer column in table "recruit.sms_message" */
export type RecruitSmsMessageIncInput = {
  sms_message_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "recruit.sms_message" */
export type RecruitSmsMessageInsertInput = {
  adminuser?: Maybe<AdminAdminuserObjRelInsertInput>;
  content?: Maybe<Scalars['String']>;
  correspondents?: Maybe<RecruitSmsMessageCorrespondentArrRelInsertInput>;
  incoming?: Maybe<Scalars['Boolean']>;
  recruiter?: Maybe<RecruitRecruiterObjRelInsertInput>;
  recruiter_user_id?: Maybe<Scalars['String']>;
  sms_message_id?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type RecruitSmsMessageMaxFields = {
  __typename?: 'recruit_sms_message_max_fields';
  content?: Maybe<Scalars['String']>;
  recruiter_user_id?: Maybe<Scalars['String']>;
  sms_message_id?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "recruit.sms_message" */
export type RecruitSmsMessageMaxOrderBy = {
  content?: Maybe<OrderBy>;
  recruiter_user_id?: Maybe<OrderBy>;
  sms_message_id?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type RecruitSmsMessageMinFields = {
  __typename?: 'recruit_sms_message_min_fields';
  content?: Maybe<Scalars['String']>;
  recruiter_user_id?: Maybe<Scalars['String']>;
  sms_message_id?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "recruit.sms_message" */
export type RecruitSmsMessageMinOrderBy = {
  content?: Maybe<OrderBy>;
  recruiter_user_id?: Maybe<OrderBy>;
  sms_message_id?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
};

/** response of any mutation on the table "recruit.sms_message" */
export type RecruitSmsMessageMutationResponse = {
  __typename?: 'recruit_sms_message_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<RecruitSmsMessage>;
};

/** input type for inserting object relation for remote table "recruit.sms_message" */
export type RecruitSmsMessageObjRelInsertInput = {
  data: RecruitSmsMessageInsertInput;
  on_conflict?: Maybe<RecruitSmsMessageOnConflict>;
};

/** on conflict condition type for table "recruit.sms_message" */
export type RecruitSmsMessageOnConflict = {
  constraint: RecruitSmsMessageConstraint;
  update_columns: Array<RecruitSmsMessageUpdateColumn>;
  where?: Maybe<RecruitSmsMessageBoolExp>;
};

/** ordering options when selecting data from "recruit.sms_message" */
export type RecruitSmsMessageOrderBy = {
  adminuser?: Maybe<AdminAdminuserOrderBy>;
  content?: Maybe<OrderBy>;
  correspondents_aggregate?: Maybe<RecruitSmsMessageCorrespondentAggregateOrderBy>;
  incoming?: Maybe<OrderBy>;
  recruiter?: Maybe<RecruitRecruiterOrderBy>;
  recruiter_user_id?: Maybe<OrderBy>;
  sms_message_id?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
};

/** primary key columns input for table: "recruit.sms_message" */
export type RecruitSmsMessagePkColumnsInput = {
  sms_message_id: Scalars['Int'];
};

/** select columns of table "recruit.sms_message" */
export enum RecruitSmsMessageSelectColumn {
  /** column name */
  Content = 'content',
  /** column name */
  Incoming = 'incoming',
  /** column name */
  RecruiterUserId = 'recruiter_user_id',
  /** column name */
  SmsMessageId = 'sms_message_id',
  /** column name */
  Timestamp = 'timestamp'
}

/** input type for updating data in table "recruit.sms_message" */
export type RecruitSmsMessageSetInput = {
  content?: Maybe<Scalars['String']>;
  incoming?: Maybe<Scalars['Boolean']>;
  recruiter_user_id?: Maybe<Scalars['String']>;
  sms_message_id?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type RecruitSmsMessageStddevFields = {
  __typename?: 'recruit_sms_message_stddev_fields';
  sms_message_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "recruit.sms_message" */
export type RecruitSmsMessageStddevOrderBy = {
  sms_message_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type RecruitSmsMessageStddevPopFields = {
  __typename?: 'recruit_sms_message_stddev_pop_fields';
  sms_message_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "recruit.sms_message" */
export type RecruitSmsMessageStddevPopOrderBy = {
  sms_message_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type RecruitSmsMessageStddevSampFields = {
  __typename?: 'recruit_sms_message_stddev_samp_fields';
  sms_message_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "recruit.sms_message" */
export type RecruitSmsMessageStddevSampOrderBy = {
  sms_message_id?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type RecruitSmsMessageSumFields = {
  __typename?: 'recruit_sms_message_sum_fields';
  sms_message_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "recruit.sms_message" */
export type RecruitSmsMessageSumOrderBy = {
  sms_message_id?: Maybe<OrderBy>;
};

/** update columns of table "recruit.sms_message" */
export enum RecruitSmsMessageUpdateColumn {
  /** column name */
  Content = 'content',
  /** column name */
  Incoming = 'incoming',
  /** column name */
  RecruiterUserId = 'recruiter_user_id',
  /** column name */
  SmsMessageId = 'sms_message_id',
  /** column name */
  Timestamp = 'timestamp'
}

/** aggregate var_pop on columns */
export type RecruitSmsMessageVarPopFields = {
  __typename?: 'recruit_sms_message_var_pop_fields';
  sms_message_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "recruit.sms_message" */
export type RecruitSmsMessageVarPopOrderBy = {
  sms_message_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type RecruitSmsMessageVarSampFields = {
  __typename?: 'recruit_sms_message_var_samp_fields';
  sms_message_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "recruit.sms_message" */
export type RecruitSmsMessageVarSampOrderBy = {
  sms_message_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type RecruitSmsMessageVarianceFields = {
  __typename?: 'recruit_sms_message_variance_fields';
  sms_message_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "recruit.sms_message" */
export type RecruitSmsMessageVarianceOrderBy = {
  sms_message_id?: Maybe<OrderBy>;
};

/** columns and relationships of "recruit.sms_template" */
export type RecruitSmsTemplate = {
  __typename?: 'recruit_sms_template';
  creation_timestamp: Scalars['timestamptz'];
  recruiter_user_id: Scalars['String'];
  sms_template_id: Scalars['Int'];
  text: Scalars['String'];
  title: Scalars['String'];
};

/** aggregated selection of "recruit.sms_template" */
export type RecruitSmsTemplateAggregate = {
  __typename?: 'recruit_sms_template_aggregate';
  aggregate?: Maybe<RecruitSmsTemplateAggregateFields>;
  nodes: Array<RecruitSmsTemplate>;
};

/** aggregate fields of "recruit.sms_template" */
export type RecruitSmsTemplateAggregateFields = {
  __typename?: 'recruit_sms_template_aggregate_fields';
  avg?: Maybe<RecruitSmsTemplateAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<RecruitSmsTemplateMaxFields>;
  min?: Maybe<RecruitSmsTemplateMinFields>;
  stddev?: Maybe<RecruitSmsTemplateStddevFields>;
  stddev_pop?: Maybe<RecruitSmsTemplateStddevPopFields>;
  stddev_samp?: Maybe<RecruitSmsTemplateStddevSampFields>;
  sum?: Maybe<RecruitSmsTemplateSumFields>;
  var_pop?: Maybe<RecruitSmsTemplateVarPopFields>;
  var_samp?: Maybe<RecruitSmsTemplateVarSampFields>;
  variance?: Maybe<RecruitSmsTemplateVarianceFields>;
};


/** aggregate fields of "recruit.sms_template" */
export type RecruitSmsTemplateAggregateFieldsCountArgs = {
  columns?: Maybe<Array<RecruitSmsTemplateSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "recruit.sms_template" */
export type RecruitSmsTemplateAggregateOrderBy = {
  avg?: Maybe<RecruitSmsTemplateAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<RecruitSmsTemplateMaxOrderBy>;
  min?: Maybe<RecruitSmsTemplateMinOrderBy>;
  stddev?: Maybe<RecruitSmsTemplateStddevOrderBy>;
  stddev_pop?: Maybe<RecruitSmsTemplateStddevPopOrderBy>;
  stddev_samp?: Maybe<RecruitSmsTemplateStddevSampOrderBy>;
  sum?: Maybe<RecruitSmsTemplateSumOrderBy>;
  var_pop?: Maybe<RecruitSmsTemplateVarPopOrderBy>;
  var_samp?: Maybe<RecruitSmsTemplateVarSampOrderBy>;
  variance?: Maybe<RecruitSmsTemplateVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "recruit.sms_template" */
export type RecruitSmsTemplateArrRelInsertInput = {
  data: Array<RecruitSmsTemplateInsertInput>;
  on_conflict?: Maybe<RecruitSmsTemplateOnConflict>;
};

/** aggregate avg on columns */
export type RecruitSmsTemplateAvgFields = {
  __typename?: 'recruit_sms_template_avg_fields';
  sms_template_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "recruit.sms_template" */
export type RecruitSmsTemplateAvgOrderBy = {
  sms_template_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "recruit.sms_template". All fields are combined with a logical 'AND'. */
export type RecruitSmsTemplateBoolExp = {
  _and?: Maybe<Array<Maybe<RecruitSmsTemplateBoolExp>>>;
  _not?: Maybe<RecruitSmsTemplateBoolExp>;
  _or?: Maybe<Array<Maybe<RecruitSmsTemplateBoolExp>>>;
  creation_timestamp?: Maybe<TimestamptzComparisonExp>;
  recruiter_user_id?: Maybe<StringComparisonExp>;
  sms_template_id?: Maybe<IntComparisonExp>;
  text?: Maybe<StringComparisonExp>;
  title?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "recruit.sms_template" */
export enum RecruitSmsTemplateConstraint {
  /** unique or primary key constraint */
  SmsTemplatePkey = 'sms_template_pkey'
}

/** input type for incrementing integer column in table "recruit.sms_template" */
export type RecruitSmsTemplateIncInput = {
  sms_template_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "recruit.sms_template" */
export type RecruitSmsTemplateInsertInput = {
  creation_timestamp?: Maybe<Scalars['timestamptz']>;
  recruiter_user_id?: Maybe<Scalars['String']>;
  sms_template_id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RecruitSmsTemplateMaxFields = {
  __typename?: 'recruit_sms_template_max_fields';
  creation_timestamp?: Maybe<Scalars['timestamptz']>;
  recruiter_user_id?: Maybe<Scalars['String']>;
  sms_template_id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "recruit.sms_template" */
export type RecruitSmsTemplateMaxOrderBy = {
  creation_timestamp?: Maybe<OrderBy>;
  recruiter_user_id?: Maybe<OrderBy>;
  sms_template_id?: Maybe<OrderBy>;
  text?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type RecruitSmsTemplateMinFields = {
  __typename?: 'recruit_sms_template_min_fields';
  creation_timestamp?: Maybe<Scalars['timestamptz']>;
  recruiter_user_id?: Maybe<Scalars['String']>;
  sms_template_id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "recruit.sms_template" */
export type RecruitSmsTemplateMinOrderBy = {
  creation_timestamp?: Maybe<OrderBy>;
  recruiter_user_id?: Maybe<OrderBy>;
  sms_template_id?: Maybe<OrderBy>;
  text?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
};

/** response of any mutation on the table "recruit.sms_template" */
export type RecruitSmsTemplateMutationResponse = {
  __typename?: 'recruit_sms_template_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<RecruitSmsTemplate>;
};

/** input type for inserting object relation for remote table "recruit.sms_template" */
export type RecruitSmsTemplateObjRelInsertInput = {
  data: RecruitSmsTemplateInsertInput;
  on_conflict?: Maybe<RecruitSmsTemplateOnConflict>;
};

/** on conflict condition type for table "recruit.sms_template" */
export type RecruitSmsTemplateOnConflict = {
  constraint: RecruitSmsTemplateConstraint;
  update_columns: Array<RecruitSmsTemplateUpdateColumn>;
  where?: Maybe<RecruitSmsTemplateBoolExp>;
};

/** ordering options when selecting data from "recruit.sms_template" */
export type RecruitSmsTemplateOrderBy = {
  creation_timestamp?: Maybe<OrderBy>;
  recruiter_user_id?: Maybe<OrderBy>;
  sms_template_id?: Maybe<OrderBy>;
  text?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
};

/** primary key columns input for table: "recruit.sms_template" */
export type RecruitSmsTemplatePkColumnsInput = {
  sms_template_id: Scalars['Int'];
};

/** select columns of table "recruit.sms_template" */
export enum RecruitSmsTemplateSelectColumn {
  /** column name */
  CreationTimestamp = 'creation_timestamp',
  /** column name */
  RecruiterUserId = 'recruiter_user_id',
  /** column name */
  SmsTemplateId = 'sms_template_id',
  /** column name */
  Text = 'text',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "recruit.sms_template" */
export type RecruitSmsTemplateSetInput = {
  creation_timestamp?: Maybe<Scalars['timestamptz']>;
  recruiter_user_id?: Maybe<Scalars['String']>;
  sms_template_id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type RecruitSmsTemplateStddevFields = {
  __typename?: 'recruit_sms_template_stddev_fields';
  sms_template_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "recruit.sms_template" */
export type RecruitSmsTemplateStddevOrderBy = {
  sms_template_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type RecruitSmsTemplateStddevPopFields = {
  __typename?: 'recruit_sms_template_stddev_pop_fields';
  sms_template_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "recruit.sms_template" */
export type RecruitSmsTemplateStddevPopOrderBy = {
  sms_template_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type RecruitSmsTemplateStddevSampFields = {
  __typename?: 'recruit_sms_template_stddev_samp_fields';
  sms_template_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "recruit.sms_template" */
export type RecruitSmsTemplateStddevSampOrderBy = {
  sms_template_id?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type RecruitSmsTemplateSumFields = {
  __typename?: 'recruit_sms_template_sum_fields';
  sms_template_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "recruit.sms_template" */
export type RecruitSmsTemplateSumOrderBy = {
  sms_template_id?: Maybe<OrderBy>;
};

/** update columns of table "recruit.sms_template" */
export enum RecruitSmsTemplateUpdateColumn {
  /** column name */
  CreationTimestamp = 'creation_timestamp',
  /** column name */
  RecruiterUserId = 'recruiter_user_id',
  /** column name */
  SmsTemplateId = 'sms_template_id',
  /** column name */
  Text = 'text',
  /** column name */
  Title = 'title'
}

/** aggregate var_pop on columns */
export type RecruitSmsTemplateVarPopFields = {
  __typename?: 'recruit_sms_template_var_pop_fields';
  sms_template_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "recruit.sms_template" */
export type RecruitSmsTemplateVarPopOrderBy = {
  sms_template_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type RecruitSmsTemplateVarSampFields = {
  __typename?: 'recruit_sms_template_var_samp_fields';
  sms_template_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "recruit.sms_template" */
export type RecruitSmsTemplateVarSampOrderBy = {
  sms_template_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type RecruitSmsTemplateVarianceFields = {
  __typename?: 'recruit_sms_template_variance_fields';
  sms_template_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "recruit.sms_template" */
export type RecruitSmsTemplateVarianceOrderBy = {
  sms_template_id?: Maybe<OrderBy>;
};

/** subscription root */
export type SubscriptionRoot = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "admin.adminuser" */
  admin_adminuser: Array<AdminAdminuser>;
  /** fetch aggregated fields from the table: "admin.adminuser" */
  admin_adminuser_aggregate: AdminAdminuserAggregate;
  /** fetch data from the table: "admin.adminuser" using primary key columns */
  admin_adminuser_by_pk?: Maybe<AdminAdminuser>;
  /** fetch data from the table: "admin.auth0mgmt" */
  admin_auth0mgmt: Array<AdminAuth0mgmt>;
  /** fetch aggregated fields from the table: "admin.auth0mgmt" */
  admin_auth0mgmt_aggregate: AdminAuth0mgmtAggregate;
  /** fetch data from the table: "admin.auth0mgmt" using primary key columns */
  admin_auth0mgmt_by_pk?: Maybe<AdminAuth0mgmt>;
  /** fetch data from the table: "admin.auth0mgmt_result" */
  admin_auth0mgmt_result: Array<AdminAuth0mgmtResult>;
  /** fetch aggregated fields from the table: "admin.auth0mgmt_result" */
  admin_auth0mgmt_result_aggregate: AdminAuth0mgmtResultAggregate;
  /** fetch data from the table: "admin.auth0mgmt_result" using primary key columns */
  admin_auth0mgmt_result_by_pk?: Maybe<AdminAuth0mgmtResult>;
  /** fetch data from the table: "admin.email" */
  admin_email: Array<AdminEmail>;
  /** fetch aggregated fields from the table: "admin.email" */
  admin_email_aggregate: AdminEmailAggregate;
  /** fetch data from the table: "admin.email" using primary key columns */
  admin_email_by_pk?: Maybe<AdminEmail>;
  /** fetch data from the table: "admin.email_layout" */
  admin_email_layout: Array<AdminEmailLayout>;
  /** fetch aggregated fields from the table: "admin.email_layout" */
  admin_email_layout_aggregate: AdminEmailLayoutAggregate;
  /** fetch data from the table: "admin.email_layout" using primary key columns */
  admin_email_layout_by_pk?: Maybe<AdminEmailLayout>;
  /** fetch data from the table: "admin.email_template" */
  admin_email_template: Array<AdminEmailTemplate>;
  /** fetch aggregated fields from the table: "admin.email_template" */
  admin_email_template_aggregate: AdminEmailTemplateAggregate;
  /** fetch data from the table: "admin.email_template" using primary key columns */
  admin_email_template_by_pk?: Maybe<AdminEmailTemplate>;
  /** fetch data from the table: "admin.twiliomgmt" */
  admin_twiliomgmt: Array<AdminTwiliomgmt>;
  /** fetch aggregated fields from the table: "admin.twiliomgmt" */
  admin_twiliomgmt_aggregate: AdminTwiliomgmtAggregate;
  /** fetch data from the table: "admin.twiliomgmt" using primary key columns */
  admin_twiliomgmt_by_pk?: Maybe<AdminTwiliomgmt>;
  /** fetch data from the table: "admin.twiliomgmt_result" */
  admin_twiliomgmt_result: Array<AdminTwiliomgmtResult>;
  /** fetch aggregated fields from the table: "admin.twiliomgmt_result" */
  admin_twiliomgmt_result_aggregate: AdminTwiliomgmtResultAggregate;
  /** fetch data from the table: "admin.twiliomgmt_result" using primary key columns */
  admin_twiliomgmt_result_by_pk?: Maybe<AdminTwiliomgmtResult>;
  /** fetch data from the table: "db_ping" */
  db_ping: Array<DbPing>;
  /** fetch aggregated fields from the table: "db_ping" */
  db_ping_aggregate: DbPingAggregate;
  /** fetch data from the table: "db_ping" using primary key columns */
  db_ping_by_pk?: Maybe<DbPing>;
  /** fetch data from the table: "db_state" */
  db_state: Array<DbState>;
  /** fetch aggregated fields from the table: "db_state" */
  db_state_aggregate: DbStateAggregate;
  /** fetch data from the table: "db_state" using primary key columns */
  db_state_by_pk?: Maybe<DbState>;
  /** fetch data from the table: "grad.achievement" */
  grad_achievement: Array<GradAchievement>;
  /** fetch aggregated fields from the table: "grad.achievement" */
  grad_achievement_aggregate: GradAchievementAggregate;
  /** fetch data from the table: "grad.achievement" using primary key columns */
  grad_achievement_by_pk?: Maybe<GradAchievement>;
  /** fetch data from the table: "grad.award" */
  grad_award: Array<GradAward>;
  /** fetch aggregated fields from the table: "grad.award" */
  grad_award_aggregate: GradAwardAggregate;
  /** fetch data from the table: "grad.award" using primary key columns */
  grad_award_by_pk?: Maybe<GradAward>;
  /** fetch data from the table: "grad.bookmark_job" */
  grad_bookmark_job: Array<GradBookmarkJob>;
  /** fetch aggregated fields from the table: "grad.bookmark_job" */
  grad_bookmark_job_aggregate: GradBookmarkJobAggregate;
  /** fetch data from the table: "grad.bookmark_job" using primary key columns */
  grad_bookmark_job_by_pk?: Maybe<GradBookmarkJob>;
  /** fetch data from the table: "grad.city_state_selection" */
  grad_city_state_selection: Array<GradCityStateSelection>;
  /** fetch aggregated fields from the table: "grad.city_state_selection" */
  grad_city_state_selection_aggregate: GradCityStateSelectionAggregate;
  /** fetch data from the table: "grad.city_state_selection" using primary key columns */
  grad_city_state_selection_by_pk?: Maybe<GradCityStateSelection>;
  /** fetch data from the table: "grad.comm_preference_selection" */
  grad_comm_preference_selection: Array<GradCommPreferenceSelection>;
  /** fetch aggregated fields from the table: "grad.comm_preference_selection" */
  grad_comm_preference_selection_aggregate: GradCommPreferenceSelectionAggregate;
  /** fetch data from the table: "grad.comm_preference_selection" using primary key columns */
  grad_comm_preference_selection_by_pk?: Maybe<GradCommPreferenceSelection>;
  /** fetch data from the table: "grad.company_selection" */
  grad_company_selection: Array<GradCompanySelection>;
  /** fetch aggregated fields from the table: "grad.company_selection" */
  grad_company_selection_aggregate: GradCompanySelectionAggregate;
  /** fetch data from the table: "grad.company_selection" using primary key columns */
  grad_company_selection_by_pk?: Maybe<GradCompanySelection>;
  /** fetch data from the table: "grad.computer_language" */
  grad_computer_language: Array<GradComputerLanguage>;
  /** fetch aggregated fields from the table: "grad.computer_language" */
  grad_computer_language_aggregate: GradComputerLanguageAggregate;
  /** fetch data from the table: "grad.computer_language" using primary key columns */
  grad_computer_language_by_pk?: Maybe<GradComputerLanguage>;
  /** fetch data from the table: "grad.computer_language_selection" */
  grad_computer_language_selection: Array<GradComputerLanguageSelection>;
  /** fetch aggregated fields from the table: "grad.computer_language_selection" */
  grad_computer_language_selection_aggregate: GradComputerLanguageSelectionAggregate;
  /** fetch data from the table: "grad.computer_language_selection" using primary key columns */
  grad_computer_language_selection_by_pk?: Maybe<GradComputerLanguageSelection>;
  /** fetch data from the table: "grad.concentration" */
  grad_concentration: Array<GradConcentration>;
  /** fetch aggregated fields from the table: "grad.concentration" */
  grad_concentration_aggregate: GradConcentrationAggregate;
  /** fetch data from the table: "grad.concentration" using primary key columns */
  grad_concentration_by_pk?: Maybe<GradConcentration>;
  /** fetch data from the table: "grad.country_selection" */
  grad_country_selection: Array<GradCountrySelection>;
  /** fetch aggregated fields from the table: "grad.country_selection" */
  grad_country_selection_aggregate: GradCountrySelectionAggregate;
  /** fetch data from the table: "grad.country_selection" using primary key columns */
  grad_country_selection_by_pk?: Maybe<GradCountrySelection>;
  /** fetch data from the table: "grad.degree" */
  grad_degree: Array<GradDegree>;
  /** fetch aggregated fields from the table: "grad.degree" */
  grad_degree_aggregate: GradDegreeAggregate;
  /** fetch data from the table: "grad.degree" using primary key columns */
  grad_degree_by_pk?: Maybe<GradDegree>;
  /** fetch data from the table: "grad.degree_fill_in_university" */
  grad_degree_fill_in_university: Array<GradDegreeFillInUniversity>;
  /** fetch aggregated fields from the table: "grad.degree_fill_in_university" */
  grad_degree_fill_in_university_aggregate: GradDegreeFillInUniversityAggregate;
  /** fetch data from the table: "grad.degree_fill_in_university" using primary key columns */
  grad_degree_fill_in_university_by_pk?: Maybe<GradDegreeFillInUniversity>;
  /** fetch data from the table: "grad.degree_latest" */
  grad_degree_latest: Array<GradDegreeLatest>;
  /** fetch aggregated fields from the table: "grad.degree_latest" */
  grad_degree_latest_aggregate: GradDegreeLatestAggregate;
  /** fetch data from the table: "grad.degree_selection" */
  grad_degree_selection: Array<GradDegreeSelection>;
  /** fetch aggregated fields from the table: "grad.degree_selection" */
  grad_degree_selection_aggregate: GradDegreeSelectionAggregate;
  /** fetch data from the table: "grad.degree_selection" using primary key columns */
  grad_degree_selection_by_pk?: Maybe<GradDegreeSelection>;
  /** fetch data from the table: "grad.employer_preference" */
  grad_employer_preference: Array<GradEmployerPreference>;
  /** fetch aggregated fields from the table: "grad.employer_preference" */
  grad_employer_preference_aggregate: GradEmployerPreferenceAggregate;
  /** fetch data from the table: "grad.employer_preference" using primary key columns */
  grad_employer_preference_by_pk?: Maybe<GradEmployerPreference>;
  /** fetch data from the table: "grad.employer_preference_selection" */
  grad_employer_preference_selection: Array<GradEmployerPreferenceSelection>;
  /** fetch aggregated fields from the table: "grad.employer_preference_selection" */
  grad_employer_preference_selection_aggregate: GradEmployerPreferenceSelectionAggregate;
  /** fetch data from the table: "grad.employer_preference_selection" using primary key columns */
  grad_employer_preference_selection_by_pk?: Maybe<GradEmployerPreferenceSelection>;
  /** fetch data from the table: "grad.event_registration" */
  grad_event_registration: Array<GradEventRegistration>;
  /** fetch aggregated fields from the table: "grad.event_registration" */
  grad_event_registration_aggregate: GradEventRegistrationAggregate;
  /** fetch data from the table: "grad.event_registration" using primary key columns */
  grad_event_registration_by_pk?: Maybe<GradEventRegistration>;
  /** fetch data from the table: "grad.fun_fact" */
  grad_fun_fact: Array<GradFunFact>;
  /** fetch aggregated fields from the table: "grad.fun_fact" */
  grad_fun_fact_aggregate: GradFunFactAggregate;
  /** fetch data from the table: "grad.fun_fact" using primary key columns */
  grad_fun_fact_by_pk?: Maybe<GradFunFact>;
  /** fetch data from the table: "grad.fun_fact_selection" */
  grad_fun_fact_selection: Array<GradFunFactSelection>;
  /** fetch aggregated fields from the table: "grad.fun_fact_selection" */
  grad_fun_fact_selection_aggregate: GradFunFactSelectionAggregate;
  /** fetch data from the table: "grad.fun_fact_selection" using primary key columns */
  grad_fun_fact_selection_by_pk?: Maybe<GradFunFactSelection>;
  /** fetch data from the table: "grad.interest_firm" */
  grad_interest_firm: Array<GradInterestFirm>;
  /** fetch aggregated fields from the table: "grad.interest_firm" */
  grad_interest_firm_aggregate: GradInterestFirmAggregate;
  /** fetch data from the table: "grad.interest_firm" using primary key columns */
  grad_interest_firm_by_pk?: Maybe<GradInterestFirm>;
  /** fetch data from the table: "grad.interest_firm_selection" */
  grad_interest_firm_selection: Array<GradInterestFirmSelection>;
  /** fetch aggregated fields from the table: "grad.interest_firm_selection" */
  grad_interest_firm_selection_aggregate: GradInterestFirmSelectionAggregate;
  /** fetch data from the table: "grad.interest_firm_selection" using primary key columns */
  grad_interest_firm_selection_by_pk?: Maybe<GradInterestFirmSelection>;
  /** fetch data from the table: "grad.interest_job_type" */
  grad_interest_job_type: Array<GradInterestJobType>;
  /** fetch aggregated fields from the table: "grad.interest_job_type" */
  grad_interest_job_type_aggregate: GradInterestJobTypeAggregate;
  /** fetch data from the table: "grad.interest_job_type" using primary key columns */
  grad_interest_job_type_by_pk?: Maybe<GradInterestJobType>;
  /** fetch data from the table: "grad.interest_job_type_selection" */
  grad_interest_job_type_selection: Array<GradInterestJobTypeSelection>;
  /** fetch aggregated fields from the table: "grad.interest_job_type_selection" */
  grad_interest_job_type_selection_aggregate: GradInterestJobTypeSelectionAggregate;
  /** fetch data from the table: "grad.interest_job_type_selection" using primary key columns */
  grad_interest_job_type_selection_by_pk?: Maybe<GradInterestJobTypeSelection>;
  /** fetch data from the table: "grad.interest_region" */
  grad_interest_region: Array<GradInterestRegion>;
  /** fetch aggregated fields from the table: "grad.interest_region" */
  grad_interest_region_aggregate: GradInterestRegionAggregate;
  /** fetch data from the table: "grad.interest_region" using primary key columns */
  grad_interest_region_by_pk?: Maybe<GradInterestRegion>;
  /** fetch data from the table: "grad.interest_region_selection" */
  grad_interest_region_selection: Array<GradInterestRegionSelection>;
  /** fetch aggregated fields from the table: "grad.interest_region_selection" */
  grad_interest_region_selection_aggregate: GradInterestRegionSelectionAggregate;
  /** fetch data from the table: "grad.interest_region_selection" using primary key columns */
  grad_interest_region_selection_by_pk?: Maybe<GradInterestRegionSelection>;
  /** fetch data from the table: "grad.interest_role" */
  grad_interest_role: Array<GradInterestRole>;
  /** fetch aggregated fields from the table: "grad.interest_role" */
  grad_interest_role_aggregate: GradInterestRoleAggregate;
  /** fetch data from the table: "grad.interest_role" using primary key columns */
  grad_interest_role_by_pk?: Maybe<GradInterestRole>;
  /** fetch data from the table: "grad.interest_role_selection" */
  grad_interest_role_selection: Array<GradInterestRoleSelection>;
  /** fetch aggregated fields from the table: "grad.interest_role_selection" */
  grad_interest_role_selection_aggregate: GradInterestRoleSelectionAggregate;
  /** fetch data from the table: "grad.interest_role_selection" using primary key columns */
  grad_interest_role_selection_by_pk?: Maybe<GradInterestRoleSelection>;
  /** fetch data from the table: "grad.major_selection" */
  grad_major_selection: Array<GradMajorSelection>;
  /** fetch aggregated fields from the table: "grad.major_selection" */
  grad_major_selection_aggregate: GradMajorSelectionAggregate;
  /** fetch data from the table: "grad.major_selection" using primary key columns */
  grad_major_selection_by_pk?: Maybe<GradMajorSelection>;
  /** fetch data from the table: "grad.page_view" */
  grad_page_view: Array<GradPageView>;
  /** fetch aggregated fields from the table: "grad.page_view" */
  grad_page_view_aggregate: GradPageViewAggregate;
  /** fetch data from the table: "grad.page_view" using primary key columns */
  grad_page_view_by_pk?: Maybe<GradPageView>;
  /** fetch data from the table: "grad.profile" */
  grad_profile: Array<GradProfile>;
  /** fetch aggregated fields from the table: "grad.profile" */
  grad_profile_aggregate: GradProfileAggregate;
  /** fetch data from the table: "grad.profile" using primary key columns */
  grad_profile_by_pk?: Maybe<GradProfile>;
  /** fetch data from the table: "grad.profile_combine" */
  grad_profile_combine: Array<GradProfileCombine>;
  /** fetch aggregated fields from the table: "grad.profile_combine" */
  grad_profile_combine_aggregate: GradProfileCombineAggregate;
  /** fetch data from the table: "grad.raise_hand" */
  grad_raise_hand: Array<GradRaiseHand>;
  /** fetch aggregated fields from the table: "grad.raise_hand" */
  grad_raise_hand_aggregate: GradRaiseHandAggregate;
  /** fetch data from the table: "grad.raise_hand" using primary key columns */
  grad_raise_hand_by_pk?: Maybe<GradRaiseHand>;
  /** fetch data from the table: "grad.spoken_language" */
  grad_spoken_language: Array<GradSpokenLanguage>;
  /** fetch aggregated fields from the table: "grad.spoken_language" */
  grad_spoken_language_aggregate: GradSpokenLanguageAggregate;
  /** fetch data from the table: "grad.spoken_language" using primary key columns */
  grad_spoken_language_by_pk?: Maybe<GradSpokenLanguage>;
  /** fetch data from the table: "grad.test_score" */
  grad_test_score: Array<GradTestScore>;
  /** fetch aggregated fields from the table: "grad.test_score" */
  grad_test_score_aggregate: GradTestScoreAggregate;
  /** fetch data from the table: "grad.test_score" using primary key columns */
  grad_test_score_by_pk?: Maybe<GradTestScore>;
  /** fetch data from the table: "grad.test_score_detail" */
  grad_test_score_detail: Array<GradTestScoreDetail>;
  /** fetch aggregated fields from the table: "grad.test_score_detail" */
  grad_test_score_detail_aggregate: GradTestScoreDetailAggregate;
  /** fetch data from the table: "grad.test_score_detail" using primary key columns */
  grad_test_score_detail_by_pk?: Maybe<GradTestScoreDetail>;
  /** fetch data from the table: "grad.university_selection" */
  grad_university_selection: Array<GradUniversitySelection>;
  /** fetch aggregated fields from the table: "grad.university_selection" */
  grad_university_selection_aggregate: GradUniversitySelectionAggregate;
  /** fetch data from the table: "grad.university_selection" using primary key columns */
  grad_university_selection_by_pk?: Maybe<GradUniversitySelection>;
  /** fetch data from the table: "grad.university_stat" */
  grad_university_stat: Array<GradUniversityStat>;
  /** fetch aggregated fields from the table: "grad.university_stat" */
  grad_university_stat_aggregate: GradUniversityStatAggregate;
  /** fetch data from the table: "grad.upload_doc" */
  grad_upload_doc: Array<GradUploadDoc>;
  /** fetch aggregated fields from the table: "grad.upload_doc" */
  grad_upload_doc_aggregate: GradUploadDocAggregate;
  /** fetch data from the table: "grad.upload_doc" using primary key columns */
  grad_upload_doc_by_pk?: Maybe<GradUploadDoc>;
  /** fetch data from the table: "grad.user_activity_summary" */
  grad_user_activity_summary: Array<GradUserActivitySummary>;
  /** fetch aggregated fields from the table: "grad.user_activity_summary" */
  grad_user_activity_summary_aggregate: GradUserActivitySummaryAggregate;
  /** fetch data from the table: "grad.user_activity_summary" using primary key columns */
  grad_user_activity_summary_by_pk?: Maybe<GradUserActivitySummary>;
  /** fetch data from the table: "grad.visa_selection" */
  grad_visa_selection: Array<GradVisaSelection>;
  /** fetch aggregated fields from the table: "grad.visa_selection" */
  grad_visa_selection_aggregate: GradVisaSelectionAggregate;
  /** fetch data from the table: "grad.visa_selection" using primary key columns */
  grad_visa_selection_by_pk?: Maybe<GradVisaSelection>;
  /** fetch data from the table: "grad.volunteer" */
  grad_volunteer: Array<GradVolunteer>;
  /** fetch aggregated fields from the table: "grad.volunteer" */
  grad_volunteer_aggregate: GradVolunteerAggregate;
  /** fetch data from the table: "grad.volunteer" using primary key columns */
  grad_volunteer_by_pk?: Maybe<GradVolunteer>;
  /** fetch data from the table: "grad.work_experience" */
  grad_work_experience: Array<GradWorkExperience>;
  /** fetch aggregated fields from the table: "grad.work_experience" */
  grad_work_experience_aggregate: GradWorkExperienceAggregate;
  /** fetch data from the table: "grad.work_experience" using primary key columns */
  grad_work_experience_by_pk?: Maybe<GradWorkExperience>;
  /** fetch data from the table: "queue_handler_permission" */
  queue_handler_permission: Array<QueueHandlerPermission>;
  /** fetch aggregated fields from the table: "queue_handler_permission" */
  queue_handler_permission_aggregate: QueueHandlerPermissionAggregate;
  /** fetch data from the table: "queue_handler_permission" using primary key columns */
  queue_handler_permission_by_pk?: Maybe<QueueHandlerPermission>;
  /** fetch data from the table: "recruit.account" */
  recruit_account: Array<RecruitAccount>;
  /** fetch aggregated fields from the table: "recruit.account" */
  recruit_account_aggregate: RecruitAccountAggregate;
  /** fetch data from the table: "recruit.account" using primary key columns */
  recruit_account_by_pk?: Maybe<RecruitAccount>;
  /** fetch data from the table: "recruit.company" */
  recruit_company: Array<RecruitCompany>;
  /** fetch aggregated fields from the table: "recruit.company" */
  recruit_company_aggregate: RecruitCompanyAggregate;
  /** fetch data from the table: "recruit.company" using primary key columns */
  recruit_company_by_pk?: Maybe<RecruitCompany>;
  /** fetch data from the table: "recruit.company_subindustry" */
  recruit_company_subindustry: Array<RecruitCompanySubindustry>;
  /** fetch aggregated fields from the table: "recruit.company_subindustry" */
  recruit_company_subindustry_aggregate: RecruitCompanySubindustryAggregate;
  /** fetch data from the table: "recruit.company_subindustry" using primary key columns */
  recruit_company_subindustry_by_pk?: Maybe<RecruitCompanySubindustry>;
  /** fetch data from the table: "recruit.event" */
  recruit_event: Array<RecruitEvent>;
  /** fetch aggregated fields from the table: "recruit.event" */
  recruit_event_aggregate: RecruitEventAggregate;
  /** fetch data from the table: "recruit.event" using primary key columns */
  recruit_event_by_pk?: Maybe<RecruitEvent>;
  /** fetch data from the table: "recruit.grad_group" */
  recruit_grad_group: Array<RecruitGradGroup>;
  /** fetch aggregated fields from the table: "recruit.grad_group" */
  recruit_grad_group_aggregate: RecruitGradGroupAggregate;
  /** fetch data from the table: "recruit.grad_group" using primary key columns */
  recruit_grad_group_by_pk?: Maybe<RecruitGradGroup>;
  /** fetch data from the table: "recruit.grad_group_member" */
  recruit_grad_group_member: Array<RecruitGradGroupMember>;
  /** fetch aggregated fields from the table: "recruit.grad_group_member" */
  recruit_grad_group_member_aggregate: RecruitGradGroupMemberAggregate;
  /** fetch data from the table: "recruit.grad_group_member" using primary key columns */
  recruit_grad_group_member_by_pk?: Maybe<RecruitGradGroupMember>;
  /** fetch data from the table: "recruit.job_posting" */
  recruit_job_posting: Array<RecruitJobPosting>;
  /** fetch aggregated fields from the table: "recruit.job_posting" */
  recruit_job_posting_aggregate: RecruitJobPostingAggregate;
  /** fetch data from the table: "recruit.job_posting" using primary key columns */
  recruit_job_posting_by_pk?: Maybe<RecruitJobPosting>;
  /** fetch data from the table: "recruit.job_requirement" */
  recruit_job_requirement: Array<RecruitJobRequirement>;
  /** fetch aggregated fields from the table: "recruit.job_requirement" */
  recruit_job_requirement_aggregate: RecruitJobRequirementAggregate;
  /** fetch data from the table: "recruit.job_requirement" using primary key columns */
  recruit_job_requirement_by_pk?: Maybe<RecruitJobRequirement>;
  /** fetch data from the table: "recruit.job_requirement_value" */
  recruit_job_requirement_value: Array<RecruitJobRequirementValue>;
  /** fetch aggregated fields from the table: "recruit.job_requirement_value" */
  recruit_job_requirement_value_aggregate: RecruitJobRequirementValueAggregate;
  /** fetch data from the table: "recruit.job_requirement_value" using primary key columns */
  recruit_job_requirement_value_by_pk?: Maybe<RecruitJobRequirementValue>;
  /** fetch data from the table: "recruit.recruiter" */
  recruit_recruiter: Array<RecruitRecruiter>;
  /** fetch aggregated fields from the table: "recruit.recruiter" */
  recruit_recruiter_aggregate: RecruitRecruiterAggregate;
  /** fetch data from the table: "recruit.recruiter" using primary key columns */
  recruit_recruiter_by_pk?: Maybe<RecruitRecruiter>;
  /** fetch data from the table: "recruit.saved_search" */
  recruit_saved_search: Array<RecruitSavedSearch>;
  /** fetch aggregated fields from the table: "recruit.saved_search" */
  recruit_saved_search_aggregate: RecruitSavedSearchAggregate;
  /** fetch data from the table: "recruit.saved_search" using primary key columns */
  recruit_saved_search_by_pk?: Maybe<RecruitSavedSearch>;
  /** fetch data from the table: "recruit.sms_correspondent" */
  recruit_sms_correspondent: Array<RecruitSmsCorrespondent>;
  /** fetch aggregated fields from the table: "recruit.sms_correspondent" */
  recruit_sms_correspondent_aggregate: RecruitSmsCorrespondentAggregate;
  /** fetch data from the table: "recruit.sms_correspondent" using primary key columns */
  recruit_sms_correspondent_by_pk?: Maybe<RecruitSmsCorrespondent>;
  /** fetch data from the table: "recruit.sms_message" */
  recruit_sms_message: Array<RecruitSmsMessage>;
  /** fetch aggregated fields from the table: "recruit.sms_message" */
  recruit_sms_message_aggregate: RecruitSmsMessageAggregate;
  /** fetch data from the table: "recruit.sms_message" using primary key columns */
  recruit_sms_message_by_pk?: Maybe<RecruitSmsMessage>;
  /** fetch data from the table: "recruit.sms_message_correspondent" */
  recruit_sms_message_correspondent: Array<RecruitSmsMessageCorrespondent>;
  /** fetch aggregated fields from the table: "recruit.sms_message_correspondent" */
  recruit_sms_message_correspondent_aggregate: RecruitSmsMessageCorrespondentAggregate;
  /** fetch data from the table: "recruit.sms_message_correspondent" using primary key columns */
  recruit_sms_message_correspondent_by_pk?: Maybe<RecruitSmsMessageCorrespondent>;
  /** fetch data from the table: "recruit.sms_template" */
  recruit_sms_template: Array<RecruitSmsTemplate>;
  /** fetch aggregated fields from the table: "recruit.sms_template" */
  recruit_sms_template_aggregate: RecruitSmsTemplateAggregate;
  /** fetch data from the table: "recruit.sms_template" using primary key columns */
  recruit_sms_template_by_pk?: Maybe<RecruitSmsTemplate>;
  /** fetch data from the table: "test_auto3" */
  test_auto3: Array<TestAuto3>;
  /** fetch aggregated fields from the table: "test_auto3" */
  test_auto3_aggregate: TestAuto3Aggregate;
  /** fetch data from the table: "test_auto3" using primary key columns */
  test_auto3_by_pk?: Maybe<TestAuto3>;
  /** fetch data from the table: "to_queue" */
  to_queue: Array<ToQueue>;
  /** fetch aggregated fields from the table: "to_queue" */
  to_queue_aggregate: ToQueueAggregate;
  /** fetch data from the table: "to_queue" using primary key columns */
  to_queue_by_pk?: Maybe<ToQueue>;
  /** fetch data from the table: "to_queue_response" */
  to_queue_response: Array<ToQueueResponse>;
  /** fetch aggregated fields from the table: "to_queue_response" */
  to_queue_response_aggregate: ToQueueResponseAggregate;
  /** fetch data from the table: "to_queue_response" using primary key columns */
  to_queue_response_by_pk?: Maybe<ToQueueResponse>;
  /** fetch data from the table: "user_auth" */
  user_auth: Array<UserAuth>;
  /** fetch aggregated fields from the table: "user_auth" */
  user_auth_aggregate: UserAuthAggregate;
  /** fetch data from the table: "user_auth" using primary key columns */
  user_auth_by_pk?: Maybe<UserAuth>;
  /** fetch data from the table: "useraccount" */
  useraccount: Array<Useraccount>;
  /** fetch aggregated fields from the table: "useraccount" */
  useraccount_aggregate: UseraccountAggregate;
  /** fetch data from the table: "useraccount" using primary key columns */
  useraccount_by_pk?: Maybe<Useraccount>;
  /** fetch data from the table: "web_api_permission" */
  web_api_permission: Array<WebApiPermission>;
  /** fetch aggregated fields from the table: "web_api_permission" */
  web_api_permission_aggregate: WebApiPermissionAggregate;
  /** fetch data from the table: "web_api_permission" using primary key columns */
  web_api_permission_by_pk?: Maybe<WebApiPermission>;
};


/** subscription root */
export type SubscriptionRootAdminAdminuserArgs = {
  distinct_on?: Maybe<Array<AdminAdminuserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminAdminuserOrderBy>>;
  where?: Maybe<AdminAdminuserBoolExp>;
};


/** subscription root */
export type SubscriptionRootAdminAdminuserAggregateArgs = {
  distinct_on?: Maybe<Array<AdminAdminuserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminAdminuserOrderBy>>;
  where?: Maybe<AdminAdminuserBoolExp>;
};


/** subscription root */
export type SubscriptionRootAdminAdminuserByPkArgs = {
  user_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootAdminAuth0mgmtArgs = {
  distinct_on?: Maybe<Array<AdminAuth0mgmtSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminAuth0mgmtOrderBy>>;
  where?: Maybe<AdminAuth0mgmtBoolExp>;
};


/** subscription root */
export type SubscriptionRootAdminAuth0mgmtAggregateArgs = {
  distinct_on?: Maybe<Array<AdminAuth0mgmtSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminAuth0mgmtOrderBy>>;
  where?: Maybe<AdminAuth0mgmtBoolExp>;
};


/** subscription root */
export type SubscriptionRootAdminAuth0mgmtByPkArgs = {
  auth0mgmt_id: Scalars['Int'];
};


/** subscription root */
export type SubscriptionRootAdminAuth0mgmtResultArgs = {
  distinct_on?: Maybe<Array<AdminAuth0mgmtResultSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminAuth0mgmtResultOrderBy>>;
  where?: Maybe<AdminAuth0mgmtResultBoolExp>;
};


/** subscription root */
export type SubscriptionRootAdminAuth0mgmtResultAggregateArgs = {
  distinct_on?: Maybe<Array<AdminAuth0mgmtResultSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminAuth0mgmtResultOrderBy>>;
  where?: Maybe<AdminAuth0mgmtResultBoolExp>;
};


/** subscription root */
export type SubscriptionRootAdminAuth0mgmtResultByPkArgs = {
  auth0mgmt_id: Scalars['Int'];
};


/** subscription root */
export type SubscriptionRootAdminEmailArgs = {
  distinct_on?: Maybe<Array<AdminEmailSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminEmailOrderBy>>;
  where?: Maybe<AdminEmailBoolExp>;
};


/** subscription root */
export type SubscriptionRootAdminEmailAggregateArgs = {
  distinct_on?: Maybe<Array<AdminEmailSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminEmailOrderBy>>;
  where?: Maybe<AdminEmailBoolExp>;
};


/** subscription root */
export type SubscriptionRootAdminEmailByPkArgs = {
  email_id: Scalars['Int'];
};


/** subscription root */
export type SubscriptionRootAdminEmailLayoutArgs = {
  distinct_on?: Maybe<Array<AdminEmailLayoutSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminEmailLayoutOrderBy>>;
  where?: Maybe<AdminEmailLayoutBoolExp>;
};


/** subscription root */
export type SubscriptionRootAdminEmailLayoutAggregateArgs = {
  distinct_on?: Maybe<Array<AdminEmailLayoutSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminEmailLayoutOrderBy>>;
  where?: Maybe<AdminEmailLayoutBoolExp>;
};


/** subscription root */
export type SubscriptionRootAdminEmailLayoutByPkArgs = {
  email_layout_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootAdminEmailTemplateArgs = {
  distinct_on?: Maybe<Array<AdminEmailTemplateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminEmailTemplateOrderBy>>;
  where?: Maybe<AdminEmailTemplateBoolExp>;
};


/** subscription root */
export type SubscriptionRootAdminEmailTemplateAggregateArgs = {
  distinct_on?: Maybe<Array<AdminEmailTemplateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminEmailTemplateOrderBy>>;
  where?: Maybe<AdminEmailTemplateBoolExp>;
};


/** subscription root */
export type SubscriptionRootAdminEmailTemplateByPkArgs = {
  email_template_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootAdminTwiliomgmtArgs = {
  distinct_on?: Maybe<Array<AdminTwiliomgmtSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminTwiliomgmtOrderBy>>;
  where?: Maybe<AdminTwiliomgmtBoolExp>;
};


/** subscription root */
export type SubscriptionRootAdminTwiliomgmtAggregateArgs = {
  distinct_on?: Maybe<Array<AdminTwiliomgmtSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminTwiliomgmtOrderBy>>;
  where?: Maybe<AdminTwiliomgmtBoolExp>;
};


/** subscription root */
export type SubscriptionRootAdminTwiliomgmtByPkArgs = {
  twiliomgmt_id: Scalars['Int'];
};


/** subscription root */
export type SubscriptionRootAdminTwiliomgmtResultArgs = {
  distinct_on?: Maybe<Array<AdminTwiliomgmtResultSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminTwiliomgmtResultOrderBy>>;
  where?: Maybe<AdminTwiliomgmtResultBoolExp>;
};


/** subscription root */
export type SubscriptionRootAdminTwiliomgmtResultAggregateArgs = {
  distinct_on?: Maybe<Array<AdminTwiliomgmtResultSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AdminTwiliomgmtResultOrderBy>>;
  where?: Maybe<AdminTwiliomgmtResultBoolExp>;
};


/** subscription root */
export type SubscriptionRootAdminTwiliomgmtResultByPkArgs = {
  twiliomgmt_id: Scalars['Int'];
};


/** subscription root */
export type SubscriptionRootDbPingArgs = {
  distinct_on?: Maybe<Array<DbPingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DbPingOrderBy>>;
  where?: Maybe<DbPingBoolExp>;
};


/** subscription root */
export type SubscriptionRootDbPingAggregateArgs = {
  distinct_on?: Maybe<Array<DbPingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DbPingOrderBy>>;
  where?: Maybe<DbPingBoolExp>;
};


/** subscription root */
export type SubscriptionRootDbPingByPkArgs = {
  id: Scalars['Int'];
};


/** subscription root */
export type SubscriptionRootDbStateArgs = {
  distinct_on?: Maybe<Array<DbStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DbStateOrderBy>>;
  where?: Maybe<DbStateBoolExp>;
};


/** subscription root */
export type SubscriptionRootDbStateAggregateArgs = {
  distinct_on?: Maybe<Array<DbStateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<DbStateOrderBy>>;
  where?: Maybe<DbStateBoolExp>;
};


/** subscription root */
export type SubscriptionRootDbStateByPkArgs = {
  key: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradAchievementArgs = {
  distinct_on?: Maybe<Array<GradAchievementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradAchievementOrderBy>>;
  where?: Maybe<GradAchievementBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradAchievementAggregateArgs = {
  distinct_on?: Maybe<Array<GradAchievementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradAchievementOrderBy>>;
  where?: Maybe<GradAchievementBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradAchievementByPkArgs = {
  achievement_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradAwardArgs = {
  distinct_on?: Maybe<Array<GradAwardSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradAwardOrderBy>>;
  where?: Maybe<GradAwardBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradAwardAggregateArgs = {
  distinct_on?: Maybe<Array<GradAwardSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradAwardOrderBy>>;
  where?: Maybe<GradAwardBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradAwardByPkArgs = {
  award_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradBookmarkJobArgs = {
  distinct_on?: Maybe<Array<GradBookmarkJobSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradBookmarkJobOrderBy>>;
  where?: Maybe<GradBookmarkJobBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradBookmarkJobAggregateArgs = {
  distinct_on?: Maybe<Array<GradBookmarkJobSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradBookmarkJobOrderBy>>;
  where?: Maybe<GradBookmarkJobBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradBookmarkJobByPkArgs = {
  bookmark_job_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradCityStateSelectionArgs = {
  distinct_on?: Maybe<Array<GradCityStateSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradCityStateSelectionOrderBy>>;
  where?: Maybe<GradCityStateSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradCityStateSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradCityStateSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradCityStateSelectionOrderBy>>;
  where?: Maybe<GradCityStateSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradCityStateSelectionByPkArgs = {
  city_state_selection_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradCommPreferenceSelectionArgs = {
  distinct_on?: Maybe<Array<GradCommPreferenceSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradCommPreferenceSelectionOrderBy>>;
  where?: Maybe<GradCommPreferenceSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradCommPreferenceSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradCommPreferenceSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradCommPreferenceSelectionOrderBy>>;
  where?: Maybe<GradCommPreferenceSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradCommPreferenceSelectionByPkArgs = {
  comm_preference_selection_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradCompanySelectionArgs = {
  distinct_on?: Maybe<Array<GradCompanySelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradCompanySelectionOrderBy>>;
  where?: Maybe<GradCompanySelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradCompanySelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradCompanySelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradCompanySelectionOrderBy>>;
  where?: Maybe<GradCompanySelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradCompanySelectionByPkArgs = {
  company_selection_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradComputerLanguageArgs = {
  distinct_on?: Maybe<Array<GradComputerLanguageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradComputerLanguageOrderBy>>;
  where?: Maybe<GradComputerLanguageBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradComputerLanguageAggregateArgs = {
  distinct_on?: Maybe<Array<GradComputerLanguageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradComputerLanguageOrderBy>>;
  where?: Maybe<GradComputerLanguageBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradComputerLanguageByPkArgs = {
  computer_language_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradComputerLanguageSelectionArgs = {
  distinct_on?: Maybe<Array<GradComputerLanguageSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradComputerLanguageSelectionOrderBy>>;
  where?: Maybe<GradComputerLanguageSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradComputerLanguageSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradComputerLanguageSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradComputerLanguageSelectionOrderBy>>;
  where?: Maybe<GradComputerLanguageSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradComputerLanguageSelectionByPkArgs = {
  computer_language: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradConcentrationArgs = {
  distinct_on?: Maybe<Array<GradConcentrationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradConcentrationOrderBy>>;
  where?: Maybe<GradConcentrationBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradConcentrationAggregateArgs = {
  distinct_on?: Maybe<Array<GradConcentrationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradConcentrationOrderBy>>;
  where?: Maybe<GradConcentrationBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradConcentrationByPkArgs = {
  concentration_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradCountrySelectionArgs = {
  distinct_on?: Maybe<Array<GradCountrySelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradCountrySelectionOrderBy>>;
  where?: Maybe<GradCountrySelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradCountrySelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradCountrySelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradCountrySelectionOrderBy>>;
  where?: Maybe<GradCountrySelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradCountrySelectionByPkArgs = {
  country_selection_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradDegreeArgs = {
  distinct_on?: Maybe<Array<GradDegreeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradDegreeOrderBy>>;
  where?: Maybe<GradDegreeBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradDegreeAggregateArgs = {
  distinct_on?: Maybe<Array<GradDegreeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradDegreeOrderBy>>;
  where?: Maybe<GradDegreeBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradDegreeByPkArgs = {
  degree_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradDegreeFillInUniversityArgs = {
  distinct_on?: Maybe<Array<GradDegreeFillInUniversitySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradDegreeFillInUniversityOrderBy>>;
  where?: Maybe<GradDegreeFillInUniversityBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradDegreeFillInUniversityAggregateArgs = {
  distinct_on?: Maybe<Array<GradDegreeFillInUniversitySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradDegreeFillInUniversityOrderBy>>;
  where?: Maybe<GradDegreeFillInUniversityBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradDegreeFillInUniversityByPkArgs = {
  degree_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradDegreeLatestArgs = {
  distinct_on?: Maybe<Array<GradDegreeLatestSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradDegreeLatestOrderBy>>;
  where?: Maybe<GradDegreeLatestBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradDegreeLatestAggregateArgs = {
  distinct_on?: Maybe<Array<GradDegreeLatestSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradDegreeLatestOrderBy>>;
  where?: Maybe<GradDegreeLatestBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradDegreeSelectionArgs = {
  distinct_on?: Maybe<Array<GradDegreeSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradDegreeSelectionOrderBy>>;
  where?: Maybe<GradDegreeSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradDegreeSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradDegreeSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradDegreeSelectionOrderBy>>;
  where?: Maybe<GradDegreeSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradDegreeSelectionByPkArgs = {
  degree_selection_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradEmployerPreferenceArgs = {
  distinct_on?: Maybe<Array<GradEmployerPreferenceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradEmployerPreferenceOrderBy>>;
  where?: Maybe<GradEmployerPreferenceBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradEmployerPreferenceAggregateArgs = {
  distinct_on?: Maybe<Array<GradEmployerPreferenceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradEmployerPreferenceOrderBy>>;
  where?: Maybe<GradEmployerPreferenceBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradEmployerPreferenceByPkArgs = {
  employer_preference_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradEmployerPreferenceSelectionArgs = {
  distinct_on?: Maybe<Array<GradEmployerPreferenceSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradEmployerPreferenceSelectionOrderBy>>;
  where?: Maybe<GradEmployerPreferenceSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradEmployerPreferenceSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradEmployerPreferenceSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradEmployerPreferenceSelectionOrderBy>>;
  where?: Maybe<GradEmployerPreferenceSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradEmployerPreferenceSelectionByPkArgs = {
  employer_preference_selection_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradEventRegistrationArgs = {
  distinct_on?: Maybe<Array<GradEventRegistrationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradEventRegistrationOrderBy>>;
  where?: Maybe<GradEventRegistrationBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradEventRegistrationAggregateArgs = {
  distinct_on?: Maybe<Array<GradEventRegistrationSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradEventRegistrationOrderBy>>;
  where?: Maybe<GradEventRegistrationBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradEventRegistrationByPkArgs = {
  event_registration_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradFunFactArgs = {
  distinct_on?: Maybe<Array<GradFunFactSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradFunFactOrderBy>>;
  where?: Maybe<GradFunFactBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradFunFactAggregateArgs = {
  distinct_on?: Maybe<Array<GradFunFactSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradFunFactOrderBy>>;
  where?: Maybe<GradFunFactBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradFunFactByPkArgs = {
  fun_fact_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradFunFactSelectionArgs = {
  distinct_on?: Maybe<Array<GradFunFactSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradFunFactSelectionOrderBy>>;
  where?: Maybe<GradFunFactSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradFunFactSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradFunFactSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradFunFactSelectionOrderBy>>;
  where?: Maybe<GradFunFactSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradFunFactSelectionByPkArgs = {
  fun_fact_selection_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradInterestFirmArgs = {
  distinct_on?: Maybe<Array<GradInterestFirmSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestFirmOrderBy>>;
  where?: Maybe<GradInterestFirmBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradInterestFirmAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestFirmSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestFirmOrderBy>>;
  where?: Maybe<GradInterestFirmBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradInterestFirmByPkArgs = {
  interest_firm_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradInterestFirmSelectionArgs = {
  distinct_on?: Maybe<Array<GradInterestFirmSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestFirmSelectionOrderBy>>;
  where?: Maybe<GradInterestFirmSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradInterestFirmSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestFirmSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestFirmSelectionOrderBy>>;
  where?: Maybe<GradInterestFirmSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradInterestFirmSelectionByPkArgs = {
  interest_firm_selection_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradInterestJobTypeArgs = {
  distinct_on?: Maybe<Array<GradInterestJobTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestJobTypeOrderBy>>;
  where?: Maybe<GradInterestJobTypeBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradInterestJobTypeAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestJobTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestJobTypeOrderBy>>;
  where?: Maybe<GradInterestJobTypeBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradInterestJobTypeByPkArgs = {
  interest_job_type_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradInterestJobTypeSelectionArgs = {
  distinct_on?: Maybe<Array<GradInterestJobTypeSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestJobTypeSelectionOrderBy>>;
  where?: Maybe<GradInterestJobTypeSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradInterestJobTypeSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestJobTypeSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestJobTypeSelectionOrderBy>>;
  where?: Maybe<GradInterestJobTypeSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradInterestJobTypeSelectionByPkArgs = {
  interest_job_type_selection_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradInterestRegionArgs = {
  distinct_on?: Maybe<Array<GradInterestRegionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRegionOrderBy>>;
  where?: Maybe<GradInterestRegionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradInterestRegionAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestRegionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRegionOrderBy>>;
  where?: Maybe<GradInterestRegionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradInterestRegionByPkArgs = {
  interest_region_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradInterestRegionSelectionArgs = {
  distinct_on?: Maybe<Array<GradInterestRegionSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRegionSelectionOrderBy>>;
  where?: Maybe<GradInterestRegionSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradInterestRegionSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestRegionSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRegionSelectionOrderBy>>;
  where?: Maybe<GradInterestRegionSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradInterestRegionSelectionByPkArgs = {
  interest_region_selection_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradInterestRoleArgs = {
  distinct_on?: Maybe<Array<GradInterestRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRoleOrderBy>>;
  where?: Maybe<GradInterestRoleBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradInterestRoleAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestRoleSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRoleOrderBy>>;
  where?: Maybe<GradInterestRoleBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradInterestRoleByPkArgs = {
  interest_role_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradInterestRoleSelectionArgs = {
  distinct_on?: Maybe<Array<GradInterestRoleSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRoleSelectionOrderBy>>;
  where?: Maybe<GradInterestRoleSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradInterestRoleSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradInterestRoleSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradInterestRoleSelectionOrderBy>>;
  where?: Maybe<GradInterestRoleSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradInterestRoleSelectionByPkArgs = {
  interest_role_selection_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradMajorSelectionArgs = {
  distinct_on?: Maybe<Array<GradMajorSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradMajorSelectionOrderBy>>;
  where?: Maybe<GradMajorSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradMajorSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradMajorSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradMajorSelectionOrderBy>>;
  where?: Maybe<GradMajorSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradMajorSelectionByPkArgs = {
  major_selection_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradPageViewArgs = {
  distinct_on?: Maybe<Array<GradPageViewSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradPageViewOrderBy>>;
  where?: Maybe<GradPageViewBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradPageViewAggregateArgs = {
  distinct_on?: Maybe<Array<GradPageViewSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradPageViewOrderBy>>;
  where?: Maybe<GradPageViewBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradPageViewByPkArgs = {
  page_view_id: Scalars['bigint'];
};


/** subscription root */
export type SubscriptionRootGradProfileArgs = {
  distinct_on?: Maybe<Array<GradProfileSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradProfileOrderBy>>;
  where?: Maybe<GradProfileBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradProfileAggregateArgs = {
  distinct_on?: Maybe<Array<GradProfileSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradProfileOrderBy>>;
  where?: Maybe<GradProfileBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradProfileByPkArgs = {
  user_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradProfileCombineArgs = {
  distinct_on?: Maybe<Array<GradProfileCombineSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradProfileCombineOrderBy>>;
  where?: Maybe<GradProfileCombineBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradProfileCombineAggregateArgs = {
  distinct_on?: Maybe<Array<GradProfileCombineSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradProfileCombineOrderBy>>;
  where?: Maybe<GradProfileCombineBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradRaiseHandArgs = {
  distinct_on?: Maybe<Array<GradRaiseHandSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradRaiseHandOrderBy>>;
  where?: Maybe<GradRaiseHandBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradRaiseHandAggregateArgs = {
  distinct_on?: Maybe<Array<GradRaiseHandSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradRaiseHandOrderBy>>;
  where?: Maybe<GradRaiseHandBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradRaiseHandByPkArgs = {
  raise__hand_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradSpokenLanguageArgs = {
  distinct_on?: Maybe<Array<GradSpokenLanguageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradSpokenLanguageOrderBy>>;
  where?: Maybe<GradSpokenLanguageBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradSpokenLanguageAggregateArgs = {
  distinct_on?: Maybe<Array<GradSpokenLanguageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradSpokenLanguageOrderBy>>;
  where?: Maybe<GradSpokenLanguageBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradSpokenLanguageByPkArgs = {
  spoken_language_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradTestScoreArgs = {
  distinct_on?: Maybe<Array<GradTestScoreSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradTestScoreOrderBy>>;
  where?: Maybe<GradTestScoreBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradTestScoreAggregateArgs = {
  distinct_on?: Maybe<Array<GradTestScoreSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradTestScoreOrderBy>>;
  where?: Maybe<GradTestScoreBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradTestScoreByPkArgs = {
  test_score_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradTestScoreDetailArgs = {
  distinct_on?: Maybe<Array<GradTestScoreDetailSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradTestScoreDetailOrderBy>>;
  where?: Maybe<GradTestScoreDetailBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradTestScoreDetailAggregateArgs = {
  distinct_on?: Maybe<Array<GradTestScoreDetailSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradTestScoreDetailOrderBy>>;
  where?: Maybe<GradTestScoreDetailBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradTestScoreDetailByPkArgs = {
  test_score_detail_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradUniversitySelectionArgs = {
  distinct_on?: Maybe<Array<GradUniversitySelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradUniversitySelectionOrderBy>>;
  where?: Maybe<GradUniversitySelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradUniversitySelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradUniversitySelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradUniversitySelectionOrderBy>>;
  where?: Maybe<GradUniversitySelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradUniversitySelectionByPkArgs = {
  university_selection_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradUniversityStatArgs = {
  distinct_on?: Maybe<Array<GradUniversityStatSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradUniversityStatOrderBy>>;
  where?: Maybe<GradUniversityStatBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradUniversityStatAggregateArgs = {
  distinct_on?: Maybe<Array<GradUniversityStatSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradUniversityStatOrderBy>>;
  where?: Maybe<GradUniversityStatBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradUploadDocArgs = {
  distinct_on?: Maybe<Array<GradUploadDocSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradUploadDocOrderBy>>;
  where?: Maybe<GradUploadDocBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradUploadDocAggregateArgs = {
  distinct_on?: Maybe<Array<GradUploadDocSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradUploadDocOrderBy>>;
  where?: Maybe<GradUploadDocBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradUploadDocByPkArgs = {
  upload_doc_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradUserActivitySummaryArgs = {
  distinct_on?: Maybe<Array<GradUserActivitySummarySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradUserActivitySummaryOrderBy>>;
  where?: Maybe<GradUserActivitySummaryBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradUserActivitySummaryAggregateArgs = {
  distinct_on?: Maybe<Array<GradUserActivitySummarySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradUserActivitySummaryOrderBy>>;
  where?: Maybe<GradUserActivitySummaryBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradUserActivitySummaryByPkArgs = {
  user_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradVisaSelectionArgs = {
  distinct_on?: Maybe<Array<GradVisaSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradVisaSelectionOrderBy>>;
  where?: Maybe<GradVisaSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradVisaSelectionAggregateArgs = {
  distinct_on?: Maybe<Array<GradVisaSelectionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradVisaSelectionOrderBy>>;
  where?: Maybe<GradVisaSelectionBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradVisaSelectionByPkArgs = {
  visa_selection_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradVolunteerArgs = {
  distinct_on?: Maybe<Array<GradVolunteerSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradVolunteerOrderBy>>;
  where?: Maybe<GradVolunteerBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradVolunteerAggregateArgs = {
  distinct_on?: Maybe<Array<GradVolunteerSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradVolunteerOrderBy>>;
  where?: Maybe<GradVolunteerBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradVolunteerByPkArgs = {
  volunteer_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootGradWorkExperienceArgs = {
  distinct_on?: Maybe<Array<GradWorkExperienceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradWorkExperienceOrderBy>>;
  where?: Maybe<GradWorkExperienceBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradWorkExperienceAggregateArgs = {
  distinct_on?: Maybe<Array<GradWorkExperienceSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradWorkExperienceOrderBy>>;
  where?: Maybe<GradWorkExperienceBoolExp>;
};


/** subscription root */
export type SubscriptionRootGradWorkExperienceByPkArgs = {
  work_experience_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootQueueHandlerPermissionArgs = {
  distinct_on?: Maybe<Array<QueueHandlerPermissionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<QueueHandlerPermissionOrderBy>>;
  where?: Maybe<QueueHandlerPermissionBoolExp>;
};


/** subscription root */
export type SubscriptionRootQueueHandlerPermissionAggregateArgs = {
  distinct_on?: Maybe<Array<QueueHandlerPermissionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<QueueHandlerPermissionOrderBy>>;
  where?: Maybe<QueueHandlerPermissionBoolExp>;
};


/** subscription root */
export type SubscriptionRootQueueHandlerPermissionByPkArgs = {
  queue: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootRecruitAccountArgs = {
  distinct_on?: Maybe<Array<RecruitAccountSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitAccountOrderBy>>;
  where?: Maybe<RecruitAccountBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitAccountAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitAccountSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitAccountOrderBy>>;
  where?: Maybe<RecruitAccountBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitAccountByPkArgs = {
  account_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootRecruitCompanyArgs = {
  distinct_on?: Maybe<Array<RecruitCompanySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitCompanyOrderBy>>;
  where?: Maybe<RecruitCompanyBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitCompanyAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitCompanySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitCompanyOrderBy>>;
  where?: Maybe<RecruitCompanyBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitCompanyByPkArgs = {
  company_id: Scalars['Int'];
};


/** subscription root */
export type SubscriptionRootRecruitCompanySubindustryArgs = {
  distinct_on?: Maybe<Array<RecruitCompanySubindustrySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitCompanySubindustryOrderBy>>;
  where?: Maybe<RecruitCompanySubindustryBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitCompanySubindustryAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitCompanySubindustrySelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitCompanySubindustryOrderBy>>;
  where?: Maybe<RecruitCompanySubindustryBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitCompanySubindustryByPkArgs = {
  company_subindustry_id: Scalars['Int'];
};


/** subscription root */
export type SubscriptionRootRecruitEventArgs = {
  distinct_on?: Maybe<Array<RecruitEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitEventOrderBy>>;
  where?: Maybe<RecruitEventBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitEventAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitEventSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitEventOrderBy>>;
  where?: Maybe<RecruitEventBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitEventByPkArgs = {
  event_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootRecruitGradGroupArgs = {
  distinct_on?: Maybe<Array<RecruitGradGroupSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitGradGroupOrderBy>>;
  where?: Maybe<RecruitGradGroupBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitGradGroupAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitGradGroupSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitGradGroupOrderBy>>;
  where?: Maybe<RecruitGradGroupBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitGradGroupByPkArgs = {
  grad_group_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootRecruitGradGroupMemberArgs = {
  distinct_on?: Maybe<Array<RecruitGradGroupMemberSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitGradGroupMemberOrderBy>>;
  where?: Maybe<RecruitGradGroupMemberBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitGradGroupMemberAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitGradGroupMemberSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitGradGroupMemberOrderBy>>;
  where?: Maybe<RecruitGradGroupMemberBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitGradGroupMemberByPkArgs = {
  grad_group_id: Scalars['String'];
  recruiter_user_id: Scalars['String'];
  student_user_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootRecruitJobPostingArgs = {
  distinct_on?: Maybe<Array<RecruitJobPostingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitJobPostingOrderBy>>;
  where?: Maybe<RecruitJobPostingBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitJobPostingAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitJobPostingSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitJobPostingOrderBy>>;
  where?: Maybe<RecruitJobPostingBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitJobPostingByPkArgs = {
  job_posting_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootRecruitJobRequirementArgs = {
  distinct_on?: Maybe<Array<RecruitJobRequirementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitJobRequirementOrderBy>>;
  where?: Maybe<RecruitJobRequirementBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitJobRequirementAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitJobRequirementSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitJobRequirementOrderBy>>;
  where?: Maybe<RecruitJobRequirementBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitJobRequirementByPkArgs = {
  job_requirement_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootRecruitJobRequirementValueArgs = {
  distinct_on?: Maybe<Array<RecruitJobRequirementValueSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitJobRequirementValueOrderBy>>;
  where?: Maybe<RecruitJobRequirementValueBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitJobRequirementValueAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitJobRequirementValueSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitJobRequirementValueOrderBy>>;
  where?: Maybe<RecruitJobRequirementValueBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitJobRequirementValueByPkArgs = {
  job_requirement_value_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootRecruitRecruiterArgs = {
  distinct_on?: Maybe<Array<RecruitRecruiterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitRecruiterOrderBy>>;
  where?: Maybe<RecruitRecruiterBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitRecruiterAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitRecruiterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitRecruiterOrderBy>>;
  where?: Maybe<RecruitRecruiterBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitRecruiterByPkArgs = {
  user_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootRecruitSavedSearchArgs = {
  distinct_on?: Maybe<Array<RecruitSavedSearchSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSavedSearchOrderBy>>;
  where?: Maybe<RecruitSavedSearchBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitSavedSearchAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitSavedSearchSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSavedSearchOrderBy>>;
  where?: Maybe<RecruitSavedSearchBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitSavedSearchByPkArgs = {
  saved_search_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootRecruitSmsCorrespondentArgs = {
  distinct_on?: Maybe<Array<RecruitSmsCorrespondentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsCorrespondentOrderBy>>;
  where?: Maybe<RecruitSmsCorrespondentBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitSmsCorrespondentAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitSmsCorrespondentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsCorrespondentOrderBy>>;
  where?: Maybe<RecruitSmsCorrespondentBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitSmsCorrespondentByPkArgs = {
  sms_correspondent_id: Scalars['Int'];
};


/** subscription root */
export type SubscriptionRootRecruitSmsMessageArgs = {
  distinct_on?: Maybe<Array<RecruitSmsMessageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsMessageOrderBy>>;
  where?: Maybe<RecruitSmsMessageBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitSmsMessageAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitSmsMessageSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsMessageOrderBy>>;
  where?: Maybe<RecruitSmsMessageBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitSmsMessageByPkArgs = {
  sms_message_id: Scalars['Int'];
};


/** subscription root */
export type SubscriptionRootRecruitSmsMessageCorrespondentArgs = {
  distinct_on?: Maybe<Array<RecruitSmsMessageCorrespondentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsMessageCorrespondentOrderBy>>;
  where?: Maybe<RecruitSmsMessageCorrespondentBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitSmsMessageCorrespondentAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitSmsMessageCorrespondentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsMessageCorrespondentOrderBy>>;
  where?: Maybe<RecruitSmsMessageCorrespondentBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitSmsMessageCorrespondentByPkArgs = {
  sms_message_correspondent_id: Scalars['Int'];
};


/** subscription root */
export type SubscriptionRootRecruitSmsTemplateArgs = {
  distinct_on?: Maybe<Array<RecruitSmsTemplateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsTemplateOrderBy>>;
  where?: Maybe<RecruitSmsTemplateBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitSmsTemplateAggregateArgs = {
  distinct_on?: Maybe<Array<RecruitSmsTemplateSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RecruitSmsTemplateOrderBy>>;
  where?: Maybe<RecruitSmsTemplateBoolExp>;
};


/** subscription root */
export type SubscriptionRootRecruitSmsTemplateByPkArgs = {
  sms_template_id: Scalars['Int'];
};


/** subscription root */
export type SubscriptionRootTestAuto3Args = {
  distinct_on?: Maybe<Array<TestAuto3SelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TestAuto3OrderBy>>;
  where?: Maybe<TestAuto3BoolExp>;
};


/** subscription root */
export type SubscriptionRootTestAuto3AggregateArgs = {
  distinct_on?: Maybe<Array<TestAuto3SelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TestAuto3OrderBy>>;
  where?: Maybe<TestAuto3BoolExp>;
};


/** subscription root */
export type SubscriptionRootTestAuto3ByPkArgs = {
  id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootToQueueArgs = {
  distinct_on?: Maybe<Array<ToQueueSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ToQueueOrderBy>>;
  where?: Maybe<ToQueueBoolExp>;
};


/** subscription root */
export type SubscriptionRootToQueueAggregateArgs = {
  distinct_on?: Maybe<Array<ToQueueSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ToQueueOrderBy>>;
  where?: Maybe<ToQueueBoolExp>;
};


/** subscription root */
export type SubscriptionRootToQueueByPkArgs = {
  to_queue_id: Scalars['Int'];
};


/** subscription root */
export type SubscriptionRootToQueueResponseArgs = {
  distinct_on?: Maybe<Array<ToQueueResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ToQueueResponseOrderBy>>;
  where?: Maybe<ToQueueResponseBoolExp>;
};


/** subscription root */
export type SubscriptionRootToQueueResponseAggregateArgs = {
  distinct_on?: Maybe<Array<ToQueueResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ToQueueResponseOrderBy>>;
  where?: Maybe<ToQueueResponseBoolExp>;
};


/** subscription root */
export type SubscriptionRootToQueueResponseByPkArgs = {
  to_queue_id: Scalars['Int'];
};


/** subscription root */
export type SubscriptionRootUserAuthArgs = {
  distinct_on?: Maybe<Array<UserAuthSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<UserAuthOrderBy>>;
  where?: Maybe<UserAuthBoolExp>;
};


/** subscription root */
export type SubscriptionRootUserAuthAggregateArgs = {
  distinct_on?: Maybe<Array<UserAuthSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<UserAuthOrderBy>>;
  where?: Maybe<UserAuthBoolExp>;
};


/** subscription root */
export type SubscriptionRootUserAuthByPkArgs = {
  email: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootUseraccountArgs = {
  distinct_on?: Maybe<Array<UseraccountSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<UseraccountOrderBy>>;
  where?: Maybe<UseraccountBoolExp>;
};


/** subscription root */
export type SubscriptionRootUseraccountAggregateArgs = {
  distinct_on?: Maybe<Array<UseraccountSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<UseraccountOrderBy>>;
  where?: Maybe<UseraccountBoolExp>;
};


/** subscription root */
export type SubscriptionRootUseraccountByPkArgs = {
  user_id: Scalars['String'];
};


/** subscription root */
export type SubscriptionRootWebApiPermissionArgs = {
  distinct_on?: Maybe<Array<WebApiPermissionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<WebApiPermissionOrderBy>>;
  where?: Maybe<WebApiPermissionBoolExp>;
};


/** subscription root */
export type SubscriptionRootWebApiPermissionAggregateArgs = {
  distinct_on?: Maybe<Array<WebApiPermissionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<WebApiPermissionOrderBy>>;
  where?: Maybe<WebApiPermissionBoolExp>;
};


/** subscription root */
export type SubscriptionRootWebApiPermissionByPkArgs = {
  fn: Scalars['String'];
};

/** columns and relationships of "test_auto3" */
export type TestAuto3 = {
  __typename?: 'test_auto3';
  col1: Scalars['String'];
  col2: Scalars['String'];
  coldouble?: Maybe<Scalars['float8']>;
  colint?: Maybe<Scalars['Int']>;
  colnumeric?: Maybe<Scalars['numeric']>;
  id: Scalars['String'];
};

/** aggregated selection of "test_auto3" */
export type TestAuto3Aggregate = {
  __typename?: 'test_auto3_aggregate';
  aggregate?: Maybe<TestAuto3AggregateFields>;
  nodes: Array<TestAuto3>;
};

/** aggregate fields of "test_auto3" */
export type TestAuto3AggregateFields = {
  __typename?: 'test_auto3_aggregate_fields';
  avg?: Maybe<TestAuto3AvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<TestAuto3MaxFields>;
  min?: Maybe<TestAuto3MinFields>;
  stddev?: Maybe<TestAuto3StddevFields>;
  stddev_pop?: Maybe<TestAuto3StddevPopFields>;
  stddev_samp?: Maybe<TestAuto3StddevSampFields>;
  sum?: Maybe<TestAuto3SumFields>;
  var_pop?: Maybe<TestAuto3VarPopFields>;
  var_samp?: Maybe<TestAuto3VarSampFields>;
  variance?: Maybe<TestAuto3VarianceFields>;
};


/** aggregate fields of "test_auto3" */
export type TestAuto3AggregateFieldsCountArgs = {
  columns?: Maybe<Array<TestAuto3SelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "test_auto3" */
export type TestAuto3AggregateOrderBy = {
  avg?: Maybe<TestAuto3AvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<TestAuto3MaxOrderBy>;
  min?: Maybe<TestAuto3MinOrderBy>;
  stddev?: Maybe<TestAuto3StddevOrderBy>;
  stddev_pop?: Maybe<TestAuto3StddevPopOrderBy>;
  stddev_samp?: Maybe<TestAuto3StddevSampOrderBy>;
  sum?: Maybe<TestAuto3SumOrderBy>;
  var_pop?: Maybe<TestAuto3VarPopOrderBy>;
  var_samp?: Maybe<TestAuto3VarSampOrderBy>;
  variance?: Maybe<TestAuto3VarianceOrderBy>;
};

/** input type for inserting array relation for remote table "test_auto3" */
export type TestAuto3ArrRelInsertInput = {
  data: Array<TestAuto3InsertInput>;
  on_conflict?: Maybe<TestAuto3OnConflict>;
};

/** aggregate avg on columns */
export type TestAuto3AvgFields = {
  __typename?: 'test_auto3_avg_fields';
  coldouble?: Maybe<Scalars['Float']>;
  colint?: Maybe<Scalars['Float']>;
  colnumeric?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "test_auto3" */
export type TestAuto3AvgOrderBy = {
  coldouble?: Maybe<OrderBy>;
  colint?: Maybe<OrderBy>;
  colnumeric?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "test_auto3". All fields are combined with a logical 'AND'. */
export type TestAuto3BoolExp = {
  _and?: Maybe<Array<Maybe<TestAuto3BoolExp>>>;
  _not?: Maybe<TestAuto3BoolExp>;
  _or?: Maybe<Array<Maybe<TestAuto3BoolExp>>>;
  col1?: Maybe<StringComparisonExp>;
  col2?: Maybe<StringComparisonExp>;
  coldouble?: Maybe<Float8ComparisonExp>;
  colint?: Maybe<IntComparisonExp>;
  colnumeric?: Maybe<NumericComparisonExp>;
  id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "test_auto3" */
export enum TestAuto3Constraint {
  /** unique or primary key constraint */
  TestAuto3Pkey = 'test_auto3_pkey'
}

/** input type for incrementing integer column in table "test_auto3" */
export type TestAuto3IncInput = {
  coldouble?: Maybe<Scalars['float8']>;
  colint?: Maybe<Scalars['Int']>;
  colnumeric?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "test_auto3" */
export type TestAuto3InsertInput = {
  col1?: Maybe<Scalars['String']>;
  col2?: Maybe<Scalars['String']>;
  coldouble?: Maybe<Scalars['float8']>;
  colint?: Maybe<Scalars['Int']>;
  colnumeric?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type TestAuto3MaxFields = {
  __typename?: 'test_auto3_max_fields';
  col1?: Maybe<Scalars['String']>;
  col2?: Maybe<Scalars['String']>;
  coldouble?: Maybe<Scalars['float8']>;
  colint?: Maybe<Scalars['Int']>;
  colnumeric?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "test_auto3" */
export type TestAuto3MaxOrderBy = {
  col1?: Maybe<OrderBy>;
  col2?: Maybe<OrderBy>;
  coldouble?: Maybe<OrderBy>;
  colint?: Maybe<OrderBy>;
  colnumeric?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type TestAuto3MinFields = {
  __typename?: 'test_auto3_min_fields';
  col1?: Maybe<Scalars['String']>;
  col2?: Maybe<Scalars['String']>;
  coldouble?: Maybe<Scalars['float8']>;
  colint?: Maybe<Scalars['Int']>;
  colnumeric?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "test_auto3" */
export type TestAuto3MinOrderBy = {
  col1?: Maybe<OrderBy>;
  col2?: Maybe<OrderBy>;
  coldouble?: Maybe<OrderBy>;
  colint?: Maybe<OrderBy>;
  colnumeric?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "test_auto3" */
export type TestAuto3MutationResponse = {
  __typename?: 'test_auto3_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<TestAuto3>;
};

/** input type for inserting object relation for remote table "test_auto3" */
export type TestAuto3ObjRelInsertInput = {
  data: TestAuto3InsertInput;
  on_conflict?: Maybe<TestAuto3OnConflict>;
};

/** on conflict condition type for table "test_auto3" */
export type TestAuto3OnConflict = {
  constraint: TestAuto3Constraint;
  update_columns: Array<TestAuto3UpdateColumn>;
  where?: Maybe<TestAuto3BoolExp>;
};

/** ordering options when selecting data from "test_auto3" */
export type TestAuto3OrderBy = {
  col1?: Maybe<OrderBy>;
  col2?: Maybe<OrderBy>;
  coldouble?: Maybe<OrderBy>;
  colint?: Maybe<OrderBy>;
  colnumeric?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "test_auto3" */
export type TestAuto3PkColumnsInput = {
  id: Scalars['String'];
};

/** select columns of table "test_auto3" */
export enum TestAuto3SelectColumn {
  /** column name */
  Col1 = 'col1',
  /** column name */
  Col2 = 'col2',
  /** column name */
  Coldouble = 'coldouble',
  /** column name */
  Colint = 'colint',
  /** column name */
  Colnumeric = 'colnumeric',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "test_auto3" */
export type TestAuto3SetInput = {
  col1?: Maybe<Scalars['String']>;
  col2?: Maybe<Scalars['String']>;
  coldouble?: Maybe<Scalars['float8']>;
  colint?: Maybe<Scalars['Int']>;
  colnumeric?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type TestAuto3StddevFields = {
  __typename?: 'test_auto3_stddev_fields';
  coldouble?: Maybe<Scalars['Float']>;
  colint?: Maybe<Scalars['Float']>;
  colnumeric?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "test_auto3" */
export type TestAuto3StddevOrderBy = {
  coldouble?: Maybe<OrderBy>;
  colint?: Maybe<OrderBy>;
  colnumeric?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type TestAuto3StddevPopFields = {
  __typename?: 'test_auto3_stddev_pop_fields';
  coldouble?: Maybe<Scalars['Float']>;
  colint?: Maybe<Scalars['Float']>;
  colnumeric?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "test_auto3" */
export type TestAuto3StddevPopOrderBy = {
  coldouble?: Maybe<OrderBy>;
  colint?: Maybe<OrderBy>;
  colnumeric?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type TestAuto3StddevSampFields = {
  __typename?: 'test_auto3_stddev_samp_fields';
  coldouble?: Maybe<Scalars['Float']>;
  colint?: Maybe<Scalars['Float']>;
  colnumeric?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "test_auto3" */
export type TestAuto3StddevSampOrderBy = {
  coldouble?: Maybe<OrderBy>;
  colint?: Maybe<OrderBy>;
  colnumeric?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type TestAuto3SumFields = {
  __typename?: 'test_auto3_sum_fields';
  coldouble?: Maybe<Scalars['float8']>;
  colint?: Maybe<Scalars['Int']>;
  colnumeric?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "test_auto3" */
export type TestAuto3SumOrderBy = {
  coldouble?: Maybe<OrderBy>;
  colint?: Maybe<OrderBy>;
  colnumeric?: Maybe<OrderBy>;
};

/** update columns of table "test_auto3" */
export enum TestAuto3UpdateColumn {
  /** column name */
  Col1 = 'col1',
  /** column name */
  Col2 = 'col2',
  /** column name */
  Coldouble = 'coldouble',
  /** column name */
  Colint = 'colint',
  /** column name */
  Colnumeric = 'colnumeric',
  /** column name */
  Id = 'id'
}

/** aggregate var_pop on columns */
export type TestAuto3VarPopFields = {
  __typename?: 'test_auto3_var_pop_fields';
  coldouble?: Maybe<Scalars['Float']>;
  colint?: Maybe<Scalars['Float']>;
  colnumeric?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "test_auto3" */
export type TestAuto3VarPopOrderBy = {
  coldouble?: Maybe<OrderBy>;
  colint?: Maybe<OrderBy>;
  colnumeric?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type TestAuto3VarSampFields = {
  __typename?: 'test_auto3_var_samp_fields';
  coldouble?: Maybe<Scalars['Float']>;
  colint?: Maybe<Scalars['Float']>;
  colnumeric?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "test_auto3" */
export type TestAuto3VarSampOrderBy = {
  coldouble?: Maybe<OrderBy>;
  colint?: Maybe<OrderBy>;
  colnumeric?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type TestAuto3VarianceFields = {
  __typename?: 'test_auto3_variance_fields';
  coldouble?: Maybe<Scalars['Float']>;
  colint?: Maybe<Scalars['Float']>;
  colnumeric?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "test_auto3" */
export type TestAuto3VarianceOrderBy = {
  coldouble?: Maybe<OrderBy>;
  colint?: Maybe<OrderBy>;
  colnumeric?: Maybe<OrderBy>;
};


/** expression to compare columns of type timestamp. All fields are combined with logical 'AND'. */
export type TimestampComparisonExp = {
  _eq?: Maybe<Scalars['timestamp']>;
  _gt?: Maybe<Scalars['timestamp']>;
  _gte?: Maybe<Scalars['timestamp']>;
  _in?: Maybe<Array<Scalars['timestamp']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamp']>;
  _lte?: Maybe<Scalars['timestamp']>;
  _neq?: Maybe<Scalars['timestamp']>;
  _nin?: Maybe<Array<Scalars['timestamp']>>;
};


/** expression to compare columns of type timestamptz. All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "to_queue" */
export type ToQueue = {
  __typename?: 'to_queue';
  content: Scalars['jsonb'];
  error_message?: Maybe<Scalars['String']>;
  queue_name: Scalars['String'];
  queued: Scalars['Boolean'];
  role?: Maybe<Scalars['String']>;
  timestamp: Scalars['timestamptz'];
  to_queue_id: Scalars['Int'];
  /** An array relationship */
  to_queue_responses: Array<ToQueueResponse>;
  /** An aggregated array relationship */
  to_queue_responses_aggregate: ToQueueResponseAggregate;
  user_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "to_queue" */
export type ToQueueContentArgs = {
  path?: Maybe<Scalars['String']>;
};


/** columns and relationships of "to_queue" */
export type ToQueueToQueueResponsesArgs = {
  distinct_on?: Maybe<Array<ToQueueResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ToQueueResponseOrderBy>>;
  where?: Maybe<ToQueueResponseBoolExp>;
};


/** columns and relationships of "to_queue" */
export type ToQueueToQueueResponsesAggregateArgs = {
  distinct_on?: Maybe<Array<ToQueueResponseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ToQueueResponseOrderBy>>;
  where?: Maybe<ToQueueResponseBoolExp>;
};

/** aggregated selection of "to_queue" */
export type ToQueueAggregate = {
  __typename?: 'to_queue_aggregate';
  aggregate?: Maybe<ToQueueAggregateFields>;
  nodes: Array<ToQueue>;
};

/** aggregate fields of "to_queue" */
export type ToQueueAggregateFields = {
  __typename?: 'to_queue_aggregate_fields';
  avg?: Maybe<ToQueueAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<ToQueueMaxFields>;
  min?: Maybe<ToQueueMinFields>;
  stddev?: Maybe<ToQueueStddevFields>;
  stddev_pop?: Maybe<ToQueueStddevPopFields>;
  stddev_samp?: Maybe<ToQueueStddevSampFields>;
  sum?: Maybe<ToQueueSumFields>;
  var_pop?: Maybe<ToQueueVarPopFields>;
  var_samp?: Maybe<ToQueueVarSampFields>;
  variance?: Maybe<ToQueueVarianceFields>;
};


/** aggregate fields of "to_queue" */
export type ToQueueAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ToQueueSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "to_queue" */
export type ToQueueAggregateOrderBy = {
  avg?: Maybe<ToQueueAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ToQueueMaxOrderBy>;
  min?: Maybe<ToQueueMinOrderBy>;
  stddev?: Maybe<ToQueueStddevOrderBy>;
  stddev_pop?: Maybe<ToQueueStddevPopOrderBy>;
  stddev_samp?: Maybe<ToQueueStddevSampOrderBy>;
  sum?: Maybe<ToQueueSumOrderBy>;
  var_pop?: Maybe<ToQueueVarPopOrderBy>;
  var_samp?: Maybe<ToQueueVarSampOrderBy>;
  variance?: Maybe<ToQueueVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ToQueueAppendInput = {
  content?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "to_queue" */
export type ToQueueArrRelInsertInput = {
  data: Array<ToQueueInsertInput>;
  on_conflict?: Maybe<ToQueueOnConflict>;
};

/** aggregate avg on columns */
export type ToQueueAvgFields = {
  __typename?: 'to_queue_avg_fields';
  to_queue_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "to_queue" */
export type ToQueueAvgOrderBy = {
  to_queue_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "to_queue". All fields are combined with a logical 'AND'. */
export type ToQueueBoolExp = {
  _and?: Maybe<Array<Maybe<ToQueueBoolExp>>>;
  _not?: Maybe<ToQueueBoolExp>;
  _or?: Maybe<Array<Maybe<ToQueueBoolExp>>>;
  content?: Maybe<JsonbComparisonExp>;
  error_message?: Maybe<StringComparisonExp>;
  queue_name?: Maybe<StringComparisonExp>;
  queued?: Maybe<BooleanComparisonExp>;
  role?: Maybe<StringComparisonExp>;
  timestamp?: Maybe<TimestamptzComparisonExp>;
  to_queue_id?: Maybe<IntComparisonExp>;
  to_queue_responses?: Maybe<ToQueueResponseBoolExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "to_queue" */
export enum ToQueueConstraint {
  /** unique or primary key constraint */
  ToQueuePkey = 'to_queue_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ToQueueDeleteAtPathInput = {
  content?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ToQueueDeleteElemInput = {
  content?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ToQueueDeleteKeyInput = {
  content?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "to_queue" */
export type ToQueueIncInput = {
  to_queue_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "to_queue" */
export type ToQueueInsertInput = {
  content?: Maybe<Scalars['jsonb']>;
  error_message?: Maybe<Scalars['String']>;
  queue_name?: Maybe<Scalars['String']>;
  queued?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  to_queue_id?: Maybe<Scalars['Int']>;
  to_queue_responses?: Maybe<ToQueueResponseArrRelInsertInput>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type ToQueueMaxFields = {
  __typename?: 'to_queue_max_fields';
  error_message?: Maybe<Scalars['String']>;
  queue_name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  to_queue_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "to_queue" */
export type ToQueueMaxOrderBy = {
  error_message?: Maybe<OrderBy>;
  queue_name?: Maybe<OrderBy>;
  role?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
  to_queue_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ToQueueMinFields = {
  __typename?: 'to_queue_min_fields';
  error_message?: Maybe<Scalars['String']>;
  queue_name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  to_queue_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "to_queue" */
export type ToQueueMinOrderBy = {
  error_message?: Maybe<OrderBy>;
  queue_name?: Maybe<OrderBy>;
  role?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
  to_queue_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "to_queue" */
export type ToQueueMutationResponse = {
  __typename?: 'to_queue_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<ToQueue>;
};

/** input type for inserting object relation for remote table "to_queue" */
export type ToQueueObjRelInsertInput = {
  data: ToQueueInsertInput;
  on_conflict?: Maybe<ToQueueOnConflict>;
};

/** on conflict condition type for table "to_queue" */
export type ToQueueOnConflict = {
  constraint: ToQueueConstraint;
  update_columns: Array<ToQueueUpdateColumn>;
  where?: Maybe<ToQueueBoolExp>;
};

/** ordering options when selecting data from "to_queue" */
export type ToQueueOrderBy = {
  content?: Maybe<OrderBy>;
  error_message?: Maybe<OrderBy>;
  queue_name?: Maybe<OrderBy>;
  queued?: Maybe<OrderBy>;
  role?: Maybe<OrderBy>;
  timestamp?: Maybe<OrderBy>;
  to_queue_id?: Maybe<OrderBy>;
  to_queue_responses_aggregate?: Maybe<ToQueueResponseAggregateOrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "to_queue" */
export type ToQueuePkColumnsInput = {
  to_queue_id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ToQueuePrependInput = {
  content?: Maybe<Scalars['jsonb']>;
};

/** columns and relationships of "to_queue_response" */
export type ToQueueResponse = {
  __typename?: 'to_queue_response';
  response: Scalars['jsonb'];
  /** An object relationship */
  to_queue: ToQueue;
  to_queue_id: Scalars['Int'];
};


/** columns and relationships of "to_queue_response" */
export type ToQueueResponseResponseArgs = {
  path?: Maybe<Scalars['String']>;
};

/** aggregated selection of "to_queue_response" */
export type ToQueueResponseAggregate = {
  __typename?: 'to_queue_response_aggregate';
  aggregate?: Maybe<ToQueueResponseAggregateFields>;
  nodes: Array<ToQueueResponse>;
};

/** aggregate fields of "to_queue_response" */
export type ToQueueResponseAggregateFields = {
  __typename?: 'to_queue_response_aggregate_fields';
  avg?: Maybe<ToQueueResponseAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<ToQueueResponseMaxFields>;
  min?: Maybe<ToQueueResponseMinFields>;
  stddev?: Maybe<ToQueueResponseStddevFields>;
  stddev_pop?: Maybe<ToQueueResponseStddevPopFields>;
  stddev_samp?: Maybe<ToQueueResponseStddevSampFields>;
  sum?: Maybe<ToQueueResponseSumFields>;
  var_pop?: Maybe<ToQueueResponseVarPopFields>;
  var_samp?: Maybe<ToQueueResponseVarSampFields>;
  variance?: Maybe<ToQueueResponseVarianceFields>;
};


/** aggregate fields of "to_queue_response" */
export type ToQueueResponseAggregateFieldsCountArgs = {
  columns?: Maybe<Array<ToQueueResponseSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "to_queue_response" */
export type ToQueueResponseAggregateOrderBy = {
  avg?: Maybe<ToQueueResponseAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ToQueueResponseMaxOrderBy>;
  min?: Maybe<ToQueueResponseMinOrderBy>;
  stddev?: Maybe<ToQueueResponseStddevOrderBy>;
  stddev_pop?: Maybe<ToQueueResponseStddevPopOrderBy>;
  stddev_samp?: Maybe<ToQueueResponseStddevSampOrderBy>;
  sum?: Maybe<ToQueueResponseSumOrderBy>;
  var_pop?: Maybe<ToQueueResponseVarPopOrderBy>;
  var_samp?: Maybe<ToQueueResponseVarSampOrderBy>;
  variance?: Maybe<ToQueueResponseVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ToQueueResponseAppendInput = {
  response?: Maybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "to_queue_response" */
export type ToQueueResponseArrRelInsertInput = {
  data: Array<ToQueueResponseInsertInput>;
  on_conflict?: Maybe<ToQueueResponseOnConflict>;
};

/** aggregate avg on columns */
export type ToQueueResponseAvgFields = {
  __typename?: 'to_queue_response_avg_fields';
  to_queue_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "to_queue_response" */
export type ToQueueResponseAvgOrderBy = {
  to_queue_id?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "to_queue_response". All fields are combined with a logical 'AND'. */
export type ToQueueResponseBoolExp = {
  _and?: Maybe<Array<Maybe<ToQueueResponseBoolExp>>>;
  _not?: Maybe<ToQueueResponseBoolExp>;
  _or?: Maybe<Array<Maybe<ToQueueResponseBoolExp>>>;
  response?: Maybe<JsonbComparisonExp>;
  to_queue?: Maybe<ToQueueBoolExp>;
  to_queue_id?: Maybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "to_queue_response" */
export enum ToQueueResponseConstraint {
  /** unique or primary key constraint */
  ToQueueResponsePkey = 'to_queue_response_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ToQueueResponseDeleteAtPathInput = {
  response?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ToQueueResponseDeleteElemInput = {
  response?: Maybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ToQueueResponseDeleteKeyInput = {
  response?: Maybe<Scalars['String']>;
};

/** input type for incrementing integer column in table "to_queue_response" */
export type ToQueueResponseIncInput = {
  to_queue_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "to_queue_response" */
export type ToQueueResponseInsertInput = {
  response?: Maybe<Scalars['jsonb']>;
  to_queue?: Maybe<ToQueueObjRelInsertInput>;
  to_queue_id?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type ToQueueResponseMaxFields = {
  __typename?: 'to_queue_response_max_fields';
  to_queue_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "to_queue_response" */
export type ToQueueResponseMaxOrderBy = {
  to_queue_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type ToQueueResponseMinFields = {
  __typename?: 'to_queue_response_min_fields';
  to_queue_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "to_queue_response" */
export type ToQueueResponseMinOrderBy = {
  to_queue_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "to_queue_response" */
export type ToQueueResponseMutationResponse = {
  __typename?: 'to_queue_response_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<ToQueueResponse>;
};

/** input type for inserting object relation for remote table "to_queue_response" */
export type ToQueueResponseObjRelInsertInput = {
  data: ToQueueResponseInsertInput;
  on_conflict?: Maybe<ToQueueResponseOnConflict>;
};

/** on conflict condition type for table "to_queue_response" */
export type ToQueueResponseOnConflict = {
  constraint: ToQueueResponseConstraint;
  update_columns: Array<ToQueueResponseUpdateColumn>;
  where?: Maybe<ToQueueResponseBoolExp>;
};

/** ordering options when selecting data from "to_queue_response" */
export type ToQueueResponseOrderBy = {
  response?: Maybe<OrderBy>;
  to_queue?: Maybe<ToQueueOrderBy>;
  to_queue_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "to_queue_response" */
export type ToQueueResponsePkColumnsInput = {
  to_queue_id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ToQueueResponsePrependInput = {
  response?: Maybe<Scalars['jsonb']>;
};

/** select columns of table "to_queue_response" */
export enum ToQueueResponseSelectColumn {
  /** column name */
  Response = 'response',
  /** column name */
  ToQueueId = 'to_queue_id'
}

/** input type for updating data in table "to_queue_response" */
export type ToQueueResponseSetInput = {
  response?: Maybe<Scalars['jsonb']>;
  to_queue_id?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type ToQueueResponseStddevFields = {
  __typename?: 'to_queue_response_stddev_fields';
  to_queue_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "to_queue_response" */
export type ToQueueResponseStddevOrderBy = {
  to_queue_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ToQueueResponseStddevPopFields = {
  __typename?: 'to_queue_response_stddev_pop_fields';
  to_queue_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "to_queue_response" */
export type ToQueueResponseStddevPopOrderBy = {
  to_queue_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ToQueueResponseStddevSampFields = {
  __typename?: 'to_queue_response_stddev_samp_fields';
  to_queue_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "to_queue_response" */
export type ToQueueResponseStddevSampOrderBy = {
  to_queue_id?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type ToQueueResponseSumFields = {
  __typename?: 'to_queue_response_sum_fields';
  to_queue_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "to_queue_response" */
export type ToQueueResponseSumOrderBy = {
  to_queue_id?: Maybe<OrderBy>;
};

/** update columns of table "to_queue_response" */
export enum ToQueueResponseUpdateColumn {
  /** column name */
  Response = 'response',
  /** column name */
  ToQueueId = 'to_queue_id'
}

/** aggregate var_pop on columns */
export type ToQueueResponseVarPopFields = {
  __typename?: 'to_queue_response_var_pop_fields';
  to_queue_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "to_queue_response" */
export type ToQueueResponseVarPopOrderBy = {
  to_queue_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ToQueueResponseVarSampFields = {
  __typename?: 'to_queue_response_var_samp_fields';
  to_queue_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "to_queue_response" */
export type ToQueueResponseVarSampOrderBy = {
  to_queue_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ToQueueResponseVarianceFields = {
  __typename?: 'to_queue_response_variance_fields';
  to_queue_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "to_queue_response" */
export type ToQueueResponseVarianceOrderBy = {
  to_queue_id?: Maybe<OrderBy>;
};

/** select columns of table "to_queue" */
export enum ToQueueSelectColumn {
  /** column name */
  Content = 'content',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  QueueName = 'queue_name',
  /** column name */
  Queued = 'queued',
  /** column name */
  Role = 'role',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  ToQueueId = 'to_queue_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "to_queue" */
export type ToQueueSetInput = {
  content?: Maybe<Scalars['jsonb']>;
  error_message?: Maybe<Scalars['String']>;
  queue_name?: Maybe<Scalars['String']>;
  queued?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['timestamptz']>;
  to_queue_id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type ToQueueStddevFields = {
  __typename?: 'to_queue_stddev_fields';
  to_queue_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "to_queue" */
export type ToQueueStddevOrderBy = {
  to_queue_id?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type ToQueueStddevPopFields = {
  __typename?: 'to_queue_stddev_pop_fields';
  to_queue_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "to_queue" */
export type ToQueueStddevPopOrderBy = {
  to_queue_id?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type ToQueueStddevSampFields = {
  __typename?: 'to_queue_stddev_samp_fields';
  to_queue_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "to_queue" */
export type ToQueueStddevSampOrderBy = {
  to_queue_id?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type ToQueueSumFields = {
  __typename?: 'to_queue_sum_fields';
  to_queue_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "to_queue" */
export type ToQueueSumOrderBy = {
  to_queue_id?: Maybe<OrderBy>;
};

/** update columns of table "to_queue" */
export enum ToQueueUpdateColumn {
  /** column name */
  Content = 'content',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  QueueName = 'queue_name',
  /** column name */
  Queued = 'queued',
  /** column name */
  Role = 'role',
  /** column name */
  Timestamp = 'timestamp',
  /** column name */
  ToQueueId = 'to_queue_id',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type ToQueueVarPopFields = {
  __typename?: 'to_queue_var_pop_fields';
  to_queue_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "to_queue" */
export type ToQueueVarPopOrderBy = {
  to_queue_id?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type ToQueueVarSampFields = {
  __typename?: 'to_queue_var_samp_fields';
  to_queue_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "to_queue" */
export type ToQueueVarSampOrderBy = {
  to_queue_id?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type ToQueueVarianceFields = {
  __typename?: 'to_queue_variance_fields';
  to_queue_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "to_queue" */
export type ToQueueVarianceOrderBy = {
  to_queue_id?: Maybe<OrderBy>;
};

/**
 * used for Auth0 user authentication
 *
 *
 * columns and relationships of "user_auth"
 */
export type UserAuth = {
  __typename?: 'user_auth';
  email: Scalars['String'];
  email_verified: Scalars['Boolean'];
  /** hashed password */
  passhash: Scalars['String'];
};

/** aggregated selection of "user_auth" */
export type UserAuthAggregate = {
  __typename?: 'user_auth_aggregate';
  aggregate?: Maybe<UserAuthAggregateFields>;
  nodes: Array<UserAuth>;
};

/** aggregate fields of "user_auth" */
export type UserAuthAggregateFields = {
  __typename?: 'user_auth_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<UserAuthMaxFields>;
  min?: Maybe<UserAuthMinFields>;
};


/** aggregate fields of "user_auth" */
export type UserAuthAggregateFieldsCountArgs = {
  columns?: Maybe<Array<UserAuthSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_auth" */
export type UserAuthAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<UserAuthMaxOrderBy>;
  min?: Maybe<UserAuthMinOrderBy>;
};

/** input type for inserting array relation for remote table "user_auth" */
export type UserAuthArrRelInsertInput = {
  data: Array<UserAuthInsertInput>;
  on_conflict?: Maybe<UserAuthOnConflict>;
};

/** Boolean expression to filter rows from the table "user_auth". All fields are combined with a logical 'AND'. */
export type UserAuthBoolExp = {
  _and?: Maybe<Array<Maybe<UserAuthBoolExp>>>;
  _not?: Maybe<UserAuthBoolExp>;
  _or?: Maybe<Array<Maybe<UserAuthBoolExp>>>;
  email?: Maybe<StringComparisonExp>;
  email_verified?: Maybe<BooleanComparisonExp>;
  passhash?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "user_auth" */
export enum UserAuthConstraint {
  /** unique or primary key constraint */
  UserAuthPkey = 'user_auth_pkey'
}

/** input type for inserting data into table "user_auth" */
export type UserAuthInsertInput = {
  email?: Maybe<Scalars['String']>;
  email_verified?: Maybe<Scalars['Boolean']>;
  passhash?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UserAuthMaxFields = {
  __typename?: 'user_auth_max_fields';
  email?: Maybe<Scalars['String']>;
  passhash?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_auth" */
export type UserAuthMaxOrderBy = {
  email?: Maybe<OrderBy>;
  passhash?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type UserAuthMinFields = {
  __typename?: 'user_auth_min_fields';
  email?: Maybe<Scalars['String']>;
  passhash?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_auth" */
export type UserAuthMinOrderBy = {
  email?: Maybe<OrderBy>;
  passhash?: Maybe<OrderBy>;
};

/** response of any mutation on the table "user_auth" */
export type UserAuthMutationResponse = {
  __typename?: 'user_auth_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<UserAuth>;
};

/** input type for inserting object relation for remote table "user_auth" */
export type UserAuthObjRelInsertInput = {
  data: UserAuthInsertInput;
  on_conflict?: Maybe<UserAuthOnConflict>;
};

/** on conflict condition type for table "user_auth" */
export type UserAuthOnConflict = {
  constraint: UserAuthConstraint;
  update_columns: Array<UserAuthUpdateColumn>;
  where?: Maybe<UserAuthBoolExp>;
};

/** ordering options when selecting data from "user_auth" */
export type UserAuthOrderBy = {
  email?: Maybe<OrderBy>;
  email_verified?: Maybe<OrderBy>;
  passhash?: Maybe<OrderBy>;
};

/** primary key columns input for table: "user_auth" */
export type UserAuthPkColumnsInput = {
  email: Scalars['String'];
};

/** select columns of table "user_auth" */
export enum UserAuthSelectColumn {
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  Passhash = 'passhash'
}

/** input type for updating data in table "user_auth" */
export type UserAuthSetInput = {
  email?: Maybe<Scalars['String']>;
  email_verified?: Maybe<Scalars['Boolean']>;
  passhash?: Maybe<Scalars['String']>;
};

/** update columns of table "user_auth" */
export enum UserAuthUpdateColumn {
  /** column name */
  Email = 'email',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  Passhash = 'passhash'
}

/** columns and relationships of "useraccount" */
export type Useraccount = {
  __typename?: 'useraccount';
  daysactive: Scalars['Int'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  middlename?: Maybe<Scalars['String']>;
  user_id: Scalars['String'];
};

/** aggregated selection of "useraccount" */
export type UseraccountAggregate = {
  __typename?: 'useraccount_aggregate';
  aggregate?: Maybe<UseraccountAggregateFields>;
  nodes: Array<Useraccount>;
};

/** aggregate fields of "useraccount" */
export type UseraccountAggregateFields = {
  __typename?: 'useraccount_aggregate_fields';
  avg?: Maybe<UseraccountAvgFields>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<UseraccountMaxFields>;
  min?: Maybe<UseraccountMinFields>;
  stddev?: Maybe<UseraccountStddevFields>;
  stddev_pop?: Maybe<UseraccountStddevPopFields>;
  stddev_samp?: Maybe<UseraccountStddevSampFields>;
  sum?: Maybe<UseraccountSumFields>;
  var_pop?: Maybe<UseraccountVarPopFields>;
  var_samp?: Maybe<UseraccountVarSampFields>;
  variance?: Maybe<UseraccountVarianceFields>;
};


/** aggregate fields of "useraccount" */
export type UseraccountAggregateFieldsCountArgs = {
  columns?: Maybe<Array<UseraccountSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "useraccount" */
export type UseraccountAggregateOrderBy = {
  avg?: Maybe<UseraccountAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<UseraccountMaxOrderBy>;
  min?: Maybe<UseraccountMinOrderBy>;
  stddev?: Maybe<UseraccountStddevOrderBy>;
  stddev_pop?: Maybe<UseraccountStddevPopOrderBy>;
  stddev_samp?: Maybe<UseraccountStddevSampOrderBy>;
  sum?: Maybe<UseraccountSumOrderBy>;
  var_pop?: Maybe<UseraccountVarPopOrderBy>;
  var_samp?: Maybe<UseraccountVarSampOrderBy>;
  variance?: Maybe<UseraccountVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "useraccount" */
export type UseraccountArrRelInsertInput = {
  data: Array<UseraccountInsertInput>;
  on_conflict?: Maybe<UseraccountOnConflict>;
};

/** aggregate avg on columns */
export type UseraccountAvgFields = {
  __typename?: 'useraccount_avg_fields';
  daysactive?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "useraccount" */
export type UseraccountAvgOrderBy = {
  daysactive?: Maybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "useraccount". All fields are combined with a logical 'AND'. */
export type UseraccountBoolExp = {
  _and?: Maybe<Array<Maybe<UseraccountBoolExp>>>;
  _not?: Maybe<UseraccountBoolExp>;
  _or?: Maybe<Array<Maybe<UseraccountBoolExp>>>;
  daysactive?: Maybe<IntComparisonExp>;
  firstname?: Maybe<StringComparisonExp>;
  lastname?: Maybe<StringComparisonExp>;
  middlename?: Maybe<StringComparisonExp>;
  user_id?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "useraccount" */
export enum UseraccountConstraint {
  /** unique or primary key constraint */
  AccountPkey = 'account_pkey',
  /** unique or primary key constraint */
  AccountUseridKey = 'account_userid_key'
}

/** input type for incrementing integer column in table "useraccount" */
export type UseraccountIncInput = {
  daysactive?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "useraccount" */
export type UseraccountInsertInput = {
  daysactive?: Maybe<Scalars['Int']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  middlename?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UseraccountMaxFields = {
  __typename?: 'useraccount_max_fields';
  daysactive?: Maybe<Scalars['Int']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  middlename?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "useraccount" */
export type UseraccountMaxOrderBy = {
  daysactive?: Maybe<OrderBy>;
  firstname?: Maybe<OrderBy>;
  lastname?: Maybe<OrderBy>;
  middlename?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type UseraccountMinFields = {
  __typename?: 'useraccount_min_fields';
  daysactive?: Maybe<Scalars['Int']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  middlename?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "useraccount" */
export type UseraccountMinOrderBy = {
  daysactive?: Maybe<OrderBy>;
  firstname?: Maybe<OrderBy>;
  lastname?: Maybe<OrderBy>;
  middlename?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** response of any mutation on the table "useraccount" */
export type UseraccountMutationResponse = {
  __typename?: 'useraccount_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<Useraccount>;
};

/** input type for inserting object relation for remote table "useraccount" */
export type UseraccountObjRelInsertInput = {
  data: UseraccountInsertInput;
  on_conflict?: Maybe<UseraccountOnConflict>;
};

/** on conflict condition type for table "useraccount" */
export type UseraccountOnConflict = {
  constraint: UseraccountConstraint;
  update_columns: Array<UseraccountUpdateColumn>;
  where?: Maybe<UseraccountBoolExp>;
};

/** ordering options when selecting data from "useraccount" */
export type UseraccountOrderBy = {
  daysactive?: Maybe<OrderBy>;
  firstname?: Maybe<OrderBy>;
  lastname?: Maybe<OrderBy>;
  middlename?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
};

/** primary key columns input for table: "useraccount" */
export type UseraccountPkColumnsInput = {
  user_id: Scalars['String'];
};

/** select columns of table "useraccount" */
export enum UseraccountSelectColumn {
  /** column name */
  Daysactive = 'daysactive',
  /** column name */
  Firstname = 'firstname',
  /** column name */
  Lastname = 'lastname',
  /** column name */
  Middlename = 'middlename',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "useraccount" */
export type UseraccountSetInput = {
  daysactive?: Maybe<Scalars['Int']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  middlename?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type UseraccountStddevFields = {
  __typename?: 'useraccount_stddev_fields';
  daysactive?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "useraccount" */
export type UseraccountStddevOrderBy = {
  daysactive?: Maybe<OrderBy>;
};

/** aggregate stddev_pop on columns */
export type UseraccountStddevPopFields = {
  __typename?: 'useraccount_stddev_pop_fields';
  daysactive?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "useraccount" */
export type UseraccountStddevPopOrderBy = {
  daysactive?: Maybe<OrderBy>;
};

/** aggregate stddev_samp on columns */
export type UseraccountStddevSampFields = {
  __typename?: 'useraccount_stddev_samp_fields';
  daysactive?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "useraccount" */
export type UseraccountStddevSampOrderBy = {
  daysactive?: Maybe<OrderBy>;
};

/** aggregate sum on columns */
export type UseraccountSumFields = {
  __typename?: 'useraccount_sum_fields';
  daysactive?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "useraccount" */
export type UseraccountSumOrderBy = {
  daysactive?: Maybe<OrderBy>;
};

/** update columns of table "useraccount" */
export enum UseraccountUpdateColumn {
  /** column name */
  Daysactive = 'daysactive',
  /** column name */
  Firstname = 'firstname',
  /** column name */
  Lastname = 'lastname',
  /** column name */
  Middlename = 'middlename',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type UseraccountVarPopFields = {
  __typename?: 'useraccount_var_pop_fields';
  daysactive?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "useraccount" */
export type UseraccountVarPopOrderBy = {
  daysactive?: Maybe<OrderBy>;
};

/** aggregate var_samp on columns */
export type UseraccountVarSampFields = {
  __typename?: 'useraccount_var_samp_fields';
  daysactive?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "useraccount" */
export type UseraccountVarSampOrderBy = {
  daysactive?: Maybe<OrderBy>;
};

/** aggregate variance on columns */
export type UseraccountVarianceFields = {
  __typename?: 'useraccount_variance_fields';
  daysactive?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "useraccount" */
export type UseraccountVarianceOrderBy = {
  daysactive?: Maybe<OrderBy>;
};


/** columns and relationships of "web_api_permission" */
export type WebApiPermission = {
  __typename?: 'web_api_permission';
  fn: Scalars['String'];
};

/** aggregated selection of "web_api_permission" */
export type WebApiPermissionAggregate = {
  __typename?: 'web_api_permission_aggregate';
  aggregate?: Maybe<WebApiPermissionAggregateFields>;
  nodes: Array<WebApiPermission>;
};

/** aggregate fields of "web_api_permission" */
export type WebApiPermissionAggregateFields = {
  __typename?: 'web_api_permission_aggregate_fields';
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<WebApiPermissionMaxFields>;
  min?: Maybe<WebApiPermissionMinFields>;
};


/** aggregate fields of "web_api_permission" */
export type WebApiPermissionAggregateFieldsCountArgs = {
  columns?: Maybe<Array<WebApiPermissionSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "web_api_permission" */
export type WebApiPermissionAggregateOrderBy = {
  count?: Maybe<OrderBy>;
  max?: Maybe<WebApiPermissionMaxOrderBy>;
  min?: Maybe<WebApiPermissionMinOrderBy>;
};

/** input type for inserting array relation for remote table "web_api_permission" */
export type WebApiPermissionArrRelInsertInput = {
  data: Array<WebApiPermissionInsertInput>;
  on_conflict?: Maybe<WebApiPermissionOnConflict>;
};

/** Boolean expression to filter rows from the table "web_api_permission". All fields are combined with a logical 'AND'. */
export type WebApiPermissionBoolExp = {
  _and?: Maybe<Array<Maybe<WebApiPermissionBoolExp>>>;
  _not?: Maybe<WebApiPermissionBoolExp>;
  _or?: Maybe<Array<Maybe<WebApiPermissionBoolExp>>>;
  fn?: Maybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "web_api_permission" */
export enum WebApiPermissionConstraint {
  /** unique or primary key constraint */
  WebApiPermissionPkey = 'web_api_permission_pkey'
}

/** input type for inserting data into table "web_api_permission" */
export type WebApiPermissionInsertInput = {
  fn?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type WebApiPermissionMaxFields = {
  __typename?: 'web_api_permission_max_fields';
  fn?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "web_api_permission" */
export type WebApiPermissionMaxOrderBy = {
  fn?: Maybe<OrderBy>;
};

/** aggregate min on columns */
export type WebApiPermissionMinFields = {
  __typename?: 'web_api_permission_min_fields';
  fn?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "web_api_permission" */
export type WebApiPermissionMinOrderBy = {
  fn?: Maybe<OrderBy>;
};

/** response of any mutation on the table "web_api_permission" */
export type WebApiPermissionMutationResponse = {
  __typename?: 'web_api_permission_mutation_response';
  /** number of affected rows by the mutation */
  affected_rows: Scalars['Int'];
  /** data of the affected rows by the mutation */
  returning: Array<WebApiPermission>;
};

/** input type for inserting object relation for remote table "web_api_permission" */
export type WebApiPermissionObjRelInsertInput = {
  data: WebApiPermissionInsertInput;
  on_conflict?: Maybe<WebApiPermissionOnConflict>;
};

/** on conflict condition type for table "web_api_permission" */
export type WebApiPermissionOnConflict = {
  constraint: WebApiPermissionConstraint;
  update_columns: Array<WebApiPermissionUpdateColumn>;
  where?: Maybe<WebApiPermissionBoolExp>;
};

/** ordering options when selecting data from "web_api_permission" */
export type WebApiPermissionOrderBy = {
  fn?: Maybe<OrderBy>;
};

/** primary key columns input for table: "web_api_permission" */
export type WebApiPermissionPkColumnsInput = {
  fn: Scalars['String'];
};

/** select columns of table "web_api_permission" */
export enum WebApiPermissionSelectColumn {
  /** column name */
  Fn = 'fn'
}

/** input type for updating data in table "web_api_permission" */
export type WebApiPermissionSetInput = {
  fn?: Maybe<Scalars['String']>;
};

/** update columns of table "web_api_permission" */
export enum WebApiPermissionUpdateColumn {
  /** column name */
  Fn = 'fn'
}

export type GetCandidateIdentityQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetCandidateIdentityQuery = (
  { __typename?: 'query_root' }
  & { grad_profile: Array<(
    { __typename?: 'grad_profile' }
    & Pick<GradProfile, 'title' | 'fullname' | 'profile_image' | 'need_sponsor' | 'authorized_to_work'>
    & { degrees: Array<(
      { __typename?: 'grad_degree' }
      & Pick<GradDegree, 'degree' | 'complete_year' | 'gpa' | 'gpa_outof' | 'gpa_not_applicable'>
      & { awards: Array<(
        { __typename?: 'grad_award' }
        & Pick<GradAward, 'award_category' | 'award_name' | 'year_received'>
      )>, concentrations: Array<(
        { __typename?: 'grad_concentration' }
        & Pick<GradConcentration, 'val' | 'type'>
      )>, university?: Maybe<(
        { __typename?: 'grad_university_selection' }
        & Pick<GradUniversitySelection, 'logo_url' | 'location_name'>
      )>, fill_in_university?: Maybe<(
        { __typename?: 'grad_degree_fill_in_university' }
        & Pick<GradDegreeFillInUniversity, 'institution_name'>
      )> }
    )> }
  )>, grad_award: Array<(
    { __typename?: 'grad_award' }
    & Pick<GradAward, 'award_name' | 'year_received'>
  )> }
);

export type GetCandidatesByGroupQueryVariables = Exact<{
  groupId: Scalars['String'];
}>;


export type GetCandidatesByGroupQuery = (
  { __typename?: 'query_root' }
  & { recruit_grad_group: Array<(
    { __typename?: 'recruit_grad_group' }
    & { grad_group_members: Array<(
      { __typename?: 'recruit_grad_group_member' }
      & { profile: (
        { __typename?: 'grad_profile' }
        & Pick<GradProfile, 'title' | 'fullname' | 'firstname' | 'middlename' | 'lastname' | 'profile_image' | 'user_id'>
        & { degrees: Array<(
          { __typename?: 'grad_degree' }
          & Pick<GradDegree, 'degree' | 'complete_year' | 'gpa' | 'gpa_outof' | 'gpa_not_applicable'>
          & { university?: Maybe<(
            { __typename?: 'grad_university_selection' }
            & Pick<GradUniversitySelection, 'location_name'>
          )> }
        )> }
      ) }
    )> }
    & GroupPartsFragment
  )> }
);

export type GetMajorSelectionQueryVariables = Exact<{
  major_name: Scalars['String'];
}>;


export type GetMajorSelectionQuery = (
  { __typename?: 'query_root' }
  & { grad_major_selection: Array<(
    { __typename?: 'grad_major_selection' }
    & MajorSelectorPartsFragment
  )> }
);

export type GetUniversitySelectionQueryVariables = Exact<{
  location_name: Scalars['String'];
}>;


export type GetUniversitySelectionQuery = (
  { __typename?: 'query_root' }
  & { grad_university_stat: Array<(
    { __typename?: 'grad_university_stat' }
    & UniversityPartsStatFragment
  )> }
);

export type InsertSMSMessageMutationVariables = Exact<{
  content?: Maybe<Scalars['String']>;
  recruiter_user_id?: Maybe<Scalars['String']>;
  correspondents: Array<RecruitSmsMessageCorrespondentInsertInput> | RecruitSmsMessageCorrespondentInsertInput;
}>;


export type InsertSMSMessageMutation = (
  { __typename?: 'mutation_root' }
  & { insert_recruit_sms_message?: Maybe<(
    { __typename?: 'recruit_sms_message_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_sms_message' }
      & MessagePartsFragment
    )> }
  )> }
);

export type CleanInsertCompanySubIndustryMutationVariables = Exact<{
  companyId?: Maybe<Scalars['Int']>;
  subIndustries: Array<RecruitCompanySubindustryInsertInput> | RecruitCompanySubindustryInsertInput;
}>;


export type CleanInsertCompanySubIndustryMutation = (
  { __typename?: 'mutation_root' }
  & { delete_recruit_company_subindustry?: Maybe<(
    { __typename?: 'recruit_company_subindustry_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_company_subindustry' }
      & SubIndustryPartsFragment
    )> }
  )>, insert_recruit_company_subindustry?: Maybe<(
    { __typename?: 'recruit_company_subindustry_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_company_subindustry' }
      & SubIndustryPartsFragment
    )> }
  )> }
);

export type CreateGroupMutationVariables = Exact<{
  recruiter_user_id: Scalars['String'];
  group_name: Scalars['String'];
}>;


export type CreateGroupMutation = (
  { __typename?: 'mutation_root' }
  & { insert_recruit_grad_group?: Maybe<(
    { __typename?: 'recruit_grad_group_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_grad_group' }
      & GroupPartsFragment
    )> }
  )> }
);

export type CreateJobMutationVariables = Exact<{
  account_id: Scalars['String'];
  active: Scalars['Boolean'];
  creation_date?: Maybe<Scalars['date']>;
  creator_id: Scalars['String'];
  description: Scalars['String'];
  firm: Scalars['String'];
  position_title: Scalars['String'];
  job_type: Scalars['String'];
  deadline?: Maybe<Scalars['date']>;
  region: Scalars['String'];
  requirements: Array<RecruitJobRequirementInsertInput> | RecruitJobRequirementInsertInput;
}>;


export type CreateJobMutation = (
  { __typename?: 'mutation_root' }
  & { insert_recruit_job_posting?: Maybe<(
    { __typename?: 'recruit_job_posting_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_job_posting' }
      & JobPartsFragment
    )> }
  )> }
);

export type DeleteConversationMutationVariables = Exact<{
  candidateId?: Maybe<Scalars['String']>;
  recruiterId?: Maybe<Scalars['String']>;
}>;


export type DeleteConversationMutation = (
  { __typename?: 'mutation_root' }
  & { delete_recruit_sms_correspondent?: Maybe<(
    { __typename?: 'recruit_sms_correspondent_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_sms_correspondent' }
      & Pick<RecruitSmsCorrespondent, 'correspondent_user_id'>
    )> }
  )> }
);

export type DeleteEventMutationVariables = Exact<{
  eventID: Scalars['String'];
}>;


export type DeleteEventMutation = (
  { __typename?: 'mutation_root' }
  & { delete_recruit_event?: Maybe<(
    { __typename?: 'recruit_event_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_event' }
      & Pick<RecruitEvent, 'event_id'>
    )> }
  )> }
);

export type DeleteJobMutationVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type DeleteJobMutation = (
  { __typename?: 'mutation_root' }
  & { delete_recruit_job_posting?: Maybe<(
    { __typename?: 'recruit_job_posting_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_job_posting' }
      & Pick<RecruitJobPosting, 'job_posting_id'>
    )> }
  )> }
);

export type DeleteTemplateMutationVariables = Exact<{
  templateId: Scalars['Int'];
}>;


export type DeleteTemplateMutation = (
  { __typename?: 'mutation_root' }
  & { delete_recruit_sms_template?: Maybe<(
    { __typename?: 'recruit_sms_template_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_sms_template' }
      & TemplatePartsFragment
    )> }
  )> }
);

export type DownloadCVQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type DownloadCVQuery = (
  { __typename?: 'query_root' }
  & { grad_upload_doc: Array<(
    { __typename?: 'grad_upload_doc' }
    & CVPartsFragment
  )> }
);

export type DownloadCVByIdQueryVariables = Exact<{
  uploadDocId: Scalars['String'];
}>;


export type DownloadCVByIdQuery = (
  { __typename?: 'query_root' }
  & { grad_upload_doc: Array<(
    { __typename?: 'grad_upload_doc' }
    & CVPartsFragment
  )> }
);

export type ExistCVQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ExistCVQuery = (
  { __typename?: 'query_root' }
  & { grad_upload_doc_aggregate: (
    { __typename?: 'grad_upload_doc_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'grad_upload_doc_aggregate_fields' }
      & Pick<GradUploadDocAggregateFields, 'count'>
    )> }
  ) }
);

export type AccountPartsFragment = (
  { __typename?: 'recruit_account' }
  & Pick<RecruitAccount, 'account_id' | 'account_name'>
);

export type SubIndustryPartsFragment = (
  { __typename?: 'recruit_company_subindustry' }
  & Pick<RecruitCompanySubindustry, 'company_subindustry_id' | 'value'>
);

export type CompanyPartsFragment = (
  { __typename?: 'recruit_company' }
  & Pick<RecruitCompany, 'company_id' | 'account_id' | 'address' | 'description' | 'industry' | 'logo' | 'photo' | 'name' | 'num_employees' | 'phone' | 'website'>
  & { account: (
    { __typename?: 'recruit_account' }
    & AccountPartsFragment
  ), subindustries: Array<(
    { __typename?: 'recruit_company_subindustry' }
    & SubIndustryPartsFragment
  )> }
);

export type AchievementPartsFragment = (
  { __typename?: 'grad_achievement' }
  & Pick<GradAchievement, 'achievement_id' | 'description'>
);

export type LanguageSelectorPartsFragment = (
  { __typename?: 'grad_spoken_language' }
  & Pick<GradSpokenLanguage, 'language' | 'spoken_language_id'>
);

export type ComputerLanguageSelectorPartsFragment = (
  { __typename?: 'grad_computer_language_selection' }
  & Pick<GradComputerLanguageSelection, 'computer_language'>
);

export type FillInUniversityPartsFragment = (
  { __typename?: 'grad_degree_fill_in_university' }
  & Pick<GradDegreeFillInUniversity, 'degree_id' | 'institution_name' | 'user_id'>
);

export type VolunteerActivitiesPartsFragment = (
  { __typename?: 'grad_volunteer' }
  & Pick<GradVolunteer, 'volunteer_id' | 'description'>
);

export type AwardPartsFragment = (
  { __typename?: 'grad_award' }
  & Pick<GradAward, 'award_id' | 'award_category' | 'award_name' | 'year_received' | 'degree_id' | 'user_id' | 'work_experience_id'>
);

export type ComputerLanguagePartsFragment = (
  { __typename?: 'grad_computer_language' }
  & Pick<GradComputerLanguage, 'computer_language_id' | 'language' | 'user_id'>
);

export type TemplatePartsFragment = (
  { __typename?: 'recruit_sms_template' }
  & Pick<RecruitSmsTemplate, 'title' | 'text' | 'sms_template_id' | 'creation_timestamp'>
);

export type ConcentrationPartsFragment = (
  { __typename?: 'grad_concentration' }
  & Pick<GradConcentration, 'concentration_id' | 'type' | 'val' | 'degree_id' | 'user_id'>
);

export type InterestRoleSelectorPartsFragment = (
  { __typename?: 'grad_interest_role_selection' }
  & Pick<GradInterestRoleSelection, 'value' | 'interest_role_selection_id'>
);

export type InterestRegionSelectorPartsFragment = (
  { __typename?: 'grad_interest_region_selection' }
  & Pick<GradInterestRegionSelection, 'value' | 'interest_region_selection_id'>
);

export type InterestFirmSelectorPartsFragment = (
  { __typename?: 'grad_interest_firm_selection' }
  & Pick<GradInterestFirmSelection, 'value' | 'interest_firm_selection_id'>
);

export type InterestJobTypeSelectorPartsFragment = (
  { __typename?: 'grad_interest_job_type_selection' }
  & Pick<GradInterestJobTypeSelection, 'value' | 'interest_job_type_selection_id'>
);

export type MajorSelectorPartsFragment = (
  { __typename?: 'grad_major_selection' }
  & Pick<GradMajorSelection, 'major' | 'major_selection_id'>
);

export type UniversityPartsFragment = (
  { __typename?: 'grad_university_selection' }
  & Pick<GradUniversitySelection, 'university_selection_id' | 'location_name' | 'logo_url'>
);

export type UniversityPartsStatFragment = (
  { __typename?: 'grad_university_stat' }
  & Pick<GradUniversityStat, 'degree_count'>
  & { university_selection?: Maybe<(
    { __typename?: 'grad_university_selection' }
    & Pick<GradUniversitySelection, 'university_selection_id' | 'location_name'>
  )> }
);

export type DegreeSelectorPartsFragment = (
  { __typename?: 'grad_degree_selection' }
  & Pick<GradDegreeSelection, 'degree' | 'degree_level' | 'degree_selection_id' | 'description'>
);

export type DegreePartsFragment = (
  { __typename?: 'grad_degree' }
  & Pick<GradDegree, 'degree_id' | 'complete_month_numeric' | 'complete_year' | 'degree' | 'degree_level' | 'gpa' | 'gpa_outof' | 'start_month_numeric' | 'start_year' | 'user_id' | 'gpa_not_applicable'>
  & { awards: Array<(
    { __typename?: 'grad_award' }
    & AwardPartsFragment
  )>, concentrations: Array<(
    { __typename?: 'grad_concentration' }
    & ConcentrationPartsFragment
  )>, university?: Maybe<(
    { __typename?: 'grad_university_selection' }
    & UniversityPartsFragment
  )>, fill_in_university?: Maybe<(
    { __typename?: 'grad_degree_fill_in_university' }
    & FillInUniversityPartsFragment
  )> }
);

export type GroupPartsFragment = (
  { __typename?: 'recruit_grad_group' }
  & Pick<RecruitGradGroup, 'group_name' | 'grad_group_id'>
);

export type GroupMembershipPartsFragment = (
  { __typename?: 'recruit_grad_group_member' }
  & Pick<RecruitGradGroupMember, 'recruiter_user_id' | 'student_user_id'>
  & { grad_group?: Maybe<(
    { __typename?: 'recruit_grad_group' }
    & GroupPartsFragment
  )> }
);

export type FunFactPartsFragment = (
  { __typename?: 'grad_fun_fact' }
  & Pick<GradFunFact, 'fun_fact_id' | 'description' | 'user_id'>
);

export type InterestRolePartsFragment = (
  { __typename?: 'grad_interest_role' }
  & Pick<GradInterestRole, 'role' | 'interest_role_id' | 'user_id'>
);

export type InterestFirmPartsFragment = (
  { __typename?: 'grad_interest_firm' }
  & Pick<GradInterestFirm, 'firm_type' | 'interest_firm_id' | 'user_id'>
);

export type InterestRegionPartsFragment = (
  { __typename?: 'grad_interest_region' }
  & Pick<GradInterestRegion, 'interest_region_id' | 'region' | 'user_id'>
);

export type InterestJobTypePartsFragment = (
  { __typename?: 'grad_interest_job_type' }
  & Pick<GradInterestJobType, 'interest_job_type_id' | 'job_type' | 'user_id'>
);

export type EmployerPreferencesPartsFragment = (
  { __typename?: 'grad_employer_preference' }
  & Pick<GradEmployerPreference, 'employer_preference_id' | 'preference' | 'user_id'>
);

export type TestScoreDetailPartsFragment = (
  { __typename?: 'grad_test_score_detail' }
  & Pick<GradTestScoreDetail, 'detail' | 'outof' | 'score' | 'test' | 'test_score_detail_id'>
);

export type TestScorePartsFragment = (
  { __typename?: 'grad_test_score' }
  & Pick<GradTestScore, 'score' | 'outof' | 'test' | 'user_id' | 'test_score_id'>
  & { test_score_details: Array<(
    { __typename?: 'grad_test_score_detail' }
    & TestScoreDetailPartsFragment
  )> }
);

export type WorkExperiencePartsFragment = (
  { __typename?: 'grad_work_experience' }
  & Pick<GradWorkExperience, 'work_experience_id' | 'city' | 'company' | 'end_month_numeric' | 'end_year' | 'job_type' | 'position' | 'start_month_numeric' | 'start_year' | 'state' | 'user_id'>
);

export type CandidateImageOnlyPartsFragment = (
  { __typename?: 'grad_profile' }
  & Pick<GradProfile, 'user_id' | 'profile_image'>
);

export type CandidatePartsBaseFragment = (
  { __typename?: 'grad_profile' }
  & Pick<GradProfile, 'user_id' | 'firstname' | 'middlename' | 'lastname' | 'fullname' | 'title' | 'email' | 'hometown' | 'comm_preference' | 'years_of_relevant_work' | 'mobile' | 'student_athlete' | 'need_sponsor' | 'authorized_to_work'>
  & { legal_residence_country?: Maybe<(
    { __typename?: 'grad_country_selection' }
    & Pick<GradCountrySelection, 'country'>
  )>, test_scores: Array<(
    { __typename?: 'grad_test_score' }
    & TestScorePartsFragment
  )>, degrees: Array<(
    { __typename?: 'grad_degree' }
    & DegreePartsFragment
  )>, fun_facts: Array<(
    { __typename?: 'grad_fun_fact' }
    & FunFactPartsFragment
  )>, employer_preferences: Array<(
    { __typename?: 'grad_employer_preference' }
    & EmployerPreferencesPartsFragment
  )>, interest_firms: Array<(
    { __typename?: 'grad_interest_firm' }
    & InterestFirmPartsFragment
  )>, interest_regions: Array<(
    { __typename?: 'grad_interest_region' }
    & InterestRegionPartsFragment
  )>, interest_job_types: Array<(
    { __typename?: 'grad_interest_job_type' }
    & InterestJobTypePartsFragment
  )>, interest_roles: Array<(
    { __typename?: 'grad_interest_role' }
    & InterestRolePartsFragment
  )>, work_experiences: Array<(
    { __typename?: 'grad_work_experience' }
    & WorkExperiencePartsFragment
  )>, computer_languages: Array<(
    { __typename?: 'grad_computer_language' }
    & ComputerLanguagePartsFragment
  )>, spoken_languages: Array<(
    { __typename?: 'grad_spoken_language' }
    & LanguageSelectorPartsFragment
  )>, achievements: Array<(
    { __typename?: 'grad_achievement' }
    & AchievementPartsFragment
  )>, volunteers: Array<(
    { __typename?: 'grad_volunteer' }
    & VolunteerActivitiesPartsFragment
  )>, awards: Array<(
    { __typename?: 'grad_award' }
    & AwardPartsFragment
  )> }
);

export type CandidatePartsFragment = (
  { __typename?: 'grad_profile' }
  & { grad_group_members: Array<(
    { __typename?: 'recruit_grad_group_member' }
    & Pick<RecruitGradGroupMember, 'recruiter_user_id' | 'student_user_id'>
    & { grad_group?: Maybe<(
      { __typename?: 'recruit_grad_group' }
      & Pick<RecruitGradGroup, 'group_name' | 'grad_group_id'>
    )> }
  )>, upload_docs_aggregate: (
    { __typename?: 'grad_upload_doc_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'grad_upload_doc_aggregate_fields' }
      & Pick<GradUploadDocAggregateFields, 'count'>
    )> }
  ) }
  & CandidatePartsBaseFragment
);

export type CandidatePartsAdminFragment = (
  { __typename?: 'grad_profile' }
  & Pick<GradProfile, 'blocked' | 'blocked_reason'>
  & { upload_docs_aggregate: (
    { __typename?: 'grad_upload_doc_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'grad_upload_doc_aggregate_fields' }
      & Pick<GradUploadDocAggregateFields, 'count'>
    )> }
  ) }
  & CandidatePartsBaseFragment
);

export type CVPartsFragment = (
  { __typename?: 'grad_upload_doc' }
  & Pick<GradUploadDoc, 'filename' | 'hex_content' | 'upload_doc_id' | 'user_id'>
);

export type MessagePartsFragment = (
  { __typename?: 'recruit_sms_message' }
  & Pick<RecruitSmsMessage, 'content' | 'incoming' | 'recruiter_user_id' | 'sms_message_id' | 'timestamp'>
);

export type MessageCorrespondentPartsFragment = (
  { __typename?: 'recruit_sms_message_correspondent' }
  & { message: (
    { __typename?: 'recruit_sms_message' }
    & Pick<RecruitSmsMessage, 'content' | 'incoming' | 'recruiter_user_id' | 'sms_message_id' | 'timestamp'>
  ) }
);

export type RecipientPartsFragment = (
  { __typename?: 'grad_profile' }
  & Pick<GradProfile, 'user_id' | 'firstname' | 'middlename' | 'lastname' | 'fullname' | 'title' | 'profile_image'>
  & { degrees: Array<(
    { __typename?: 'grad_degree' }
    & DegreePartsFragment
  )> }
);

export type ConversationPartsFragment = (
  { __typename?: 'recruit_sms_correspondent' }
  & Pick<RecruitSmsCorrespondent, 'recruiter_user_id' | 'correspondent_user_id' | 'sms_correspondent_id' | 'last_incoming_timestamp' | 'last_message_timestamp' | 'last_outgoing_timestamp' | 'last_read_timestamp' | 'archived' | 'blocked' | 'conversation_ended' | 'blocked_reason'>
  & { grad_profile: (
    { __typename?: 'grad_profile' }
    & RecipientPartsFragment
  ) }
);

export type RaisedHandPartsFragment = (
  { __typename?: 'grad_raise_hand' }
  & Pick<GradRaiseHand, 'raise__hand_id' | 'user_id' | 'job_posting_id'>
);

export type JobRequirementValuePartsFragment = (
  { __typename?: 'recruit_job_requirement_value' }
  & Pick<RecruitJobRequirementValue, 'label' | 'value' | 'value_id' | 'job_requirement_value_id'>
);

export type JobRequirementPartsFragment = (
  { __typename?: 'recruit_job_requirement' }
  & Pick<RecruitJobRequirement, 'requirement_name' | 'requirement_type' | 'boolean_value' | 'job_requirement_id' | 'max_range_value' | 'min_range_value' | 'number_value'>
  & { values: Array<(
    { __typename?: 'recruit_job_requirement_value' }
    & JobRequirementValuePartsFragment
  )> }
);

export type RegionPartsFragment = (
  { __typename?: 'grad_interest_region_selection' }
  & Pick<GradInterestRegionSelection, 'interest_region_selection_id' | 'value'>
);

export type JobPartsFragment = (
  { __typename?: 'recruit_job_posting' }
  & Pick<RecruitJobPosting, 'job_posting_id' | 'account_id' | 'active' | 'creation_date' | 'creator_id' | 'deadline' | 'description' | 'firm' | 'job_type' | 'modified_date' | 'position_title' | 'publishing_date' | 'region' | 'public'>
  & { job_requirements: Array<(
    { __typename?: 'recruit_job_requirement' }
    & JobRequirementPartsFragment
  )>, raise_hands: Array<(
    { __typename?: 'grad_raise_hand' }
    & RaisedHandPartsFragment
  )> }
);

export type GetCVsByUsersIdQueryVariables = Exact<{
  userIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetCVsByUsersIdQuery = (
  { __typename?: 'query_root' }
  & { grad_upload_doc: Array<(
    { __typename?: 'grad_upload_doc' }
    & CVPartsFragment
  )> }
);

export type GetCVsCountByUsersIdQueryVariables = Exact<{
  userIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetCVsCountByUsersIdQuery = (
  { __typename?: 'query_root' }
  & { grad_upload_doc_aggregate: (
    { __typename?: 'grad_upload_doc_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'grad_upload_doc_aggregate_fields' }
      & Pick<GradUploadDocAggregateFields, 'count'>
    )> }
  ) }
);

export type GetCandidateQueryVariables = Exact<{
  admin: Scalars['Boolean'];
  userId: Scalars['String'];
}>;


export type GetCandidateQuery = (
  { __typename?: 'query_root' }
  & { grad_profile: Array<(
    { __typename?: 'grad_profile' }
    & Pick<GradProfile, 'profile_image'>
    & CandidatePartsAdminFragment
    & CandidatePartsFragment
  )> }
);

export type GetCandidatesQueryVariables = Exact<{
  admin: Scalars['Boolean'];
  dynamicQuery?: Maybe<GradProfileBoolExp>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  order_by: GradProfileOrderBy;
}>;


export type GetCandidatesQuery = (
  { __typename?: 'query_root' }
  & { grad_profile_aggregate: (
    { __typename?: 'grad_profile_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'grad_profile_aggregate_fields' }
      & Pick<GradProfileAggregateFields, 'count'>
    )> }
  ), grad_profile: Array<(
    { __typename?: 'grad_profile' }
    & CandidatePartsAdminFragment
    & CandidatePartsFragment
  )> }
);

export type GetCompanyOldQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCompanyOldQuery = (
  { __typename?: 'query_root' }
  & { recruit_company: Array<(
    { __typename?: 'recruit_company' }
    & CompanyPartsFragment
  )> }
);

export type GetComputerLanguageSelectionQueryVariables = Exact<{
  language?: Maybe<Scalars['String']>;
}>;


export type GetComputerLanguageSelectionQuery = (
  { __typename?: 'query_root' }
  & { grad_computer_language_selection: Array<(
    { __typename?: 'grad_computer_language_selection' }
    & ComputerLanguageSelectorPartsFragment
  )> }
);

export type GetConversationsSubscriptionVariables = Exact<{
  candidateId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetConversationsSubscription = (
  { __typename?: 'subscription_root' }
  & { recruit_sms_correspondent: Array<(
    { __typename?: 'recruit_sms_correspondent' }
    & ConversationPartsFragment
  )> }
);

export type GetDegreeSelectionQueryVariables = Exact<{
  degree_name?: Maybe<Scalars['String']>;
}>;


export type GetDegreeSelectionQuery = (
  { __typename?: 'query_root' }
  & { grad_degree_selection: Array<(
    { __typename?: 'grad_degree_selection' }
    & DegreeSelectorPartsFragment
  )> }
);

export type GetEventQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEventQuery = (
  { __typename?: 'query_root' }
  & { recruit_event_by_pk?: Maybe<(
    { __typename?: 'recruit_event' }
    & Pick<RecruitEvent, 'event_id' | 'title' | 'image' | 'description' | 'capacity' | 'timezone' | 'start_datetime' | 'end_datetime' | 'event_type' | 'address' | 'event_url'>
  )>, recruit_company: Array<(
    { __typename?: 'recruit_company' }
    & Pick<RecruitCompany, 'company_id'>
  )> }
);

export type GetEventAttendeesQueryVariables = Exact<{
  eventID: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetEventAttendeesQuery = (
  { __typename?: 'query_root' }
  & { recruit_event: Array<(
    { __typename?: 'recruit_event' }
    & { event_registrations: Array<(
      { __typename?: 'grad_event_registration' }
      & { profile: (
        { __typename?: 'grad_profile' }
        & Pick<GradProfile, 'profile_image'>
        & CandidatePartsFragment
      ) }
    )> }
  )>, recruit_event_aggregate: (
    { __typename?: 'recruit_event_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'recruit_event_aggregate_fields' }
      & Pick<RecruitEventAggregateFields, 'count'>
    )> }
  ) }
);

export type GetGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGroupsQuery = (
  { __typename?: 'query_root' }
  & { recruit_grad_group: Array<(
    { __typename?: 'recruit_grad_group' }
    & GroupPartsFragment
  )> }
);

export type GetGroupsByNameQueryVariables = Exact<{
  name?: Maybe<Scalars['String']>;
}>;


export type GetGroupsByNameQuery = (
  { __typename?: 'query_root' }
  & { recruit_grad_group: Array<(
    { __typename?: 'recruit_grad_group' }
    & GroupPartsFragment
  )> }
);

export type GetInterestFirmSelectionQueryVariables = Exact<{
  firm_type?: Maybe<Scalars['String']>;
}>;


export type GetInterestFirmSelectionQuery = (
  { __typename?: 'query_root' }
  & { grad_interest_firm_selection: Array<(
    { __typename?: 'grad_interest_firm_selection' }
    & InterestFirmSelectorPartsFragment
  )> }
);

export type GetInterestJobTypeSelectionQueryVariables = Exact<{
  job_type?: Maybe<Scalars['String']>;
}>;


export type GetInterestJobTypeSelectionQuery = (
  { __typename?: 'query_root' }
  & { grad_interest_job_type_selection: Array<(
    { __typename?: 'grad_interest_job_type_selection' }
    & InterestJobTypeSelectorPartsFragment
  )> }
);

export type GetInterestRegionSelectionQueryVariables = Exact<{
  region?: Maybe<Scalars['String']>;
}>;


export type GetInterestRegionSelectionQuery = (
  { __typename?: 'query_root' }
  & { grad_interest_region_selection: Array<(
    { __typename?: 'grad_interest_region_selection' }
    & InterestRegionSelectorPartsFragment
  )> }
);

export type GetInterestRolesSelectionQueryVariables = Exact<{
  role?: Maybe<Scalars['String']>;
}>;


export type GetInterestRolesSelectionQuery = (
  { __typename?: 'query_root' }
  & { grad_interest_role_selection: Array<(
    { __typename?: 'grad_interest_role_selection' }
    & InterestRoleSelectorPartsFragment
  )> }
);

export type GetJobQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetJobQuery = (
  { __typename?: 'query_root' }
  & { recruit_job_posting: Array<(
    { __typename?: 'recruit_job_posting' }
    & JobPartsFragment
  )> }
);

export type GetJobCVsQueryVariables = Exact<{
  userIds?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetJobCVsQuery = (
  { __typename?: 'query_root' }
  & { grad_upload_doc: Array<(
    { __typename?: 'grad_upload_doc' }
    & CVPartsFragment
  )> }
);

export type GetJobsQueryVariables = Exact<{
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetJobsQuery = (
  { __typename?: 'query_root' }
  & { recruit_job_posting_aggregate: (
    { __typename?: 'recruit_job_posting_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'recruit_job_posting_aggregate_fields' }
      & Pick<RecruitJobPostingAggregateFields, 'count'>
    )> }
  ), recruit_job_posting: Array<(
    { __typename?: 'recruit_job_posting' }
    & JobPartsFragment
  )> }
);

export type GetMessagesSubscriptionVariables = Exact<{
  candidateId?: Maybe<Scalars['String']>;
}>;


export type GetMessagesSubscription = (
  { __typename?: 'subscription_root' }
  & { recruit_sms_message: Array<(
    { __typename?: 'recruit_sms_message' }
    & { correspondents: Array<(
      { __typename?: 'recruit_sms_message_correspondent' }
      & Pick<RecruitSmsMessageCorrespondent, 'error_message'>
    )> }
    & MessagePartsFragment
  )> }
);

export type GetPersonalAchievementsQueryVariables = Exact<{
  candidateId: Scalars['String'];
}>;


export type GetPersonalAchievementsQuery = (
  { __typename?: 'query_root' }
  & { grad_achievement: Array<(
    { __typename?: 'grad_achievement' }
    & AchievementPartsFragment
  )> }
);

export type GetProfessionalDesignationsQueryVariables = Exact<{
  candidateId: Scalars['String'];
}>;


export type GetProfessionalDesignationsQuery = (
  { __typename?: 'query_root' }
  & { grad_award: Array<(
    { __typename?: 'grad_award' }
    & AwardPartsFragment
  )> }
);

export type GetProfileImagesByUserIdsQueryVariables = Exact<{
  userIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetProfileImagesByUserIdsQuery = (
  { __typename?: 'query_root' }
  & { grad_profile: Array<(
    { __typename?: 'grad_profile' }
    & CandidateImageOnlyPartsFragment
  )> }
);

export type GetRecipientByIdQueryVariables = Exact<{
  userId?: Maybe<Scalars['String']>;
}>;


export type GetRecipientByIdQuery = (
  { __typename?: 'query_root' }
  & { grad_profile: Array<(
    { __typename?: 'grad_profile' }
    & RecipientPartsFragment
  )> }
);

export type GetRecipientsByNameQueryVariables = Exact<{
  name?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetRecipientsByNameQuery = (
  { __typename?: 'query_root' }
  & { grad_profile: Array<(
    { __typename?: 'grad_profile' }
    & RecipientPartsFragment
  )> }
);

export type GetRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegionsQuery = (
  { __typename?: 'query_root' }
  & { grad_interest_region_selection: Array<(
    { __typename?: 'grad_interest_region_selection' }
    & RegionPartsFragment
  )> }
);

export type GetTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTemplatesQuery = (
  { __typename?: 'query_root' }
  & { recruit_sms_template: Array<(
    { __typename?: 'recruit_sms_template' }
    & TemplatePartsFragment
  )> }
);

export type GetVolunteerActivitiesQueryVariables = Exact<{
  candidateId: Scalars['String'];
}>;


export type GetVolunteerActivitiesQuery = (
  { __typename?: 'query_root' }
  & { grad_volunteer: Array<(
    { __typename?: 'grad_volunteer' }
    & VolunteerActivitiesPartsFragment
  )> }
);

export type HideEventMutationVariables = Exact<{
  eventID: Scalars['String'];
  show_event: Scalars['Boolean'];
}>;


export type HideEventMutation = (
  { __typename?: 'mutation_root' }
  & { update_recruit_event_by_pk?: Maybe<(
    { __typename?: 'recruit_event' }
    & Pick<RecruitEvent, 'event_id' | 'show_event'>
  )> }
);

export type InsertEventMutationVariables = Exact<{
  title: Scalars['String'];
  image: Scalars['String'];
  description: Scalars['String'];
  capacity: Scalars['Int'];
  timezone: Scalars['String'];
  startDate: Scalars['timestamp'];
  endDate: Scalars['timestamp'];
  eventType: Scalars['String'];
  address?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  userID: Scalars['String'];
  companyID: Scalars['String'];
  showEvent: Scalars['Boolean'];
}>;


export type InsertEventMutation = (
  { __typename?: 'mutation_root' }
  & { insert_recruit_event?: Maybe<(
    { __typename?: 'recruit_event_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_event' }
      & Pick<RecruitEvent, 'title' | 'image' | 'description' | 'capacity' | 'timezone' | 'start_datetime' | 'end_datetime' | 'event_type' | 'address' | 'event_url' | 'show_event'>
    )> }
  )> }
);

export type InsertGroupMembersMutationVariables = Exact<{
  groupMembers: Array<RecruitGradGroupMemberInsertInput> | RecruitGradGroupMemberInsertInput;
}>;


export type InsertGroupMembersMutation = (
  { __typename?: 'mutation_root' }
  & { insert_recruit_grad_group_member?: Maybe<(
    { __typename?: 'recruit_grad_group_member_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_grad_group_member' }
      & GroupMembershipPartsFragment
    )> }
  )> }
);

export type InsertJobRequirementsMutationVariables = Exact<{
  requirements: Array<RecruitJobRequirementInsertInput> | RecruitJobRequirementInsertInput;
}>;


export type InsertJobRequirementsMutation = (
  { __typename?: 'mutation_root' }
  & { insert_recruit_job_requirement?: Maybe<(
    { __typename?: 'recruit_job_requirement_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_job_requirement' }
      & JobRequirementPartsFragment
    )> }
  )> }
);

export type InsertTemplateMutationVariables = Exact<{
  recruiterId: Scalars['String'];
  content: Scalars['String'];
  title: Scalars['String'];
}>;


export type InsertTemplateMutation = (
  { __typename?: 'mutation_root' }
  & { insert_recruit_sms_template?: Maybe<(
    { __typename?: 'recruit_sms_template_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_sms_template' }
      & TemplatePartsFragment
    )> }
  )> }
);

export type RemoveGroupMembersMutationVariables = Exact<{
  recruiterId: Scalars['String'];
  candidatesIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type RemoveGroupMembersMutation = (
  { __typename?: 'mutation_root' }
  & { delete_recruit_grad_group_member?: Maybe<(
    { __typename?: 'recruit_grad_group_member_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_grad_group_member' }
      & GroupMembershipPartsFragment
    )> }
  )> }
);

export type RemoveGroupsMutationVariables = Exact<{
  groupsIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type RemoveGroupsMutation = (
  { __typename?: 'mutation_root' }
  & { delete_recruit_grad_group?: Maybe<(
    { __typename?: 'recruit_grad_group_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_grad_group' }
      & GroupPartsFragment
    )> }
  )> }
);

export type RemoveJobRequirementsMutationVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type RemoveJobRequirementsMutation = (
  { __typename?: 'mutation_root' }
  & { delete_recruit_job_requirement?: Maybe<(
    { __typename?: 'recruit_job_requirement_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_job_requirement' }
      & JobRequirementPartsFragment
    )> }
  )> }
);

export type UpdateCandidateBlockMutationVariables = Exact<{
  admin: Scalars['Boolean'];
  candidateId: Scalars['String'];
  blocked_reason?: Maybe<Scalars['String']>;
  blocked: Scalars['Boolean'];
}>;


export type UpdateCandidateBlockMutation = (
  { __typename?: 'mutation_root' }
  & { update_grad_profile?: Maybe<(
    { __typename?: 'grad_profile_mutation_response' }
    & { returning: Array<(
      { __typename?: 'grad_profile' }
      & CandidatePartsAdminFragment
      & CandidatePartsFragment
    )> }
  )> }
);

export type UpdateCompanyMutationVariables = Exact<{
  companyId: Scalars['Int'];
  address?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  num_employees?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
}>;


export type UpdateCompanyMutation = (
  { __typename?: 'mutation_root' }
  & { update_recruit_company_by_pk?: Maybe<(
    { __typename?: 'recruit_company' }
    & CompanyPartsFragment
  )> }
);

export type UpdateConversationSeenTimeMutationVariables = Exact<{
  recruiter_user_id: Scalars['String'];
  correspondent_user_id: Scalars['String'];
  last_read_timestamp: Scalars['timestamptz'];
}>;


export type UpdateConversationSeenTimeMutation = (
  { __typename?: 'mutation_root' }
  & { update_recruit_sms_correspondent?: Maybe<(
    { __typename?: 'recruit_sms_correspondent_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_sms_correspondent' }
      & ConversationPartsFragment
    )> }
  )> }
);

export type UpdateEventMutationVariables = Exact<{
  eventID: Scalars['String'];
  title: Scalars['String'];
  image: Scalars['String'];
  description: Scalars['String'];
  capacity: Scalars['Int'];
  timezone: Scalars['String'];
  startDate: Scalars['timestamp'];
  endDate: Scalars['timestamp'];
  eventType: Scalars['String'];
  address?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
}>;


export type UpdateEventMutation = (
  { __typename?: 'mutation_root' }
  & { update_recruit_event_by_pk?: Maybe<(
    { __typename?: 'recruit_event' }
    & Pick<RecruitEvent, 'title' | 'image' | 'description' | 'capacity' | 'timezone' | 'start_datetime' | 'end_datetime' | 'event_type' | 'address' | 'event_url'>
  )> }
);

export type UpdateJobMutationVariables = Exact<{
  job_posting_id: Scalars['String'];
  description: Scalars['String'];
  position_title: Scalars['String'];
  job_type: Scalars['String'];
  deadline?: Maybe<Scalars['date']>;
  region: Scalars['String'];
}>;


export type UpdateJobMutation = (
  { __typename?: 'mutation_root' }
  & { update_recruit_job_posting?: Maybe<(
    { __typename?: 'recruit_job_posting_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_job_posting' }
      & JobPartsFragment
    )> }
  )> }
);

export type UpdateJobsStatusActiveMutationVariables = Exact<{
  jobId: Scalars['String'];
  active: Scalars['Boolean'];
}>;


export type UpdateJobsStatusActiveMutation = (
  { __typename?: 'mutation_root' }
  & { update_recruit_job_posting?: Maybe<(
    { __typename?: 'recruit_job_posting_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_job_posting' }
      & JobPartsFragment
    )> }
  )> }
);

export type UpdateJobsStatusPublicMutationVariables = Exact<{
  jobId: Scalars['String'];
  public: Scalars['Boolean'];
}>;


export type UpdateJobsStatusPublicMutation = (
  { __typename?: 'mutation_root' }
  & { update_recruit_job_posting?: Maybe<(
    { __typename?: 'recruit_job_posting_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_job_posting' }
      & JobPartsFragment
    )> }
  )> }
);

export type UpdateTemplateMutationVariables = Exact<{
  templateId: Scalars['Int'];
  content: Scalars['String'];
  title: Scalars['String'];
}>;


export type UpdateTemplateMutation = (
  { __typename?: 'mutation_root' }
  & { update_recruit_sms_template?: Maybe<(
    { __typename?: 'recruit_sms_template_mutation_response' }
    & { returning: Array<(
      { __typename?: 'recruit_sms_template' }
      & TemplatePartsFragment
    )> }
  )> }
);

export type GetRecruitersListAdminQueryVariables = Exact<{
  email?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetRecruitersListAdminQuery = (
  { __typename?: 'query_root' }
  & { recruit_recruiter: Array<(
    { __typename?: 'recruit_recruiter' }
    & Pick<RecruitRecruiter, 'email' | 'fullname' | 'user_id' | 'twilio_phone'>
    & { account: (
      { __typename?: 'recruit_account' }
      & { company?: Maybe<(
        { __typename?: 'recruit_company' }
        & Pick<RecruitCompany, 'name'>
      )> }
    ) }
  )>, recruit_recruiter_aggregate: (
    { __typename?: 'recruit_recruiter_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'recruit_recruiter_aggregate_fields' }
      & Pick<RecruitRecruiterAggregateFields, 'count'>
    )> }
  ) }
);

export type CandidatesListPartsBaseFragment = (
  { __typename?: 'grad_profile' }
  & Pick<GradProfile, 'user_id' | 'firstname' | 'middlename' | 'lastname' | 'fullname' | 'title' | 'email' | 'comm_preference' | 'hometown' | 'years_of_relevant_work' | 'mobile' | 'student_athlete' | 'need_sponsor' | 'authorized_to_work'>
  & { test_scores: Array<(
    { __typename?: 'grad_test_score' }
    & Pick<GradTestScore, 'score' | 'outof' | 'test' | 'user_id' | 'test_score_id'>
    & { test_score_details: Array<(
      { __typename?: 'grad_test_score_detail' }
      & Pick<GradTestScoreDetail, 'detail' | 'outof' | 'score' | 'test' | 'test_score_detail_id'>
    )> }
  )>, degrees: Array<(
    { __typename?: 'grad_degree' }
    & Pick<GradDegree, 'degree_id' | 'complete_month_numeric' | 'complete_year' | 'degree' | 'degree_level' | 'gpa' | 'gpa_outof' | 'start_month_numeric' | 'start_year' | 'user_id' | 'gpa_not_applicable'>
    & { awards: Array<(
      { __typename?: 'grad_award' }
      & Pick<GradAward, 'award_id' | 'award_category' | 'award_name' | 'year_received' | 'degree_id' | 'user_id' | 'work_experience_id'>
    )>, concentrations: Array<(
      { __typename?: 'grad_concentration' }
      & Pick<GradConcentration, 'concentration_id' | 'type' | 'val' | 'degree_id' | 'user_id'>
    )>, university?: Maybe<(
      { __typename?: 'grad_university_selection' }
      & Pick<GradUniversitySelection, 'university_selection_id' | 'location_name' | 'logo_url'>
    )>, fill_in_university?: Maybe<(
      { __typename?: 'grad_degree_fill_in_university' }
      & Pick<GradDegreeFillInUniversity, 'degree_id' | 'institution_name' | 'user_id'>
    )> }
  )>, fun_facts: Array<(
    { __typename?: 'grad_fun_fact' }
    & Pick<GradFunFact, 'fun_fact_id' | 'description' | 'user_id'>
  )>, employer_preferences: Array<(
    { __typename?: 'grad_employer_preference' }
    & Pick<GradEmployerPreference, 'employer_preference_id' | 'preference' | 'user_id'>
  )>, interest_firms: Array<(
    { __typename?: 'grad_interest_firm' }
    & Pick<GradInterestFirm, 'firm_type' | 'interest_firm_id' | 'user_id'>
  )>, interest_regions: Array<(
    { __typename?: 'grad_interest_region' }
    & Pick<GradInterestRegion, 'interest_region_id' | 'region' | 'user_id'>
  )>, interest_job_types: Array<(
    { __typename?: 'grad_interest_job_type' }
    & Pick<GradInterestJobType, 'interest_job_type_id' | 'job_type' | 'user_id'>
  )>, interest_roles: Array<(
    { __typename?: 'grad_interest_role' }
    & Pick<GradInterestRole, 'role' | 'interest_role_id' | 'user_id'>
  )>, work_experiences: Array<(
    { __typename?: 'grad_work_experience' }
    & Pick<GradWorkExperience, 'work_experience_id' | 'city' | 'company' | 'end_month_numeric' | 'end_year' | 'job_type' | 'position' | 'start_month_numeric' | 'start_year' | 'state' | 'user_id'>
  )>, computer_languages: Array<(
    { __typename?: 'grad_computer_language' }
    & Pick<GradComputerLanguage, 'computer_language_id' | 'language' | 'user_id'>
  )>, spoken_languages: Array<(
    { __typename?: 'grad_spoken_language' }
    & Pick<GradSpokenLanguage, 'language' | 'spoken_language_id'>
  )> }
);

export type CandidatesListPartsFragment = (
  { __typename?: 'grad_profile' }
  & { grad_group_members: Array<(
    { __typename?: 'recruit_grad_group_member' }
    & Pick<RecruitGradGroupMember, 'recruiter_user_id' | 'student_user_id'>
    & { grad_group?: Maybe<(
      { __typename?: 'recruit_grad_group' }
      & Pick<RecruitGradGroup, 'group_name' | 'grad_group_id'>
    )> }
  )> }
  & CandidatesListPartsBaseFragment
);

export type GetCandidatesListRecruiterQueryVariables = Exact<{
  dynamicQuery?: Maybe<GradProfileBoolExp>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetCandidatesListRecruiterQuery = (
  { __typename?: 'query_root' }
  & { grad_profile_aggregate: (
    { __typename?: 'grad_profile_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'grad_profile_aggregate_fields' }
      & Pick<GradProfileAggregateFields, 'count'>
    )> }
  ), grad_profile: Array<(
    { __typename?: 'grad_profile' }
    & CandidatesListPartsFragment
  )> }
);

export type GetCompanyQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCompanyQuery = (
  { __typename?: 'query_root' }
  & { recruit_company: Array<(
    { __typename?: 'recruit_company' }
    & Pick<RecruitCompany, 'company_id' | 'account_id' | 'address' | 'description' | 'industry' | 'logo' | 'photo' | 'name' | 'num_employees' | 'phone' | 'website'>
    & { account: (
      { __typename?: 'recruit_account' }
      & Pick<RecruitAccount, 'account_id' | 'account_name'>
    ), subindustries: Array<(
      { __typename?: 'recruit_company_subindustry' }
      & Pick<RecruitCompanySubindustry, 'company_subindustry_id' | 'value'>
    )> }
  )> }
);

export type GetEventDetailQueryVariables = Exact<{
  eventID: Scalars['String'];
}>;


export type GetEventDetailQuery = (
  { __typename?: 'query_root' }
  & { recruit_event_by_pk?: Maybe<(
    { __typename?: 'recruit_event' }
    & Pick<RecruitEvent, 'title' | 'address' | 'capacity' | 'description' | 'end_datetime' | 'start_datetime' | 'timezone' | 'image' | 'event_type' | 'show_event' | 'event_id' | 'event_url'>
    & { account: (
      { __typename?: 'recruit_account' }
      & { company?: Maybe<(
        { __typename?: 'recruit_company' }
        & Pick<RecruitCompany, 'name'>
      )> }
    ), event_registrations: Array<(
      { __typename?: 'grad_event_registration' }
      & Pick<GradEventRegistration, 'user_id'>
      & { profile: (
        { __typename?: 'grad_profile' }
        & { upload_docs_aggregate: (
          { __typename?: 'grad_upload_doc_aggregate' }
          & { aggregate?: Maybe<(
            { __typename?: 'grad_upload_doc_aggregate_fields' }
            & Pick<GradUploadDocAggregateFields, 'count'>
          )> }
        ) }
      ) }
    )> }
  )> }
);

export type GetEventListPartsFragment = (
  { __typename?: 'recruit_event' }
  & Pick<RecruitEvent, 'event_id' | 'title' | 'capacity' | 'timezone' | 'image' | 'event_type' | 'start_datetime' | 'end_datetime' | 'show_event' | 'address' | 'event_url'>
  & { event_registrations: Array<(
    { __typename?: 'grad_event_registration' }
    & Pick<GradEventRegistration, 'user_id'>
  )> }
);

export type GetEventListQueryVariables = Exact<{
  userID: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetEventListQuery = (
  { __typename?: 'query_root' }
  & { recruit_event: Array<(
    { __typename?: 'recruit_event' }
    & GetEventListPartsFragment
  )>, recruit_event_aggregate: (
    { __typename?: 'recruit_event_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'recruit_event_aggregate_fields' }
      & Pick<RecruitEventAggregateFields, 'count'>
    )> }
  ) }
);

export type GetJobDismissRecipientsByIdPartsFragment = (
  { __typename?: 'grad_profile' }
  & Pick<GradProfile, 'user_id' | 'firstname' | 'fullname'>
);

export type GetJobDetailRequirementValuePartsFragment = (
  { __typename?: 'recruit_job_requirement_value' }
  & Pick<RecruitJobRequirementValue, 'label' | 'value' | 'value_id'>
);

export type GetJobDetailRequirementPartsFragment = (
  { __typename?: 'recruit_job_requirement' }
  & Pick<RecruitJobRequirement, 'requirement_name' | 'requirement_type' | 'job_requirement_id' | 'max_range_value' | 'min_range_value' | 'boolean_value'>
  & { values: Array<(
    { __typename?: 'recruit_job_requirement_value' }
    & GetJobDetailRequirementValuePartsFragment
  )> }
);

export type GetJobDetailRaisedHandPartsFragment = (
  { __typename?: 'grad_raise_hand' }
  & Pick<GradRaiseHand, 'user_id'>
  & { profile: (
    { __typename?: 'grad_profile' }
    & { upload_docs: Array<(
      { __typename?: 'grad_upload_doc' }
      & Pick<GradUploadDoc, 'user_id'>
    )> }
  ) }
);

export type GetJobDetailPartsFragment = (
  { __typename?: 'recruit_job_posting' }
  & Pick<RecruitJobPosting, 'job_type' | 'job_posting_id' | 'active' | 'public' | 'deadline' | 'description' | 'region' | 'position_title' | 'publishing_date'>
  & { job_requirements: Array<(
    { __typename?: 'recruit_job_requirement' }
    & GetJobDetailRequirementPartsFragment
  )>, raise_hands: Array<(
    { __typename?: 'grad_raise_hand' }
    & GetJobDetailRaisedHandPartsFragment
  )> }
);

export type GetJobDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetJobDetailQuery = (
  { __typename?: 'query_root' }
  & { recruit_job_posting: Array<(
    { __typename?: 'recruit_job_posting' }
    & GetJobDetailPartsFragment
  )> }
);

export type GetJobDismissRecipientsByIdQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetJobDismissRecipientsByIdQuery = (
  { __typename?: 'query_root' }
  & { grad_profile: Array<(
    { __typename?: 'grad_profile' }
    & GetJobDismissRecipientsByIdPartsFragment
  )> }
);

export type GetJobsListPartsFragment = (
  { __typename?: 'recruit_job_posting' }
  & Pick<RecruitJobPosting, 'deadline' | 'job_posting_id' | 'active' | 'public' | 'job_type' | 'region' | 'description' | 'position_title'>
  & { raise_hands: Array<(
    { __typename?: 'grad_raise_hand' }
    & Pick<GradRaiseHand, 'user_id'>
  )> }
);

export type GetJobRequirementsFragment = (
  { __typename?: 'recruit_job_posting' }
  & { job_requirements: Array<(
    { __typename?: 'recruit_job_requirement' }
    & Pick<RecruitJobRequirement, 'requirement_type' | 'requirement_name' | 'job_requirement_id' | 'min_range_value' | 'max_range_value' | 'boolean_value'>
    & { values: Array<(
      { __typename?: 'recruit_job_requirement_value' }
      & Pick<RecruitJobRequirementValue, 'value' | 'label' | 'value_id'>
    )> }
  )> }
);

export type GetJobsListQueryVariables = Exact<{
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetJobsListQuery = (
  { __typename?: 'query_root' }
  & { recruit_job_posting_aggregate: (
    { __typename?: 'recruit_job_posting_aggregate' }
    & { aggregate?: Maybe<(
      { __typename?: 'recruit_job_posting_aggregate_fields' }
      & Pick<RecruitJobPostingAggregateFields, 'count'>
    )> }
  ), recruit_job_posting: Array<(
    { __typename?: 'recruit_job_posting' }
    & GetJobsListPartsFragment
    & GetJobRequirementsFragment
  )> }
);

export type GetJobDetailCandidatesValidGPAFromIdsQueryVariables = Exact<{
  Ids?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetJobDetailCandidatesValidGPAFromIdsQuery = (
  { __typename?: 'query_root' }
  & { grad_profile: Array<(
    { __typename?: 'grad_profile' }
    & Pick<GradProfile, 'user_id'>
  )> }
);

export type GetCurrentConversationsQueryVariables = Exact<{
  candidateId?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetCurrentConversationsQuery = (
  { __typename?: 'query_root' }
  & { recruit_sms_correspondent: Array<(
    { __typename?: 'recruit_sms_correspondent' }
    & Pick<RecruitSmsCorrespondent, 'correspondent_user_id'>
  )> }
);

export type GetMyProfileRecruiterQueryVariables = Exact<{
  userId?: Maybe<Scalars['String']>;
}>;


export type GetMyProfileRecruiterQuery = (
  { __typename?: 'query_root' }
  & { recruit_recruiter: Array<(
    { __typename?: 'recruit_recruiter' }
    & Pick<RecruitRecruiter, 'fullname' | 'email' | 'user_id'>
    & { account: (
      { __typename?: 'recruit_account' }
      & { company?: Maybe<(
        { __typename?: 'recruit_company' }
        & Pick<RecruitCompany, 'name'>
      )> }
    ) }
  )> }
);

export const AccountPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment AccountParts on recruit_account {
  account_id
  account_name
}
    `;
export const SubIndustryPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment SubIndustryParts on recruit_company_subindustry {
  company_subindustry_id
  value
}
    `;
export const CompanyPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment CompanyParts on recruit_company {
  company_id
  account {
    ...AccountParts
  }
  account_id
  address
  description
  industry
  logo
  photo
  name
  num_employees
  phone
  subindustries {
    ...SubIndustryParts
  }
  website
}
    ${AccountPartsFragmentDoc}
${SubIndustryPartsFragmentDoc}`;
export const ComputerLanguageSelectorPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment ComputerLanguageSelectorParts on grad_computer_language_selection {
  computer_language
}
    `;
export const TemplatePartsFragmentDoc = /*#__PURE__*/ gql`
    fragment TemplateParts on recruit_sms_template {
  title
  text
  sms_template_id
  creation_timestamp
}
    `;
export const InterestRoleSelectorPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment InterestRoleSelectorParts on grad_interest_role_selection {
  value
  interest_role_selection_id
}
    `;
export const InterestRegionSelectorPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment InterestRegionSelectorParts on grad_interest_region_selection {
  value
  interest_region_selection_id
}
    `;
export const InterestFirmSelectorPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment InterestFirmSelectorParts on grad_interest_firm_selection {
  value
  interest_firm_selection_id
}
    `;
export const InterestJobTypeSelectorPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment InterestJobTypeSelectorParts on grad_interest_job_type_selection {
  value
  interest_job_type_selection_id
}
    `;
export const MajorSelectorPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment MajorSelectorParts on grad_major_selection {
  major
  major_selection_id
}
    `;
export const UniversityPartsStatFragmentDoc = /*#__PURE__*/ gql`
    fragment UniversityPartsStat on grad_university_stat {
  university_selection {
    university_selection_id
    location_name
  }
  degree_count
}
    `;
export const DegreeSelectorPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment DegreeSelectorParts on grad_degree_selection {
  degree
  degree_level
  degree_selection_id
  description
}
    `;
export const GroupPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment GroupParts on recruit_grad_group {
  group_name
  grad_group_id
}
    `;
export const GroupMembershipPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment GroupMembershipParts on recruit_grad_group_member {
  recruiter_user_id
  student_user_id
  grad_group {
    ...GroupParts
  }
}
    ${GroupPartsFragmentDoc}`;
export const CandidateImageOnlyPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment CandidateImageOnlyParts on grad_profile {
  user_id
  profile_image
}
    `;
export const TestScoreDetailPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment TestScoreDetailParts on grad_test_score_detail {
  detail
  outof
  score
  test
  test_score_detail_id
}
    `;
export const TestScorePartsFragmentDoc = /*#__PURE__*/ gql`
    fragment TestScoreParts on grad_test_score {
  score
  outof
  test
  user_id
  test_score_id
  test_score_details {
    ...TestScoreDetailParts
  }
}
    ${TestScoreDetailPartsFragmentDoc}`;
export const AwardPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment AwardParts on grad_award {
  award_id
  award_category
  award_name
  year_received
  degree_id
  user_id
  work_experience_id
}
    `;
export const ConcentrationPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment ConcentrationParts on grad_concentration {
  concentration_id
  type
  val
  degree_id
  user_id
}
    `;
export const UniversityPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment UniversityParts on grad_university_selection {
  university_selection_id
  location_name
  logo_url
}
    `;
export const FillInUniversityPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment FillInUniversityParts on grad_degree_fill_in_university {
  degree_id
  institution_name
  user_id
}
    `;
export const DegreePartsFragmentDoc = /*#__PURE__*/ gql`
    fragment DegreeParts on grad_degree {
  degree_id
  complete_month_numeric
  complete_year
  degree
  degree_level
  gpa
  gpa_outof
  start_month_numeric
  start_year
  user_id
  gpa_not_applicable
  awards {
    ...AwardParts
  }
  concentrations {
    ...ConcentrationParts
  }
  university {
    ...UniversityParts
  }
  fill_in_university {
    ...FillInUniversityParts
  }
}
    ${AwardPartsFragmentDoc}
${ConcentrationPartsFragmentDoc}
${UniversityPartsFragmentDoc}
${FillInUniversityPartsFragmentDoc}`;
export const FunFactPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment FunFactParts on grad_fun_fact {
  fun_fact_id
  description
  user_id
}
    `;
export const EmployerPreferencesPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment EmployerPreferencesParts on grad_employer_preference {
  employer_preference_id
  preference
  user_id
}
    `;
export const InterestFirmPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment InterestFirmParts on grad_interest_firm {
  firm_type
  interest_firm_id
  user_id
}
    `;
export const InterestRegionPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment InterestRegionParts on grad_interest_region {
  interest_region_id
  region
  user_id
}
    `;
export const InterestJobTypePartsFragmentDoc = /*#__PURE__*/ gql`
    fragment InterestJobTypeParts on grad_interest_job_type {
  interest_job_type_id
  job_type
  user_id
}
    `;
export const InterestRolePartsFragmentDoc = /*#__PURE__*/ gql`
    fragment InterestRoleParts on grad_interest_role {
  role
  interest_role_id
  user_id
}
    `;
export const WorkExperiencePartsFragmentDoc = /*#__PURE__*/ gql`
    fragment WorkExperienceParts on grad_work_experience {
  work_experience_id
  city
  company
  end_month_numeric
  end_year
  job_type
  position
  start_month_numeric
  start_year
  state
  user_id
}
    `;
export const ComputerLanguagePartsFragmentDoc = /*#__PURE__*/ gql`
    fragment ComputerLanguageParts on grad_computer_language {
  computer_language_id
  language
  user_id
}
    `;
export const LanguageSelectorPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment LanguageSelectorParts on grad_spoken_language {
  language
  spoken_language_id
}
    `;
export const AchievementPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment AchievementParts on grad_achievement {
  achievement_id
  description
}
    `;
export const VolunteerActivitiesPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment VolunteerActivitiesParts on grad_volunteer {
  volunteer_id
  description
}
    `;
export const CandidatePartsBaseFragmentDoc = /*#__PURE__*/ gql`
    fragment CandidatePartsBase on grad_profile {
  user_id
  firstname
  middlename
  lastname
  fullname
  title
  email
  hometown
  comm_preference
  years_of_relevant_work
  mobile
  student_athlete
  need_sponsor
  authorized_to_work
  legal_residence_country {
    country
  }
  test_scores {
    ...TestScoreParts
  }
  degrees {
    ...DegreeParts
  }
  fun_facts {
    ...FunFactParts
  }
  employer_preferences {
    ...EmployerPreferencesParts
  }
  interest_firms {
    ...InterestFirmParts
  }
  interest_regions {
    ...InterestRegionParts
  }
  interest_job_types {
    ...InterestJobTypeParts
  }
  interest_roles {
    ...InterestRoleParts
  }
  work_experiences {
    ...WorkExperienceParts
  }
  computer_languages {
    ...ComputerLanguageParts
  }
  spoken_languages {
    ...LanguageSelectorParts
  }
  achievements {
    ...AchievementParts
  }
  volunteers {
    ...VolunteerActivitiesParts
  }
  awards {
    ...AwardParts
  }
}
    ${TestScorePartsFragmentDoc}
${DegreePartsFragmentDoc}
${FunFactPartsFragmentDoc}
${EmployerPreferencesPartsFragmentDoc}
${InterestFirmPartsFragmentDoc}
${InterestRegionPartsFragmentDoc}
${InterestJobTypePartsFragmentDoc}
${InterestRolePartsFragmentDoc}
${WorkExperiencePartsFragmentDoc}
${ComputerLanguagePartsFragmentDoc}
${LanguageSelectorPartsFragmentDoc}
${AchievementPartsFragmentDoc}
${VolunteerActivitiesPartsFragmentDoc}
${AwardPartsFragmentDoc}`;
export const CandidatePartsFragmentDoc = /*#__PURE__*/ gql`
    fragment CandidateParts on grad_profile {
  grad_group_members {
    recruiter_user_id
    student_user_id
    grad_group {
      group_name
      grad_group_id
    }
  }
  ...CandidatePartsBase
  upload_docs_aggregate {
    aggregate {
      count
    }
  }
}
    ${CandidatePartsBaseFragmentDoc}`;
export const CandidatePartsAdminFragmentDoc = /*#__PURE__*/ gql`
    fragment CandidatePartsAdmin on grad_profile {
  blocked
  blocked_reason
  ...CandidatePartsBase
  upload_docs_aggregate {
    aggregate {
      count
    }
  }
}
    ${CandidatePartsBaseFragmentDoc}`;
export const CVPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment CVParts on grad_upload_doc {
  filename
  hex_content
  upload_doc_id
  user_id
}
    `;
export const MessagePartsFragmentDoc = /*#__PURE__*/ gql`
    fragment MessageParts on recruit_sms_message {
  content
  incoming
  recruiter_user_id
  sms_message_id
  timestamp
}
    `;
export const MessageCorrespondentPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment MessageCorrespondentParts on recruit_sms_message_correspondent {
  message {
    content
    incoming
    recruiter_user_id
    sms_message_id
    timestamp
  }
}
    `;
export const RecipientPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment RecipientParts on grad_profile {
  user_id
  firstname
  middlename
  lastname
  fullname
  title
  profile_image
  degrees {
    ...DegreeParts
  }
}
    ${DegreePartsFragmentDoc}`;
export const ConversationPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment ConversationParts on recruit_sms_correspondent {
  recruiter_user_id
  correspondent_user_id
  sms_correspondent_id
  last_incoming_timestamp
  last_message_timestamp
  last_outgoing_timestamp
  last_read_timestamp
  archived
  blocked
  conversation_ended
  blocked_reason
  grad_profile {
    ...RecipientParts
  }
}
    ${RecipientPartsFragmentDoc}`;
export const RegionPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment RegionParts on grad_interest_region_selection {
  interest_region_selection_id
  value
}
    `;
export const JobRequirementValuePartsFragmentDoc = /*#__PURE__*/ gql`
    fragment JobRequirementValueParts on recruit_job_requirement_value {
  label
  value
  value_id
  job_requirement_value_id
}
    `;
export const JobRequirementPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment JobRequirementParts on recruit_job_requirement {
  requirement_name
  requirement_type
  boolean_value
  job_requirement_id
  max_range_value
  min_range_value
  number_value
  values {
    ...JobRequirementValueParts
  }
}
    ${JobRequirementValuePartsFragmentDoc}`;
export const RaisedHandPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment RaisedHandParts on grad_raise_hand {
  raise__hand_id
  user_id
  job_posting_id
}
    `;
export const JobPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment JobParts on recruit_job_posting {
  job_posting_id
  account_id
  active
  creation_date
  creator_id
  deadline
  description
  firm
  job_type
  modified_date
  position_title
  publishing_date
  region
  public
  job_requirements {
    ...JobRequirementParts
  }
  raise_hands {
    ...RaisedHandParts
  }
}
    ${JobRequirementPartsFragmentDoc}
${RaisedHandPartsFragmentDoc}`;
export const CandidatesListPartsBaseFragmentDoc = /*#__PURE__*/ gql`
    fragment CandidatesListPartsBase on grad_profile {
  user_id
  firstname
  middlename
  lastname
  fullname
  title
  email
  comm_preference
  hometown
  years_of_relevant_work
  mobile
  student_athlete
  need_sponsor
  authorized_to_work
  test_scores {
    score
    outof
    test
    user_id
    test_score_id
    test_score_details {
      detail
      outof
      score
      test
      test_score_detail_id
    }
  }
  degrees {
    degree_id
    complete_month_numeric
    complete_year
    degree
    degree_level
    gpa
    gpa_outof
    start_month_numeric
    start_year
    user_id
    gpa_not_applicable
    awards {
      award_id
      award_category
      award_name
      year_received
      degree_id
      user_id
      work_experience_id
    }
    concentrations {
      concentration_id
      type
      val
      degree_id
      user_id
    }
    university {
      university_selection_id
      location_name
      logo_url
    }
    fill_in_university {
      degree_id
      institution_name
      user_id
    }
  }
  fun_facts {
    fun_fact_id
    description
    user_id
  }
  employer_preferences {
    employer_preference_id
    preference
    user_id
  }
  interest_firms {
    firm_type
    interest_firm_id
    user_id
  }
  interest_regions {
    interest_region_id
    region
    user_id
  }
  interest_job_types {
    interest_job_type_id
    job_type
    user_id
  }
  interest_roles {
    role
    interest_role_id
    user_id
  }
  work_experiences {
    work_experience_id
    city
    company
    end_month_numeric
    end_year
    job_type
    position
    start_month_numeric
    start_year
    state
    user_id
  }
  computer_languages {
    computer_language_id
    language
    user_id
  }
  spoken_languages {
    language
    spoken_language_id
  }
}
    `;
export const CandidatesListPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment CandidatesListParts on grad_profile {
  grad_group_members {
    recruiter_user_id
    student_user_id
    grad_group {
      group_name
      grad_group_id
    }
  }
  ...CandidatesListPartsBase
}
    ${CandidatesListPartsBaseFragmentDoc}`;
export const GetEventListPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment GetEventListParts on recruit_event {
  event_id
  title
  capacity
  timezone
  image
  event_type
  start_datetime
  end_datetime
  show_event
  address
  event_url
  event_registrations {
    user_id
  }
}
    `;
export const GetJobDismissRecipientsByIdPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment GetJobDismissRecipientsByIdParts on grad_profile {
  user_id
  firstname
  fullname
}
    `;
export const GetJobDetailRequirementValuePartsFragmentDoc = /*#__PURE__*/ gql`
    fragment GetJobDetailRequirementValueParts on recruit_job_requirement_value {
  label
  value
  value_id
}
    `;
export const GetJobDetailRequirementPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment GetJobDetailRequirementParts on recruit_job_requirement {
  requirement_name
  requirement_type
  job_requirement_id
  max_range_value
  min_range_value
  boolean_value
  values {
    ...GetJobDetailRequirementValueParts
  }
}
    ${GetJobDetailRequirementValuePartsFragmentDoc}`;
export const GetJobDetailRaisedHandPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment GetJobDetailRaisedHandParts on grad_raise_hand {
  user_id
  profile {
    upload_docs(where: {hex_content: {_is_null: true}}) {
      user_id
    }
  }
}
    `;
export const GetJobDetailPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment GetJobDetailParts on recruit_job_posting {
  job_type
  job_posting_id
  active
  public
  deadline
  description
  region
  position_title
  publishing_date
  job_requirements {
    ...GetJobDetailRequirementParts
  }
  raise_hands(where: {profile: {upload_docs: {hex_content: {_is_null: false}}}}) {
    ...GetJobDetailRaisedHandParts
  }
}
    ${GetJobDetailRequirementPartsFragmentDoc}
${GetJobDetailRaisedHandPartsFragmentDoc}`;
export const GetJobsListPartsFragmentDoc = /*#__PURE__*/ gql`
    fragment GetJobsListParts on recruit_job_posting {
  deadline
  job_posting_id
  active
  public
  job_type
  region
  description
  position_title
  raise_hands(where: {profile: {upload_docs: {hex_content: {_is_null: false}}}}) {
    user_id
  }
}
    `;
export const GetJobRequirementsFragmentDoc = /*#__PURE__*/ gql`
    fragment GetJobRequirements on recruit_job_posting {
  job_requirements {
    requirement_type
    requirement_name
    job_requirement_id
    min_range_value
    max_range_value
    boolean_value
    values {
      value
      label
      value_id
    }
  }
}
    `;
export const GetCandidateIdentityDocument = /*#__PURE__*/ gql`
    query GetCandidateIdentity($userId: String!) {
  grad_profile(where: {user_id: {_eq: $userId}}) {
    title
    fullname
    profile_image
    need_sponsor
    authorized_to_work
    degrees {
      degree
      complete_year
      awards {
        award_category
        award_name
        year_received
      }
      concentrations {
        val
        type
      }
      university {
        logo_url
        location_name
      }
      fill_in_university {
        institution_name
      }
      gpa
      gpa_outof
      gpa_not_applicable
    }
  }
  grad_award(
    where: {user_id: {_eq: $userId}, award_category: {_eq: "Professional designation"}}
    order_by: {year_received: desc}
  ) {
    award_name
    year_received
  }
}
    `;

/**
 * __useGetCandidateIdentityQuery__
 *
 * To run a query within a React component, call `useGetCandidateIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateIdentityQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCandidateIdentityQuery(baseOptions: Apollo.QueryHookOptions<GetCandidateIdentityQuery, GetCandidateIdentityQueryVariables>) {
        return Apollo.useQuery<GetCandidateIdentityQuery, GetCandidateIdentityQueryVariables>(GetCandidateIdentityDocument, baseOptions);
      }
export function useGetCandidateIdentityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateIdentityQuery, GetCandidateIdentityQueryVariables>) {
          return Apollo.useLazyQuery<GetCandidateIdentityQuery, GetCandidateIdentityQueryVariables>(GetCandidateIdentityDocument, baseOptions);
        }
export type GetCandidateIdentityQueryHookResult = ReturnType<typeof useGetCandidateIdentityQuery>;
export type GetCandidateIdentityLazyQueryHookResult = ReturnType<typeof useGetCandidateIdentityLazyQuery>;
export type GetCandidateIdentityQueryResult = Apollo.QueryResult<GetCandidateIdentityQuery, GetCandidateIdentityQueryVariables>;
export const GetCandidatesByGroupDocument = /*#__PURE__*/ gql`
    query GetCandidatesByGroup($groupId: String!) {
  recruit_grad_group(where: {grad_group_id: {_eq: $groupId}}) {
    ...GroupParts
    grad_group_members {
      profile {
        title
        fullname
        firstname
        middlename
        lastname
        profile_image
        user_id
        degrees {
          degree
          complete_year
          university {
            location_name
          }
          gpa
          gpa_outof
          gpa_not_applicable
        }
      }
    }
  }
}
    ${GroupPartsFragmentDoc}`;

/**
 * __useGetCandidatesByGroupQuery__
 *
 * To run a query within a React component, call `useGetCandidatesByGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidatesByGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidatesByGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetCandidatesByGroupQuery(baseOptions: Apollo.QueryHookOptions<GetCandidatesByGroupQuery, GetCandidatesByGroupQueryVariables>) {
        return Apollo.useQuery<GetCandidatesByGroupQuery, GetCandidatesByGroupQueryVariables>(GetCandidatesByGroupDocument, baseOptions);
      }
export function useGetCandidatesByGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidatesByGroupQuery, GetCandidatesByGroupQueryVariables>) {
          return Apollo.useLazyQuery<GetCandidatesByGroupQuery, GetCandidatesByGroupQueryVariables>(GetCandidatesByGroupDocument, baseOptions);
        }
export type GetCandidatesByGroupQueryHookResult = ReturnType<typeof useGetCandidatesByGroupQuery>;
export type GetCandidatesByGroupLazyQueryHookResult = ReturnType<typeof useGetCandidatesByGroupLazyQuery>;
export type GetCandidatesByGroupQueryResult = Apollo.QueryResult<GetCandidatesByGroupQuery, GetCandidatesByGroupQueryVariables>;
export const GetMajorSelectionDocument = /*#__PURE__*/ gql`
    query GetMajorSelection($major_name: String!) {
  grad_major_selection(where: {major: {_ilike: $major_name}}) {
    ...MajorSelectorParts
  }
}
    ${MajorSelectorPartsFragmentDoc}`;

/**
 * __useGetMajorSelectionQuery__
 *
 * To run a query within a React component, call `useGetMajorSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMajorSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMajorSelectionQuery({
 *   variables: {
 *      major_name: // value for 'major_name'
 *   },
 * });
 */
export function useGetMajorSelectionQuery(baseOptions: Apollo.QueryHookOptions<GetMajorSelectionQuery, GetMajorSelectionQueryVariables>) {
        return Apollo.useQuery<GetMajorSelectionQuery, GetMajorSelectionQueryVariables>(GetMajorSelectionDocument, baseOptions);
      }
export function useGetMajorSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMajorSelectionQuery, GetMajorSelectionQueryVariables>) {
          return Apollo.useLazyQuery<GetMajorSelectionQuery, GetMajorSelectionQueryVariables>(GetMajorSelectionDocument, baseOptions);
        }
export type GetMajorSelectionQueryHookResult = ReturnType<typeof useGetMajorSelectionQuery>;
export type GetMajorSelectionLazyQueryHookResult = ReturnType<typeof useGetMajorSelectionLazyQuery>;
export type GetMajorSelectionQueryResult = Apollo.QueryResult<GetMajorSelectionQuery, GetMajorSelectionQueryVariables>;
export const GetUniversitySelectionDocument = /*#__PURE__*/ gql`
    query GetUniversitySelection($location_name: String!) {
  grad_university_stat(
    order_by: {degree_count: desc}
    where: {university_selection: {location_name: {_ilike: $location_name}}}
  ) {
    ...UniversityPartsStat
  }
}
    ${UniversityPartsStatFragmentDoc}`;

/**
 * __useGetUniversitySelectionQuery__
 *
 * To run a query within a React component, call `useGetUniversitySelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniversitySelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniversitySelectionQuery({
 *   variables: {
 *      location_name: // value for 'location_name'
 *   },
 * });
 */
export function useGetUniversitySelectionQuery(baseOptions: Apollo.QueryHookOptions<GetUniversitySelectionQuery, GetUniversitySelectionQueryVariables>) {
        return Apollo.useQuery<GetUniversitySelectionQuery, GetUniversitySelectionQueryVariables>(GetUniversitySelectionDocument, baseOptions);
      }
export function useGetUniversitySelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniversitySelectionQuery, GetUniversitySelectionQueryVariables>) {
          return Apollo.useLazyQuery<GetUniversitySelectionQuery, GetUniversitySelectionQueryVariables>(GetUniversitySelectionDocument, baseOptions);
        }
export type GetUniversitySelectionQueryHookResult = ReturnType<typeof useGetUniversitySelectionQuery>;
export type GetUniversitySelectionLazyQueryHookResult = ReturnType<typeof useGetUniversitySelectionLazyQuery>;
export type GetUniversitySelectionQueryResult = Apollo.QueryResult<GetUniversitySelectionQuery, GetUniversitySelectionQueryVariables>;
export const InsertSMSMessageDocument = /*#__PURE__*/ gql`
    mutation InsertSMSMessage($content: String, $recruiter_user_id: String, $correspondents: [recruit_sms_message_correspondent_insert_input!]!) {
  insert_recruit_sms_message(
    objects: {content: $content, incoming: false, recruiter_user_id: $recruiter_user_id, correspondents: {data: $correspondents, on_conflict: {constraint: sms_message_correspondent_pkey, update_columns: []}}}
  ) {
    returning {
      ...MessageParts
    }
  }
}
    ${MessagePartsFragmentDoc}`;
export type InsertSMSMessageMutationFn = Apollo.MutationFunction<InsertSMSMessageMutation, InsertSMSMessageMutationVariables>;

/**
 * __useInsertSMSMessageMutation__
 *
 * To run a mutation, you first call `useInsertSMSMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertSMSMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertSmsMessageMutation, { data, loading, error }] = useInsertSMSMessageMutation({
 *   variables: {
 *      content: // value for 'content'
 *      recruiter_user_id: // value for 'recruiter_user_id'
 *      correspondents: // value for 'correspondents'
 *   },
 * });
 */
export function useInsertSMSMessageMutation(baseOptions?: Apollo.MutationHookOptions<InsertSMSMessageMutation, InsertSMSMessageMutationVariables>) {
        return Apollo.useMutation<InsertSMSMessageMutation, InsertSMSMessageMutationVariables>(InsertSMSMessageDocument, baseOptions);
      }
export type InsertSMSMessageMutationHookResult = ReturnType<typeof useInsertSMSMessageMutation>;
export type InsertSMSMessageMutationResult = Apollo.MutationResult<InsertSMSMessageMutation>;
export type InsertSMSMessageMutationOptions = Apollo.BaseMutationOptions<InsertSMSMessageMutation, InsertSMSMessageMutationVariables>;
export const CleanInsertCompanySubIndustryDocument = /*#__PURE__*/ gql`
    mutation CleanInsertCompanySubIndustry($companyId: Int, $subIndustries: [recruit_company_subindustry_insert_input!]!) {
  delete_recruit_company_subindustry(where: {company_id: {_eq: $companyId}}) {
    returning {
      ...SubIndustryParts
    }
  }
  insert_recruit_company_subindustry(objects: $subIndustries) {
    returning {
      ...SubIndustryParts
    }
  }
}
    ${SubIndustryPartsFragmentDoc}`;
export type CleanInsertCompanySubIndustryMutationFn = Apollo.MutationFunction<CleanInsertCompanySubIndustryMutation, CleanInsertCompanySubIndustryMutationVariables>;

/**
 * __useCleanInsertCompanySubIndustryMutation__
 *
 * To run a mutation, you first call `useCleanInsertCompanySubIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCleanInsertCompanySubIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cleanInsertCompanySubIndustryMutation, { data, loading, error }] = useCleanInsertCompanySubIndustryMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      subIndustries: // value for 'subIndustries'
 *   },
 * });
 */
export function useCleanInsertCompanySubIndustryMutation(baseOptions?: Apollo.MutationHookOptions<CleanInsertCompanySubIndustryMutation, CleanInsertCompanySubIndustryMutationVariables>) {
        return Apollo.useMutation<CleanInsertCompanySubIndustryMutation, CleanInsertCompanySubIndustryMutationVariables>(CleanInsertCompanySubIndustryDocument, baseOptions);
      }
export type CleanInsertCompanySubIndustryMutationHookResult = ReturnType<typeof useCleanInsertCompanySubIndustryMutation>;
export type CleanInsertCompanySubIndustryMutationResult = Apollo.MutationResult<CleanInsertCompanySubIndustryMutation>;
export type CleanInsertCompanySubIndustryMutationOptions = Apollo.BaseMutationOptions<CleanInsertCompanySubIndustryMutation, CleanInsertCompanySubIndustryMutationVariables>;
export const CreateGroupDocument = /*#__PURE__*/ gql`
    mutation CreateGroup($recruiter_user_id: String!, $group_name: String!) {
  insert_recruit_grad_group(
    objects: {recruiter_user_id: $recruiter_user_id, group_name: $group_name}
  ) {
    returning {
      ...GroupParts
    }
  }
}
    ${GroupPartsFragmentDoc}`;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      recruiter_user_id: // value for 'recruiter_user_id'
 *      group_name: // value for 'group_name'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, baseOptions);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const CreateJobDocument = /*#__PURE__*/ gql`
    mutation CreateJob($account_id: String!, $active: Boolean!, $creation_date: date, $creator_id: String!, $description: String!, $firm: String!, $position_title: String!, $job_type: String!, $deadline: date, $region: String!, $requirements: [recruit_job_requirement_insert_input!]!) {
  insert_recruit_job_posting(
    objects: {account_id: $account_id, active: $active, creation_date: $creation_date, creator_id: $creator_id, description: $description, firm: $firm, position_title: $position_title, job_type: $job_type, deadline: $deadline, region: $region, job_requirements: {data: $requirements}}
  ) {
    returning {
      ...JobParts
    }
  }
}
    ${JobPartsFragmentDoc}`;
export type CreateJobMutationFn = Apollo.MutationFunction<CreateJobMutation, CreateJobMutationVariables>;

/**
 * __useCreateJobMutation__
 *
 * To run a mutation, you first call `useCreateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobMutation, { data, loading, error }] = useCreateJobMutation({
 *   variables: {
 *      account_id: // value for 'account_id'
 *      active: // value for 'active'
 *      creation_date: // value for 'creation_date'
 *      creator_id: // value for 'creator_id'
 *      description: // value for 'description'
 *      firm: // value for 'firm'
 *      position_title: // value for 'position_title'
 *      job_type: // value for 'job_type'
 *      deadline: // value for 'deadline'
 *      region: // value for 'region'
 *      requirements: // value for 'requirements'
 *   },
 * });
 */
export function useCreateJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobMutation, CreateJobMutationVariables>) {
        return Apollo.useMutation<CreateJobMutation, CreateJobMutationVariables>(CreateJobDocument, baseOptions);
      }
export type CreateJobMutationHookResult = ReturnType<typeof useCreateJobMutation>;
export type CreateJobMutationResult = Apollo.MutationResult<CreateJobMutation>;
export type CreateJobMutationOptions = Apollo.BaseMutationOptions<CreateJobMutation, CreateJobMutationVariables>;
export const DeleteConversationDocument = /*#__PURE__*/ gql`
    mutation DeleteConversation($candidateId: String, $recruiterId: String) {
  delete_recruit_sms_correspondent(
    where: {recruiter_user_id: {_eq: $recruiterId}, _and: {correspondent_user_id: {_eq: $candidateId}}}
  ) {
    returning {
      correspondent_user_id
    }
  }
}
    `;
export type DeleteConversationMutationFn = Apollo.MutationFunction<DeleteConversationMutation, DeleteConversationMutationVariables>;

/**
 * __useDeleteConversationMutation__
 *
 * To run a mutation, you first call `useDeleteConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConversationMutation, { data, loading, error }] = useDeleteConversationMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      recruiterId: // value for 'recruiterId'
 *   },
 * });
 */
export function useDeleteConversationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConversationMutation, DeleteConversationMutationVariables>) {
        return Apollo.useMutation<DeleteConversationMutation, DeleteConversationMutationVariables>(DeleteConversationDocument, baseOptions);
      }
export type DeleteConversationMutationHookResult = ReturnType<typeof useDeleteConversationMutation>;
export type DeleteConversationMutationResult = Apollo.MutationResult<DeleteConversationMutation>;
export type DeleteConversationMutationOptions = Apollo.BaseMutationOptions<DeleteConversationMutation, DeleteConversationMutationVariables>;
export const DeleteEventDocument = /*#__PURE__*/ gql`
    mutation DeleteEvent($eventID: String!) {
  delete_recruit_event(where: {event_id: {_eq: $eventID}}) {
    returning {
      event_id
    }
  }
}
    `;
export type DeleteEventMutationFn = Apollo.MutationFunction<DeleteEventMutation, DeleteEventMutationVariables>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      eventID: // value for 'eventID'
 *   },
 * });
 */
export function useDeleteEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventMutation, DeleteEventMutationVariables>) {
        return Apollo.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(DeleteEventDocument, baseOptions);
      }
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>;
export type DeleteEventMutationResult = Apollo.MutationResult<DeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<DeleteEventMutation, DeleteEventMutationVariables>;
export const DeleteJobDocument = /*#__PURE__*/ gql`
    mutation DeleteJob($jobId: String!) {
  delete_recruit_job_posting(where: {job_posting_id: {_eq: $jobId}}) {
    returning {
      job_posting_id
    }
  }
}
    `;
export type DeleteJobMutationFn = Apollo.MutationFunction<DeleteJobMutation, DeleteJobMutationVariables>;

/**
 * __useDeleteJobMutation__
 *
 * To run a mutation, you first call `useDeleteJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobMutation, { data, loading, error }] = useDeleteJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDeleteJobMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobMutation, DeleteJobMutationVariables>) {
        return Apollo.useMutation<DeleteJobMutation, DeleteJobMutationVariables>(DeleteJobDocument, baseOptions);
      }
export type DeleteJobMutationHookResult = ReturnType<typeof useDeleteJobMutation>;
export type DeleteJobMutationResult = Apollo.MutationResult<DeleteJobMutation>;
export type DeleteJobMutationOptions = Apollo.BaseMutationOptions<DeleteJobMutation, DeleteJobMutationVariables>;
export const DeleteTemplateDocument = /*#__PURE__*/ gql`
    mutation DeleteTemplate($templateId: Int!) {
  delete_recruit_sms_template(where: {sms_template_id: {_eq: $templateId}}) {
    returning {
      ...TemplateParts
    }
  }
}
    ${TemplatePartsFragmentDoc}`;
export type DeleteTemplateMutationFn = Apollo.MutationFunction<DeleteTemplateMutation, DeleteTemplateMutationVariables>;

/**
 * __useDeleteTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateMutation, { data, loading, error }] = useDeleteTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useDeleteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>) {
        return Apollo.useMutation<DeleteTemplateMutation, DeleteTemplateMutationVariables>(DeleteTemplateDocument, baseOptions);
      }
export type DeleteTemplateMutationHookResult = ReturnType<typeof useDeleteTemplateMutation>;
export type DeleteTemplateMutationResult = Apollo.MutationResult<DeleteTemplateMutation>;
export type DeleteTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>;
export const DownloadCVDocument = /*#__PURE__*/ gql`
    query DownloadCV($userId: String!) {
  grad_upload_doc(where: {user_id: {_eq: $userId}}) {
    ...CVParts
  }
}
    ${CVPartsFragmentDoc}`;

/**
 * __useDownloadCVQuery__
 *
 * To run a query within a React component, call `useDownloadCVQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCVQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadCVQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDownloadCVQuery(baseOptions: Apollo.QueryHookOptions<DownloadCVQuery, DownloadCVQueryVariables>) {
        return Apollo.useQuery<DownloadCVQuery, DownloadCVQueryVariables>(DownloadCVDocument, baseOptions);
      }
export function useDownloadCVLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadCVQuery, DownloadCVQueryVariables>) {
          return Apollo.useLazyQuery<DownloadCVQuery, DownloadCVQueryVariables>(DownloadCVDocument, baseOptions);
        }
export type DownloadCVQueryHookResult = ReturnType<typeof useDownloadCVQuery>;
export type DownloadCVLazyQueryHookResult = ReturnType<typeof useDownloadCVLazyQuery>;
export type DownloadCVQueryResult = Apollo.QueryResult<DownloadCVQuery, DownloadCVQueryVariables>;
export const DownloadCVByIdDocument = /*#__PURE__*/ gql`
    query DownloadCVById($uploadDocId: String!) {
  grad_upload_doc(where: {upload_doc_id: {_eq: $uploadDocId}}) {
    ...CVParts
  }
}
    ${CVPartsFragmentDoc}`;

/**
 * __useDownloadCVByIdQuery__
 *
 * To run a query within a React component, call `useDownloadCVByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCVByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadCVByIdQuery({
 *   variables: {
 *      uploadDocId: // value for 'uploadDocId'
 *   },
 * });
 */
export function useDownloadCVByIdQuery(baseOptions: Apollo.QueryHookOptions<DownloadCVByIdQuery, DownloadCVByIdQueryVariables>) {
        return Apollo.useQuery<DownloadCVByIdQuery, DownloadCVByIdQueryVariables>(DownloadCVByIdDocument, baseOptions);
      }
export function useDownloadCVByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadCVByIdQuery, DownloadCVByIdQueryVariables>) {
          return Apollo.useLazyQuery<DownloadCVByIdQuery, DownloadCVByIdQueryVariables>(DownloadCVByIdDocument, baseOptions);
        }
export type DownloadCVByIdQueryHookResult = ReturnType<typeof useDownloadCVByIdQuery>;
export type DownloadCVByIdLazyQueryHookResult = ReturnType<typeof useDownloadCVByIdLazyQuery>;
export type DownloadCVByIdQueryResult = Apollo.QueryResult<DownloadCVByIdQuery, DownloadCVByIdQueryVariables>;
export const ExistCVDocument = /*#__PURE__*/ gql`
    query ExistCV($userId: String!) {
  grad_upload_doc_aggregate(where: {user_id: {_eq: $userId}}) {
    aggregate {
      count(distinct: true)
    }
  }
}
    `;

/**
 * __useExistCVQuery__
 *
 * To run a query within a React component, call `useExistCVQuery` and pass it any options that fit your needs.
 * When your component renders, `useExistCVQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExistCVQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useExistCVQuery(baseOptions: Apollo.QueryHookOptions<ExistCVQuery, ExistCVQueryVariables>) {
        return Apollo.useQuery<ExistCVQuery, ExistCVQueryVariables>(ExistCVDocument, baseOptions);
      }
export function useExistCVLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExistCVQuery, ExistCVQueryVariables>) {
          return Apollo.useLazyQuery<ExistCVQuery, ExistCVQueryVariables>(ExistCVDocument, baseOptions);
        }
export type ExistCVQueryHookResult = ReturnType<typeof useExistCVQuery>;
export type ExistCVLazyQueryHookResult = ReturnType<typeof useExistCVLazyQuery>;
export type ExistCVQueryResult = Apollo.QueryResult<ExistCVQuery, ExistCVQueryVariables>;
export const GetCVsByUsersIdDocument = /*#__PURE__*/ gql`
    query GetCVsByUsersId($userIds: [String!]) {
  grad_upload_doc(where: {user_id: {_in: $userIds}}) {
    ...CVParts
  }
}
    ${CVPartsFragmentDoc}`;

/**
 * __useGetCVsByUsersIdQuery__
 *
 * To run a query within a React component, call `useGetCVsByUsersIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCVsByUsersIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCVsByUsersIdQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetCVsByUsersIdQuery(baseOptions?: Apollo.QueryHookOptions<GetCVsByUsersIdQuery, GetCVsByUsersIdQueryVariables>) {
        return Apollo.useQuery<GetCVsByUsersIdQuery, GetCVsByUsersIdQueryVariables>(GetCVsByUsersIdDocument, baseOptions);
      }
export function useGetCVsByUsersIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCVsByUsersIdQuery, GetCVsByUsersIdQueryVariables>) {
          return Apollo.useLazyQuery<GetCVsByUsersIdQuery, GetCVsByUsersIdQueryVariables>(GetCVsByUsersIdDocument, baseOptions);
        }
export type GetCVsByUsersIdQueryHookResult = ReturnType<typeof useGetCVsByUsersIdQuery>;
export type GetCVsByUsersIdLazyQueryHookResult = ReturnType<typeof useGetCVsByUsersIdLazyQuery>;
export type GetCVsByUsersIdQueryResult = Apollo.QueryResult<GetCVsByUsersIdQuery, GetCVsByUsersIdQueryVariables>;
export const GetCVsCountByUsersIdDocument = /*#__PURE__*/ gql`
    query GetCVsCountByUsersId($userIds: [String!]) {
  grad_upload_doc_aggregate(where: {user_id: {_in: $userIds}}) {
    aggregate {
      count(distinct: true)
    }
  }
}
    `;

/**
 * __useGetCVsCountByUsersIdQuery__
 *
 * To run a query within a React component, call `useGetCVsCountByUsersIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCVsCountByUsersIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCVsCountByUsersIdQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetCVsCountByUsersIdQuery(baseOptions?: Apollo.QueryHookOptions<GetCVsCountByUsersIdQuery, GetCVsCountByUsersIdQueryVariables>) {
        return Apollo.useQuery<GetCVsCountByUsersIdQuery, GetCVsCountByUsersIdQueryVariables>(GetCVsCountByUsersIdDocument, baseOptions);
      }
export function useGetCVsCountByUsersIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCVsCountByUsersIdQuery, GetCVsCountByUsersIdQueryVariables>) {
          return Apollo.useLazyQuery<GetCVsCountByUsersIdQuery, GetCVsCountByUsersIdQueryVariables>(GetCVsCountByUsersIdDocument, baseOptions);
        }
export type GetCVsCountByUsersIdQueryHookResult = ReturnType<typeof useGetCVsCountByUsersIdQuery>;
export type GetCVsCountByUsersIdLazyQueryHookResult = ReturnType<typeof useGetCVsCountByUsersIdLazyQuery>;
export type GetCVsCountByUsersIdQueryResult = Apollo.QueryResult<GetCVsCountByUsersIdQuery, GetCVsCountByUsersIdQueryVariables>;
export const GetCandidateDocument = /*#__PURE__*/ gql`
    query GetCandidate($admin: Boolean!, $userId: String!) {
  grad_profile(where: {user_id: {_eq: $userId}}) {
    ... on grad_profile @include(if: $admin) {
      ...CandidatePartsAdmin
    }
    ... on grad_profile @skip(if: $admin) {
      ...CandidateParts
    }
    profile_image
  }
}
    ${CandidatePartsAdminFragmentDoc}
${CandidatePartsFragmentDoc}`;

/**
 * __useGetCandidateQuery__
 *
 * To run a query within a React component, call `useGetCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCandidateQuery(baseOptions: Apollo.QueryHookOptions<GetCandidateQuery, GetCandidateQueryVariables>) {
        return Apollo.useQuery<GetCandidateQuery, GetCandidateQueryVariables>(GetCandidateDocument, baseOptions);
      }
export function useGetCandidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateQuery, GetCandidateQueryVariables>) {
          return Apollo.useLazyQuery<GetCandidateQuery, GetCandidateQueryVariables>(GetCandidateDocument, baseOptions);
        }
export type GetCandidateQueryHookResult = ReturnType<typeof useGetCandidateQuery>;
export type GetCandidateLazyQueryHookResult = ReturnType<typeof useGetCandidateLazyQuery>;
export type GetCandidateQueryResult = Apollo.QueryResult<GetCandidateQuery, GetCandidateQueryVariables>;
export const GetCandidatesDocument = /*#__PURE__*/ gql`
    query GetCandidates($admin: Boolean!, $dynamicQuery: grad_profile_bool_exp, $offset: Int, $limit: Int, $order_by: grad_profile_order_by!) {
  grad_profile_aggregate(where: $dynamicQuery) {
    aggregate {
      count
    }
  }
  grad_profile(
    order_by: [$order_by]
    where: $dynamicQuery
    offset: $offset
    limit: $limit
  ) {
    ... on grad_profile @include(if: $admin) {
      ...CandidatePartsAdmin
    }
    ... on grad_profile @skip(if: $admin) {
      ...CandidateParts
    }
  }
}
    ${CandidatePartsAdminFragmentDoc}
${CandidatePartsFragmentDoc}`;

/**
 * __useGetCandidatesQuery__
 *
 * To run a query within a React component, call `useGetCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidatesQuery({
 *   variables: {
 *      admin: // value for 'admin'
 *      dynamicQuery: // value for 'dynamicQuery'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useGetCandidatesQuery(baseOptions: Apollo.QueryHookOptions<GetCandidatesQuery, GetCandidatesQueryVariables>) {
        return Apollo.useQuery<GetCandidatesQuery, GetCandidatesQueryVariables>(GetCandidatesDocument, baseOptions);
      }
export function useGetCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidatesQuery, GetCandidatesQueryVariables>) {
          return Apollo.useLazyQuery<GetCandidatesQuery, GetCandidatesQueryVariables>(GetCandidatesDocument, baseOptions);
        }
export type GetCandidatesQueryHookResult = ReturnType<typeof useGetCandidatesQuery>;
export type GetCandidatesLazyQueryHookResult = ReturnType<typeof useGetCandidatesLazyQuery>;
export type GetCandidatesQueryResult = Apollo.QueryResult<GetCandidatesQuery, GetCandidatesQueryVariables>;
export const GetCompanyOldDocument = /*#__PURE__*/ gql`
    query GetCompanyOld($id: String!) {
  recruit_company(where: {account: {recruiters: {user_id: {_eq: $id}}}}) {
    ...CompanyParts
  }
}
    ${CompanyPartsFragmentDoc}`;

/**
 * __useGetCompanyOldQuery__
 *
 * To run a query within a React component, call `useGetCompanyOldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyOldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyOldQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyOldQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyOldQuery, GetCompanyOldQueryVariables>) {
        return Apollo.useQuery<GetCompanyOldQuery, GetCompanyOldQueryVariables>(GetCompanyOldDocument, baseOptions);
      }
export function useGetCompanyOldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyOldQuery, GetCompanyOldQueryVariables>) {
          return Apollo.useLazyQuery<GetCompanyOldQuery, GetCompanyOldQueryVariables>(GetCompanyOldDocument, baseOptions);
        }
export type GetCompanyOldQueryHookResult = ReturnType<typeof useGetCompanyOldQuery>;
export type GetCompanyOldLazyQueryHookResult = ReturnType<typeof useGetCompanyOldLazyQuery>;
export type GetCompanyOldQueryResult = Apollo.QueryResult<GetCompanyOldQuery, GetCompanyOldQueryVariables>;
export const GetComputerLanguageSelectionDocument = /*#__PURE__*/ gql`
    query GetComputerLanguageSelection($language: String) {
  grad_computer_language_selection(
    where: {computer_language: {_ilike: $language}}
  ) {
    ...ComputerLanguageSelectorParts
  }
}
    ${ComputerLanguageSelectorPartsFragmentDoc}`;

/**
 * __useGetComputerLanguageSelectionQuery__
 *
 * To run a query within a React component, call `useGetComputerLanguageSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComputerLanguageSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComputerLanguageSelectionQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetComputerLanguageSelectionQuery(baseOptions?: Apollo.QueryHookOptions<GetComputerLanguageSelectionQuery, GetComputerLanguageSelectionQueryVariables>) {
        return Apollo.useQuery<GetComputerLanguageSelectionQuery, GetComputerLanguageSelectionQueryVariables>(GetComputerLanguageSelectionDocument, baseOptions);
      }
export function useGetComputerLanguageSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetComputerLanguageSelectionQuery, GetComputerLanguageSelectionQueryVariables>) {
          return Apollo.useLazyQuery<GetComputerLanguageSelectionQuery, GetComputerLanguageSelectionQueryVariables>(GetComputerLanguageSelectionDocument, baseOptions);
        }
export type GetComputerLanguageSelectionQueryHookResult = ReturnType<typeof useGetComputerLanguageSelectionQuery>;
export type GetComputerLanguageSelectionLazyQueryHookResult = ReturnType<typeof useGetComputerLanguageSelectionLazyQuery>;
export type GetComputerLanguageSelectionQueryResult = Apollo.QueryResult<GetComputerLanguageSelectionQuery, GetComputerLanguageSelectionQueryVariables>;
export const GetConversationsDocument = /*#__PURE__*/ gql`
    subscription GetConversations($candidateId: String, $name: String, $limit: Int) {
  recruit_sms_correspondent(
    limit: $limit
    order_by: {last_message_timestamp: desc_nulls_last, correspondent_user_id: desc_nulls_last}
    where: {correspondent_user_id: {_eq: $candidateId}, grad_profile: {fullname: {_ilike: $name}}}
  ) {
    ...ConversationParts
  }
}
    ${ConversationPartsFragmentDoc}`;

/**
 * __useGetConversationsSubscription__
 *
 * To run a query within a React component, call `useGetConversationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationsSubscription({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      name: // value for 'name'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetConversationsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetConversationsSubscription, GetConversationsSubscriptionVariables>) {
        return Apollo.useSubscription<GetConversationsSubscription, GetConversationsSubscriptionVariables>(GetConversationsDocument, baseOptions);
      }
export type GetConversationsSubscriptionHookResult = ReturnType<typeof useGetConversationsSubscription>;
export type GetConversationsSubscriptionResult = Apollo.SubscriptionResult<GetConversationsSubscription>;
export const GetDegreeSelectionDocument = /*#__PURE__*/ gql`
    query GetDegreeSelection($degree_name: String) {
  grad_degree_selection(where: {degree: {_ilike: $degree_name}}) {
    ...DegreeSelectorParts
  }
}
    ${DegreeSelectorPartsFragmentDoc}`;

/**
 * __useGetDegreeSelectionQuery__
 *
 * To run a query within a React component, call `useGetDegreeSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDegreeSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDegreeSelectionQuery({
 *   variables: {
 *      degree_name: // value for 'degree_name'
 *   },
 * });
 */
export function useGetDegreeSelectionQuery(baseOptions?: Apollo.QueryHookOptions<GetDegreeSelectionQuery, GetDegreeSelectionQueryVariables>) {
        return Apollo.useQuery<GetDegreeSelectionQuery, GetDegreeSelectionQueryVariables>(GetDegreeSelectionDocument, baseOptions);
      }
export function useGetDegreeSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDegreeSelectionQuery, GetDegreeSelectionQueryVariables>) {
          return Apollo.useLazyQuery<GetDegreeSelectionQuery, GetDegreeSelectionQueryVariables>(GetDegreeSelectionDocument, baseOptions);
        }
export type GetDegreeSelectionQueryHookResult = ReturnType<typeof useGetDegreeSelectionQuery>;
export type GetDegreeSelectionLazyQueryHookResult = ReturnType<typeof useGetDegreeSelectionLazyQuery>;
export type GetDegreeSelectionQueryResult = Apollo.QueryResult<GetDegreeSelectionQuery, GetDegreeSelectionQueryVariables>;
export const GetEventDocument = /*#__PURE__*/ gql`
    query GetEvent($id: String!) {
  recruit_event_by_pk(event_id: $id) {
    event_id
    title
    image
    description
    capacity
    timezone
    start_datetime
    end_datetime
    event_type
    address
    event_url
  }
  recruit_company(where: {account: {recruiters: {user_id: {_eq: $id}}}}) {
    company_id
  }
}
    `;

/**
 * __useGetEventQuery__
 *
 * To run a query within a React component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventQuery(baseOptions: Apollo.QueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
        return Apollo.useQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, baseOptions);
      }
export function useGetEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
          return Apollo.useLazyQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, baseOptions);
        }
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<typeof useGetEventLazyQuery>;
export type GetEventQueryResult = Apollo.QueryResult<GetEventQuery, GetEventQueryVariables>;
export const GetEventAttendeesDocument = /*#__PURE__*/ gql`
    query GetEventAttendees($eventID: String!, $limit: Int = 30, $offset: Int = 0) {
  recruit_event(where: {event_id: {_eq: $eventID}}) {
    event_registrations(limit: $limit, offset: $offset) {
      profile {
        ... on grad_profile {
          ...CandidateParts
          profile_image
        }
      }
    }
  }
  recruit_event_aggregate {
    aggregate {
      count
    }
  }
}
    ${CandidatePartsFragmentDoc}`;

/**
 * __useGetEventAttendeesQuery__
 *
 * To run a query within a React component, call `useGetEventAttendeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventAttendeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventAttendeesQuery({
 *   variables: {
 *      eventID: // value for 'eventID'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetEventAttendeesQuery(baseOptions: Apollo.QueryHookOptions<GetEventAttendeesQuery, GetEventAttendeesQueryVariables>) {
        return Apollo.useQuery<GetEventAttendeesQuery, GetEventAttendeesQueryVariables>(GetEventAttendeesDocument, baseOptions);
      }
export function useGetEventAttendeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventAttendeesQuery, GetEventAttendeesQueryVariables>) {
          return Apollo.useLazyQuery<GetEventAttendeesQuery, GetEventAttendeesQueryVariables>(GetEventAttendeesDocument, baseOptions);
        }
export type GetEventAttendeesQueryHookResult = ReturnType<typeof useGetEventAttendeesQuery>;
export type GetEventAttendeesLazyQueryHookResult = ReturnType<typeof useGetEventAttendeesLazyQuery>;
export type GetEventAttendeesQueryResult = Apollo.QueryResult<GetEventAttendeesQuery, GetEventAttendeesQueryVariables>;
export const GetGroupsDocument = /*#__PURE__*/ gql`
    query GetGroups {
  recruit_grad_group {
    ...GroupParts
  }
}
    ${GroupPartsFragmentDoc}`;

/**
 * __useGetGroupsQuery__
 *
 * To run a query within a React component, call `useGetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
        return Apollo.useQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, baseOptions);
      }
export function useGetGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
          return Apollo.useLazyQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, baseOptions);
        }
export type GetGroupsQueryHookResult = ReturnType<typeof useGetGroupsQuery>;
export type GetGroupsLazyQueryHookResult = ReturnType<typeof useGetGroupsLazyQuery>;
export type GetGroupsQueryResult = Apollo.QueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export const GetGroupsByNameDocument = /*#__PURE__*/ gql`
    query GetGroupsByName($name: String) {
  recruit_grad_group(where: {group_name: {_ilike: $name}}) {
    ...GroupParts
  }
}
    ${GroupPartsFragmentDoc}`;

/**
 * __useGetGroupsByNameQuery__
 *
 * To run a query within a React component, call `useGetGroupsByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetGroupsByNameQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupsByNameQuery, GetGroupsByNameQueryVariables>) {
        return Apollo.useQuery<GetGroupsByNameQuery, GetGroupsByNameQueryVariables>(GetGroupsByNameDocument, baseOptions);
      }
export function useGetGroupsByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsByNameQuery, GetGroupsByNameQueryVariables>) {
          return Apollo.useLazyQuery<GetGroupsByNameQuery, GetGroupsByNameQueryVariables>(GetGroupsByNameDocument, baseOptions);
        }
export type GetGroupsByNameQueryHookResult = ReturnType<typeof useGetGroupsByNameQuery>;
export type GetGroupsByNameLazyQueryHookResult = ReturnType<typeof useGetGroupsByNameLazyQuery>;
export type GetGroupsByNameQueryResult = Apollo.QueryResult<GetGroupsByNameQuery, GetGroupsByNameQueryVariables>;
export const GetInterestFirmSelectionDocument = /*#__PURE__*/ gql`
    query GetInterestFirmSelection($firm_type: String) {
  grad_interest_firm_selection(
    where: {value: {_ilike: $firm_type}}
    order_by: {value: asc}
  ) {
    ...InterestFirmSelectorParts
  }
}
    ${InterestFirmSelectorPartsFragmentDoc}`;

/**
 * __useGetInterestFirmSelectionQuery__
 *
 * To run a query within a React component, call `useGetInterestFirmSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterestFirmSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterestFirmSelectionQuery({
 *   variables: {
 *      firm_type: // value for 'firm_type'
 *   },
 * });
 */
export function useGetInterestFirmSelectionQuery(baseOptions?: Apollo.QueryHookOptions<GetInterestFirmSelectionQuery, GetInterestFirmSelectionQueryVariables>) {
        return Apollo.useQuery<GetInterestFirmSelectionQuery, GetInterestFirmSelectionQueryVariables>(GetInterestFirmSelectionDocument, baseOptions);
      }
export function useGetInterestFirmSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInterestFirmSelectionQuery, GetInterestFirmSelectionQueryVariables>) {
          return Apollo.useLazyQuery<GetInterestFirmSelectionQuery, GetInterestFirmSelectionQueryVariables>(GetInterestFirmSelectionDocument, baseOptions);
        }
export type GetInterestFirmSelectionQueryHookResult = ReturnType<typeof useGetInterestFirmSelectionQuery>;
export type GetInterestFirmSelectionLazyQueryHookResult = ReturnType<typeof useGetInterestFirmSelectionLazyQuery>;
export type GetInterestFirmSelectionQueryResult = Apollo.QueryResult<GetInterestFirmSelectionQuery, GetInterestFirmSelectionQueryVariables>;
export const GetInterestJobTypeSelectionDocument = /*#__PURE__*/ gql`
    query GetInterestJobTypeSelection($job_type: String) {
  grad_interest_job_type_selection(where: {value: {_ilike: $job_type}}, limit: 10) {
    ...InterestJobTypeSelectorParts
  }
}
    ${InterestJobTypeSelectorPartsFragmentDoc}`;

/**
 * __useGetInterestJobTypeSelectionQuery__
 *
 * To run a query within a React component, call `useGetInterestJobTypeSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterestJobTypeSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterestJobTypeSelectionQuery({
 *   variables: {
 *      job_type: // value for 'job_type'
 *   },
 * });
 */
export function useGetInterestJobTypeSelectionQuery(baseOptions?: Apollo.QueryHookOptions<GetInterestJobTypeSelectionQuery, GetInterestJobTypeSelectionQueryVariables>) {
        return Apollo.useQuery<GetInterestJobTypeSelectionQuery, GetInterestJobTypeSelectionQueryVariables>(GetInterestJobTypeSelectionDocument, baseOptions);
      }
export function useGetInterestJobTypeSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInterestJobTypeSelectionQuery, GetInterestJobTypeSelectionQueryVariables>) {
          return Apollo.useLazyQuery<GetInterestJobTypeSelectionQuery, GetInterestJobTypeSelectionQueryVariables>(GetInterestJobTypeSelectionDocument, baseOptions);
        }
export type GetInterestJobTypeSelectionQueryHookResult = ReturnType<typeof useGetInterestJobTypeSelectionQuery>;
export type GetInterestJobTypeSelectionLazyQueryHookResult = ReturnType<typeof useGetInterestJobTypeSelectionLazyQuery>;
export type GetInterestJobTypeSelectionQueryResult = Apollo.QueryResult<GetInterestJobTypeSelectionQuery, GetInterestJobTypeSelectionQueryVariables>;
export const GetInterestRegionSelectionDocument = /*#__PURE__*/ gql`
    query GetInterestRegionSelection($region: String) {
  grad_interest_region_selection(
    where: {value: {_ilike: $region}}
    order_by: {value: asc}
  ) {
    ...InterestRegionSelectorParts
  }
}
    ${InterestRegionSelectorPartsFragmentDoc}`;

/**
 * __useGetInterestRegionSelectionQuery__
 *
 * To run a query within a React component, call `useGetInterestRegionSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterestRegionSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterestRegionSelectionQuery({
 *   variables: {
 *      region: // value for 'region'
 *   },
 * });
 */
export function useGetInterestRegionSelectionQuery(baseOptions?: Apollo.QueryHookOptions<GetInterestRegionSelectionQuery, GetInterestRegionSelectionQueryVariables>) {
        return Apollo.useQuery<GetInterestRegionSelectionQuery, GetInterestRegionSelectionQueryVariables>(GetInterestRegionSelectionDocument, baseOptions);
      }
export function useGetInterestRegionSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInterestRegionSelectionQuery, GetInterestRegionSelectionQueryVariables>) {
          return Apollo.useLazyQuery<GetInterestRegionSelectionQuery, GetInterestRegionSelectionQueryVariables>(GetInterestRegionSelectionDocument, baseOptions);
        }
export type GetInterestRegionSelectionQueryHookResult = ReturnType<typeof useGetInterestRegionSelectionQuery>;
export type GetInterestRegionSelectionLazyQueryHookResult = ReturnType<typeof useGetInterestRegionSelectionLazyQuery>;
export type GetInterestRegionSelectionQueryResult = Apollo.QueryResult<GetInterestRegionSelectionQuery, GetInterestRegionSelectionQueryVariables>;
export const GetInterestRolesSelectionDocument = /*#__PURE__*/ gql`
    query GetInterestRolesSelection($role: String) {
  grad_interest_role_selection(
    where: {value: {_ilike: $role}}
    order_by: {value: asc}
  ) {
    ...InterestRoleSelectorParts
  }
}
    ${InterestRoleSelectorPartsFragmentDoc}`;

/**
 * __useGetInterestRolesSelectionQuery__
 *
 * To run a query within a React component, call `useGetInterestRolesSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterestRolesSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterestRolesSelectionQuery({
 *   variables: {
 *      role: // value for 'role'
 *   },
 * });
 */
export function useGetInterestRolesSelectionQuery(baseOptions?: Apollo.QueryHookOptions<GetInterestRolesSelectionQuery, GetInterestRolesSelectionQueryVariables>) {
        return Apollo.useQuery<GetInterestRolesSelectionQuery, GetInterestRolesSelectionQueryVariables>(GetInterestRolesSelectionDocument, baseOptions);
      }
export function useGetInterestRolesSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInterestRolesSelectionQuery, GetInterestRolesSelectionQueryVariables>) {
          return Apollo.useLazyQuery<GetInterestRolesSelectionQuery, GetInterestRolesSelectionQueryVariables>(GetInterestRolesSelectionDocument, baseOptions);
        }
export type GetInterestRolesSelectionQueryHookResult = ReturnType<typeof useGetInterestRolesSelectionQuery>;
export type GetInterestRolesSelectionLazyQueryHookResult = ReturnType<typeof useGetInterestRolesSelectionLazyQuery>;
export type GetInterestRolesSelectionQueryResult = Apollo.QueryResult<GetInterestRolesSelectionQuery, GetInterestRolesSelectionQueryVariables>;
export const GetJobDocument = /*#__PURE__*/ gql`
    query GetJob($id: String!) {
  recruit_job_posting(where: {job_posting_id: {_eq: $id}}) {
    ...JobParts
  }
}
    ${JobPartsFragmentDoc}`;

/**
 * __useGetJobQuery__
 *
 * To run a query within a React component, call `useGetJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobQuery(baseOptions: Apollo.QueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
        return Apollo.useQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, baseOptions);
      }
export function useGetJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
          return Apollo.useLazyQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, baseOptions);
        }
export type GetJobQueryHookResult = ReturnType<typeof useGetJobQuery>;
export type GetJobLazyQueryHookResult = ReturnType<typeof useGetJobLazyQuery>;
export type GetJobQueryResult = Apollo.QueryResult<GetJobQuery, GetJobQueryVariables>;
export const GetJobCVsDocument = /*#__PURE__*/ gql`
    query GetJobCVs($userIds: [String!]) {
  grad_upload_doc(where: {user_id: {_in: $userIds}}) {
    ...CVParts
  }
}
    ${CVPartsFragmentDoc}`;

/**
 * __useGetJobCVsQuery__
 *
 * To run a query within a React component, call `useGetJobCVsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobCVsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobCVsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetJobCVsQuery(baseOptions?: Apollo.QueryHookOptions<GetJobCVsQuery, GetJobCVsQueryVariables>) {
        return Apollo.useQuery<GetJobCVsQuery, GetJobCVsQueryVariables>(GetJobCVsDocument, baseOptions);
      }
export function useGetJobCVsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobCVsQuery, GetJobCVsQueryVariables>) {
          return Apollo.useLazyQuery<GetJobCVsQuery, GetJobCVsQueryVariables>(GetJobCVsDocument, baseOptions);
        }
export type GetJobCVsQueryHookResult = ReturnType<typeof useGetJobCVsQuery>;
export type GetJobCVsLazyQueryHookResult = ReturnType<typeof useGetJobCVsLazyQuery>;
export type GetJobCVsQueryResult = Apollo.QueryResult<GetJobCVsQuery, GetJobCVsQueryVariables>;
export const GetJobsDocument = /*#__PURE__*/ gql`
    query GetJobs($offset: Int = 0, $limit: Int = 12) {
  recruit_job_posting_aggregate {
    aggregate {
      count
    }
  }
  recruit_job_posting(offset: $offset, limit: $limit) {
    ...JobParts
  }
}
    ${JobPartsFragmentDoc}`;

/**
 * __useGetJobsQuery__
 *
 * To run a query within a React component, call `useGetJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
        return Apollo.useQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, baseOptions);
      }
export function useGetJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
          return Apollo.useLazyQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, baseOptions);
        }
export type GetJobsQueryHookResult = ReturnType<typeof useGetJobsQuery>;
export type GetJobsLazyQueryHookResult = ReturnType<typeof useGetJobsLazyQuery>;
export type GetJobsQueryResult = Apollo.QueryResult<GetJobsQuery, GetJobsQueryVariables>;
export const GetMessagesDocument = /*#__PURE__*/ gql`
    subscription GetMessages($candidateId: String) {
  recruit_sms_message(
    where: {correspondents: {correspondent_user_id: {_eq: $candidateId}}}
    order_by: {timestamp: asc}
  ) {
    ...MessageParts
    correspondents(where: {correspondent_user_id: {_eq: $candidateId}}) {
      error_message
    }
  }
}
    ${MessagePartsFragmentDoc}`;

/**
 * __useGetMessagesSubscription__
 *
 * To run a query within a React component, call `useGetMessagesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesSubscription({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useGetMessagesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetMessagesSubscription, GetMessagesSubscriptionVariables>) {
        return Apollo.useSubscription<GetMessagesSubscription, GetMessagesSubscriptionVariables>(GetMessagesDocument, baseOptions);
      }
export type GetMessagesSubscriptionHookResult = ReturnType<typeof useGetMessagesSubscription>;
export type GetMessagesSubscriptionResult = Apollo.SubscriptionResult<GetMessagesSubscription>;
export const GetPersonalAchievementsDocument = /*#__PURE__*/ gql`
    query GetPersonalAchievements($candidateId: String!) {
  grad_achievement(where: {user_id: {_eq: $candidateId}}) {
    ...AchievementParts
  }
}
    ${AchievementPartsFragmentDoc}`;

/**
 * __useGetPersonalAchievementsQuery__
 *
 * To run a query within a React component, call `useGetPersonalAchievementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalAchievementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalAchievementsQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useGetPersonalAchievementsQuery(baseOptions: Apollo.QueryHookOptions<GetPersonalAchievementsQuery, GetPersonalAchievementsQueryVariables>) {
        return Apollo.useQuery<GetPersonalAchievementsQuery, GetPersonalAchievementsQueryVariables>(GetPersonalAchievementsDocument, baseOptions);
      }
export function useGetPersonalAchievementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonalAchievementsQuery, GetPersonalAchievementsQueryVariables>) {
          return Apollo.useLazyQuery<GetPersonalAchievementsQuery, GetPersonalAchievementsQueryVariables>(GetPersonalAchievementsDocument, baseOptions);
        }
export type GetPersonalAchievementsQueryHookResult = ReturnType<typeof useGetPersonalAchievementsQuery>;
export type GetPersonalAchievementsLazyQueryHookResult = ReturnType<typeof useGetPersonalAchievementsLazyQuery>;
export type GetPersonalAchievementsQueryResult = Apollo.QueryResult<GetPersonalAchievementsQuery, GetPersonalAchievementsQueryVariables>;
export const GetProfessionalDesignationsDocument = /*#__PURE__*/ gql`
    query GetProfessionalDesignations($candidateId: String!) {
  grad_award(
    where: {user_id: {_eq: $candidateId}, award_category: {_eq: "Professional designation"}}
    order_by: {year_received: desc}
  ) {
    ...AwardParts
  }
}
    ${AwardPartsFragmentDoc}`;

/**
 * __useGetProfessionalDesignationsQuery__
 *
 * To run a query within a React component, call `useGetProfessionalDesignationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfessionalDesignationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfessionalDesignationsQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useGetProfessionalDesignationsQuery(baseOptions: Apollo.QueryHookOptions<GetProfessionalDesignationsQuery, GetProfessionalDesignationsQueryVariables>) {
        return Apollo.useQuery<GetProfessionalDesignationsQuery, GetProfessionalDesignationsQueryVariables>(GetProfessionalDesignationsDocument, baseOptions);
      }
export function useGetProfessionalDesignationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfessionalDesignationsQuery, GetProfessionalDesignationsQueryVariables>) {
          return Apollo.useLazyQuery<GetProfessionalDesignationsQuery, GetProfessionalDesignationsQueryVariables>(GetProfessionalDesignationsDocument, baseOptions);
        }
export type GetProfessionalDesignationsQueryHookResult = ReturnType<typeof useGetProfessionalDesignationsQuery>;
export type GetProfessionalDesignationsLazyQueryHookResult = ReturnType<typeof useGetProfessionalDesignationsLazyQuery>;
export type GetProfessionalDesignationsQueryResult = Apollo.QueryResult<GetProfessionalDesignationsQuery, GetProfessionalDesignationsQueryVariables>;
export const GetProfileImagesByUserIdsDocument = /*#__PURE__*/ gql`
    query GetProfileImagesByUserIds($userIds: [String!]!) {
  grad_profile(where: {user_id: {_in: $userIds}}) {
    ...CandidateImageOnlyParts
  }
}
    ${CandidateImageOnlyPartsFragmentDoc}`;

/**
 * __useGetProfileImagesByUserIdsQuery__
 *
 * To run a query within a React component, call `useGetProfileImagesByUserIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileImagesByUserIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileImagesByUserIdsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetProfileImagesByUserIdsQuery(baseOptions: Apollo.QueryHookOptions<GetProfileImagesByUserIdsQuery, GetProfileImagesByUserIdsQueryVariables>) {
        return Apollo.useQuery<GetProfileImagesByUserIdsQuery, GetProfileImagesByUserIdsQueryVariables>(GetProfileImagesByUserIdsDocument, baseOptions);
      }
export function useGetProfileImagesByUserIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileImagesByUserIdsQuery, GetProfileImagesByUserIdsQueryVariables>) {
          return Apollo.useLazyQuery<GetProfileImagesByUserIdsQuery, GetProfileImagesByUserIdsQueryVariables>(GetProfileImagesByUserIdsDocument, baseOptions);
        }
export type GetProfileImagesByUserIdsQueryHookResult = ReturnType<typeof useGetProfileImagesByUserIdsQuery>;
export type GetProfileImagesByUserIdsLazyQueryHookResult = ReturnType<typeof useGetProfileImagesByUserIdsLazyQuery>;
export type GetProfileImagesByUserIdsQueryResult = Apollo.QueryResult<GetProfileImagesByUserIdsQuery, GetProfileImagesByUserIdsQueryVariables>;
export const GetRecipientByIdDocument = /*#__PURE__*/ gql`
    query GetRecipientById($userId: String) {
  grad_profile(where: {user_id: {_eq: $userId}}) {
    ...RecipientParts
  }
}
    ${RecipientPartsFragmentDoc}`;

/**
 * __useGetRecipientByIdQuery__
 *
 * To run a query within a React component, call `useGetRecipientByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipientByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipientByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetRecipientByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetRecipientByIdQuery, GetRecipientByIdQueryVariables>) {
        return Apollo.useQuery<GetRecipientByIdQuery, GetRecipientByIdQueryVariables>(GetRecipientByIdDocument, baseOptions);
      }
export function useGetRecipientByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecipientByIdQuery, GetRecipientByIdQueryVariables>) {
          return Apollo.useLazyQuery<GetRecipientByIdQuery, GetRecipientByIdQueryVariables>(GetRecipientByIdDocument, baseOptions);
        }
export type GetRecipientByIdQueryHookResult = ReturnType<typeof useGetRecipientByIdQuery>;
export type GetRecipientByIdLazyQueryHookResult = ReturnType<typeof useGetRecipientByIdLazyQuery>;
export type GetRecipientByIdQueryResult = Apollo.QueryResult<GetRecipientByIdQuery, GetRecipientByIdQueryVariables>;
export const GetRecipientsByNameDocument = /*#__PURE__*/ gql`
    query GetRecipientsByName($name: String, $limit: Int) {
  grad_profile(where: {fullname: {_ilike: $name}}, limit: $limit) {
    ...RecipientParts
  }
}
    ${RecipientPartsFragmentDoc}`;

/**
 * __useGetRecipientsByNameQuery__
 *
 * To run a query within a React component, call `useGetRecipientsByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipientsByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipientsByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetRecipientsByNameQuery(baseOptions?: Apollo.QueryHookOptions<GetRecipientsByNameQuery, GetRecipientsByNameQueryVariables>) {
        return Apollo.useQuery<GetRecipientsByNameQuery, GetRecipientsByNameQueryVariables>(GetRecipientsByNameDocument, baseOptions);
      }
export function useGetRecipientsByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecipientsByNameQuery, GetRecipientsByNameQueryVariables>) {
          return Apollo.useLazyQuery<GetRecipientsByNameQuery, GetRecipientsByNameQueryVariables>(GetRecipientsByNameDocument, baseOptions);
        }
export type GetRecipientsByNameQueryHookResult = ReturnType<typeof useGetRecipientsByNameQuery>;
export type GetRecipientsByNameLazyQueryHookResult = ReturnType<typeof useGetRecipientsByNameLazyQuery>;
export type GetRecipientsByNameQueryResult = Apollo.QueryResult<GetRecipientsByNameQuery, GetRecipientsByNameQueryVariables>;
export const GetRegionsDocument = /*#__PURE__*/ gql`
    query GetRegions {
  grad_interest_region_selection {
    ...RegionParts
  }
}
    ${RegionPartsFragmentDoc}`;

/**
 * __useGetRegionsQuery__
 *
 * To run a query within a React component, call `useGetRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
        return Apollo.useQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, baseOptions);
      }
export function useGetRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
          return Apollo.useLazyQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, baseOptions);
        }
export type GetRegionsQueryHookResult = ReturnType<typeof useGetRegionsQuery>;
export type GetRegionsLazyQueryHookResult = ReturnType<typeof useGetRegionsLazyQuery>;
export type GetRegionsQueryResult = Apollo.QueryResult<GetRegionsQuery, GetRegionsQueryVariables>;
export const GetTemplatesDocument = /*#__PURE__*/ gql`
    query GetTemplates {
  recruit_sms_template {
    ...TemplateParts
  }
}
    ${TemplatePartsFragmentDoc}`;

/**
 * __useGetTemplatesQuery__
 *
 * To run a query within a React component, call `useGetTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
        return Apollo.useQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, baseOptions);
      }
export function useGetTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
          return Apollo.useLazyQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, baseOptions);
        }
export type GetTemplatesQueryHookResult = ReturnType<typeof useGetTemplatesQuery>;
export type GetTemplatesLazyQueryHookResult = ReturnType<typeof useGetTemplatesLazyQuery>;
export type GetTemplatesQueryResult = Apollo.QueryResult<GetTemplatesQuery, GetTemplatesQueryVariables>;
export const GetVolunteerActivitiesDocument = /*#__PURE__*/ gql`
    query GetVolunteerActivities($candidateId: String!) {
  grad_volunteer(where: {user_id: {_eq: $candidateId}}) {
    ...VolunteerActivitiesParts
  }
}
    ${VolunteerActivitiesPartsFragmentDoc}`;

/**
 * __useGetVolunteerActivitiesQuery__
 *
 * To run a query within a React component, call `useGetVolunteerActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolunteerActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolunteerActivitiesQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useGetVolunteerActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GetVolunteerActivitiesQuery, GetVolunteerActivitiesQueryVariables>) {
        return Apollo.useQuery<GetVolunteerActivitiesQuery, GetVolunteerActivitiesQueryVariables>(GetVolunteerActivitiesDocument, baseOptions);
      }
export function useGetVolunteerActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVolunteerActivitiesQuery, GetVolunteerActivitiesQueryVariables>) {
          return Apollo.useLazyQuery<GetVolunteerActivitiesQuery, GetVolunteerActivitiesQueryVariables>(GetVolunteerActivitiesDocument, baseOptions);
        }
export type GetVolunteerActivitiesQueryHookResult = ReturnType<typeof useGetVolunteerActivitiesQuery>;
export type GetVolunteerActivitiesLazyQueryHookResult = ReturnType<typeof useGetVolunteerActivitiesLazyQuery>;
export type GetVolunteerActivitiesQueryResult = Apollo.QueryResult<GetVolunteerActivitiesQuery, GetVolunteerActivitiesQueryVariables>;
export const HideEventDocument = /*#__PURE__*/ gql`
    mutation HideEvent($eventID: String!, $show_event: Boolean!) {
  update_recruit_event_by_pk(
    _set: {show_event: $show_event}
    pk_columns: {event_id: $eventID}
  ) {
    event_id
    show_event
  }
}
    `;
export type HideEventMutationFn = Apollo.MutationFunction<HideEventMutation, HideEventMutationVariables>;

/**
 * __useHideEventMutation__
 *
 * To run a mutation, you first call `useHideEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideEventMutation, { data, loading, error }] = useHideEventMutation({
 *   variables: {
 *      eventID: // value for 'eventID'
 *      show_event: // value for 'show_event'
 *   },
 * });
 */
export function useHideEventMutation(baseOptions?: Apollo.MutationHookOptions<HideEventMutation, HideEventMutationVariables>) {
        return Apollo.useMutation<HideEventMutation, HideEventMutationVariables>(HideEventDocument, baseOptions);
      }
export type HideEventMutationHookResult = ReturnType<typeof useHideEventMutation>;
export type HideEventMutationResult = Apollo.MutationResult<HideEventMutation>;
export type HideEventMutationOptions = Apollo.BaseMutationOptions<HideEventMutation, HideEventMutationVariables>;
export const InsertEventDocument = /*#__PURE__*/ gql`
    mutation InsertEvent($title: String!, $image: String!, $description: String!, $capacity: Int!, $timezone: String!, $startDate: timestamp!, $endDate: timestamp!, $eventType: String!, $address: String, $link: String, $userID: String!, $companyID: String!, $showEvent: Boolean!) {
  insert_recruit_event(
    objects: {title: $title, image: $image, description: $description, capacity: $capacity, timezone: $timezone, start_datetime: $startDate, end_datetime: $endDate, event_type: $eventType, address: $address, event_url: $link, account_id: $companyID, creator_id: $userID, show_event: $showEvent}
  ) {
    returning {
      title
      image
      description
      capacity
      timezone
      start_datetime
      end_datetime
      event_type
      address
      event_url
      show_event
    }
  }
}
    `;
export type InsertEventMutationFn = Apollo.MutationFunction<InsertEventMutation, InsertEventMutationVariables>;

/**
 * __useInsertEventMutation__
 *
 * To run a mutation, you first call `useInsertEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertEventMutation, { data, loading, error }] = useInsertEventMutation({
 *   variables: {
 *      title: // value for 'title'
 *      image: // value for 'image'
 *      description: // value for 'description'
 *      capacity: // value for 'capacity'
 *      timezone: // value for 'timezone'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      eventType: // value for 'eventType'
 *      address: // value for 'address'
 *      link: // value for 'link'
 *      userID: // value for 'userID'
 *      companyID: // value for 'companyID'
 *      showEvent: // value for 'showEvent'
 *   },
 * });
 */
export function useInsertEventMutation(baseOptions?: Apollo.MutationHookOptions<InsertEventMutation, InsertEventMutationVariables>) {
        return Apollo.useMutation<InsertEventMutation, InsertEventMutationVariables>(InsertEventDocument, baseOptions);
      }
export type InsertEventMutationHookResult = ReturnType<typeof useInsertEventMutation>;
export type InsertEventMutationResult = Apollo.MutationResult<InsertEventMutation>;
export type InsertEventMutationOptions = Apollo.BaseMutationOptions<InsertEventMutation, InsertEventMutationVariables>;
export const InsertGroupMembersDocument = /*#__PURE__*/ gql`
    mutation InsertGroupMembers($groupMembers: [recruit_grad_group_member_insert_input!]!) {
  insert_recruit_grad_group_member(objects: $groupMembers) {
    returning {
      ...GroupMembershipParts
    }
  }
}
    ${GroupMembershipPartsFragmentDoc}`;
export type InsertGroupMembersMutationFn = Apollo.MutationFunction<InsertGroupMembersMutation, InsertGroupMembersMutationVariables>;

/**
 * __useInsertGroupMembersMutation__
 *
 * To run a mutation, you first call `useInsertGroupMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertGroupMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertGroupMembersMutation, { data, loading, error }] = useInsertGroupMembersMutation({
 *   variables: {
 *      groupMembers: // value for 'groupMembers'
 *   },
 * });
 */
export function useInsertGroupMembersMutation(baseOptions?: Apollo.MutationHookOptions<InsertGroupMembersMutation, InsertGroupMembersMutationVariables>) {
        return Apollo.useMutation<InsertGroupMembersMutation, InsertGroupMembersMutationVariables>(InsertGroupMembersDocument, baseOptions);
      }
export type InsertGroupMembersMutationHookResult = ReturnType<typeof useInsertGroupMembersMutation>;
export type InsertGroupMembersMutationResult = Apollo.MutationResult<InsertGroupMembersMutation>;
export type InsertGroupMembersMutationOptions = Apollo.BaseMutationOptions<InsertGroupMembersMutation, InsertGroupMembersMutationVariables>;
export const InsertJobRequirementsDocument = /*#__PURE__*/ gql`
    mutation InsertJobRequirements($requirements: [recruit_job_requirement_insert_input!]!) {
  insert_recruit_job_requirement(objects: $requirements) {
    returning {
      ...JobRequirementParts
    }
  }
}
    ${JobRequirementPartsFragmentDoc}`;
export type InsertJobRequirementsMutationFn = Apollo.MutationFunction<InsertJobRequirementsMutation, InsertJobRequirementsMutationVariables>;

/**
 * __useInsertJobRequirementsMutation__
 *
 * To run a mutation, you first call `useInsertJobRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertJobRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertJobRequirementsMutation, { data, loading, error }] = useInsertJobRequirementsMutation({
 *   variables: {
 *      requirements: // value for 'requirements'
 *   },
 * });
 */
export function useInsertJobRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<InsertJobRequirementsMutation, InsertJobRequirementsMutationVariables>) {
        return Apollo.useMutation<InsertJobRequirementsMutation, InsertJobRequirementsMutationVariables>(InsertJobRequirementsDocument, baseOptions);
      }
export type InsertJobRequirementsMutationHookResult = ReturnType<typeof useInsertJobRequirementsMutation>;
export type InsertJobRequirementsMutationResult = Apollo.MutationResult<InsertJobRequirementsMutation>;
export type InsertJobRequirementsMutationOptions = Apollo.BaseMutationOptions<InsertJobRequirementsMutation, InsertJobRequirementsMutationVariables>;
export const InsertTemplateDocument = /*#__PURE__*/ gql`
    mutation InsertTemplate($recruiterId: String!, $content: String!, $title: String!) {
  insert_recruit_sms_template(
    objects: {text: $content, title: $title, recruiter_user_id: $recruiterId}
  ) {
    returning {
      ...TemplateParts
    }
  }
}
    ${TemplatePartsFragmentDoc}`;
export type InsertTemplateMutationFn = Apollo.MutationFunction<InsertTemplateMutation, InsertTemplateMutationVariables>;

/**
 * __useInsertTemplateMutation__
 *
 * To run a mutation, you first call `useInsertTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertTemplateMutation, { data, loading, error }] = useInsertTemplateMutation({
 *   variables: {
 *      recruiterId: // value for 'recruiterId'
 *      content: // value for 'content'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useInsertTemplateMutation(baseOptions?: Apollo.MutationHookOptions<InsertTemplateMutation, InsertTemplateMutationVariables>) {
        return Apollo.useMutation<InsertTemplateMutation, InsertTemplateMutationVariables>(InsertTemplateDocument, baseOptions);
      }
export type InsertTemplateMutationHookResult = ReturnType<typeof useInsertTemplateMutation>;
export type InsertTemplateMutationResult = Apollo.MutationResult<InsertTemplateMutation>;
export type InsertTemplateMutationOptions = Apollo.BaseMutationOptions<InsertTemplateMutation, InsertTemplateMutationVariables>;
export const RemoveGroupMembersDocument = /*#__PURE__*/ gql`
    mutation RemoveGroupMembers($recruiterId: String!, $candidatesIds: [String!]!) {
  delete_recruit_grad_group_member(
    where: {recruiter_user_id: {_eq: $recruiterId}, student_user_id: {_in: $candidatesIds}}
  ) {
    returning {
      ...GroupMembershipParts
    }
  }
}
    ${GroupMembershipPartsFragmentDoc}`;
export type RemoveGroupMembersMutationFn = Apollo.MutationFunction<RemoveGroupMembersMutation, RemoveGroupMembersMutationVariables>;

/**
 * __useRemoveGroupMembersMutation__
 *
 * To run a mutation, you first call `useRemoveGroupMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGroupMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGroupMembersMutation, { data, loading, error }] = useRemoveGroupMembersMutation({
 *   variables: {
 *      recruiterId: // value for 'recruiterId'
 *      candidatesIds: // value for 'candidatesIds'
 *   },
 * });
 */
export function useRemoveGroupMembersMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGroupMembersMutation, RemoveGroupMembersMutationVariables>) {
        return Apollo.useMutation<RemoveGroupMembersMutation, RemoveGroupMembersMutationVariables>(RemoveGroupMembersDocument, baseOptions);
      }
export type RemoveGroupMembersMutationHookResult = ReturnType<typeof useRemoveGroupMembersMutation>;
export type RemoveGroupMembersMutationResult = Apollo.MutationResult<RemoveGroupMembersMutation>;
export type RemoveGroupMembersMutationOptions = Apollo.BaseMutationOptions<RemoveGroupMembersMutation, RemoveGroupMembersMutationVariables>;
export const RemoveGroupsDocument = /*#__PURE__*/ gql`
    mutation RemoveGroups($groupsIds: [String!]!) {
  delete_recruit_grad_group(where: {grad_group_id: {_in: $groupsIds}}) {
    returning {
      ...GroupParts
    }
  }
}
    ${GroupPartsFragmentDoc}`;
export type RemoveGroupsMutationFn = Apollo.MutationFunction<RemoveGroupsMutation, RemoveGroupsMutationVariables>;

/**
 * __useRemoveGroupsMutation__
 *
 * To run a mutation, you first call `useRemoveGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGroupsMutation, { data, loading, error }] = useRemoveGroupsMutation({
 *   variables: {
 *      groupsIds: // value for 'groupsIds'
 *   },
 * });
 */
export function useRemoveGroupsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGroupsMutation, RemoveGroupsMutationVariables>) {
        return Apollo.useMutation<RemoveGroupsMutation, RemoveGroupsMutationVariables>(RemoveGroupsDocument, baseOptions);
      }
export type RemoveGroupsMutationHookResult = ReturnType<typeof useRemoveGroupsMutation>;
export type RemoveGroupsMutationResult = Apollo.MutationResult<RemoveGroupsMutation>;
export type RemoveGroupsMutationOptions = Apollo.BaseMutationOptions<RemoveGroupsMutation, RemoveGroupsMutationVariables>;
export const RemoveJobRequirementsDocument = /*#__PURE__*/ gql`
    mutation RemoveJobRequirements($jobId: String!) {
  delete_recruit_job_requirement(where: {job_posting_id: {_eq: $jobId}}) {
    returning {
      ...JobRequirementParts
    }
  }
}
    ${JobRequirementPartsFragmentDoc}`;
export type RemoveJobRequirementsMutationFn = Apollo.MutationFunction<RemoveJobRequirementsMutation, RemoveJobRequirementsMutationVariables>;

/**
 * __useRemoveJobRequirementsMutation__
 *
 * To run a mutation, you first call `useRemoveJobRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveJobRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeJobRequirementsMutation, { data, loading, error }] = useRemoveJobRequirementsMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useRemoveJobRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveJobRequirementsMutation, RemoveJobRequirementsMutationVariables>) {
        return Apollo.useMutation<RemoveJobRequirementsMutation, RemoveJobRequirementsMutationVariables>(RemoveJobRequirementsDocument, baseOptions);
      }
export type RemoveJobRequirementsMutationHookResult = ReturnType<typeof useRemoveJobRequirementsMutation>;
export type RemoveJobRequirementsMutationResult = Apollo.MutationResult<RemoveJobRequirementsMutation>;
export type RemoveJobRequirementsMutationOptions = Apollo.BaseMutationOptions<RemoveJobRequirementsMutation, RemoveJobRequirementsMutationVariables>;
export const UpdateCandidateBlockDocument = /*#__PURE__*/ gql`
    mutation UpdateCandidateBlock($admin: Boolean!, $candidateId: String!, $blocked_reason: String = "", $blocked: Boolean!) {
  update_grad_profile(
    _set: {blocked: $blocked, blocked_reason: $blocked_reason}
    where: {user_id: {_eq: $candidateId}}
  ) {
    returning {
      ... on grad_profile @include(if: $admin) {
        ...CandidatePartsAdmin
      }
      ... on grad_profile @skip(if: $admin) {
        ...CandidateParts
      }
    }
  }
}
    ${CandidatePartsAdminFragmentDoc}
${CandidatePartsFragmentDoc}`;
export type UpdateCandidateBlockMutationFn = Apollo.MutationFunction<UpdateCandidateBlockMutation, UpdateCandidateBlockMutationVariables>;

/**
 * __useUpdateCandidateBlockMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateBlockMutation, { data, loading, error }] = useUpdateCandidateBlockMutation({
 *   variables: {
 *      admin: // value for 'admin'
 *      candidateId: // value for 'candidateId'
 *      blocked_reason: // value for 'blocked_reason'
 *      blocked: // value for 'blocked'
 *   },
 * });
 */
export function useUpdateCandidateBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCandidateBlockMutation, UpdateCandidateBlockMutationVariables>) {
        return Apollo.useMutation<UpdateCandidateBlockMutation, UpdateCandidateBlockMutationVariables>(UpdateCandidateBlockDocument, baseOptions);
      }
export type UpdateCandidateBlockMutationHookResult = ReturnType<typeof useUpdateCandidateBlockMutation>;
export type UpdateCandidateBlockMutationResult = Apollo.MutationResult<UpdateCandidateBlockMutation>;
export type UpdateCandidateBlockMutationOptions = Apollo.BaseMutationOptions<UpdateCandidateBlockMutation, UpdateCandidateBlockMutationVariables>;
export const UpdateCompanyDocument = /*#__PURE__*/ gql`
    mutation UpdateCompany($companyId: Int!, $address: String, $description: String, $industry: String, $name: String, $num_employees: String, $phone: String, $website: String, $logo: String, $photo: String) {
  update_recruit_company_by_pk(
    pk_columns: {company_id: $companyId}
    _set: {address: $address, description: $description, industry: $industry, name: $name, num_employees: $num_employees, phone: $phone, website: $website, logo: $logo, photo: $photo}
  ) {
    ...CompanyParts
  }
}
    ${CompanyPartsFragmentDoc}`;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      address: // value for 'address'
 *      description: // value for 'description'
 *      industry: // value for 'industry'
 *      name: // value for 'name'
 *      num_employees: // value for 'num_employees'
 *      phone: // value for 'phone'
 *      website: // value for 'website'
 *      logo: // value for 'logo'
 *      photo: // value for 'photo'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, baseOptions);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const UpdateConversationSeenTimeDocument = /*#__PURE__*/ gql`
    mutation UpdateConversationSeenTime($recruiter_user_id: String!, $correspondent_user_id: String!, $last_read_timestamp: timestamptz!) {
  update_recruit_sms_correspondent(
    where: {correspondent_user_id: {_eq: $correspondent_user_id}, recruiter_user_id: {_eq: $recruiter_user_id}}
    _set: {last_read_timestamp: $last_read_timestamp}
  ) {
    returning {
      ...ConversationParts
    }
  }
}
    ${ConversationPartsFragmentDoc}`;
export type UpdateConversationSeenTimeMutationFn = Apollo.MutationFunction<UpdateConversationSeenTimeMutation, UpdateConversationSeenTimeMutationVariables>;

/**
 * __useUpdateConversationSeenTimeMutation__
 *
 * To run a mutation, you first call `useUpdateConversationSeenTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConversationSeenTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConversationSeenTimeMutation, { data, loading, error }] = useUpdateConversationSeenTimeMutation({
 *   variables: {
 *      recruiter_user_id: // value for 'recruiter_user_id'
 *      correspondent_user_id: // value for 'correspondent_user_id'
 *      last_read_timestamp: // value for 'last_read_timestamp'
 *   },
 * });
 */
export function useUpdateConversationSeenTimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConversationSeenTimeMutation, UpdateConversationSeenTimeMutationVariables>) {
        return Apollo.useMutation<UpdateConversationSeenTimeMutation, UpdateConversationSeenTimeMutationVariables>(UpdateConversationSeenTimeDocument, baseOptions);
      }
export type UpdateConversationSeenTimeMutationHookResult = ReturnType<typeof useUpdateConversationSeenTimeMutation>;
export type UpdateConversationSeenTimeMutationResult = Apollo.MutationResult<UpdateConversationSeenTimeMutation>;
export type UpdateConversationSeenTimeMutationOptions = Apollo.BaseMutationOptions<UpdateConversationSeenTimeMutation, UpdateConversationSeenTimeMutationVariables>;
export const UpdateEventDocument = /*#__PURE__*/ gql`
    mutation UpdateEvent($eventID: String!, $title: String!, $image: String!, $description: String!, $capacity: Int!, $timezone: String!, $startDate: timestamp!, $endDate: timestamp!, $eventType: String!, $address: String, $link: String) {
  update_recruit_event_by_pk(
    pk_columns: {event_id: $eventID}
    _set: {title: $title, image: $image, description: $description, capacity: $capacity, timezone: $timezone, start_datetime: $startDate, end_datetime: $endDate, event_type: $eventType, address: $address, event_url: $link}
  ) {
    title
    image
    description
    capacity
    timezone
    start_datetime
    end_datetime
    event_type
    address
    event_url
  }
}
    `;
export type UpdateEventMutationFn = Apollo.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      eventID: // value for 'eventID'
 *      title: // value for 'title'
 *      image: // value for 'image'
 *      description: // value for 'description'
 *      capacity: // value for 'capacity'
 *      timezone: // value for 'timezone'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      eventType: // value for 'eventType'
 *      address: // value for 'address'
 *      link: // value for 'link'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, baseOptions);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;
export const UpdateJobDocument = /*#__PURE__*/ gql`
    mutation UpdateJob($job_posting_id: String!, $description: String!, $position_title: String!, $job_type: String!, $deadline: date, $region: String!) {
  update_recruit_job_posting(
    where: {job_posting_id: {_eq: $job_posting_id}}
    _set: {description: $description, position_title: $position_title, job_type: $job_type, deadline: $deadline, region: $region}
  ) {
    returning {
      ...JobParts
    }
  }
}
    ${JobPartsFragmentDoc}`;
export type UpdateJobMutationFn = Apollo.MutationFunction<UpdateJobMutation, UpdateJobMutationVariables>;

/**
 * __useUpdateJobMutation__
 *
 * To run a mutation, you first call `useUpdateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobMutation, { data, loading, error }] = useUpdateJobMutation({
 *   variables: {
 *      job_posting_id: // value for 'job_posting_id'
 *      description: // value for 'description'
 *      position_title: // value for 'position_title'
 *      job_type: // value for 'job_type'
 *      deadline: // value for 'deadline'
 *      region: // value for 'region'
 *   },
 * });
 */
export function useUpdateJobMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobMutation, UpdateJobMutationVariables>) {
        return Apollo.useMutation<UpdateJobMutation, UpdateJobMutationVariables>(UpdateJobDocument, baseOptions);
      }
export type UpdateJobMutationHookResult = ReturnType<typeof useUpdateJobMutation>;
export type UpdateJobMutationResult = Apollo.MutationResult<UpdateJobMutation>;
export type UpdateJobMutationOptions = Apollo.BaseMutationOptions<UpdateJobMutation, UpdateJobMutationVariables>;
export const UpdateJobsStatusActiveDocument = /*#__PURE__*/ gql`
    mutation UpdateJobsStatusActive($jobId: String!, $active: Boolean!) {
  update_recruit_job_posting(
    where: {job_posting_id: {_eq: $jobId}}
    _set: {active: $active}
  ) {
    returning {
      ...JobParts
    }
  }
}
    ${JobPartsFragmentDoc}`;
export type UpdateJobsStatusActiveMutationFn = Apollo.MutationFunction<UpdateJobsStatusActiveMutation, UpdateJobsStatusActiveMutationVariables>;

/**
 * __useUpdateJobsStatusActiveMutation__
 *
 * To run a mutation, you first call `useUpdateJobsStatusActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobsStatusActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobsStatusActiveMutation, { data, loading, error }] = useUpdateJobsStatusActiveMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUpdateJobsStatusActiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobsStatusActiveMutation, UpdateJobsStatusActiveMutationVariables>) {
        return Apollo.useMutation<UpdateJobsStatusActiveMutation, UpdateJobsStatusActiveMutationVariables>(UpdateJobsStatusActiveDocument, baseOptions);
      }
export type UpdateJobsStatusActiveMutationHookResult = ReturnType<typeof useUpdateJobsStatusActiveMutation>;
export type UpdateJobsStatusActiveMutationResult = Apollo.MutationResult<UpdateJobsStatusActiveMutation>;
export type UpdateJobsStatusActiveMutationOptions = Apollo.BaseMutationOptions<UpdateJobsStatusActiveMutation, UpdateJobsStatusActiveMutationVariables>;
export const UpdateJobsStatusPublicDocument = /*#__PURE__*/ gql`
    mutation UpdateJobsStatusPublic($jobId: String!, $public: Boolean!) {
  update_recruit_job_posting(
    where: {job_posting_id: {_eq: $jobId}}
    _set: {public: $public}
  ) {
    returning {
      ...JobParts
    }
  }
}
    ${JobPartsFragmentDoc}`;
export type UpdateJobsStatusPublicMutationFn = Apollo.MutationFunction<UpdateJobsStatusPublicMutation, UpdateJobsStatusPublicMutationVariables>;

/**
 * __useUpdateJobsStatusPublicMutation__
 *
 * To run a mutation, you first call `useUpdateJobsStatusPublicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobsStatusPublicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobsStatusPublicMutation, { data, loading, error }] = useUpdateJobsStatusPublicMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      public: // value for 'public'
 *   },
 * });
 */
export function useUpdateJobsStatusPublicMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobsStatusPublicMutation, UpdateJobsStatusPublicMutationVariables>) {
        return Apollo.useMutation<UpdateJobsStatusPublicMutation, UpdateJobsStatusPublicMutationVariables>(UpdateJobsStatusPublicDocument, baseOptions);
      }
export type UpdateJobsStatusPublicMutationHookResult = ReturnType<typeof useUpdateJobsStatusPublicMutation>;
export type UpdateJobsStatusPublicMutationResult = Apollo.MutationResult<UpdateJobsStatusPublicMutation>;
export type UpdateJobsStatusPublicMutationOptions = Apollo.BaseMutationOptions<UpdateJobsStatusPublicMutation, UpdateJobsStatusPublicMutationVariables>;
export const UpdateTemplateDocument = /*#__PURE__*/ gql`
    mutation UpdateTemplate($templateId: Int!, $content: String!, $title: String!) {
  update_recruit_sms_template(
    where: {sms_template_id: {_eq: $templateId}}
    _set: {text: $content, title: $title}
  ) {
    returning {
      ...TemplateParts
    }
  }
}
    ${TemplatePartsFragmentDoc}`;
export type UpdateTemplateMutationFn = Apollo.MutationFunction<UpdateTemplateMutation, UpdateTemplateMutationVariables>;

/**
 * __useUpdateTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateMutation, { data, loading, error }] = useUpdateTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      content: // value for 'content'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>) {
        return Apollo.useMutation<UpdateTemplateMutation, UpdateTemplateMutationVariables>(UpdateTemplateDocument, baseOptions);
      }
export type UpdateTemplateMutationHookResult = ReturnType<typeof useUpdateTemplateMutation>;
export type UpdateTemplateMutationResult = Apollo.MutationResult<UpdateTemplateMutation>;
export type UpdateTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>;
export const GetRecruitersListAdminDocument = /*#__PURE__*/ gql`
    query GetRecruitersListAdmin($email: String, $fullname: String, $company: String, $offset: Int = 0, $limit: Int = 12) {
  recruit_recruiter(
    where: {email: {_ilike: $email}, fullname: {_ilike: $fullname}, account: {company: {name: {_ilike: $company}}}}
    offset: $offset
    limit: $limit
  ) {
    email
    fullname
    user_id
    twilio_phone
    account {
      company {
        name
      }
    }
  }
  recruit_recruiter_aggregate(
    where: {email: {_ilike: $email}, fullname: {_ilike: $fullname}, account: {company: {name: {_ilike: $company}}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetRecruitersListAdminQuery__
 *
 * To run a query within a React component, call `useGetRecruitersListAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecruitersListAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecruitersListAdminQuery({
 *   variables: {
 *      email: // value for 'email'
 *      fullname: // value for 'fullname'
 *      company: // value for 'company'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetRecruitersListAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetRecruitersListAdminQuery, GetRecruitersListAdminQueryVariables>) {
        return Apollo.useQuery<GetRecruitersListAdminQuery, GetRecruitersListAdminQueryVariables>(GetRecruitersListAdminDocument, baseOptions);
      }
export function useGetRecruitersListAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecruitersListAdminQuery, GetRecruitersListAdminQueryVariables>) {
          return Apollo.useLazyQuery<GetRecruitersListAdminQuery, GetRecruitersListAdminQueryVariables>(GetRecruitersListAdminDocument, baseOptions);
        }
export type GetRecruitersListAdminQueryHookResult = ReturnType<typeof useGetRecruitersListAdminQuery>;
export type GetRecruitersListAdminLazyQueryHookResult = ReturnType<typeof useGetRecruitersListAdminLazyQuery>;
export type GetRecruitersListAdminQueryResult = Apollo.QueryResult<GetRecruitersListAdminQuery, GetRecruitersListAdminQueryVariables>;
export const GetCandidatesListRecruiterDocument = /*#__PURE__*/ gql`
    query GetCandidatesListRecruiter($dynamicQuery: grad_profile_bool_exp, $offset: Int!, $limit: Int!) {
  grad_profile_aggregate(where: $dynamicQuery) {
    aggregate {
      count
    }
  }
  grad_profile(
    order_by: {creation_timestamp: desc_nulls_last}
    where: $dynamicQuery
    offset: $offset
    limit: $limit
  ) {
    ...CandidatesListParts
  }
}
    ${CandidatesListPartsFragmentDoc}`;

/**
 * __useGetCandidatesListRecruiterQuery__
 *
 * To run a query within a React component, call `useGetCandidatesListRecruiterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidatesListRecruiterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidatesListRecruiterQuery({
 *   variables: {
 *      dynamicQuery: // value for 'dynamicQuery'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCandidatesListRecruiterQuery(baseOptions: Apollo.QueryHookOptions<GetCandidatesListRecruiterQuery, GetCandidatesListRecruiterQueryVariables>) {
        return Apollo.useQuery<GetCandidatesListRecruiterQuery, GetCandidatesListRecruiterQueryVariables>(GetCandidatesListRecruiterDocument, baseOptions);
      }
export function useGetCandidatesListRecruiterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidatesListRecruiterQuery, GetCandidatesListRecruiterQueryVariables>) {
          return Apollo.useLazyQuery<GetCandidatesListRecruiterQuery, GetCandidatesListRecruiterQueryVariables>(GetCandidatesListRecruiterDocument, baseOptions);
        }
export type GetCandidatesListRecruiterQueryHookResult = ReturnType<typeof useGetCandidatesListRecruiterQuery>;
export type GetCandidatesListRecruiterLazyQueryHookResult = ReturnType<typeof useGetCandidatesListRecruiterLazyQuery>;
export type GetCandidatesListRecruiterQueryResult = Apollo.QueryResult<GetCandidatesListRecruiterQuery, GetCandidatesListRecruiterQueryVariables>;
export const GetCompanyDocument = /*#__PURE__*/ gql`
    query GetCompany($id: String!) {
  recruit_company(where: {account: {recruiters: {user_id: {_eq: $id}}}}) {
    company_id
    account {
      account_id
      account_name
    }
    account_id
    address
    description
    industry
    logo
    photo
    name
    num_employees
    phone
    subindustries {
      company_subindustry_id
      value
    }
    website
  }
}
    `;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
        return Apollo.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, baseOptions);
      }
export function useGetCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          return Apollo.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, baseOptions);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export const GetEventDetailDocument = /*#__PURE__*/ gql`
    query GetEventDetail($eventID: String!) {
  recruit_event_by_pk(event_id: $eventID) {
    title
    address
    capacity
    description
    end_datetime
    start_datetime
    timezone
    image
    event_type
    show_event
    event_id
    event_url
    account {
      company {
        name
      }
    }
    event_registrations(
      where: {profile: {upload_docs: {hex_content: {_is_null: false}}}}
    ) {
      user_id
      profile {
        upload_docs_aggregate {
          aggregate {
            count
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventDetailQuery__
 *
 * To run a query within a React component, call `useGetEventDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventDetailQuery({
 *   variables: {
 *      eventID: // value for 'eventID'
 *   },
 * });
 */
export function useGetEventDetailQuery(baseOptions: Apollo.QueryHookOptions<GetEventDetailQuery, GetEventDetailQueryVariables>) {
        return Apollo.useQuery<GetEventDetailQuery, GetEventDetailQueryVariables>(GetEventDetailDocument, baseOptions);
      }
export function useGetEventDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventDetailQuery, GetEventDetailQueryVariables>) {
          return Apollo.useLazyQuery<GetEventDetailQuery, GetEventDetailQueryVariables>(GetEventDetailDocument, baseOptions);
        }
export type GetEventDetailQueryHookResult = ReturnType<typeof useGetEventDetailQuery>;
export type GetEventDetailLazyQueryHookResult = ReturnType<typeof useGetEventDetailLazyQuery>;
export type GetEventDetailQueryResult = Apollo.QueryResult<GetEventDetailQuery, GetEventDetailQueryVariables>;
export const GetEventListDocument = /*#__PURE__*/ gql`
    query GetEventList($userID: String!, $limit: Int = 4, $offset: Int = 0) {
  recruit_event(
    where: {creator_id: {_eq: $userID}}
    limit: $limit
    offset: $offset
    order_by: {creation_timestamp: desc, event_id: desc}
  ) {
    ...GetEventListParts
  }
  recruit_event_aggregate(where: {creator_id: {_eq: $userID}}) {
    aggregate {
      count
    }
  }
}
    ${GetEventListPartsFragmentDoc}`;

/**
 * __useGetEventListQuery__
 *
 * To run a query within a React component, call `useGetEventListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventListQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetEventListQuery(baseOptions: Apollo.QueryHookOptions<GetEventListQuery, GetEventListQueryVariables>) {
        return Apollo.useQuery<GetEventListQuery, GetEventListQueryVariables>(GetEventListDocument, baseOptions);
      }
export function useGetEventListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventListQuery, GetEventListQueryVariables>) {
          return Apollo.useLazyQuery<GetEventListQuery, GetEventListQueryVariables>(GetEventListDocument, baseOptions);
        }
export type GetEventListQueryHookResult = ReturnType<typeof useGetEventListQuery>;
export type GetEventListLazyQueryHookResult = ReturnType<typeof useGetEventListLazyQuery>;
export type GetEventListQueryResult = Apollo.QueryResult<GetEventListQuery, GetEventListQueryVariables>;
export const GetJobDetailDocument = /*#__PURE__*/ gql`
    query GetJobDetail($id: String!) {
  recruit_job_posting(where: {job_posting_id: {_eq: $id}}) {
    ...GetJobDetailParts
  }
}
    ${GetJobDetailPartsFragmentDoc}`;

/**
 * __useGetJobDetailQuery__
 *
 * To run a query within a React component, call `useGetJobDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobDetailQuery(baseOptions: Apollo.QueryHookOptions<GetJobDetailQuery, GetJobDetailQueryVariables>) {
        return Apollo.useQuery<GetJobDetailQuery, GetJobDetailQueryVariables>(GetJobDetailDocument, baseOptions);
      }
export function useGetJobDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobDetailQuery, GetJobDetailQueryVariables>) {
          return Apollo.useLazyQuery<GetJobDetailQuery, GetJobDetailQueryVariables>(GetJobDetailDocument, baseOptions);
        }
export type GetJobDetailQueryHookResult = ReturnType<typeof useGetJobDetailQuery>;
export type GetJobDetailLazyQueryHookResult = ReturnType<typeof useGetJobDetailLazyQuery>;
export type GetJobDetailQueryResult = Apollo.QueryResult<GetJobDetailQuery, GetJobDetailQueryVariables>;
export const GetJobDismissRecipientsByIdDocument = /*#__PURE__*/ gql`
    query GetJobDismissRecipientsById($ids: [String!]!) {
  grad_profile(where: {user_id: {_in: $ids}}) {
    ...GetJobDismissRecipientsByIdParts
  }
}
    ${GetJobDismissRecipientsByIdPartsFragmentDoc}`;

/**
 * __useGetJobDismissRecipientsByIdQuery__
 *
 * To run a query within a React component, call `useGetJobDismissRecipientsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobDismissRecipientsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobDismissRecipientsByIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetJobDismissRecipientsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetJobDismissRecipientsByIdQuery, GetJobDismissRecipientsByIdQueryVariables>) {
        return Apollo.useQuery<GetJobDismissRecipientsByIdQuery, GetJobDismissRecipientsByIdQueryVariables>(GetJobDismissRecipientsByIdDocument, baseOptions);
      }
export function useGetJobDismissRecipientsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobDismissRecipientsByIdQuery, GetJobDismissRecipientsByIdQueryVariables>) {
          return Apollo.useLazyQuery<GetJobDismissRecipientsByIdQuery, GetJobDismissRecipientsByIdQueryVariables>(GetJobDismissRecipientsByIdDocument, baseOptions);
        }
export type GetJobDismissRecipientsByIdQueryHookResult = ReturnType<typeof useGetJobDismissRecipientsByIdQuery>;
export type GetJobDismissRecipientsByIdLazyQueryHookResult = ReturnType<typeof useGetJobDismissRecipientsByIdLazyQuery>;
export type GetJobDismissRecipientsByIdQueryResult = Apollo.QueryResult<GetJobDismissRecipientsByIdQuery, GetJobDismissRecipientsByIdQueryVariables>;
export const GetJobsListDocument = /*#__PURE__*/ gql`
    query GetJobsList($offset: Int = 0, $limit: Int = 12) {
  recruit_job_posting_aggregate {
    aggregate {
      count
    }
  }
  recruit_job_posting(
    offset: $offset
    limit: $limit
    order_by: {creation_date: desc, job_posting_id: desc}
  ) {
    ...GetJobsListParts
    ...GetJobRequirements
  }
}
    ${GetJobsListPartsFragmentDoc}
${GetJobRequirementsFragmentDoc}`;

/**
 * __useGetJobsListQuery__
 *
 * To run a query within a React component, call `useGetJobsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsListQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetJobsListQuery(baseOptions?: Apollo.QueryHookOptions<GetJobsListQuery, GetJobsListQueryVariables>) {
        return Apollo.useQuery<GetJobsListQuery, GetJobsListQueryVariables>(GetJobsListDocument, baseOptions);
      }
export function useGetJobsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsListQuery, GetJobsListQueryVariables>) {
          return Apollo.useLazyQuery<GetJobsListQuery, GetJobsListQueryVariables>(GetJobsListDocument, baseOptions);
        }
export type GetJobsListQueryHookResult = ReturnType<typeof useGetJobsListQuery>;
export type GetJobsListLazyQueryHookResult = ReturnType<typeof useGetJobsListLazyQuery>;
export type GetJobsListQueryResult = Apollo.QueryResult<GetJobsListQuery, GetJobsListQueryVariables>;
export const GetJobDetailCandidatesValidGPAFromIdsDocument = /*#__PURE__*/ gql`
    query GetJobDetailCandidatesValidGPAFromIds($Ids: [String!]) {
  grad_profile(where: {user_id: {_in: $Ids}}) {
    user_id
  }
}
    `;

/**
 * __useGetJobDetailCandidatesValidGPAFromIdsQuery__
 *
 * To run a query within a React component, call `useGetJobDetailCandidatesValidGPAFromIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobDetailCandidatesValidGPAFromIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobDetailCandidatesValidGPAFromIdsQuery({
 *   variables: {
 *      Ids: // value for 'Ids'
 *   },
 * });
 */
export function useGetJobDetailCandidatesValidGPAFromIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetJobDetailCandidatesValidGPAFromIdsQuery, GetJobDetailCandidatesValidGPAFromIdsQueryVariables>) {
        return Apollo.useQuery<GetJobDetailCandidatesValidGPAFromIdsQuery, GetJobDetailCandidatesValidGPAFromIdsQueryVariables>(GetJobDetailCandidatesValidGPAFromIdsDocument, baseOptions);
      }
export function useGetJobDetailCandidatesValidGPAFromIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobDetailCandidatesValidGPAFromIdsQuery, GetJobDetailCandidatesValidGPAFromIdsQueryVariables>) {
          return Apollo.useLazyQuery<GetJobDetailCandidatesValidGPAFromIdsQuery, GetJobDetailCandidatesValidGPAFromIdsQueryVariables>(GetJobDetailCandidatesValidGPAFromIdsDocument, baseOptions);
        }
export type GetJobDetailCandidatesValidGPAFromIdsQueryHookResult = ReturnType<typeof useGetJobDetailCandidatesValidGPAFromIdsQuery>;
export type GetJobDetailCandidatesValidGPAFromIdsLazyQueryHookResult = ReturnType<typeof useGetJobDetailCandidatesValidGPAFromIdsLazyQuery>;
export type GetJobDetailCandidatesValidGPAFromIdsQueryResult = Apollo.QueryResult<GetJobDetailCandidatesValidGPAFromIdsQuery, GetJobDetailCandidatesValidGPAFromIdsQueryVariables>;
export const GetCurrentConversationsDocument = /*#__PURE__*/ gql`
    query GetCurrentConversations($candidateId: String, $limit: Int = 15) {
  recruit_sms_correspondent(
    limit: $limit
    order_by: {last_message_timestamp: desc_nulls_last}
    where: {correspondent_user_id: {_eq: $candidateId}}
  ) {
    correspondent_user_id
  }
}
    `;

/**
 * __useGetCurrentConversationsQuery__
 *
 * To run a query within a React component, call `useGetCurrentConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentConversationsQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCurrentConversationsQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentConversationsQuery, GetCurrentConversationsQueryVariables>) {
        return Apollo.useQuery<GetCurrentConversationsQuery, GetCurrentConversationsQueryVariables>(GetCurrentConversationsDocument, baseOptions);
      }
export function useGetCurrentConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentConversationsQuery, GetCurrentConversationsQueryVariables>) {
          return Apollo.useLazyQuery<GetCurrentConversationsQuery, GetCurrentConversationsQueryVariables>(GetCurrentConversationsDocument, baseOptions);
        }
export type GetCurrentConversationsQueryHookResult = ReturnType<typeof useGetCurrentConversationsQuery>;
export type GetCurrentConversationsLazyQueryHookResult = ReturnType<typeof useGetCurrentConversationsLazyQuery>;
export type GetCurrentConversationsQueryResult = Apollo.QueryResult<GetCurrentConversationsQuery, GetCurrentConversationsQueryVariables>;
export const GetMyProfileRecruiterDocument = /*#__PURE__*/ gql`
    query GetMyProfileRecruiter($userId: String) {
  recruit_recruiter(where: {user_id: {_eq: $userId}}) {
    fullname
    email
    user_id
    account {
      company {
        name
      }
    }
  }
}
    `;

/**
 * __useGetMyProfileRecruiterQuery__
 *
 * To run a query within a React component, call `useGetMyProfileRecruiterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProfileRecruiterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProfileRecruiterQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMyProfileRecruiterQuery(baseOptions?: Apollo.QueryHookOptions<GetMyProfileRecruiterQuery, GetMyProfileRecruiterQueryVariables>) {
        return Apollo.useQuery<GetMyProfileRecruiterQuery, GetMyProfileRecruiterQueryVariables>(GetMyProfileRecruiterDocument, baseOptions);
      }
export function useGetMyProfileRecruiterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyProfileRecruiterQuery, GetMyProfileRecruiterQueryVariables>) {
          return Apollo.useLazyQuery<GetMyProfileRecruiterQuery, GetMyProfileRecruiterQueryVariables>(GetMyProfileRecruiterDocument, baseOptions);
        }
export type GetMyProfileRecruiterQueryHookResult = ReturnType<typeof useGetMyProfileRecruiterQuery>;
export type GetMyProfileRecruiterLazyQueryHookResult = ReturnType<typeof useGetMyProfileRecruiterLazyQuery>;
export type GetMyProfileRecruiterQueryResult = Apollo.QueryResult<GetMyProfileRecruiterQuery, GetMyProfileRecruiterQueryVariables>;